import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: {
            // routes & menus
            Dashboard: 'Dashboard',
            'Space Data': 'Space',
            'Equipment Data': 'Equipment',
            'Meter Data': 'Meter',
            'Tenant Data': 'Tenant',
            'Store Data': 'Store',
            'Shopfloor Data': 'Shopfloor',
            'Combined Equipment Data': 'Combined Equipment',
            'Auxiliary System': 'Auxiliary System',
            Microgrid: 'Microgrid',
            'Energy Storage Power Station': 'Power Station',
            'Photovoltaic Power Station': 'Power Station',
            'Fault Alarm': 'Fault Alarm',
            Monitoring: 'Monitoring',
            'Advanced Reporting': 'Advanced Reporting',
            'Knowledge Base': 'Knowledge Base',
            'Energy Category Data': 'Energy Category',
            'Energy Item Data': 'Energy Item',
            Carbon: 'CO2 Emissions',
            Cost: 'Cost',
            Output: 'Output',
            Income: 'Income',
            Efficiency: 'Efficiency',
            Load: 'Load',
            Statistics: 'Statistics',
            'Batch Analysis': 'Batch Analysis',
            Saving: 'Saving',
            Plan: 'Plan',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Equipment Tracking',
            'Equipment Comparison': 'Comparison',
            'Shopfloor Comparison': 'Comparison',
            'Store Comparison': 'Comparison',
            'Space Comparison': 'Comparison',
            'Combined Equipment Comparison': 'Comparison',
            'Tenant Comparison': 'Comparison',
            'Environment Monitor': 'Environment Monitor',
            'Meter Energy': 'Meter Energy',
            'Meter Carbon': 'Meter CO2 Emissions',
            'Meter Cost': 'Meter Cost',
            'Meter Trend': 'Meter Trend',
            'Meter Realtime': 'Meter Realtime',
            'Meter Saving': 'Meter Saving',
            'Meter Plan': 'Meter Plan',
            'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
            'Meter Batch Analysis': 'Meter Batch Analysis',
            'Meter Comparison': 'Meter Comparison',
            'Meter Tracking': 'Meter Tracking',
            'Virtual Meter Saving': 'Virtual Meter Saving',
            'Virtual Meter Plan': 'Virtual Meter Plan',
            'Virtual Meter Energy': 'Virtual Meter Energy',
            'Virtual Meter Carbon': 'Virtual Meter CO2 Emissions',
            'Virtual Meter Cost': 'Virtual Meter Cost',
            'Virtual Meter Batch Analysis': 'Virtual Meter Batch Analysis',
            'Virtual Meter Comparison': 'Virtual Meter Comparison',
            'Offline Meter Energy': 'Offline Meter Energy',
            'Offline Meter Carbon': 'Offline Meter CO2 Emissions',
            'Offline Meter Cost': 'Offline Meter Cost',
            'Offline Meter Batch Analysis': 'Offline Meter Batch Analysis',
            'Offline Meter Saving': 'Offline Meter Saving',
            'Offline Meter Plan': 'Offline Meter Plan',
            'Offline Meter Input': 'Offline Meter Input',
            'Tenant Bill': 'Tenant Bill',
            'Energy Flow Diagram': 'Energy Flow Diagram',
            'Distribution System': 'Distribution System',
            'SVG System': 'SCADA Visualization System',
            'Faults Data': 'Faults',
            'Space Equipments': 'Space Equipments',
            'Combined Equipments': 'Combined Equipments',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Total Number of Work Orders',
            'Number of New Work Orders': 'Number of New Work Orders',
            'Number of Inprogress Work Orders': 'Number of Inprogress Work Orders',
            'Number of Done Work Orders': 'Number of Done Work Orders',
            'Fuel Indicator': 'Fuel Consumption',
            'Charge Energy Indicator': 'Charge Energy',
            'Discharge Energy Indicator': 'Disharge Energy',
            'Charge Cost Indicator': 'Charge Cost',
            'Discharge Revenue Indicator': 'Discharge Revenue',
            'HVAC': 'HVAC',
            'Fire Control': 'Fire Control',

            // Dashboard
            'Welcome to MyEMS': 'Welcome to MyEMS',
            'An Industry Leading Open Source Energy Management System': 'An Industry Leading Open Source Energy Management System',
            "This Year's Consumption CATEGORY VALUE UNIT": "This Year's Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Year's Costs CATEGORY VALUE UNIT": "This Year's Costs {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Consumption CATEGORY VALUE UNIT": "This Month's Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": "This Month's Costs {{CATEGORY}} {{VALUE}} {{UNIT}}",
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}  in The Same Period Last Year',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Costs {{CATEGORY}} {{VALUE}} {{UNIT}} in The Same Period Last Year',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Consumption {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Costs {{UNIT}}',
            // Entities
            Space: 'Space',
            Equipment: 'Equipment',
            Meter: 'Meter',
            'Offline Meter': 'Offline Meter',
            'Virtual Meter': 'Virtual Meter',
            Tenant: 'Tenant',
            Store: 'Store',
            Shopfloor: 'Shopfloor',
            'Combined Equipment': 'Combined Equipment',
            'Cost Center': 'Cost Center',
            Name: 'Name',
            DisplayName: 'Display Name',
            UserName: 'User Name',
            Description: 'Description',
            'Energy Category': 'Energy Category',
            'Child Spaces': 'Child Spaces',
            'Associated Equipment': 'Associated Equipment',
            //Energy Categories
            Electricity: 'Electricity',
            Water: 'Water',
            'Natural Gas': 'Natural Gas',
            // SidePanelModal
            Settings: 'Settings',
            'Set your own customized style': 'Set your own customized style',
            'Color Scheme': 'Color Scheme',
            'Choose the perfect color mode for your app': 'Choose the perfect color mode for your app',
            Light: 'Light',
            Dark: 'Dark',
            'RTL Mode': 'RTL Mode',
            'Switch your language direction': 'Switch your language direction',
            'Fluid Layout': 'Fluid Layout',
            'Toggle container layout system': 'Toggle container layout system',
            'Navigation Position': 'Navigation Position',
            'Vertical': 'Vertical',
            'Top': 'Top',
            'Combo': 'Combo',
            'Transparent': 'Transparent',
            'Inverted': 'Inverted',
            'Card': 'Card',
            'Vibrant': 'Vibrant',
            'Select a suitable navigation system for your web application': 'Select a suitable navigation system for your web application',
            'Vertical Nav': 'Vertical Nav',
            'Top Nav': 'Top Nav',
            'Vertical Navbar Style': 'Vertical Navbar Style',
            'Switch between styles for your vertical navbar': 'Switch between styles for your vertical navbar',
            Language: 'Language',
            'Switch between languages': 'Switch between languages',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Like What You See?',
            'Get MyEMS now': 'Get MyEMS now',
            'PQ.About': 'This analysis covers voltage deviation, voltage unbalance, frequency deviation, and current unbalance. Voltage deviation is computed as (U - Un) / Un × 100%; frequency deviation as |f - fn|; three-phase unbalance as max(|Xi - Xavg|) / Xavg × 100% using time-aligned phases. Results are calculated from the selected meter time-series within the chosen reporting period. If three-phase channels are not available or timestamps are not aligned, unbalance indices are skipped. Transient spikes or missing samples may inflate worst-case indicators; use compliance rate and P95 metrics to assess steady-state performance.',
            Purchase: 'Enterprise Edition',
            ContactInfo: 'Contact Information',
            ProductWebsite: 'Product Website',
            CompanyWebsite: 'Company Website',
            SalesPhone: 'Sales Phone',
            // Query Panel
            'Base Period Begins': 'Base Period Begins',
            'Base Period Ends': 'Base Period Ends',
            'Comparison Types': 'Comparison Types',
            'Year-Over-Year': 'Year-Over-Year',
            'Month-On-Month': 'Month-On-Month',
            'Free Comparison': 'Free Comparison',
            'None Comparison': 'None Comparison',
            'Reporting Period Begins': 'Reporting Period Begins',
            'Reporting Period Ends': 'Reporting Period Ends',
            '(Optional)': '(Optional)',
            'Period Types': 'Period Types',
            Yearly: 'Yearly',
            Monthly: 'Monthly',
            Weekly: 'Weekly',
            Daily: 'Daily',
            Hourly: 'Hourly',
            Submit: 'Submit',
            'Input Energy Category': 'Input Energy Category',
            'Output Energy Category': 'Output Energy Category',
            'Fraction Parameter': 'Fraction Parameter',
            Search: 'Search',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'OK',
            today: 'Today',
            yesterday: 'Yesterday',
            hours: 'Hours',
            minutes: 'Minutes',
            seconds: 'Seconds',
            last7Days: 'Last 7 Days',
            'Select Date Range': 'Select Date Range',
            //Card Summaries and Line Charts
            'Base Period': 'Base Period',
            'Reporting Period': 'Reporting Period',
            'Per Unit Area': 'Per Unit Area',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Per Unit Production',
            Baseline: 'Baseline',
            Actual: 'Actual',
            'Baseline Value - Actual Value': 'Baseline - Actual',
            'Average Load': 'Average Load',
            'Maximum Load': 'Maximum Load',
            'Load Factor': 'Load Factor',
            'Ratio of Average Load to Maximum Load': 'Ratio of Average Load to Maximum Load',
            'Carbon Dioxide Emissions by Energy Category': 'Carbon Dioxide Emissions by Energy Category',
            'Costs by Energy Category': 'Costs by Energy Category',
            'Incomes by Energy Category': 'Incomes by Energy Category',
            'Electricity Consumption by Time-Of-Use': 'Electricity Consumption by Time-Of-Use',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Electricity Carbon Dioxide Emissions by Time-Of-Use',
            'Electricity Cost by Time-Of-Use': 'Electricity Cost by Time-Of-Use',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Comsumption by Energy Items',
            'Ton of Standard Coal by Energy Category': 'Ton of Standard Coal(TCE) by Energy Category',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Ton of Carbon Dioxide Emissions(TCO2E) by Energy Category',
            'Reporting Period Consumption CATEGORY UNIT': 'Reporting Period Consumption {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Reporting Period Consumption {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Reporting Period Consumption {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Reporting Period Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Base Period Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Reporting Period Consumption {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Reporting Period Consumption {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Base Period Consumption {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Child Space Proportion by Energy Category {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Child Space Total Proportion',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Reporting Period Carbon Dioxide Emissions {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Reporting Period Carbon Dioxide Emissions {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Base Period Carbon Dioxide Emissions {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Reporting Period Costs {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Reporting Period Costs {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Base Period Costs {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Reporting Period Output {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Reporting Period Output {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Reporting Period Output {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Reporting Period Output {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Base Period Output {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Reporting Period Income {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Reporting Period Income {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Base Period Income {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Reporting Period Total Income {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Reporting Period Cumulative Efficiency {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Reporting Period Cumulative Efficiency {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Reporting Period Cumulative Comprehensive Efficiency {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Reporting Period Cumulative Comprehensive Efficiency {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Base Period Cumulative Comprehensive Efficiency {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Instantaneous Efficiency {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Instantaneous Efficiency {{UNIT}}',
            'Equipment Efficiency Indicator': 'Equipment Efficiency Indicator',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Instantaneous Comprehensive Efficiency {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Reporting Period Cumulative Efficiency {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Reporting Period Cumulative Efficiency {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Base Period Cumulative Efficiency {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Base Period Cumulative Efficiency {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Base Period {{CATEGORY}} Maximum Load {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Reporting Period {{CATEGORY}} Maximum Load {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Reporting Period {{CATEGORY}} Average Load {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Reporting Period {{CATEGORY}} Load Factor',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Base Period {{CATEGORY}} Average Load {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Reporting Period {{CATEGORY}} Average Value {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Reporting Period {{CATEGORY}} Maximum Value {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Reporting Period {{CATEGORY}} Minimum Value {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Reporting Period {{CATEGORY}} Arithmetic Mean {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Reporting Period {{CATEGORY}} Median (Middle Value) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Reporting Period {{CATEGORY}} Sample Standard Deviation {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Reporting Period {{CATEGORY}} Sample Variance {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Reporting Period Saving {{CATEGORY}} (Baseline - Actual) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Reporting Period Decreased {{CATEGORY}} (Baseline - Actual) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Reporting Period Saving {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Base Period Saving {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Reporting Period Master Meter Consumption {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Reporting Period Master Meter Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Reporting Period Submeters Consumption {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Reporting Period Submeters Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Reporting Period Difference {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Reporting Period Percentage Difference',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Reporting Period Difference {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Trend Values',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Fault List',
            'Reporting Period Number of Fault VALUE': 'Reporting Period Number of Fault {{VALUE}}',
            'All Faults': 'All Faults',
            'Space Faults': 'Space Faults',
            'Number of All Faults': 'Number of All Faults',
            'Number of Space Faults': 'Number of Space Faults',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Ton of Standard Coal',
            'Ton of Carbon Dioxide Emissions': 'Ton of Carbon Dioxide Emissions',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Carbon emissions per unit of energy consumption',
            'Operating Characteristic Curve': 'Operating Characteristic Curve',
            Tariff: 'Tariff',
            'Detailed Data': 'Detailed Data',
            'Child Spaces Data': 'Child Spaces Data',
            'Associated Equipment Data': 'Associated Equipment Data',
            'This Year': 'This Year',
            'The Same Period Last Year': 'The Same Period Last Year',
            'This Month': 'This Month',
            'This Day': 'This Day',
            Total: 'Total',
            'No data found': 'No data found',
            Export: 'Export',
            Datetime: 'Datetime',
            'Time-Of-Use Type': 'Time-Of-Use Type',
            'Top-Peak': 'Top-Peak',
            'On-Peak': 'On-Peak',
            'Mid-Peak': 'Mid-Peak',
            'Off-Peak': 'Off-Peak',
            'Deep': 'Deep-Valley',
            Percentage: 'Percentage',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Trend in the last hour of Energy Value Point',
            Circuit: 'Circuit',
            Point: 'Point',
            'Realtime Value': 'Realtime Value',
            //Meter Tracking
            'Meter List': 'Meter List',
            'Edit Meter': 'Edit',
            'Start Value': 'Start Value',
            'End Value': 'End Value',
            'Difference Value': 'Difference Value',
            'Start Integrity Rate': 'Start Integrity Rate(%)',
            'End Integrity Rate': 'End Integrity Rate(%)',
            'Full Integrity Rate': 'Full Integrity Rate(%)',
            //Equipment Tracking
            'Equipment List': 'Equipment List',
            'Edit Equipment': 'Edit',
            //Profile Dropdown
            Feedback: 'Feedback',
            'Account Settings': 'Account Settings',
            Logout: 'Logout',
            //Authentication
            'Log in': 'Log in',
            'Email address': 'Email address',
            'Phone Number': 'Phone Number',
            Password: 'Password',
            CaptchaCode: 'Captcha',
            Refresh: 'Refresh',
            'Remember me': 'Remember me',
            'Logged in as ': 'Logged in as ',
            'Forgot Password?': 'Forgot Password?',
            'Forgot your password?': 'Forgot your password?',
            "Enter your email and we'll send you a reset link": "Enter your email and we'll send you a reset link",
            "Enter your email and we'll send you a registration link":
                "Enter your email and we'll send you a registration link",
            'Reset Password': 'Reset Password',
            'Thanks for using MyEMS!': 'Thanks for using MyEMS!',
            'You are now successfully signed out': 'You are now successfully signed out',
            'Return to Login': 'Return to Login',
            'Please check your email!': 'Please check your email!',
            'An email has been sent to ': 'An email has been sent to ',
            'Please click on the included link to reset your password':
                'Please click on the included link to reset your password',
            'Please click on the included link to register your account':
                'Please click on the included link to register your account',
            'An email with password reset link is sent to ': 'An email with password reset link is sent to ',
            'Change Password': 'Change Password',
            'Old Password': 'Old Password',
            'New Password': 'New Password',
            'Confirm Password': 'Confirm Password',
            'Update Password': 'Update Password',
            'Password has been changed!': 'Password has been changed!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Verification code has been sent to your inbox. \
      Please copy it to the input box below.',
            'New to MyEMS': 'New to MyEMS',
            'Create an account': 'Create an account',
            'EMAIL Account registration successful': '{{EMAIL}} Account registration successful',
            'Thanks for verifying your account!': 'Thanks for verifying your account!',
            'Your code is': 'Your code is',
            'Send verification code': 'Send verification code',
            'Please wait for NUMBER seconds': 'Please wait for {{NUMBER}} seconds',
            'Password reset': 'Password reset',
            'Please wait for approval': 'Please wait for approval',
            //notification
            Notifications: 'Notifications',
            'Mark all as read': 'Mark all as read',
            'View all': 'All',
            'Notification New': 'NEW',
            'Notification Earlier': 'EARLIER',
            'Notification List': 'Notification List',
            'Bulk actions': 'Bulk actions',
            'Notification Subject': 'Subject',
            'Notification Created Datetime': 'Created Datetime',
            'Notification Priority': 'Priority',
            'Notification Message': 'Message',
            'Notification Status': 'Status',
            'Notification Mark As Read': 'Mark As Read',
            'Notification Mark As Acknowledged': 'Acknowledge',
            'Notification Low': 'Low',
            'Notification Medium': 'Medium',
            'Notification High': 'High',
            'Notification Critical': 'Critical',
            'Notification Unread': 'Unread',
            'Notification Read': 'Read',
            'Notification Acknowledged': 'Acknowledged',
            'Notification Archive': 'Archive',
            'Notification Delete': 'Delete',
            'Notification Apply': 'Apply',
            'Notification Start Datetime': 'Start Datetime',
            'Notification End Datetime': 'End Datetime',
            'Notification Update Datetime': 'Update Datetime',
            //Monitoring
            'Run Commands': 'Run Commands',
            'Pin Code': 'Pin Code',
            'Unlock': 'Unlock',
            'Set Value': 'Set Value',
            'Fault Alarms': 'Fault Alarms',
            'Instantaneous Efficiency VALUE UNIT': 'Instantaneous Efficiency {{VALUE}} {{UNIT}}',
            'Communication Online': 'Online',
            'Communication Offline': 'Offline',
            'Equipment Status': 'Equipment Status',
            'Equipment Running': 'Running',
            'Equipment Stopped': 'Stopped',
            'Show Up to': 'Show Up to',
            All: 'All',
            'FROM - TO of TOTAL': 'The current display of {{FROM}} - {{TO}} total {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Microgrid Energy',
            'Microgrid Revenue': 'Microgrid Revenue',
            'Microgrid Carbon': 'Microgrid Carbon',
            'Photovoltaic Generation': 'Photovoltaic Generation',
            'EV Charger Consumption': 'EV Charger Consumption',
            'Load Consumption': 'Load Consumption',
            'Grid Buy': 'Grid Buy',
            'Grid Sell': 'Grid Sell',
            'EV Charger': 'EV Charger',
            'Heat Pump': 'Heat Pump',
            'Photovoltaic': 'Photovoltaic',
            'PCS Run State': 'PCS Run State',
            'PCS Unknown': 'Unknown',
            'PCS Initializing': 'Initializing',
            'PCS Standby': 'Standby',
            'PCS Shutdown': 'Shutdown',
            'PCS Fault': 'Fault',
            'PCS Running': 'Running',
            'Battery Power': 'Battery Power',
            'Photovoltaic Power': 'Photovoltaic Power',
            'Grid Power': 'Grid Power',
            'Load Power': 'Load Power',
            Reporting: 'Reporting',
            Maintenance: 'Maintenance',
            'Serial Number': 'Serial Number',
            Address: 'Address',
            'Postal Code': 'Postal Code',
            'Rated Capacity': 'Rated Capacity',
            'Rated Power': 'Rated Power',
            Latitude: 'Latitude',
            Longitude: 'Longitude',
            'Strategy Management': 'Strategy Management',
            'Charging Schedule': 'Charging Schedule',
            'Charge Start Time': 'Charge Start Time',
            'Charge End Time': 'Charge End Time',
            'Discharge Start Time': 'Discharge Start Time',
            'Discharge End Time': 'Discharge End Time',
            'Total Rated Power': 'Total Rated Power',
            'Total Rated Capacity': 'Total Rated Capacity',
            "Today's Charge": "Today's Charge",
            "Today's Discharge": "Today's Discharge",
            "Today's Generation": "Today's Generation",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Total Charge',
            'Total Discharge': 'Total Discharge',
            'Total Generation': 'Total Generation',
            'Total Revenue': 'Total Revenue',
            'Total Photovoltaic Generation': 'Total Photovoltaic Generation',
            'Total EV Charger Consumption': 'Total EV Charger Consumption',
            'Total Load Consumption': 'Total Load Consumption',
            'Total Grid Buy': 'Total Grid Buy',
            'Total Grid Sell': 'Total Grid Sell',
            'Total Efficiency': 'Total Efficiency',
            'Discharge Achievement Rate': 'Discharge Achievement Rate',
            'Revenue Ranking': 'Revenue Ranking',
            'Efficiency Ranking': 'Efficiency Ranking',
            'Charge Ranking': 'Charge Ranking',
            'Discharge Ranking': 'Discharge Ranking',
            'Number of Microgrids': 'Number of Microgrids',
            'Number of Power Stations': 'Number of Power Stations',
            'Microgrid List': 'Microgrid List',
            'Select Microgrid': 'Select Microgrid',
            'Previous Page': 'Previous Page',
            'Next Page': 'Next Page',
            '7 Days': '7 Days',
            'Charge UNIT': 'Charge {{UNIT}}',
            'Discharge UNIT': 'Discharge {{UNIT}}',
            'Generation UNIT': 'Generation {{UNIT}}',
            'Energy Indicator': 'Energy',
            'Revenue Indicator': 'Revenue',
            'Carbon Indicator': 'Carbon',

            // Energy Storage Power Station
            'Battery Operating State': 'Battery Operating State',
            'Battery State': 'Battery State',
            'Battery Unknown': 'Unknown',
            'Battery Stopped': 'Stopped',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Fault', // 1
            'Battery Warning': 'Warning', // 2
            'Battery Standby': 'Standby', // 3
            'Battery Prohibit DisCharging': 'Prohibit DisCharging', //4
            'Battery Prohibit Charging': 'Prohibit Charging',// 5
            'Battery Normal': 'Normal', // 6
            'Battery Charging': 'Charging', // 7
            'Battery Discharging': 'Discharging', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Phase of Lifecycle',
            'Use Phase': 'Use Phase',
            'Commissioning Phase': 'Commissioning Phase',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Installation Phase',
            'Device Status': 'Device Status',
            'Basic Information': 'Basic Information',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'Invertor',
            'Invertor Run State': 'Invertor Run State',
            'Invertor Unknown': 'Unknown',
            'Invertor Initializing': 'Initializing',
            'Invertor Standby': 'Standby',
            'Invertor Shutdown': 'Shutdown',
            'Invertor Fault': 'Fault',
            'Invertor Running': 'Running',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Created Datetime',
            'File Format': 'File Format',
            'File Size': 'File Size',
            Uploader: 'Uploader',
            //Error
            "The page you're looking for is not found": "The page you're looking for is not found",
            "Make sure the address is correct and that the page hasn't moved. ":
                "Make sure the address is correct and that the page hasn't moved. ",
            'If you think this is a mistake,': 'If you think this is a mistake,',
            'contact us': 'contact us',
            'Take me home': 'Take me home',
            'Whoops, something went wrong!': 'Whoops, something went wrong!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Try refreshing the page, or going back and attempting the action again. ',
            'If this problem persists,': 'If this problem persists,',
            'Captcha Error': 'Captcha Error',
            'Confirm Password Error': 'The confirm password does not match',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'It looks like you clicked \
      on an invalid password reset link. Please tryagain.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'It looks like you clicked \
      on an invalid registration account link. Please tryagain.',
            //Tenant Bill
            'Lease Contract Number': 'Lease Contract Number',
            Download: 'Download',
            Print: 'Print',
            'Payment Notice': 'Payment Notice',
            'Bill To': 'Bill To',
            'Bill Number': 'Bill Number',
            'Bill Date': 'Bill Date',
            'Payment Due Date': 'Payment Due Date',
            'Amount Payable': 'Amount Payable',
            'Billing Period Start': 'Billing Period Start',
            'Billing Period End': 'Billing Period End',
            Quantity: 'Quantity',
            Price: 'Price',
            Unit: 'Unit',
            Amount: 'Amount',
            Subtotal: 'Subtotal',
            'VAT Output Tax': 'VAT Output Tax',
            'Total Amount Payable': 'Total Amount Payable',
            'Please make sure to pay on or before the payment due date above':
                'Please make sure to pay on or before the payment due date above',
            'Send money to the following account': 'Send money to the following account',
            'Account Name': 'Account Name',
            'Bank Name': 'Bank Name',
            'Bank Address': 'Bank Address',
            'RMB Account': 'RMB Account',
            // button
            'Toggle Navigation': 'Toggle Navigation',
            // working calendar
            'Working Days': 'Working Days',
            'Non Working Days': 'Non Working Days',
            'Select Row': 'Please Select Data Row',
            // Offline Meter Input
            'Daily Value': 'Daily Value',
            Date: 'Date',
            'Successfully Saved': 'Successfully Saved',
            'Previous Data Is Empty': 'Previous Data Is Empty',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'Invalid offline meter value',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'There is relation with virtual power plants',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Master Meter',
            SubMeter: 'Submeter',
            'Power Quality': 'Netzqualität',
            'About Power Quality': 'Über die Netzqualität',
            'Trend Values': 'Trendwerte',
            Category: 'Kategorie',
            Type: 'Typ',
            Unit: 'Einheit',
            Limit: 'Grenzwert',
            'Normal Limit': 'Normaler Grenzwert',
            'Severe Limit': 'Schwerer Grenzwert',
            Compliance: 'Einhaltungsrate',
            'Worst Deviation': 'Schlimmste Abweichung',
            'Worst Time': 'Schlimmster Zeitpunkt',
            'Severe Exceed Count': 'Anzahl schwerer Überschreitungen',
            'Worst Unbalance': 'Größte Unwucht',
            Hz: 'Hz',
            voltage: 'Voltage',
            current: 'Current',
            frequency: 'Frequency',
            voltage_deviation: 'Voltage Deviation',
            current_unbalance: 'Current Unbalance',
            voltage_unbalance: 'Voltage Unbalance',
            mean_deviation_pct: 'Mean Deviation (%)',
            p95_abs_deviation_pct: 'P95 Abs Deviation (%)',
            mean_abs_deviation_hz: 'Mean Abs Deviation (Hz)',
            frequency_deviation: 'Frequency Deviation',
            p95_abs_deviation_hz: 'P95 Abs Deviation (Hz)',
            mean_unbalance_pct: 'Mean Unbalance (%)',
            p95_unbalance_pct: 'P95 Unbalance (%)',
            count: 'Count',
            min: 'Min',
            max: 'Max',
            mean: 'Mean',
            std: 'Std',
            p5: 'P5',
            p95: 'P95'
        }
    },
    zh_CN: {
        translation: {
            // routes & menus
            Dashboard: '总览',
            'Space Data': '空间数据',
            'Equipment Data': '设备数据',
            'Meter Data': '计量表数据',
            'Tenant Data': '租户数据',
            'Store Data': '门店数据',
            'Shopfloor Data': '车间数据',
            'Combined Equipment Data': '组合设备数据',
            'Auxiliary System': '辅助系统',
            Microgrid: '微电网',
            'Energy Storage Power Station': '电站',
            'Photovoltaic Power Station': '电站',
            'Fault Alarm': '故障报警',
            Monitoring: '设备监控',
            'Advanced Reporting': '高级报表',
            'Knowledge Base': '知识库',
            'Energy Category Data': '能耗分类分析',
            'Energy Item Data': '能耗分项分析',
            Carbon: '碳排放分析',
            Cost: '成本分析',
            Output: '产出分析',
            Income: '收入分析',
            Efficiency: '效率分析',
            Load: '负荷分析',
            Statistics: '统计分析',
            'Batch Analysis': '批量分析',
            Saving: '节能分析',
            Plan: '计划分析',
            Prediction: '预测分析',
            'Production': '产量',
            'Space Production': '产量能耗分析',
            'Equipment Tracking': '设备台账',
            'Equipment Comparison': '对比分析',
            'Shopfloor Comparison': '对比分析',
            'Store Comparison': '对比分析',
            'Space Comparison': '对比分析',
            'Combined Equipment Comparison': '对比分析',
            'Tenant Comparison': '对比分析',
            'Environment Monitor': '环境监测',
            'Meter Energy': '计量表能耗分析',
            'Meter Carbon': '计量表碳排放分析',
            'Meter Cost': '计量表成本分析',
            'Meter Trend': '计量表趋势分析',
            'Meter Realtime': '计量表实时分析',
            'Meter Saving': '计量表节能分析',
            'Meter Plan': '计量表计划分析',
            'Master Meter Submeters Balance': '总分表平衡分析',
            'Meter Batch Analysis': '计量表批量分析',
            'Meter Comparison': '计量表对比分析',
            'Meter Tracking': '计量表台账',
            'Virtual Meter Saving': '虚拟表节能分析',
            'Virtual Meter Plan': '虚拟表计划分析',
            'Virtual Meter Energy': '虚拟表能耗分析',
            'Virtual Meter Carbon': '虚拟表碳排放分析',
            'Virtual Meter Cost': '虚拟表成本分析',
            'Virtual Meter Batch Analysis': '虚拟表批量分析',
            'Virtual Meter Comparison': '虚拟表对比分析',
            'Offline Meter Energy': '离线表能耗分析',
            'Offline Meter Carbon': '离线表碳排放分析',
            'Offline Meter Cost': '离线表成本分析',
            'Offline Meter Batch Analysis': '离线表批量分析',
            'Offline Meter Saving': '离线表节能分析',
            'Offline Meter Plan': '离线表计划分析',
            'Offline Meter Input': '离线表数据录入',
            'Tenant Bill': '租户账单',
            'Energy Flow Diagram': '能流图',
            'Distribution System': '配电系统',
            'SVG System': '组态可视化系统',
            'Faults Data': '故障分析',
            'Space Equipments': '空间设备',
            'Combined Equipments': '组合设备',
            'Energy Storage Power Station List': '电站列表',
            'Energy Storage Power Station Details': '设备监控',
            'Energy Storage Power Station Reporting': '数据报表',
            'Energy Storage Power Station Alarm': '故障报警',
            'Energy Storage Power Station Maintenance': '维护保养',
            'Enter Production': '产量录入',
            'Multiple Microgrids': '多站数据',
            'Multiple Microgrids Dashboard': '多站总览',
            'Multiple Microgrids List': '电站列表',
            'Single Microgrid': '单站数据',
            'Single Microgrid Dashboard': '单站总览',
            'Single Microgrid Details': '设备数据',
            'Single Microgrid Fault Alarm': '故障告警',
            'Microgrid Reports': '统计报表',
            'Microgrid Reports Energy': '电量报表',
            'Microgrid Reports Revenue': '收益报表',
            'Microgrid Reports Parameters': '数据查询',
            'Multiple Energy Storage Power Stations': '储能多站数据',
            'Multiple Energy Storage Power Stations Dashboard': '储能多站总览',
            'Multiple Energy Storage Power Stations List': '储能电站列表',
            'Single Energy Storage Power Station': '储能单站数据',
            'Single Energy Storage Power Station Dashboard': '储能单站总览',
            'Single Energy Storage Power Station Details': '储能设备数据',
            'Single Energy Storage Power Station Fault Alarm': '储能故障告警',
            'Energy Storage Power Station Reports': '储能统计报表',
            'Energy Storage Power Station Reports Energy': '储能电量报表',
            'Energy Storage Power Station Reports Revenue': '储能收益报表',
            'Energy Storage Power Station Reports Parameters': '储能数据查询',
            'Multiple Energy Storage Power Stations': '多站数据',
            'Multiple Energy Storage Power Stations Dashboard': '多站总览',
            'Multiple Energy Storage Power Stations List': '电站列表',
            'Single Energy Storage Power Station': '单站数据',
            'Single Energy Storage Power Station Dashboard': '单站总览',
            'Single Energy Storage Power Station Details': '设备数据',
            'Single Energy Storage Power Station Fault Alarm': '故障告警',
            'Energy Storage Power Station Reports': '统计报表',
            'Energy Storage Power Station Reports Energy': '电量报表',
            'Energy Storage Power Station Reports Revenue': '收益报表',
            'Energy Storage Power Station Reports Parameters': '数据查询',
            'Photovoltaic Power Station List': '电站列表',
            'Photovoltaic Power Station Details': '设备监控',
            'Photovoltaic Power Station Reporting': '数据报表',
            'Photovoltaic Power Station Alarm': '故障报警',
            'Photovoltaic Power Station Maintenance': '维护保养',
            'Multiple Photovoltaic Power Stations': '多站数据',
            'Multiple Photovoltaic Power Stations Dashboard': '多站总览',
            'Multiple Photovoltaic Power Stations List': '电站列表',
            'Single Photovoltaic Power Station': '单站数据',
            'Single Photovoltaic Power Station Dashboard': '单站总览',
            'Single Photovoltaic Power Station Details': '设备数据',
            'Single Photovoltaic Power Station Fault Alarm': '故障告警',
            'Photovoltaic Power Station Reports': '统计报表',
            'Photovoltaic Power Station Reports Energy': '电量报表',
            'Photovoltaic Power Station Reports Revenue': '收益报表',
            'Photovoltaic Power Station Reports Parameters': '数据查询',
            'Work Order': '工单管理',
            'Work Order Installation': '安装记录',
            'Work Order Repair': '维修记录',
            'Work Order Inspection': '巡检记录',
            'Total Number of Work Orders': '总工单数量',
            'Number of New Work Orders': '新发工单数量',
            'Number of Inprogress Work Orders': '进行中工单数量',
            'Number of Done Work Orders': '已完成工单数量',
            'Fuel Indicator': '耗油量',
            'Charge Energy Indicator': '充电能量',
            'Discharge Energy Indicator': '放电能量',
            'Charge Cost Indicator': '充电成本',
            'Discharge Revenue Indicator': '放电收益',
            'HVAC': '空调',
            'Fire Control': '消防',

            // Dashboard
            'Welcome to MyEMS': '欢迎使用MyEMS',
            'An Industry Leading Open Source Energy Management System': '行业领先的开源能源管理系统',
            "This Year's Consumption CATEGORY VALUE UNIT": '本年消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": '本年成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": '本月消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": '本月产出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Costs CATEGORY VALUE UNIT": '本月成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': '去年同期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '去年同期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} 消耗 {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} 成本 {{UNIT}}',
            // Entities
            Space: '空间',
            Equipment: '设备',
            Meter: '计量表',
            'Offline Meter': '离线表',
            'Virtual Meter': '虚拟表',
            Tenant: '租户',
            Store: '门店',
            Shopfloor: '车间',
            'Combined Equipment': '组合设备',
            'Cost Center': '成本中心',
            Name: '名称',
            DisplayName: '显示名',
            UserName: '用户名',
            Description: '描述',
            'Energy Category': '能源分类',
            'Child Spaces': '子空间',
            'Associated Equipment': '相关设备',
            //Energy Categories
            Electricity: '电',
            Water: '自来水',
            'Natural Gas': '天然气',
            // SidePanelModal
            Settings: '设置',
            'Set your own customized style': '设置您的自定义样式',
            'Color Scheme': '配色方案',
            'Choose the perfect color mode for your app': '为您的应用选择理想的色彩模式',
            Light: '亮色',
            Dark: '暗色',
            'RTL Mode': 'RTL模式',
            'Switch your language direction': '改变你的语言方向',
            'Fluid Layout': '流动布局',
            'Toggle container layout system': '切换容器布局系统',
            'Navigation Position': '导航栏位置',
            'Vertical': '垂直',
            'Top': '顶部',
            'Combo': '组合',
            'Transparent': '透明',
            'Inverted': '反色',
            'Card': '卡片',
            'Vibrant': '活力',
            'Select a suitable navigation system for your web application': '为您的web应用程序选择合适的导航栏系统',
            'Vertical Nav': '垂直导航栏',
            'Top Nav': '顶部导航栏',
            'Vertical Navbar Style': '垂直导航栏样式',
            'Switch between styles for your vertical navbar': '切换垂直导航栏的样式',
            Language: '语言',
            'Switch between languages': '切换语言',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': '喜欢这个系统?',
            'Get MyEMS now': '立即获取MyEMS',
            'PQ.About': '本分析涵盖电压偏差、电压不平衡、频率偏差和电流不平衡。电压偏差按(U−Un)/Un×100%计算；频率偏差按|f−fn|计算；三相不平衡按max(|Xi−Xavg|)/Xavg×100%计算，并要求三相通道时间对齐。结果基于所选计量表在报告期内的时间序列。如果缺少三相通道或时间戳不对齐，将跳过不平衡指标。瞬态尖峰或缺失采样可能放大最差值，稳态评估建议参考合规率与P95等统计指标。',
            Purchase: '采购企业版',
            ContactInfo: '联系方式',
            ProductWebsite: '产品官网',
            CompanyWebsite: '公司官网',
            SalesPhone: '销售电话',
            // Query Panels
            'Base Period Begins': '基准期开始',
            'Base Period Ends': '基准期结束',
            'Comparison Types': '比较类型',
            'Year-Over-Year': '去年同比',
            'Month-On-Month': '上月环比',
            'Free Comparison': '自由比',
            'None Comparison': '不比',
            'Reporting Period Begins': '报告期开始',
            'Reporting Period Ends': '报告期结束',
            '(Optional)': '(可选)',
            'Period Types': '时间尺度',
            Yearly: '年',
            Monthly: '月',
            Weekly: '周',
            Daily: '日',
            Hourly: '时',
            Submit: '提交',
            'Input Energy Category': '消耗能源分类',
            'Output Energy Category': '产出能源分类',
            'Fraction Parameter': '分式参数',
            Search: '搜索',
            //DateRangePicker
            sunday: '日',
            monday: '一',
            tuesday: '二',
            wednesday: '三',
            thursday: '四',
            friday: '五',
            saturday: '六',
            ok: '确定',
            today: '今天',
            yesterday: '昨天',
            hours: '时',
            minutes: '分',
            seconds: '秒',
            last7Days: '最近七天',
            'Select Date Range': '选择日期范围',
            //Card Summaries and Line Charts
            'Base Period': '基准期',
            'Reporting Period': '报告期',
            'Per Unit Area': '单位面积值',
            'Per Capita': '人均值',
            'Per Unit Production': '单位产品值',
            Baseline: '基线值',
            Actual: '实际值',
            'Baseline Value - Actual Value': '基线值-实际值',
            'Average Load': '平均负荷',
            'Maximum Load': '最大负荷',
            'Load Factor': '负荷系数',
            'Ratio of Average Load to Maximum Load': '平均负荷与最大负荷的比值',
            'Carbon Dioxide Emissions by Energy Category': '二氧化碳排放占比',
            'Costs by Energy Category': '成本占比',
            'Incomes by Energy Category': '收入占比',
            'Electricity Consumption by Time-Of-Use': '分时消耗电量',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': '分时用电排放二氧化碳',
            'Electricity Cost by Time-Of-Use': '分时用电成本',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} 分项消耗占比',
            'Ton of Standard Coal by Energy Category': '吨标准煤(TCE)占比',
            'Ton of Carbon Dioxide Emissions by Energy Category': '吨二氧化碳排放(TCO2E)占比',
            'Reporting Period Consumption CATEGORY UNIT': '报告期消耗 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': '报告期预测 {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} 报告期消耗 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 报告期消耗 {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': '报告期产量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': '基准期产量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': '报告期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': '报告期预测 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': '基准期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': '报告期预测 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': '报告期消耗 {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '报告期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': '基准期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': '子空间分类占比 {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': '子空间总计占比',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '报告期二氧化碳排放 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                '报告期二氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '基准期二氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': '报告期成本 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': '报告期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': '基准期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': '报告期产出 {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} 报告期产出 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 报告期产出 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': '报告期产出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': '基准期产出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': '报告期收入 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': '报告期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': '基准期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': '报告期总收入 {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': '报告期累积效率 {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} 报告期累积效率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} 报告期累积综合效率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 报告期累积综合效率 {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 基准期累积综合效率 {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': '瞬时效率 {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 瞬时效率 {{UNIT}}',
            'Equipment Efficiency Indicator': '设备能效指标',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 瞬时综合效率 {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': '报告期累积效率 {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '报告期累积效率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': '基准期累积效率 {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': '基准期累积效率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': '基准期 {{CATEGORY}} 最大负荷 {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': '报告期 {{CATEGORY}} 最大负荷 {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': '报告期 {{CATEGORY}} 平均负荷 {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': '报告期 {{CATEGORY}} 负荷系数',
            'Base Period CATEGORY Average Load VALUE UNIT': '基准期 {{CATEGORY}} 平均负荷 {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': '报告期 {{CATEGORY}} 平均值 {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': '报告期 {{CATEGORY}} 最大值 {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': '报告期 {{CATEGORY}} 最小值 {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': '报告期 {{CATEGORY}}  算术平均数 {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': '报告期 {{CATEGORY}} 中位数 {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': '报告期 {{CATEGORY}} 样本标准差 {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': '报告期 {{CATEGORY}} 样本方差 {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '报告期节约 {{CATEGORY}} (基线-实际) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '报告期减少 {{CATEGORY}} (基线-实际) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': '报告期节约 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': '基准期节约 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': '报告期总表消耗 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '报告期总表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': '报告期分表消耗 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': '报告期分表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': '报告期差值 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': '报告期差值百分比',
            'Reporting Period Difference CATEGORY VALUE UNIT': '报告期差值 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': '趋势值',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': '故障列表',
            'Reporting Period Number of Fault VALUE': '报告期故障数: {{VALUE}}',
            'All Faults': '全部故障',
            'Space Faults': '空间故障',
            'Number of All Faults': '全部故障数',
            'Number of Space Faults': '空间故障数',
            'Total Number of Faults': '总故障数量',
            'Number of New Faults': '新发故障数量',
            'Number of Inprogress Faults': '进行中故障数量',
            'Number of Done Faults': '已完成故障数量',
            //Data Panels
            'Ton of Standard Coal': '吨标准煤',
            'Ton of Carbon Dioxide Emissions': '吨二氧化碳排放',
            'Carbon Emissions Per Unit Of Energy Consumption': '单位能耗碳排放',
            'Operating Characteristic Curve': '运行曲线',
            Tariff: '费率',
            'Detailed Data': '详细数据',
            'Child Spaces Data': '子空间数据',
            'Associated Equipment Data': '相关设备数据',
            'This Year': '本年',
            'The Same Period Last Year': '去年同期',
            'This Month': '本月',
            'This Day': '本日',
            Total: '总计',
            'No data found': '没有数据',
            Export: '导出',
            Datetime: '日期时间',
            'Time-Of-Use Type': '分时类型',
            'Top-Peak': '尖',
            'On-Peak': '峰',
            'Mid-Peak': '平',
            'Off-Peak': '谷',
            'Deep': '深谷',
            Percentage: '百分比',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': '能耗值点最近一小时趋势',
            Circuit: '回路',
            Point: '数据点',
            'Realtime Value': '实时值',
            //Meter Tracking
            'Meter List': '计量表列表',
            'Edit Meter': '编辑',
            'Start Value': '起始值',
            'End Value': '结束值',
            'Difference Value': '差值',
            'Start Integrity Rate': '起始数据完整率(%)',
            'End Integrity Rate': '结束数据完整率(%)',
            'Full Integrity Rate': '整体数据完整率(%)',
            //Equipment Tracking
            'Equipment List': '设备列表',
            'Edit Equipment': '编辑',
            //Profile Dropdown
            Feedback: '反馈',
            'Account Settings': '账号设置',
            Logout: '退出',
            //Authentication
            'Log in': '登录',
            'Email address': '电子邮件地址',
            'Phone Number': '电话号码',
            Password: '密码',
            CaptchaCode: '验证码',
            Refresh: '刷新',
            'Remember me': '记住我',
            'Logged in as ': '已登录 ',
            'Forgot Password?': '忘记密码?',
            'Forgot your password?': '忘记你的密码?',
            "Enter your email and we'll send you a reset link": '输入电子邮件地址，我们会把重置链接发送给您',
            "Enter your email and we'll send you a registration link": '输入电子邮件地址，我们会把注册链接发送给您',
            'Reset Password': '重置密码',
            'Thanks for using MyEMS!': '感谢您使用MyEMS!',
            'You are now successfully signed out': '您已成功退出',
            'Return to Login': '返回登录',
            'Please check your email!': '请查收您的电子邮件!',
            'An email has been sent to ': '一封电子邮件已经发送至 ',
            'Please click on the included link to reset your password': '请点击里面的链接重置您的密码',
            'Please click on the included link to register your account': '请点击里面的链接注册您的账户',
            'An email with password reset link is sent to ': '一封包含密码重置链接的电子邮件已经发送至 ',
            'Change Password': '修改密码',
            'Old Password': '原密码',
            'New Password': '新密码',
            'Confirm Password': '重复新密码',
            'Update Password': '更新密码',
            'Password has been changed!': '密码已修改!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below.':
                '验证码已发送到您的收件箱，请将其复制到下面的输入框中。',
            'New to MyEMS': '初次使用MyEMS',
            'Create an account': '注册账户',
            'EMAIL Account registration successful': '{{EMAIL}}账号注册成功',
            'Thanks for verifying your account!': '感谢您验证您的账户！',
            'Your code is': '您的代码是',
            'Send verification code': '发送验证码',
            'Please wait for NUMBER seconds': '请等待{{NUMBER}}秒',
            'Password reset': '密码重置',
            'Please wait for approval': '请等待审核',
            //notification
            Notifications: '通知',
            'Mark all as read': '全部设为已读',
            'View all': '全部',
            'Notification New': '新的',
            'Notification Earlier': '更早的',
            'Notification List': '通知列表',
            'Bulk actions': '批量操作',
            'Notification Subject': '主题',
            'Notification Created Datetime': '创建时间',
            'Notification Message': '内容',
            'Notification Priority': '优先级',
            'Notification Status': '状态',
            'Notification Mark As Read': '标记为已读',
            'Notification Mark As Acknowledged': '确认',
            'Notification Low': '低',
            'Notification Medium': '中',
            'Notification High': '高',
            'Notification Critical': '严重',
            'Notification Unread': '未读',
            'Notification Read': '已读',
            'Notification Acknowledged': '已确认',
            'Notification Archive': '存档',
            'Notification Delete': '删除',
            'Notification Apply': '应用',
            'Notification Start Datetime': '开始时间',
            'Notification End Datetime': '结束时间',
            'Notification Update Datetime': '更新时间',
            //Monitoring
            'Run Commands': '运行指令',
            'Pin Code': '密码',
            'Unlock': '解锁',
            'Set Value': '设定值',
            'Fault Alarms': '故障报警',
            'Instantaneous Efficiency VALUE UNIT': '瞬时效率 {{VALUE}} {{UNIT}}',
            'Communication Status': '通信状态',
            'Communication Online': '在线',
            'Communication Offline': '离线',
            'Equipment Status': '设备状态',
            'Equipment Running': '运行',
            'Equipment Stopped': '停机',
            'Show Up to': '每页显示数量',
            All: '全部',
            'FROM - TO of TOTAL': '当前显示{{FROM}} - {{TO}} 总计{{TOTAL}}',
            //Microgrid
            'Microgrid Energy': '电量',
            'Microgrid Revenue': '收益',
            'Microgrid Carbon': '碳排放',
            'Photovoltaic Generation': '光伏发电量',
            'EV Charger Consumption': '充电桩用电量',
            'Load Consumption': '负载用电量',
            'Grid Buy': '从电网购买电量',
            'Grid Sell': '向电网销售电量',
            'EV Charger': '充电桩',
            'Heat Pump': '热泵',
            'Photovoltaic': '光伏',
            'PCS Run State': 'PCS运行状态',
            'PCS Unknown': '未知',
            'PCS Initializing': '初始上电',
            'PCS Standby': '待机',
            'PCS Shutdown': '关机',
            'PCS Fault': '故障',
            'PCS Running': '运行',
            'Battery Power': '电池功率',
            'Photovoltaic Power': '光伏功率',
            'Grid Power': '电网功率',
            'Load Power': '负载功率',
            Reporting: '数据报表',
            Maintenance: '维护保养',
            'General Information': '基本信息',
            'Serial Number': '序列号',
            Address: '地址',
            'Postal Code': '邮编',
            'Rated Capacity': '额定容量',
            'Rated Power': '额定功率',
            Latitude: '纬度',
            Longitude: '经度',
            'Strategy Management': '策略管理',
            'Charging Schedule': '充电时间表',
            'Charge Start Time': '充电开始时间',
            'Charge End Time': '充电结束时间',
            'Discharge Start Time': '放电开始时间',
            'Discharge End Time': '放电结束时间',
            'Total Rated Power': '总额定功率',
            'Total Rated Capacity': '总额定容量',
            // Energy Indicator
            "Today's Charge": "今日充电量",
            "Today's Discharge": "今日放电量",
            "Today's Generation": "今日发电量",
            'Total Fuel Consumption': '总耗油量',
            'Total Charge': '总充电',
            'Total Discharge': '总放电',
            'Total Generation': '总发电量',
            'Total Revenue': '总收益',
            'Total Photovoltaic Generation': '总光伏发电量',
            'Total EV Charger Consumption': '充电桩总用电量',
            'Total Load Consumption': '负载总用电量',
            'Total Grid Buy': '从电网购买总电量',
            'Total Grid Sell': '向电网销售总电量',
            'Total Efficiency': '综合效率',
            'Discharge Achievement Rate': '放电达成率',
            // Revenue Indicator
            "Today's Cost": "今日成本",
            "Today's Income": "今日收入",
            "Total Cost": "累计成本",
            "Total Income": "累计收入",
            "Today's Revenue": "今日盈利",

            'Revenue Ranking': '收益排名',
            'Efficiency Ranking': '效率排名',
            'Charge Ranking': '充电排名',
            'Discharge Ranking': '放电排名',
            'Number of Microgrids': '微电网数',
            'Number of Power Stations': '电站数',
            'Microgrid List': '微电网列表',
            'Select Microgrid': '选择微电网',
            'Previous Page': '上一页',
            'Next Page': '下一页',
            '7 Days': '7日',
            'Charge UNIT': '充 {{UNIT}}',
            'Discharge UNIT': '放 {{UNIT}}',
            'Generation UNIT': '发电 {{UNIT}}',
            'Energy Indicator': '能量',
            'Revenue Indicator': '收益',
            'Carbon Indicator': '碳',

            // Energy Storage Power Station
            'Battery Operating State': '电池运行状态',
            'Battery State': '电池状态',
            'Battery Unknown': '未知',
            'Battery Stopped': '停止',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': '故障', // 1
            'Battery Warning': '预警', // 2
            'Battery Standby': '待机', // 3
            'Battery Prohibit DisCharging': '禁放', // 4
            'Battery Prohibit Charging': '禁充', // 5
            'Battery Normal': '正常', // 6
            'Battery Charging': '充电', // 7
            'Battery Discharging': '放电', // 8
            'Battery Idle': '空闲', // 9
            'Phase of Lifecycle': '阶段',
            'Use Phase': '投用',
            'Commissioning Phase': '调试',
            'Commissioning Date': '启用日期',
            'Installation Phase': '在建',
            'Device Status': '设备状态',
            'Basic Information': '基本信息',
            'Gateway': '网关',
            'Grid Meter': '电网电表',
            'Load Meter': '负载电表',
            'ESS Meter': '储能电表',
            'Total Active Power': '总有功功率',
            'Active Power A': 'A相有功功率',
            'Active Power B': 'B相有功功率',
            'Active Power C': 'C相有功功率',
            'Total Reactive Power': '总无功功率',
            'Reactive Power A': 'A相无功功率',
            'Reactive Power B': 'B相无功功率',
            'Reactive Power C': 'C相无功功率',
            'Total Apparent Power': '总视在功率',
            'Apparent Power A': 'A相视在功率',
            'Apparent Power B': 'B相视在功率',
            'Apparent Power C': 'C相视在功率',
            'Total Power Factor': '总功率因数',
            'Active Energy Import': '正向有功电能',
            'Active Energy Export': '反向有功电能',
            'Active Energy Net': '净有功电能',

            'Generator': '发电机',

            // Photovoltaic Power Station
            'Invertor': '逆变器',
            'Invertor Run State': '逆变器运行状态',
            'Invertor Unknown': '未知',
            'Invertor Initializing': '初始上电',
            'Invertor Standby': '待机',
            'Invertor Shutdown': '关机',
            'Invertor Fault': '故障',
            'Invertor Running': '运行',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': '生成时间',
            'File Format': '文件格式',
            'File Size': '文件大小',
            Uploader: '上传者',
            'Upload Datetime': '上传时间',
            //Error
            "The page you're looking for is not found": '您要找的页面不存在',
            "Make sure the address is correct and that the page hasn't moved": '请确认地址正确且页面没有被移动',
            'If you think this is a mistake,': '如果您认为这是一个错误,',
            'contact us': '联系我们',
            'Take me home': '带我回首页',
            'Whoops, something went wrong!': '哦, 出错了！!',
            'Try refreshing the page, or going back and attempting the action again':
                '请尝试刷新页面, 或回退并再次尝试执行这个操作',
            'If this problem persists,': '如果问题依然存在,',
            'Captcha Error': '验证码错误',
            'Confirm Password Error': '两次密码不一致',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                '看起来你点击了一个无效的重置密码链接。请再试一次。',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                '看起来你点击了一个无效的注册账号链接。请再试一次。',
            //Tenant Bill
            'Lease Contract Number': '租赁合同号码',
            Download: '下载',
            Print: '打印',
            'Payment Notice': '付款通知书',
            'Bill To': '致',
            'Bill Number': '账单号码',
            'Bill Date': '账单日期',
            'Payment Due Date': '付款到期日',
            'Amount Payable': '应付款金额',
            'Billing Period Start': '结算期起始日期',
            'Billing Period End': '结算期结束日期',
            Quantity: '数量',
            Price: '价格',
            Unit: '单位',
            Amount: '金额',
            Subtotal: '小计',
            'VAT Output Tax': '增值税销项税金',
            'Total Amount Payable': '应付金额合计',
            'Please make sure to pay on or before the payment due date above': '请确保在上述付款到期日或之前付款',
            'Send money to the following account': '汇款至以下账户',
            'Account Name': '账户名称',
            'Bank Name': '开户银行',
            'Bank Address': '银行地址',
            'RMB Account': '人民币账户',
            // button
            'Toggle Navigation': '切换导航',
            // working calendar
            'Working Days': '工作日',
            'Non Working Days': '非工作日',
            'Select Row': '请选择要操作的数据行',
            // Offline Meter Input
            'Daily Value': '日数据',
            Date: '日期',
            'Successfully Saved': '保存成功',
            'Previous Data Is Empty': '之前的数据为空',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': '管理员会话不存在',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': '管理员会话已超时',
            'API.ADVANCED_REPORT_NOT_FOUND': '高级报表不存在',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': '错误请求',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': '不能将已经设为分表的计量表设置为总表',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': '组合设备与设备关系已存在',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': '组合设备与设备关系不存在',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': '组合设备与计量表关系已存在',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': '组合设备与计量表关系不存在',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': '组合设备名称已使用',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': '组合设备不存在',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '组合设备与离线表关系已存在',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '组合设备与离线表关系不存在',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '组合设备相关参数名称已使用',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '组合设备相关参数不存在或不匹配',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '组合设备与虚拟表关系已存在',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '组合设备与虚拟表关系不存在',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': '联系人姓名已使用',
            'API.CONTACT_NOT_FOUND': '联系人不存在',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': '成本中心外部ID已存在',
            'API.COST_CENTER_NAME_EXISTS': '成本中心名称已存在',
            'API.COST_CENTER_NOT_FOUND': '成本中心不存在',
            'API.COST_FILE_NOT_FOUND': '成本文件不存在',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': '数据源名称已使用',
            'API.DATA_SOURCE_NOT_FOUND': '数据源不存在',
            'API.DATABASE_ERROR': '数据库错误',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': '日期已在工作日历中',
            'API.DATE_LOCAL_NOT_FOUND': '未找到本地日期',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': '配电回路名称已使用',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': '配电回路不存在',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': '配电回路与点位关系已存在',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': '配电回路与点位关系不存在',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': '配电系统名称已使用',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': '配电系统不存在',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': '电子邮箱已使用',
            'API.EMAIL_MESSAGE_NOT_FOUND': '电子邮件消息不存在',
            'API.EMAIL_NOT_FOUND': '电子邮箱不存在',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': '邮件服务器主机已使用',
            'API.EMAIL_SERVER_NOT_FOUND': '邮件服务器主机不存在',
            'API.EMPTY_VARIABLES_ARRAY': '空变量数组',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': '能源分类名称已使用',
            'API.ENERGY_CATEGORY_NOT_FOUND': '能源分类不存在',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': '能源分类在能源分项中已使用',
            'API.ENERGY_CATEGORY_USED_IN_METER': '能源分类在计量表中已使用',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': '能源分类在离线表中已使用',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': '能源分类在费率中已使用',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': '能源分类在虚拟表中已使用',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': '能流图链接已使用',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': '能流图链接不存在或不匹配',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': '能流图名称已使用',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': '能流图节点已使用',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': '能流图节点不存在或不匹配',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': '能流图不存在',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': '能源分项不属于能源分类',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': '能源分项不属于能源分类',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': '能源分项已使用',
            'API.ENERGY_ITEM_NOT_FOUND': '能源分项不存在',
            'API.ENERGY_ITEM_USED_IN_METER': '能源分项在计量表中已使用',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': '能源分项在离线表中已使用',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': '能源分项在虚拟表中已使用',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': '设备与计量表关系已存在',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': '设备与计量表关系不存在',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': '设备名称已使用',
            'API.EQUIPMENT_NOT_FOUND': '设备不存在',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '设备与离线表关系已存在',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '设备与离线表关系不存在',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '设备相关参数名称已使用',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '设备相关参数不存在或不匹配',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '设备与虚拟表关系已存在',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '设备与虚拟表关系不存在',
            'API.ERROR': '错误',
            'API.EXCEPTION': '异常',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': '恢复成本文件失败',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': '恢复知识文件失败',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': '恢复离线表文件失败',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': '保存离线表文件失败',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': '上传成本文件失败',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': '上传知识文件失败',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': '上传离线表文件失败',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': '网关名称已使用',
            'API.GATEWAY_NOT_FOUND': '网关不存在',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': '无效的 ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': '无效地址',
            'API.INVALID_ADDRESS_VALUE': '无效地址值',
            'API.INVALID_ADVANCED_REPORT_ID': '无效的高级报表ID',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': '无效面积值',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': '无效的基准期结束时间',
            'API.INVALID_BASE_PERIOD_START_DATETIME': '无效的基准期开始时间',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': '无效波特率',
            'API.INVALID_BUILDINGS_VALUE': '无效的建筑值',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': '无效类型',
            'API.INVALID_CHANNEL': '无效通道',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': '无效的组合设备ID',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': '无效的组合设备名称',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': '无效的组合设备相关参数ID',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': '无效的组合设备相关参数名称',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': '无效的组合设备相关参数类型',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': '无效的组合设备UUIDs',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': '无效连接',
            'API.INVALID_CONSTANT_VALUE': '无效常量值',
            'API.INVALID_CONTACT_ID': '无效的联络人ID',
            'API.INVALID_CONTACT_NAME': '无效的联络人姓名',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': '无效的成本中心ID',
            'API.INVALID_COST_FILE_ID': '无效的成本文件ID',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': '无效的数据源ID',
            'API.INVALID_DATA_SOURCE_NAME': '无效的数据源名称',
            'API.INVALID_DATA_SOURCE_PROTOCOL': '无效的数据源协议',
            'API.INVALID_DATE_LOCAL': '无效的本地日期',
            'API.INVALID_DENOMINATOR_METER_UUID': '无效的标准计量表UUID',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': '无效的显示名称',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': '无效的配电回路ID',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': '无效的配电回路名称',
            'API.INVALID_DISTRIBUTION_ROOM': '无效的配电室',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': '无效的配电系统ID',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': '无效的配电系统名称',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': '无效的邮箱',
            'API.INVALID_EMAIL_MESSAGE_ID': '无效的电子邮件ID',
            'API.INVALID_EMAIL_SERVER_HOST': '无效的电子邮箱服务器主机',
            'API.INVALID_EMAIL_SERVER_ID': '无效的电子邮箱服务器ID',
            'API.INVALID_END_DATE_FORMAT': '无效的结束日期格式',
            'API.INVALID_END_DATETIME': '无效的结束日期',
            'API.INVALID_ENERGY_CATEGORY_ID': '无效的能源分类ID',
            'API.INVALID_ENERGY_CATEGORY_NAME': '无效的能源分类名称',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': '无效的能流图ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': '无效的能流图链接ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': '无效的能流图名称',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': '无效的能流图节点ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': '无效的能流图节点名称',
            'API.INVALID_ENERGY_ITEM_ID': '无效的能源分项ID',
            'API.INVALID_ENERGY_ITEM_NAME': '无效的能源分项名称',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': '表达式中无效的表达式',
            'API.INVALID_EQUIPMENT_ID': '无效的设备ID',
            'API.INVALID_EQUIPMENT_NAME': '无效的设备名称',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': '无效的设备相关参数ID',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': '无效的设备相关参数名称',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': '无效的设备相关参数类型',
            'API.INVALID_EQUIPMENT_UUID': '无效的设备UUID',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': '无效表达式',
            'API.INVALID_EXPRESSION_OBJECT': '无效的表达式对象',
            'API.INVALID_FDD_CODE': '无效的故障错误码',
            'API.INVALID_FLOORS_VALUE': '无效的楼层值',
            'API.INVALID_FROM_ADDR': '无效地址',
            'API.INVALID_GATEWAY_ID': '无效的网关ID',
            'API.INVALID_GATEWAY_NAME': '无效的网关名称',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': '无效的小时上限值',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': '无效的小时下限值',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': '无效的管理值',
            'API.INVALID_IS_COST_DATA_DISPLAYED': '无效的是否显示成本数据',
            'API.INVALID_IS_COUNTED_VALUE': '无效的计数值',
            'API.INVALID_IS_ENABLED': '无效的是否启用',
            'API.INVALID_IS_HIDDEN': '无效的是否隐藏',
            'API.INVALID_IS_IN_LEASE_VALUE': '无效的是否在租值',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': '无效的输入是否汇总值',
            'API.INVALID_IS_KEY_TENANT_VALUE': '无效的是否主力租户值',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': '无效的输出是否汇总值',
            'API.INVALID_IS_OUTPUT_VALUE': '无效的输出是否汇总值',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': '无效的是否保存趋势值',
            'API.INVALID_IS_VIRTUAL_VALUE': '无效的是否虚拟点值',
            'API.INVALID_KGCE': '无效的千克标准煤系数',
            'API.INVALID_KGCO2E': '无效的千克二氧化碳排放系数',
            'API.INVALID_KNOWLEDGE_FILE_ID': '无效的知识文件ID',
            'API.INVALID_LATITUDE_VALUE': '无效的纬度值',
            'API.INVALID_LEASE_NUMBER_VALUE': '无效的租约编号',
            'API.INVALID_LONGITUDE_VALUE': '无效的经度值',
            'API.INVALID_LOW_LIMIT_VALUE': '无效的下限值',
            'API.INVALID_MASTER_METER_ID': '无效的总计量表ID',
            'API.INVALID_MENU_ID': '无效的菜单ID',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': '无效的消息模板',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': '无效的计量表ID',
            'API.INVALID_METER_NAME': '无效的计量表名称',
            'API.INVALID_METER_UUID': '无效的计量表UUID',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': '无效的名称值',
            'API.INVALID_NEW_PASSWORD': '无效的新密码',
            'API.INVALID_NON_WORKING_DAY_ID': '无效的非工作日ID',
            'API.INVALID_NOTIFICATION_ID': '无效的通知ID',
            'API.INVALID_NUMERATOR_METER_UUID': '无效的分子表UUID',
            'API.INVALID_OBJECT_TYPE': '无效的对象类型',
            'API.INVALID_OFFLINE_METER_DATA': '无效离线表数据',
            'API.INVALID_OFFLINE_METER_FILE_ID': '无效的离线表文件ID',
            'API.INVALID_OFFLINE_METER_ID': '无效的离线表ID',
            'API.INVALID_OFFLINE_METER_NAME': '无效的离线表名称',
            'API.INVALID_OFFLINE_METER_UUID': '无效的离线表UUID',
            'API.INVALID_OFFSET_CONSTANT_VALUE': '无效的偏移常量',
            'API.INVALID_OLD_PASSWORD': '无效的旧密码',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': '无效的父空间ID',
            'API.INVALID_PASSWORD': '无效的密码',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': '无效峰值电流',
            'API.INVALID_PEAK_LOAD': '无效峰值负载',
            'API.INVALID_PERIOD_TYPE': '无效周期类型',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': '无效的数据点ID',
            'API.INVALID_POINT_NAME': '无效的数据点名称',
            'API.INVALID_PORT': '无效端口',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': '无效的优先级',
            'API.INVALID_PRIVILEGE': '无效的权限',
            'API.INVALID_PRIVILEGE_DATA': '无效的权限数据',
            'API.INVALID_PRIVILEGE_ID': '无效的权限ID',
            'API.INVALID_PRIVILEGE_NAME': '无效的权限名称',
            'API.INVALID_RATIO_VALUE': '无效的变比值',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': '无效回复',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': '无效的报告期结束日期时间',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': '无效的报告期开始日期时间',
            'API.INVALID_REQUIRES_AUTHENTICATION': '无效的需要身份验证',
            'API.INVALID_ROOMS_VALUE': '无效的房间值',
            'API.INVALID_RULE_ID': '无效的规则ID',
            'API.INVALID_RULE_NAME': '无效的规则名称',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': '无效的传感器ID',
            'API.INVALID_SENSOR_NAME': '无效的传感器名称',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': '无效的串口号',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': '会话无效，请重新登陆',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': '无效的车间ID',
            'API.INVALID_SHOPFLOOR_NAME': '无效的车间名称',
            'API.INVALID_SHOPFLOOR_UUID': '无效的车间UUID',
            'API.INVALID_SOURCE_NODE_ID': '无效的源节点ID',
            'API.INVALID_SPACE_ID': '无效的空间ID',
            'API.INVALID_SPACE_NAME': '无效的空间名称',
            'API.INVALID_SPACE_UUID': '无效的空间UUID',
            'API.INVALID_START_DATE_FORMAT': '无效的开始时间格式',
            'API.INVALID_START_DATETIME': '无效的开始时间',
            'API.INVALID_STATUS': '无效状态',
            'API.INVALID_STORE_ID': '无效门店ID',
            'API.INVALID_STORE_NAME': '无效门店名称',
            'API.INVALID_STORE_TYPE_DESCRIPTION': '无效的门店类型描述',
            'API.INVALID_STORE_TYPE_ID': '无效的门店类型ID',
            'API.INVALID_STORE_TYPE_NAME': '无效的门店类型名称',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': '无效的门店类型简化代码',
            'API.INVALID_STORE_UUID': '无效门店UUID',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': '无效SVG',
            'API.INVALID_SWITCHGEAR': '无效的开关设备',
            'API.INVALID_TARGET_NODE_ID': '无效的目标节点ID',
            'API.INVALID_TARIFF_BLOCK_PRICING': '无效的阶梯费率定价',
            'API.INVALID_TARIFF_ID': '无效的费率ID',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': '无效的分时费率定价',
            'API.INVALID_TARIFF_TYPE': '无效的费率类型',
            'API.INVALID_TENANT_ID': '无效的租户ID',
            'API.INVALID_TENANT_NAME': '无效的租户名称',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': '无效的租户类型描述',
            'API.INVALID_TENANT_TYPE_ID': '无效的租户类型ID',
            'API.INVALID_TENANT_TYPE_NAME': '无效的租户类型名称',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': '无效的租户类型简化代码',
            'API.INVALID_TENANT_UUID': '无效的租户UUID',
            'API.INVALID_TEXT_MESSAGE_ID': '无效的短信ID',
            'API.INVALID_TIMEZONE_ID': '无效的时区ID',
            'API.INVALID_TOKEN': '无效令牌',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': '无效的计量单位',
            'API.INVALID_UNIT_OF_PRICE': '无效的价格单位',
            'API.INVALID_UNITS': '无效单位',
            'API.INVALID_USER_ID': '无效的用户ID',
            'API.INVALID_USER_NAME': '无效的用户名称',
            'API.INVALID_USER_NAME_OR_EMAIL': '无效的用户名称或邮箱',
            'API.INVALID_USER_PHONE': '无效的用户手机号',
            'API.INVALID_USER_PLEASE_RE_LOGIN': '无效的用户请重新登录',
            'API.INVALID_USER_UUID': '无效的用户UUID',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': '无效的变量计量表ID',
            'API.INVALID_VARIABLE_METER_TYPE': '无效的变量计量表类型',
            'API.INVALID_VARIABLE_NAME': '无效的变量名称',
            'API.INVALID_VERIFICATION_CODE': '无效的验证码',
            'API.INVALID_VIRTUAL_METER_ID': '无效的虚拟表ID',
            'API.INVALID_VIRTUAL_METER_NAME': '无效的虚拟表名称',
            'API.INVALID_VIRTUAL_METER_UUID': '无效的虚拟表UUID',
            'API.INVALID_WEB_MESSAGE_ID': '无效的web消息ID',
            'API.INVALID_WECHAT_MESSAGE_ID': '无效的微信消息ID',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': '无效的工作日历ID',
            'API.INVALID_WORKING_CALENDAR_NAME': '无效的工作日历名称',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': '无法从磁盘中删除知识文件',
            'API.KNOWLEDGE_FILE_NOT_FOUND': '知识库文件不存在',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': '总表不属于同一能源分类',
            'API.MASTER_METER_NOT_FOUND': '总表不存在',
            'API.MENU_NOT_FOUND': '菜单不存在',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': '计量表名称已使用',
            'API.METER_NOT_FOUND': '计量表不存在',
            'API.METER_OF_VARIABLE_NOT_FOUND': '计量表变量不存在',
            'API.METER_POINT_RELATION_EXISTS': '计量表与数据点关系已存在',
            'API.METER_POINT_RELATION_NOT_FOUND': '计量表与数据点关系不存在',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '新密码长度不能超过100个字符',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': '非工作日不存在',
            'API.NOT_FOUND': '不存在',
            'API.NOTIFICATION_NOT_FOUND': '通知不存在',
            'API.OFFLINE_METER_FILE_NOT_FOUND': '离线表文件不存在',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': '离线表名称已使用',
            'API.OFFLINE_METER_NOT_FOUND': '离线表不存在',
            'API.INVALID_OFFLINE_METER_VALUE': '无效的离线数据',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': '离线表变量不存在',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '旧密码长度不能超过100个字符',
            'API.PARENT_SPACE_NOT_FOUND': '父空间不存在',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '密码长度不能超过100个字符',
            'API.PASSWORDS_MATCH': '新密码与旧密码一致',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': '数据点名称已使用',
            'API.POINT_NOT_FOUND': '数据点不存在',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': '权限名称已使用',
            'API.PRIVILEGE_NOT_FOUND': '权限不存在',
            'API.RULE_NAME_IS_ALREADY_IN_USE': '规则名称已使用',
            'API.RULE_NOT_FOUND': '规则不存在',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': '传感器名称已使用',
            'API.SENSOR_NOT_FOUND': '传感器不存在',
            'API.SENSOR_POINT_RELATION_EXISTS': '传感器与数据点关系已存在',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': '传感器与数据点关系不存在',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': '车间与设备关系已存在',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': '车间与设备关系不存在',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': '车间与计量表关系已存在',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': '车间与计量表关系不存在',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': '车间名称已使用',
            'API.SHOPFLOOR_NOT_FOUND': '车间不存在',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': '车间与离线表关系已存在',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': '车间与离线表关系不存在',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': '车间与数据点关系已存在',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': '车间与数据点关系不存在',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': '车间与传感器关系已存在',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': '车间与传感器关系不存在',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': '车间与虚拟表关系已存在',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': '车间与虚拟表关系不存在',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': '车间工作日历关系已存在',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': '车间与工作日历关系不存在',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': '源节点不存在',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': '空间与组合设备关系已存在',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': '空间与组合设备关系不存在',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': '空间与设备关系已存在',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': '空间与设备关系不存在',
            'API.SPACE_METER_RELATION_EXISTS': '空间与计量表关系已存在',
            'API.SPACE_METER_RELATION_NOT_FOUND': '空间与计量表关系不存在',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': '空间名称已使用',
            'API.SPACE_NOT_FOUND': '空间不存在',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': '空间在权限中不存在',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': '空间与离线表关系已存在',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': '空间与离线表关系不存在',
            'API.SPACE_POINT_RELATION_EXISTS': '空间与数据点关系已存在',
            'API.SPACE_POINT_RELATION_NOT_FOUND': '空间与数据点关系不存在',
            'API.SPACE_SENSOR_RELATION_EXISTS': '空间与传感器关系已存在',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': '空间与传感器关系不存在',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': '空间与车间关系已存在',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': '空间与车间关系不存在',
            'API.SPACE_STORE_RELATION_EXISTS': '空间与门店关系已存在',
            'API.SPACE_STORE_RELATION_NOT_FOUND': '空间与门店关系不存在',
            'API.SPACE_TENANT_RELATION_EXISTS': '空间与租户关系已存在',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': '空间与租户关系不存在',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': '空间与虚拟表关系已存在',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': '空间与虚拟表关系不存在',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': '空间与工作日历关系已存在',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': '空间与工作日历关系不存在',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': '开始日期时间必须早于结束日期时间',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': '门店与计量表关系已存在',
            'API.STORE_METER_RELATION_NOT_FOUND': '门店与计量表关系不存在',
            'API.STORE_NAME_IS_ALREADY_IN_USE': '门店名称已使用',
            'API.STORE_NOT_FOUND': '门店不存在',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': '门店与离线表关系已存在',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': '门店与离线表关系不存在',
            'API.STORE_POINT_RELATION_EXISTS': '门店与数据点关系已存在',
            'API.STORE_POINT_RELATION_NOT_FOUND': '门店与数据点关系不存在',
            'API.STORE_SENSOR_RELATION_EXISTS': '门店与传感器关系已存在',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': '门店传感器关系不存在',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': '门店类型名称已使用',
            'API.STORE_TYPE_NOT_FOUND': '门店类型不存在',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '门店类型简化代码已使用',
            'API.STORE_TYPE_USED_IN_STORE': '门店类型在门店中已使用',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': '门店与虚拟表关系已存在',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': '门店与虚拟表关系不存在',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': '门店与工作日历关系已存在',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': '门店与工作日历关系不存在',
            'API.TARGET_NODE_NOT_FOUND': '目标节点不存在',
            'API.TARIFF_IN_USE': '费率正在使用',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': '费率和成本中心已关联',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': '费率和成本中心未关联',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': '费率名称已使用',
            'API.TARIFF_NOT_FOUND': '费率不存在',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': '租户与计量表关系已存在',
            'API.TENANT_METER_RELATION_NOT_FOUND': '租户与计量表关系不存在',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': '租户名称已使用',
            'API.TENANT_NOT_FOUND': '租户不存在',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': '租户与离线表关系已存在',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': '租户与离线表关系不存在',
            'API.TENANT_POINT_RELATION_EXISTS': '租户与数据点关系已存在',
            'API.TENANT_POINT_RELATION_NOT_FOUND': '租户与数据点关系不存在',
            'API.TENANT_SENSOR_RELATION_EXISTS': '租户与传感器关系已存在',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': '租户与传感器关系不存在',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': '租户与类型名称已使用',
            'API.TENANT_TYPE_NOT_FOUND': '租户类型不存在',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '租户类型简化代码已使用',
            'API.TENANT_TYPE_USED_IN_TENANT': '租户类型在租户中已使用',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': '租户与虚拟表关系已存在',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': '租户与虚拟表关系不存在',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': '租户与工作日历关系已存在',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': '租户与工作日历关系不存在',
            'API.TEXT_MESSAGE_NOT_FOUND': '未找到短信',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': '报告期必须大于15分钟',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': '与子表有关系',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': '与子空间有关系',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': '与组合设备相关参数有关系',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': '与组合设备有关系',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': '与数据源有关系',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': '与能流图有关系',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': '与储能集装箱电池有关系',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': '与储能集装箱电网有关系',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': '与储能集装箱负载有关系',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': '与储能集装箱功率转换系统(PCS)有关系',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': '与设备相关参数有关系',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': '与设备有关系',
            'API.THERE_IS_RELATION_WITH_METER': '与计量表有关系',
            'API.THERE_IS_RELATION_WITH_METERS': '与多个记量表有关系',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': '与离线表有关系',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': '与多个离线表有关系',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': '与虚拟表有关系',
            'API.THERE_IS_RELATION_WITH_SENSORS': '与传感器有关系',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': '与车间有关系',
            'API.THERE_IS_RELATION_WITH_SPACES': '与空间有关系',
            'API.THERE_IS_RELATION_WITH_STORES': '与门店有关系',
            'API.THERE_IS_RELATION_WITH_TENANTS': '与租户有关系',
            'API.THERE_IS_RELATION_WITH_USERS': '与用户有关系',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': '与虚拟表有关系',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': '与虚拟电厂有关系',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': '这个数据源正在被一个计量表使用',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '这个计量表正在被一个虚拟表使用',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '这个离线表正在被一个虚拟表使用',
            'API.THIS_SPACE_CANNOT_BE_CLONED': '空间不能被克隆',
            'API.THIS_SPACE_CANNOT_BE_DELETED': '空间不能被删除',
            'API.TIMEZONE_NOT_FOUND': '时区不存在',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '未找到令牌，请登录',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': '用户帐号已锁定',
            'API.USER_ACCOUNT_HAS_EXPIRED': '用户帐号已过期',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': '用户名已使用',
            'API.USER_NOT_FOUND': '用户不存在',
            'API.USER_PASSWORD_HAS_EXPIRED': '用户密码已过期',
            'API.USER_PRIVILEGE_NOT_FOUND': '未发现用户权限',
            'API.USER_SESSION_NOT_FOUND': '未发现用户会话',
            'API.USER_SESSION_TIMEOUT': '用户会话已过期',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '用户UUID不存在，请登录',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': '虚拟表名称已使用',
            'API.VIRTUAL_METER_NOT_FOUND': '虚拟表不存在',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': '变量的虚拟表不存在',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': '虚拟数据点应该是模拟量',
            'API.WEB_MESSAGE_NOT_FOUND': 'web信息不存在',
            'API.WECHAT_MESSAGE_NOT_FOUND': '微信信息不存在',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': '工作日历名称已使用',
            'API.WORKING_CALENDAR_NOT_FOUND': '工作日历不存在',

            MasterMeter: '总表',
            SubMeter: '分表',
            'Power Quality': '电能质量',
            'About Power Quality': '关于电能质量',
            'Trend Values': '趋势值',
            Category: '类别',
            Type: '类型',
            Unit: '单位',
            Limit: '限值',
            'Normal Limit': '正常限值',
            'Severe Limit': '严重限值',
            Compliance: '合规率',
            'Worst Deviation': '最差偏差',
            'Worst Time': '最差发生时间',
            'Severe Exceed Count': '严重越限次数',
            'Worst Unbalance': '最大不平衡率',
            Hz: '赫兹',
            voltage: '电压',
            current: '电流',
            frequency: '频率',
            voltage_deviation: '电压偏差',
            current_unbalance: '电流不平衡',
            voltage_unbalance: '电压不平衡',
            mean_deviation_pct: '平均偏差(%)',
            p95_abs_deviation_pct: 'P95绝对偏差(%)',
            mean_abs_deviation_hz: '平均绝对偏差(Hz)',
            frequency_deviation: '频率偏差',
            p95_abs_deviation_hz: 'P95绝对偏差(Hz)',
            mean_unbalance_pct: '平均不平衡率(%)',
            p95_unbalance_pct: 'P95不平衡率(%)',
            count: '计数',
            min: '最小值',
            max: '最大值',
            mean: '平均值',
            std: '标准差',
            p5: 'P5',
            p95: 'P95'
        }
    },
    de: {
        translation: {
            // routes & menus
            Dashboard: 'Instrumententafel',
            'Space Data': 'Platz',
            'Equipment Data': 'Ausrüstung',
            'Meter Data': 'Meter',
            'Tenant Data': 'Mieter',
            'Store Data': 'Geschäft',
            'Shopfloor Data': 'Werkstatt',
            'Combined Equipment Data': 'Kombinierte Ausrüstung',
            'Auxiliary System': 'Hilfssystem',
            Microgrid: 'Mikronetz',
            'Energy Storage Power Station': 'Kraftwerk',
            'Photovoltaic Power Station': 'Kraftwerk',
            'Fault Alarm': 'Fehleralarm',
            Monitoring: 'Überwachung',
            'Advanced Reporting': 'Erweiterte Berichterstellung',
            'Knowledge Base': 'Wissensbasis',
            'Energy Category Data': 'Energiekategorie',
            'Energy Item Data': 'Unterpunkt Energieverbrauch',
            Carbon: 'CO2 Emissionen',
            Cost: 'Kosten',
            Output: 'Ausgang',
            Income: 'Einkommen',
            Efficiency: 'Effizienz',
            Load: 'Stromlast',
            Statistics: 'Statistiken',
            'Batch Analysis': 'Charge Analyse',
            Saving: 'Sparen',
            Plan: 'Planen',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Ausrüstung Datei',
            'Equipment Comparison': 'Ausrüstung Vergleich',
            'Shopfloor Comparison': 'Ausrüstung Vergleich',
            'Store Comparison': 'Geschäfte  Vergleich',
            'Space Comparison': 'Raumvergleich',
            'Combined Equipment Comparison': 'Ausrüstung Vergleich',
            'Tenant Comparison': 'Vergleich der Mieter',
            'Environment Monitor': 'Umgebungsmonitor',
            'Meter Energy': 'Meter Energie ',
            'Meter Carbon': 'Meter CO2 Emissionen',
            'Meter Cost': 'Meter Kosten',
            'Meter Trend': 'Meter Trend',
            'Meter Realtime': 'Meter Echtzeit',
            'Meter Saving': 'Meter Sparen',
            'Meter Plan': 'Meterplan',
            'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
            'Meter Batch Analysis': 'Meter Charge Analyse',
            'Meter Comparison': 'Meter Vergleich',
            'Meter Tracking': 'Meterverfolgung',
            'Virtual Meter Saving': 'Virtual Meter Sparen',
            'Virtual Meter Plan': 'Virtueller Zählerplan',
            'Virtual Meter Energy': 'Virtuelles Meter Energie',
            'Virtual Meter Carbon': 'Virtuelles Meter CO2 Emissionen',
            'Virtual Meter Cost': 'Virtuelles Meter Kosten',
            'Virtual Meter Batch Analysis': 'Virtuelles Meter Charge Analyse',
            'Virtual Meter Comparison': 'Vergleich virtueller Zähler',
            'Offline Meter Energy': 'Offline Meter Energie',
            'Offline Meter Carbon': 'Offline Meter CO2 Emissionen',
            'Offline Meter Cost': 'Offline Meter Kosten',
            'Offline Meter Batch Analysis': 'Offline Meter Charge Analyse',
            'Offline Meter Saving': 'Offline Meter Sparen',
            'Offline Meter Plan': 'Offline-Zählerplan',
            'Offline Meter Input': 'Offline-Zählereinstellung',
            'Tenant Bill': 'Mieter Rechnung',
            'Energy Flow Diagram': 'Energieflussdiagramm',
            'Distribution System': 'Vertriebssystem',
            'SVG System': 'SCADA-Visualisierungssystem',
            'Faults Data': 'Fehler',
            'Space Equipments': 'Platz Ausrüstung',
            'Combined Equipments': 'Kombinierte Ausrüstung',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Gesamtzahl der Arbeitsaufträge',
            'Number of New Work Orders': 'Anzahl der neuen Arbeitsaufträge',
            'Number of Inprogress Work Orders': 'Anzahl der laufenden Arbeitsaufträge',
            'Number of Done Work Orders': 'Anzahl der erledigten Arbeitsaufträge',
            'Fuel Indicator': 'Kraftstoffverbrauch',
            'Charge Energy Indicator': 'Ladeenergie',
            'Discharge Energy Indicator': 'Entladeenergie',
            'Charge Cost Indicator': 'Ladekosten',
            'Discharge Revenue Indicator': 'Entladeeinnahmen',
            'HVAC': 'HVAC',
            'Fire Control': 'Brandschutz',

            // Dashboard
            'Welcome to MyEMS': 'Willkommen bei MyEMS',
            'An Industry Leading Open Source Energy Management System': 'Ein branchenführendes Open Source Energie Management System',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Der Verbrauch Dieses Jahr {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Der Kosten Dieses Jahr {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Der Verbrauch Dieses Monat {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Der Kosten Dieses Monat {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Der Verbrauch {{CATEGORY}} {{VALUE}} {{UNIT}} im gleichen Zeitraum im vergangenen Jahr',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Der Kosten {{CATEGORY}} {{VALUE}} {{UNIT}} im gleichen Zeitraum im vergangenen Jahr',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Verbrauch {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Kosten {{UNIT}}',
            // Entities
            Space: 'Platz',
            Equipment: 'Ausrüstung',
            Meter: 'Meter',
            'Offline Meter': 'Offline Meter',
            'Virtual Meter': 'Virtuelles Meter',
            Tenant: 'Mieter',
            Store: 'Geschäft',
            Shopfloor: 'Werkstatt',
            'Combined Equipment': 'Kombinierte Ausrüstung',
            'Cost Center': 'Kostenstelle',
            Name: 'Name',
            DisplayName: 'Anzeigename',
            UserName: 'Nutzername',
            Description: 'Beschreibung',
            'Energy Category': 'Energiekategorie',
            'Child Spaces': 'Teil Platz',
            'Associated Equipment': 'Dazugehörige Geräte',
            //Energy Categories
            Electricity: 'Elektrizität',
            Water: 'Wasser',
            'Natural Gas': 'Erdgas',
            // SidePanelModal
            Settings: 'Einstellungen',
            'Set your own customized style': 'Stellen Sie Ihren eigenen Stil ein',
            'Color Scheme': 'Farbschema',
            'Choose the perfect color mode for your app': 'Wählen Sie den perfekten Farbmodus für Ihre App',
            Light: 'Helle',
            Dark: 'Dunkle',
            'RTL Mode': 'RTL-Modus',
            'Switch your language direction': 'Wechseln Sie Ihre Sprachrichtung',
            'Fluid Layout': 'Flüssigkeitsanordnung',
            'Toggle container layout system': 'Container-Layout-System umschalten',
            'Navigation Position': 'Navigationsposition',
            'Vertical': 'Vertikal',
            'Top': 'oben',
            'Combo': 'Kombination',
            'Transparent': 'Transparent',
            'Inverted': 'Umgekehrt',
            'Card': 'Kartenansicht',
            'Vibrant': 'Lebendig',
            'Select a suitable navigation system for your web application':
                'Wählen Sie ein geeignetes Navigationssystem für Ihre Webanwendung',
            'Vertical Nav': 'Vertikale Navigation',
            'Top Nav': 'Top Nav',
            'Vertical Navbar Style': 'Vertikaler Navbar-Stil',
            'Switch between styles for your vertical navbar':
                'Wechseln Sie zwischen den Stilen für Ihre vertikale Navigationsleiste',
            Language: 'Sprache',
            'Switch between languages': 'Zwischen den Sprachen wechseln',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Wie was du siehst?',
            'Get MyEMS now': 'Holen Sie sich jetzt MyEMS',
            Purchase: 'Enterprise Edition',
            ContactInfo: 'Kontaktinformationen',
            ProductWebsite: 'Produktwebsite',
            CompanyWebsite: 'Firmenwebsite',
            SalesPhone: 'Verkaufstelefon',
            // Query Panels
            'Base Period Begins': 'Basisperiode beginnt',
            'Base Period Ends': 'Basisperiode endet',
            'Comparison Types': 'Vergleichstypen',
            'Year-Over-Year': 'Jahr für Jahr',
            'Month-On-Month': 'Monat für Monat',
            'Free Comparison': 'Freier Vergleich',
            'None Comparison': 'Kein Vergleich',
            'Reporting Period Begins': 'Berichtszeitraum beginnt',
            'Reporting Period Ends': 'Berichtszeitraum endet',
            '(Optional)': '(Optional)',
            'Period Types': 'Periodentypen',
            Yearly: 'Jährlich',
            Monthly: 'Monatlich',
            Weekly: 'Wöchentlich',
            Daily: 'Täglich',
            Hourly: 'Stündlich',
            Submit: 'einreichen',
            'Input Energy Category': 'Eingangsenergiekategorie',
            'Output Energy Category': 'Ausgangsenergiekategorie',
            'Fraction Parameter': 'Fraktion Parameter',
            Search: 'Suche',
            //DateRangePicker
            sunday: 'So',
            monday: 'Mo',
            tuesday: 'Di',
            wednesday: 'Mi',
            thursday: 'Do',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'OKAY',
            today: 'Heute',
            yesterday: 'Gestern',
            hours: 'Stunden',
            minutes: 'Protokoll',
            seconds: 'Nachschlag',
            last7Days: 'Letzte 7 Tage',
            'Select Date Range': 'Datumsbereich auswählen',
            //Card Summaries and Line Charts
            'Base Period': 'Basiszeitraum',
            'Reporting Period': 'Berichtszeitraum',
            'Per Unit Area': 'Pro Flächeneinheit',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Produktion pro Einheit',
            Baseline: 'Basiswert',
            Actual: 'Istwert',
            'Baseline Value - Actual Value': 'Basiswert - Istwert',
            'Average Load': 'Durchschnittliche Belastung',
            'Maximum Load': 'Maximale Last',
            'Load Factor': 'Ladefaktor',
            'Ratio of Average Load to Maximum Load': 'Verhältnis von durchschnittlicher Last zu maximaler Last',
            'Carbon Dioxide Emissions by Energy Category': 'Kohlendioxidemissionen nach Energiekategorien',
            'Costs by Energy Category': 'Kosten nach Energiekategorie',
            'Incomes by Energy Category': 'Einkommen nach Energiekategorie',
            'Electricity Consumption by Time-Of-Use': 'Stromverbrauch nach Nutzungsdauer',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Emission von Kohlendioxid bei Zeitaufteilung',
            'Electricity Cost by Time-Of-Use': 'Kosten des Stromverbrauchs nach Zeiteinteilung',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} nach Unterpunkt Energieverbrauch',
            'Ton of Standard Coal by Energy Category': 'Tonne Standardkohle(TCE) nach Energiekategorie',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Tonne Kohlendioxidemissionen(TCO2E) nach Energiekategorie',
            'Reporting Period Consumption CATEGORY UNIT': 'Verbrauch des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Verbrauch des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Verbrauch des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Verbrauch des Berichtszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Verbrauch des Basiszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT':
                'Verbrauch des Berichtszeitraums {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Verbrauch des Berichtszeitraums {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Verbrauch des Basiszeitraums {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Anteil des Teil Platz nach Energiekategorie {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Anteil des Teil Platz Gesamtanteil',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Berichtszeitraum Kohlendioxidemissionen {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Berichtszeitraum Kohlendioxidemissionen {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Basiszeitraum Kohlendioxidemissionen {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Berichtszeitraumkosten {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Berichtszeitraumkosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Kosten des Basiszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Ausgabe des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{EQUIPMENT}} Ausgabe des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Ausgabe des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Ausgabe des Berichtszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Basisperiodenausgabe {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Berichtsperiodeneinkommen {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Berichtsperiodeneinkommen {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Basisperiodeneinkommen {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Berichtszeitraum Gesamteinkommen {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Berichtszeitraum Kumulative Effizienz {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Berichtszeitraum Kumulative Effizienz {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Berichtszeitraum Kumulative Gesamteffizienz {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Berichtszeitraum Kumulative Gesamteffizienz {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Basisperiode Kumulative Gesamteffizienz {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Sofortige Effizienz {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Sofortige Effizienz {{UNIT}}',
            'Equipment Efficiency Indicator': 'Geräteenergieeffizienzindikator',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Sofortige umfassende Effizienz {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Berichtszeitraum Kumulative Effizienz {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Berichtszeitraum Kumulative Effizienz {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Kumulative Effizienz der Basisperiode {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Kumulative Effizienz der Basisperiode {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Basiszeitraum {{CATEGORY}} Maximale Last {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Berichtszeitraum {{CATEGORY}} Maximale Last {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT':
                'Berichtszeitraum {{CATEGORY}} Durchschnittliche Belastung {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Berichtszeitraum {{CATEGORY}} Ladefaktor',
            'Base Period CATEGORY Average Load VALUE UNIT':
                'Basiszeitraum {{CATEGORY}} Durchschnittliche Belastung {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Berichtszeitraum {{CATEGORY}} Durchschnittswert {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Berichtszeitraum {{CATEGORY}} Höchster Wert {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Berichtszeitraum {{CATEGORY}} Mindestwert {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Berichtszeitraum {{CATEGORY}} Arithmetisches Mittel {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Berichtszeitraum {{CATEGORY}} Median (Mittlerer Wert) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Berichtszeitraum {{CATEGORY}} Standardabweichung der Probe {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Berichtszeitraum {{CATEGORY}} Stichprobenvarianz {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Einsparungen im Berichtszeitraum {{CATEGORY}} (Grundlinie - Ist) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Berichtszeitraum verkürzt {{CATEGORY}} (Grundlinie - Ist) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Einsparungen im Berichtszeitraum {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Einsparungen in der Basisperiode {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Berichtszeitraum Master Meter Verbrauch {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Berichtszeitraum Master Meter Verbrauch {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Berichtszeitraum Submeters Verbrauch {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Berichtszeitraum Submeters Verbrauch {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Unterschied im Berichtszeitraum {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Unterschied im Prozentsatz Berichtszeitraum',
            'Reporting Period Difference CATEGORY VALUE UNIT':
                'Unterschied im Berichtszeitraum {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Fehlerliste',
            'Reporting Period Number of Fault VALUE': 'Berichtszeitraum Anzahl der Fehler: {{VALUE}}',
            'All Faults': 'Alle Fehler',
            'Space Faults': 'Platz Fehler',
            'Number of All Faults': 'Anzahl aller Fehler',
            'Number of Space Faults': 'Anzahl der Platz Fehler',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Tonne Standardkohle',
            'Ton of Carbon Dioxide Emissions': 'Tonne Kohlendioxidemissionen',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Kohlenstoffemissionen pro Einheit Energieverbrauch',
            'Operating Characteristic Curve': 'Betriebscharakteristikkurve',
            Tariff: 'Tarif',
            'Detailed Data': 'Detaillierte Daten',
            'Child Spaces Data': 'Teil Platz Daten',
            'Associated Equipment Data': 'Dazugehörige Geräte Daten',
            'This Year': 'Dieses Jahr',
            'The Same Period Last Year': 'gleichen Zeitraum im vergangenen Jahr',
            'This Month': 'Diesen Monat',
            'This Day': 'Dieser Tag',
            Total: 'Gesamt',
            'No data found': 'Keine Daten gefunden',
            Export: 'Export',
            Datetime: 'Terminzeit',
            'Time-Of-Use Type': 'Art der Zeitteilung',
            'Top-Peak': 'Top-Peak',
            'On-Peak': 'On-Peak',
            'Mid-Peak': 'Mid-Peak',
            'Off-Peak': 'Off-Peak',
            'Deep': 'Deep-Valley',
            Percentage: 'Prozentsatz',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Trend in der letzten Stunde des Energiewertpunkts',
            Circuit: 'Schaltkreis',
            Point: 'Punkt',
            'Realtime Value': 'Echtzeitwert',
            //Meter Tracking
            'Meter List': 'Zählerliste',
            'Edit Meter': 'bearbeiten',
            'Start Value': 'Wert des Starts',
            'End Value': 'Wert des Ends',
            'Difference Value': 'Differenzwert',
            'Start Integrity Rate': 'Start Integritätsrate(%)',
            'End Integrity Rate': 'End Integritätsrate(%)',
            'Full Integrity Rate': 'Vollständige Integritätsrate(%)',
            //Equipment Tracking
            'Equipment List': 'Ausrüstungsliste',
            'Edit Equipment': 'bearbeiten',
            //Profile Dropdown
            Feedback: 'Feedback',
            'Account Settings': 'Kontoeinstellungen',
            Logout: 'Ausloggen',
            //Authentication
            'Log in': 'Anmeldung',
            'Email address': 'E-Mail-Addresse',
            'Phone Number': 'Telefonnummer',
            Password: 'Passwort',
            CaptchaCode: 'Captcha',
            Refresh: 'Auffrischen',
            'Remember me': 'Behalte mich in Erinnerung',
            'Logged in as ': 'Angemeldet als ',
            'Forgot Password?': 'Passwort vergessen?',
            'Forgot your password?': 'Passwort vergessen?',
            "Enter your email and we'll send you a reset link":
                'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen',
            "Enter your email and we'll send you a registration link":
                'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen den Registrierungslink zu',
            'Reset Password': 'Passwort zurücksetzen',
            'Thanks for using MyEMS!': 'Vielen Dank, dass Sie MyEMS verwenden!',
            'You are now successfully signed out': 'Sie sind jetzt erfolgreich abgemeldet',
            'Return to Login': 'Zurück zum Login',
            'Please check your email!': 'Bitte überprüfen Sie Ihre E-Mails!',
            'An email has been sent to ': 'Eine email wurde gesendet an ',
            'Please click on the included link to reset your password':
                'Bitte klicken Sie auf den enthaltenen Link, um Ihr Passwort zurückzusetzen',
            'Please click on the included link to register your account':
                'Bitte klicken Sie auf den beigefügten Link, um Ihr Konto zu registrieren.',
            'An email with password reset link is sent to ':
                'Eine E-Mail mit einem Link zum Zurücksetzen des Passworts wird an gesendet ',
            'Change Password': 'Ändere das Passwort',
            'Old Password': 'Altes Passwort',
            'New Password': 'Neues Kennwort',
            'Confirm Password': 'Bestätige das Passwort',
            'Update Password': 'Kennwort aktualisieren',
            'Password has been changed!': 'Das Passwort wurde geändert!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below.':
                'Der Bestätigungscode wurde an Ihr Postfach gesendet. \
      Bitte kopieren Sie ihn in das Eingabefeld unten.',
            'New to MyEMS': 'Neu bei MyEMS',
            'Create an account': 'Ein Konto erstellen',
            'EMAIL Account registration successful': '{{EMAIL}} Konto erfolgreich registriert',
            'Thanks for verifying your account!': 'Vielen Dank, dass Sie Ihr Konto verifiziert haben!',
            'Your code is': 'Ihr Code lautet',
            'Send verification code': 'Verifizierungscode gesendet',
            'Please wait for NUMBER seconds': 'Bitte warten Sie {{NUMBER}} Sekunden',
            'Password reset': 'Passwort zurücksetzen',
            'Please wait for approval': 'Bitte warten Sie auf Genehmigung',
            //notification
            Notifications: 'Benachrichtigungen',
            'Mark all as read': 'Markiere alle als gelesen',
            'View all': 'Alle',
            'Notification New': 'Neu',
            'Notification Earlier': 'Vorhin',
            'Notification List': 'Benachrichtigungsliste',
            'Bulk actions': 'Massenaktionen',
            'Notification Subject': 'Betreff',
            'Notification Created Datetime': 'Datetime erstellt',
            'Notification Priority': 'Priorität',
            'Notification Message': 'Nachricht',
            'Notification Status': 'Status',
            'Notification Mark As Read': 'Mark as read',
            'Notification Mark As Acknowledged': 'Bestätigen',
            'Notification Low': 'Niedrig',
            'Notification Medium': 'Mittelmaß',
            'Notification High': 'Hoch',
            'Notification Critical': 'Kritisch',
            'Notification Unread': 'Ungelesene',
            'Notification Read': 'Lesen',
            'Notification Acknowledged': 'Anerkannt',
            'Notification Archive': 'Archiv',
            'Notification Delete': 'Löschen',
            'Notification Apply': 'Anwenden',
            'Notification Start Datetime': 'Starten Sie Datetime',
            'Notification End Datetime': 'Datum/Uhrzeit beenden',
            'Notification Update Datetime': 'Datum/Uhrzeit aktualisieren',
            //Monitoring
            'Run Commands': 'Befehle ausführen',
            'Pin Code': 'PIN-Code',
            'Unlock': 'Freischalten',
            'Set Value': 'Wert festlegen',
            'Fault Alarms': 'Fehleralarme',
            'Instantaneous Efficiency VALUE UNIT': 'Sofortige Effizienz {{VALUE}} {{UNIT}}',
            'Communication Status': 'Kommunikationsstatus',
            'Communication Online': 'Online',
            'Communication Offline': 'Offline',
            'Equipment Status': 'Ausrüstung Status',
            'Equipment Running': 'Läuft',
            'Equipment Stopped': 'Gestoppt',
            'Show Up to': 'Zeigen Sie bis zu',
            All: 'Alles',
            'FROM - TO of TOTAL': 'Die aktuelle Anzeige von {{FROM}} und {{TO}} total {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Mikronetz-Energie',
            'Microgrid Revenue': 'Mikronetz-Umsatz',
            'Microgrid Carbon': 'Mikronetz-Kohlenstoff',
            'Photovoltaic Generation': 'Photovoltaik-Erzeugung',
            'EV Charger Consumption': 'EV-Ladegerät-Verbrauch',
            'Load Consumption': 'Lastverbrauch',
            'Grid Buy': 'Netzbezug',
            'Grid Sell': 'Netzeinspeisung',
            'EV Charger': 'EV-Ladegerät',
            'Heat Pump': 'Wärmepumpe',
            'Photovoltaic': 'Photovoltaik',
            'PCS Run State': 'PCS-Ausführungsstatus',
            'PCS Unknown': 'Unbekannt',
            'PCS Initializing': 'Initialisieren',
            'PCS Standby': 'Standby',
            'PCS Shutdown': 'Herunterfahren',
            'PCS Fault': 'Fehler',
            'PCS Running': 'Laufend',
            'Battery Power': 'Batterieleistung',
            'Photovoltaic Power': 'Photovoltaik',
            'Grid Power': 'Netzleistung',
            'Load Power': 'Lastleistung',
            Reporting: 'Berichterstattung',
            Maintenance: 'Wartung',
            'Serial Number': 'Seriennummer',
            Address: 'Adresse',
            'Postal Code': 'Postleitzahl',
            'Rated Capacity': 'Nennleistung',
            'Rated Power': 'Nennleistung',
            Latitude: 'Breitengrad',
            Longitude: 'Längengrad',
            'Strategy Management': 'Strategiemanagement',
            'Charging Schedule': 'Ladeplan',
            'Charge Start Time': 'Ladestartzeit',
            'Charge End Time': 'Endzeit der Ladung',
            'Discharge Start Time': 'Startzeit der Entladung',
            'Discharge End Time': 'Endzeit der Entladung',
            'Total Rated Power': 'Nennleistung insgesamt',
            'Total Rated Capacity': 'Gesamtnennkapazität',
            // Energy Indicator
            "Today's Charge": "Das heutige Ladevolumen",
            "Today's Discharge": "Die heutige Entladungskapazität",
            "Today's Generation": "Die heutige Stromerzeugung",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Gesamtbetrag',
            'Total Discharge': 'totale Entladung',
            'Total Generation': 'Gesamtgeneration',
            'Total Revenue': 'Gesamtumsatz',
            'Total Photovoltaic Generation': 'Gesamte Photovoltaik-Erzeugung',
            'Total EV Charger Consumption': 'Gesamter EV-Ladegerät-Verbrauch',
            'Total Load Consumption': 'Gesamter Lastverbrauch',
            'Total Grid Buy': 'Gesamter Netzbezug',
            'Total Grid Sell': 'Gesamter Netzeinspeisung',
            'Total Efficiency': 'Gesamtwirkungsgrad',
            'Discharge Achievement Rate': 'Entladungsleistungsrate',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Umsatzranking',
            'Efficiency Ranking': 'Effizienzranking',
            'Charge Ranking': 'Rangliste der Ladekapazitäten',
            'Discharge Ranking': 'Entlassungsrangliste',
            'Number of Microgrids': 'Anzahl der Mikronetze',
            'Number of Power Stations': 'Anzahl der Kraftwerke',
            'Microgrid List': 'Microgrid-Liste',
            'Select Microgrid': 'Mikronetz auswählen',
            'Previous Page': 'Vorherige Seite',
            'Next Page': 'Nächste Seite',
            '7 Days': '7 Tage',
            'Charge UNIT': 'Aufladung {{UNIT}}',
            'Discharge UNIT': 'Entladung {{UNIT}}',
            'Generation UNIT': 'Strom erzeugen {{UNIT}}',
            'Energy Indicator': 'Energieanzeige',
            'Revenue Indicator': 'Umsatzindikator',
            'Carbon Indicator': 'Kohlenstoffindikator',

            // Energy Storage Power Station
            'Battery Operating State': 'Batteriebetriebszustand',
            'Battery State': 'Batteriestatus',
            'Battery Unknown': 'Unbekannt',
            'Battery Stopped': 'Angehalten',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Fehler', // 1
            'Battery Warning': 'Warnung', // 2
            'Battery Standby': 'Standby', // 3
            'Battery Prohibit DisCharging': 'Deaktivieren verbieten', // 4
            'Battery Prohibit Charging': 'Gebühren verbieten', // 5
            'Battery Normal': 'Normal', // 6
            'Battery Charging': 'Aufladung', // 7
            'Battery Discharging': 'Selama pembebasan', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Phase des Lebenszyklus',
            'Use Phase': 'Anwendungsphase',
            'Commissioning Phase': 'Phase der Inbetriebnahme',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Installationsphase',
            'Device Status': 'Gerätestatus',
            'Basic Information': 'Grundlegende Informationen',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'Wechselrichter',
            'Invertor Run State': 'Ausführungsstatus',
            'Invertor Unknown': 'Unbekannt',
            'Invertor Initializing': 'Initialisieren',
            'Invertor Standby': 'Standby',
            'Invertor Shutdown': 'Herunterfahren',
            'Invertor Fault': 'Fehler',
            'Invertor Running': 'Laufend',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': 'Datetime erstellt',
            'File Format': 'Datei Format',
            'File Size': 'Dateigröße',
            Uploader: 'Uploader',
            'Upload Datetime': 'Datetime hochladen',
            //Error
            "The page you're looking for is not found": 'Die gesuchte Seite wurde nicht gefunden',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Stellen Sie sicher, dass die Adresse korrekt ist und die Seite nicht verschoben wurde',
            'If you think this is a mistake,': 'Wenn Sie denken, dass dies ein Fehler ist,',
            'contact us': 'kontaktiere uns',
            'Take me home': 'Bring mich zurück zur Homepage',
            'Whoops, something went wrong!': 'Oh, etwas ist schief gelaufen!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Versuchen Sie, die Seite zu aktualisieren, oder gehen Sie zurück und versuchen Sie die Aktion erneut. ',
            'If this problem persists,': 'Wenn dieses Problem weiterhin besteht,',
            'Captcha Error': 'Captcha-Fehler',
            'Confirm Password Error': 'Das Bestätigungspasswort stimmt nicht überein',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Es scheint, als hättest \
      du auf einen ungültigen Link zur Passwortrücksetzung geklickt. Bitte versuche es erneut.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Es sieht so aus, als hätten \
      Sie auf einen ungültigen Registrierungslink geklickt. Bitte versuchen Sie es erneut.',
            //Tenant Bill
            'Lease Contract Number': 'Mietvertragsnummer',
            Download: 'Herunterladen',
            Print: 'Drucken',
            'Payment Notice': 'Zahlungshinweis',
            'Bill To': 'Zu',
            'Bill Number': 'Rechnungsnummer',
            'Bill Date': 'Rechnungsdatum',
            'Payment Due Date': 'Fälligkeitsdatum',
            'Amount Payable': 'Bezahlbarer Betrag',
            'Billing Period Start': 'Beginn des Abrechnungszeitraums',
            'Billing Period End': 'Ende des Abrechnungszeitraums',
            Quantity: 'Menge',
            Price: 'Preis',
            Unit: 'Maßeinheit',
            Amount: 'Geldbetrag',
            Subtotal: 'Zwischensumme',
            'VAT Output Tax': 'Mehrwertsteuer Ausgangssteuer',
            'Total Amount Payable': 'Gesamtbetrag zahlbar',
            'Please make sure to pay on or before the payment due date above':
                'Bitte stellen Sie sicher, dass Sie am oder vor dem oben genannten Fälligkeitsdatum bezahlen',
            'Send money to the following account': 'Senden Sie Geld auf das folgende Konto',
            'Account Name': 'Kontobezeichnung',
            'Bank Name': 'Bank Name',
            'Bank Address': 'Bankadresse',
            'RMB Account': 'RMB-Konto',
            // button
            'Toggle Navigation': 'Navigation umschalten',
            // working calendar
            'Working Days': 'Arbeitstage',
            'Non Working Days': 'Arbeitsfreie Tage',
            'Select Row': 'Bitte wählen Sie die zu bearbeitende Zeile aus',
            // Offline Meter Input
            'Daily Value': 'Tageswert',
            Date: 'Datum',
            'Successfully Saved': 'Betrieb erfolgreich',
            'Previous Data Is Empty': 'Vorherige Daten sind leer',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administratorsitzung nicht gefunden',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Zeitüberschreitung für Administratorsitzungen',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Erweiterter Bericht nicht gefunden',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Ungültige Anfrage',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER':
                'Vorhandenes Submeter kann nicht als Mastermeter festgelegt werden',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Kombinierte Ausrüstungsausrüstung besteht',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Kombinierte Ausrüstungsausrüstung nicht gefunden',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Kombinierte Gerätezählerbeziehung besteht',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Kombinierte Gerätezählerbeziehung nicht gefunden',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Kombinierter Gerätename wird bereits verwendet',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Kombinierte Ausrüstung nicht gefunden',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Kombinierte Geräte-Offline-Zählerbeziehung besteht',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND':
                'Kombinierte Geräte-Offline-Zählerbeziehung nicht gefunden',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE':
                'Der Name des kombinierten Geräteparameters wird bereits verwendet',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH':
                'Parameter für kombinierte Ausrüstung nicht gefunden oder stimmt nicht überein',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS':
                'Kombinierte Ausrüstung virtuelle Zählerbeziehung existiert',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND':
                'Kombinierte Ausrüstung virtuelle Zählerbeziehung nicht gefunden',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Der Kontaktname wird bereits verwendet',
            'API.CONTACT_NOT_FOUND': 'Kontakt nicht gefunden',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Externe Kostenstellen-ID vorhanden',
            'API.COST_CENTER_NAME_EXISTS': 'Der Name der Kostenstelle ist vorhanden',
            'API.COST_CENTER_NOT_FOUND': 'Kostenstelle nicht gefunden',
            'API.COST_FILE_NOT_FOUND': 'Kostendatei nicht gefunden',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Der Name der Datenquelle wird bereits verwendet',
            'API.DATA_SOURCE_NOT_FOUND': 'Datenquelle nicht gefunden',
            'API.DATABASE_ERROR': 'Datenbankfehler',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Datum ist bereits im Arbeitskalender',
            'API.DATE_LOCAL_NOT_FOUND': 'Datum lokal nicht gefunden',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Der Name der Verteilungsschaltung wird bereits verwendet',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Verteilungskreis nicht gefunden',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Verteilungskreispunktbeziehung existiert',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Verteilungskreispunktbeziehung nicht gefunden',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Der Name des Verteilungssystems wird bereits verwendet',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Verteilungssystem nicht gefunden',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'E-Mail wird bereits verwendet',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'E-Mail-Nachricht nicht gefunden',
            'API.EMAIL_NOT_FOUND': 'Die E-Mail-Adresse existiert nicht',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'E-Mail-Server-Host wird bereits verwendet',
            'API.EMAIL_SERVER_NOT_FOUND': 'E-Mail-Server nicht gefunden',
            'API.EMPTY_VARIABLES_ARRAY': 'Leeres Variablen-Array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Name der Energiekategorie wird bereits verwendet',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energiekategorie nicht gefunden',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energiekategorie, die in Energieerzeugnissen verwendet wird',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energiekategorie im Zähler',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energiekategorie, die in Offline-Zählern verwendet wird',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'In Tarifen verwendete Energiekategorie',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energiekategorie, die im virtuellen Zähler verwendet wird',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energieflussdiagramm-Link wird bereits verwendet',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH':
                'Energieflussdiagramm-Link nicht gefunden oder stimmt nicht überein',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Der Name des Energieflussdiagramms wird bereits verwendet',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE':
                'Der Name des Energieflussdiagramm-Knotens wird bereits verwendet',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH':
                'Energieflussdiagrammknoten nicht gefunden oder nicht übereinstimmend',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energieflussdiagramm nicht gefunden',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieartikel gehört nicht zur Energiekategorie',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieartikel gehört nicht zur Energiekategorie',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Name des Energieelements wird bereits verwendet',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energieartikel nicht gefunden',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energieelement, das im Zähler verwendet wird',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energieelement, das im Offline-Zähler verwendet wird',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energieelement, das im virtuellen Zähler verwendet wird',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Gerätezählerbeziehung besteht',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Gerätezählerbeziehung nicht gefunden',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Gerätename wird bereits verwendet',
            'API.EQUIPMENT_NOT_FOUND': 'Ausrüstung nicht gefunden',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Geräte-Offline-Zählerbeziehung existiert',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Geräte-Offline-Zählerbeziehung nicht gefunden',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Der Name des Geräteparameters wird bereits verwendet',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment-Parameter nicht gefunden oder stimmt nicht überein',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Virtuelle Zählerbeziehung der Ausrüstung existiert',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Gerätezählerbeziehung nicht gefunden',
            'API.ERROR': 'Fehler',
            'API.EXCEPTION': 'Ausnahme',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Kostendatei konnte nicht wiederhergestellt werden',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Fehler beim Wiederherstellen der Wissensdatei',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Offline-Zählerdatei konnte nicht wiederhergestellt werden',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Offline-Zählerdatei konnte nicht gespeichert werden',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Kostendatei konnte nicht hochgeladen werden',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Wissensdatei konnte nicht hochgeladen werden',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Offline-Zählerdatei konnte nicht hochgeladen werden',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway-Name wird bereits verwendet',
            'API.GATEWAY_NOT_FOUND': 'Gateway nicht gefunden',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Ungültig ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Ungültige Adresse',
            'API.INVALID_ADDRESS_VALUE': 'Ungültiger Adresswert',
            'API.INVALID_ADVANCED_REPORT_ID': 'Ungültige erweiterte Berichts-ID',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Ungültiger Flächenwert',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Ungültige Basisperiode EnddatumUhrzeit',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Startdatum ungültiger BasiszeitraumUhrzeit',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Ungültige Baudrate',
            'API.INVALID_BUILDINGS_VALUE': 'Ungültiger Gebäudewert',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Ungültige Kategorie',
            'API.INVALID_CHANNEL': 'Ungültiger Kanal',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Ungültige kombinierte Geräte-ID',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Ungültiger kombinierter Gerätename',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Ungültige kombinierte Geräteparameter-ID',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Ungültiger kombinierter Geräteparametername',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Ungültiger kombinierter Geräteparametertyp',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Ungültige kombinierte Geräte-uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Ungültige Verbindung',
            'API.INVALID_CONSTANT_VALUE': 'Ungültiger konstanter Wert',
            'API.INVALID_CONTACT_ID': 'Ungültige Kontakt-ID',
            'API.INVALID_CONTACT_NAME': 'Ungültiger Kontaktname',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Ungültige Kostenstellen-ID',
            'API.INVALID_COST_FILE_ID': 'Ungültige Kostendatei-ID',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Ungültige Datenquellen-ID',
            'API.INVALID_DATA_SOURCE_NAME': 'Ungültiger Datenquellenname',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Ungültiges Datenquellenprotokoll',
            'API.INVALID_DATE_LOCAL': 'Ungültiges lokales Datum',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Ungültiger Nenner Meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Ungültiger Anzeigename',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Ungültige Verteilungskreis-ID',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Ungültiger Verteilungskreisname',
            'API.INVALID_DISTRIBUTION_ROOM': 'Ungültiger Verteilungsraum',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Ungültige Verteilungssystem-ID',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Ungültiger Verteilungssystemname',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Ungültige E-Mail-Adresse',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Ungültige E-Mail-Nachrichten-ID',
            'API.INVALID_EMAIL_SERVER_HOST': 'Ungültiger E-Mail-Server-Host',
            'API.INVALID_EMAIL_SERVER_ID': 'Ungültige E-Mail-Server-ID',
            'API.INVALID_END_DATE_FORMAT': 'Ungültiges Enddatumsformat',
            'API.INVALID_END_DATETIME': 'Ungültige Enddatumszeit',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Ungültige Energiekategorie-ID',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Ungültiger Energiekategoriename',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Ungültige Energieflussdiagramm-ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Ungültige Energieflussdiagramm-Link-ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Ungültiger Name des Energieflussdiagramms',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Ungültige Energieflussdiagramm-Knoten-ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Ungültiger Energieflussdiagramm-Knotenname',
            'API.INVALID_ENERGY_ITEM_ID': 'Ungültige Energieelement-ID',
            'API.INVALID_ENERGY_ITEM_NAME': 'Ungültiger Energieelementname',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Ungültige Gleichung im Ausdruck',
            'API.INVALID_EQUIPMENT_ID': 'Ungültige Geräte-ID',
            'API.INVALID_EQUIPMENT_NAME': 'Ungültiger Gerätename',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Ungültige Geräteparameter-ID',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Ungültiger Geräteparametername',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Ungültiger Geräteparametertyp',
            'API.INVALID_EQUIPMENT_UUID': 'Ungültige Geräteuuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Ungültiger Ausdruck',
            'API.INVALID_EXPRESSION_OBJECT': 'Ungültiges Ausdrucksobjekt',
            'API.INVALID_FDD_CODE': 'Ungültiger FDD-Code',
            'API.INVALID_FLOORS_VALUE': 'Ungültiger Wert für Böden',
            'API.INVALID_FROM_ADDR': 'Ungültig von addr',
            'API.INVALID_GATEWAY_ID': 'Ungültige Gateway-ID',
            'API.INVALID_GATEWAY_NAME': 'Ungültiger Gatewayname',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Ungültiger stündlich hoher Grenzwert',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Ungültiger stündlicher niedriger Grenzwert',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Ungültig ist admin-Wert',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Ungültiger Wert wird gezählt',
            'API.INVALID_IS_ENABLED': 'Ungültig ist aktiviert',
            'API.INVALID_IS_HIDDEN': 'Ungültig ist ausgeblendet',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Ungültig ist im Leasingwert',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Ungültig ist der gezählte Eingabewert',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Ungültig ist Schlüsselmandantenwert',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Ungültig ist der gezählte Ausgabewert',
            'API.INVALID_IS_OUTPUT_VALUE': 'Ungültig ist Ausgabewert',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Ungültig ist Trendwert',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Ungültig ist virtueller Wert',
            'API.INVALID_KGCE': 'Ungültige kgce',
            'API.INVALID_KGCO2E': 'Ungültiges kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Ungültige Wissensdatei-ID',
            'API.INVALID_LATITUDE_VALUE': 'Ungültiger Breitengradwert',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Ungültiger Wert der Leasenummer',
            'API.INVALID_LONGITUDE_VALUE': 'Ungültiger Längengrad',
            'API.INVALID_LOW_LIMIT_VALUE': 'Ungültiger niedriger Grenzwert',
            'API.INVALID_MASTER_METER_ID': 'Ungültige Masterzähler-ID',
            'API.INVALID_MENU_ID': 'Ungültige Menü-ID',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Ungültige Nachrichtenvorlage',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Ungültige Zähler-ID',
            'API.INVALID_METER_NAME': 'Ungültiger Zählername',
            'API.INVALID_METER_UUID': 'ungültiger Meter UUID',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Ungültiger Namenswert',
            'API.INVALID_NEW_PASSWORD': 'Ungültiges neues Kennwort',
            'API.INVALID_NON_WORKING_DAY_ID': 'Ungültige arbeitsfreie ID',
            'API.INVALID_NOTIFICATION_ID': 'Ungültige Benachrichtigungs-ID',
            'API.INVALID_NUMERATOR_METER_UUID': 'Ungültige Zählerzählerzähler-UUID',
            'API.INVALID_OBJECT_TYPE': 'Ungültiger Objekttyp',
            'API.INVALID_OFFLINE_METER_DATA': 'Ungültige Offline-Zählerdaten',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Ungültige Offline-Zählerdatei-ID',
            'API.INVALID_OFFLINE_METER_ID': 'Ungültige Offline-Zähler-ID',
            'API.INVALID_OFFLINE_METER_NAME': 'Ungültiger Offline-Zählername',
            'API.INVALID_OFFLINE_METER_UUID': 'Ungültige Offline-Zähler-uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Ungültiger Wert der Offset-Konstante',
            'API.INVALID_OLD_PASSWORD': 'Ungültiges altes Passwort',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Ungültige ID des übergeordneten Bereichs',
            'API.INVALID_PASSWORD': 'Ungültiges Kennwort',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Ungültiger Spitzenstrom',
            'API.INVALID_PEAK_LOAD': 'Ungültige Spitzenlast',
            'API.INVALID_PERIOD_TYPE': 'Ungültiger Periodentyp',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Ungültige Punkt-ID',
            'API.INVALID_POINT_NAME': 'Ungültiger Punktname',
            'API.INVALID_PORT': 'Ungültiger Port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Ungültige Priorität',
            'API.INVALID_PRIVILEGE': 'Ungültige Berechtigung',
            'API.INVALID_PRIVILEGE_DATA': 'Ungültige Berechtigungsdaten',
            'API.INVALID_PRIVILEGE_ID': 'Ungültige Berechtigungs-ID',
            'API.INVALID_PRIVILEGE_NAME': 'Ungültiger Berechtigungsname',
            'API.INVALID_RATIO_VALUE': 'Ungültiger Verhältniswert',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Ungültige Antwort',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Ungültige Berichtsperiode EnddatumUhrzeit',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Startdatum des ungültigen Berichtszeitraums',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Ungültig erfordert Authentifizierung',
            'API.INVALID_ROOMS_VALUE': 'Ungültiger Zimmerwert',
            'API.INVALID_RULE_ID': 'Ungültige Regel-ID',
            'API.INVALID_RULE_NAME': 'Ungültiger Regelname',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Ungültige Sensor-ID',
            'API.INVALID_SENSOR_NAME': 'Ungültiger Sensorname',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_PORT': 'Ungültiger serieller Port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Ungültige Sitzung, bitte melden Sie sich erneut an',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Ungültige Shopfloor-ID',
            'API.INVALID_SHOPFLOOR_NAME': 'Ungültiger Shopfloor-Name',
            'API.INVALID_SHOPFLOOR_UUID': 'Ungültige Shopfloor-uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Ungültige Quellknoten-ID',
            'API.INVALID_SPACE_ID': 'Ungültige Speicherplatz-ID',
            'API.INVALID_SPACE_NAME': 'Ungültiger Leerzeichenname',
            'API.INVALID_SPACE_UUID': 'Ungültiges Leerzeichen uuid',
            'API.INVALID_START_DATE_FORMAT': 'Ungültiges Startdatumsformat',
            'API.INVALID_START_DATETIME': 'Ungültiges StartdatumUhrzeit',
            'API.INVALID_STATUS': 'Ungültiger Status',
            'API.INVALID_STORE_ID': 'Ungültige Store-ID',
            'API.INVALID_STORE_NAME': 'Ungültiger Store-Name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Beschreibung des ungültigen Shop-Typs',
            'API.INVALID_STORE_TYPE_ID': 'Ungültige Speichertyp-ID',
            'API.INVALID_STORE_TYPE_NAME': 'Ungültiger Name des Speichertyps',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Ungültiger vereinfachter Code für den Shop-Typ',
            'API.INVALID_STORE_UUID': 'Ungültige Speicher-uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Ungültiges SVG',
            'API.INVALID_SWITCHGEAR': 'Ungültige Schaltanlage',
            'API.INVALID_TARGET_NODE_ID': 'Ungültige Zielknoten-ID',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Ungültige Tarifpauschale',
            'API.INVALID_TARIFF_ID': 'Ungültige Tarif-ID',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Ungültiger Tarifpreis für Nutzungszeit',
            'API.INVALID_TARIFF_TYPE': 'Ungültiger Tariftyp',
            'API.INVALID_TENANT_ID': 'Ungültige Mandanten-ID',
            'API.INVALID_TENANT_NAME': 'Ungültiger Mandantenname',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Beschreibung des ungültigen Mandantentyps',
            'API.INVALID_TENANT_TYPE_ID': 'Ungültige Mandantentyp-ID',
            'API.INVALID_TENANT_TYPE_NAME': 'Ungültiger Mandantentypname',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Ungültiger vereinfachter Mandantentyp',
            'API.INVALID_TENANT_UUID': 'Ungültige Mandanten-UUID',
            'API.INVALID_TEXT_MESSAGE_ID': 'Ungültige SMS-ID',
            'API.INVALID_TIMEZONE_ID': 'Ungültige Zeitzonen-ID',
            'API.INVALID_TOKEN': 'Ungültiges Token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Ungültige Mengeneinheit',
            'API.INVALID_UNIT_OF_PRICE': 'Ungültige Preiseinheit',
            'API.INVALID_UNITS': 'Ungültige Einheiten',
            'API.INVALID_USER_ID': 'Ungültige Benutzer-ID',
            'API.INVALID_USER_NAME': 'Ungültiger Benutzername',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Ungültiger Benutzername oder ungültige E-Mail-Adresse',
            'API.INVALID_USER_PHONE': 'Ungültiges Benutzertelefon',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Ungültiger Benutzer, bitte erneut anmelden',
            'API.INVALID_USER_UUID': 'Ungültige Benutzer-UUID',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Ungültige variable Zähler-ID',
            'API.INVALID_VARIABLE_METER_TYPE': 'Ungültiger variabler Zählertyp',
            'API.INVALID_VARIABLE_NAME': 'Ungültiger Variablenname',
            'API.INVALID_VERIFICATION_CODE': 'Ungültiger Bestätigungscode',
            'API.INVALID_VIRTUAL_METER_ID': 'Ungültige ID des virtuellen Zählers',
            'API.INVALID_VIRTUAL_METER_NAME': 'Ungültiger Name des virtuellen Zählers',
            'API.INVALID_VIRTUAL_METER_UUID': 'Ungültige uuid des virtuellen Zählers',
            'API.INVALID_WEB_MESSAGE_ID': 'Ungültige Webnachrichten-ID',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Ungültige wechat-Nachrichten-ID',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Ungültige Arbeitskalender-ID ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Ungültiger Arbeitskalender Name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Wissensdatei kann nicht vom Datenträger entfernt werden',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Wissensdatei nicht gefunden',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Masterzähler gehört nicht zur gleichen Energiekategorie',
            'API.MASTER_METER_NOT_FOUND': 'Mastermeter nicht gefunden',
            'API.MENU_NOT_FOUND': 'Menü nicht gefunden',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Zählername wird bereits verwendet',
            'API.METER_NOT_FOUND': 'Meter nicht gefunden',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter der Variablen nicht gefunden',
            'API.METER_POINT_RELATION_EXISTS': 'Meterpunktbeziehung existiert',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meterpunktbeziehung nicht gefunden',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
                'Die länge des neuen codes darf nicht mehr als 100 zeichen betragen',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'arbeitsfreier Tag nicht gefunden',
            'API.NOT_FOUND': 'Nicht gefunden',
            'API.NOTIFICATION_NOT_FOUND': 'Benachrichtigung nicht gefunden',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline-Zählerdatei nicht gefunden',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Der Name des Offline-Zählers wird bereits verwendet',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline-Messgerät nicht gefunden',
            'API.INVALID_OFFLINE_METER_VALUE': 'Ungültiger Offline-Zählerwert',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline-Zähler der Variablen nicht gefunden',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
                'Die länge des alten codes darf nicht mehr als 100 zeichen betragen',
            'API.PARENT_SPACE_NOT_FOUND': 'Übergeordneter Speicherplatz nicht gefunden',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Die länge des codes darf keine 100 zeichen überschreiten',
            'API.PASSWORDS_MATCH': 'Das neue Passwort ist das gleiche wie das alte Passwort',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Punktname wird bereits verwendet',
            'API.POINT_NOT_FOUND': 'Punkt nicht gefunden',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Berechtigungsname wird bereits verwendet',
            'API.PRIVILEGE_NOT_FOUND': 'Berechtigung nicht gefunden',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Regelname wird bereits verwendet',
            'API.RULE_NOT_FOUND': 'Regel nicht gefunden',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensorname wird bereits verwendet',
            'API.SENSOR_NOT_FOUND': 'Sensor nicht gefunden',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensorpunktbeziehung existiert',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensorpunktbeziehung nicht gefunden',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor Equipment Beziehung besteht',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor Equipment Beziehung nicht gefunden',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor Meter Beziehung besteht',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor Meter Beziehung nicht gefunden',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor-Name wird bereits verwendet',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor nicht gefunden',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor Offline-Zählerbeziehung existiert',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor Offline-Zählerbeziehung nicht gefunden',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor-Punktbeziehung existiert',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor-Punktbeziehung nicht gefunden',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor-Sensorbeziehung besteht',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor-Sensorbeziehung nicht gefunden',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtuelle Zählerbeziehung existiert',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtuelle Zählerbeziehung nicht gefunden',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Es besteht eine Arbeitskalender-Shop-Beziehung',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Shopfloor nicht gefunden',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Quellknoten nicht gefunden',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Raumkombinierte Ausrüstungsbeziehung besteht',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Raumkombinierte Ausrüstungsbeziehung nicht gefunden',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Raumausrüstungsbeziehung besteht',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Beziehung zwischen Weltraumausrüstung nicht gefunden',
            'API.SPACE_METER_RELATION_EXISTS': 'Raummeterbeziehung existiert',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space-Meter-Beziehung nicht gefunden',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space-Name wird bereits verwendet',
            'API.SPACE_NOT_FOUND': 'Speicherplatz nicht gefunden',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Speicherplatz nicht im Privileg gefunden',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline Meter Beziehung existiert',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Speicherplatz-Offline-Zählerbeziehung nicht gefunden',
            'API.SPACE_POINT_RELATION_EXISTS': 'Raumpunktbeziehung existiert',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Raumpunktbeziehung nicht gefunden',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Raumsensorbeziehung besteht',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Raumsensorbeziehung nicht gefunden',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Raum-Shopfloor-Beziehung besteht',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Raum-Shopfloor-Beziehung nicht gefunden',
            'API.SPACE_STORE_RELATION_EXISTS': 'Raumspeicherbeziehung existiert',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Raumspeicherbeziehung nicht gefunden',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space-Mandantenbeziehung ist vorhanden',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Raummieterbeziehung nicht gefunden',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Raumbezogene virtuelle Zählerbeziehung existiert',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Zählerbeziehung für den Weltraum nicht gefunden',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Arbeitskalender-Space-Beziehung vorhanden',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Speicherplatz nicht gefunden',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'StartdatumUhrzeit muss früher als Enddatumszeit sein',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Speicherzählerbeziehung vorhanden',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Speicherzählerbeziehung nicht gefunden',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Der Store-Name wird bereits verwendet',
            'API.STORE_NOT_FOUND': 'Shop nicht gefunden',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Offline-Zählerbeziehung speichern ist vorhanden',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Offline-Zählerbeziehung speichern nicht gefunden',
            'API.STORE_POINT_RELATION_EXISTS': 'Speicherpunktbeziehung vorhanden',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Speicherpunktbeziehung nicht gefunden',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Speichersensorbeziehung ist vorhanden',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Sensorbeziehung nicht gefunden',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Der Name des Geschäftstyps wird bereits verwendet',
            'API.STORE_TYPE_NOT_FOUND': 'Shop-Typ nicht gefunden',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE':
                'Der vereinfachte Code für den Shop-Typ wird bereits verwendet',
            'API.STORE_TYPE_USED_IN_STORE': 'Im Store verwendeter Shop-Typ',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Virtuelle Zählerbeziehung speichern ist vorhanden',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Zählerbeziehung nicht gefunden',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Es besteht eine Beziehung zum Arbeitskalenderspeicher',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Speicher nicht gefunden',
            'API.TARGET_NODE_NOT_FOUND': 'Zielknoten nicht gefunden',
            'API.TARIFF_IN_USE': 'Tarif im Einsatz',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tarif ist bereits mit Kostenstelle verknüpft',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tarif ist nicht mit Kostenstelle verknüpft',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tarifname wird bereits verwendet',
            'API.TARIFF_NOT_FOUND': 'Tarif nicht gefunden',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Mandantenzählerbeziehung vorhanden',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Mieterzählerbeziehung nicht gefunden',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Mandantenname wird bereits verwendet',
            'API.TENANT_NOT_FOUND': 'Mieter nicht gefunden',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Mandanten-Offlinezählerbeziehung ist vorhanden',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Mandanten-Offlinezählerbeziehung nicht gefunden',
            'API.TENANT_POINT_RELATION_EXISTS': 'Mandantenpunktbeziehung ist vorhanden',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Mandantenpunktbeziehung nicht gefunden',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Mandantensensorbeziehung ist vorhanden',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Mandantensensorbeziehung nicht gefunden',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Der Name des Mandantentyps wird bereits verwendet',
            'API.TENANT_TYPE_NOT_FOUND': 'Mandantentyp nicht gefunden',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Vereinfachter Mandantentyp wird bereits verwendet',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Im Mandanten verwendeter Mandantentyp',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Virtuelle Mandantenzählerbeziehung ist vorhanden',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Mandantenzählerbeziehung nicht gefunden',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Es besteht eine funktionierende Kalendermandantenbeziehung',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Mandant nicht gefunden',
            'API.TEXT_MESSAGE_NOT_FOUND': 'SMS nicht gefunden',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Der Berichtszeitraum muss länger als 15 Minuten sein',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Es besteht ein Zusammenhang mit Kinderzählern',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Es gibt eine Beziehung zu Kinderräumen',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'Es besteht ein Zusammenhang mit kombinierten Ausrüstungsparametern',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Es besteht ein Zusammenhang mit kombinierten Ausrüstungen',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Es besteht ein Zusammenhang mit Datenquellen',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS':
                'Es besteht ein Zusammenhang mit Energieflussdiagramm-Links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Es gibt einen Zusammenhang mit Energiespeicherbehältern Batterien',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Es besteht ein Zusammenhang mit Energiespeichercontainern, Netzen',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Es besteht ein Zusammenhang mit den Lasten von Energiespeichercontainern',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Es besteht ein Zusammenhang mit Energiespeichercontainern Energieumwandlungssystemen',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Es besteht ein Zusammenhang mit Geräteparametern',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Es besteht ein Zusammenhang mit Ausrüstungen',
            'API.THERE_IS_RELATION_WITH_METER': 'Es besteht ein Zusammenhang mit dem Zähler',
            'API.THERE_IS_RELATION_WITH_METERS': 'Es besteht ein Zusammenhang mit Zählern',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Es besteht ein Zusammenhang mit dem Offline-Zähler',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Es besteht ein Zusammenhang mit Offline-Zählern',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Es besteht ein Bezug zu anderen virtuellen Zählern',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'Es besteht ein Zusammenhang mit Sensoren',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Es besteht ein Zusammenhang mit Shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'Es gibt einen Bezug zu Räumen',
            'API.THERE_IS_RELATION_WITH_STORES': 'Es besteht eine Beziehung zu Geschäften',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'Es besteht eine Beziehung zu den Mietern',
            'API.THERE_IS_RELATION_WITH_USERS': 'Es besteht eine Beziehung zu den Benutzern',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Es besteht ein Zusammenhang mit dem virtuellen Zähler',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Es gibt Beziehungen zu virtuellen Kraftwerken',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Diese Datenquelle wird von einem Messgerät verwendet',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Dieser Zähler wird von einem virtuellen Zähler verwendet',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER':
                'Dieser Offline-Zähler wird von einem virtuellen Zähler verwendet',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'Dieser Speicherplatz kann nicht gelöscht werden',
            'API.TIMEZONE_NOT_FOUND': 'Zeitzone nicht gefunden',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token nicht in Headern gefunden, bitte melden Sie sich an',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Benutzerkonto wurde gesperrt',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'Benutzerkonto ist abgelaufen',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'Der Benutzername wird bereits verwendet',
            'API.USER_NOT_FOUND': 'Benutzer nicht gefunden',
            'API.USER_PASSWORD_HAS_EXPIRED': 'Benutzerkennwort ist abgelaufen',
            'API.USER_PRIVILEGE_NOT_FOUND': 'Benutzerberechtigung nicht gefunden',
            'API.USER_SESSION_NOT_FOUND': 'Benutzersitzung nicht gefunden',
            'API.USER_SESSION_TIMEOUT': 'Zeitüberschreitung der Benutzersitzung',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN':
                'Benutzer uuid nicht in Headern gefunden Bitte melden Sie sich an',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Der Name des virtuellen Zählers wird bereits verwendet',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtueller Zähler nicht gefunden',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtueller Zähler der Variablen nicht gefunden',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtueller Punkt sollte analoger Wert sein',
            'API.WEB_MESSAGE_NOT_FOUND': 'Webnachricht nicht gefunden',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat-Nachricht nicht gefunden',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Der Name des Arbeitskalenders wird bereits verwendet',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Arbeitskalender nicht gefunden',

            MasterMeter: 'Übersichtstabelle',
            SubMeter: 'Subtable',
            'Power Quality': "Qualité de l’énergie",
            'About Power Quality': "À propos de la qualité de l’énergie",
            'Trend Values': 'Valeurs de tendance',
            Category: 'Catégorie',
            Type: 'Type',
            Unit: 'Unité',
            Limit: 'Limite',
            'Normal Limit': 'Limite normale',
            'Severe Limit': 'Limite sévère',
            Compliance: 'Taux de conformité',
            'Worst Deviation': 'Pire écart',
            'Worst Time': "Heure du pire écart",
            'Severe Exceed Count': 'Nb de dépassements sévères',
            'Worst Unbalance': 'Déséquilibre maximal',
            Hz: 'Hz',
            voltage: 'Tension',
            current: 'Courant',
            frequency: 'Fréquence',
            voltage_deviation: 'Écart de tension',
            current_unbalance: 'Déséquilibre de courant',
            voltage_unbalance: 'Déséquilibre de tension',
            mean_deviation_pct: 'Écart moyen (%)',
            p95_abs_deviation_pct: 'Écart absolu P95 (%)',
            mean_abs_deviation_hz: 'Écart absolu moyen (Hz)',
            frequency_deviation: 'Écart de fréquence',
            p95_abs_deviation_hz: 'Écart absolu P95 (Hz)',
            mean_unbalance_pct: 'Déséquilibre moyen (%)',
            p95_unbalance_pct: 'Déséquilibre P95 (%)',
            count: 'Compte',
            min: 'Min',
            max: 'Max',
            mean: 'Moyenne',
            std: 'Écart-type',
            p5: 'P5',
            p95: 'P95'
        }
    },
    fr: {
        translation: {
            // routes & menus
            Dashboard: 'Tableau de bord',
            'Space Data': 'Espace',
            'Equipment Data': 'Équipement',
            'Meter Data': 'Mètre',
            'Tenant Data': 'Locataire',
            'Store Data': 'Boutique',
            'Shopfloor Data': 'Atelier',
            'Combined Equipment Data': 'Équipement combiné',
            'Auxiliary System': 'Système auxiliaire',
            Microgrid: 'Micro-réseau',
            'Energy Storage Power Station': 'Centrale électrique',
            'Photovoltaic Power Station': 'Centrale électrique',
            'Fault Alarm': 'Alarme de panne',
            Monitoring: 'Surveillance',
            'Advanced Reporting': 'Rapports avancés',
            'Knowledge Base': 'Base de connaissances',
            'Energy Category Data': 'Catégorie d’énergie',
            'Energy Item Data': 'Élément d’énergie',
            Carbon: 'Émissions de CO2',
            Cost: 'Coût',
            Output: 'Sortie',
            Income: 'Revenu',
            Efficiency: 'Efficacité',
            Load: 'Charger',
            Statistics: 'Statistiques',
            'Batch Analysis': 'Analyse des lots',
            Saving: 'Épargne',
            Plan: 'Plan',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Suivi de l’équipement',
            'Equipment Comparison': 'Comparaison d’équipement',
            'Shopfloor Comparison': 'Comparaison d’équipement',
            'Store Comparison': 'Comparaison',
            'Space Comparison': 'Comparaison',
            'Combined Equipment Comparison': 'Comparaison d’équipement',
            'Tenant Comparison': 'Comparaison des locataires',
            'Environment Monitor': 'Moniteur d’environnement',
            'Meter Energy': 'Compteur d’énergie',
            'Meter Carbon': 'Computer Émissions de CO2',
            'Meter Cost': 'Compteur Coût',
            'Meter Trend': 'Compteur Tendance',
            'Meter Realtime': 'Compteur en temps réel',
            'Meter Saving': 'Compteur Économie',
            'Meter Plan': 'plan de compteur',
            'Master Meter Submeters Balance': 'Balance des sous-compteurs du compteur maître',
            'Meter Batch Analysis': 'Compteur Analyse des lots ',
            'Meter Comparison': 'Compteurs Comparaison',
            'Meter Tracking': 'Compteurs Suivi',
            'Virtual Meter Saving': 'Compteur Virtuel Économie',
            'Virtual Meter Plan': 'Plan de compteur virtuel',
            'Virtual Meter Energy': 'Compteur Virtuel d’énergie',
            'Virtual Meter Carbon': 'Compteur Virtuel Émissions de CO2',
            'Virtual Meter Cost': 'Compteur Virtuel Coût',
            'Virtual Meter Batch Analysis': 'Analyse par lots de tables virtuelles',
            'Virtual Meter Comparison': "Comparaison de compteurs virtuels",
            'Offline Meter Energy': 'Compteur Hors Ligne d’énergie',
            'Offline Meter Carbon': 'Compteur Hors Ligne Émissions de CO2',
            'Offline Meter Cost': 'Compteur Hors Ligne Coût',
            'Offline Meter Batch Analysis': 'Analyse des lots de compteurs hors ligne',
            'Offline Meter Saving': 'Compteur Hors Ligne Économie',
            'Offline Meter Plan': 'Plan de compteur hors ligne',
            'Offline Meter Input': 'Compteur Hors Ligne Entrée',
            'Tenant Bill': 'Locataire Facture',
            'Energy Flow Diagram': 'Diagramme de flux d’énergie',
            'Distribution System': 'Réseau de distribution',
            'SVG System': 'Systèmes de visualisation SCADA Ⓔ',
            'Faults Data': 'Défauts',
            'Space Equipments': 'Espace Équipements',
            'Combined Equipments': 'Combinés Équipements',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Nombre total de bons de travail',
            'Number of New Work Orders': 'Nombre de nouveaux bons de travail',
            'Number of Inprogress Work Orders': 'Nombre de bons de travail en cours',
            'Number of Done Work Orders': 'Nombre de bons de travail terminés',
            'Fuel Indicator': 'Consommation de carburant',
            'Charge Energy Indicator': 'Énergie de charge',
            'Discharge Energy Indicator': 'Énergie de décharge',
            'Charge Cost Indicator': 'Coût de charge',
            'Discharge Revenue Indicator': 'Revenu de décharge',
            'HVAC': 'HVAC',
            'Fire Control': 'Lutte contre les incendies',

            // Dashboard
            'Welcome to MyEMS': 'Bienvenue chez MyEMS',
            'An Industry Leading Open Source Energy Management System': 'Un système de gestion de l’énergie open source leader de l’industrie',
            "This Year's Consumption CATEGORY VALUE UNIT": 'La consommation de cette année {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Les coûts de cette année {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Ce mois-ci Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Coûts de ce mois-ci {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Consommation {{CATEGORY}} {{VALUE}} {{UNIT}} à la même période l’an dernier',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Coûts {{CATEGORY}} {{VALUE}} {{UNIT}} à la même période l’an dernier',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Consommation {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Coûts {{UNIT}}',
            // Entities
            Space: 'Espace',
            Equipment: 'Équipements',
            Meter: 'Compteur',
            'Offline Meter': 'Compteur Hors Ligne',
            'Virtual Meter': 'Compteur Virtuel',
            Tenant: 'Locataire',
            Store: 'Boutique',
            Shopfloor: 'Atelier',
            'Combined Equipment': 'Équipement combiné',
            'Cost Center': 'Centre de coûts',
            Name: 'Nom',
            DisplayName: 'Montrer Nom',
            UserName: 'Utilisateur Nom',
            Description: 'Description',
            'Energy Category': 'Catégorie d’énergie',
            'Child Spaces': 'Espaces enfants',
            'Associated Equipment': 'Équipement connexe',
            //Energy Categories
            Electricity: 'Électricité',
            Water: 'Eau',
            'Natural Gas': 'Naturel Gaz',
            // SidePanelModal
            Settings: 'Paramètres',
            'Set your own customized style': 'Définissez votre propre style personnalisé',
            'Color Scheme': 'Couleur Schéma',
            'Choose the perfect color mode for your app': 'Choisissez le mode de couleur parfait pour votre application',
            Light: 'Lumière',
            Dark: 'Sombre',
            'RTL Mode': 'RTL Mode',
            'Switch your language direction': 'Changez de langue',
            'Fluid Layout': 'Disposition fluide',
            'Toggle container layout system': 'Système de disposition de conteneur bascule',
            'Navigation Position': 'Navigation Position',
            'Vertical': 'Verticale',
            'Top': 'Le top',
            'Combo': 'Combinaison',
            'Transparent': 'Transparent',
            'Inverted': 'Inversé',
            'Card': 'Carte',
            'Vibrant': 'Animé',
            'Select a suitable navigation system for your web application':
                'Sélectionnez un système de navigation adapté à votre application Web',
            'Vertical Nav': 'Navigation verticale',
            'Top Nav': 'Navigation supérieure',
            'Vertical Navbar Style': 'Style de barre de navigation verticale',
            'Switch between styles for your vertical navbar':
                'Basculer entre les styles pour votre barre de navigation verticale',
            Language: 'Langue',
            'Switch between languages': 'Basculer entre les langues',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Vous aimez ce que vous voyez ?',
            'Get MyEMS now': 'Avoir MyEMS Maintenant',
            Purchase: 'Édition Enterprise',
            ContactInfo: 'Coordonnees',
            ProductWebsite: 'Site produit',
            CompanyWebsite: "Site de l'entreprise",
            SalesPhone: 'Telephone commercial',
            // Query Panel
            'Base Period Begins': 'Base Période Commence',
            'Base Period Ends': 'Base Période Finit',
            'Comparison Types': 'Comparaison Types',
            'Year-Over-Year': 'D’une année à l’autre',
            'Month-On-Month': 'Mois sur mois',
            'Free Comparison': 'Libre Comparaison',
            'None Comparison': 'Aucun Comparaison',
            'Reporting Period Begins': 'Rapports Période Commence',
            'Reporting Period Ends': 'Rapports Période Finit',
            '(Optional)': '(Optionnel)',
            'Period Types': 'Période Types',
            Yearly: 'Annuel',
            Monthly: 'Mensuel',
            Weekly: 'Hebdomadaire',
            Daily: 'Quotidien',
            Hourly: 'Horaire',
            Submit: 'Envoyer',
            'Input Energy Category': 'Entrée Énergie Catégorie',
            'Output Energy Category': 'Sortie Énergie Catégorie',
            'Fraction Parameter': 'Fraction Paramètre',
            Search: 'Rechercher',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'D’ACCORD',
            today: 'Aujourd’hui',
            yesterday: 'Hier',
            hours: 'Heures',
            minutes: 'Compte-rendu',
            seconds: 'Secondes',
            last7Days: '7 derniers jours',
            'Select Date Range': 'Sélectionnez une plage de dates',
            //Card Summaries and Line Charts
            'Base Period': 'Base Période',
            'Reporting Period': 'Rapports Période',
            'Per Unit Area': 'Par unité de surface',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Production unitaire',
            Baseline: 'Ligne de base',
            Actual: 'Effective',
            'Baseline Value - Actual Value': 'Ligne de base - Effective',
            'Average Load': 'Moyen Charger',
            'Maximum Load': 'Maximum Charger',
            'Load Factor': 'Charger Facteur',
            'Ratio of Average Load to Maximum Load': 'Rapport entre la charge moyenne et la charge maximale',
            'Carbon Dioxide Emissions by Energy Category': 'Émissions de dioxyde de carbone par catégorie d’énergie',
            'Costs by Energy Category': 'Coûts par catégorie d’énergie',
            'Incomes by Energy Category': 'Revenus par catégorie d’énergie',
            'Electricity Consumption by Time-Of-Use': 'Consommation d’électricité selon l’heure de consommation',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use':
                'Électricité Émissions de dioxyde de carbone selon l’heure de consommation',
            'Electricity Cost by Time-Of-Use': 'Coût de l’électricité selon l’heure de consommation',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Consommation par éléments énergétiques',
            'Ton of Standard Coal by Energy Category': 'Tonne de charbon standard (TCE) par catégorie d’énergie',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'Tonnes d’émissions de dioxyde de carbone (TCO2E) par catégorie d’énergie',
            'Reporting Period Consumption CATEGORY UNIT': 'Rapports Période Consommation {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Rapports Période Consommation {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Rapports Période Consommation {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Rapports Période Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Base Période Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Rapports Période Consommation {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Rapports Période Consommation {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Base Période Consommation {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Espace enfant Proportion par catégorie d’énergie {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Espace enfant Total Proportion',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Rapports Période Émissions de dioxyde de carbone {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Rapports Période Émissions de dioxyde de carbone {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Base Période Émissions de dioxyde de carbone {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Rapports Période Coûts {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Rapports Période Coûts {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Base Période Coûts {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Rapports Période Sortie {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Rapports Période Sortie {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Rapports Période Sortie {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Rapports Période Sortie {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Base Période Sortie {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Rapports Période Revenu {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Rapports Période Revenu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Base Période Revenu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Rapports Période Total Revenu {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Rapports Période Efficacité Cumulative {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Rapports Période Efficacité Cumulative {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Rapports Période Efficacité Globale Cumulée {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Rapports Période Efficacité Globale Cumulée {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Base Période Efficacité Globale Cumulée {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Instantané Efficacité {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Instantané Efficacité {{UNIT}}',
            'Equipment Efficiency Indicator': 'Indicateur d’efficacité énergétique de l’équipement',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Instantané Complet Efficacité {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Rapports Période Cumulatif Efficacité {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Rapports Période Cumulatif Efficacité {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Base Période Cumulatif Efficacité {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Base Période Cumulatif Efficacité {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Base Période {{CATEGORY}} Maximum Charger {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Rapports Période {{CATEGORY}} Maximum Charger {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Rapports Période {{CATEGORY}} Moyen Charger {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Rapports Période{{CATEGORY}} Charger Facteur',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Base Période {{CATEGORY}} Moyen Charger {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Rapports Période {{CATEGORY}} Moyen Valeur {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Rapports Période {{CATEGORY}} Maximum Valeur {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Rapports Période {{CATEGORY}} Minimum Valeur {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Rapports Période {{CATEGORY}} Arithmétique Méchant {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Rapports Période {{CATEGORY}} Médian (Milieu Valeur) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Rapports Période {{CATEGORY}} Échantillon Standard Déviation {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Rapports Période {{CATEGORY}} Échantillon Variance {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Rapports Période Épargne {{CATEGORY}} (Ligne de base - Effective) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Rapports Période Diminué {{CATEGORY}} (Ligne de base - Effective) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Rapports Période Épargne {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Base Période Épargne {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Rapports Période Maître Compteur Consommation {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Rapports Période Maître Compteur Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Rapports Période Sous-Compteur Consommation {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Rapports Période Sous-Compteur Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Rapports Période Difference {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Rapports Période Pourcentage Difference',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Rapports Période Difference {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Faute Liste',
            'Reporting Period Number of Fault VALUE': 'Rapports Période Nombre de Faute {{VALUE}}',
            'All Faults': 'Tout Fautes',
            'Space Faults': 'Espace Fautes',
            'Number of All Faults': 'Nombre de Tout Fautes',
            'Number of Space Faults': 'Nombre de Espace Fautes',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Tonne de Charbon standard',
            'Ton of Carbon Dioxide Emissions': 'Tonne de Émissions de dioxyde de carbone',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Émissions de carbone par unité de consommation d\'énergie',
            'Operating Characteristic Curve': 'Courbe des caractéristiques de travail',
            Tariff: 'Tarif',
            'Detailed Data': 'Détaillé Données',
            'Child Spaces Data': 'Enfant Espaces Données',
            'Associated Equipment Data': 'Associé Équipement Données',
            'This Year': 'Cette année',
            'The Same Period Last Year': 'La même période l’an dernier',
            'This Month': 'Ce mois-ci',
            'This Day': 'Ce jour',
            Total: 'Total',
            'No data found': 'Non Données fonder',
            Export: 'Exportation',
            Datetime: 'Datetime',
            'Time-Of-Use Type': 'Heure d’utilisation Type',
            'Top-Peak': 'Top-Peak',
            'On-Peak': 'On-Peak',
            'Mid-Peak': 'Mid-Peak',
            'Off-Peak': 'Off-Peak',
            'Deep': 'Deep-Valley',
            Percentage: 'Pourcentage',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Tendance dans la dernière heure d’Energy Value Point',
            Circuit: 'Circuit',
            Point: 'Point',
            'Realtime Value': 'Temps réel Valeur',
            //Meter Tracking
            'Meter List': 'Compteur Liste',
            'Edit Meter': 'Éditer',
            'Start Value': 'Commencer Valeur',
            'End Value': 'Fin Valeur',
            'Difference Value': 'Différence Valeur',
            'Start Integrity Rate': 'Commencer Intégrité Taux(%)',
            'End Integrity Rate': 'Fin Intégrité Taux(%)',
            'Full Integrity Rate': 'Plein Intégrité Taux(%)',
            //Equipment Tracking
            'Equipment List': 'Équipement Liste',
            'Edit Equipment': 'Éditer',
            //Profile Dropdown
            Feedback: 'Rétroaction',
            'Account Settings': 'Compte Paramètres',
            Logout: 'Déconnexion',
            //Authentication
            'Log in': "S'identifier",
            'Email address': 'Messagerie électronique adresse',
            'Phone Number': 'Numéro de téléphone',
            Password: 'Mot de passe',
            CaptchaCode: 'Captcha',
            Refresh: 'Rafraîchir',
            'Remember me': 'Se souvenir me',
            'Logged in as ': 'Connecté dans comme ',
            'Forgot Password?': 'Oublié Mot de passe?',
            'Forgot your password?': 'Oublié votre Mot de passe?',
            "Enter your email and we'll send you a reset link":
                'Entrez votre adresse e-mail et nous vous enverrons un lien de réinitialisation',
            "Enter your email and we'll send you a registration link":
                'Entrez votre adresse e-mail et nous vous enverrons un lien d’inscription',
            'Reset Password': 'Réinitialisation Mot de passe',
            'Thanks for using MyEMS!': 'Merci d’utiliser MyEMS!',
            'You are now successfully signed out': 'Vous êtes maintenant déconnecté avec succès',
            'Return to Login': 'Rendre À Connectez-vous',
            'Please check your email!': 'S’il vous plaît vérifier votre e-mail!',
            'An email has been sent to ': 'Un e-mail a été envoyé à',
            'Please click on the included link to reset your password':
                'Veuillez cliquer sur le lien inclus pour réinitialiser votre mot de passe',
            'Please click on the included link to register your account':
                'Veuillez cliquer sur le lien inclus pour enregistrer votre compte',
            'An email with password reset link is sent to ':
                'Un e-mail avec un lien de réinitialisation du mot de passe est envoyé à ',
            'Change Password': 'Changement Mot de passe',
            'Old Password': 'Vieux Mot de passe',
            'New Password': 'Nouveau Mot de passe',
            'Confirm Password': 'Confirmer Mot de passe',
            'Update Password': 'Mettre à jour Mot de passe',
            'Password has been changed!': 'Le mot de passe a été changé!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Le code de vérification a été envoyé dans votre boîte de réception. \
      Veuillez le copier dans la zone de saisie ci-dessous.',
            'New to MyEMS': 'Nouveau sur MyEMS',
            'Create an account': 'Créer un compte',
            'EMAIL Account registration successful': '{{EMAIL}} Compte inscription réussi',
            'Thanks for verifying your account!': 'Merci d’avoir vérifié votre compte!',
            'Your code is': 'Votre code est',
            'Send verification code': 'Envoyer le code de vérification',
            'Please wait for NUMBER seconds': 'Veuillez patienter {{NUMBER}} Secondes',
            'Password reset': 'Mot de passe réinitialisation',
            'Please wait for approval': 'Veuillez attendre l’approbation',
            //notification
            Notifications: 'Notifications',
            'Mark all as read': 'Marquer tout comme lu',
            'View all': 'Tout',
            'Notification New': 'NOUVEAU',
            'Notification Earlier': 'PLUS TÔT',
            'Notification List': 'Liste des notifications',
            'Bulk actions': 'Actions groupées',
            'Notification Subject': 'Subject',
            'Notification Created Datetime': 'Date/heure de création',
            'Notification Priority': 'Priorité',
            'Notification Message': 'Message',
            'Notification Status': 'Statut',
            'Notification Mark As Read': 'Marquer comme lu',
            'Notification Mark As Acknowledged': 'Reconnaître',
            'Notification Low': 'Bas',
            'Notification Medium': 'Douleur moyenne',
            'Notification High': 'Haut',
            'Notification Critical': 'Critique',
            'Notification Unread': 'Non lu',
            'Notification Read': 'Lire',
            'Notification Acknowledged': 'Reconnu',
            'Notification Archive': 'Archiver',
            'Notification Delete': 'Supprimer',
            'Notification Apply': 'Appliquer',
            'Notification Start Datetime': 'Dateheure de début',
            'Notification End Datetime': 'Dateheure de fin',
            'Notification Update Datetime': 'Mettre à jour la date et l\'heure',
            //Monitoring
            'Run Commands': 'Exécuter des commandes',
            'Pin Code': 'Code PIN',
            'Unlock': 'Ouvrir',
            'Set Value': 'Définir la valeur',
            'Fault Alarms': 'Alarmes de panne',
            'Instantaneous Efficiency VALUE UNIT': 'Instantané Efficacité {{VALUE}} {{UNIT}}',
            'Communication Online': 'En ligne',
            'Communication Offline': 'Hors-ligne',
            'Equipment Status': 'État de l’équipement',
            'Equipment Running': 'Course',
            'Equipment Stopped': 'Arrêté',
            'Show Up to': 'Présentez-vous à',
            All: 'Tout',
            'FROM - TO of TOTAL': 'Affichage actuel {{FROM}} - {{TO}} total {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Énergie des microréseaux',
            'Microgrid Revenue': 'Revenus des microréseaux',
            'Microgrid Carbon': 'Carbone des microréseaux',
            'Photovoltaic Generation': 'Génération photovoltaïque',
            'EV Charger Consumption': 'Consommation des chargeurs EV',
            'Load Consumption': 'Consommation de charge',
            'Grid Buy': 'Achat du réseau',
            'Grid Sell': 'Vente au réseau',
            'EV Charger': 'Chargeur pour véhicule électrique',
            'Heat Pump': 'Pompe à chaleur',
            'Photovoltaic': 'Photovoltaïque',
            'PCS Run State': 'État de fonctionnement du PCS',
            'PCS Unknown': 'Inconnu',
            'PCS Initializing': 'Initialisation en cours',
            'PCS Standby': 'Articles de rechange',
            'PCS Shutdown': 'Temps d’arrêt',
            'PCS Fault': 'La faute',
            'PCS Running': 'Courir',
            'Battery Power': 'Puissance de la batterie',
            'Photovoltaic Power': 'Puissance photovoltaïque',
            'Grid Power': 'Puissance du réseau électrique',
            'Load Power': 'Puissance de charge',
            Reporting: 'Rapport',
            Maintenance: 'Réparation',
            'Serial Number': 'Numéro de série',
            Address: 'Adresse',
            'Postal Code': 'Code Postal',
            'Rated Capacity': 'Capacité nominale',
            'Rated Power': 'Puissance nominale',
            Latitude: 'Latitude',
            Longitude: 'Longitude',
            'Strategy Management': 'Gestion des politiques',
            'Charging Schedule': 'Charging Schedule',
            'Charge Start Time': 'Charge début temps',
            'Charge End Time': 'Charge end Time',
            'Discharge Start Time': 'Le Discharge start time',
            'Discharge End Time': 'Le Discharge end Time',
            'Total Rated Power': 'Puissance totale',
            'Total Rated Capacity': 'Capacité nominale totale',
            "Today's Charge": "Volume de charge aujourd'hui",
            "Today's Discharge": "Décharge aujourd'hui",
            "Today's Generation": "La production d’électricité d’aujourd’hui",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Charge totale',
            'Total Discharge': 'décharge totale',
            'Total Generation': 'Génération totale',
            'Total Revenue': 'Revenu total',
            'Total Photovoltaic Generation': 'Génération photovoltaïque totale',
            'Total EV Charger Consumption': 'Consommation totale des chargeurs EV',
            'Total Load Consumption': 'Consommation totale de charge',
            'Total Grid Buy': 'Achat total du réseau',
            'Total Grid Sell': 'Vente totale au réseau',
            'Total Efficiency': 'Efficacité totale',
            'Discharge Achievement Rate': 'Taux de réussite de la décharge',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Classement des revenus',
            'Efficiency Ranking': 'Classement d\'efficacité',
            'Charge Ranking': 'Classement de la capacité de charge',
            'Discharge Ranking': 'Classement de décharge',
            'Number of Microgrids': 'Nombre de micro-réseaux',
            'Number of Power Stations': 'Nombre de centrales électriques',
            'Microgrid List': 'Liste des microréseaux',
            'Select Microgrid': 'Sélectionner le microréseau',
            'Previous Page': 'Page précédente',
            'Next Page': 'Page suivante',
            '7 Days': '7 jours',
            'Charge UNIT': 'Charge {{UNIT}}',
            'Discharge UNIT': 'décharge {{UNIT}}',
            'Generation UNIT': 'produire de l\'électricité {{UNIT}}',
            'Energy Indicator': 'énergétique',
            'Revenue Indicator': 'rendement',
            'Carbon Indicator': 'carbone',

            // Energy Storage Power Station
            'Battery Operating State': 'État de fonctionnement de la batterie',
            'Battery State': 'État de la batterie',
            'Battery Unknown': 'Inconnu',
            'Battery Stopped': 'A cessé',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'La faute', // 1
            'Battery Warning': 'Avertissement', // 2
            'Battery Standby': 'Articles de rechange', // 3
            'Battery Prohibit DisCharging': 'Interdiction de désinstaller', // 4
            'Battery Prohibit Charging': 'Interdiction de charger', // 5
            'Battery Normal': 'Typiquement', // 6
            'Battery Charging': 'En charge', // 7
            'Battery Discharging': 'Dans la décharge', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Phases du cycle de vie',
            'Use Phase': 'Phase d\'utilisation',
            'Commissioning Phase': 'Phase de mise en service',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Phase d\'installation',
            'Device Status': 'État de l\'appareil',
            'Basic Information': 'Informations de base',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'onduleurs',
            'Invertor Run State': 'État de fonctionnement',
            'Invertor Unknown': 'Inconnu',
            'Invertor Initializing': 'Initialisation en cours',
            'Invertor Standby': 'Articles de rechange',
            'Invertor Shutdown': 'Temps d’arrêt',
            'Invertor Fault': 'La faute',
            'Invertor Running': 'Courir',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Créé Datetime',
            'File Format': 'Lime Format',
            'File Size': 'Lime Taille',
            Uploader: 'Téléchargeur',
            //Error
            "The page you're looking for is not found": 'La page que vous recherchez est introuvable',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Assurez-vous que l’adresse est correcte et que la page n’a pas été déplacée. ',
            'If you think this is a mistake,': 'Si vous pensez que c’est une erreur,',
            'contact us': 'Contactez-nous',
            'Take me home': 'Ramenez-moi à la maison',
            'Whoops, something went wrong!': 'Whoops, quelque chose s’est mal passé!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Essayez d’actualiser la page, ou revenir en arrière et tenter à nouveau l’action. ',
            'If this problem persists,': 'Si ce problème persiste,',
            'Captcha Error': 'Captcha Erreur',
            'Confirm Password Error': 'Le mot de passe de confirmation ne correspond pas',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Il semble que vous ayez cliqué \
      sur un lien de réinitialisation de mot de passe non valide. Veuillez réessayer.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Il semble que vous ayez \
      cliqué sur un lien de compte d’inscription non valide. Veuillez réessayer..',
            //Tenant Bill
            'Lease Contract Number': 'Bail Contrat Nombre',
            Download: 'Télécharger',
            Print: 'Imprimer',
            'Payment Notice': 'Paiement Remarquer',
            'Bill To': 'Facture À',
            'Bill Number': 'Facture Nombre',
            'Bill Date': 'Facture Date',
            'Payment Due Date': 'Paiement Due Date',
            'Amount Payable': 'Quantité Payable',
            'Billing Period Start': 'Facturation Période Commencer',
            'Billing Period End': 'Facturation Période Fin',
            Quantity: 'Quantité',
            Price: 'Prix',
            Amount: 'Quantité',
            Subtotal: 'Sous-total',
            'VAT Output Tax': 'TVA Sortie Taxe',
            'Total Amount Payable': 'Total Quantité Payable',
            'Please make sure to pay on or before the payment due date above':
                'Veuillez vous assurer de payer au plus tard à la date d’échéance du paiement ci-dessus',
            'Send money to the following account': 'Envoyer de l’argent sur le compte suivant',
            'Account Name': 'Compte Nom',
            'Bank Name': 'Banque Nom',
            'Bank Address': 'Banque Adresse',
            'RMB Account': 'RMB Compte',
            // button
            'Toggle Navigation': 'Cabillot Navigation',
            // working calendar
            'Working Days': 'Travaillant Jours',
            'Non Working Days': 'Non Travaillant Jours',
            'Select Row': 'Veuillez sélectionner la ligne de données',
            // Offline Meter Input
            'Daily Value': 'Quotidien Valeur',
            Date: 'Date',
            'Successfully Saved': 'Avec succès Sauvé',
            'Previous Data Is Empty': 'Précédent Les données sont vides',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'Ungültiger Offline-Zählerwert',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Relation avec la centrale électrique virtuelle',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Tableau récapitulatif',
            SubMeter: 'Sous - table',
            'Power Quality': 'Calidad de energía',
            'About Power Quality': 'Acerca de la calidad de energía',
            'Trend Values': 'Valores de tendencia',
            Category: 'Categoría',
            Type: 'Tipo',
            Unit: 'Unidad',
            Limit: 'Límite',
            'Normal Limit': 'Límite normal',
            'Severe Limit': 'Límite severo',
            Compliance: 'Tasa de cumplimiento',
            'Worst Deviation': 'Peor desviación',
            'Worst Time': 'Momento de peor desviación',
            'Severe Exceed Count': 'Conteo de excedencias severas',
            'Worst Unbalance': 'Desbalance máximo',
            Hz: 'Hz',
            voltage: 'Tensión',
            current: 'Corriente',
            frequency: 'Frecuencia',
            voltage_deviation: 'Desviación de tensión',
            current_unbalance: 'Desequilibrio de corriente',
            voltage_unbalance: 'Desequilibrio de tensión',
            mean_deviation_pct: 'Desviación media (%)',
            p95_abs_deviation_pct: 'Desviación absoluta P95 (%)',
            mean_abs_deviation_hz: 'Desviación absoluta media (Hz)',
            frequency_deviation: 'Desviación de frecuencia',
            p95_abs_deviation_hz: 'Desviación absoluta P95 (Hz)',
            mean_unbalance_pct: 'Desequilibrio medio (%)',
            p95_unbalance_pct: 'Desequilibrio P95 (%)',
            count: 'Recuento',
            min: 'Mín',
            max: 'Máx',
            mean: 'Media',
            std: 'Desv. est.',
            p5: 'P5',
            p95: 'P95'
        }
    },
    es: {
        translation: {
            // routes & menus
            Dashboard: 'Salpicadero',
            'Space Data': 'Espacio',
            'Equipment Data': 'Equipo',
            'Meter Data': 'Metro',
            'Tenant Data': 'Arrendatario',
            'Store Data': 'Tienda',
            'Shopfloor Data': 'Taller',
            'Combined Equipment Data': 'Equipos combinados',
            'Auxiliary System': 'Sistema auxiliar',
            Microgrid: 'Microrred',
            'Energy Storage Power Station': 'Central eléctrica',
            'Photovoltaic Power Station': 'Central eléctrica',
            'Fault Alarm': 'Alarma de falla',
            Monitoring: 'Monitorización',
            'Advanced Reporting': 'Informes avanzados',
            'Knowledge Base': 'Knowledge base',
            'Energy Category Data': 'Categoría de energía',
            'Energy Item Data': 'Artículo de energía',
            Carbon: 'Emisiones de CO2',
            Cost: 'Costar',
            Output: 'Salida',
            Income: 'Renta',
            Efficiency: 'Eficacia',
            Load: 'Carga',
            Statistics: 'Estadística',
            'Batch Analysis': 'Análisis de lotes',
            Saving: 'Ahorro',
            Plan: 'Plan',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Seguimiento de equipos',
            'Equipment Comparison': 'Comparación de equipos',
            'Shopfloor Comparison': 'Comparación de equipos',
            'Store Comparison': 'Comparación de equipos',
            'Space Comparison': 'Comparación',
            'Combined Equipment Comparison': 'Comparación de equipos',
            'Tenant Comparison': 'comparar inquilinos',
            'Environment Monitor': 'Monitor de entorno',
            'Meter Energy': 'Energía del medidor',
            'Meter Carbon': 'Medir las Emisiones de CO2',
            'Meter Cost': 'Costo del medidor',
            'Meter Trend': 'Tendencia del medidor',
            'Meter Realtime': 'Medidor en tiempo real',
            'Meter Saving': 'Ahorro de medidores',
            'Meter Plan': 'plano del medidor',
            'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
            'Meter Batch Analysis': 'Análisis de lotes de medidores',
            'Meter Comparison': 'Comparación de medidores',
            'Meter Tracking': 'Seguimiento del medidor',
            'Virtual Meter Saving': 'Ahorro de medidores virtuales',
            'Virtual Meter Plan': 'Plan de contadores virtuales',
            'Virtual Meter Energy': 'Medidor virtual de energía',
            'Virtual Meter Carbon': 'Medidor virtual de Emisiones de CO2',
            'Virtual Meter Cost': 'Costo del medidor virtual',
            'Virtual Meter Batch Analysis': 'Análisis por lotes de medidores virtuales',
            'Virtual Meter Comparison': "Comparación de medidores virtuales",
            'Offline Meter Energy': 'Energía del medidor fuera de línea',
            'Offline Meter Carbon': 'Medición fuera de línea de Emisiones de CO2',
            'Offline Meter Cost': 'Costo del medidor fuera de línea',
            'Offline Meter Batch Analysis': 'Análisis de lotes de medidores fuera de línea',
            'Offline Meter Saving': 'Ahorro de medidores fuera de línea',
            'Offline Meter Plan': 'Plan de medidor sin conexión',
            'Offline Meter Input': 'Entrada de medidor fuera de línea',
            'Tenant Bill': 'Proyecto de ley del inquilino',
            'Energy Flow Diagram': 'Diagrama de flujo de energía',
            'Distribution System': 'Sistema de distribución',
            'SVG System': 'Sistema de visualización SCADA',
            'Faults Data': 'Fallas',
            'Space Equipments': 'Equipos espaciales',
            'Combined Equipments': 'Equipos combinados',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Número total de órdenes de trabajo',
            'Number of New Work Orders': 'Número de órdenes de trabajo nuevas',
            'Number of Inprogress Work Orders': 'Número de órdenes de trabajo en curso',
            'Number of Done Work Orders': 'Número de órdenes de trabajo finalizadas',
            'Fuel Indicator': 'Consumo de combustible',
            'Charge Energy Indicator': 'Energía de carga',
            'Discharge Energy Indicator': 'Energía de descarga',
            'Charge Cost Indicator': 'Costo de carga',
            'Discharge Revenue Indicator': 'Ingresos de descarga',
            'HVAC': 'HVAC',
            'Fire Control': 'Control de incendios',

            // Dashboard
            'Welcome to MyEMS': 'Bienvenido a MyEMS',
            'An Industry Leading Open Source Energy Management System':
                'Un sistema de gestión de energía de código abierto líder en la industria',
            "This Year's Consumption CATEGORY VALUE UNIT": 'El consumo de este año {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Los costos de este año {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'El consumo de este mes {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Los costos de este mes {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Consumo {{CATEGORY}} {{VALUE}} {{UNIT}}  en el mismo período del año pasado',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Costos {{CATEGORY}} {{VALUE}} {{UNIT}} en el mismo período del año pasado',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Consumo {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Costos {{UNIT}}',
            // Entities
            Space: 'Espacio',
            Equipment: 'Equipo',
            Meter: 'Metro',
            'Offline Meter': 'Medidor fuera de línea',
            'Virtual Meter': 'Medidor virtual',
            Tenant: 'Arrendatario',
            Store: 'Tienda',
            Shopfloor: 'Taller',
            'Combined Equipment': 'Equipos combinados',
            'Cost Center': 'Centro de Costos',
            Name: 'Nombre',
            DisplayName: 'Nombre para mostrar',
            UserName: 'Nombre de usuario',
            Description: 'Descripción',
            'Energy Category': 'Categoría de energía',
            'Child Spaces': 'Espacios infantiles',
            'Associated Equipment': 'Equipos asociados',
            //Energy Categories
            Electricity: 'Electricidad',
            Water: 'Agua',
            'Natural Gas': 'Gas natural',
            // SidePanelModal
            Settings: 'Configuración',
            'Set your own customized style': 'Establece tu propio estilo personalizado',
            'Color Scheme': 'Esquema de color',
            'Choose the perfect color mode for your app': 'Elige el modo de color perfecto para tu aplicación',
            Light: 'Luz',
            Dark: 'Oscuro',
            'RTL Mode': 'Modo RTL',
            'Switch your language direction': 'Cambiar la dirección del idioma',
            'Fluid Layout': 'Diseño fluido',
            'Toggle container layout system': 'Alternar sistema de diseño de contenedores',
            'Navigation Position': 'Posición de navegación',
            'Vertical': 'Vertical',
            'Top': 'Arriba',
            'Combo': 'Combinación',
            'Transparent': 'Transparente',
            'Inverted': 'Invertida',
            'Card': 'Tarjeta',
            'Vibrant': 'Vívida',
            'Select a suitable navigation system for your web application':
                'Seleccione un sistema de navegación adecuado para su aplicación web',
            'Vertical Nav': 'Navegación vertical',
            'Top Nav': 'Navegación superior',
            'Vertical Navbar Style': 'Estilo de barra de navegación vertical',
            'Switch between styles for your vertical navbar': 'Cambiar entre estilos para la barra de navegación vertical',
            Language: 'Idioma',
            'Switch between languages': 'Cambiar entre idiomas',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Me gusta lo que ves?',
            'Get MyEMS now': 'Obtenga MyEMS ahora',
            Purchase: 'Versión corporativa',
            ContactInfo: 'Informacion de contacto',
            ProductWebsite: 'Sitio web del producto',
            CompanyWebsite: 'Sitio web de la empresa',
            SalesPhone: 'Telefono de ventas',
            // Query Panel
            'Base Period Begins': 'Comienza el período base',
            'Base Period Ends': 'Finaliza el período base',
            'Comparison Types': 'Tipos de comparación',
            'Year-Over-Year': 'Año tras año',
            'Month-On-Month': 'Mes a mes',
            'Free Comparison': 'Comparación gratuita',
            'None Comparison': 'Ninguna Comparación',
            'Reporting Period Begins': 'Comienza el período del informe',
            'Reporting Period Ends': 'Finaliza el período de presentación de informes',
            '(Optional)': '(Opcional)',
            'Period Types': 'Tipos de período',
            Yearly: 'Anual',
            Monthly: 'Mensual',
            Weekly: 'Semanal',
            Daily: 'Diario',
            Hourly: 'Cada hora',
            Submit: 'Enviar',
            'Input Energy Category': 'Categoría de energía de entrada',
            'Output Energy Category': 'Categoría de energía de salida',
            'Fraction Parameter': 'Parámetro Fraction',
            Search: 'Buscar',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'De acuerdo',
            today: 'Hoy',
            yesterday: 'Ayer',
            hours: 'Horas',
            minutes: 'Acta',
            seconds: 'Sobras',
            last7Days: 'Últimos 7 días',
            'Select Date Range': 'Seleccionar intervalo de fechas',
            //Card Summaries and Line Charts
            'Base Period': 'Período base',
            'Reporting Period': 'Período',
            'Per Unit Area': 'Por unidad de área',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Por unidad de producción',
            Baseline: 'Referencia',
            Actual: 'Actual',
            'Baseline Value - Actual Value': 'Línea base - Actual',
            'Average Load': 'Carga media',
            'Maximum Load': 'Carga máxima',
            'Load Factor': 'Factor de carga',
            'Ratio of Average Load to Maximum Load': 'Relación entre la carga media y la carga máxima',
            'Carbon Dioxide Emissions by Energy Category': 'Emisiones de dióxido de carbono por categoría de energía',
            'Costs by Energy Category': 'Costos por categoría de energía',
            'Incomes by Energy Category': 'Ingresos por categoría de energía',
            'Electricity Consumption by Time-Of-Use': 'Consumo de electricidad por tiempo de uso',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use':
                'Emisiones de dióxido de carbono de electricidad por tiempo de uso',
            'Electricity Cost by Time-Of-Use': 'Costo de electricidad por tiempo de uso',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Consumo por partidas energéticas',
            'Ton of Standard Coal by Energy Category': 'Tonelada de carbón estándar(TCE) por categoría de energía',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'Toneladas de emisiones de dióxido de carbono(TCO2E) por categoría de energía',
            'Reporting Period Consumption CATEGORY UNIT': 'Consumo del período de informe {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Consumo del período de informe {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Consumo del período de informe {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Consumo del período de informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Consumo del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT':
                'Consumo del período de informe {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Consumo del período de informe {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Consumo del período base {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT':
                'Proporción del espacio infantil por categoría de energía {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Espacio infantil Proporción total',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Período de presentación de informes Emisiones de dióxido de carbono {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Período de presentación de informes Emisiones de dióxido de carbono {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emisiones de dióxido de carbono del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Costos del período de informe {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Costos del período de informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Costos del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Resultados del período del informe {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{EQUIPMENT}} Resultados del período del informe {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Resultados del período del informe {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT':
                'Resultados del período del informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Resultado del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Ingresos del período del informe {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Ingresos del período del informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Ingresos del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Ingresos totales del período del informe {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT':
                'Eficiencia acumulada del período de presentación de informes {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Eficiencia acumulada del período de presentación de informes {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Período de presentación de informes Eficiencia integral acumulada {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Período de presentación de informes Eficiencia integral acumulada {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Período base Eficiencia integral acumulada {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Eficiencia instantánea {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Eficiencia instantánea {{UNIT}}',
            'Equipment Efficiency Indicator': 'Indicador de eficiencia energética del equipo',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiencia integral instantánea {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT':
                'Eficiencia acumulada del período de presentación de informes {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Eficiencia acumulada del período de presentación de informes {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Eficiencia acumulada del período base {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Eficiencia acumulada del período base {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Período base {{CATEGORY}} Carga máxima {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Período {{CATEGORY}} Carga máxima {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Período {{CATEGORY}} Carga media {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Período {{CATEGORY}} Factor de carga',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Período base {{CATEGORY}} Carga media {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Período {{CATEGORY}} Valor medio {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Período {{CATEGORY}} Valor máximo {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Período {{CATEGORY}} Valor mínimo {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Período {{CATEGORY}} Media aritmética {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Período {{CATEGORY}} Mediana (Valor medio) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Período {{CATEGORY}} Desviación estándar de la muestra {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Período {{CATEGORY}} Varianza de la muestra {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Ahorro del período de informe {{CATEGORY}} (Línea base - Actual) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Período de informe disminuido {{CATEGORY}} (Línea base - Actual) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Ahorro del período de informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Ahorro del período base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Período de informe Consumo del medidor maestro {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Período de informe Consumo del medidor maestro {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Período del informe Consumo de submedidores {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Período del informe Consumo de submedidores {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Diferencia en el período del informe {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Diferencia porcentual del período del informe',
            'Reporting Period Difference CATEGORY VALUE UNIT':
                'Diferencia en el período del informe {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Lista de fallos',
            'Reporting Period Number of Fault VALUE': 'Período de informe Número de falla {{VALUE}}',
            'All Faults': 'Todas las fallas',
            'Space Faults': 'Fallas de espacio',
            'Number of All Faults': 'Número de todas las fallas',
            'Number of Space Faults': 'Número de fallos de espacio',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Tonelada de carbón estándar',
            'Ton of Carbon Dioxide Emissions': 'Toneladas de emisiones de dióxido de carbono',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Emisiones de carbono por unidad de consumo de energía',
            'Operating Characteristic Curve': 'Curva característica de trabajo',
            Tariff: 'Arancel',
            'Detailed Data': 'Datos detallados',
            'Child Spaces Data': 'Datos de espacios secundarios',
            'Associated Equipment Data': 'Datos de equipos asociados',
            'This Year': 'Este año',
            'The Same Period Last Year': 'El mismo período del año pasado',
            'This Month': 'Este mes',
            'This Day': 'Este día',
            Total: 'Total',
            'No data found': 'No se han encontrado datos',
            Export: 'Exportar',
            Datetime: 'Fecha y hora',
            'Time-Of-Use Type': 'Tipo de tiempo de uso',
            'Top-Peak': 'Pico superior',
            'On-Peak': 'En horas pico',
            'Mid-Peak': 'Pico medio',
            'Off-Peak': 'Fuera de las horas pico',
            'Deep': 'Deep-Valley',
            Percentage: 'Porcentaje',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Tendencia en la última hora de Energy Value Point',
            Circuit: 'Circuito',
            Point: 'Punto',
            'Realtime Value': 'Valor en tiempo real',
            //Meter Tracking
            'Meter List': 'Lista de medidores',
            'Edit Meter': 'Editar',
            'Start Value': 'Valor inicial',
            'End Value': 'Valor final',
            'Difference Value': 'Valor de diferencia',
            'Start Integrity Rate': 'Tasa de integridad de inicio(%)',
            'End Integrity Rate': 'Tasa de integridad final(%)',
            'Full Integrity Rate': 'Tasa de integridad total(%)',
            //Equipment Tracking
            'Equipment List': 'Lista de equipos',
            'Edit Equipment': 'Editar',
            //Profile Dropdown
            Feedback: 'Retroalimentación',
            'Account Settings': 'Configuración de la cuenta',
            Logout: 'Cerrar sesión',
            //Authentication
            'Log in': 'Inicia sesión',
            'Email address': 'Dirección de correo electrónico',
            'Phone Number': 'Número de teléfono',
            Password: 'Contraseña',
            CaptchaCode: 'Captcha',
            Refresh: 'Actualizar',
            'Remember me': 'Recuérdame',
            'Logged in as ': 'Conectado como ',
            'Forgot Password?': 'Olvidé mi contraseña?',
            'Forgot your password?': 'Olvidó su contraseña?',
            "Enter your email and we'll send you a reset link":
                'Introduce tu correo electrónico y te enviaremos un enlace de restablecimiento',
            "Enter your email and we'll send you a registration link":
                'Introduce tu email y te enviaremos un enlace de registro',
            'Reset Password': 'Restablecer contraseña',
            'Thanks for using MyEMS!': 'Gracias por usar MyEMS!',
            'You are now successfully signed out': 'Ahora ha cerrado sesión correctamente',
            'Return to Login': 'Volver al inicio de sesión',
            'Please check your email!': 'Por favor, revise su correo electrónico!',
            'An email has been sent to ': 'Se ha enviado un correo electrónico a ',
            'Please click on the included link to reset your password':
                'Haga clic en el enlace incluido para restablecer su contraseña',
            'Please click on the included link to register your account':
                'Haga clic en el enlace incluido para registrar su cuenta',
            'An email with password reset link is sent to ':
                'Se envía un correo electrónico con el enlace de restablecimiento de contraseña a ',
            'Change Password': 'Cambiar contraseña',
            'Old Password': 'Contraseña antigua',
            'New Password': 'Nueva contraseña',
            'Confirm Password': 'Confirmar contraseña',
            'Update Password': 'Actualizar contraseña',
            'Password has been changed!': 'Se ha cambiado la contraseña!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Se ha enviado un código de verificación a tu bandeja de entrada. \
      Cópielo en el cuadro de entrada a continuación.',
            'New to MyEMS': 'Nuevo en MyEMS',
            'Create an account': 'Crear una cuenta',
            'EMAIL Account registration successful': '{{EMAIL}} Registro de cuenta exitoso',
            'Thanks for verifying your account!': 'Gracias por verificar tu cuenta!',
            'Your code is': 'Su código es',
            'Send verification code': 'Enviar código de verificación',
            'Please wait for NUMBER seconds': 'Por favor, espere a {{NUMBER}} sobras',
            'Password reset': 'Restablecimiento de contraseña',
            'Please wait for approval': 'Por favor, espere la aprobación',
            //notification
            Notifications: 'Notificaciones',
            'Mark all as read': 'Marcar todo como leído',
            'View all': 'Todo',
            'Notification New': 'NUEVO',
            'Notification Earlier': 'ANTERIOR',
            'Notification List': 'Lista de notificaciones',
            'Bulk actions': 'Acciones masivas',
            'Notification Subject': 'Asunto',
            'Notification Created Datetime': 'Fecha y hora de creación',
            'Notification Priority': 'Prioridad',
            'Notification Message': 'Mensaje',
            'Notification Status': 'Estado',
            'Notification Mark As Read': 'Marcar como leído',
            'Notification Mark As Acknowledged': 'Reconocer',
            'Notification Low': 'Bajo',
            'Notification Medium': 'Medio',
            'Notification High': 'Alto',
            'Notification Critical': 'Crítico',
            'Notification Unread': 'No leído',
            'Notification Read': 'Leer',
            'Notification Acknowledged': 'Reconocido',
            'Notification Archive': 'Archivo',
            'Notification Delete': 'Borrar',
            'Notification Apply': 'Aplicar',
            'Notification Start Datetime': 'Fecha de inicio y hora',
            'Notification End Datetime': 'Fecha y hora de finalización',
            'Notification Update Datetime': 'Actualizar fecha y hora',
            //Monitoring
            'Run Commands': 'Ejecutar comandos',
            'Pin Code': 'Código PIN',
            'Unlock': 'Descubrir',
            'Set Value': 'Establecer valor',
            'Fault Alarms': 'Alarmas de avería',
            'Instantaneous Efficiency VALUE UNIT': 'Eficiencia instantánea {{VALUE}} {{UNIT}}',
            'Communication Online': 'En línea',
            'Communication Offline': 'Sin conexión',
            'Equipment Status': 'Estado del dispositivo',
            'Equipment Running': 'Corriente',
            'Equipment Stopped': 'Detenido',
            'Show Up to': 'Presentarse a',
            All: 'Todo',
            'FROM - TO of TOTAL': 'Actualmente se muestra {{FROM}} - {{TO}} total {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Energía de microrredes',
            'Microgrid Revenue': 'Ingresos de microrredes',
            'Microgrid Carbon': 'Carbono de microrredes',
            'Photovoltaic Generation': 'Generación fotovoltaica',
            'EV Charger Consumption': 'Consumo de cargadores EV',
            'Load Consumption': 'Consumo de carga',
            'Grid Buy': 'Compra de la red',
            'Grid Sell': 'Venta a la red',
            'EV Charger': 'Cargador de vehículos eléctricos',
            'Heat Pump': 'Bomba de calor',
            'Photovoltaic': 'Fotovoltaica',
            'PCS Run State': 'Estado de funcionamiento del PCs',
            'PCS Unknown': 'Desconocido',
            'PCS Initializing': 'Se está iniciando',
            'PCS Standby': 'Artículos de repuesto',
            'PCS Shutdown': 'Parada',
            'PCS Fault': 'Culpa',
            'PCS Running': 'Correr',
            'Battery Power': 'Potencia de la batería',
            'Photovoltaic Power': 'Фотоэлектрическая мощность',
            'Grid Power': 'Potencia de la red eléctrica',
            'Load Power': 'Potencia de carga',
            Reporting: 'Informe',
            Maintenance: 'Mantenimiento',
            'Serial Number': 'Numéro de série',
            Address: 'Adresse de résidence',
            'Postal Code': 'Code Postal',
            'Rated Capacity': 'Capacidad nominal',
            'Rated Power': 'Potencia nominal',
            Latitude: 'Latitude',
            Longitude: 'Longitude',
            'Strategy Management': 'Gestión estratégica',
            'Charging Schedule': 'Calendrier de charge',
            'Charge Start Time': 'Heure de début de charge',
            'Charge End Time': 'Temps de fin de charge',
            'Discharge Start Time': 'Heure de début de décharge',
            'Discharge End Time': 'Temps de fin de décharge',
            'Total Rated Power': 'Potencia nominal total',
            'Total Rated Capacity': 'Capacidad nominal total',
            "Today's Charge": "Carga hoy",
            "Today's Discharge": "Descarga de electricidad hoy",
            "Today's Generation": "La generación de energía actual",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Carga total',
            'Total Discharge': 'descarga total',
            'Total Generation': 'Generación total',
            'Total Revenue': 'Los ingresos totales',
            'Total Photovoltaic Generation': 'Generación fotovoltaica total',
            'Total EV Charger Consumption': 'Consumo total de cargadores EV',
            'Total Load Consumption': 'Consumo total de carga',
            'Total Grid Buy': 'Compra total de la red',
            'Total Grid Sell': 'Venta total a la red',
            'Total Efficiency': 'Eficiencia total',
            'Discharge Achievement Rate': 'Tasa de logro de descarga',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Clasificación de ingresos',
            'Efficiency Ranking': 'Clasificación de eficiencia',
            'Charge Ranking': 'Clasificación de capacidad de carga',
            'Discharge Ranking': 'Clasificación de alta',
            'Number of Microgrids': 'Número de microrredes',
            'Number of Power Stations': 'Número de centrales eléctricas',
            'Microgrid List': 'Lista de microrredes',
            'Select Microgrid': 'Seleccionar microrred',
            'Previous Page': 'Pagina anterior',
            'Next Page': 'Siguiente página',
            '7 Days': '7 días',
            'Charge UNIT': 'Cargar {{UNIT}}',
            'Discharge UNIT': 'descargar {{UNIT}}',
            'Generation UNIT': 'producir electricidad {{UNIT}}',
            'Energy Indicator': 'energía',
            'Revenue Indicator': 'rendimiento',
            'Carbon Indicator': 'carbono',

            // Energy Storage Power Station
            'Battery Operating State': 'Estado de funcionamiento de la batería',
            'Battery State': 'Estado de la batería',
            'Battery Unknown': 'Desconocido',
            'Battery Stopped': 'Se ha detenido',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Culpa', // 1
            'Battery Warning': 'Aviso', // 2
            'Battery Standby': 'Artículos de repuesto', // 3
            'Battery Prohibit DisCharging': 'Prohibición de descargar', // 4
            'Battery Prohibit Charging': 'Está prohibido cargar', // 5
            'Battery Normal': 'Típico', // 6
            'Battery Charging': 'En carga', // 7
            'Battery Discharging': 'En descarga', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Fase del ciclo de vida',
            'Use Phase': 'Fase de uso',
            'Commissioning Phase': 'Fase de puesta en marcha',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Fase de instalación',
            'Device Status': 'Estado del dispositivo',
            'Basic Information': 'Información básica',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'inversores',
            'Invertor Run State': 'Estado de funcionamiento',
            'Invertor Unknown': 'Desconocido',
            'Invertor Initializing': 'Se está iniciando',
            'Invertor Standby': 'Artículos de repuesto',
            'Invertor Shutdown': 'Parada',
            'Invertor Fault': 'Culpa',
            'Invertor Running': 'Correr',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Fecha y hora creada',
            'File Format': 'Formato de archivo',
            'File Size': 'Tamaño del archivo',
            Uploader: 'Cargador',
            //Error
            "The page you're looking for is not found": 'La página que estás buscando no se encuentra',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Asegúrese de que la dirección sea correcta y que la página no se haya movido. ',
            'If you think this is a mistake,': 'Si crees que esto es un error,',
            'contact us': 'contáctenos',
            'Take me home': 'Llévame a casa',
            'Whoops, something went wrong!': 'Vaya, algo salió mal!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Intente actualizar la página o retroceda e intente la acción nuevamente. ',
            'If this problem persists,': 'Si este problema persiste,',
            'Captcha Error': 'Error de captcha',
            'Confirm Password Error': 'La contraseña de confirmación no coincide',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Parece que hiciste clic \
      en un vínculo de restablecimiento de contraseña no válido. Inténtalo de nuevo.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Parece que hiciste clic \
      en un vínculo de cuenta de registro no válido. Inténtalo de nuevo.',
            //Tenant Bill
            'Lease Contract Number': 'Número de contrato de arrendamiento',
            Download: 'Descargar',
            Print: 'Impresión',
            'Payment Notice': 'Aviso de pago',
            'Bill To': 'Facturar a',
            'Bill Number': 'Número de factura',
            'Bill Date': 'Fecha de facturación',
            'Payment Due Date': 'Fecha de vencimiento del pago',
            'Amount Payable': 'Importe a pagar',
            'Billing Period Start': 'Inicio del período de facturación',
            'Billing Period End': 'Fin del período de facturación',
            Quantity: 'Cantidad',
            Price: 'Precio',
            Amount: 'Importe',
            Subtotal: 'Subtotal',
            'VAT Output Tax': 'IVA repercutido',
            'Total Amount Payable': 'Importe total a pagar',
            'Please make sure to pay on or before the payment due date above':
                'Asegúrese de pagar en o antes de la fecha de vencimiento del pago anterior',
            'Send money to the following account': 'Enviar dinero a la siguiente cuenta',
            'Account Name': 'Nombre de la cuenta',
            'Bank Name': 'Nombre del banco',
            'Bank Address': 'Dirección del banco',
            'RMB Account': 'Cuenta en RMB',
            // button
            'Toggle Navigation': 'Alternar navegación',
            // working calendar
            'Working Days': 'Días laborables',
            'Non Working Days': 'Días no laborables',
            'Select Row': 'Seleccione Fila de datos',
            // Offline Meter Input
            'Daily Value': 'Valor diario',
            Date: 'Fecha',
            'Successfully Saved': 'Guardado correctamente',
            'Previous Data Is Empty': 'Los datos anteriores están vacíos',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'Valeur de compteur hors ligne invalide',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Relacionado con centrales virtuales',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Tabla general',
            SubMeter: 'Tabla dividida',
            'Power Quality': 'Качество электроэнергии',
            'About Power Quality': 'О качестве электроэнергии',
            'Trend Values': 'Значения тренда',
            Category: 'Категория',
            Type: 'Тип',
            Unit: 'Единица',
            Limit: 'Предел',
            'Normal Limit': 'Нормальный предел',
            'Severe Limit': 'Критический предел',
            Compliance: 'Уровень соответствия',
            'Worst Deviation': 'Наибольшее отклонение',
            'Worst Time': 'Время наибольшего отклонения',
            'Severe Exceed Count': 'Число серьёзных превышений',
            'Worst Unbalance': 'Максимальный небаланс',
            Hz: 'Гц',
            voltage: 'Напряжение',
            current: 'Ток',
            frequency: 'Частота',
            voltage_deviation: 'Отклонение напряжения',
            current_unbalance: 'Несимметрия тока',
            voltage_unbalance: 'Несимметрия напряжения',
            mean_deviation_pct: 'Среднее отклонение (%)',
            p95_abs_deviation_pct: 'P95 абсолютное отклонение (%)',
            mean_abs_deviation_hz: 'Среднее абсолютное отклонение (Гц)',
            frequency_deviation: 'Отклонение частоты',
            p95_abs_deviation_hz: 'P95 абсолютное отклонение (Гц)',
            mean_unbalance_pct: 'Средняя несимметрия (%)',
            p95_unbalance_pct: 'P95 несимметрия (%)',
            count: 'Количество',
            min: 'Мин',
            max: 'Макс',
            mean: 'Среднее',
            std: 'Ст. откл.',
            p5: 'P5',
            p95: 'P95'
        }
    },
    ru: {
        translation: {
            // routes & menus
            Dashboard: 'Щиток',
            'Space Data': 'Пространство',
            'Equipment Data': 'Оборудование',
            'Meter Data': 'Метр',
            'Tenant Data': 'Съёмщик',
            'Store Data': 'Магазин',
            'Shopfloor Data': 'Торговый зал',
            'Combined Equipment Data': 'Комбинированное оборудование',
            'Auxiliary System': 'Вспомогательная система',
            Microgrid: 'Микросеть',
            'Energy Storage Power Station': 'Электростанция',
            'Photovoltaic Power Station': 'Электростанция',
            'Fault Alarm': 'Сигнализация неисправности',
            Monitoring: 'Контроль',
            'Advanced Reporting': 'Расширенная отчетность',
            'Knowledge Base': 'База знаний',
            'Energy Category Data': 'Категория «Энергия»',
            'Energy Item Data': 'Энергетический элемент',
            Carbon: 'Выбросы CO2',
            Cost: 'Стоить',
            Output: 'Выпуск',
            Income: 'Доход',
            Efficiency: 'Эффективность',
            Load: 'Груз',
            Statistics: 'Статистика',
            'Batch Analysis': 'Пакетный анализ',
            Saving: 'Спасительный',
            Plan: 'План',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Отслеживание оборудования',
            'Equipment Comparison': 'Сравнение оборудования',
            'Shopfloor Comparison': 'Сравнение оборудования',
            'Store Comparison': 'Сравнение оборудования',
            'Space Comparison': 'Сравнение оборудования',
            'Combined Equipment Comparison': 'Сравнение оборудования',
            'Tenant Comparison': 'сравнение арендаторов',
            'Environment Monitor': 'Монитор окружающей среды',
            'Meter Energy': 'Счетчик энергии',
            'Meter Carbon': 'Выбросы CO2 по приборам',
            'Meter Cost': 'Стоимость счетчика',
            'Meter Trend': 'Тренд счетчика',
            'Meter Realtime': 'Счетчик в реальном времени',
            'Meter Saving': 'Экономия счетчиков',
            'Meter Plan': 'Метрический план',
            'Master Meter Submeters Balance': 'Весы счетчиков Master Meter',
            'Meter Batch Analysis': 'Пакетный анализ счетчиков',
            'Meter Comparison': 'Сравнение счетчиков',
            'Meter Tracking': 'Слежение за счетчиком',
            'Virtual Meter Saving': 'Экономия виртуальных счетчиков',
            'Virtual Meter Plan': 'План виртуального счетчика',
            'Virtual Meter Energy': 'Виртуальный счетчик энергии',
            'Virtual Meter Carbon': 'Выбросы CO2 виртуальными приборами',
            'Virtual Meter Cost': 'Стоимость виртуального счетчика',
            'Virtual Meter Batch Analysis': 'Анализ партии виртуальных счетчиков',
            'Virtual Meter Comparison': "Сравнение виртуальных счетчиков",
            'Offline Meter Energy': 'Автономный счетчик энергии',
            'Offline Meter Carbon': 'Выбросы CO2 из автономных приборов',
            'Offline Meter Cost': 'Стоимость автономного счетчика',
            'Offline Meter Batch Analysis': 'Автономный пакетный анализ счетчиков',
            'Offline Meter Saving': 'Автономное сохранение счетчиков',
            'Offline Meter Plan': 'План автономного счетчика',
            'Offline Meter Input': 'Автономный вход счетчика',
            'Tenant Bill': 'Счет арендатора',
            'Energy Flow Diagram': 'Диаграмма потоков энергии',
            'Distribution System': 'Система дистрибуции',
            'SVG System': 'Система визуализации SCADA',
            'Faults Data': 'Ошибки',
            'Space Equipments': 'Космическое оборудование',
            'Combined Equipments': 'Комбинированное оборудование',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Общее количество заказов на работу',
            'Number of New Work Orders': 'Количество новых заказов на работу',
            'Number of Inprogress Work Orders': 'Количество незавершенных заказов на работу',
            'Number of Done Work Orders': 'Количество выполненных заказов на работу',
            'Fuel Indicator': 'Потребление топлива',
            'Charge Energy Indicator': 'Зарядка энергии',
            'Discharge Energy Indicator': 'Разрядка энергии',
            'Charge Cost Indicator': 'Стоимость зарядки',
            'Discharge Revenue Indicator': 'Доход от разрядки',
            'HVAC': 'HVAC',
            'Fire Control': 'Пожарная безопасность',

            // Dashboard
            'Welcome to MyEMS': 'Добро пожаловать в MyEMS',
            'An Industry Leading Open Source Energy Management System':
                'Ведущая в отрасли система управления энергопотреблением с открытым исходным кодом',
            "This Year's Consumption CATEGORY VALUE UNIT": 'В этом году Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Расходы этого года {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Потребление в этом месяце {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Расходы за этот месяц {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Потребление {{CATEGORY}} {{VALUE}} {{UNIT}} за аналогичный период прошлого года',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Издержки {{CATEGORY}} {{VALUE}} {{UNIT}} за аналогичный период прошлого года',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Потребление {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Издержки {{UNIT}}',
            // Entities
            Space: 'Пространство',
            Equipment: 'Оборудование',
            Meter: 'Метр',
            'Offline Meter': 'Автономный счетчик',
            'Virtual Meter': 'Виртуальный счетчик',
            Tenant: 'Съёмщик',
            Store: 'Магазин',
            Shopfloor: 'Торговый зал',
            'Combined Equipment': 'Комбинированное оборудование',
            'Cost Center': 'Центр затрат',
            Name: 'Имя',
            DisplayName: 'Отображаемое имя',
            UserName: 'Имя пользователя',
            Description: 'Описание',
            'Energy Category': 'Категория «Энергия»',
            'Child Spaces': 'Детские пространства',
            'Associated Equipment': 'Сопутствующее оборудование',
            //Energy Categories
            Electricity: 'Электричество',
            Water: 'Вода',
            'Natural Gas': 'Природный газ',
            // SidePanelModal
            Settings: 'Параметры',
            'Set your own customized style': 'Установите свой собственный стиль',
            'Color Scheme': 'Цветовая схема',
            'Choose the perfect color mode for your app': 'Выберите идеальный цветовой режим для вашего приложения',
            Light: 'Свет',
            Dark: 'Темный',
            'RTL Mode': 'Режим RTL',
            'Switch your language direction': 'Переключение языкового направления',
            'Fluid Layout': 'Плавная компоновка',
            'Toggle container layout system': 'Переключить систему компоновки контейнеров',
            'Navigation Position': 'Навигационное положение',
            'Vertical': 'Вертикально',
            'Top': 'Верхний',
            'Combo': 'Комбинация',
            'Transparent': 'Прозрачный',
            'Inverted': 'Перевёрнутый',
            'Card': 'Карточный',
            'Vibrant': 'Живой',
            'Select a suitable navigation system for your web application':
                'Выберите подходящую навигационную систему для вашего веб-приложения',
            'Vertical Nav': 'Вертикальная навигация',
            'Top Nav': 'Наверх Навигатор',
            'Vertical Navbar Style': 'Вертикальный стиль навигационной панели',
            'Switch between styles for your vertical navbar': 'Переключение между стилями для вертикальной панели навигации',
            Language: 'Язык',
            'Switch between languages': 'Переключение между языками',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Нравится то, что вы видите?',
            'Get MyEMS now': 'Получить MyEMS прямо сейчас',
            Purchase: 'Корпоративная версия',
            ContactInfo: 'Контактная информация',
            ProductWebsite: 'Сайт продукта',
            CompanyWebsite: 'Сайт компании',
            SalesPhone: 'Телефон отдела продаж',
            // Query Panel
            'Base Period Begins': 'Начинается базовый период',
            'Base Period Ends': 'Базовый период заканчивается',
            'Comparison Types': 'Типы сравнения',
            'Year-Over-Year': 'Год к году',
            'Month-On-Month': 'Месяц за месяцем',
            'Free Comparison': 'Бесплатное сравнение',
            'None Comparison': 'Нет сравнения',
            'Reporting Period Begins': 'Начало отчетного периода',
            'Reporting Period Ends': 'Окончание отчетного периода',
            '(Optional)': '(Необязательный)',
            'Period Types': 'Типы периодов',
            Yearly: 'Ежегодный',
            Monthly: 'Ежемесячный',
            Weekly: 'Еженедельный',
            Daily: 'Ежедневный',
            Hourly: 'Ежечасный',
            Submit: 'Отправить',
            'Input Energy Category': 'Категория входной энергии',
            'Output Energy Category': 'Категория выходной энергии',
            'Fraction Parameter': 'Параметр фракции',
            Search: 'Искать',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'ХОРОШО',
            today: 'Сегодня',
            yesterday: 'Вчера',
            hours: 'Часов',
            minutes: 'Протокол',
            seconds: 'Товары второго сорта',
            last7Days: 'Последние 7 дней',
            'Select Date Range': 'Выберите диапазон дат',
            //Card Summaries and Line Charts
            'Base Period': 'Базовый период',
            'Reporting Period': 'Отчетный период',
            'Per Unit Area': 'На единицу площади',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'На единицу продукции',
            Baseline: 'Базис',
            Actual: 'Действительный',
            'Baseline Value - Actual Value': 'Базовый уровень - Фактический',
            'Average Load': 'Средняя нагрузка',
            'Maximum Load': 'Максимальная нагрузка',
            'Load Factor': 'Коэффициент загрузки',
            'Ratio of Average Load to Maximum Load': 'Отношение средней нагрузки к максимальной нагрузке',
            'Carbon Dioxide Emissions by Energy Category': 'Выбросы углекислого газа по энергетическим категориям',
            'Costs by Energy Category': 'Затраты по энергетическим категориям',
            'Incomes by Energy Category': 'Доходы по энергетическим категориям',
            'Electricity Consumption by Time-Of-Use': 'Потребление электроэнергии по времени использования',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use':
                'Выбросы углекислого газа в электроэнергетике по времени использования',
            'Electricity Cost by Time-Of-Use': 'Стоимость электроэнергии по времени использования',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Потребление по энергетическим объектам',
            'Ton of Standard Coal by Energy Category': 'Тонна стандартного угля (ТВК) по энергетическим категориям',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'Тонн выбросов углекислого газа (TCO2E) по энергетическим категориям',
            'Reporting Period Consumption CATEGORY UNIT': 'Потребление за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Потребление за отчетный период {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Потребление за отчетный период{{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Потребление за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Потребление за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT':
                'Потребление за отчетный период {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Потребление за отчетный период {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Потребление за базовый период {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT':
                'Доля дочернего пространства по энергетическим категориям {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Общая доля дочернего пространства',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Выбросы двуокиси углерода за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Выбросы двуокиси углерода за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Выбросы углекислого газа за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Затраты за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Затраты за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Затраты на базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Результаты работы за отчетный период {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{EQUIPMENT}} Результаты работы за отчетный период {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Результаты работы за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT':
                'Результаты работы за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Выходные данные за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Доходы за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Доходы за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Доход за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Совокупный доход за отчетный период {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT':
                'Совокупная эффективность отчетного периода {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Совокупная эффективность отчетного периода {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Совокупная комплексная эффективность отчетного периода {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Совокупная комплексная эффективность отчетного периода {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Базисный период Кумулятивная комплексная эффективность {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Мгновенная эффективность {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Мгновенная эффективность {{UNIT}}',
            'Equipment Efficiency Indicator': 'Показатель энергоэффективности оборудования',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Мгновенная комплексная эффективность {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT':
                'Совокупная эффективность отчетного периода {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Совокупная эффективность отчетного периода {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Кумулятивная эффективность базисного периода {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Кумулятивная эффективность базисного периода {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Базовый период {{CATEGORY}} Максимальная нагрузка {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Отчетный период {{CATEGORY}} Максимальная нагрузка {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Отчетный период {{CATEGORY}} Средняя нагрузка {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Отчетный период {{CATEGORY}} Коэффициент загрузки',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Базовый период {{CATEGORY}} Средняя нагрузка {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Отчетный период {{CATEGORY}} Среднее значение {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Отчетный период {{CATEGORY}} Максимальное значение {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Отчетный период {{CATEGORY}} Минимальное значение {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Отчетный период {{CATEGORY}} Среднее арифметическое {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Отчетный период {{CATEGORY}} Медиана (Среднее значение) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Отчетный период {{CATEGORY}} Стандартное отклонение образца {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Отчетный период {{CATEGORY}} Дисперсия выборки {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Сохранение отчетного периода {{CATEGORY}} (Базовый уровень - Фактический) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Отчетный период сократился {{CATEGORY}} (Базовый уровень - Фактический) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Сохранение отчетного периода {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Экономия за базовый период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Потребление эталонного счетчика за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Потребление эталонного счетчика за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Потребление субсчетчиков за отчетный период {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Потребление субсчетчиков за отчетный период {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Разница в отчетных периодах {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Разница в процентах за отчетный период',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Разница в отчетных периодах {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Значения тренда',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Список неисправностей',
            'Reporting Period Number of Fault VALUE': 'Номер неисправности за отчетный период {{VALUE}}',
            'All Faults': 'Все неисправности',
            'Space Faults': 'Космические разломы',
            'Number of All Faults': 'Количество всех неисправностей',
            'Number of Space Faults': 'Количество пробелов',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Тонна стандартного угля',
            'Ton of Carbon Dioxide Emissions': 'тонн выбросов углекислого газа',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Выбросы углерода на единицу потребления энергии',
            'Operating Characteristic Curve': 'рабочая характеристика',
            Tariff: 'Тариф',
            'Detailed Data': 'Подробные данные',
            'Child Spaces Data': 'Данные о дочерних пространствах',
            'Associated Equipment Data': 'Связанные данные об оборудовании',
            'This Year': 'В этом году',
            'The Same Period Last Year': 'Аналогичный период прошлого года',
            'This Month': 'В этом месяце',
            'This Day': 'Сегодня',
            Total: 'Итог',
            'No data found': 'Данные не найдены',
            Export: 'Экспорт',
            Datetime: 'Дата и время',
            'Time-Of-Use Type': 'Тип времени использования',
            'Top-Peak': 'Топ-Пик',
            'On-Peak': 'На пике',
            'Mid-Peak': 'Мид-Пик',
            'Off-Peak': 'Вне пика',
            'Deep': 'Deep-Valley',
            Percentage: 'Процент',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Тренд в последний час Energy Value Point',
            Circuit: 'Контур',
            Point: 'Точка',
            'Realtime Value': 'Значение в реальном времени',
            //Meter Tracking
            'Meter List': 'Список счетчиков',
            'Edit Meter': 'Редактировать',
            'Start Value': 'Начальное значение',
            'End Value': 'Конечная стоимость',
            'Difference Value': 'Значение разницы',
            'Start Integrity Rate': 'Начальный уровень целостности(%)',
            'End Integrity Rate': 'Конечная степень целостности(%)',
            'Full Integrity Rate': 'Полная степень целостности(%)',
            //Equipment Tracking
            'Equipment List': 'Список оборудования',
            'Edit Equipment': 'Редактировать',
            //Profile Dropdown
            Feedback: 'Обратная связь',
            'Account Settings': 'Настройки учетной записи',
            Logout: 'Выход',
            //Authentication
            'Log in': 'Войти',
            'Email address': 'Адрес электронной почты',
            'Phone Number': 'Номер телефона',
            Password: 'Пароль',
            CaptchaCode: 'Капча',
            Refresh: 'Освежать',
            'Remember me': 'Помни обо мне',
            'Logged in as ': 'Авторизовался как ',
            'Forgot Password?': 'Забыли пароль?',
            'Forgot your password?': 'Забыли пароль?',
            "Enter your email and we'll send you a reset link":
                'Введите свой адрес электронной почты, и мы вышлем вам ссылку для сброса',
            "Enter your email and we'll send you a registration link":
                'Введите свой адрес электронной почты, и мы вышлем вам ссылку для регистрации',
            'Reset Password': 'Сброс пароля',
            'Thanks for using MyEMS!': 'Спасибо за использование MyEMS!',
            'You are now successfully signed out': 'Теперь вы успешно вышли из системы',
            'Return to Login': 'Вернуться к входу в систему',
            'Please check your email!': 'Пожалуйста, проверьте свою электронную почту!',
            'An email has been sent to ': 'Электронное письмо было отправлено по адресу ',
            'Please click on the included link to reset your password':
                'Пожалуйста, нажмите на прилагаемую ссылку, чтобы сбросить пароль',
            'Please click on the included link to register your account':
                'Пожалуйста, нажмите на прилагаемую ссылку, чтобы зарегистрировать свою учетную запись',
            'An email with password reset link is sent to ':
                'Электронное письмо со ссылкой для сброса пароля отправляется на адрес ',
            'Change Password': 'Смена пароля',
            'Old Password': 'Старый пароль',
            'New Password': 'Новый пароль',
            'Confirm Password': 'Подтвердите пароль',
            'Update Password': 'Обновить пароль',
            'Password has been changed!': 'Пароль был изменен!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Код подтверждения был отправлен на ваш почтовый ящик. \
      Скопируйте его в поле ввода ниже.',
            'New to MyEMS': 'Новичок в MyEMS',
            'Create an account': 'Создать аккаунт',
            'EMAIL Account registration successful': '{{EMAIL}} Регистрация аккаунта прошла успешно',
            'Thanks for verifying your account!': 'Спасибо за подтверждение вашей учетной записи!',
            'Your code is': 'Ваш код:',
            'Send verification code': 'Отправить проверочный код',
            'Please wait for NUMBER seconds': 'Пожалуйста, подождите {{NUMBER}} товары второго сорта',
            'Password reset': 'Сброс пароля',
            'Please wait for approval': 'Пожалуйста, дождитесь одобрения',
            //notification
            Notifications: 'Уведомления',
            'Mark all as read': 'Пометить все как прочитанное',
            'View all': 'Bce',
            'Notification New': 'Новые функции',
            'Notification Earlier': 'РАНЬШЕ',
            'Notification List': 'Список уведомлений',
            'Bulk actions': 'Массовые действия',
            'Notification Subject': 'Тема',
            'Notification Created Datetime': 'Дата и время создания',
            'Notification Priority': 'Приоритет',
            'Notification Message': 'Сообщение',
            'Notification Status': 'Статус',
            'Notification Mark As Read': 'Отметить как прочитанное',
            'Notification Mark As Acknowledged': 'Признавать',
            'Notification Low': 'Низкий',
            'Notification Medium': 'Терпимая',
            'Notification High': 'Высокий',
            'Notification Critical': 'Критический',
            'Notification Unread': 'Непрочитанный',
            'Notification Read': 'Читать',
            'Notification Acknowledged': 'Признанный',
            'Notification Archive': 'Архив',
            'Notification Delete': 'Удалить',
            'Notification Apply': 'Применять',
            'Notification Start Datetime': 'Дата и время начала',
            'Notification End Datetime': 'Конец даты и времени',
            'Notification Update Datetime': 'Обновить дату и время',
            //Monitoring
            'Run Commands': 'Выполнение команд',
            'Pin Code': 'Пин-код',
            'Unlock': 'Разблокировать',
            'Set Value': 'Установить значение',
            'Fault Alarms': 'Аварийные сигналы о неисправностях',
            'Instantaneous Efficiency VALUE UNIT': 'Мгновенная эффективность {{VALUE}} {{UNIT}}',
            'Communication Online': 'Онлайн',
            'Communication Offline': 'Автономный',
            'Equipment Status': 'Состояние оборудования',
            'Equipment Running': 'Бег',
            'Equipment Stopped': 'Остановленный',
            'Show Up to': 'Показать до',
            All: 'Все',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} из {{TOTAL}} Оборудования',
            //Microgrid
            'Microgrid Energy': 'Микросетевая энергетика',
            'Microgrid Revenue': 'Доход от микросетей',
            'Microgrid Carbon': 'Углерод от микросетей',
            'Photovoltaic Generation': 'Фотоэлектрическая генерация',
            'EV Charger Consumption': 'Потребление зарядных устройств EV',
            'Load Consumption': 'Потребление нагрузки',
            'Grid Buy': 'Покупка из сети',
            'Grid Sell': 'Продажа в сеть',
            'EV Charger': 'Зарядное устройство для электромобилей',
            'Heat Pump': 'Тепловой насос',
            'Photovoltaic': 'Фотоэлектрические',
            'PCS Run State': 'Режим работы PCS',
            'PCS Unknown': 'Неизвестный',
            'PCS Initializing': 'Начинается',
            'PCS Standby': 'Запасные материалы',
            'PCS Shutdown': 'Остановка',
            'PCS Fault': 'Ошибка',
            'PCS Running': 'Бег',
            'Battery Power': 'Мощность батареи',
            'Photovoltaic Power': 'Фотоэлектрическая мощность',
            'Grid Power': 'Мощность сети',
            'Load Power': 'мощность нагрузки',
            Reporting: 'Доклады',
            Maintenance: 'Техническое обслуживание',
            'Serial Number': 'Серийный номер',
            Address: 'Адрес',
            'Postal Code': 'Почтовый индекс',
            'Rated Capacity': 'Номинальная емкость',
            'Rated Power': 'Номинальная мощность',
            Latitude: 'Широта',
            Longitude: 'Долгота',
            'Strategy Management': 'Стратегическое управление',
            'Charging Schedule': 'График зарядки',
            'Charge Start Time': 'Время начала зарядки',
            'Charge End Time': 'Время окончания зарядки',
            'Discharge Start Time': 'Время начала разряда',
            'Discharge End Time': 'Время окончания разряда',
            'Total Rated Power': 'Общая номинальная мощность',
            'Total Rated Capacity': 'Общая номинальная мощность',
            "Today's Charge": "Сегодняшняя сумма начисления",
            "Today's Discharge": "Выписка сегодня",
            "Today's Generation": "Современная энергетика",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Полный заряд',
            'Total Discharge': 'общий сброс',
            'Total Generation': 'Общая генерация',
            'Total Revenue': 'Общий доход',
            'Total Photovoltaic Generation': 'Общая фотоэлектрическая генерация',
            'Total EV Charger Consumption': 'Общее потребление зарядных устройств EV',
            'Total Load Consumption': 'Общее потребление нагрузки',
            'Total Grid Buy': 'Общая покупка из сети',
            'Total Grid Sell': 'Общая продажа в сеть',
            'Total Efficiency': 'Общая эффективность',
            'Discharge Achievement Rate': 'Скорость достижения разряда',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Рейтинг доходов',
            'Efficiency Ranking': 'Рейтинг эффективности',
            'Charge Ranking': 'Рейтинг зарядной емкости',
            'Discharge Ranking': 'Рейтинг разряда',
            'Number of Microgrids': 'Количество микросетей',
            'Number of Power Stations': 'Количество электростанций',
            'Microgrid List': 'Список микросетей',
            'Select Microgrid': 'Выбрать микросеть',
            'Previous Page': 'Предыдущая страница',
            'Next Page': 'Следущая страница',
            '7 Days': '7 дней',
            'Charge UNIT': 'Заряжать {{UNIT}}',
            'Discharge UNIT': 'увольнять {{UNIT}}',
            'Generation UNIT': 'генерировать электричество {{UNIT}}',
            'Energy Indicator': 'Энергетика',
            'Revenue Indicator': 'Поступления',
            'Carbon Indicator': 'Углерод',

            // Energy Storage Power Station
            'Battery Operating State': 'режим работы батареи',
            'Battery State': 'Состояние батареи',
            'Battery Unknown': 'Неизвестный',
            'Battery Stopped': 'Прекращено',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Ошибка', // 1
            'Battery Warning': 'предупреждение', // 2
            'Battery Standby': 'Запасные материалы', // 3
            'Battery Prohibit DisCharging': 'Запрещается выгрузка', // 4
            'Battery Prohibit Charging': 'Зарядка запрещена.', // 5
            'Battery Normal': 'Типичный', // 6
            'Battery Charging': 'Заряжается.', // 7
            'Battery Discharging': 'В разряде.', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Этапы жизненного цикла',
            'Use Phase': 'Этап использования',
            'Commissioning Phase': 'Этап отладки',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Этап установки',
            'Device Status': 'Состояние устройства',
            'Basic Information': 'Основная информация',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'инверторы',
            'Invertor Run State': 'Режим работы',
            'Invertor Unknown': 'Неизвестный',
            'Invertor Initializing': 'Начинается',
            'Invertor Standby': 'Запасные материалы',
            'Invertor Shutdown': 'Остановка',
            'Invertor Fault': 'Ошибка',
            'Invertor Running': 'Бег',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Дата и время создания',
            'File Format': 'Формат файла',
            'File Size': 'Размер файла',
            Uploader: 'Разместил(а)',
            //Error
            "The page you're looking for is not found": 'Страница, которую вы ищете, не найдена',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Убедитесь, что адрес указан правильно и страница не перемещена. ',
            'If you think this is a mistake,': 'Если вы считаете, что это ошибка,',
            'contact us': 'Свяжитесь с нами',
            'Take me home': 'Отвези меня домой',
            'Whoops, something went wrong!': 'Ой, что-то пошло не так!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Попробуйте обновить страницу или вернуться и повторить попытку выполнения. ',
            'If this problem persists,': 'Если проблема не устранена,',
            'Captcha Error': 'Ошибка капчи',
            'Confirm Password Error': 'Пароль подтверждения не совпадает',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Похоже, вы нажали \
      по неверной ссылке для сброса пароля. Пожалуйста, попробуйте еще раз.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Похоже, вы нажали \
      по неверной ссылке на регистрационный аккаунт. Пожалуйста, попробуйте еще раз.',
            //Tenant Bill
            'Lease Contract Number': 'Номер договора аренды',
            Download: 'Загружать',
            Print: 'Печатать',
            'Payment Notice': 'Уведомление об оплате',
            'Bill To': 'Билл К',
            'Bill Number': 'Номер счета',
            'Bill Date': 'Дата выставления счета',
            'Payment Due Date': 'Срок оплаты',
            'Amount Payable': 'Сумма к оплате',
            'Billing Period Start': 'Начало расчетного периода',
            'Billing Period End': 'Окончание расчетного периода',
            Quantity: 'Количество',
            Price: 'Цена',
            Unit: 'Единица',
            Amount: 'Количество',
            Subtotal: 'Промежуточная сумма',
            'VAT Output Tax': 'Налог на добавленную стоимость',
            'Total Amount Payable': 'Общая сумма к оплате',
            'Please make sure to pay on or before the payment due date above':
                'Пожалуйста, убедитесь, что вы оплатили в установленный выше срок оплаты или раньше',
            'Send money to the following account': 'Отправьте деньги на следующий счет',
            'Account Name': 'Имя учетной записи',
            'Bank Name': 'Название банка',
            'Bank Address': 'Адрес банка',
            'RMB Account': 'Счет в юанях',
            // button
            'Toggle Navigation': 'Переключить навигацию',
            // working calendar
            'Working Days': 'Будни',
            'Non Working Days': 'Нерабочие дни',
            'Select Row': 'Пожалуйста, выберите строку данных',
            // Offline Meter Input
            'Daily Value': 'Суточная норма',
            Date: 'Дата',
            'Successfully Saved': 'Успешно сохранено',
            'Previous Data Is Empty': 'Предыдущие данные пусты',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'Недействительное значение автономного счетчика',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Это связано с виртуальной электростанцией.',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Резюме таблиці',
            SubMeter: 'Підтаблиця',
            'Power Quality': 'جودة الطاقة',
            'About Power Quality': 'حول جودة الطاقة',
            'Trend Values': 'قيم الاتجاه',
            Category: 'الفئة',
            Type: 'النوع',
            Unit: 'الوحدة',
            Limit: 'الحد',
            'Normal Limit': 'الحد العادي',
            'Severe Limit': 'الحد الحاد',
            Compliance: 'معدل الامتثال',
            'Worst Deviation': 'أسوأ انحراف',
            'Worst Time': 'وقت أسوأ انحراف',
            'Severe Exceed Count': 'عدد التجاوزات الحادة',
            'Worst Unbalance': 'أقصى عدم توازن',
            Hz: 'هرتز',
            voltage: 'الجهد',
            current: 'التيار',
            frequency: 'التردد',
            voltage_deviation: 'انحراف الجهد',
            current_unbalance: 'عدم توازن التيار',
            voltage_unbalance: 'عدم توازن الجهد',
            mean_deviation_pct: 'متوسط الانحراف (%)',
            p95_abs_deviation_pct: 'انحراف مطلق P95 (%)',
            mean_abs_deviation_hz: 'متوسط الانحراف المطلق (هرتز)',
            frequency_deviation: 'انحراف التردد',
            p95_abs_deviation_hz: 'انحراف مطلق P95 (هرتز)',
            mean_unbalance_pct: 'متوسط عدم التوازن (%)',
            p95_unbalance_pct: 'عدم التوازن P95 (%)',
            count: 'العدد',
            min: 'الحد الأدنى',
            max: 'الحد الأقصى',
            mean: 'المتوسط',
            std: 'الانحراف المعياري',
            p5: 'P5',
            p95: 'P95'
        }
    },
    ar: {
        translation: {
            // routes & menus
            Dashboard: 'لوحه القياده',
            'Space Data': 'فضاء',
            'Equipment Data': 'معدات',
            'Meter Data': 'متر',
            'Tenant Data': 'مستاجر',
            'Store Data': 'دكان',
            'Shopfloor Data': 'شوب فلور',
            'Combined Equipment Data': 'المعدات المشتركة',
            'Auxiliary System': 'النظام المساعد',
            Microgrid: 'الشبكة المصغرة',
            'Energy Storage Power Station': 'محطة توليد الكهرباء',
            'Photovoltaic Power Station': 'محطة توليد الكهرباء',
            'Fault Alarm': 'إنذار الأعطال',
            Monitoring: 'رصد',
            'Advanced Reporting': 'التقارير المتقدمة',
            'Knowledge Base': 'معارف',
            'Energy Category Data': 'فئة الطاقة',
            'Energy Item Data': 'عنصر الطاقة',
            Carbon: 'انبعاثات ثاني أكسيد الكربون',
            Cost: 'كلف',
            Output: 'الناتج',
            Income: 'دخل',
            Efficiency: 'كفاءة',
            Load: 'حمل',
            Statistics: 'الاحصاءات',
            'Batch Analysis': 'تحليل الدفعات',
            Saving: 'حفظ',
            Plan: 'يخطط',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'تتبع المعدات',
            'Equipment Comparison': 'مقارنة المعدات',
            'Shopfloor Comparison': 'مقارنة المعدات',
            'Store Comparison': 'مقارنة المعدات',
            'Space Comparison': 'مقارنة المعدات',
            'Combined Equipment Comparison': 'مقارنة المعدات',
            'Tenant Comparison': 'مقارنة المستأجرين',
            'Environment Monitor': 'مراقب البيئة',
            'Meter Energy': 'طاقة المتر',
            'Meter Carbon': 'متر انبعاثات ثاني أكسيد الكربون',
            'Meter Cost': 'تكلفة المتر',
            'Meter Trend': 'متر الاتجاه',
            'Meter Realtime': 'متر الوقت الحقيقي',
            'Meter Saving': 'توفير العداد',
            'Meter Plan': 'خطة العداد',
            'Master Meter Submeters Balance': 'ماستر ميتر عدادات فرعية الرصيد',
            'Meter Batch Analysis': 'تحليل دفعة العدادات',
            'Meter Comparison': 'مقارنة العدادات',
            'Meter Tracking': 'تتبع العداد',
            'Virtual Meter Saving': 'توفير العداد الافتراضي',
            'Virtual Meter Plan': 'خطة العدادات الافتراضية',
            'Virtual Meter Energy': 'طاقة العداد الافتراضي',
            'Virtual Meter Carbon': 'صك الظاهري انبعاثات ثاني أكسيد الكربون',
            'Virtual Meter Cost': 'تكلفة العداد الافتراضي',
            'Virtual Meter Batch Analysis': 'تحليل دفعة العدادات الافتراضية',
            'Virtual Meter Comparison': "مقارنة العدادات الافتراضية",
            'Offline Meter Energy': 'طاقة العداد غير المتصل بالإنترنت',
            'Offline Meter Carbon': 'انبعاثات ثاني أكسيد الكربون من خط الصك',
            'Offline Meter Cost': 'تكلفة العداد غير متصل',
            'Offline Meter Batch Analysis': 'تحليل دفعة متر غير متصل',
            'Offline Meter Saving': 'توفير عداد دون اتصال',
            'Offline Meter Plan': 'خطة متر دون اتصال',
            'Offline Meter Input': 'إدخال عداد غير متصل',
            'Tenant Bill': 'فاتورة المستأجر',
            'Energy Flow Diagram': 'مخطط تدفق الطاقة',
            'Distribution System': 'نظام التوزيع',
            'SVG System': 'نظام التصور SCADA',
            'Faults Data': 'اخطاء',
            'Space Equipments': 'معدات الفضاء',
            'Combined Equipments': 'المعدات المشتركة',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'إجمالي عدد أوامر العمل',
            'Number of New Work Orders': 'عدد أوامر العمل الجديدة',
            'Number of Inprogress Work Orders': 'عدد أوامر العمل قيد التنفيذ',
            'Number of Done Work Orders': 'عدد أوامر العمل المنجزة',
            'Fuel Indicator': 'استهلاك الوقود',
            'Charge Energy Indicator': 'طاقة الشحن',
            'Discharge Energy Indicator': 'طاقة التفريغ',
            'Charge Cost Indicator': 'تكلفة الشحن',
            'Discharge Revenue Indicator': 'إيرادات التفريغ',
            'HVAC': 'HVAC',
            'Fire Control': 'مكافحة الحرائق',

            // Dashboard
            'Welcome to MyEMS': 'مرحبا بكم في MyEMS',
            'An Industry Leading Open Source Energy Management System': 'نظام إدارة طاقة مفتوح المصدر رائد في الصناعة',
            "This Year's Consumption CATEGORY VALUE UNIT": 'استهلاك هذا العام {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'تكاليف هذا العام {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'استهلاك هذا الشهر {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'تكاليف هذا الشهر {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'استهلاك {{CATEGORY}} {{VALUE}} {{UNIT}} في نفس الفترة من العام الماضي',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'تكاليف {{CATEGORY}} {{VALUE}} {{UNIT}} في نفس الفترة من العام الماضي',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} استهلاك {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} تكاليف {{UNIT}}',
            // Entities
            Space: 'فضاء',
            Equipment: 'معدات',
            Meter: 'متر',
            'Offline Meter': 'عداد غير متصل',
            'Virtual Meter': 'العداد الافتراضي',
            Tenant: 'مستاجر',
            Store: 'دكان',
            Shopfloor: 'شوب فلور',
            'Combined Equipment': 'المعدات المشتركة',
            'Cost Center': 'مركز التكلفة',
            Name: 'اسم',
            DisplayName: 'اسم العرض',
            UserName: 'اسم المستخدم',
            Description: 'وصف',
            'Energy Category': 'فئة الطاقة',
            'Child Spaces': 'مساحات الأطفال',
            'Associated Equipment': 'المعدات المرتبطة',
            //Energy Categories
            Electricity: 'كهرباء',
            Water: 'الماء',
            'Natural Gas': 'الغاز الطبيعي',
            // SidePanelModal
            Settings: 'اعدادات',
            'Set your own customized style': 'حدد أسلوبك المخصص',
            'Color Scheme': 'نظام الألوان',
            'Choose the perfect color mode for your app': 'اختر وضع الألوان المثالي لتطبيقك',
            Light: 'ضوء',
            Dark: 'داكن',
            'RTL Mode': 'وضع RTL',
            'Switch your language direction': 'تبديل اتجاه اللغة',
            'Fluid Layout': 'تخطيط السوائل',
            'Toggle container layout system': 'تبديل نظام تخطيط الحاوية',
            'Navigation Position': 'موقف الملاحة',
            'Vertical': 'عمودي',
            'Top': 'توب .',
            'Combo': 'كومبو',
            'Transparent': 'شفاف',
            'Inverted': 'معكوس',
            'Card': 'بطاقة',
            'Vibrant': 'حيوي',
            'Select a suitable navigation system for your web application': 'حدد نظام ملاحة مناسب لتطبيق الويب الخاص بك',
            'Vertical Nav': 'التنقل العمودي',
            'Top Nav': 'توب ناف',
            'Vertical Navbar Style': 'نمط شريط التنقل العمودي',
            'Switch between styles for your vertical navbar': 'التبديل بين الأنماط لشريط التنقل العمودي',
            Language: 'اللغة',
            'Switch between languages': 'التبديل بين اللغات',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'أعجبك ما تراه?',
            'Get MyEMS now': 'احصل على MyEMS الآن',
            Purchase: 'الطبعة المؤسسة',
            ContactInfo: 'معلومات الاتصال',
            ProductWebsite: 'الموقع الرسمي للمنتج',
            CompanyWebsite: 'الموقع الرسمي للشركة',
            SalesPhone: 'هاتف المبيعات',
            // Query Panel
            'Base Period Begins': 'تبدأ فترة الأساس',
            'Base Period Ends': 'تنتهي فترة الأساس',
            'Comparison Types': 'أنواع المقارنة',
            'Year-Over-Year': 'على أساس سنوي',
            'Month-On-Month': 'على أساس شهري',
            'Free Comparison': 'مقارنة مجانية',
            'None Comparison': 'لا شيء مقارنة',
            'Reporting Period Begins': 'بدء الفترة المشمولة بالتقرير',
            'Reporting Period Ends': 'انتهاء الفترة المشمولة بالتقرير',
            '(Optional)': '(اختياري)',
            'Period Types': 'أنواع الدورة الشهرية',
            Yearly: 'السنويه',
            Monthly: 'شهري',
            Weekly: 'أسبوعي',
            Daily: 'يومي',
            Hourly: 'الساعه',
            Submit: 'إرسال',
            'Input Energy Category': 'فئة طاقة المدخلات',
            'Output Energy Category': 'فئة الطاقة الناتجة',
            'Fraction Parameter': 'معلمة الكسر',
            Search: 'بحث',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'موافق',
            today: 'اليوم',
            yesterday: 'أمس',
            hours: 'الساعات',
            minutes: 'محضر',
            seconds: 'الثواني',
            last7Days: 'آخر 7 أيام',
            'Select Date Range': 'حدد النطاق الزمني',
            //Card Summaries and Line Charts
            'Base Period': 'فترة الأساس',
            'Reporting Period': 'الفترة المشمولة بالتقرير',
            'Per Unit Area': 'لكل وحدة مساحة',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'لكل وحدة إنتاج',
            Baseline: 'الاساس',
            Actual: 'حقيقي',
            'Baseline Value - Actual Value': 'خط الأساس - الفعلي',
            'Average Load': 'متوسط الحمولة',
            'Maximum Load': 'الحمولة القصوى',
            'Load Factor': 'عامل الحمولة',
            'Ratio of Average Load to Maximum Load': 'نسبة متوسط الحمولة إلى الحمولة القصوى',
            'Carbon Dioxide Emissions by Energy Category': 'انبعاثات ثاني أكسيد الكربون حسب فئة الطاقة',
            'Costs by Energy Category': 'التكاليف حسب فئة الطاقة',
            'Incomes by Energy Category': 'الدخل حسب فئة الطاقة',
            'Electricity Consumption by Time-Of-Use': 'استهلاك الكهرباء حسب وقت الاستخدام',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'انبعاثات ثاني أكسيد الكربون الكهربائية حسب وقت الاستخدام',
            'Electricity Cost by Time-Of-Use': 'تكلفة الكهرباء حسب وقت الاستخدام',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} الاستهلاك حسب عناصر الطاقة',
            'Ton of Standard Coal by Energy Category': 'طن من الفحم القياسي (TCE) حسب فئة الطاقة',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'طن من انبعاثات ثاني أكسيد الكربون (TCO2E) حسب فئة الطاقة',
            'Reporting Period Consumption CATEGORY UNIT': 'استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'استهلاك الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'استهلاك فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT':
                'استهلاك الفترة المشمولة بالتقرير {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'استهلاك الفترة المشمولة بالتقرير {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'استهلاك فترة الأساس {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'نسبة مساحة الطفل حسب فئة الطاقة {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'النسبة الإجمالية لمساحة الطفل',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'انبعاثات ثاني أكسيد الكربون في الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'انبعاثات ثاني أكسيد الكربون في الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'انبعاثات ثاني أكسيد الكربون في فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'تكاليف الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'تكاليف الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'تكاليف فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'ناتج فترة التقرير {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} ناتج فترة التقرير {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} ناتج فترة التقرير {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'ناتج فترة التقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'ناتج فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'إيرادات الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'إيرادات الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'إيرادات فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'الفترة المشمولة بالتقرير إجمالي الدخل {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT':
                'الكفاءة التراكمية للفترة المشمولة بالتقرير {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} الكفاءة التراكمية للفترة المشمولة بالتقرير {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} الكفاءة الشاملة التراكمية للفترة المشمولة بالتقرير {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} الكفاءة الشاملة التراكمية للفترة المشمولة بالتقرير {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} فترة الأساس الكفاءة الشاملة التراكمية {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'كفاءة فورية {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} كفاءة فورية {{UNIT}}',
            'Equipment Efficiency Indicator': 'مؤشر كفاءة الطاقة للمعدات',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} كفاءة شاملة فورية {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT':
                'الكفاءة التراكمية للفترة المشمولة بالتقرير {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'الكفاءة التراكمية للفترة المشمولة بالتقرير {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'الكفاءة التراكمية لفترة الأساس {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': 'الكفاءة التراكمية لفترة الأساس {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'فترة الأساس {{CATEGORY}} الحمولة القصوى {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} الحمولة القصوى {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} متوسط الحمولة {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'الفترة المشمولة بالتقرير {{CATEGORY}} عامل الحمولة',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Base Period {{CATEGORY}} متوسط الحمولة {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} متوسط القيمة {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} القيمة القصوى {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} الحد الأدنى للقيمة {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} المتوسط الحسابي {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT':
                'الفترة المشمولة بالتقرير {{CATEGORY}} الوسيط (القيمة المتوسطة) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} عينة الانحراف المعياري {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'الفترة المشمولة بالتقرير {{CATEGORY}} تباين العينة {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'توفير الفترة المشمولة بالتقرير {{CATEGORY}} (خط الأساس - الفعلي) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'انخفضت الفترة المشمولة بالتقرير {{CATEGORY}} (خط الأساس - الفعلي) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'توفير الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'توفير فترة الأساس {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'الفترة المشمولة بالتقرير استهلاك العداد الرئيسي {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'الفترة المشمولة بالتقرير استهلاك العداد الرئيسي {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'استهلاك العدادات الفرعية للفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'استهلاك العدادات الفرعية للفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'فرق الفترة المشمولة بالتقرير {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'فرق النسبة المئوية للفترة المشمولة بالتقرير',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'فرق الفترة المشمولة بالتقرير {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'قيم الاتجاه',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'قائمة الأعطال',
            'Reporting Period Number of Fault VALUE': 'الفترة المشمولة بالتقرير عدد الأعطال {{VALUE}}',
            'All Faults': 'جميع الأخطاء',
            'Space Faults': 'أخطاء الفضاء',
            'Number of All Faults': 'عدد جميع الأخطاء',
            'Number of Space Faults': 'عدد أخطاء الفضاء',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'طن من الفحم القياسي',
            'Ton of Carbon Dioxide Emissions': 'طن من انبعاثات ثاني أكسيد الكربون',
            'Carbon Emissions Per Unit Of Energy Consumption': 'انبعاثات الكربون لكل وحدة من استهلاك الطاقة',
            'Operating Characteristic Curve': 'عمل منحنى المميزة',
            Tariff: 'تعريف',
            'Detailed Data': 'بيانات مفصلة',
            'Child Spaces Data': 'بيانات المساحات الفرعية',
            'Associated Equipment Data': 'بيانات المعدات المرتبطة',
            'This Year': 'هذا العام',
            'The Same Period Last Year': 'نفس الفترة من العام الماضي',
            'This Month': 'هذا الشهر',
            'This Day': 'هذا اليوم',
            Total: 'مجموع',
            'No data found': 'لم يتم العثور على بيانات',
            Export: 'تصدير',
            Datetime: 'التاريخ والوقت',
            'Time-Of-Use Type': 'نوع وقت الاستخدام',
            'Top-Peak': 'توب بيك',
            'On-Peak': 'في أوقات الذروة',
            'Mid-Peak': 'منتصف الذروة',
            'Off-Peak': 'خارج أوقات الذروة',
            'Deep': 'Deep-Valley',
            Percentage: 'النسبه المئويه',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'الاتجاه في الساعة الأخيرة من نقطة قيمة الطاقة',
            Circuit: 'الدائره',
            Point: 'نقطة',
            'Realtime Value': 'القيمة في الوقت الحقيقي',
            //Meter Tracking
            'Meter List': 'قائمة العدادات',
            'Edit Meter': 'حرر',
            'Start Value': 'قيمة البداية',
            'End Value': 'القيمة النهائية',
            'Difference Value': 'قيمة الفرق',
            'Start Integrity Rate': 'معدل النزاهة المبدئي(%)',
            'End Integrity Rate': 'معدل النزاهة النهائي(%)',
            'Full Integrity Rate': 'معدل النزاهة الكامل(%)',
            //Equipment Tracking
            'Equipment List': 'قائمة المعدات',
            'Edit Equipment': 'حرر',
            //Profile Dropdown
            Feedback: 'ردود الفعل',
            'Account Settings': 'إعدادات الحساب',
            Logout: 'الخروج',
            //Authentication
            'Log in': 'تسجيل الدخول',
            'Email address': 'عنوان البريد الإلكتروني',
            'Phone Number': 'رقم الهاتف',
            Password: 'شعار',
            CaptchaCode: 'كلمة التحقق',
            Refresh: 'تحديث',
            'Remember me': 'تذكرني',
            'Logged in as ': 'تم تسجيل الدخول باسم ',
            'Forgot Password?': 'نسيت كلمة المرور?',
            'Forgot your password?': 'نسيت كلمة المرور?',
            "Enter your email and we'll send you a reset link": 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين',
            "Enter your email and we'll send you a registration link": 'أدخل بريدك الإلكتروني وسنرسل لك رابط التسجيل',
            'Reset Password': 'إعادة تعيين كلمة المرور',
            'Thanks for using MyEMS!': 'شكرا لاستخدام MyEMS!',
            'You are now successfully signed out': 'لقد قمت الآن بتسجيل الخروج بنجاح',
            'Return to Login': 'العودة إلى تسجيل الدخول',
            'Please check your email!': 'يرجى التحقق من بريدك الإلكتروني!',
            'An email has been sent to ': 'تم إرسال بريد إلكتروني إلى ',
            'Please click on the included link to reset your password':
                'يرجى النقر على الرابط المرفق لإعادة تعيين كلمة المرور الخاصة بك',
            'Please click on the included link to register your account': 'يرجى النقر على الرابط المرفق لتسجيل حسابك',
            'An email with password reset link is sent to ':
                'يتم إرسال بريد إلكتروني يحتوي على رابط إعادة تعيين كلمة المرور إلى ',
            'Change Password': 'تغيير كلمة المرور',
            'Old Password': 'كلمة المرور القديمة',
            'New Password': 'كلمة مرور جديدة',
            'Confirm Password': 'تأكيد كلمة المرور',
            'Update Password': 'تحديث كلمة المرور',
            'Password has been changed!': 'تم تغيير كلمة المرور!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'تم إرسال رمز التحقق إلى صندوق الوارد الخاص بك. \
      يرجى نسخه إلى مربع الإدخال أدناه.',
            'New to MyEMS': 'جديد في MyEMS',
            'Create an account': 'إنشاء حساب',
            'EMAIL Account registration successful': '{{EMAIL}} تم تسجيل الحساب بنجاح',
            'Thanks for verifying your account!': 'شكرا للتحقق من حسابك!',
            'Your code is': 'الرمز الخاص بك هو',
            'Send verification code': 'إرسال رمز التحقق',
            'Please wait for NUMBER seconds': 'يرجى الانتظار {{NUMBER}} الثواني',
            'Password reset': 'إعادة تعيين كلمة المرور',
            'Please wait for approval': 'يرجى انتظار الموافقة',
            //notification
            Notifications: 'الاخطارات',
            'Mark all as read': 'وضع علامة مقروءة على الكل',
            'View all': 'كل',
            'Notification New': 'الجديد',
            'Notification Earlier': 'أسبق',
            'Notification List': 'قائمة الإشعارات',
            'Bulk actions': 'الإجراءات المجمعة',
            'Notification Subject': 'موضوع',
            'Notification Created Datetime': 'تاريخ الإنشاء',
            'Notification Priority': 'أولوية',
            'Notification Message': 'رسالة',
            'Notification Status': 'حالة',
            'Notification Mark As Read': 'وضع علامة كمقروءة',
            'Notification Mark As Acknowledged': 'اعترف',
            'Notification Low': 'منخفض',
            'Notification Medium': 'Medium',
            'Notification High': 'عال',
            'Notification Critical': 'حرج',
            'Notification Unread': 'غير مقروء',
            'Notification Read': 'قرأ',
            'Notification Acknowledged': 'اعترف',
            'Notification Archive': 'أرشيف',
            'Notification Delete': 'حذف',
            'Notification Apply': 'طبق',
            'Notification Start Datetime': 'بدء التاريخ والوقت',
            'Notification End Datetime': 'تاريخ الانتهاء',
            'Notification Update Datetime': 'تحديث التاريخ والوقت',
            //Monitoring
            'Run Commands': 'تشغيل الأوامر',
            'Pin Code': 'الرمز البريدي',
            'Unlock': 'فتح',
            'Set Value': 'تعيين القيمة',
            'Fault Alarms': 'إنذارات الأعطال',
            'Instantaneous Efficiency VALUE UNIT': 'كفاءة فورية {{VALUE}} {{UNIT}}',
            'Communication Online': 'عبر الإنترنت',
            'Communication Offline': 'دون اتصال',
            'Equipment Status': 'حالة الجهاز',
            'Equipment Running': 'تشغيل',
            'Equipment Stopped': 'توقف',
            'Show Up to': 'احضر إلى',
            All: 'كل',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} من {{TOTAL}} المعدات',
            //Microgrid
            'Microgrid Energy': 'طاقة الشبكة الصغيرة',
            'Microgrid Revenue': 'إيرادات الشبكة الصغيرة',
            'Microgrid Carbon': 'كربون الشبكة الصغيرة',
            'Photovoltaic Generation': 'الجيل الكهروضوئي',
            'EV Charger Consumption': 'استهلاك شواحن السيارات الكهربائية',
            'Load Consumption': 'استهلاك الحمل',
            'Grid Buy': 'شراء من الشبكة',
            'Grid Sell': 'بيع للشبكة',
            'EV Charger': 'شاحن السيارة الكهربائية',
            'Heat Pump': 'مضخة الحرارة',
            'Photovoltaic': 'الطاقة الكهروضوئية',
            'PCS Run State': 'جهاز الدولة',
            'PCS Unknown': 'غير معروف',
            'PCS Initializing': 'تهيئة',
            'PCS Standby': 'المواد الاحتياطية',
            'PCS Shutdown': 'توقف',
            'PCS Fault': 'خطأ',
            'PCS Running': 'تشغيل .',
            'Battery Power': 'طاقة البطارية',
            'Photovoltaic Power': 'الطاقة الضوئية',
            'Grid Power': 'قوة الشبكة',
            'Load Power': 'تحميل السلطة',
            Reporting: 'تقرير .',
            Maintenance: 'الرقم المتسلسل',
            'Serial Number': 'الرقم المتسلسل',
            Address: 'العنوان',
            'Postal Code': 'الرمز البريدي',
            'Rated Capacity': 'تصنيف القدرات',
            'Rated Power': 'تصنيف السلطة',
            Latitude: 'خط العرض',
            Longitude: 'خط الطول',
            'Strategy Management': 'الإدارة الاستراتيجية',
            'Charging Schedule': 'جدول الشحن',
            'Charge Start Time': 'شحن وقت البدء',
            'Charge End Time': 'شحن نهاية الوقت',
            'Discharge Start Time': 'وقت بدء التفريغ',
            'Discharge End Time': 'أداء نهاية الوقت',
            'Total Rated Power': 'إجمالي الطاقة المقدرة',
            'Total Rated Capacity': 'إجمالي السعة المقدرة',
            "Today's Charge": "مبلغ الشحن اليوم",
            "Today's Discharge": "التفريغ اليوم",
            "Today's Generation": "توليد الطاقة اليوم",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'القيمة الاجمالية',
            'Total Discharge': 'التفريغ الكلي',
            'Total Generation': 'الجيل الإجمالي',
            'Total Revenue': 'إجمالي الإيرادات',
            'Total Photovoltaic Generation': 'إجمالي الجيل الكهروضوئي',
            'Total EV Charger Consumption': 'إجمالي استهلاك شاحن EV',
            'Total Load Consumption': 'إجمالي استهلاك الحمل',
            'Total Grid Buy': 'إجمالي الشراء من الشبكة',
            'Total Grid Sell': 'إجمالي البيع للشبكة',
            'Total Efficiency': 'الكفاءة الكلية',
            'Discharge Achievement Rate': 'معدل إنجاز التفريغ',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'تصنيف الإيرادات',
            'Efficiency Ranking': 'تصنيف الكفاءة',
            'Charge Ranking': 'تصنيف توليد الطاقة',
            'Discharge Ranking': 'تصنيف التفريغ',
            'Number of Microgrids': 'عدد الشبكات الصغيرة',
            'Number of Power Stations': 'عدد محطات الطاقة',
            'Microgrid List': 'قائمة ميكروغريد',
            'Select Microgrid': 'اختر ميكروغريد',
            'Previous Page': 'الصفحة السابقة',
            'Next Page': 'الصفحة التالية',
            '7 Days': '7 أيام',
            'Charge UNIT': 'تكلفة {{UNIT}}',
            'Discharge UNIT': 'تسريح {{UNIT}}',
            'Generation UNIT': 'توليد الكهرباء {{UNIT}}',
            'Energy Indicator': 'الطاقة',
            'Revenue Indicator': 'دخل',
            'Carbon Indicator': 'كربون',

            // Energy Storage Power Station
            'Battery Operating State': 'حالة البطارية',
            'Battery State': 'حالة البطارية',
            'Battery Unknown': 'غير معروف',
            'Battery Stopped': 'توقف',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'خطأ', // 1
            'Battery Warning': 'حذر', // 2
            'Battery Standby': 'المواد الاحتياطية', // 3
            'Battery Prohibit DisCharging': 'تعطيل إلغاء', // 4
            'Battery Prohibit Charging': 'حظر شحن', // 5
            'Battery Normal': 'نموذجي', // 6
            'Battery Charging': 'شحن', // 7
            'Battery Discharging': 'في التفريغ', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'مراحل دورة الحياة',
            'Use Phase': 'استخدام المرحلة',
            'Commissioning Phase': 'مرحلة التصحيح',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'مرحلة التثبيت',
            'Device Status': 'حالة الجهاز',
            'Basic Information': 'المعلومات الأساسية',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'العاكسون',
            'Invertor Run State': 'جهاز الدولة',
            'Invertor Unknown': 'غير معروف',
            'Invertor Initializing': 'تهيئة',
            'Invertor Standby': 'المواد الاحتياطية',
            'Invertor Shutdown': 'توقف',
            'Invertor Fault': 'خطأ',
            'Invertor Running': 'تشغيل .',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'تاريخ الإنشاء',
            'File Format': 'تنسيق الملف',
            'File Size': 'حجم الملف',
            Uploader: 'رافع',
            //Error
            "The page you're looking for is not found": 'لم يتم العثور على الصفحة التي تبحث عنها',
            "Make sure the address is correct and that the page hasn't moved. ": 'تأكد من صحة العنوان وعدم نقل الصفحة. ',
            'If you think this is a mistake,': 'إذا كنت تعتقد أن هذا خطأ,',
            'contact us': 'اتصل بنا',
            'Take me home': 'خذني إلى المنزل',
            'Whoops, something went wrong!': 'عذرا ، حدث خطأ ما!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'حاول تحديث الصفحة، أو الرجوع ومحاولة اتخاذ الإجراء مرة أخرى. ',
            'If this problem persists,': 'إذا استمرت هذه المشكلة,',
            'Captcha Error': 'خطأ كلمة التحقق',
            'Confirm Password Error': 'تأكيد كلمة المرور غير متطابق',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'يبدو أنك نقرت \
      على رابط إعادة تعيين كلمة المرور غير صالح. يرجى المحاولة مرة أخرى.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'يبدو أنك نقرت \
      على رابط حساب تسجيل غير صالح. يرجى المحاولة مرة أخرى.',
            //Tenant Bill
            'Lease Contract Number': 'رقم عقد الإيجار',
            Download: 'تحميل',
            Print: 'طبع',
            'Payment Notice': 'إشعار الدفع',
            'Bill To': 'بيل إلى',
            'Bill Number': 'رقم الفاتورة',
            'Bill Date': 'تاريخ الفاتورة',
            'Payment Due Date': 'تاريخ استحقاق الدفع',
            'Amount Payable': 'المبلغ المستحق الدفع',
            'Billing Period Start': 'بدء فترة الفوترة',
            'Billing Period End': 'نهاية فترة الفوترة',
            Quantity: 'كم',
            Price: 'ثمن',
            Unit: 'وحدة',
            Amount: 'مبلغ',
            Subtotal: 'المجموع الفرعي',
            'VAT Output Tax': 'ضريبة مخرجات ضريبة القيمة المضافة',
            'Total Amount Payable': 'إجمالي المبلغ المستحق الدفع',
            'Please make sure to pay on or before the payment due date above':
                'يرجى التأكد من الدفع في أو قبل تاريخ استحقاق الدفع أعلاه',
            'Send money to the following account': 'إرسال الأموال إلى الحساب التالي',
            'Account Name': 'اسم الحساب',
            'Bank Name': 'اسم البنك',
            'Bank Address': 'عنوان البنك',
            'RMB Account': 'حساب الرنمينبي',
            // button
            'Toggle Navigation': 'تبديل التنقل',
            // working calendar
            'Working Days': 'أيام العمل',
            'Non Working Days': 'أيام العطلة',
            'Select Row': 'الرجاء اختيار صف البيانات',
            // Offline Meter Input
            'Daily Value': 'القيمة اليومية',
            Date: 'تاريخ',
            'Successfully Saved': 'تم الحفظ بنجاح',
            'Previous Data Is Empty': 'البيانات السابقة فارغة',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'قيمة عداد غير متصل غير صالحة',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'مع الظاهري محطة توليد الكهرباء',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'جدول موجز',
            SubMeter: 'تقسيم الجدول',
            'Power Quality': 'Chất lượng điện năng',
            'About Power Quality': 'Giới thiệu về chất lượng điện năng',
            'Trend Values': 'Giá trị xu hướng',
            Category: 'Danh mục',
            Type: 'Loại',
            Unit: 'Đơn vị',
            Limit: 'Giới hạn',
            'Normal Limit': 'Giới hạn bình thường',
            'Severe Limit': 'Giới hạn nghiêm trọng',
            Compliance: 'Tỷ lệ tuân thủ',
            'Worst Deviation': 'Độ lệch lớn nhất',
            'Worst Time': 'Thời điểm lệch lớn nhất',
            'Severe Exceed Count': 'Số lần vượt nghiêm trọng',
            'Worst Unbalance': 'Mất cân bằng lớn nhất',
            Hz: 'Hz',
            voltage: 'الجهد',
            current: 'التيار',
            frequency: 'التردد',
            voltage_deviation: 'انحراف الجهد',
            current_unbalance: 'عدم توازن التيار',
            voltage_unbalance: 'عدم توازن الجهد',
            mean_deviation_pct: 'متوسط الانحراف (%)',
            p95_abs_deviation_pct: 'انحراف مطلق P95 (%)',
            mean_abs_deviation_hz: 'متوسط الانحراف المطلق (هرتز)',
            p95_abs_deviation_hz: 'انحراف مطلق P95 (هرتز)',
            mean_unbalance_pct: 'متوسط عدم التوازن (%)',
            p95_unbalance_pct: 'عدم التوازن P95 (%)',
            count: 'العدد',
            min: 'الحد الأدنى',
            max: 'الحد الأقصى',
            mean: 'المتوسط',
            std: 'الانحراف المعياري',
            p5: 'P5',
            p95: 'P95'
        }
    },
    vi: {
        translation: {
            // routes & menus
            Dashboard: 'Bảng điều khiển',
            'Space Data': 'Không gian',
            'Equipment Data': 'Thiết bị',
            'Meter Data': 'Mét',
            'Tenant Data': 'Thuê',
            'Store Data': 'Cửa hàng',
            'Shopfloor Data': 'Tầng cửa hàng',
            'Combined Equipment Data': 'Thiết bị kết hợp',
            'Auxiliary System': 'Hệ thống phụ trợ',
            Microgrid: 'Lưới điện siêu nhỏ',
            'Energy Storage Power Station': 'Trạm điện',
            'Photovoltaic Power Station': 'Trạm điện',
            'Fault Alarm': 'Báo động lỗi',
            Monitoring: 'Giám sát',
            'Advanced Reporting': 'Báo cáo nâng cao',
            'Knowledge Base': 'Cơ sở tri thức',
            'Energy Category Data': 'Danh mục năng lượng',
            'Energy Item Data': 'Mục năng lượng',
            Carbon: 'Khí thải CO2',
            Cost: 'Chi phí',
            Output: 'Ra',
            Income: 'Thu nhập',
            Efficiency: 'Hiệu quả',
            Load: 'Tải',
            Statistics: 'Thống kê',
            'Batch Analysis': 'Phân tích hàng loạt',
            Saving: 'Tiết kiệm',
            Plan: 'Kế hoạch',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Theo dõi thiết bị',
            'Equipment Comparison': 'So sánh thiết bị',
            'Shopfloor Comparison': 'So sánh thiết bị',
            'Store Comparison': 'So sánh thiết bị',
            'Space Comparison': 'So sánh thiết bị',
            'Combined Equipment Comparison': 'So sánh thiết bị',
            'Tenant Comparison': 'so sánh người thuê',
            'Environment Monitor': 'Giám sát môi trường',
            'Meter Energy': 'Năng lượng đo',
            'Meter Carbon': 'Thiết bị phát thải CO2',
            'Meter Cost': 'Chi phí đồng hồ đo',
            'Meter Trend': 'Xu hướng đồng hồ đo',
            'Meter Realtime': 'Đồng hồ thời gian thực',
            'Meter Saving': 'Tiết kiệm đồng hồ',
            'Meter Plan': 'Kế hoạch đồng hồ',
            'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
            'Meter Batch Analysis': 'Phân tích hàng loạt đồng hồ',
            'Meter Comparison': 'So sánh đồng hồ',
            'Meter Tracking': 'Theo dõi đồng hồ đo',
            'Virtual Meter Saving': 'Tiết kiệm đồng hồ ảo',
            'Virtual Meter Plan': 'Kế hoạch đồng hồ ảo',
            'Virtual Meter Energy': 'Năng lượng đồng hồ ảo',
            'Virtual Meter Carbon': 'Khí thải CO2 ảo',
            'Virtual Meter Cost': 'Chi phí đồng hồ ảo',
            'Virtual Meter Batch Analysis': 'Phân tích hàng loạt đồng hồ ảo',
            'Virtual Meter Comparison': "So sánh công tơ ảo",
            'Offline Meter Energy': 'Đồng hồ đo năng lượng ngoại tuyến',
            'Offline Meter Carbon': 'Phát thải CO2 cho thiết bị ngoại tuyến',
            'Offline Meter Cost': 'Chi phí đồng hồ ngoại tuyến',
            'Offline Meter Batch Analysis': 'Phân tích hàng loạt đồng hồ ngoại tuyến',
            'Offline Meter Saving': 'Tiết kiệm đồng hồ ngoại tuyến',
            'Offline Meter Plan': 'Gói đồng hồ đo ngoại tuyến',
            'Offline Meter Input': 'Đầu vào đồng hồ ngoại tuyến',
            'Tenant Bill': 'Hóa đơn người thuê nhà',
            'Energy Flow Diagram': 'Sơ đồ dòng năng lượng',
            'Distribution System': 'Hệ thống phân phối',
            'SVG System': 'Hệ thống trực quan hóa SCADA',
            'Faults Data': 'Lỗi',
            'Space Equipments': 'Thiết bị không gian',
            'Combined Equipments': 'Thiết bị kết hợp',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Tổng số lệnh công việc',
            'Number of New Work Orders': 'Số lệnh công việc mới',
            'Number of Inprogress Work Orders': 'Số lệnh công việc đang thực hiện',
            'Number of Done Work Orders': 'Số lệnh công việc đã hoàn thành',
            'Fuel Indicator': 'Tiêu thụ nhiên liệu',
            'Charge Energy Indicator': 'Năng lượng sạc',
            'Discharge Energy Indicator': 'Năng lượng xả',
            'Charge Cost Indicator': 'Chi phí sạc',
            'Discharge Revenue Indicator': 'Doanh thu xả',
            'HVAC': 'HVAC',
            'Fire Control': 'Kiểm soát cháy',

            // Dashboard
            'Welcome to MyEMS': 'Chào mừng bạn đến với MyEMS',
            'An Industry Leading Open Source Energy Management System':
                'Một hệ thống quản lý năng lượng nguồn mở hàng đầu trong ngành',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Tiêu thụ năm nay {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Chi phí năm nay {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Tiêu thụ tháng này {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Chi phí của tháng này {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Tiêu thụ {{CATEGORY}} {{VALUE}} {{UNIT}} cùng kỳ năm ngoái',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Chi phí {{CATEGORY}} {{VALUE}} {{UNIT}} cùng kỳ năm ngoái',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Tiêu thụ {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Chi phí {{UNIT}}',
            // Entities
            Space: 'Không gian',
            Equipment: 'Thiết bị',
            Meter: 'Mét',
            'Offline Meter': 'Đồng hồ ngoại tuyến',
            'Virtual Meter': 'Đồng hồ ảo',
            Tenant: 'Thuê',
            Store: 'Cửa hàng',
            Shopfloor: 'Tầng cửa hàng',
            'Combined Equipment': 'Thiết bị kết hợp',
            'Cost Center': 'Trung tâm chi phí',
            Name: 'Tên',
            DisplayName: 'Tên hiển thị',
            UserName: 'Tên người dùng',
            Description: 'Sự miêu tả',
            'Energy Category': 'Danh mục năng lượng',
            'Child Spaces': 'Không gian trẻ em',
            'Associated Equipment': 'Thiết bị liên quan',
            //Energy Categories
            Electricity: 'Điện',
            Water: 'Nước',
            'Natural Gas': 'Khí thiên nhiên',
            // SidePanelModal
            Settings: 'Cài đặt',
            'Set your own customized style': 'Đặt phong cách tùy chỉnh của riêng bạn',
            'Color Scheme': 'Bảng màu',
            'Choose the perfect color mode for your app': 'Chọn chế độ màu hoàn hảo cho ứng dụng của bạn',
            Light: 'Ánh sáng',
            Dark: 'Tối',
            'RTL Mode': 'Chế độ RTL',
            'Switch your language direction': 'Chuyển hướng ngôn ngữ của bạn',
            'Fluid Layout': 'Bố cục chất lỏng',
            'Toggle container layout system': 'Chuyển đổi hệ thống bố trí container',
            'Navigation Position': 'Vị trí điều hướng',
            'Vertical': 'Dọc',
            'Top': 'Đầu trang',
            'Combo': 'Kết hợp',
            'Transparent': 'Trong suốt',
            'Inverted': 'Đảo ngược',
            'Card': 'Dạng thẻ',
            'Vibrant': 'Sống động',
            'Select a suitable navigation system for your web application':
                'Chọn một hệ thống điều hướng phù hợp cho ứng dụng web của bạn',
            'Vertical Nav': 'Điều hướng dọc',
            'Top Nav': 'Điều hướng hàng đầu',
            'Vertical Navbar Style': 'Kiểu Navbar dọc',
            'Switch between styles for your vertical navbar': 'Chuyển đổi giữa các kiểu cho thanh điều hướng dọc của bạn',
            Language: 'Ngôn ngữ',
            'Switch between languages': 'Chuyển đổi giữa các ngôn ngữ',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Thích những gì bạn thấy?',
            'Get MyEMS now': 'Tải MyEMS ngay bây giờ',
            Purchase: 'Phiên bản doanh nghiệp',
            ContactInfo: 'Thong tin lien he',
            ProductWebsite: 'Website san pham',
            CompanyWebsite: 'Website cong ty',
            SalesPhone: 'So dien thoai ban hang',
            // Query Panel
            'Base Period Begins': 'Thời gian cơ sở bắt đầu',
            'Base Period Ends': 'Thời gian cơ sở kết thúc',
            'Comparison Types': 'Các loại so sánh',
            'Year-Over-Year': 'So với cùng kỳ năm ngoái',
            'Month-On-Month': 'Hàng tháng',
            'Free Comparison': 'So sánh miễn phí',
            'None Comparison': 'Không so sánh',
            'Reporting Period Begins': 'Thời gian báo cáo bắt đầu',
            'Reporting Period Ends': 'Kỳ báo cáo kết thúc',
            '(Optional)': '(Tùy chọn)',
            'Period Types': 'Các loại thời gian',
            Yearly: 'Thường niên',
            Monthly: 'Nguyệt san',
            Weekly: 'Tuần',
            Daily: 'Nhật báo',
            Hourly: 'Giờ',
            Submit: 'Trình',
            'Input Energy Category': 'Danh mục năng lượng đầu vào',
            'Output Energy Category': 'Danh mục năng lượng đầu ra',
            'Fraction Parameter': 'Tham số phân số',
            Search: 'Tìm kiếm',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'OK',
            today: 'Hôm nay',
            yesterday: 'Hôm qua',
            hours: 'Giờ',
            minutes: 'Biên bản',
            seconds: 'Giây',
            last7Days: '7 ngày qua',
            'Select Date Range': 'Chọn Phạm vi ngày',
            //Card Summaries and Line Charts
            'Base Period': 'Thời gian cơ sở',
            'Reporting Period': 'Kỳ báo cáo',
            'Per Unit Area': 'Trên một đơn vị diện tích',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Mỗi đơn vị sản xuất',
            Baseline: 'Baseline',
            Actual: 'Thực tế',
            'Baseline Value - Actual Value': 'Baseline - Thực tế',
            'Average Load': 'Tải trung bình',
            'Maximum Load': 'Tải tối đa',
            'Load Factor': 'Hệ số tải',
            'Ratio of Average Load to Maximum Load': 'Tỷ lệ tải trung bình so với tải tối đa',
            'Carbon Dioxide Emissions by Energy Category': 'Phát thải carbon dioxide theo danh mục năng lượng',
            'Costs by Energy Category': 'Chi phí theo loại năng lượng',
            'Incomes by Energy Category': 'Thu nhập theo loại năng lượng',
            'Electricity Consumption by Time-Of-Use': 'Tiêu thụ điện theo thời gian sử dụng',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Điện phát thải carbon dioxide theo thời gian sử dụng',
            'Electricity Cost by Time-Of-Use': 'Chi phí điện theo thời gian sử dụng',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Tiêu thụ theo các mặt hàng năng lượng',
            'Ton of Standard Coal by Energy Category': 'Tấn than tiêu chuẩn (TCE) theo loại năng lượng',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Tấn khí thải carbon dioxide (TCO2E) theo loại năng lượng',
            'Reporting Period Consumption CATEGORY UNIT': 'Tiêu thụ kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} Tiêu thụ kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Tiêu thụ kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Tiêu thụ kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Tiêu thụ thời gian cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Tiêu thụ kỳ báo cáo {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Tiêu thụ kỳ báo cáo {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Tiêu thụ thời gian cơ sở {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Tỷ lệ không gian trẻ em theo loại năng lượng {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Tổng tỷ lệ không gian trẻ em',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Kỳ báo cáo Phát thải Carbon Dioxide {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Kỳ báo cáo Phát thải Carbon Dioxide {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Thời kỳ cơ sở Phát thải carbon Dioxide {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Chi phí kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Chi phí kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Chi phí giai đoạn cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Sản lượng kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Sản lượng kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Sản lượng kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Sản lượng kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Sản lượng giai đoạn cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Thu nhập kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Thu nhập kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Thu nhập thời kỳ cơ sở {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Kỳ báo cáo Tổng thu nhập {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Kỳ báo cáo Hiệu quả tích lũy {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} Kỳ báo cáo Hiệu quả tích lũy {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Kỳ báo cáo Tích lũy Hiệu quả toàn diện {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Kỳ báo cáo Tích lũy Hiệu quả toàn diện {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Thời gian cơ sở Tích lũy Hiệu quả toàn diện {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Hiệu quả tức thời {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Hiệu quả tức thời {{UNIT}}',
            'Equipment Efficiency Indicator': 'Chỉ số hiệu suất năng lượng của thiết bị',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Hiệu quả toàn diện tức thời {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Kỳ báo cáo Hiệu quả tích lũy {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Kỳ báo cáo Hiệu quả tích lũy {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Thời gian cơ sở Hiệu quả tích lũy {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Thời gian cơ sở Hiệu quả tích lũy {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Thời gian cơ sở {{CATEGORY}} Tải tối đa {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Kỳ báo cáo {{CATEGORY}} Tải tối đa {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Kỳ báo cáo {{CATEGORY}} Tải trung bình {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Kỳ báo cáo {{CATEGORY}} Hệ số tải',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Thời gian cơ sở {{CATEGORY}} Tải trung bình {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Kỳ báo cáo {{CATEGORY}} Giá trị trung bình {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Kỳ báo cáo {{CATEGORY}} Giá trị tối đa {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Kỳ báo cáo {{CATEGORY}} Giá trị tối thiểu {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Kỳ báo cáo {{CATEGORY}} Trung bình số học {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Kỳ báo cáo {{CATEGORY}} Trung tuyến (Giá trị trung bình) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Kỳ báo cáo {{CATEGORY}} Độ lệch chuẩn mẫu {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Kỳ báo cáo {{CATEGORY}} Phương sai mẫu {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Tiết kiệm kỳ báo cáo {{CATEGORY}} (Đường cơ sở - Thực tế) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Kỳ báo cáo giảm {{CATEGORY}} (Đường cơ sở - Thực tế) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Tiết kiệm kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Tiết kiệm thời gian cơ bản {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Kỳ báo cáo Tiêu thụ đồng hồ chính {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Kỳ báo cáo Tiêu thụ đồng hồ chính {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': 'Kỳ báo cáo Tiêu thụ công tơ phụ {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Kỳ báo cáo Tiêu thụ công tơ phụ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Chênh lệch kỳ báo cáo {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Chênh lệch phần trăm kỳ báo cáo',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Chênh lệch kỳ báo cáo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Giá trị xu hướng',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Danh sách lỗi',
            'Reporting Period Number of Fault VALUE': 'Kỳ báo cáo Số lỗi {{VALUE}}',
            'All Faults': 'Tất cả lỗi',
            'Space Faults': 'Lỗi không gian',
            'Number of All Faults': 'Số lượng tất cả các lỗi',
            'Number of Space Faults': 'Số lỗi không gian',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Tấn than tiêu chuẩn',
            'Ton of Carbon Dioxide Emissions': 'Tấn khí thải carbon dioxide',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Lượng khí thải carbon trên mỗi đơn vị tiêu thụ năng lượng',
            'Operating Characteristic Curve': 'Đường cong đặc tính làm việc',
            Tariff: 'Thuế quan',
            'Detailed Data': 'Dữ liệu chi tiết',
            'Child Spaces Data': 'Dữ liệu không gian trẻ em',
            'Associated Equipment Data': 'Dữ liệu thiết bị liên quan',
            'This Year': 'Năm nay',
            'The Same Period Last Year': 'cùng kỳ năm ngoái',
            'This Month': 'Tháng này',
            'This Day': 'Ngày này',
            Total: 'Tất cả',
            'No data found': 'Không tìm thấy dữ liệu',
            Export: 'Xuất khẩu',
            Datetime: 'Ngày giờ',
            'Time-Of-Use Type': 'Loại thời gian sử dụng',
            'Top-Peak': 'Đỉnh cao nhất',
            'On-Peak': 'Vào giờ cao điểm',
            'Mid-Peak': 'Giữa giờ cao điểm',
            'Off-Peak': 'Ngoài giờ cao điểm',
            'Deep': 'Deep-Valley',
            Percentage: 'Tỷ lệ phần trăm',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Xu hướng trong giờ cuối cùng của Điểm giá trị năng lượng',
            Circuit: 'Mạch',
            Point: 'Điểm',
            'Realtime Value': 'Giá trị thời gian thực',
            //Meter Tracking
            'Meter List': 'Danh sách đồng hồ đo',
            'Edit Meter': 'Biên tập',
            'Start Value': 'Giá trị bắt đầu',
            'End Value': 'Giá trị cuối cùng',
            'Difference Value': 'Giá trị chênh lệch',
            'Start Integrity Rate': 'Tỷ lệ toàn vẹn bắt đầu(%)',
            'End Integrity Rate': 'Tỷ lệ toàn vẹn cuối cùng(%)',
            'Full Integrity Rate': 'Tỷ lệ toàn vẹn đầy đủ(%)',
            //Equipment Tracking
            'Equipment List': 'Danh sách thiết bị',
            'Edit Equipment': 'Biên tập',
            //Profile Dropdown
            Feedback: 'Phản hồi',
            'Account Settings': 'Cài đặt tài khoảntrở lại',
            Logout: 'Đăng xuất',
            //Authentication
            'Log in': 'Đăng nhập',
            'Email address': 'Địa chỉ email',
            'Phone Number': 'Số điện thoại',
            Password: 'Mật khẩu',
            CaptchaCode: 'Captcha',
            Refresh: 'Làm tươi',
            'Remember me': 'Ghi nhớ tôi',
            'Logged in as ': 'Đăng nhập với tư cách ',
            'Forgot Password?': 'Quên mật khẩu?',
            'Forgot your password?': 'Quên Mật khẩu?',
            "Enter your email and we'll send you a reset link":
                'Nhập email của bạn và chúng tôi sẽ gửi cho bạn liên kết đặt lại',
            "Enter your email and we'll send you a registration link":
                'Nhập email của bạn và chúng tôi sẽ gửi cho bạn liên kết đăng ký',
            'Reset Password': 'Đặt lại mật khẩu',
            'Thanks for using MyEMS!': 'Cảm ơn bạn đã sử dụng MyEMS!',
            'You are now successfully signed out': 'Bây giờ bạn đã đăng xuất thành công',
            'Return to Login': 'Quay lại Đăng nhập',
            'Please check your email!': 'Vui lòng kiểm tra email của bạn!',
            'An email has been sent to ': 'Một email đã được gửi đến ',
            'Please click on the included link to reset your password':
                'Vui lòng nhấp vào liên kết đi kèm để đặt lại mật khẩu của bạn',
            'Please click on the included link to register your account':
                'Vui lòng nhấp vào liên kết đi kèm để đăng ký tài khoản của bạn',
            'An email with password reset link is sent to ': 'Một email có liên kết đặt lại mật khẩu được gửi đến ',
            'Change Password': 'Thay đổi mật khẩu',
            'Old Password': 'Mật khẩu cũ',
            'New Password': 'Mật khẩu mới',
            'Confirm Password': 'Xác nhận mật khẩu',
            'Update Password': 'Cập nhật mật khẩu',
            'Password has been changed!': 'Mật khẩu đã được thay đổi!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Mã xác minh đã được gửi đến hộp thư đến của bạn. \
      Vui lòng sao chép nó vào hộp nhập liệu bên dưới.',
            'New to MyEMS': 'Bạn mới sử dụng MyEMS',
            'Create an account': 'Tạo tài khoản',
            'EMAIL Account registration successful': '{{EMAIL}} Đăng ký tài khoản thành công',
            'Thanks for verifying your account!': 'Cảm ơn bạn đã xác minh tài khoản của bạn!',
            'Your code is': 'Mã của bạn là',
            'Send verification code': 'Gửi mã xác minh',
            'Please wait for NUMBER seconds': 'Vui lòng chờ đợi {{NUMBER}} Giây',
            'Password reset': 'Đặt lại mật khẩu',
            'Please wait for approval': 'Vui lòng chờ phê duyệt',
            //notification
            Notifications: 'Thông báo',
            'Mark all as read': 'Đánh dấu tất cả là đã đọc',
            'View all': 'Tất cả',
            'Notification New': 'MỚI',
            'Notification Earlier': 'TRƯỚC',
            'Notification List': 'Danh sách thông báo',
            'Bulk actions': 'Hành động hàng loạt',
            'Notification Subject': 'Chủ đề',
            'Notification Created Datetime': 'Ngày giờ đã tạo',
            'Notification Priority': 'Ưu tiên',
            'Notification Message': 'Thông điệp',
            'Notification Status': 'Tình trạng',
            'Notification Mark As Read': 'Đánh dấu là đã đọc',
            'Notification Mark As Acknowledged': 'Thừa nhận',
            'Notification Low': 'Thấp',
            'Notification Medium': 'Đau vừa',
            'Notification High': 'Cao',
            'Notification Critical': 'Nguy kịch',
            'Notification Unread': 'Unread',
            'Notification Read': 'Đọc',
            'Notification Acknowledged': 'Thừa nhận',
            'Notification Archive': 'Lưu trữ',
            'Notification Delete': 'Xóa',
            'Notification Apply': 'Áp dụng',
            'Notification Start Datetime': 'Ngày giờ bắt đầu',
            'Notification End Datetime': 'Ngày kết thúc',
            'Notification Update Datetime': 'Cập nhật ngày giờ',
            //Monitoring
            'Run Commands': 'Chạy lệnh',
            'Pin Code': 'Mã số bưu chính',
            'Unlock': 'Mở khóa',
            'Set Value': 'Đặt giá trị',
            'Fault Alarms': 'Báo động lỗi',
            'Instantaneous Efficiency VALUE UNIT': 'Hiệu quả tức thời {{VALUE}} {{UNIT}}',
            'Communication Online': 'Trực tuyến',
            'Communication Offline': 'Ngoại tuyến',
            'Equipment Status': 'Trạng thái thiết bị',
            'Equipment Running': 'Chạy',
            'Equipment Stopped': 'Dừng lại',
            'Show Up to': 'Hiển thị lên đến',
            All: 'Tất cả',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} của {{TOTAL}} Thiết bị',
            //Microgrid
            'Microgrid Energy': 'Năng lượng lưới điện siêu nhỏ',
            'Microgrid Revenue': 'Doanh thu lưới điện siêu nhỏ',
            'Microgrid Carbon': 'Carbon lưới điện siêu nhỏ',
            'Photovoltaic Generation': 'Sản lượng điện mặt trời',
            'EV Charger Consumption': 'Mức tiêu thụ bộ sạc EV',
            'Load Consumption': 'Mức tiêu thụ tải',
            'Grid Buy': 'Mua từ lưới',
            'Grid Sell': 'Bán cho lưới',
            'EV Charger': 'Bộ sạc EV',
            'Heat Pump': 'Máy bơm nhiệt',
            'Photovoltaic': 'Quang điện',
            'PCS Run State': 'Trạng thái hoạt động PCS',
            'PCS Unknown': 'Không rõ',
            'PCS Initializing': 'Đang khởi tạo',
            'PCS Standby': 'Chờ',
            'PCS Shutdown': 'Tắt máy',
            'PCS Fault': 'Lỗi',
            'PCS Running': 'Chạy',
            'Battery Power': 'Năng lượng pin',
            'Photovoltaic Power': 'Công suất PV',
            'Grid Power': 'Điện lưới',
            'Load Power': 'Tải điện',
            Reporting: 'Báo cáo',
            Maintenance: 'Sửa chữa',
            'Serial Number': 'Số sê-ri',
            Address: 'Địa chỉ',
            'Postal Code': 'Mã bưu điện',
            'Rated Capacity': 'Công suất định mức',
            'Rated Power': 'Công suất định mức',
            Latitude: 'Vĩ độ',
            Longitude: 'Kinh độ',
            'Strategy Management': 'Quản lý chiến lược',
            'Charging Schedule': 'Lịch sạc',
            'Charge Start Time': 'Thời gian bắt đầu sạc',
            'Charge End Time': 'Thời gian sạc kết thúc',
            'Discharge Start Time': 'Thời gian bắt đầu xả',
            'Discharge End Time': 'Thời gian kết thúc xả',
            'Total Rated Power': 'Tổng công suất định mức',
            'Total Rated Capacity': 'Tổng công suất định mức',
            "Today's Charge": "Số tiền tính phí hôm nay",
            "Today's Discharge": "Hôm nay xuất viện",
            "Today's Generation": "Sản xuất điện ngày nay",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Tổng phí',
            'Total Discharge': 'tổng lượng xả',
            'Total Generation': 'Tổng thế hệ',
            'Total Revenue': 'Tổng doanh thu',
            'Total Photovoltaic Generation': 'Tổng sản lượng điện mặt trời',
            'Total EV Charger Consumption': 'Tổng mức tiêu thụ bộ sạc EV',
            'Total Load Consumption': 'Tổng mức tiêu thụ tải',
            'Total Grid Buy': 'Tổng mua từ lưới',
            'Total Grid Sell': 'Tổng bán cho lưới',
            'Total Efficiency': 'Tổng hiệu suất',
            'Discharge Achievement Rate': 'Tỷ lệ thành tích xả',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Xếp hạng doanh thu',
            'Efficiency Ranking': 'Xếp hạng hiệu quả',
            'Charge Ranking': 'Xếp hạng công suất sạc',
            'Discharge Ranking': 'Xếp hạng xả thải',
            'Number of Microgrids': 'Số lượng lưới điện siêu nhỏ',
            'Number of Power Stations': 'Số lượng trạm điện',
            'Microgrid List': 'Danh sách lưới điện siêu nhỏ',
            'Select Microgrid': 'Chọn lưới điện siêu nhỏ',
            'Previous Page': 'Trang trước',
            'Next Page': 'Trang tiếp theo',
            '7 Days': '7 ngày',
            'Charge UNIT': 'Thù lao {{UNIT}}',
            'Discharge UNIT': 'phóng điện {{UNIT}}',
            'Generation UNIT': 'tạo ra điện {{UNIT}}',
            'Energy Indicator': 'Năng lượng',
            'Revenue Indicator': 'Thu nhập',
            'Carbon Indicator': 'Cacbon',

            // Energy Storage Power Station
            'Battery Operating State': 'Trạng thái hoạt động của pin',
            'Battery State': 'Trạng thái pin',
            'Battery Unknown': 'Không rõ',
            'Battery Stopped': 'Đã dừng',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Lỗi', // 1
            'Battery Warning': 'Cảnh báo', // 2
            'Battery Standby': 'Phụ tùng', // 3
            'Battery Prohibit DisCharging': 'Không gỡ cài đặt', // 4
            'Battery Prohibit Charging': 'Không sạc', // 5
            'Battery Normal': 'Đặc trưng', // 6
            'Battery Charging': 'Đang sạc', // 7
            'Battery Discharging': 'Đang xả', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Giai đoạn vòng đời',
            'Use Phase': 'Giai đoạn sử dụng',
            'Commissioning Phase': 'Giai đoạn gỡ lỗi',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Giai đoạn cài đặt',
            'Device Status': 'Trạng thái thiết bị',
            'Basic Information': 'Thông tin cơ bản',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'biến tần',
            'Invertor Run State': 'Trạng thái hoạt động',
            'Invertor Unknown': 'Không rõ',
            'Invertor Initializing': 'Đang khởi tạo',
            'Invertor Standby': 'Chờ',
            'Invertor Shutdown': 'Tắt máy',
            'Invertor Fault': 'Lỗi',
            'Invertor Running': 'Chạy',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Đã tạo Datetime',
            'File Format': 'Định dạng tệp',
            'File Size': 'Kích thước tệp',
            Uploader: 'Trình tải lên',
            //Error
            "The page you're looking for is not found": 'Không tìm thấy trang bạn đang tìm kiếm',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Đảm bảo địa chỉ chính xác và trang chưa di chuyển. ',
            'If you think this is a mistake,': 'Nếu bạn nghĩ rằng đây là một sai lầm,',
            'contact us': 'Liên hệ với chúng tôi',
            'Take me home': 'Đưa tôi về nhà',
            'Whoops, something went wrong!': 'Rất tiếc, đã xảy ra sự cố!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Thử làm mới trang hoặc quay lại và thử lại hành động. ',
            'If this problem persists,': 'Nếu vấn đề này vẫn tiếp diễn,',
            'Captcha Error': 'Lỗi Captcha',
            'Confirm Password Error': 'Mật khẩu xác nhận không khớp',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Có vẻ như bạn đã nhấp vào \
      liên kết đặt lại mật khẩu không hợp lệ. Vui lòng thử lại.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Có vẻ như bạn đã nhấp vào \
      liên kết tài khoản đăng ký không hợp lệ. Vui lòng thử lại.',
            //Tenant Bill
            'Lease Contract Number': 'Số hợp đồng thuê',
            Download: 'Tải xuống',
            Print: 'In',
            'Payment Notice': 'Thông báo thanh toán',
            'Bill To': 'Lập hóa đơn đến',
            'Bill Number': 'Số hóa đơn',
            'Bill Date': 'Ngày lập hóa đơn',
            'Payment Due Date': 'Ngày đến hạn thanh toán',
            'Amount Payable': 'Số tiền phải trả',
            'Billing Period Start': 'Thời hạn thanh toán Bắt đầu',
            'Billing Period End': 'Kết thúc thời hạn thanh toán',
            Quantity: 'Số lượng',
            Price: 'Giá',
            Unit: 'Đơn vị',
            Amount: 'Lượng',
            Subtotal: 'Tổng phụ',
            'VAT Output Tax': 'Thuế đầu ra VAT',
            'Total Amount Payable': 'Tổng số tiền phải trả',
            'Please make sure to pay on or before the payment due date above':
                'Vui lòng đảm bảo thanh toán vào hoặc trước ngày đến hạn thanh toán ở trên',
            'Send money to the following account': 'Gửi tiền vào tài khoản sau',
            'Account Name': 'Tên tài khoản',
            'Bank Name': 'Tên ngân hàng',
            'Bank Address': 'Địa chỉ ngân hàng',
            'RMB Account': 'Tài khoản RMB',
            // button
            'Toggle Navigation': 'Chuyển đổi điều hướng',
            // working calendar
            'Working Days': 'Ngày làm việc',
            'Non Working Days': 'Ngày không làm việc',
            'Select Row': 'Vui lòng chọn Hàng dữ liệu',
            // Offline Meter Input
            'Daily Value': 'Giá trị hàng ngày',
            Date: 'Ngày',
            'Successfully Saved': 'Đã lưu thành công',
            'Previous Data Is Empty': 'Dữ liệu trước đó trống',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'Giá trị đồng hồ ngoại tuyến không hợp lệ',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Mối quan hệ với Virtual Power Plant',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Bảng tổng hợp',
            SubMeter: 'Bảng phụ',
            'Power Quality': 'คุณภาพพลังงานไฟฟ้า',
            'About Power Quality': 'เกี่ยวกับคุณภาพพลังงานไฟฟ้า',
            'Trend Values': 'ค่ากราฟแนวโน้ม',
            Category: 'หมวดหมู่',
            Type: 'ประเภท',
            Unit: 'หน่วย',
            Limit: 'ขีดจำกัด',
            'Normal Limit': 'ขีดจำกัดปกติ',
            'Severe Limit': 'ขีดจำกัดรุนแรง',
            Compliance: 'อัตราการสอดคล้อง',
            'Worst Deviation': 'ค่าความเบี่ยงเบนสูงสุด',
            'Worst Time': 'เวลาที่เบี่ยงเบนสูงสุด',
            'Severe Exceed Count': 'จำนวนครั้งที่เกินรุนแรง',
            'Worst Unbalance': 'ความไม่สมดุลสูงสุด',
            Hz: 'เฮิรตซ์',
            voltage: 'แรงดันไฟฟ้า',
            current: 'กระแสไฟฟ้า',
            frequency: 'ความถี่',
            voltage_deviation: 'ความคลาดเคลื่อนแรงดัน',
            current_unbalance: 'ความไม่สมดุลของกระแส',
            voltage_unbalance: 'ความไม่สมดุลของแรงดัน',
            mean_deviation_pct: 'ความคลาดเคลื่อนเฉลี่ย (%)',
            p95_abs_deviation_pct: 'ความคลาดเคลื่อนสัมบูรณ์ P95 (%)',
            mean_abs_deviation_hz: 'ความคลาดเคลื่อนสัมบูรณ์เฉลี่ย (Hz)',
            p95_abs_deviation_hz: 'ความคลาดเคลื่อนสัมบูรณ์ P95 (Hz)',
            mean_unbalance_pct: 'ความไม่สมดุลเฉลี่ย (%)',
            p95_unbalance_pct: 'ความไม่สมดุล P95 (%)',
            count: 'จำนวน',
            min: 'น้อยสุด',
            max: 'มากสุด',
            mean: 'เฉลี่ย',
            std: 'ส่วนเบี่ยงเบนมาตรฐาน',
            p5: 'P5',
            p95: 'P95'
        }
    },
    th: {
        translation: {
            // routes & menus
            Dashboard: 'แผงหน้าปัด',
            'Space Data': 'อวกาศ',
            'Equipment Data': 'อุปกรณ์',
            'Meter Data': 'เมตร',
            'Tenant Data': 'ผู้เช่า',
            'Store Data': 'ร้าน',
            'Shopfloor Data': 'ชั้นร้านค้า',
            'Combined Equipment Data': 'อุปกรณ์รวม',
            'Auxiliary System': 'ระบบเสริม',
            Microgrid: 'ไมโครกริด',
            'Energy Storage Power Station': 'สถานีไฟฟ้า',
            'Photovoltaic Power Station': 'สถานีไฟฟ้า',
            'Fault Alarm': 'สัญญาณเตือนความผิดพลาด',
            Monitoring: 'ตรวจ สอบ',
            'Advanced Reporting': 'การรายงานขั้นสูง',
            'Knowledge Base': 'ฐานความรู้',
            'Energy Category Data': 'ประเภทพลังงาน',
            'Energy Item Data': 'รายการพลังงาน',
            Carbon: 'การปล่อยก๊าซคาร์บอนไดออกไซด์',
            Cost: 'ค่า',
            Output: 'ผลิตภัณฑ์',
            Income: 'รายได้',
            Efficiency: 'ประสิทธิภาพ',
            Load: 'ภาระ',
            Statistics: 'สถิติ',
            'Batch Analysis': 'การวิเคราะห์แบทช์',
            Saving: 'การประหยัด',
            Plan: 'วางแผน',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'การติดตามอุปกรณ์',
            'Equipment Comparison': 'การเปรียบเทียบอุปกรณ์',
            'Shopfloor Comparison': 'การเปรียบเทียบอุปกรณ์',
            'Store Comparison': 'การเปรียบเทียบอุปกรณ์',
            'Space Comparison': 'การเปรียบเทียบอุปกรณ์',
            'Combined Equipment Comparison': 'การเปรียบเทียบอุปกรณ์',
            'Tenant Comparison': 'เปรียบเทียบผู้เช่า',
            'Environment Monitor': 'การตรวจสอบสภาพแวดล้อม',
            'Meter Energy': 'เครื่องวัดพลังงาน',
            'Meter Carbon': 'มาตรวัดการปล่อย CO2',
            'Meter Cost': 'ค่ามิเตอร์',
            'Meter Trend': 'เทรนด์มิเตอร์',
            'Meter Realtime': 'มิเตอร์เรียลไทม์',
            'Meter Saving': 'ประหยัดมิเตอร์',
            'Meter Plan': 'แผนมิเตอร์',
            'Master Meter Submeters Balance': 'Master Meter Submeters สมดุล',
            'Meter Batch Analysis': 'การวิเคราะห์แบทช์มิเตอร์',
            'Meter Comparison': 'การเปรียบเทียบมิเตอร์',
            'Meter Tracking': 'การติดตามมิเตอร์',
            'Virtual Meter Saving': 'การบันทึกมิเตอร์เสมือน',
            'Virtual Meter Plan': 'แผนมิเตอร์เสมือน',
            'Virtual Meter Energy': 'เครื่องวัดพลังงานเสมือน',
            'Virtual Meter Carbon': 'เสมือนมิเตอร์ปล่อย CO2',
            'Virtual Meter Cost': 'ค่ามิเตอร์เสมือน',
            'Virtual Meter Batch Analysis': 'การวิเคราะห์แบทช์มิเตอร์เสมือน',
            'Virtual Meter Comparison': "การเปรียบเทียบมิติเสมือน",
            'Offline Meter Energy': 'เครื่องวัดพลังงานออฟไลน์',
            'Offline Meter Carbon': 'ออฟไลน์มิเตอร์ปล่อย CO2',
            'Offline Meter Cost': 'ค่ามิเตอร์ออฟไลน์',
            'Offline Meter Batch Analysis': 'การวิเคราะห์แบทช์มิเตอร์ออฟไลน์',
            'Offline Meter Saving': 'ประหยัดมิเตอร์ออฟไลน์',
            'Offline Meter Plan': 'แผนมิเตอร์ออฟไลน์',
            'Offline Meter Input': 'อินพุตมิเตอร์ออฟไลน์',
            'Tenant Bill': 'บิลผู้เช่า',
            'Energy Flow Diagram': 'แผนภาพการไหลของพลังงาน',
            'Distribution System': 'ระบบจําหน่าย',
            'SVG System': 'ระบบการแสดงภาพ SCADA',
            'Faults Data': 'ข้อ บกพร่อง',
            'Space Equipments': 'อุปกรณ์อวกาศ',
            'Combined Equipments': 'อุปกรณ์รวม',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'จำนวนใบสั่งงานทั้งหมด',
            'Number of New Work Orders': 'จำนวนใบสั่งงานใหม่',
            'Number of Inprogress Work Orders': 'จำนวนใบสั่งงานที่อยู่ระหว่างดำเนินการ',
            'Number of Done Work Orders': 'จำนวนใบสั่งงานที่เสร็จสิ้นแล้ว',
            'Fuel Indicator': 'อัตราการสิ้นเปลืองเชื้อเพลิง',
            'Charge Energy Indicator': 'ค่าพลังงานที่เรียกเก็บ',
            'Discharge Energy Indicator': 'ค่าพลังงานที่ปล่อยทิ้ง',
            'Charge Cost Indicator': 'ต้นทุนค่าธรรมเนียม',
            'Discharge Revenue Indicator': 'รายได้จากการปล่อยทิ้ง',
            'HVAC': 'HVAC',
            'Fire Control': 'ระบบควบคุมอัคคีภัย',

            // Dashboard
            'Welcome to MyEMS': 'ยินดีต้อนรับสู่ MyEMS',
            'An Industry Leading Open Source Energy Management System': 'ระบบการจัดการพลังงานโอเพ่นซอร์สชั้นนําของอุตสาหกรรม',
            "This Year's Consumption CATEGORY VALUE UNIT": 'การบริโภคในปีนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'ค่าใช้จ่ายในปีนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'การบริโภคในเดือนนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'ค่าใช้จ่ายของเดือนนี้ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'การบริโภค {{CATEGORY}} {{VALUE}} {{UNIT}} ในช่วงเดียวกันของปีก่อน',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'ต้น ทุน {{CATEGORY}} {{VALUE}} {{UNIT}} ในช่วงเดียวกันของปีก่อน',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} การบริโภค {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} ต้น ทุน {{UNIT}}',
            // Entities
            Space: 'อวกาศ',
            Equipment: 'อุปกรณ์',
            Meter: 'เมตร',
            'Offline Meter': 'เครื่องวัดออฟไลน์',
            'Virtual Meter': 'เครื่องวัดเสมือน',
            Tenant: 'ผู้เช่า',
            Store: 'ร้าน',
            Shopfloor: 'ชั้นร้านค้า',
            'Combined Equipment': 'อุปกรณ์รวม',
            'Cost Center': 'ศูนย์ต้นทุน',
            Name: 'ชื่อ',
            DisplayName: 'ชื่อที่ใช้แสดง',
            UserName: 'ชื่อผู้ใช้',
            Description: 'การบรรยาย',
            'Energy Category': 'ประเภทพลังงาน',
            'Child Spaces': 'พื้นที่สําหรับเด็ก',
            'Associated Equipment': 'อุปกรณ์ที่เกี่ยวข้อง',
            //Energy Categories
            Electricity: 'ไฟฟ้า',
            Water: 'น้ำ',
            'Natural Gas': 'ก๊าซธรรมชาติ',
            // SidePanelModal
            Settings: 'การตั้งค่า',
            'Set your own customized style': 'กําหนดสไตล์ของคุณเอง',
            'Color Scheme': 'โทนสี',
            'Choose the perfect color mode for your app': 'เลือกโหมดสีที่สมบูรณ์แบบสําหรับแอปของคุณ',
            Light: 'แสง',
            Dark: 'มืด',
            'RTL Mode': 'โหมด RTL',
            'Switch your language direction': 'เปลี่ยนทิศทางภาษาของคุณ',
            'Fluid Layout': 'เค้าโครงของไหล',
            'Toggle container layout system': 'สลับระบบเค้าโครงคอนเทนเนอร์',
            'Navigation Position': 'ตําแหน่งการนําทาง',
            'Vertical': 'แนวตั้ง',
            'Top': 'ด้านบน',
            'Combo': 'คอมโบ',
            'Transparent': 'โปร่งใส',
            'Inverted': 'กลับด้าน',
            'Card': 'การ์ด',
            'Vibrant': 'สดใส',
            'Select a suitable navigation system for your web application':
                'เลือกระบบนําทางที่เหมาะสมสําหรับเว็บแอปพลิเคชันของคุณ',
            'Vertical Nav': 'การนําทางแนวตั้ง',
            'Top Nav': 'มูลค่านําเที่ยวสูงสุด',
            'Vertical Navbar Style': 'แนวตั้ง Navbar Style',
            'Switch between styles for your vertical navbar': 'สลับระหว่างสไตล์สําหรับ navbar แนวตั้งของคุณ',
            Language: 'ภาษา',
            'Switch between languages': 'สลับระหว่างภาษาต่างๆ',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'ชอบสิ่งที่คุณเห็น?',
            'Get MyEMS now': 'รับ MyEMS ทันที',
            Purchase: 'รุ่นองค์กร',
            ContactInfo: 'ข้อมูลติดต่อ',
            ProductWebsite: 'เว็บไซต์ผลิตภัณฑ์',
            CompanyWebsite: 'เว็บไซต์บริษัท',
            SalesPhone: 'โทรศัพท์ฝ่ายขาย',
            // Query Panel
            'Base Period Begins': 'ระยะเวลาฐานเริ่มต้น',
            'Base Period Ends': 'ระยะเวลาฐานเริ่มต้น',
            'Comparison Types': 'ประเภทการเปรียบเทียบ',
            'Year-Over-Year': 'ปีต่อปี',
            'Month-On-Month': 'เดือนต่อเดือน',
            'Free Comparison': 'เปรียบเทียบฟรี',
            'None Comparison': 'ไม่มีการเปรียบเทียบ',
            'Reporting Period Begins': 'รอบระยะเวลารายงานเริ่มต้น',
            'Reporting Period Ends': 'สิ้นสุดรอบระยะเวลารายงาน',
            '(Optional)': '(เสริม)',
            'Period Types': 'ประเภทระยะเวลา',
            Yearly: 'รายปี',
            Monthly: 'รายเดือน',
            Weekly: 'รายสัปดาห์',
            Daily: 'ทุกวัน',
            Hourly: 'รายชั่วโมง',
            Submit: 'ส่ง',
            'Input Energy Category': 'ประเภทพลังงานอินพุต',
            'Output Energy Category': 'ประเภทพลังงานขาออก',
            'Fraction Parameter': 'พารามิเตอร์เศษส่วน',
            Search: 'ค้น',
            //DateRangePicker
            sunday: 'ซู',
            monday: 'โม',
            tuesday: 'ตู่',
            wednesday: 'เรา',
            thursday: 'สธ.',
            friday: 'FR',
            saturday: 'ซา',
            ok: 'ตกลง, ได้',
            today: 'วันนี้',
            yesterday: 'เมื่อวานนี้',
            hours: 'ชั่วโมง',
            minutes: 'รายงานการประชุม',
            seconds: 'วินาที',
            last7Days: '7 วันที่ผ่านมา',
            'Select Date Range': 'เลือกช่วงวันที่',
            //Card Summaries and Line Charts
            'Base Period': 'ระยะเวลาฐาน',
            'Reporting Period': 'รอบระยะเวลารายงาน',
            'Per Unit Area': 'ต่อหน่วยพื้นที่',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'ต่อหน่วยการผลิต',
            Baseline: 'พื้นฐาน',
            Actual: 'จริง',
            'Baseline Value - Actual Value': 'พื้นฐาน - จริง',
            'Average Load': 'โหลดเฉลี่ย',
            'Maximum Load': 'โหลดสูงสุด',
            'Load Factor': 'โหลดแฟกเตอร์',
            'Ratio of Average Load to Maximum Load': 'อัตราส่วนของโหลดเฉลี่ยต่อโหลดสูงสุด',
            'Carbon Dioxide Emissions by Energy Category': 'การปล่อยก๊าซคาร์บอนไดออกไซด์ตามประเภทพลังงาน',
            'Costs by Energy Category': 'ค่าใช้จ่ายตามหมวดพลังงาน',
            'Incomes by Energy Category': 'รายได้ตามหมวดพลังงาน',
            'Electricity Consumption by Time-Of-Use': 'ปริมาณการใช้ไฟฟ้าตามเวลาการใช้งาน',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'การปล่อยก๊าซคาร์บอนไดออกไซด์จากไฟฟ้าตามเวลาการใช้งาน',
            'Electricity Cost by Time-Of-Use': 'ค่าไฟฟ้าตามเวลาที่ใช้',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Comsumption โดยรายการพลังงาน',
            'Ton of Standard Coal by Energy Category': 'ตันของถ่านหินมาตรฐาน (TCE) ตามประเภทพลังงาน',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'ตันของการปล่อยก๊าซคาร์บอนไดออกไซด์ (TCO2E) ตามประเภทพลังงาน',
            'Reporting Period Consumption CATEGORY UNIT': 'ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'ปริมาณการใช้ในรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'การบริโภคช่วงฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT':
                'ปริมาณการใช้ในรอบระยะเวลารายงาน {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'ปริมาณการใช้ในรอบระยะเวลารายงาน {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'การบริโภคช่วงฐาน {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'สัดส่วนพื้นที่เด็กแบ่งตามประเภทพลังงาน {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'พื้นที่เด็กสัดส่วนทั้งหมด',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'รอบระยะเวลารายงานการปล่อยก๊าซคาร์บอนไดออกไซด์ {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'รอบระยะเวลารายงานการปล่อยก๊าซคาร์บอนไดออกไซด์ {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'การปล่อยก๊าซคาร์บอนไดออกไซด์ในช่วงเวลาพื้นฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'ค่าใช้จ่ายรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'ค่าใช้จ่ายรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'ค่าใช้จ่ายรอบระยะเวลาพื้นฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'ผลผลิตรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'เอาต์พุตระยะเวลาฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'รายได้รอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'รายได้รอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'รายได้งวดฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'รอบระยะเวลารายงาน รายได้รวม {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} รอบระยะเวลารายงาน ประสิทธิภาพที่ครอบคลุมสะสม {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} รอบระยะเวลารายงาน ประสิทธิภาพที่ครอบคลุมสะสม {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} ระยะเวลาฐานประสิทธิภาพที่ครอบคลุมสะสม {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'ประสิทธิภาพทันที {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} ประสิทธิภาพทันที {{UNIT}}',
            'Equipment Efficiency Indicator': 'ตัวชี้วัดประสิทธิภาพพลังงานของอุปกรณ์',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} ประสิทธิภาพที่ครอบคลุมทันที {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'รอบระยะเวลารายงาน ประสิทธิภาพสะสม {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'ประสิทธิภาพการสะสมของระยะเวลาฐาน {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'ประสิทธิภาพการสะสมของระยะเวลาฐาน {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'ระยะเวลาฐาน {{CATEGORY}} โหลดสูงสุด {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} โหลดสูงสุด {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} โหลดเฉลี่ย {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'รอบระยะเวลารายงาน {{CATEGORY}} โหลดแฟกเตอร์',
            'Base Period CATEGORY Average Load VALUE UNIT': 'ระยะเวลาฐาน {{CATEGORY}} โหลดเฉลี่ย {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่าเฉลี่ย {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่าสูงสุด {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} มูลค่าขั้นต่ํา {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่าเฉลี่ยเลขคณิต {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ค่ามัธยฐาน (ค่ากลาง) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ตัวอย่างค่าเบี่ยงเบนมาตรฐาน {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'รอบระยะเวลารายงาน {{CATEGORY}} ความแปรปรวนของตัวอย่าง {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'การบันทึกรอบระยะเวลารายงาน {{CATEGORY}} (พื้นฐาน - จริง) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'รอบระยะเวลารายงานลดลง {{CATEGORY}} (พื้นฐาน - จริง) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'การบันทึกรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'การออมระยะเวลาพื้นฐาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'ระยะเวลาการรายงานการใช้มิเตอร์หลัก {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'ระยะเวลาการรายงานการใช้มิเตอร์หลัก {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'ระยะเวลาการรายงาน Submeters การบริโภค {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'ระยะเวลาการรายงาน Submeters การบริโภค {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'ความแตกต่างของรอบระยะเวลารายงาน {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'ความแตกต่างของเปอร์เซ็นต์รอบระยะเวลารายงาน',
            'Reporting Period Difference CATEGORY VALUE UNIT':
                'ความแตกต่างของรอบระยะเวลารายงาน {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'ค่าแนวโน้ม',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'รายการข้อบกพร่อง',
            'Reporting Period Number of Fault VALUE': 'จํานวนรอบระยะเวลารายงานความผิดพลาด {{VALUE}}',
            'All Faults': 'ความผิดพลาดทั้งหมด',
            'Space Faults': 'ความผิดพลาดของพื้นที่',
            'Number of All Faults': 'จํานวนความผิดพลาดทั้งหมด',
            'Number of Space Faults': 'จํานวนความผิดพลาดของพื้นที่',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'ตันของถ่านหินมาตรฐาน',
            'Ton of Carbon Dioxide Emissions': 'ตันของการปล่อยก๊าซคาร์บอนไดออกไซด์',
            'Carbon Emissions Per Unit Of Energy Consumption': 'การปล่อยคาร์บอนต่อหน่วยการบริโภคพลังงาน',
            'Operating Characteristic Curve': 'เส้นโค้งลักษณะการทำงาน',
            Tariff: 'ภาษี',
            'Detailed Data': 'ข้อมูลรายละเอียด',
            'Child Spaces Data': 'ข้อมูลพื้นที่ย่อย',
            'Associated Equipment Data': 'ข้อมูลอุปกรณ์ที่เกี่ยวข้อง',
            'This Year': 'ในปีนี้',
            'The Same Period Last Year': 'ช่วงเดียวกันของปีก่อน',
            'This Month': 'เดือนนี้',
            'This Day': 'วันนี้',
            Total: 'ทั้งหมด',
            'No data found': 'ไม่พบข้อมูล',
            Export: 'ส่งออก',
            Datetime: 'วันที่เวลา',
            'Time-Of-Use Type': 'ประเภทเวลาใช้งาน',
            'Top-Peak': 'ท็อปพีค',
            'On-Peak': 'ออนพีค',
            'Mid-Peak': 'มิดพีค',
            'Off-Peak': 'ออฟพีค',
            'Deep': 'Deep-Valley',
            Percentage: 'อัตราร้อยละ',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'แนวโน้มในชั่วโมงสุดท้ายของ Energy Value Point',
            Circuit: 'วงจร',
            Point: 'จุด',
            'Realtime Value': 'มูลค่าเรียลไทม์',
            //Meter Tracking
            'Meter List': 'รายการมิเตอร์',
            'Edit Meter': 'แก้ไข',
            'Start Value': 'มูลค่าเริ่มต้น',
            'End Value': 'มูลค่าสิ้นสุด',
            'Difference Value': 'ค่าความแตกต่าง',
            'Start Integrity Rate': 'เริ่ม Integrity Rate(%)',
            'End Integrity Rate': 'สิ้นสุดอัตราความสมบูรณ์(%)',
            'Full Integrity Rate': 'อัตราความซื่อสัตย์เต็มที่(%)',
            //Equipment Tracking
            'Equipment List': 'รายการอุปกรณ์',
            'Edit Equipment': 'แก้ไข',
            //Profile Dropdown
            Feedback: 'การตอบสนอง',
            'Account Settings': 'การตั้งค่าบัญชี',
            Logout: 'ออกจากระบบ',
            //Authentication
            'Log in': 'เข้าสู่ระบบ',
            'Email address': 'ที่อยู่อีเมล',
            'Phone Number': 'หมายเลขโทรศัพท์',
            Password: 'รหัสผ่าน',
            CaptchaCode: 'แคปต์ชา',
            Refresh: 'ฟื้นฟู',
            'Remember me': 'จําฉันไว้',
            'Logged in as ': 'เข้าสู่ระบบเป็น ',
            'Forgot Password?': 'ลืมรหัสผ่าน?',
            'Forgot your password?': 'ลืมรหัสผ่าน?',
            "Enter your email and we'll send you a reset link": 'ป้อนอีเมลของคุณแล้วเราจะส่งลิงก์รีเซ็ตให้คุณ',
            "Enter your email and we'll send you a registration link": 'ป้อนอีเมลของคุณแล้วเราจะส่งลิงก์ลงทะเบียนให้คุณ',
            'Reset Password': 'รีเซ็ตรหัสผ่าน',
            'Thanks for using MyEMS!': 'ขอบคุณที่ใช้ MyEMS!',
            'You are now successfully signed out': 'ตอนนี้คุณออกจากระบบเรียบร้อยแล้ว',
            'Return to Login': 'กลับไปที่เข้าสู่ระบบ',
            'Please check your email!': 'โปรดตรวจสอบอีเมลของคุณ!',
            'An email has been sent to ': 'อีเมลถูกส่งไปยัง ',
            'Please click on the included link to reset your password': 'โปรดคลิกที่ลิงค์ที่ให้มาเพื่อรีเซ็ตรหัสผ่านของคุณ',
            'Please click on the included link to register your account': 'โปรดคลิกที่ลิงค์ที่ให้มาเพื่อลงทะเบียนบัญชีของคุณ',
            'An email with password reset link is sent to ': 'อีเมลที่มีลิงก์รีเซ็ตรหัสผ่านจะถูกส่งไปยัง ',
            'Change Password': 'เปลี่ยนรหัสผ่าน',
            'Old Password': 'รหัสผ่านเก่า',
            'New Password': 'รหัสผ่านใหม่',
            'Confirm Password': 'ยืนยันรหัสผ่าน',
            'Update Password': 'อัปเดตรหัสผ่าน',
            'Password has been changed!': 'เปลี่ยนรหัสผ่านแล้ว!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'รหัสยืนยันถูกส่งไปยังกล่องจดหมายของคุณแล้ว. \
      โปรดคัดลอกไปยังช่องป้อนข้อมูลด้านล่าง.',
            'New to MyEMS': 'เพิ่งเริ่มใช้ MyEMS',
            'Create an account': 'สร้างบัญชี',
            'EMAIL Account registration successful': '{{EMAIL}} การลงทะเบียนบัญชีสําเร็จ',
            'Thanks for verifying your account!': 'ขอบคุณสําหรับการยืนยันบัญชีของคุณ!',
            'Your code is': 'รหัสของคุณคือ',
            'Send verification code': 'ส่งรหัสยืนยัน',
            'Please wait for NUMBER seconds': 'กรุณารอสักครู่ {{NUMBER}} วินาที',
            'Password reset': 'รีเซ็ตรหัสผ่าน',
            'Please wait for approval': 'กรุณารอการอนุมัติ',
            //notification
            Notifications: 'แจ้ง เตือน',
            'Mark all as read': 'ทําเครื่องหมายทั้งหมดว่าอ่านแล้ว',
            'View all': 'ทั้งหมด',
            'Notification New': 'ใหม่',
            'Notification Earlier': 'เมื่อก่อน',
            'Notification List': 'รายการการแจ้งเตือน',
            'Bulk actions': 'การดําเนินการหลายรายการในครั้งเดียว',
            'Notification Subject': 'ชื่อเรื่อง',
            'Notification Created Datetime': 'วันที่และเวลาที่สร้าง',
            'Notification Priority': 'สำคัญ',
            'Notification Message': 'ข้อความ',
            'Notification Status': 'สถานะ',
            'Notification Mark As Read': 'ทําเครื่องหมายว่าอ่านแล้ว',
            'Notification Mark As Acknowledged': 'ยอมรับ',
            'Notification Low': 'ต่ํา',
            'Notification Medium': 'ปานกลาง',
            'Notification High': 'สูง',
            'Notification Critical': 'เกี่ยวกับการวิจารณ์',
            'Notification Unread': 'ยังไม่ได้อ่าน',
            'Notification Read': 'อ่าน',
            'Notification Acknowledged': 'ยอม รับ',
            'Notification Archive': 'หอจดหมายเหตุ',
            'Notification Delete': 'ลบ',
            'Notification Apply': 'ใช้',
            'Notification Start Datetime': 'เริ่มวันที่และเวลา',
            'Notification End Datetime': 'สิ้นสุดวันที่และเวลา',
            'Notification Update Datetime': 'อัปเดตวันที่และเวลา',
            //Monitoring
            'Run Commands': 'เรียกใช้คําสั่ง',
            'Pin Code': 'รหัสพิน',
            'Unlock': 'ปลดล็อค',
            'Set Value': 'ตั้งค่าค่า',
            'Fault Alarms': 'สัญญาณเตือนความผิดพลาด',
            'Instantaneous Efficiency VALUE UNIT': 'ประสิทธิภาพทันที {{VALUE}} {{UNIT}}',
            'Communication Online': 'ออนไลน์',
            'Communication Offline': 'ออฟไลน์',
            'Equipment Status': 'สถานะของอุปกรณ์',
            'Equipment Running': 'กำลัง เรียก ใช้',
            'Equipment Stopped': 'หยุด',
            'Show Up to': 'แสดงถึง',
            All: 'ทั้งหมด',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} ของ {{TOTAL}} อุปกรณ์',
            //Microgrid
            'Microgrid Energy': 'พลังงานไมโครกริด',
            'Microgrid Revenue': 'รายได้จากไมโครกริด',
            'Microgrid Carbon': 'คาร์บอนจากไมโครกริด',
            'Photovoltaic Generation': 'การผลิตไฟฟ้าพลังงานแสงอาทิตย์',
            'EV Charger Consumption': 'การใช้พลังงานของเครื่องชาร์จรถยนต์ไฟฟ้า',
            'Load Consumption': 'การใช้พลังงานโหลด',
            'Grid Buy': 'การซื้อจากกริด',
            'Grid Sell': 'การขายให้กริด',
            'EV Charger': 'เครื่องชาร์จรถยนต์ไฟฟ้า',
            'Heat Pump': 'ปั๊มความร้อน',
            'Photovoltaic': 'โฟโตวอลตาอิก',
            'PCS Run State': 'PCS สถานะการทำงาน',
            'PCS Unknown': 'ไม่ทราบ',
            'PCS Initializing': 'กำลังเริ่มต้น',
            'PCS Standby': 'รายการสำรอง',
            'PCS Shutdown': 'ปิดเครื่อง',
            'PCS Fault': 'ความผิด',
            'PCS Running': 'วิ่ง',
            'Battery Power': 'พลังงานแบตเตอรี่',
            'Photovoltaic Power': 'Fotovoltaik gücü',
            'Grid Power': 'พลังงานกริด',
            'Load Power': 'กำลังโหลด',
            Reporting: 'รายงาน',
            Maintenance: 'การซ่อมแซม',
            'Serial Number': 'หมายเลขผลิตภัณฑ์',
            Address: 'ที่อยู่',
            'Postal Code': 'รหัสไปรษณีย์',
            'Rated Capacity': 'ความจุสูงสุด',
            'Rated Power': 'กำลังไฟสูงสุด',
            Latitude: 'ละติจูด',
            Longitude: 'ลองจิจูด',
            'Strategy Management': 'การจัดการนโยบาย',
            'Charging Schedule': 'กำหนดการชาร์จ',
            'Charge Start Time': 'เวลาเริ่มต้นการชาร์จ',
            'Charge End Time': 'เวลาสิ้นสุดการชาร์จ',
            'Discharge Start Time': 'เวลาเริ่มต้นของการปลดปล่อย',
            'Discharge End Time': 'เวลาสิ้นสุดการปลดปล่อย',
            'Total Rated Power': 'กำลังไฟรวม',
            'Total Rated Capacity': 'ความจุสูงสุดรวม',
            "Today's Charge": "จำนวนเงินที่เรียกเก็บวันนี้",
            "Today's Discharge": "ปลดประจำการวันนี้",
            "Today's Generation": "การผลิตกระแสไฟฟ้าในปัจจุบัน",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'ค่าใช้จ่ายทั้งหมด',
            'Total Discharge': 'การปลดปล่อยทั้งหมด',
            'Total Generation': 'รุ่นทั้งหมด',
            'Total Revenue': 'รายได้รวม',
            'Total Photovoltaic Generation': 'การผลิตไฟฟ้าพลังงานแสงอาทิตย์ทั้งหมด',
            'Total EV Charger Consumption': 'การใช้พลังงานชาร์จ EV ทั้งหมด',
            'Total Load Consumption': 'การใช้พลังงานโหลดทั้งหมด',
            'Total Grid Buy': 'การซื้อจากกริดทั้งหมด',
            'Total Grid Sell': 'การขายให้กริดทั้งหมด',
            'Total Efficiency': 'ประสิทธิภาพโดยรวม',
            'Discharge Achievement Rate': 'อัตราความสำเร็จในการระบาย',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'การจัดอันดับรายได้',
            'Efficiency Ranking': 'การจัดอันดับประสิทธิภาพ',
            'Charge Ranking': 'การจัดอันดับความจุการชาร์จ',
            'Discharge Ranking': 'อันดับการปลดปล่อย',
            'Number of Microgrids': 'จำนวนไมโครกริด',
            'Number of Power Stations': 'จำนวนสถานีไฟฟ้า',
            'Microgrid List': 'รายการไมโครกริด',
            'Select Microgrid': 'เลือกไมโครกริด',
            'Previous Page': 'หน้าก่อนหน้า',
            'Next Page': 'หน้าต่อไป',
            '7 Days': '7 วัน',
            'Charge UNIT': 'ค่าใช้จ่าย {{UNIT}}',
            'Discharge UNIT': 'ปล่อย {{UNIT}}',
            'Generation UNIT': 'ผลิตกระแสไฟฟ้า {{UNIT}}',
            'Energy Indicator': 'ดัชนีพลังงาน',
            'Revenue Indicator': 'ตัวบ่งชี้ผลผลิต',
            'Carbon Indicator': 'ดัชนีคาร์บอน',

            // Energy Storage Power Station
            'Battery Operating State': 'สถานะการทำงานของแบตเตอรี่',
            'Battery State': 'สถานะแบตเตอรี่',
            'Battery Unknown': 'ไม่ทราบ',
            'Battery Stopped': 'หยุดแล้ว',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'ความผิด', // 1
            'Battery Warning': 'คำเตือน', // 2
            'Battery Standby': 'รายการสำรอง', // 3
            'Battery Prohibit DisCharging': 'ห้ามขนถ่าย', // 4
            'Battery Prohibit Charging': 'ห้ามชาร์จ', // 5
            'Battery Normal': 'ทั่วไป', // 6
            'Battery Charging': 'ในการชาร์จ', // 7
            'Battery Discharging': 'ในการปลดปล่อย', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'ระยะวงจรชีวิต',
            'Use Phase': 'ขั้นตอนการใช้งาน',
            'Commissioning Phase': 'ขั้นตอนการว่าจ้าง',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'ขั้นตอนการติดตั้ง',
            'Device Status': 'สถานะอุปกรณ์',
            'Basic Information': 'ข้อมูลพื้นฐาน',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'อินเวอร์เตอร์',
            'Invertor Run State': 'สถานะการทำงาน',
            'Invertor Unknown': 'ไม่ทราบ',
            'Invertor Initializing': 'กำลังเริ่มต้น',
            'Invertor Standby': 'รายการสำรอง',
            'Invertor Shutdown': 'ปิดเครื่อง',
            'Invertor Fault': 'ความผิด',
            'Invertor Running': 'วิ่ง',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'วันที่สร้าง',
            'File Format': 'รูปแบบไฟล์',
            'File Size': 'ขนาดไฟล์',
            Uploader: 'ผู้อัปโหลด',
            //Error
            "The page you're looking for is not found": 'ไม่พบหน้าเว็บที่คุณกําลังมองหา',
            "Make sure the address is correct and that the page hasn't moved. ":
                'ตรวจสอบให้แน่ใจว่าที่อยู่ถูกต้องและหน้าเว็บไม่ได้ย้าย. ',
            'If you think this is a mistake,': 'หากคุณคิดว่านี่เป็นความผิดพลาด,',
            'contact us': 'ติดต่อเรา',
            'Take me home': 'พาฉันกลับบ้าน',
            'Whoops, something went wrong!': 'โอ้โหมีบางอย่างผิดพลาด!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'ลองรีเฟรชหน้าเว็บ หรือย้อนกลับไปลองดําเนินการอีกครั้ง. ',
            'If this problem persists,': 'หากปัญหานี้ยังคงมีอยู่,',
            'Captcha Error': 'ข้อผิดพลาด Captcha',
            'Confirm Password Error': 'รหัสผ่านยืนยันไม่ตรงกัน',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'ดูเหมือนว่าคุณคลิกที่ลิงก์รีเซ็ตรหัสผ่านไม่ถูกต้อง กรุณาลองอีกครั้ง',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'ดูเหมือนว่าคุณคลิกที่ลิงค์บัญชีการลงทะเบียนที่ไม่ถูกต้อง กรุณาลองอีกครั้ง',
            //Tenant Bill
            'Lease Contract Number': 'เลขที่สัญญาเช่า',
            Download: 'ดาวน์โหลด',
            Print: 'พิมพ์',
            'Payment Notice': 'แจ้งการชําระเงิน',
            'Bill To': 'เรียกเก็บเงินไปยัง',
            'Bill Number': 'หมายเลขบิล',
            'Bill Date': 'วันที่เรียกเก็บเงิน',
            'Payment Due Date': 'วันครบกําหนดชําระเงิน',
            'Amount Payable': 'จํานวนเงินที่ต้องชําระ',
            'Billing Period Start': 'เริ่มรอบการเรียกเก็บเงิน',
            'Billing Period End': 'สิ้นสุดรอบการเรียกเก็บเงิน',
            Quantity: 'ปริมาณ',
            Price: 'ราคา',
            Unit: 'หน่วย',
            Amount: 'ปริมาณ',
            Subtotal: 'ยอดรวม',
            'VAT Output Tax': 'ภาษีส่งออก VAT',
            'Total Amount Payable': 'ยอดรวมที่ต้องชําระ',
            'Please make sure to pay on or before the payment due date above':
                'โปรดตรวจสอบให้แน่ใจว่าได้ชําระเงินก่อนหรือก่อนวันครบกําหนดชําระเงินข้างต้น',
            'Send money to the following account': 'ส่งเงินเข้าบัญชีต่อไปนี้',
            'Account Name': 'ชื่อบัญชี',
            'Bank Name': 'ชื่อธนาคาร',
            'Bank Address': 'ที่อยู่ธนาคาร',
            'RMB Account': 'บัญชี RMB',
            // button
            'Toggle Navigation': 'สลับการนําทาง',
            // working calendar
            'Working Days': 'วันทําการ',
            'Non Working Days': 'วันที่ไม่ได้ทํางาน',
            'Select Row': 'กรุณาเลือกแถวข้อมูล',
            // Offline Meter Input
            'Daily Value': 'ปริมาณที่แนะนําต่อวัน',
            Date: 'วันที่',
            'Successfully Saved': 'บันทึกสําเร็จ',
            'Previous Data Is Empty': 'ข้อมูลก่อนหน้าว่างเปล่า',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'ค่ามิเตอร์ออฟไลน์ไม่ถูกต้อง',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'มีความสัมพันธ์กับโรงไฟฟ้าเสมือนจริง',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'ตารางรวม',
            SubMeter: 'ตารางแยก',
            'Power Quality': 'Güç kalitesi',
            'About Power Quality': 'Güç kalitesi hakkında',
            'Trend Values': 'Eğilim değerleri',
            Category: 'Kategori',
            Type: 'Tür',
            Unit: 'Birim',
            Limit: 'Sınır',
            'Normal Limit': 'Normal sınır',
            'Severe Limit': 'Ağır sınır',
            Compliance: 'Uyum oranı',
            'Worst Deviation': 'En büyük sapma',
            'Worst Time': 'En kötü zaman',
            'Severe Exceed Count': 'Ağır aşım sayısı',
            'Worst Unbalance': 'Maksimum dengesizlik',
            Hz: 'Hz',
            voltage: 'Gerilim',
            current: 'Akım',
            frequency: 'Frekans',
            voltage_deviation: 'Gerilim sapması',
            current_unbalance: 'Akım dengesizliği',
            voltage_unbalance: 'Gerilim dengesizliği',
            mean_deviation_pct: 'Ortalama sapma (%)',
            p95_abs_deviation_pct: 'P95 mutlak sapma (%)',
            mean_abs_deviation_hz: 'Ortalama mutlak sapma (Hz)',
            p95_abs_deviation_hz: 'P95 mutlak sapma (Hz)',
            mean_unbalance_pct: 'Ortalama dengesizlik (%)',
            p95_unbalance_pct: 'P95 dengesizlik (%)',
            count: 'Adet',
            min: 'Min',
            max: 'Maks',
            mean: 'Ortalama',
            std: 'Std',
            p5: 'P5',
            p95: 'P95'
        }
    },
    tr: {
        translation: {
            // routes & menus
            Dashboard: 'Tablo',
            'Space Data': 'Uzay',
            'Equipment Data': 'Ekipman',
            'Meter Data': 'Metre',
            'Tenant Data': 'Kiracı',
            'Store Data': 'Mağaza',
            'Shopfloor Data': 'Üretim bölümü',
            'Combined Equipment Data': 'Kombine Ekipmanlar',
            'Auxiliary System': 'Yardımcı Sistem',
            Microgrid: 'Mikro şebeke',
            'Energy Storage Power Station': 'Güç İstasyonu',
            'Photovoltaic Power Station': 'Güç İstasyonu',
            'Fault Alarm': 'Arıza Alarmı',
            Monitoring: 'Izleme',
            'Advanced Reporting': 'Gelişmiş Raporlama',
            'Knowledge Base': 'Bilgi bankası',
            'Energy Category Data': 'Enerji Kategorisi',
            'Energy Item Data': 'Enerji Öğesi',
            Carbon: 'CO2 Emisyonları',
            Cost: 'Masraf',
            Output: 'Çıktı',
            Income: 'Gelir',
            Efficiency: 'Randıman',
            Load: 'Yük',
            Statistics: 'İstatistik',
            'Batch Analysis': 'Toplu Analiz',
            Saving: 'Tasarruf',
            Plan: 'Plan',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Ekipman Takibi',
            'Equipment Comparison': 'Ekipman Karşılaştırması',
            'Shopfloor Comparison': 'Ekipman Karşılaştırması',
            'Store Comparison': 'Ekipman Karşılaştırması',
            'Space Comparison': 'Ekipman Karşılaştırması',
            'Combined Equipment Comparison': 'Ekipman Karşılaştırması',
            'Tenant Comparison': 'Kiracı karşılaştırması',
            'Environment Monitor': 'Ortam İzleyicisi',
            'Meter Energy': 'Sayaç Enerjisi',
            'Meter Carbon': 'Meter CO2 Emisyonları',
            'Meter Cost': 'Sayaç Maliyeti',
            'Meter Trend': 'Ölçüm Trendi',
            'Meter Realtime': 'Gerçek Zamanlı Ölçüm Cihazı',
            'Meter Saving': 'Sayaç Tasarrufu',
            'Meter Plan': 'Sayaç Planı',
            'Master Meter Submeters Balance': 'Ana Sayaç Alt Sayaç Dengesi',
            'Meter Batch Analysis': 'Sayaç Toplu Analizi',
            'Meter Comparison': 'Sayaç Karşılaştırması',
            'Meter Tracking': 'Sayaç Takibi',
            'Virtual Meter Saving': 'Sanal Sayaç Tasarrufu',
            'Virtual Meter Plan': 'Sanal Sayaç Planı',
            'Virtual Meter Energy': 'Sanal Sayaç Enerji',
            'Virtual Meter Carbon': 'Sanal Meter CO2 Emisyonları',
            'Virtual Meter Cost': 'Sanal Sayaç Maliyeti',
            'Virtual Meter Batch Analysis': 'Sanal Ölçüm Toplu Analizi',
            'Virtual Meter Comparison': "Sanal Sayaç Karşılaştırması",
            'Offline Meter Energy': 'Çevrimdışı Sayaç Enerjisi',
            'Offline Meter Carbon': 'Çevrimiçi Meter CO2 Emisyonları',
            'Offline Meter Cost': 'Çevrimdışı Ölçüm Maliyeti',
            'Offline Meter Batch Analysis': 'Çevrimdışı Ölçüm Toplu Analizi',
            'Offline Meter Saving': 'Çevrimdışı Sayaç Kaydetme',
            'Offline Meter Plan': 'Çevrimdışı Sayaç Planı',
            'Offline Meter Input': 'Çevrimdışı Sayaç Girişi',
            'Tenant Bill': 'Kiracı Faturası',
            'Energy Flow Diagram': 'Enerji Akış Diyagramı',
            'Distribution System': 'Dağıtım Sistemi',
            'SVG System': 'SCADA Görselleştirme Sistemi',
            'Faults Data': 'Hata',
            'Space Equipments': 'Uzay Ekipmanları',
            'Combined Equipments': 'Kombine Ekipmanlar',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Toplam İş Emri Sayısı',
            'Number of New Work Orders': 'Yeni İş Emri Sayısı',
            'Number of Inprogress Work Orders': 'Devam Eden İş Emri Sayısı',
            'Number of Done Work Orders': 'Tamamlanan İş Emri Sayısı',
            'Fuel Indicator': 'Yangın Kullanımı',
            'Charge Energy Indicator': 'Enerji Yükle',
            'Discharge Energy Indicator': 'Enerji Boşalt',
            'Charge Cost Indicator': 'Maliyet Yükle',
            'Discharge Revenue Indicator': 'Gelir Boşalt',
            'HVAC': 'HVAC',
            'Fire Control': 'Yangın Kontrolü',

            // Dashboard
            'Welcome to MyEMS': "MyEMS'ye Hoş Geldiniz",
            'An Industry Leading Open Source Energy Management System': 'Endüstri Lideri Açık Kaynak Enerji Yönetim Sistemi',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Bu Yılın Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Bu Yılın Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Bu Ayın Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Bu Ayın Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Tüketim {{CATEGORY}} {{VALUE}} {{UNIT}} Geçen Yılın Aynı Döneminde',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Maliyet {{CATEGORY}} {{VALUE}} {{UNIT}} Geçen Yılın Aynı Döneminde',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Tüketim {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Maliyet {{UNIT}}',
            // Entities
            Space: 'Uzay',
            Equipment: 'Ekipman',
            Meter: 'Metre',
            'Offline Meter': 'Çevrimdışı Ölçüm',
            'Virtual Meter': 'Sanal Ölçüm',
            Tenant: 'Kiracı',
            Store: 'Mağaza',
            Shopfloor: 'Üretim bölümü',
            'Combined Equipment': 'Kombine Ekipmanlar',
            'Cost Center': 'Maliyet Merkezi',
            Name: 'Ad',
            DisplayName: 'Görünen ad',
            UserName: 'Kullanıcı Adı',
            Description: 'Tarif',
            'Energy Category': 'Enerji Kategorisi',
            'Child Spaces': 'Çocuk Alanları',
            'Associated Equipment': 'İlgili Ekipmanlar',
            //Energy Categories
            Electricity: 'Elektrik',
            Water: 'Suyun',
            'Natural Gas': 'Doğalgaz',
            // SidePanelModal
            Settings: 'Ayarlar',
            'Set your own customized style': 'Kendi özelleştirilmiş stilinizi belirleyin',
            'Color Scheme': 'Renk Şeması',
            'Choose the perfect color mode for your app': 'Uygulamanız için mükemmel renk modunu seçin',
            Light: 'Işık',
            Dark: 'Koyu',
            'RTL Mode': 'RTL Modu',
            'Switch your language direction': 'Dil yönünüzü değiştirme',
            'Fluid Layout': 'Değişken Düzen',
            'Toggle container layout system': 'Konteyner düzen sistemini değiştir',
            'Navigation Position': 'Navigasyon Konumu',
            'Vertical': 'Dikey',
            'Top': 'Üst',
            'Combo': 'Kombinasyon',
            'Transparent': 'Şeffaf',
            'Inverted': 'Ters çevrilmiş',
            'Card': 'Kart',
            'Vibrant': 'Canlı',
            'Select a suitable navigation system for your web application':
                'Web uygulamanız için uygun bir navigasyon sistemi seçin',
            'Vertical Nav': 'Dikey Navigasyon',
            'Top Nav': 'En İyi Gezinti',
            'Vertical Navbar Style': 'Dikey Gezinme Çubuğu Stili',
            'Switch between styles for your vertical navbar': 'Dikey gezinme çubuğunuz için stiller arasında geçiş yapma',
            Language: 'Dil',
            'Switch between languages': 'Diller arasında geçiş yapma',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Gördüklerinizi beğendiniz mi?',
            'Get MyEMS now': "MyEMS'yi şimdi edinin",
            Purchase: 'Enterprise Edition',
            ContactInfo: 'Iletisim Bilgileri',
            ProductWebsite: 'Urun Web Sitesi',
            CompanyWebsite: 'Sirket Web Sitesi',
            SalesPhone: 'Satis Telefonu',
            // Query Panel
            'Base Period Begins': 'Baz Dönemi Başlıyor',
            'Base Period Ends': 'Baz Dönem Biter',
            'Comparison Types': 'Karşılaştırma Türleri',
            'Year-Over-Year': 'Yıldan Yıla',
            'Month-On-Month': 'Aydan Aya',
            'Free Comparison': 'Ücretsiz Karşılaştırma',
            'None Comparison': 'Karşılaştırma Yok',
            'Reporting Period Begins': 'Raporlama Dönemi Başlıyor',
            'Reporting Period Ends': 'Raporlama Dönemi Sona Eriyor',
            '(Optional)': '(Opsiyonel)',
            'Period Types': 'Dönem Türleri',
            Yearly: 'Yıllık',
            Monthly: 'Aylık',
            Weekly: 'Haftalık',
            Daily: 'Günlük',
            Hourly: 'Saatlik',
            Submit: 'Gönder',
            'Input Energy Category': 'Giriş Enerji Kategorisi',
            'Output Energy Category': 'Çıkış Enerjisi Kategorisi',
            'Fraction Parameter': 'Kesir Parametresi',
            Search: 'Aramak',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'TAMAM',
            today: 'Bugün',
            yesterday: 'Dün',
            hours: 'Saat',
            minutes: 'Tutanak',
            seconds: 'Saniye',
            last7Days: 'Son 7 Gün',
            'Select Date Range': 'Tarih Aralığını Seçin',
            //Card Summaries and Line Charts
            'Base Period': 'Baz Dönem',
            'Reporting Period': 'Raporlama Dönemi',
            'Per Unit Area': 'Birim Alan Başına',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Birim Üretim Başına',
            Baseline: 'Taban çizgisi',
            Actual: 'Gerçek',
            'Baseline Value - Actual Value': 'Taban çizgisi - Gerçek',
            'Average Load': 'Ortalama Yük',
            'Maximum Load': 'Maksimum Yük',
            'Load Factor': 'Yük Faktörü',
            'Ratio of Average Load to Maximum Load': 'Ortalama Yükün Maksimum Yüke Oranı',
            'Carbon Dioxide Emissions by Energy Category': 'Enerji Kategorisine Göre Karbondioksit Emisyonları',
            'Costs by Energy Category': 'Enerji Kategorisine Göre Maliyetler',
            'Incomes by Energy Category': 'Enerji Kategorisine Göre Gelirler',
            'Electricity Consumption by Time-Of-Use': 'Kullanım Süresine Göre Elektrik Tüketimi',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use':
                'Kullanım Süresine Göre Elektrik Karbondioksit Emisyonları',
            'Electricity Cost by Time-Of-Use': 'Kullanım süresine göre elektrik maliyeti',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Enerji Maddeleri Tarafından Tüketim',
            'Ton of Standard Coal by Energy Category': 'Enerji Kategorisine Göre Ton Standart Kömür (TCE)',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'Enerji Kategorisine Göre Tonlarca Karbondioksit Emisyonu (TCO2E)',
            'Reporting Period Consumption CATEGORY UNIT': 'Raporlama Dönemi Tüketimi {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Raporlama Dönemi Tüketimi {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Tüketimi {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Raporlama Dönemi Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Baz Dönem Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Raporlama Dönemi Tüketimi {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Raporlama Dönemi Tüketimi {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Baz Dönem Tüketimi {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Enerji Kategorisine Göre Çocuk Alanı Oranı {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Çocuk Alanı Toplam Oranı',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Raporlama Dönemi Karbondioksit Emisyonları {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Raporlama Dönemi Karbondioksit Emisyonları {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Baz Dönem Karbondioksit Emisyonları {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Raporlama Dönemi Maliyetleri {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Raporlama Dönemi Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Baz Dönem Maliyetleri {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Raporlama Dönemi Çıktısı {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Raporlama Dönemi Çıktısı {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Çıktısı {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Raporlama Dönemi Çıktısı {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Baz Dönem Çıkışı {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Raporlama Dönemi Geliri {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Raporlama Dönemi Geliri {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Baz Dönem Geliri {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Raporlama Dönemi Toplam Geliri {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Raporlama Dönemi Kümülatif Verimliliği {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Raporlama Dönemi Kümülatif Verimliliği {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Kümülatif Kapsamlı Verimlilik {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Raporlama Dönemi Kümülatif Kapsamlı Verimlilik {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Baz Dönem Kümülatif Kapsamlı Verimlilik {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Anlık Verimlilik {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Anlık Verimlilik {{UNIT}}',
            'Equipment Efficiency Indicator': 'Ekipman Enerji Verimliliği Göstergesi',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Anlık Kapsamlı Verimlilik {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Raporlama Dönemi Kümülatif Verimliliği {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Raporlama Dönemi Kümülatif Verimliliği {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Baz Dönem Kümülatif Verimlilik {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Baz Dönem Kümülatif Verimlilik {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Baz Dönem {{CATEGORY}} Maksimum Yük {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Raporlama Dönemi {{CATEGORY}} Maksimum Yük {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Raporlama Dönemi {{CATEGORY}} Ortalama Yük {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Raporlama Dönemi {{CATEGORY}} Yük Faktörü',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Baz Dönem {{CATEGORY}} Ortalama Yük {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Raporlama Dönemi {{CATEGORY}} Ortalama Değer {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Raporlama Dönemi {{CATEGORY}} Maksimum Değer {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Raporlama Dönemi {{CATEGORY}} Minimum Değer {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Raporlama Dönemi {{CATEGORY}} Aritmetik Ortalama {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Raporlama Dönemi {{CATEGORY}} Medyan (Orta Değer) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Raporlama Dönemi {{CATEGORY}} Numune Standart Sapması {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Raporlama Dönemi {{CATEGORY}} Örnek Varyans {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Raporlama Dönemi Tasarrufu {{CATEGORY}} (Taban çizgisi - Gerçek) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Raporlama Dönemi Azaldı {{CATEGORY}} (Taban çizgisi - Gerçek) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Raporlama Dönemi Tasarrufu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Baz Dönem Tasarrufu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Raporlama Dönemi Ana Sayaç Tüketimi {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Raporlama Dönemi Ana Sayaç Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Raporlama Dönemi Alt Sayaç Tüketimi {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Raporlama Dönemi Alt Sayaç Tüketimi {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Raporlama Dönemi Farkı {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Raporlama Dönemi Yüzde Farkı',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'v {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Trend Değerleri',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Arıza Listesi',
            'Reporting Period Number of Fault VALUE': 'Raporlama Dönemi Hata Sayısı {{VALUE}}',
            'All Faults': 'Tüm Hatalar',
            'Space Faults': 'Uzay Fayları',
            'Number of All Faults': 'Tüm Arızaların Sayısı',
            'Number of Space Faults': 'Uzay Hatalarının Sayısı',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Ton Standart Kömür',
            'Ton of Carbon Dioxide Emissions': 'Tonlarca karbondioksit emisyonu',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Enerji tüketim birimi başına karbon emisyonları',
            'Operating Characteristic Curve': 'işletim karakteristik eğri',
            Tariff: 'Tarife',
            'Detailed Data': 'Detaylı Veri',
            'Child Spaces Data': 'Alt Alanlar Verileri',
            'Associated Equipment Data': 'İlişkili Ekipman Verileri',
            'This Year': 'Bu Yıl',
            'The Same Period Last Year': 'Geçen yılın aynı döneminde',
            'This Month': 'Bu Ay',
            'This Day': 'Bu Gün',
            Total: 'Toplam',
            'No data found': 'Veri bulunamadı',
            Export: 'Ihracat',
            Datetime: 'Tarih-saat',
            'Time-Of-Use Type': 'Kullanım Süresi Türü',
            'Top-Peak': 'Üst Düzey Zirve',
            'On-Peak': 'Zirvede',
            'Mid-Peak': 'Orta Tepe Noktası',
            'Off-Peak': 'Peak',
            'Deep': 'Deep-Valley',
            Percentage: 'Yüzde',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Enerji Değer Noktasının son saatindeki eğilim',
            Circuit: 'Devre',
            Point: 'Nokta',
            'Realtime Value': 'Gerçek Zamanlı Değer',
            //Meter Tracking
            'Meter List': 'Sayaç Listesi',
            'Edit Meter': 'Düzenlemek',
            'Start Value': 'Başlangıç Değeri',
            'End Value': 'Bitiş Değeri',
            'Difference Value': 'Fark Değeri',
            'Start Integrity Rate': 'Başlangıç Bütünlük Oranı(%)',
            'End Integrity Rate': 'Son Bütünlük Oranı(%)',
            'Full Integrity Rate': 'Tam Bütünlük Oranı(%)',
            //Equipment Tracking
            'Equipment List': 'Ekipman Listesi',
            'Edit Equipment': 'Düzenlemek',
            //Profile Dropdown
            Feedback: 'Geri besleme',
            'Account Settings': 'Hesap Ayarları',
            Logout: 'Oturum kapatma',
            //Authentication
            'Log in': 'Oturum aç',
            'Email address': 'E-posta adresi',
            'Phone Number': 'Telefon numarası',
            Password: 'Parola',
            CaptchaCode: 'Arjantin',
            Refresh: 'Yenilemek',
            'Remember me': 'Beni hatırla',
            'Logged in as ': 'Şu şekilde oturum açtım: ',
            'Forgot Password?': 'Şifremi Unuttum?',
            'Forgot your password?': 'Şifrenizi mi unuttunuz?',
            "Enter your email and we'll send you a reset link": 'E-postanızı girin, size bir sıfırlama bağlantısı gönderelim',
            "Enter your email and we'll send you a registration link":
                'E-posta adresinizi girin, size bir kayıt bağlantısı gönderelim',
            'Reset Password': 'Şifreyi Sıfırla',
            'Thanks for using MyEMS!': "MyEMS'yi kullandığınız için teşekkür ederiz!",
            'You are now successfully signed out': 'Artık oturumunuz başarıyla kapatıldı',
            'Return to Login': 'Girişe Dön',
            'Please check your email!': 'Lütfen e-postanızı kontrol edin!',
            'An email has been sent to ': 'Şu adrese bir e-posta gönderildi: ',
            'Please click on the included link to reset your password':
                'Şifrenizi sıfırlamak için lütfen birlikte verilen bağlantıya tıklayın',
            'Please click on the included link to register your account':
                'Hesabınızı kaydetmek için lütfen dahil edilen bağlantıya tıklayın',
            'An email with password reset link is sent to ':
                'Parola sıfırlama bağlantısı içeren bir e-posta şu adrese gönderilir: ',
            'Change Password': 'Şifre Değiştir',
            'Old Password': 'Eski Şifre',
            'New Password': 'Yeni Şifre',
            'Confirm Password': 'Şifreyi Onayla',
            'Update Password': 'Şifreyi Güncelle',
            'Password has been changed!': 'Şifre değiştirildi!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Doğrulama kodu gelen kutunuza gönderildi. \
      Lütfen aşağıdaki giriş kutusuna kopyalayın.',
            'New to MyEMS': "MyEMS'de yeni",
            'Create an account': 'Bir hesap oluşturun',
            'EMAIL Account registration successful': '{{EMAIL}} Hesap kaydı başarılı',
            'Thanks for verifying your account!': 'Hesabınızı doğruladığınız için teşekkür ederiz!',
            'Your code is': 'Kodunuz',
            'Send verification code': 'Doğrulama kodu gönder',
            'Please wait for NUMBER seconds': 'Lütfen bekleyin {{NUMBER}} Saniye',
            'Password reset': 'Parola sıfırlama',
            'Please wait for approval': 'Lütfen onay için bekleyin',
            //notification
            Notifications: 'Bildirim',
            'Mark all as read': 'Tümünü okundu olarak işaretle',
            'View all': 'Tüm',
            'Notification New': 'YENİ',
            'Notification Earlier': 'ÖNCEKİ',
            'Notification List': 'Bildirim Listesi',
            'Bulk actions': 'Toplu işlemler',
            'Notification Subject': 'Konu',
            'Notification Created Datetime': 'Oluşturulma TarihiSaat',
            'Notification Priority': 'Öncelik',
            'Notification Message': 'İleti',
            'Notification Status': 'Durum',
            'Notification Mark As Read': 'Okundu Olarak İşaretle',
            'Notification Mark As Acknowledged': 'Kabul',
            'Notification Low': 'Alçak',
            'Notification Medium': 'Orta',
            'Notification High': 'Yüksek',
            'Notification Critical': 'Kritik',
            'Notification Unread': 'Okunmamış',
            'Notification Read': 'Okumak',
            'Notification Acknowledged': 'Kabul',
            'Notification Archive': 'Arşiv',
            'Notification Delete': 'Silmek',
            'Notification Apply': 'Uygulamak',
            'Notification Start Datetime': 'Tarih Saati Başlat',
            'Notification End Datetime': 'Bitiş TarihiSaat',
            'Notification Update Datetime': 'Tarih Saati Güncelle',
            //Monitoring
            'Run Commands': 'Komutları Çalıştır',
            'Pin Code': 'Posta Kodu',
            'Unlock': 'Kilidini aç',
            'Set Value': 'Değer Ayarla',
            'Fault Alarms': 'Arıza Alarmları',
            'Instantaneous Efficiency VALUE UNIT': 'Anlık Verimlilik {{VALUE}} {{UNIT}}',
            'Communication Online': 'Çevrimiçi',
            'Communication Offline': 'Çevrimdışı',
            'Equipment Status': 'Eğitim durumu',
            'Equipment Running': 'Koşarak',
            'Equipment Stopped': 'Durdu',
            'Show Up to': 'Şuraya Kadar Göster',
            All: 'Tüm',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} in {{TOTAL}} Alet -leri',
            //Microgrid
            'Microgrid Energy': 'Mikro Şebeke Enerjisi',
            'Microgrid Revenue': 'Mikro Şebeke Geliri',
            'Microgrid Carbon': 'Mikro Şebeke Karbon',
            'Photovoltaic Generation': 'Fotovoltaik Üretim',
            'EV Charger Consumption': 'EV Şarj Cihazı Tüketimi',
            'Load Consumption': 'Yük Tüketimi',
            'Grid Buy': 'Şebeke Satın Alma',
            'Grid Sell': 'Şebeke Satış',
            'EV Charger': 'EV Şarj Cihazı',
            'Heat Pump': 'Isı Pompası',
            'Photovoltaic': 'Fotovoltaik',
            'PCS Run State': 'PCS Çalıştırma Durumu',
            'PCS Unknown': 'Bilinmemiş',
            'PCS Initializing': 'Initializing',
            'PCS Standby': 'Standby',
            'PCS Shutdown': 'Kapa çeneni',
            'PCS Fault': 'Hata',
            'PCS Running': 'Çıkıyor',
            'Battery Power': 'Battery power',
            'Photovoltaic Power': 'Fotovoltaik gücü',
            'Grid Power': 'Grid gücü',
            'Load Power': 'Yükleme gücü',
            Reporting: 'Rapor',
            Maintenance: 'Yedekleme',
            'Serial Number': 'Seri Numarası',
            Address: 'Adres',
            'Postal Code': 'Posta Kodu',
            'Rated Capacity': 'Değerli Kapacite',
            'Rated Power': 'Değerli Güç',
            Latitude: 'Latitude',
            Longitude: 'Yükseklik',
            'Strategy Management': 'Strateji yönetimi',
            'Charging Schedule': 'Yükleme Zamanı',
            'Charge Start Time': 'Yükleme Başlangıç Zamanı',
            'Charge End Time': 'Charge End Time',
            'Discharge Start Time': 'Başlangıç Zamanını Aç',
            'Discharge End Time': 'Açırma sonu zamanı',
            'Total Rated Power': 'Toplam Nominal Güç',
            'Total Rated Capacity': 'Toplam Nominal Kapasite',
            "Today's Charge": "Bugünün ödeme tutarı",
            "Today's Discharge": "Bugün taburcu olun",
            "Today's Generation": "Günümüzün enerji üretimi",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Toplam ücret',
            'Total Discharge': 'toplam deşarj',
            'Total Generation': 'Toplam Üretim',
            'Total Revenue': 'Toplam gelir',
            'Total Photovoltaic Generation': 'Toplam Fotovoltaik Üretim',
            'Total EV Charger Consumption': 'Toplam EV Şarj Cihazı Tüketimi',
            'Total Load Consumption': 'Toplam Yük Tüketimi',
            'Total Grid Buy': 'Toplam Şebeke Satın Alma',
            'Total Grid Sell': 'Toplam Şebeke Satış',
            'Total Efficiency': 'Toplam Verimlilik',
            'Discharge Achievement Rate': 'Deşarj Başarı Oranı',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Gelir sıralaması',
            'Efficiency Ranking': 'Verimlilik sıralaması',
            'Charge Ranking': 'Şarj kapasitesi sıralaması',
            'Discharge Ranking': 'Deşarj sıralaması',
            'Number of Microgrids': 'Mikro şebeke sayısı',
            'Number of Power Stations': 'Elektrik santrallerinin sayısı',
            'Microgrid List': 'Mikro Şebeke Listesi',
            'Select Microgrid': 'Mikro Şebeke Seç',
            'Previous Page': 'Önceki sayfa',
            'Next Page': 'Sonraki Sayfa',
            '7 Days': '7 gün',
            'Charge UNIT': 'Şarj {{UNIT}}',
            'Discharge UNIT': 'deşarj {{UNIT}}',
            'Generation UNIT': 'elektrik üretmek {{UNIT}}',
            'Energy Indicator': 'enerji endeksi',
            'Revenue Indicator': 'Verim göstergesi',
            'Carbon Indicator': 'karbon indeksi',

            // Energy Storage Power Station
            'Battery Operating State': 'Batarya İşlemi Durumu',
            'Battery State': 'Batarya durumu',
            'Battery Unknown': 'Bilinmemiş',
            'Battery Stopped': 'Durduruldu',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Hata', // 1
            'Battery Warning': 'Uyarı', // 2
            'Battery Standby': 'Standby', // 3
            'Battery Prohibit DisCharging': 'Yüklemeyi yasakla', // 4
            'Battery Prohibit Charging': 'Yüklemeyi yasakla', // 5
            'Battery Normal': 'Normal', // 6
            'Battery Charging': 'Yüklenmek', // 7
            'Battery Discharging': 'During discharge', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Lifecycle Fazi',
            'Use Phase': 'Use Phase',
            'Commissioning Phase': 'Komisyon Fazi',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Kurulum Aşaması',
            'Device Status': 'Cihaz Durumu',
            'Basic Information': 'Temel Bilgiler',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'invertörler',
            'Invertor Run State': 'Çalıştırma Durumu',
            'Invertor Unknown': 'Bilinmemiş',
            'Invertor Initializing': 'Initializing',
            'Invertor Standby': 'Standby',
            'Invertor Shutdown': 'Kapa çeneni',
            'Invertor Fault': 'Hata',
            'Invertor Running': 'Çıkıyor',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Oluşturulma Tarihi',
            'File Format': 'Dosya Biçimi',
            'File Size': 'Dosya Boyutu',
            Uploader: 'Yükleyici',
            //Error
            "The page you're looking for is not found": 'Aradığınız sayfa bulunamadı',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Adresin doğru olduğundan ve sayfanın taşınmadığından emin olun. ',
            'If you think this is a mistake,': 'Bunun bir hata olduğunu düşünüyorsanız,',
            'contact us': 'bize ulaşın',
            'Take me home': 'Beni eve götür',
            'Whoops, something went wrong!': 'Whoops, bir şeyler ters gitti!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Sayfayı yenilemeyi veya geri dönüp eylemi yeniden denemeyi deneyin. ',
            'If this problem persists,': 'Bu sorun devam ederse,',
            'Captcha Error': 'Captcha Hatası',
            'Confirm Password Error': 'Onay parolası eşleşmiyor',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Geçersiz bir parola sıfırlama \
      bağlantısına tıklamış gibi görünüyorsunuz. Lütfen tekrar deneyin.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Geçersiz bir kayıt hesabı \
      bağlantısına tıklamış gibi görünüyorsunuz. Lütfen tekrar deneyin.',
            //Tenant Bill
            'Lease Contract Number': 'Kira Sözleşme Numarası',
            Download: 'İndirmek',
            Print: 'Yazdırmak',
            'Payment Notice': 'Ödeme Bildirimi',
            'Bill To': 'Fatura Gönder',
            'Bill Number': 'Fatura Numarası',
            'Bill Date': 'Fatura Tarihi',
            'Payment Due Date': 'Ödeme Son Tarihi',
            'Amount Payable': 'Ödenecek Tutar',
            'Billing Period Start': 'Fatura Dönemi Başlangıcı',
            'Billing Period End': 'Fatura Dönemi Sonu',
            Quantity: 'Miktar',
            Price: 'Fiyat',
            Amount: 'Miktar',
            Subtotal: 'Ara toplam',
            'VAT Output Tax': 'KDV Çıkış Vergisi',
            'Total Amount Payable': 'Ödenecek Toplam Tutar',
            'Please make sure to pay on or before the payment due date above':
                'Lütfen yukarıdaki son ödeme tarihinde veya öncesinde ödeme yaptığınızdan emin olun',
            'Send money to the following account': 'Aşağıdaki hesaba para gönderin',
            'Account Name': 'Hesap Adı',
            'Bank Name': 'Banka Adı',
            'Bank Address': 'Banka Adresi',
            'RMB Account': 'RMB Hesabı',
            // button
            'Toggle Navigation': 'Navigasyonu Değiştir',
            // working calendar
            'Working Days': 'Çalışma Günleri',
            'Non Working Days': 'Çalışma Dışı Günler',
            'Select Row': 'Lütfen Veri Satırı Seçiniz',
            // Offline Meter Input
            'Daily Value': 'Günlük Değer',
            Date: 'Tarih',
            'Successfully Saved': 'Başarıyla Kaydedildi',
            'Previous Data Is Empty': 'Önceki veriler boş',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Sanal güç santralleri ile ilişkisi var',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Sažetak tablica',
            SubMeter: 'Podtablica',
            'Power Quality': 'Kualiti kuasa',
            'About Power Quality': 'Perihal kualiti kuasa',
            'Trend Values': 'Nilai trend',
            Category: 'Kategori',
            Type: 'Jenis',
            Unit: 'Unit',
            Limit: 'Had',
            'Normal Limit': 'Had normal',
            'Severe Limit': 'Had teruk',
            Compliance: 'Kadar pematuhan',
            'Worst Deviation': 'Sisihan terburuk',
            'Worst Time': 'Masa terburuk',
            'Severe Exceed Count': 'Kiraan lebihan teruk',
            'Worst Unbalance': 'Ketidakseimbangan maksimum',
            Hz: 'Hz',
            voltage: 'Voltan',
            current: 'Arus',
            frequency: 'Frekuensi',
            voltage_deviation: 'Sisihan voltan',
            current_unbalance: 'Ketidakseimbangan arus',
            voltage_unbalance: 'Ketidakseimbangan voltan',
            mean_deviation_pct: 'Sisihan purata (%)',
            p95_abs_deviation_pct: 'Sisihan mutlak P95 (%)',
            mean_abs_deviation_hz: 'Sisihan mutlak purata (Hz)',
            p95_abs_deviation_hz: 'Sisihan mutlak P95 (Hz)',
            mean_unbalance_pct: 'Ketidakseimbangan purata (%)',
            p95_unbalance_pct: 'Ketidakseimbangan P95 (%)',
            count: 'Kiraan',
            min: 'Min',
            max: 'Maks',
            mean: 'Purata',
            std: 'Sisihan piawai',
            p5: 'P5',
            p95: 'P95'
        }
    },
    ms: {
        translation: {
            // routes & menus
            Dashboard: 'Dashboard',
            'Space Data': 'Ruang',
            'Equipment Data': 'Peralatan',
            'Meter Data': 'Meter',
            'Tenant Data': 'Penyewa',
            'Store Data': 'Kedai',
            'Shopfloor Data': 'Bengkel',
            'Combined Equipment Data': 'Peralatan Gabungan',
            'Auxiliary System': 'Sistem Bantuan',
            Microgrid: 'Microgrid',
            'Energy Storage Power Station': 'Stesen Kuasa',
            'Photovoltaic Power Station': 'Stesen Kuasa',
            'Fault Alarm': 'Penggera Kesalahan',
            Monitoring: 'Pemantauan',
            'Advanced Reporting': 'Laporan Lanjutan',
            'Knowledge Base': 'Pangkalan Pengetahuan',
            'Energy Category Data': 'Kategori Tenaga',
            'Energy Item Data': 'Barangan Tenaga',
            Carbon: 'Emisi CO2',
            Cost: 'Kos',
            Output: 'Output',
            Income: 'Pendapatan',
            Efficiency: 'Kecekapan',
            Load: 'Memuatkan',
            Statistics: 'Statistik',
            'Batch Analysis': 'Analisis Kumpulan',
            Saving: 'Menyimpan',
            Plan: 'Rancang',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Penjejakan Peralatan',
            'Equipment Comparison': 'Perbandingan Peralatan',
            'Shopfloor Comparison': 'Perbandingan Peralatan',
            'Store Comparison': 'Perbandingan Peralatan',
            'Space Comparison': 'Perbandingan Peralatan',
            'Combined Equipment Comparison': 'Perbandingan Peralatan',
            'Tenant Comparison': 'perbandingan penyewa',
            'Environment Monitor': 'Monitor Alam Sekitar',
            'Meter Energy': 'Tenaga Meter',
            'Meter Carbon': 'Meter Emisi CO2',
            'Meter Cost': 'Kos Meter',
            'Meter Trend': 'Meter Trend',
            'Meter Realtime': 'Meter Masa Nyata',
            'Meter Saving': 'Penjimatan Meter',
            'Meter Plan': 'Pelan Meter',
            'Master Meter Submeters Balance': 'Baki Submeter Meter Master',
            'Meter Batch Analysis': 'Analisis Kelompok Meter',
            'Meter Comparison': 'Perbandingan Meter',
            'Meter Tracking': 'Penjejakan Meter',
            'Virtual Meter Saving': 'Penjimatan Meter Maya',
            'Virtual Meter Plan': 'Pelan Meter Maya',
            'Virtual Meter Energy': 'Tenaga Meter Maya',
            'Virtual Meter Carbon': 'Emisi CO2 Meter Maya',
            'Virtual Meter Cost': 'Kos Meter Maya',
            'Virtual Meter Batch Analysis': 'Analisis kelompok meter maya',
            'Virtual Meter Comparison': "Perbandingan Meter Maya",
            'Offline Meter Energy': 'Tenaga Meter Luar Talian',
            'Offline Meter Carbon': 'Emisi Meter CO2 Offline',
            'Offline Meter Cost': 'Kos Meter Luar Talian',
            'Offline Meter Batch Analysis': 'Analisis kelompok meter luar talian',
            'Offline Meter Saving': 'Penjimatan Meter Luar Talian',
            'Offline Meter Plan': 'Pelan Meter Luar Talian',
            'Offline Meter Input': 'Input Meter Luar Talian',
            'Tenant Bill': 'Bil Penyewa',
            'Energy Flow Diagram': 'Gambar Rajah Aliran Tenaga',
            'Distribution System': 'Sistem Pengedaran',
            'SVG System': 'Sistem Visualisasi SCADA',
            'Faults Data': 'Kesilapan',
            'Space Equipments': 'Peralatan Angkasa',
            'Combined Equipments': 'Peralatan Gabungan',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Jumlah Bilangan Pesanan Kerja',
            'Number of New Work Orders': 'Bilangan Pesanan Kerja Baharu',
            'Number of Inprogress Work Orders': 'Bilangan Pesanan Kerja Sedang Bertindak',
            'Number of Done Work Orders': 'Bilangan Pesanan Kerja Selesai',
            'Fuel Indicator': 'Penggunaan bahan bakar',
            'Charge Energy Indicator': 'Mengecas Tenaga',
            'Discharge Energy Indicator': 'Tenaga Pelepasan',
            'Charge Cost Indicator': 'Kos Caj',
            'Discharge Revenue Indicator': 'Hasil Pelepasan',
            'HVAC': 'HVAC',
            'Fire Control': 'Kawalan Kebakaran',

            // Dashboard
            'Welcome to MyEMS': 'Selamat datang ke MyEMS',
            'An Industry Leading Open Source Energy Management System':
                'Sistem Pengurusan Tenaga Sumber Terbuka Terkemuka Industri',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Penggunaan Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Kos Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Penggunaan Bulan Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Kos bulan ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Penggunaan {{CATEGORY}} {{VALUE}} {{UNIT}} dalam tempoh yang sama tahun lepas',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Bayaran {{CATEGORY}} {{VALUE}} {{UNIT}} dalam tempoh yang sama tahun lepas',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Penggunaan {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Bayaran {{UNIT}}',
            // Entities
            Space: 'Ruang',
            Equipment: 'Peralatan',
            Meter: 'Meter',
            'Offline Meter': 'Meter Luar Talian',
            'Virtual Meter': 'Meter Maya',
            Tenant: 'Penyewa',
            Store: 'Kedai',
            Shopfloor: 'Bengkel',
            'Combined Equipment': 'Peralatan Gabungan',
            'Cost Center': 'Pusat Kos',
            Name: 'Nama',
            DisplayName: 'Nama Paparan',
            UserName: 'Nama Pengguna',
            Description: 'Keterangan',
            'Energy Category': 'Kategori Tenaga',
            'Child Spaces': 'Ruang Kanak-kanak',
            'Associated Equipment': 'Peralatan Berkaitan',
            //Energy Categories
            Electricity: 'Elektrik',
            Water: 'Air',
            'Natural Gas': 'Gas Asli',
            // SidePanelModal
            Settings: 'Seting',
            'Set your own customized style': 'Mengesetkan gaya tersuai anda sendiri',
            'Color Scheme': 'Skema Warna',
            'Choose the perfect color mode for your app': 'Pilih mod warna yang sesuai untuk apl anda',
            Light: 'Cahaya',
            Dark: 'Gelap',
            'RTL Mode': 'Mod RTL',
            'Switch your language direction': 'Tukar arah bahasa anda',
            'Fluid Layout': 'Susun atur cecair',
            'Toggle container layout system': 'Sistem susun atur kontena togol',
            'Navigation Position': 'Kedudukan Navigasi',
            'Vertical': 'Menegak',
            'Top': 'bahagian atas',
            'Combo': 'Gabungan',
            'Transparent': 'Lutsinar',
            'Inverted': 'Songsang',
            'Card': 'Kad',
            'Vibrant': 'Menarik',
            'Select a suitable navigation system for your web application':
                'Pilih sistem navigasi yang sesuai untuk aplikasi web anda',
            'Vertical Nav': 'Tentera Laut Menegak',
            'Top Nav': 'Tentera Laut Atas',
            'Vertical Navbar Style': 'Gaya Navbar Menegak',
            'Switch between styles for your vertical navbar': 'Bertukar antara gaya untuk bar navigasi menegak anda',
            Language: 'Bahasa',
            'Switch between languages': 'Bertukar antara bahasa',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Seperti apa yang anda lihat?',
            'Get MyEMS now': 'Dapatkan MyEMS sekarang',
            Purchase: 'Editan Perusahaan',
            ContactInfo: 'Maklumat Hubungan',
            ProductWebsite: 'Laman Web Produk',
            CompanyWebsite: 'Laman Web Syarikat',
            SalesPhone: 'Telefon Jualan',
            // Query Panel
            'Base Period Begins': 'Tempoh Asas Bermula',
            'Base Period Ends': 'Tempoh Asas Berakhir',
            'Comparison Types': 'Jenis Perbandingan',
            'Year-Over-Year': 'Tahun Ke Tahun',
            'Month-On-Month': 'Bulan Ke Bulan',
            'Free Comparison': 'Perbandingan Percuma',
            'None Comparison': 'Tiada Perbandingan',
            'Reporting Period Begins': 'Tempoh pelaporan bermula',
            'Reporting Period Ends': 'Tempoh pelaporan berakhir',
            '(Optional)': '(Pilihan)',
            'Period Types': 'Jenis Tempoh',
            Yearly: 'Tahunan',
            Monthly: 'Bulanan',
            Weekly: 'Mingguan',
            Daily: 'Harian',
            Hourly: 'Jam',
            Submit: 'Hantar',
            'Input Energy Category': 'Kategori Tenaga Input',
            'Output Energy Category': 'Kategori Tenaga Output',
            'Fraction Parameter': 'Parameter pecahan',
            Search: 'Carian',
            //DateRangePicker
            sunday: 'Su',
            monday: 'Mo',
            tuesday: 'Tu',
            wednesday: 'We',
            thursday: 'Th',
            friday: 'Fr',
            saturday: 'Sa',
            ok: 'OK',
            today: 'Hari ini',
            yesterday: 'Semalam',
            hours: 'Jam',
            minutes: 'Minit',
            seconds: 'Saat',
            last7Days: '7 Hari Terakhir',
            'Select Date Range': 'Pilih Julat Tarikh',
            //Card Summaries and Line Charts
            'Base Period': 'Tempoh Asas',
            'Reporting Period': 'Tempoh Pelaporan',
            'Per Unit Area': 'Kawasan Unit',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Pengeluaran Seunit',
            Baseline: 'Garis dasar',
            Actual: 'Sebenar',
            'Baseline Value - Actual Value': 'Garis dasar - Sebenar',
            'Average Load': 'Beban purata',
            'Maximum Load': 'Beban Maksimum',
            'Load Factor': 'Faktor Beban',
            'Ratio of Average Load to Maximum Load': 'Nisbah beban purata kepada beban maksimum',
            'Carbon Dioxide Emissions by Energy Category': 'Pelepasan karbon dioksida mengikut kategori tenaga',
            'Costs by Energy Category': 'Kos mengikut Kategori Tenaga',
            'Incomes by Energy Category': 'Pendapatan mengikut Kategori Tenaga',
            'Electricity Consumption by Time-Of-Use': 'Penggunaan elektrik mengikut masa penggunaan',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use':
                'Pelepasan karbon dioksida elektrik mengikut masa penggunaan',
            'Electricity Cost by Time-Of-Use': 'Kos elektrik mengikut masa penggunaan',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Komperusi oleh Barangan Tenaga',
            'Ton of Standard Coal by Energy Category': 'Tan arang batu standard (TCE) mengikut kategori tenaga',
            'Ton of Carbon Dioxide Emissions by Energy Category':
                'Tan pelepasan karbon dioksida (TCO2E) mengikut kategori tenaga',
            'Reporting Period Consumption CATEGORY UNIT': 'Tempoh Pelaporan Penggunaan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Tempoh Pelaporan Penggunaan {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Tempoh Pelaporan Penggunaan {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Tempoh Pelaporan Penggunaan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Tempoh Asas Penggunaan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Tempoh Pelaporan Penggunaan {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Tempoh Pelaporan Penggunaan {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Tempoh Asas Penggunaan {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT':
                'Perkadaran Ruang Kanak-kanak mengikut Kategori Tenaga {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Jumlah Perkadaran Ruang Kanak-kanak',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Tempoh pelaporan pelepasan karbon dioksida {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Tempoh pelaporan pelepasan karbon dioksida {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Tempoh Asas Pelepasan Karbon Dioksida {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Kos Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Kos Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Kos Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Output Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Output Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Output Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Output Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Output Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Pendapatan Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Pendapatan Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Pendapatan Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Tempoh Pelaporan Jumlah Pendapatan {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Tempoh Pelaporan Kecekapan Kumulatif {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Tempoh Pelaporan Kecekapan Kumulatif {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Tempoh Pelaporan Kecekapan Komprehensif Kumulatif {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Tempoh Pelaporan Kecekapan Komprehensif Kumulatif {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Tempoh Asas Kecekapan Komprehensif Kumulatif {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Kecekapan Seketika {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Kecekapan Seketika {{UNIT}}',
            'Equipment Efficiency Indicator': 'Penunjuk Kecekapan Tenaga Peralatan',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Kecekapan Komprehensif Seketika {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Tempoh Pelaporan Kecekapan Kumulatif {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Tempoh Pelaporan Kecekapan Kumulatif {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Tempoh Asas Kecekapan Kumulatif {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Tempoh Asas Kecekapan Kumulatif {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Tempoh Asas {{CATEGORY}} Beban Maksimum {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Tempoh Pelaporan {{CATEGORY}} Beban Maksimum {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Tempoh Pelaporan {{CATEGORY}} Beban purata {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Tempoh Pelaporan {{CATEGORY}} Faktor Beban',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Tempoh Asas {{CATEGORY}} Beban purata {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Tempoh Pelaporan {{CATEGORY}} Nilai purata {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Tempoh Pelaporan {{CATEGORY}} Nilai Maksimum {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Tempoh Pelaporan {{CATEGORY}} Nilai Minimum {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Tempoh Pelaporan {{CATEGORY}} Min Aritmetik {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Tempoh Pelaporan {{CATEGORY}} Median (Nilai Pertengahan) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Tempoh Pelaporan {{CATEGORY}} Sisihan Piawai Sampel {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Tempoh Pelaporan {{CATEGORY}} Sampel Varians {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Penjimatan Tempoh Pelaporan {{CATEGORY}} (Garis dasar - Sebenar) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Tempoh Pelaporan Berkurangan {{CATEGORY}} (Garis dasar - Sebenar) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Penjimatan Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Penjimatan Tempoh Asas {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Tempoh Pelaporan Penggunaan Meter Induk {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Tempoh Pelaporan Penggunaan Meter Induk {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Tempoh Pelaporan Penggunaan Submeter {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Tempoh Pelaporan Penggunaan Submeter {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Perbezaan Tempoh Pelaporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Perbezaan Peratusan Tempoh Pelaporan',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Perbezaan Tempoh Pelaporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Nilai Trend',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Senarai Kesalahan',
            'Reporting Period Number of Fault VALUE': 'Tempoh Pelaporan Bilangan Kesalahan {{VALUE}}',
            'All Faults': 'Semua Kesalahan',
            'Space Faults': 'Kesalahan Angkasa',
            'Number of All Faults': 'Bilangan Semua Kesalahan',
            'Number of Space Faults': 'Bilangan Kesalahan Ruang',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Tan arang batu standard',
            'Ton of Carbon Dioxide Emissions': 'Tan pelepasan karbon dioksida',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Pelepasan karbon setiap unit penggunaan tenaga',
            'Operating Characteristic Curve': 'Lengkung karakteristik operasi',
            Tariff: 'Tarif',
            'Detailed Data': 'Data terperinci',
            'Child Spaces Data': 'Data Ruang Kanak-kanak',
            'Associated Equipment Data': 'Data Peralatan Berkaitan',
            'This Year': 'Tahun ini',
            'The Same Period Last Year': 'Tempoh yang sama tahun lepas',
            'This Month': 'Bulan Ini',
            'This Day': 'Hari Ini',
            Total: 'Jumlah',
            'No data found': 'Tiada data ditemui',
            Export: 'Eksport',
            Datetime: 'Masa tarikh',
            'Time-Of-Use Type': 'Jenis Masa Penggunaan',
            'Top-Peak': 'Puncak Atas',
            'On-Peak': 'On-Peak',
            'Mid-Peak': 'Pertengahan Puncak',
            'Off-Peak': 'Luar Puncak',
            'Deep': 'Deep-Valley',
            Percentage: 'Peratusan',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Trend pada jam terakhir Titik Nilai Tenaga',
            Circuit: 'Litar',
            Point: 'Titik',
            'Realtime Value': 'Nilai Masa Nyata',
            //Meter Tracking
            'Meter List': 'Senarai Meter',
            'Edit Meter': 'Edit',
            'Start Value': 'Nilai Mula',
            'End Value': 'Nilai Akhir',
            'Difference Value': 'Perbezaan Nilai',
            'Start Integrity Rate': 'Mulakan Kadar Integriti(%)',
            'End Integrity Rate': 'Tamatkan Kadar Integriti(%)',
            'Full Integrity Rate': 'Kadar Integriti Penuh(%)',
            //Equipment Tracking
            'Equipment List': 'Senarai Peralatan',
            'Edit Equipment': 'Edit',
            //Profile Dropdown
            Feedback: 'Maklum balas',
            'Account Settings': 'Tetapan Akaun',
            Logout: 'Log keluar',
            //Authentication
            'Log in': 'Log masuk',
            'Email address': 'Alamat e-mel',
            'Phone Number': 'Nombor telefon',
            Password: 'Kata laluan',
            CaptchaCode: 'Captcha',
            Refresh: 'Refresh',
            'Remember me': 'Ingat saya',
            'Logged in as ': 'Log masuk sebagai ',
            'Forgot Password?': 'Lupa Kata Laluan?',
            'Forgot your password?': 'Lupa kata laluan anda?',
            "Enter your email and we'll send you a reset link":
                'Masukkan e-mel anda dan kami akan menghantar pautan set semula kepada anda',
            "Enter your email and we'll send you a registration link":
                'Masukkan e-mel anda dan kami akan menghantar pautan pendaftaran kepada anda',
            'Reset Password': 'Set Semula Kata Laluan',
            'Thanks for using MyEMS!': 'Terima kasih kerana menggunakan MyEMS!',
            'You are now successfully signed out': 'Anda kini berjaya mendaftar keluar',
            'Return to Login': 'Kembali ke Log Masuk',
            'Please check your email!': 'Sila semak e-mel anda!',
            'An email has been sent to ': 'E-mel telah dihantar kepada ',
            'Please click on the included link to reset your password':
                'Sila klik pada pautan yang disertakan untuk menetapkan semula kata laluan anda',
            'Please click on the included link to register your account':
                'Sila klik pada pautan yang disertakan untuk mendaftarkan akaun anda',
            'An email with password reset link is sent to ': 'Pautan e-mel dengan set semula kata laluan dihantar kepada ',
            'Change Password': 'Tukar Kata Laluan',
            'Old Password': 'Kata Laluan Lama',
            'New Password': 'Kata Laluan Baru',
            'Confirm Password': 'Sahkan Kata Laluan',
            'Update Password': 'Kemas kini Kata Laluan',
            'Password has been changed!': 'Kata laluan telah ditukar!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below..':
                'Kod pengesahan telah dihantar ke peti masuk anda. \
      Sila salin ke kotak input di bawah.',
            'New to MyEMS': 'Baru mengenali MyEMS',
            'Create an account': 'Buat akaun',
            'EMAIL Account registration successful': '{{EMAIL}} Pendaftaran akaun berjaya',
            'Thanks for verifying your account!': 'Terima kasih kerana mengesahkan akaun anda!',
            'Your code is': 'Kod anda ialah',
            'Send verification code': 'Hantar kod pengesahan',
            'Please wait for NUMBER seconds': 'Sila tunggu {{NUMBER}} Saat',
            'Password reset': 'Penetapan semula kata laluan',
            'Please wait for approval': 'Sila tunggu kelulusan',
            //notification
            Notifications: 'Pemberitahuan',
            'Mark all as read': 'Tandakan semua sebagai dibaca',
            'View all': 'Semua',
            'Notification New': 'BARU',
            'Notification Earlier': 'AWAL',
            'Notification List': 'Senarai Pemberitahuan',
            'Bulk actions': 'Tindakan pukal',
            'Notification Subject': 'Subjek',
            'Notification Created Datetime': 'Dibuat Datetime',
            'Notification Priority': 'Keutamaan',
            'Notification Message': 'Mesej',
            'Notification Status': 'Status',
            'Notification Mark As Read': 'Tandakan Sebagai Baca',
            'Notification Mark As Acknowledged': 'Mengakui',
            'Notification Low': 'Rendah',
            'Notification Medium': 'Sederhana',
            'Notification High': 'Tinggi',
            'Notification Critical': 'Kritikal',
            'Notification Unread': 'Belum dibaca',
            'Notification Read': 'Membaca',
            'Notification Acknowledged': 'Diiktiraf',
            'Notification Archive': 'Arkib',
            'Notification Delete': 'Menghapuskan',
            'Notification Apply': 'Memohon',
            'Notification Start Datetime': 'Tarikh Mula',
            'Notification End Datetime': 'Tarikh Tamat',
            'Notification Update Datetime': 'Kemas kini Datetime',
            //Monitoring
            'Run Commands': 'Jalankan Perintah',
            'Pin Code': 'Kod Pin',
            'Unlock': 'Buka kunci',
            'Set Value': 'Tetapkan Nilai',
            'Fault Alarms': 'Penggera Kesalahan',
            'Instantaneous Efficiency VALUE UNIT': 'Kecekapan Seketika {{VALUE}} {{UNIT}}',
            'Communication Online': 'Dalam talian',
            'Communication Offline': 'Luar talian',
            'Equipment Status': 'Status Peralatan',
            'Equipment Running': 'Menjalankan',
            'Equipment Stopped': 'Berhenti',
            'Show Up to': 'Tunjukkan kepada',
            All: 'Semua',
            'FROM - TO of TOTAL': '{{FROM}} - {{TO}} daripada {{TOTAL}} Peralatan',
            //Microgrid
            'Microgrid Energy': 'Tenaga Microgrid',
            'Microgrid Revenue': 'Hasil Microgrid',
            'Microgrid Carbon': 'Mikrogrid Karbon',
            'Photovoltaic Generation': 'Penjanaan Fotovoltaik',
            'EV Charger Consumption': 'Penggunaan Pengecas EV',
            'Load Consumption': 'Penggunaan Beban',
            'Grid Buy': 'Pembelian Grid',
            'Grid Sell': 'Jualan Grid',
            'EV Charger': 'Pengecas EV',
            'Heat Pump': 'Pam Haba',
            'Photovoltaic': 'fotovoltaik',
            'PCS Run State': 'PCS Run State',
            'PCS Unknown': 'Tidak diketahui',
            'PCS Initializing': 'Memulakan',
            'PCS Standby': 'Bersedia',
            'PCS Shutdown': 'Matikan',
            'PCS Fault': 'Gagal',
            'PCS Running': 'Jalankan',
            'Battery Power': 'Battery power',
            'Photovoltaic Power': 'Kuasa fotovoltaik',
            'Grid Power': 'Kuasa grid',
            'Load Power': 'Muat kuasa',
            Reporting: 'Laporan',
            Maintenance: 'Kekal',
            'Serial Number': 'Nombor Siri',
            Address: 'Alamat',
            'Postal Code': 'Kod Postal',
            'Rated Capacity': 'Kemampuan Dinilai',
            'Rated Power': 'Kuasa Dinilai',
            Latitude: 'Latitud',
            Longitude: 'Longitud',
            'Strategy Management': 'Pengurusan strategi',
            'Charging Schedule': 'Memuatkan Jadual',
            'Charge Start Time': 'Muat Masa Mula',
            'Charge End Time': 'Masa Akhir Muat',
            'Discharge Start Time': 'Masa Mula Buang',
            'Discharge End Time': 'Masa Akhir Buang',
            'Total Rated Power': 'Jumlah Kuasa Dinilai',
            'Total Rated Capacity': 'Jumlah Kapasiti Dinilai',
            "Today's Charge": "Jumlah caj hari ini",
            "Today's Discharge": "Discharge hari ini",
            "Today's Generation": "Penjanaan kuasa hari ini",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Jumlah caj',
            'Total Discharge': 'jumlah pelepasan',
            'Total Generation': 'Jumlah Penjanaan',
            'Total Revenue': 'Jumlah hasil',
            'Total Photovoltaic Generation': 'Jumlah Penjanaan Fotovoltaik',
            'Total EV Charger Consumption': 'Jumlah Penggunaan Pengecas EV',
            'Total Load Consumption': 'Jumlah Penggunaan Beban',
            'Total Grid Buy': 'Jumlah Pembelian Grid',
            'Total Grid Sell': 'Jumlah Jualan Grid',
            'Total Efficiency': 'Jumlah Kecekapan',
            'Discharge Achievement Rate': 'Kadar Pencapaian Pelepasan',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Kedudukan hasil',
            'Efficiency Ranking': 'Kedudukan kecekapan',
            'Charge Ranking': 'Kedudukan kapasiti pengecasan',
            'Discharge Ranking': 'Kedudukan pelepasan',
            'Number of Microgrids': 'Bilangan mikrogrid',
            'Number of Power Stations': 'Bilangan stesen janakuasa',
            'Microgrid List': 'Senarai Microgrid',
            'Select Microgrid': 'Pilih Microgrid',
            'Previous Page': 'Halaman sebelumnya',
            'Next Page': 'Muka surat seterusnya',
            '7 Days': '7 hari',
            'Charge UNIT': 'caj {{UNIT}}',
            'Discharge UNIT': 'pelepasan {{UNIT}}',
            'Generation UNIT': 'menjana tenaga elektrik {{UNIT}}',
            'Energy Indicator': 'indeks tenaga',
            'Revenue Indicator': 'Penunjuk hasil',
            'Carbon Indicator': 'indeks karbon',

            // Energy Storage Power Station
            'Battery Operating State': 'Keadaan Operasi Bateri',
            'Battery State': 'Status Bateri',
            'Battery Unknown': 'Tidak diketahui',
            'Battery Stopped': 'Berhenti',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Gagal', // 1
            'Battery Warning': 'Amaran', // 2
            'Battery Standby': 'Bersedia', // 3
            'Battery Prohibit DisCharging': 'Melarangkan Nyahmuat', // 4
            'Battery Prohibit Charging': 'Melarang Memuatkan', // 5
            'Battery Normal': 'Normal', // 6
            'Battery Charging': 'Memuatkan', // 7
            'Battery Discharging': 'Semasa pembuangan', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Fasa Siklo Hidup',
            'Use Phase': 'Guna Tahap',
            'Commissioning Phase': 'Fasa Pemasangan',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Fasa Pemasangan',
            'Device Status': 'Status Peranti',
            'Basic Information': 'Maklumat Asas',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'penyongsang',
            'Invertor Run State': 'Run State',
            'Invertor Unknown': 'Tidak diketahui',
            'Invertor Initializing': 'Memulakan',
            'Invertor Standby': 'Bersedia',
            'Invertor Shutdown': 'Matikan',
            'Invertor Fault': 'Gagal',
            'Invertor Running': 'Jalankan',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Dicipta Datetime',
            'File Format': 'Format Fail',
            'File Size': 'Saiz Fail',
            Uploader: 'Pemuat naik',
            //Error
            "The page you're looking for is not found": 'Halaman yang anda cari tidak dijumpai',
            "Make sure the address is correct and that the page hasn't moved. ":
                'Pastikan alamat betul dan halaman tidak dialihkan. ',
            'If you think this is a mistake,': 'Jika anda fikir ini adalah kesilapan,',
            'contact us': 'Hubungi Kami',
            'Take me home': 'Bawa saya pulang',
            'Whoops, something went wrong!': 'Whoops, ada sesuatu yang tidak kena!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Cuba segarkan semula halaman atau kembali dan cuba lakukan tindakan sekali lagi. ',
            'If this problem persists,': 'Sekiranya masalah ini berterusan,',
            'Captcha Error': 'Ralat Captcha',
            'Confirm Password Error': 'Kata laluan sahkan tidak sepadan',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Nampaknya anda mengklik pautan \
      penetapan semula kata laluan yang tidak sah. Sila cubalah.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Nampaknya anda mengklik pautan \
      akaun pendaftaran tidak sah. Sila cubalah.',
            //Tenant Bill
            'Lease Contract Number': 'Nombor Kontrak Pajakan',
            Download: 'Muat turun',
            Print: 'Cetakan',
            'Payment Notice': 'Notis Pembayaran',
            'Bill To': 'Bil Kepada',
            'Bill Number': 'Nombor Bil',
            'Bill Date': 'Tarikh Bil',
            'Payment Due Date': 'Tarikh Akhir Pembayaran',
            'Amount Payable': 'Amaun Perlu Dibayar',
            'Billing Period Start': 'Tempoh Pengebilan Bermula',
            'Billing Period End': 'Tempoh Tamat Tempoh Pengebilan',
            Quantity: 'Kuantiti',
            Price: 'Harga',
            Unit: 'Unit',
            Amount: 'Jumlah',
            Subtotal: 'Subjumlah',
            'VAT Output Tax': 'Cukai Output VAT',
            'Total Amount Payable': 'Jumlah Amaun Yang Perlu Dibayar',
            'Please make sure to pay on or before the payment due date above':
                'Sila pastikan anda membayar pada atau sebelum tarikh akhir pembayaran di atas',
            'Send money to the following account': 'Hantar wang ke akaun berikut',
            'Account Name': 'Nama Akaun',
            'Bank Name': 'Nama Bank',
            'Bank Address': 'Alamat Bank',
            'RMB Account': 'Akaun RMB',
            // button
            'Toggle Navigation': 'Togol Navigasi',
            // working calendar
            'Working Days': 'Hari Bekerja',
            'Non Working Days': 'Hari Bukan Bekerja',
            'Select Row': 'Sila Pilih Baris Data',
            // Offline Meter Input
            'Daily Value': 'Nilai Harian',
            Date: 'Tarikh',
            'Successfully Saved': 'Berjaya Diselamatkan',
            'Previous Data Is Empty': 'Data Sebelumnya Kosong',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact id',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid fdd code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
            'API.INVALID_MENU_ID': 'Invalid menu id',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter id',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter uuid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point id',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule id',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor id',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
            'API.INVALID_SPACE_ID': 'Invalid space id',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space uuid',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store id',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store uuid',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff id',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant id',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user id',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user uuid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': 'Nilai meter luar talian tidak sah',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'New password is the same as the old password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
                'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Ada hubungan dengan Pjantan Kuasa Maya',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: 'Jadual Ringkasan',
            SubMeter: 'Subjadual',
            'Power Quality': 'Kualitas daya',
            'About Power Quality': 'Tentang kualitas daya',
            'Trend Values': 'Nilai tren',
            Category: 'Kategori',
            Type: 'Jenis',
            Unit: 'Satuan',
            Limit: 'Batas',
            'Normal Limit': 'Batas normal',
            'Severe Limit': 'Batas berat',
            Compliance: 'Tingkat kepatuhan',
            'Worst Deviation': 'Deviasi terburuk',
            'Worst Time': 'Waktu terburuk',
            'Severe Exceed Count': 'Jumlah pelampauan berat',
            'Worst Unbalance': 'Ketidakseimbangan maksimum',
            Hz: 'Hz',
            voltage: 'Tegangan',
            current: 'Arus',
            frequency: 'Frekuensi',
            voltage_deviation: 'Penyimpangan tegangan',
            current_unbalance: 'Ketidakseimbangan arus',
            voltage_unbalance: 'Ketidakseimbangan tegangan',
            mean_deviation_pct: 'Penyimpangan rata-rata (%)',
            p95_abs_deviation_pct: 'Penyimpangan absolut P95 (%)',
            mean_abs_deviation_hz: 'Penyimpangan absolut rata-rata (Hz)',
            frequency_deviation: 'Penyimpangan frekuensi',
            p95_abs_deviation_hz: 'Penyimpangan absolut P95 (Hz)',
            mean_unbalance_pct: 'Ketidakseimbangan rata-rata (%)',
            p95_unbalance_pct: 'Ketidakseimbangan P95 (%)',
            count: 'Jumlah',
            min: 'Min',
            max: 'Maks',
            mean: 'Rata-rata',
            std: 'Simpangan baku',
            p5: 'P5',
            p95: 'P95'
        }
    },
    id: {
        translation: {
            // routes & menus
            Dashboard: 'Overview',
            'Space Data': 'Data Ruang',
            'Equipment Data': 'Data Perangkat',
            'Meter Data': 'Data Meter',
            'Tenant Data': 'Data Tenant',
            'Store Data': 'Simpan Data',
            'Shopfloor Data': 'Data Workshop',
            'Combined Equipment Data': 'Data Perangkat Kombinasi',
            'Auxiliary System': 'Sistem Bantuan',
            Microgrid: 'Microgrid',
            'Energy Storage Power Station': 'Stasiun Daya',
            'Photovoltaic Power Station': 'Stasiun Daya',
            'Fault Alarm': 'Alarm Cacat',
            Monitoring: 'Monitor Peralatan',
            'Advanced Reporting': 'Laporan Lanjutan',
            'Knowledge Base': 'Dasar Pengetahuan',
            'Energy Category Data': 'Analis Klasifikasi Konsumsi Energi',
            'Energy Item Data': 'Analis Pembatasan Konsumsi Energi',
            Carbon: 'Emisi CO2',
            Cost: 'Analisis Biaya',
            Output: 'Analis Keluaran',
            Income: 'Analisi Pendapatan',
            Efficiency: 'Analis Efisiensi',
            Load: 'Analisi Muat',
            Statistics: 'Analisis Statistik',
            'Batch Analysis': 'Analisi Seri',
            Saving: 'Analis Penyimpanan Energi',
            Plan: 'Rencana',
            Prediction: 'Prediction',
            'Production': 'Production',
            'Space Production': 'Space Production',
            'Equipment Tracking': 'Buku Peralatan',
            'Equipment Comparison': 'Perbandingan Peralatan',
            'Shopfloor Comparison': 'Perbandingan Peralatan',
            'Store Comparison': 'Perbandingan Peralatan',
            'Space Comparison': 'Perbandingan Peralatan',
            'Combined Equipment Comparison': 'Perbandingan Peralatan',
            'Tenant Comparison': 'perbandingan penyewa',
            'Environment Monitor': 'Monitoring Lingkungan',
            'Meter Energy': 'Analis Konsumsi Energi Dari Meter',
            'Meter Carbon': 'Meter Emisi CO2',
            'Meter Cost': 'Analisi Biaya Tabel Pengukuran',
            'Meter Trend': 'Analisi Trend Meters',
            'Meter Realtime': 'Analisis Waktu Nyata Dari Meter Pengukuran',
            'Meter Saving': 'Analisis Penyimpanan Energi Dari Ukuran Meter',
            'Meter Plan': 'Rencana Meteran',
            'Master Meter Submeters Balance': 'Analisi Bilansi Tabel Skor Total',
            'Meter Batch Analysis': 'Analisis Seri Dari Meter Pengukuran',
            'Meter Comparison': 'Analisi Komparatif Dari Meter Ukuran',
            'Meter Tracking': 'Pemberi Tabel Keukuran',
            'Virtual Meter Saving': 'Analis Menyimpan Energi Tabel Virtual',
            'Virtual Meter Plan': 'Paket Meteran Virtual',
            'Virtual Meter Energy': 'Analis Konsum Energi Tabel Virtual',
            'Virtual Meter Carbon': 'Emisi CO2 Meter Virtual',
            'Virtual Meter Cost': 'Analisi Biaya Tabel Virtual',
            'Virtual Meter Batch Analysis': 'Analisi Batch Tabel Virtual',
            'Virtual Meter Comparison': "Perbandingan Meter Virtual",
            'Offline Meter Energy': 'Analis Konsum Energi Jadual Offline',
            'Offline Meter Carbon': 'Emisi Meter CO2 Offline',
            'Offline Meter Cost': 'Analisi Biaya Tabel Offline',
            'Offline Meter Batch Analysis': 'Analisi Batch Tabel Offline',
            'Offline Meter Saving': 'Analis Penyimpanan Energi Dari Tabel Offline',
            'Offline Meter Plan': 'Paket Pengukur Offline',
            'Offline Meter Input': 'Entri Data Tabel Offline',
            'Tenant Bill': 'Pembayaran Sengaja',
            'Energy Flow Diagram': 'Diagram Aliran Energi',
            'Distribution System': 'Sistem Distribusi Listrik',
            'SVG System': 'Sistem Visualisasi Konfigurasi',
            'Faults Data': 'Analisis Kesalahan',
            'Space Equipments': 'Peralatan Ruang',
            'Combined Equipments': 'Peralatan Kombinasi',
            'Energy Storage Power Station List': 'List',
            'Energy Storage Power Station Details': 'Details',
            'Energy Storage Power Station Reporting': 'Reporting',
            'Energy Storage Power Station Alarm': 'Alarm',
            'Energy Storage Power Station Maintenance': 'Maintenance',
            'Enter Production': 'Enter Production',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
            'Multiple Energy Storage Power Stations List': 'List',
            'Single Energy Storage Power Station': 'Single Power Station',
            'Single Energy Storage Power Station Dashboard': 'Dashboard',
            'Single Energy Storage Power Station Details': 'Details',
            'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
            'Energy Storage Power Station Reports': 'Power Station Reports',
            'Energy Storage Power Station Reports Energy': 'Energy',
            'Energy Storage Power Station Reports Revenue': 'Revenue',
            'Energy Storage Power Station Reports Parameters': 'Parameters',
            'Photovoltaic Power Station List': 'Power Station List',
            'Photovoltaic Power Station Details': 'Details',
            'Photovoltaic Power Station Reporting': 'Reporting',
            'Photovoltaic Power Station Alarm': 'Alarm',
            'Photovoltaic Power Station Maintenance': 'Maintenance',
            'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
            'Multiple Photovoltaic Power Stations List': 'List',
            'Single Photovoltaic Power Station': 'Single Power Station',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard',
            'Single Photovoltaic Power Station Details': 'Details',
            'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
            'Photovoltaic Power Station Reports': 'Power Station Reports',
            'Photovoltaic Power Station Reports Energy': 'Energy',
            'Photovoltaic Power Station Reports Revenue': 'Revenue',
            'Photovoltaic Power Station Reports Parameters': 'Parameters',
            'Work Order': 'Work Order',
            'Work Order Installation': 'Installation',
            'Work Order Repair': ' Repair',
            'Work Order Inspection': 'Inspection',
            'Total Number of Work Orders': 'Jumlah Total Perintah Kerja',
            'Number of New Work Orders': 'Jumlah Perintah Kerja Baru',
            'Number of Inprogress Work Orders': 'Jumlah Perintah Kerja yang Sedang Diproses',
            'Number of Done Work Orders': 'Jumlah Perintah Kerja yang Selesai',
            'Fuel Indicator': 'Konsum bahan bakar',
            'Charge Energy Indicator': 'Energi Pengisian Daya',
            'Discharge Energy Indicator': 'Energi Pembuangan Daya',
            'Charge Cost Indicator': 'Biaya Pengisian Daya',
            'Discharge Revenue Indicator': 'Pendapatan Pembuangan Daya',
            'HVAC': 'HVAC',
            'Fire Control': 'Pengendalian Kebakaran',

            // Dashboard
            'Welcome to MyEMS': 'Selamat Datang Di MyEMS',
            'An Industry Leading Open Source Energy Management System':
                'Industri Memimpin Sistem Manajemen Energi Sumber Terbuka',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Konsum Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Biaya Tahun Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Konsum Bulan Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": 'Biaya Bulan Ini {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Konsum Selama Periode Yang Sama Tahun Lalu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Biaya Untuk Periode Yang Sama Tahun Lalu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Konsum {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Biaya {{UNIT}}',
            // Entities
            Space: 'Ruang',
            Equipment: 'Peralatan',
            Meter: 'Gauges',
            'Offline Meter': 'Jadual Offline',
            'Virtual Meter': 'Tabel Virtual',
            Tenant: 'Penyewa',
            Store: 'Toko',
            Shopfloor: 'Workshop',
            'Combined Equipment': 'Peralatan Kombinasi',
            'Cost Center': 'Pusat Biaya',
            Name: 'Nama',
            DisplayName: 'Tampilkan Nama',
            UserName: 'Nama Pengguna',
            Description: 'Deskripsikan',
            'Energy Category': 'Klasifikasi Energi',
            'Child Spaces': 'Subspace',
            'Associated Equipment': 'Peralatan Yang Berhubungan',
            //Energy Categories
            Electricity: 'Listrik',
            Water: 'Water Tap',
            'Natural Gas': 'Gas Alami',
            // SidePanelModal
            Settings: 'Mengatur',
            'Set your own customized style': 'Tetapkan Gaya Suai Anda',
            'Color Scheme': 'Skema Warna',
            'Choose the perfect color mode for your app': 'Pilih Mode Warna Ideal Untuk Aplikasi Anda',
            Light: 'Warna Cerah',
            Dark: 'Gelap',
            'RTL Mode': 'Mod RTL',
            'Switch your language direction': 'Ubah Arah Bahasa Anda',
            'Fluid Layout': 'Bentangan Aliran',
            'Toggle container layout system': 'Tukar Sistem Bentangan Kontainer',
            'Navigation Position': 'Lokasi Bar Navigasi',
            'Vertical': 'Vertikal',
            'Top': 'Atas',
            'Combo': 'Kombinasi',
            'Transparent': 'Transparan',
            'Inverted': 'Terbalik',
            'Card': 'Kartu',
            'Vibrant': 'Hidup',
            'Select a suitable navigation system for your web application':
                'Pilih Sistem Bar Navigasi Yang Sesuai Untuk Aplikasi Web Anda',
            'Vertical Nav': 'Bar Navigasi Vertikal',
            'Top Nav': 'Bar Navigasi Atas',
            'Vertical Navbar Style': 'Gaya Bar Navigasi Vertikal',
            'Switch between styles for your vertical navbar': 'Tukar Gaya Bar Navigasi Vertikal',
            Language: 'Bahasa',
            'Switch between languages': 'Tukar Bahasa',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Saya Suka Sistem Ini?',
            'Get MyEMS now': 'Dapatkan MyEMS Sekarang',
            Purchase: 'Enterprise Edition',
            ContactInfo: 'Informasi Kontak',
            ProductWebsite: 'Situs Web Produk',
            CompanyWebsite: 'Situs Web Perusahaan',
            SalesPhone: 'Telepon Penjualan',
            // Query Panels
            'Base Period Begins': 'Mulai Periode Benchmark',
            'Base Period Ends': 'Akhir Periode Benchmark',
            'Comparison Types': 'Compare Types',
            'Year-Over-Year': 'Tahun lalu-tahun',
            'Month-On-Month': 'Bulan Pada Bulan',
            'Free Comparison': 'Rasio Kebebasan',
            'None Comparison': 'Tidak Dibandingkan Dengan',
            'Reporting Period Begins': 'Mulai Periode Laporan',
            'Reporting Period Ends': 'Akhir Periode Laporan',
            '(Optional)': '(Opsional)',
            'Period Types': 'Skala Waktu',
            Yearly: 'Tahun',
            Monthly: 'Bulan',
            Weekly: 'Minggu',
            Daily: 'Hari',
            Hourly: 'Jam',
            Submit: 'Kirim',
            'Input Energy Category': 'Klasifikasi Konsumsi Energi',
            'Output Energy Category': 'Klasifikasi Energi Keluaran',
            'Fraction Parameter': 'Parameter Fraksi',
            Search: 'Cari',
            //DateRangePicker
            sunday: 'Minggu',
            monday: 'Senin',
            tuesday: 'Selasa',
            wednesday: 'Rabu',
            thursday: 'Kamis',
            friday: 'Jumat',
            saturday: 'Sabtu',
            ok: 'Konfirmasi',
            today: 'Hari Ini',
            yesterday: 'Kemarin',
            hours: 'Jam',
            minutes: 'Cabang',
            seconds: 'Detik',
            last7Days: 'Tujuh Hari Terakhir',
            'Select Date Range': 'Pilih Jangkauan Tanggal',
            //Card Summaries and Line Charts
            'Base Period': 'Periode Dasar',
            'Reporting Period': 'Periode Laporan',
            'Per Unit Area': 'Nilai Area Unit',
            'Per Capita': 'Per Capita',
            'Per Unit Production': 'Nilai Produk Unit',
            Baseline: 'Nilai Garis Dasar',
            Actual: 'Nilai Sebenarnya',
            'Baseline Value - Actual Value': 'Nilai Garis Dasar - Nilai Sebenarnya',
            'Average Load': 'Bekas Rata-rata',
            'Maximum Load': 'Muat Maksimum',
            'Load Factor': 'Faktor Muat',
            'Ratio of Average Load to Maximum Load': 'Rasio Dari Beban Rata-rata Ke Beban Maksimum',
            'Carbon Dioxide Emissions by Energy Category': 'Proporci Emisi Dioksida Karbon',
            'Costs by Energy Category': 'Proporci Biaya',
            'Incomes by Energy Category': 'Proporci Pendapatan',
            'Electricity Consumption by Time-Of-Use': 'Konsum Daya Berbagi Waktu',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Waktu Berbagi Emisi Listrik Karbon Dioksida',
            'Electricity Cost by Time-Of-Use': 'Waktu Berbagi Biaya Listrik',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Proporci Konsumsi Yang Ditentukan',
            'Ton of Standard Coal by Energy Category': 'Proporci Ton Coal Standard (TCE)',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Proporci Ton Emisi Carbon Dioxide (TCO2E)',
            'Reporting Period Consumption CATEGORY UNIT': 'Konsum Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Konsum Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Konsum Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Konsum Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Konsum Periode Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Konsum Selama Periode Laporan {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Konsum Selama Periode Laporan {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Konsum Periode Dasar {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Proporci Klasifikasi Subspace {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Proporci Total Subspace',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Emisi Dioksida Karbon Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emisi Dioksida Karbon Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emisi Dioksida Karbon Selama Periode Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Biaya Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Biaya Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Biaya Peristiwa Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Output Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{EQUIPMENT}} Output Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Output Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Output Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Output Periode Benchmark {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Daftar Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Daftar Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Daftar Periode Dasar {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Total Pendapatan Selama Periode Laporan {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT':
                'Efisiensi Berkumpul Selama Periode Laporan {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Efisiensi Berkumpul Selama Periode Laporan {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Berkumpul Selama Periode Laporan {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Berkumpul Selama Periode Laporan {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Berkumpul Selama Periode Benchmark {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Efisiensi Segera {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Efisiensi Segera {{UNIT}}',
            'Equipment Efficiency Indicator': 'Indikator Efisiensi Energi Peralatan',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Efisiensi Komprensif Instan {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT':
                'Efisiensi Berkumpul Selama Periode Laporan {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Efisiensi Berkumpul Selama Periode Laporan {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Efisiensi Kumulatif Periode Dasar {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Efisiensi Kumulatif Periode Dasar {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Periode Dasar {{CATEGORY}} Muat Maksimum {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Periode Laporan {{CATEGORY}} Muat Maksimum {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Periode Laporan {{CATEGORY}} Bekas Rata-rata {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Periode Laporan {{CATEGORY}} Faktor Muat',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Periode Dasar {{CATEGORY}} Bekas Rata-rata {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Periode Laporan {{CATEGORY}} Nilai Rata-rata {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Periode Laporan {{CATEGORY}} Nilai Maksimum {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Periode Laporan {{CATEGORY}} Nilai Minimum {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Periode Laporan {{CATEGORY}}  Maksudnya Aritmetik {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Periode Laporan {{CATEGORY}} Median {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Periode Laporan {{CATEGORY}} Abaikan Standar Sampel {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Periode Laporan {{CATEGORY}} Variasi Sampel {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Penyimpanan Selama Periode Laporan {{CATEGORY}} (Baseline-Sebenar) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Pengurangan Dalam Periode Laporan {{CATEGORY}} (Baseline-Sebenar) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT':
                'Penyimpanan Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Penyelamatan Peristiwa Benchmark {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Total Konsum Tabel Selama Period Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Total Konsum Tabel Selama Period Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Konsum Menurut Tabel Selama Periode Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Konsum Menurut Tabel Selama Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Perbedaan Periode Laporan {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Percentage Perbedaan Selama Periode Laporan',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Perbedaan Periode Laporan {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Nilai Perkembangan',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Daftar Gagal',
            'Reporting Period Number of Fault VALUE': 'Jumlah Kesalahan Selama Periode Laporan: {{VALUE}}',
            'All Faults': 'Semua Kesalahan',
            'Space Faults': 'Kesalahan Ruang',
            'Number of All Faults': 'Jumlah Total Kesalahan',
            'Number of Space Faults': 'Jumlah Kesalahan Ruang',
            'Total Number of Faults': 'Total Number of Faults',
            'Number of New Faults': 'Number of New Faults',
            'Number of Inprogress Faults': 'Number of Inprogress Faults',
            'Number of Done Faults': 'Number of Done Faults',
            //Data Panels
            'Ton of Standard Coal': 'Ton Batubara Standar',
            'Ton of Carbon Dioxide Emissions': 'Ton Emisi Dioksida Karbon',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Emisi karbon per unit konsumsi energi',
            'Operating Characteristic Curve': 'kurva karakteristik operasi',
            Tariff: 'Kadar',
            'Detailed Data': 'Data Rincian',
            'Child Spaces Data': 'Data Subspace',
            'Associated Equipment Data': 'Data Peralatan Terhubung',
            'This Year': 'Tahun Ini',
            'The Same Period Last Year': 'Periode Yang Sama Tahun Lalu',
            'This Month': 'Bulan Ini',
            'This Day': 'Hari Ini',
            Total: 'Total',
            'No data found': 'Tidak Ada Data',
            Export: 'Eksport',
            Datetime: 'Waktu Tarikh',
            'Time-Of-Use Type': 'Jenis Berbagi Waktu',
            'Top-Peak': 'Tip',
            'On-Peak': 'Puncak',
            'Mid-Peak': 'Flat',
            'Off-Peak': 'Lembah',
            'Deep': 'Deep-Valley',
            Percentage: 'Persentase',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Tenderasi Titik Konsumsi Energi Dalam Jam Terakhir',
            Circuit: 'Loop',
            Point: 'Titik Data',
            'Realtime Value': 'Nilai Waktu Nyata',
            //Meter Tracking
            'Meter List': 'Daftar Meter Ukuran',
            'Edit Meter': 'Edit',
            'Start Value': 'Nilai Awal',
            'End Value': 'Nilai Akhir',
            'Difference Value': 'Perbedaan',
            'Start Integrity Rate': 'Memulai Tingkat Integritas Data(%)',
            'End Integrity Rate': 'Tingkat Integritas Data Akhir(%)',
            'Full Integrity Rate': 'Tingkat Integritas Data Umum(%)',
            //Equipment Tracking
            'Equipment List': 'Daftar Peranti',
            'Edit Equipment': 'Edit',
            //Profile Dropdown
            Feedback: 'Feedback',
            'Account Settings': 'Pengaturan Akaun',
            Logout: 'Keluar',
            //Authentication
            'Log in': 'Login',
            'Email address': 'Alamat Surel',
            'Phone Number': 'Nomor telepon',
            Password: 'Sandi',
            CaptchaCode: 'Kode Verifikasi',
            Refresh: 'Segar',
            'Remember me': 'Ingat Aku',
            'Logged in as ': 'Daftar Masuk ',
            'Forgot Password?': 'Lupakan Kata Sandi?',
            'Forgot your password?': 'Lupakan Kata Sandimu?',
            "Enter your email and we'll send you a reset link":
                'Masukkan Alamat Email Dan Kami Akan Mengirimkan Anda Link Reset',
            "Enter your email and we'll send you a registration link":
                'Masukkan Alamat Email Dan Kami Akan Mengirimkan Link Pendaftaran',
            'Reset Password': 'Reset Kata Sandi',
            'Thanks for using MyEMS!': 'Terima Kasih Telah Menggunakan MyEMS!',
            'You are now successfully signed out': 'Anda Berhasil Keluar',
            'Return to Login': 'Kembali Ke Daftar Masuk',
            'Please check your email!': 'Silakan Periksa Email Anda!',
            'An email has been sent to ': 'Email Telah Dikirim Ke ',
            'Please click on the included link to reset your password':
                'Silakan Klik Pada Link Di Dalam untuk Reset Kata Sandi Anda',
            'Please click on the included link to register your account':
                'Silakan Klik Pada Link Di Dalam Untuk Mendaftar Rekening Anda',
            'An email with password reset link is sent to ':
                'Sebuah Email Yang Mengandung Sambungan Reset Kata Sandi Telah Dikirim Ke ',
            'Change Password': 'Ubah Kata Sandi',
            'Old Password': 'Kata Sandi Asal',
            'New Password': 'Kata Sandi Baru',
            'Confirm Password': 'Ulangi Kata Sandi Baru',
            'Update Password': 'Kemaskini Kata Sandi',
            'Password has been changed!': 'Kata Sandi Telah Diubah!',
            'Verification code has been sent to your inbox. \
      Please copy it to the input box below.':
                'Kode Verifikasi Telah Dikirim Ke Kotak Masuk Anda. Silakan Salin Ke Kotak Masukan Di Bawah。',
            'New to MyEMS': 'Penggunaan Awal MyEMS',
            'Create an account': 'Daftar Rekening',
            'EMAIL Account registration successful': '{{EMAIL}}Reġistrasi Rekening Berhasil',
            'Thanks for verifying your account!': 'Terima Kasih Sudah Memeriksa Rekening Anda！',
            'Your code is': 'Kode Anda Adalah',
            'Send verification code': 'Kirim Kode Verifikasi',
            'Please wait for NUMBER seconds': 'Silakan Berdiri{{NUMBER}}Detik',
            'Password reset': 'Reset Kata Sandi',
            'Please wait for approval': 'Silakan Tunggu Ulang',
            //notification
            Notifications: 'Notis',
            'Mark all as read': 'Set Semua Sebagai Baca',
            'View all': 'Seluruh',
            'Notification New': 'BaruNew',
            'Notification Earlier': 'Sebelumnya',
            'Notification List': 'Senarai Notifikasi',
            'Bulk actions': 'Operasi Seri',
            'Notification Subject': 'Tema',
            'Notification Created Datetime': 'Tanggal Waktu Dibuat',
            'Notification Message': 'Isi',
            'Notification Priority': 'Prioritas',
            'Notification Status': 'Keadaan',
            'Notification Mark As Read': 'Tanda Sebagai Baca',
            'Notification Mark As Acknowledged': 'Konfirmasi',
            'Notification Low': 'Rendah',
            'Notification Medium': 'Dalam',
            'Notification High': 'Tinggi',
            'Notification Critical': 'Serius',
            'Notification Unread': 'Belum Dibaca',
            'Notification Read': 'Baca',
            'Notification Acknowledged': 'Dikonfirmasi',
            'Notification Archive': 'Arkib',
            'Notification Delete': 'Hapus',
            'Notification Apply': 'Aplikasi',
            'Notification Start Datetime': 'Mulai Tanggal Waktu',
            'Notification End Datetime': 'Tanggal Waktu Berakhir',
            'Notification Update Datetime': 'Perbarui Tanggal Waktu',
            //Monitoring
            'Run Commands': 'Jalankan Perintah',
            'Pin Code': 'Kode Pin',
            'Unlock': 'Membuka kunci',
            'Set Value': 'Tetapkan Nilai',
            'Fault Alarms': 'Alarm Cacat',
            'Instantaneous Efficiency VALUE UNIT': 'Efisiensi Segera {{VALUE}} {{UNIT}}',
            'Communication Status': 'Status Komunikasi',
            'Communication Online': 'Di Talian',
            'Communication Offline': 'Off Line',
            'Equipment Status': 'Status Perangkat',
            'Equipment Running': 'Bekerja',
            'Equipment Stopped': 'Matikan',
            'Show Up to': 'Tampilkan Kuantitas Per Halaman',
            All: 'Seluruh',
            'FROM - TO of TOTAL': 'Tampilan Saat Ini{{FROM}} - {{TO}} Total{{TOTAL}}Peranti',
            //Microgrid
            'Microgrid Energy': 'Energi Mikrogrid',
            'Microgrid Revenue': 'Pendapatan Mikrogrid',
            'Microgrid Carbon': 'Karbon Mikrogrid',
            'Photovoltaic Generation': 'Generasi Fotovoltaik',
            'EV Charger Consumption': 'Konsumsi Pengisi Daya EV',
            'Load Consumption': 'Konsumsi Beban',
            'Grid Buy': 'Pembelian dari Grid',
            'Grid Sell': 'Penjualan ke Grid',
            'EV Charger': 'Kargadó di EV',
            'Heat Pump': 'Pompa Panas',
            'Photovoltaic': 'Fotovoltaik',
            'PCS Run State': 'PCS Run State',
            'PCS Unknown': 'Tidak diketahui',
            'PCS Initializing': 'Menginisialisasi',
            'PCS Standby': 'Bersiap',
            'PCS Shutdown': 'Matikan',
            'PCS Fault': 'Gagal',
            'PCS Running': 'Running',
            'Battery Power': 'Battery power',
            'Photovoltaic Power': 'Kekuatan fotovoltaik',
            'Grid Power': 'Kuasa jaringan',
            'Load Power': 'Kuat muat',
            Reporting: 'Laporan',
            Maintenance: 'Penjagaan',
            'Serial Number': 'Nomor Seri',
            Address: 'Alamat',
            'Postal Code': 'Kode Postal',
            'Rated Capacity': 'Kapasitas Dinilai',
            'Rated Power': 'Kuasa Dinilai',
            Latitude: 'Latitude',
            Longitude: 'Longitude',
            'Strategy Management': 'Manajemen strategi',
            'Charging Schedule': 'Memuatkan Schedule',
            'Charge Start Time': 'Muat Waktu Mula',
            'Charge End Time': 'Waktu Akhir Muat',
            'Discharge Start Time': 'Buang Waktu Mula',
            'Discharge End Time': 'Waktu Akhir Buan',
            'Total Rated Power': 'Nilai Daya Total',
            'Total Rated Capacity': 'Kapasitas Nilai Total',
            "Today's Charge": "Jumlah penagihan hari ini",
            "Today's Discharge": "Keluar hari ini",
            "Today's Generation": "Pembangkit listrik saat ini",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Total biaya',
            'Total Discharge': 'debit total',
            'Total Generation': 'Generasi Total',
            'Total Revenue': 'Total pendapatan',
            'Total Photovoltaic Generation': 'Total Generasi Fotovoltaik',
            'Total EV Charger Consumption': 'Total Konsumsi Pengisi Daya EV',
            'Total Load Consumption': 'Total Konsumsi Beban',
            'Total Grid Buy': 'Total Pembelian dari Grid',
            'Total Grid Sell': 'Total Penjualan ke Grid',
            'Total Efficiency': 'Efisiensi Total',
            'Discharge Achievement Rate': 'Tingkat Pencapaian Pelepasan',
            // Revenue Indicator
            "Today's Cost": "Today's Cost",
            "Today's Income": "Today's Income",
            "Total Cost": "Total Cost",
            "Total Income": "Total Income",
            "Today's Revenue": "Today's Revenue",

            'Revenue Ranking': 'Peringkat pendapatan',
            'Efficiency Ranking': 'Peringkat efisiensi',
            'Charge Ranking': 'Peringkat kapasitas pengisian daya',
            'Discharge Ranking': 'Peringkat pelepasan',
            'Number of Microgrids': 'Jumlah microgrid',
            'Number of Power Stations': 'Jumlah pembangkit listrik',
            'Microgrid List': 'Daftar Mikrogrid',
            'Select Microgrid': 'Pilih Mikrogrid',
            'Previous Page': 'Halaman sebelumnya',
            'Next Page': 'Halaman selanjutnya',
            '7 Days': '7 hari',
            'Charge UNIT': 'Mengenakan biaya {{UNIT}}',
            'Discharge UNIT': 'memulangkan {{UNIT}}',
            'Generation UNIT': 'menghasilkan listrik {{UNIT}}',
            'Energy Indicator': 'indeks energi',
            'Revenue Indicator': 'Indikator hasil',
            'Carbon Indicator': 'indeks karbon',

            // Energy Storage Power Station
            'Battery Operating State': 'Status Operasi Bateri',
            'Battery State': 'Status Bateri',
            'Battery Unknown': 'Tidak diketahui',
            'Battery Stopped': 'Berhenti',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Gagal', // 1
            'Battery Warning': 'Peringatan', // 2
            'Battery Standby': 'Bersiap', // 3
            'Battery Prohibit DisCharging': 'Melarangkan Memotong', // 4
            'Battery Prohibit Charging': 'Melarangkan Memuatkan', // 5
            'Battery Normal': 'Normal', // 6
            'Battery Charging': 'Memuatkan', // 7
            'Battery Discharging': 'Selama pembebasan', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Tahap Sepeda Hidup',
            'Use Phase': 'Gunakan Tahap',
            'Commissioning Phase': 'Fase Komisionasi',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Tahap Instalasi',
            'Device Status': 'Status Perangkat',
            'Basic Information': 'Informasi Dasar',
            'Gateway': 'Gateway',
            'Grid Meter': 'Grid Meter',
            'Load Meter': 'Load Meter',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'inverter',
            'Invertor Run State': 'Run State',
            'Invertor Unknown': 'Tidak diketahui',
            'Invertor Initializing': 'Menginisialisasi',
            'Invertor Standby': 'Bersiap',
            'Invertor Shutdown': 'Matikan',
            'Invertor Fault': 'Gagal',
            'Invertor Running': 'Running',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': 'Waktu Generasi',
            'File Format': 'Format Berkas',
            'File Size': 'Ukuran Berkas',
            Uploader: 'Penguasa',
            'Upload Datetime': 'Waktu Pengiriman',
            //Error
            "The page you're looking for is not found": 'Halaman Yang Anda Cari Tidak Ada',
            "Make sure the address is correct and that the page hasn't moved":
                'Silakan Konfirmasi Bahwa Alamat Benar Dan Halaman Belum Dipindahkan',
            'If you think this is a mistake,': 'Jika Anda Berpikir Ini Adalah Kesalahan,',
            'contact us': 'Hubungi Kami',
            'Take me home': 'Bawa Aku Kembali Ke Halaman Rumah',
            'Whoops, something went wrong!': 'Oh, Ada Kesalahan!',
            'Try refreshing the page, or going back and attempting the action again':
                'Silakan Coba Menyegarkan Halaman, Atau Kembali Dan Coba Melakukan Operasi Ini Lagi',
            'If this problem persists,': 'Jika Masalah Terus Berlangsung,',
            'Captcha Error': 'Galat Kode Verifikasi',
            'Confirm Password Error': 'Dua Kata Sandi Tidak Cocok',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Sepertinya Anda Mengklik Pada Sambungan Sandi Reset Tidak Valid. Silakan Coba Lagi。',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Sepertinya Kau Mengklik Pada Link Pendaftaran Rekening Yang Tidak Valid. Silakan Coba Lagi。',
            //Tenant Bill
            'Lease Contract Number': 'Nomor Kontrak Sewa',
            Download: 'Download',
            Print: 'Mencetak',
            'Payment Notice': 'Pengumuman Pembayaran',
            'Bill To': 'Ke',
            'Bill Number': 'Nomor Faktur',
            'Bill Date': 'Tanggal Pernyataan',
            'Payment Due Date': 'Tarikh Tarikh Pembayaran',
            'Amount Payable': 'Jumlah Yang Dapat Dibayar',
            'Billing Period Start': 'Tanggal Awal Periode Penyelesaian',
            'Billing Period End': 'Tanggal Akhir Periode Penyelesaian',
            Quantity: 'Jumlah',
            Price: 'Harga',
            Unit: 'Unit',
            Amount: 'Uang',
            Subtotal: 'Subtotal',
            'VAT Output Tax': 'Pajak Output Pajak Nilai Tambahan',
            'Total Amount Payable': 'Jumlah Yang Harus Dibayar',
            'Please make sure to pay on or before the payment due date above':
                'Silakan Pastikan Pembayaran Dilakukan Pada Atau Sebelum Tanggal Pembayaran Yang Disebutkan Di Atas',
            'Send money to the following account': 'Pengiriman Ke Akun Berikutnya',
            'Account Name': 'Title Of Account',
            'Bank Name': 'Bank Membuka',
            'Bank Address': 'Alamat Bank',
            'RMB Account': 'Akaun RMB',
            // button
            'Toggle Navigation': 'Tukar Navigasi',
            // working calendar
            'Working Days': 'Minggu',
            'Non Working Days': 'Hari Tidak Bekerja',
            'Select Row': 'Silakan Pilih Baris Data Untuk Beroperasi',
            // Offline Meter Input
            'Daily Value': 'Data Sehari',
            Date: 'Tanggal',
            'Successfully Saved': 'Successfully Saved',
            'Previous Data Is Empty': 'Data Sebelumnya Kosong',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sesi Administrator Tidak Ada',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Sesi Administrator Telah Tamat Waktu',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Laporan Lanjutan Tidak Ada',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Permintaan Galat',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER':
                'Tidak Dapat Menetapkan Tabel Ukuran Yang Sudah Ditetapkan Sebagai Tabel Bawah Sebagai Tabel Total',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Perangkat Kombinasi Dan Hubungan Perangkat Sudah Ada',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Perangkat Kombinasi Dan Hubungan Perangkat Tidak Ada',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Hubungan Antara Peralatan Kombinasi Dan Meter Sudah Ada',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Hubungan Antara Peralatan Kombinasi Dan Meter Tidak Ada',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nama Perangkat Kombinasi Sudah Digunakan',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Perangkat Kombinasi Tidak Ada',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS':
                'Perangkat Kombinasi Dan Hubungan Meja Luar Talian Sudah Ada',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND':
                'Hubungan Antara Perangkat Kombinasi Dan Tabel Offline Tidak Ada',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE':
                'Nama Parameter Yang Berhubungan Dengan Perangkat Kombinasi Sudah Digunakan',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH':
                'Parameter Yang Berhubungan Dengan Perangkat Kombinasi Tidak Ada Atau Tidak Cocok',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Perangkat Kombinasi Dan Hubungan Meja Virtual Sudah Ada',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND':
                'Perangkat Kombinasi Dan Hubungan Meja Virtual Tidak Ada',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Nama Kontak Sudah Digunakan',
            'API.CONTACT_NOT_FOUND': 'Kontak Tidak Ada',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'ID Luar Pusat Biaya Sudah Ada',
            'API.COST_CENTER_NAME_EXISTS': 'Nama Pusat Biaya Sudah Ada',
            'API.COST_CENTER_NOT_FOUND': 'Pusat Biaya Tidak Ada',
            'API.COST_FILE_NOT_FOUND': 'Berkas Biaya Tidak Ada',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Nama Sumber Data Sudah Digunakan',
            'API.DATA_SOURCE_NOT_FOUND': 'Sumber Data Tidak Ada',
            'API.DATABASE_ERROR': 'Galat Pangkalan Data',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Tanggal Sudah Ada Dalam Kalender Kerja',
            'API.DATE_LOCAL_NOT_FOUND': 'Tanggal Lokal Tidak Ditemukan',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Nama Sirkuit Distribusi Sudah Digunakan',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Sirkuit Distribusi Tidak Ada',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Sirkuit Distribusi Dan Hubungan Titik Sudah Ada',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Hubungan Antara Sirkuit Distribusi Dan Titik Tidak Ada',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nama Sistem Distribusi Sudah Digunakan',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Sistem Distribusi Tidak Ada',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email Sudah Digunakan',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Pesan Surel Tidak Ada',
            'API.EMAIL_NOT_FOUND': 'Email Tidak Ada',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Hos Server Surat Sudah Digunakan',
            'API.EMAIL_SERVER_NOT_FOUND': 'Hos Server Surat Tidak Ada',
            'API.EMPTY_VARIABLES_ARRAY': 'Array Variabel Kosong',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Nama Klasifikasi Energi Sudah Digunakan',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Klasifikasi Energi Tidak Ada',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Klasifikasi Energi Telah Digunakan Dalam Sub Kategori Energi',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Klasifikasi Energi Telah Digunakan Dalam Tabel Pengukuran',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Klasifikasi Energi Yang Digunakan Dalam Tabel Offline',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Klasifikasi Energi Telah Digunakan Dalam Tarif',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Klasifikasi Energi Sudah Digunakan Dalam Tabel Virtual',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Link Grafik Aliran Energi Telah Digunakan',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Link Grafik Aliran Energi Tidak Ada Atau Tidak Cocok',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Nama grafik aliran energi sudah digunakan',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Nod grafik aliran energi sudah digunakan',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Nod grafik aliran energi tidak ada atau tidak cocok',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Diagram aliran energi tidak ada',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Subitem energi tidak termasuk kategori energi',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Subitem energi tidak termasuk kategori energi',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Subitem energi digunakan',
            'API.ENERGY_ITEM_NOT_FOUND': 'Subitem energi tidak ada',
            'API.ENERGY_ITEM_USED_IN_METER': 'Subitem energi telah digunakan dalam tabel pengukuran',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Subitem energi telah digunakan dalam tabel offline',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Subitem energi sudah digunakan dalam tabel virtual',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Hubungan antara peralatan dan meter sudah ada',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Hubungan antara peralatan dan meter tidak ada',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nama perangkat sudah digunakan',
            'API.EQUIPMENT_NOT_FOUND': 'Peranti tidak ada',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara perangkat dan tabel luar talian sudah ada',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara perangkat dan tabel luar talian tidak ada',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nama parameter terkait perangkat telah digunakan',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parameter terkait perangkat tidak ada atau tidak cocok',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara perangkat dan meja virtual sudah ada',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara perangkat dan meja virtual tidak ada',
            'API.ERROR': 'Kesalahan',
            'API.EXCEPTION': 'Abnormal',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Fail biaya pemulihan gagal',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Gagal memulihkan berkas pengetahuan',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Gagal memulihkan berkas tabel luar talian',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Gagal menyimpan berkas tabel offline',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Gagal mengunggah berkas biaya',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Gagal mengunggah berkas pengetahuan',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Gagal mengunggah berkas tabel luar talian',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Nama gerbang sudah digunakan',
            'API.GATEWAY_NOT_FOUND': 'Gateway tidak ada',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Tidak valid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Alamat tidak valid',
            'API.INVALID_ADDRESS_VALUE': 'Nilai alamat tidak valid',
            'API.INVALID_ADVANCED_REPORT_ID': 'ID laporan maju tidak valid',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Nilai area tidak valid',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Waktu akhir periode dasar tidak valid',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Waktu awal periode dasar tidak valid',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Rata Baud tidak valid',
            'API.INVALID_BUILDINGS_VALUE': 'Nilai bangunan tidak valid',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Jenis tidak valid',
            'API.INVALID_CHANNEL': 'Saluran tidak valid',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'ID perangkat kombinasi tidak valid',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nama perangkat kombinasi tidak valid',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'ID parameter berkaitan dengan perangkat kombinasi tidak valid',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME':
                'Nama parameter berkaitan dengan perangkat kombinasi tidak valid',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE':
                'Tipe parameter berkaitan dengan perangkat kombinasi tidak valid',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID perangkat kombinasi tidak valid',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Koneksi tidak valid',
            'API.INVALID_CONSTANT_VALUE': 'Nilai konstan tidak valid',
            'API.INVALID_CONTACT_ID': 'ID kontak tidak valid',
            'API.INVALID_CONTACT_NAME': 'Nama kontak tidak valid',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'ID pusat biaya tidak valid',
            'API.INVALID_COST_FILE_ID': 'ID berkas biaya tidak valid',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'ID sumber data tidak valid',
            'API.INVALID_DATA_SOURCE_NAME': 'Nama sumber data tidak valid',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Protokol sumber data tidak valid',
            'API.INVALID_DATE_LOCAL': 'Tarikh lokal tidak valid',
            'API.INVALID_DENOMINATOR_METER_UUID': 'UUID ukuran standar tidak valid',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Nama paparan tidak valid',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'ID sirkuit distribusi tidak valid',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nama sirkuit distribusi tidak valid',
            'API.INVALID_DISTRIBUTION_ROOM': 'Ruangan distribusi tidak valid',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'ID sistem distribusi tidak valid',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nama sistem distribusi tidak valid',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Kotak surat tidak valid',
            'API.INVALID_EMAIL_MESSAGE_ID': 'ID email tidak valid',
            'API.INVALID_EMAIL_SERVER_HOST': 'Hos server email tidak valid',
            'API.INVALID_EMAIL_SERVER_ID': 'ID server email tidak valid',
            'API.INVALID_END_DATE_FORMAT': 'Format tanggal akhir tidak valid',
            'API.INVALID_END_DATETIME': 'Tarikh akhir tidak valid',
            'API.INVALID_ENERGY_CATEGORY_ID': 'ID klasifikasi energi tidak valid',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Nama klasifikasi energi tidak valid',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'ID Graf Aliran Energi tidak valid',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'ID Link Graf Aliran Energi tidak valid',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nama diagram aliran energi tidak valid',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'ID Node Graf Aliran Energi tidak valid',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nama Node Graf Aliran Energi tidak valid',
            'API.INVALID_ENERGY_ITEM_ID': 'ID sub item energi tidak valid',
            'API.INVALID_ENERGY_ITEM_NAME': 'Nama sub item energi tidak valid',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Ekspresi tidak valid dalam ekspresi',
            'API.INVALID_EQUIPMENT_ID': 'ID perangkat tidak valid',
            'API.INVALID_EQUIPMENT_NAME': 'Nama perangkat tidak valid',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'ID parameter berkaitan perangkat tidak valid',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nama parameter terkait perangkat tidak valid',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Tipe parameter terkait perangkat tidak valid',
            'API.INVALID_EQUIPMENT_UUID': 'UUID perangkat tidak valid',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Ekspresi tidak valid',
            'API.INVALID_EXPRESSION_OBJECT': 'Objek ekspresi tidak valid',
            'API.INVALID_FDD_CODE': 'Kode kesalahan tidak valid',
            'API.INVALID_FLOORS_VALUE': 'Nilai lantai tidak valid',
            'API.INVALID_FROM_ADDR': 'Alamat tidak valid',
            'API.INVALID_GATEWAY_ID': 'ID gateway tidak valid',
            'API.INVALID_GATEWAY_NAME': 'Nama gerbang tidak valid',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Nilai batas jam tidak valid',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Nilai batas jam bawah tidak valid',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Nilai manajemen tidak valid',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Nilai hitungan tidak valid',
            'API.INVALID_IS_ENABLED': 'Tidak valid diaktifkan',
            'API.INVALID_IS_HIDDEN': 'Apakah menyembunyikan yang tidak valid',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Apakah nilai sewa tidak valid',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Apakah input tidak valid agregat',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Nilai penyewa utama tidak valid',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Apakah output tidak valid agregat',
            'API.INVALID_IS_OUTPUT_VALUE': 'Apakah output tidak valid agregat',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Apakah menyimpan nilai trend yang tidak valid',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Nilai titik virtual tidak valid',
            'API.INVALID_KGCE': 'Koefisien batubara standar kilogram tidak valid',
            'API.INVALID_KGCO2E': 'Koefisien emisi dioksida karbon kilogram tidak valid',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'ID berkas pengetahuan tidak valid',
            'API.INVALID_LATITUDE_VALUE': 'Nilai latitud tidak valid',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Nomor sewa tidak valid',
            'API.INVALID_LONGITUDE_VALUE': 'Nilai longitud tidak valid',
            'API.INVALID_LOW_LIMIT_VALUE': 'Nilai batas bawah tidak valid',
            'API.INVALID_MASTER_METER_ID': 'ID meter total tidak valid',
            'API.INVALID_MENU_ID': 'ID menu tidak valid',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Templat pesan tidak valid',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'ID meter tidak valid',
            'API.INVALID_METER_NAME': 'Nama meter tidak valid',
            'API.INVALID_METER_UUID': 'UUID ukuran tidak valid',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Nilai nama tidak valid',
            'API.INVALID_NEW_PASSWORD': 'Kata sandi baru tidak valid',
            'API.INVALID_NON_WORKING_DAY_ID': 'ID hari tidak bekerja tidak valid',
            'API.INVALID_NOTIFICATION_ID': 'ID pemberitahuan tidak valid',
            'API.INVALID_NUMERATOR_METER_UUID': 'UUID tabel numerator tidak valid',
            'API.INVALID_OBJECT_TYPE': 'Jenis objek tidak valid',
            'API.INVALID_OFFLINE_METER_DATA': 'Data tabel offline tidak valid',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'ID berkas tabel luar talian tidak valid',
            'API.INVALID_OFFLINE_METER_ID': 'ID tabel luar talian tidak valid',
            'API.INVALID_OFFLINE_METER_NAME': 'Nama tabel luar talian tidak valid',
            'API.INVALID_OFFLINE_METER_UUID': 'UUID tabel luar talian tidak valid',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Kata sandi lama tidak valid',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'ID ruang induk tidak valid',
            'API.INVALID_PASSWORD': 'Kata sandi tidak valid',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Maksimum saat ini tidak valid',
            'API.INVALID_PEAK_LOAD': 'Muatan puncak tidak valid',
            'API.INVALID_PERIOD_TYPE': 'Tipe siklus tidak valid',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'ID titik data tidak valid',
            'API.INVALID_POINT_NAME': 'Nama titik data tidak valid',
            'API.INVALID_PORT': 'Port tidak valid',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Prioritas tidak valid',
            'API.INVALID_PRIVILEGE': 'Keizinan tidak valid',
            'API.INVALID_PRIVILEGE_DATA': 'Data izin tidak valid',
            'API.INVALID_PRIVILEGE_ID': 'ID ijin tidak valid',
            'API.INVALID_PRIVILEGE_NAME': 'Nama ijin tidak valid',
            'API.INVALID_RATIO_VALUE': 'Nisbah variabel tidak valid',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Jawaban tidak valid',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Waktu tanggal akhir periode laporan tidak valid',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Periode laporan tidak valid waktu tanggal awal',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Tidak valid membutuhkan autentikasi',
            'API.INVALID_ROOMS_VALUE': 'Nilai ruang tidak valid',
            'API.INVALID_RULE_ID': 'ID aturan tidak valid',
            'API.INVALID_RULE_NAME': 'Nama aturan tidak valid',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'ID sensor tidak valid',
            'API.INVALID_SENSOR_NAME': 'Nama sensor tidak valid',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_PORT': 'Nomor port seri tidak valid',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sesi tidak valid, silakan log masuk lagi',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'ID workshop tidak valid',
            'API.INVALID_SHOPFLOOR_NAME': 'Nama workshop tidak valid',
            'API.INVALID_SHOPFLOOR_UUID': 'UUID workshop tidak valid',
            'API.INVALID_SOURCE_NODE_ID': 'ID node sumber tidak valid',
            'API.INVALID_SPACE_ID': 'ID ruang tidak valid',
            'API.INVALID_SPACE_NAME': 'Nama ruang tidak valid',
            'API.INVALID_SPACE_UUID': 'UUID ruang tidak valid',
            'API.INVALID_START_DATE_FORMAT': 'Format waktu awal tidak valid',
            'API.INVALID_START_DATETIME': 'Waktu awal tidak valid',
            'API.INVALID_STATUS': 'Keadaan tidak valid',
            'API.INVALID_STORE_ID': 'ID toko tidak valid',
            'API.INVALID_STORE_NAME': 'Nama toko tidak valid',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Deskripsi tipe storan tidak valid',
            'API.INVALID_STORE_TYPE_ID': 'ID tipe toko tidak valid',
            'API.INVALID_STORE_TYPE_NAME': 'Nama tipe toko tidak valid',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Kode penyimplifikasi tipe storan tidak valid',
            'API.INVALID_STORE_UUID': 'UUID toko tidak valid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'SVG tidak valid',
            'API.INVALID_SWITCHGEAR': 'Switchgear tidak valid',
            'API.INVALID_TARGET_NODE_ID': 'ID node target tidak valid',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Penghargaan tingkat tidak valid',
            'API.INVALID_TARIFF_ID': 'ID kadar tidak valid',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Penghargaan tingkat waktu-penggunaan tidak valid',
            'API.INVALID_TARIFF_TYPE': 'Jenis kadar tidak valid',
            'API.INVALID_TENANT_ID': 'ID penyewa tidak valid',
            'API.INVALID_TENANT_NAME': 'Nama penyewa tidak valid',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Deskripsi tipe penyewa tidak valid',
            'API.INVALID_TENANT_TYPE_ID': 'ID tipe penyewa tidak valid',
            'API.INVALID_TENANT_TYPE_NAME': 'Nama tipe penyewa tidak valid',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Kode penyimplifikasi tipe penyewa tidak valid',
            'API.INVALID_TENANT_UUID': 'UUID penyewa tidak valid',
            'API.INVALID_TEXT_MESSAGE_ID': 'ID SMS tidak valid',
            'API.INVALID_TIMEZONE_ID': 'ID zona waktu tidak valid',
            'API.INVALID_TOKEN': 'Token tidak valid',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Unit ukuran tidak valid',
            'API.INVALID_UNIT_OF_PRICE': 'Unit harga tidak valid',
            'API.INVALID_UNITS': 'Unit tidak valid',
            'API.INVALID_USER_ID': 'ID pengguna tidak valid',
            'API.INVALID_USER_NAME': 'Nama pengguna tidak valid',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Nama pengguna atau email tidak valid',
            'API.INVALID_USER_PHONE': 'Nomor telepon pengguna tidak valid',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Pengguna tidak valid, silakan log masuk lagi',
            'API.INVALID_USER_UUID': 'UUID pengguna tidak valid',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'ID meter variabel tidak valid',
            'API.INVALID_VARIABLE_METER_TYPE': 'Tipe meter variabel tidak valid',
            'API.INVALID_VARIABLE_NAME': 'Nama variabel tidak valid',
            'API.INVALID_VERIFICATION_CODE': 'Kode verifikasi tidak valid',
            'API.INVALID_VIRTUAL_METER_ID': 'ID tabel virtual tidak valid',
            'API.INVALID_VIRTUAL_METER_NAME': 'Nama tabel virtual tidak valid',
            'API.INVALID_VIRTUAL_METER_UUID': 'UUID tabel virtual tidak valid',
            'API.INVALID_WEB_MESSAGE_ID': 'ID pesan web tidak valid',
            'API.INVALID_WECHAT_MESSAGE_ID': 'ID pesan WeChat tidak valid',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'ID kalender kerja tidak valid',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Nama kalender kerja tidak valid',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Tidak dapat menghapus berkas pengetahuan dari disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Berkas dasar pengetahuan tidak ada',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
                'Tabel ringkasan tidak termasuk dalam kategori energi yang sama',
            'API.MASTER_METER_NOT_FOUND': 'Tabel ringkasan tidak ada',
            'API.MENU_NOT_FOUND': 'Menu tidak ada',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Nama meter sudah digunakan',
            'API.METER_NOT_FOUND': 'Meter tidak ada',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Variabel meter tidak ada',
            'API.METER_POINT_RELATION_EXISTS': 'Hubungan antara meter dan titik data sudah ada',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Hubungan antara meter dan titik data tidak ada',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
                'Kata sandi baru tidak dapat melebihi 100 karakter dalam panjang',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Hari tidak bekerja tidak ada',
            'API.NOT_FOUND': 'Tidak ada',
            'API.NOTIFICATION_NOT_FOUND': 'Notifikasi tidak ada',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Berkas tabel luar talian tidak ada',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nama tabel luar talian sudah digunakan',
            'API.INVALID_OFFLINE_METER_VALUE': 'Nilai meter offline tidak valid',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Variabel tabel luar talian tidak ada',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
                'Kata sandi lama tidak dapat melebihi 100 karakter dalam panjang',
            'API.PARENT_SPACE_NOT_FOUND': 'Ruang orang tua tidak ada',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Panjang sandi tidak dapat melebihi 100 karakter',
            'API.PASSWORDS_MATCH': 'Kata sandi baru cocok dengan kata sandi lama',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nama titik data sudah digunakan',
            'API.POINT_NOT_FOUND': 'Titik data tidak ada',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nama izin sudah digunakan',
            'API.PRIVILEGE_NOT_FOUND': 'Keizinan tidak ada',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nama aturan sudah digunakan',
            'API.RULE_NOT_FOUND': 'Aturan tidak ada',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nama sensor sudah digunakan',
            'API.SENSOR_NOT_FOUND': 'Sensor tidak hadir',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Hubungan antara sensor dan titik data sudah ada',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Hubungan antara sensor dan titik data tidak ada',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Hubungan antara workshop dan peralatan sudah ada',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Hubungan antara workshop dan peralatan tidak ada',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Hubungan antara workshop dan meter sudah ada',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Hubungan antara workshop dan meter tidak ada',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nama workshop sudah digunakan',
            'API.SHOPFLOOR_NOT_FOUND': 'Workshop tidak ada',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara workshop dan meja offline sudah ada',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara workshop dan meja offline tidak ada',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Hubungan antara workshop dan titik data sudah ada',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Hubungan antara workshop dan titik data tidak ada',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Hubungan antara workshop dan sensor sudah ada',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Hubungan antara workshop dan sensor tidak ada',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara workshop dan meja virtual sudah ada',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara workshop dan meja virtual tidak ada',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan kalender pekerjaan workshop sudah ada',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan antara workshop dan kalender kerja tidak ada',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Nod sumber tidak ada',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan perangkat kombinasi sudah ada',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND':
                'Hubungan antara ruang angkasa dan perangkat kombinasi tidak ada',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Hubungan antara ruang dan perangkat sudah ada',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Hubungan antara ruang dan peralatan tidak ada',
            'API.SPACE_METER_RELATION_EXISTS': 'Hubungan antara ruang dan meter sudah ada',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Hubungan antara ruang dan meter tidak ada',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nama ruang sudah digunakan',
            'API.SPACE_NOT_FOUND': 'Ruang tidak ada',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Ruang tidak ada dalam keizinan',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara ruang dan tabel luar talian sudah ada',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara ruang dan tabel luar talian tidak ada',
            'API.SPACE_POINT_RELATION_EXISTS': 'Hubungan ruang dan titik data sudah ada',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Hubungan antara ruang dan titik data tidak ada',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan sensor sudah ada',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Hubungan antara ruang angkasa dan sensor tidak ada',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan workshop sudah ada',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Hubungan antara ruang angkasa dan workshop tidak ada',
            'API.SPACE_STORE_RELATION_EXISTS': 'Hubungan antara ruang dan toko sudah ada',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Hubungan antara ruang dan toko tidak ada',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Hubungan antara ruang angkasa dan penyewa sudah ada',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Hubungan antara ruang angkasa dan penyewa tidak ada',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara ruang dan meja virtual sudah ada',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara ruang dan meja virtual tidak ada',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan antara ruang dan kalender kerja sudah ada',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan antara ruang dan kalender kerja tidak ada',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME':
                'Waktu tanggal awal harus lebih awal dari waktunya tanggal akhir',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Hubungan antara toko dan meter sudah ada',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Hubungan antara toko dan meter tidak ada',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Simpan nama yang sudah digunakan',
            'API.STORE_NOT_FOUND': 'Simpan tidak ada',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Hubungan antara toko dan meja offline sudah ada',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan antara toko dan meja offline tidak ada',
            'API.STORE_POINT_RELATION_EXISTS': 'Hubungan antara toko dan titik data sudah ada',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Hubungan antara toko dan titik data sudah ada',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Hubungan antara toko dan sensor sudah ada',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Hubungan sensor toko tidak ada',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Simpan nama tipe yang sudah digunakan',
            'API.STORE_TYPE_NOT_FOUND': 'Tipe penyimpanan tidak ada',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Simpan kode penyimplifikasi tipe yang digunakan',
            'API.STORE_TYPE_USED_IN_STORE': 'Tipe penyimpanan yang sudah digunakan dalam penyimpanan',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan antara toko dan meja virtual sudah ada',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan antara toko dan meja virtual tidak ada',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan antara toko dan kalender kerja sudah ada',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan antara toko dan kalender kerja tidak ada',
            'API.TARGET_NODE_NOT_FOUND': 'Nod sasaran tidak ada',
            'API.TARIFF_IN_USE': 'Kadar dalam penggunaan',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Rate dan pusat biaya sudah terkait',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Rate dan pusat biaya tidak terkait',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nama kadar sudah digunakan',
            'API.TARIFF_NOT_FOUND': 'Kadar tidak ada',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Hubungan Tenant dan Meter sudah ada',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Hubungan antara penyewa dan meter tidak ada',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nama yang sudah digunakan',
            'API.TENANT_NOT_FOUND': 'Tenant tidak ada',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Hubungan meja Tenant dan offline sudah ada',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Hubungan meja Tenant dan offline tidak ada',
            'API.TENANT_POINT_RELATION_EXISTS': 'Hubungan Tenant dan Data Point sudah ada',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Hubungan Tenant dan Data Point tidak ada',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Hubungan sensor Tenant sudah ada',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Hubungan sensor Tenant tidak ada',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nama dan tipe yang sudah digunakan',
            'API.TENANT_TYPE_NOT_FOUND': 'Nama dan tipe yang sudah digunakan',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Kode penyimplifikasi tipe Tenant digunakan',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tipe tenant sudah digunakan dalam penyewa',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Hubungan meja yang tegang dan virtual sudah ada',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Hubungan meja yang tegang dan virtual tidak ada',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Hubungan kalender tenan dan kerja sudah ada',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Hubungan kalender tegang dan kerja tidak ada',
            'API.TEXT_MESSAGE_NOT_FOUND': 'SMS tidak ditemukan',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Periode laporan harus lebih besar dari 15 menit',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Terkait dengan meja anak',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Terkait dengan subspace',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Berkait dengan parameter peralatan kombinasi',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Terkait dengan peralatan kombinasi',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Hubungan dengan sumber data',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Terkait dengan diagram aliran energi',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Berkait dengan parameter terkait peralatan',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Terkait dengan peralatan',
            'API.THERE_IS_RELATION_WITH_METER': 'Terkait dengan tabel pengukuran',
            'API.THERE_IS_RELATION_WITH_METERS': 'Berkait dengan skala berbilang',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Hubungan dengan tabel luar talian',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Hubungan dengan berbagai tabel luar talian',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Hubungan dengan tabel virtual',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'Terkait dengan sensor',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Berkait dengan workshop',
            'API.THERE_IS_RELATION_WITH_SPACES': 'Hubungan dengan ruang',
            'API.THERE_IS_RELATION_WITH_STORES': 'Berkait dengan toko',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'Berkait dengan penyewa',
            'API.THERE_IS_RELATION_WITH_USERS': 'Terhubung dengan pengguna',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Hubungan dengan tabel virtual',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Ada hubungan dengan Plant Daya Virtual',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Sumber data ini sedang digunakan oleh meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Meter ini digunakan oleh meter virtual',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Meja luar talian ini digunakan oleh meja virtual',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'Ruang tidak dapat dihapus',
            'API.TIMEZONE_NOT_FOUND': 'Zona waktu tidak ada',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token tidak ditemukan, silakan log masuk',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Akaun pengguna terkunci',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'Akaun pengguna telah habis',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'Nama pengguna sudah digunakan',
            'API.USER_NOT_FOUND': 'Pengguna tidak ada',
            'API.USER_PASSWORD_HAS_EXPIRED': 'Kata sandi pengguna telah habis',
            'API.USER_PRIVILEGE_NOT_FOUND': 'Tidak ditemukan keizinan pengguna',
            'API.USER_SESSION_NOT_FOUND': 'Tidak ditemukan sesi pengguna',
            'API.USER_SESSION_TIMEOUT': 'Sesi pengguna sudah habis',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID pengguna tidak ada, silakan log masuk',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nama tabel virtual sudah digunakan',
            'API.VIRTUAL_METER_NOT_FOUND': 'Tabel virtual tidak ada',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Tabel virtual untuk variabel tidak ada',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Titik data virtual seharusnya jumlah analog',
            'API.WEB_MESSAGE_NOT_FOUND': 'Informasi web tidak ada',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Informasi WeChat tidak ada',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nama kalender kerja sudah digunakan',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Kalender kerja tidak ada',

            MasterMeter: 'Tabel Ringkasan',
            SubMeter: 'Subtable',
            'Power Quality': 'Kualitas daya',
            'About Power Quality': 'Tentang kualitas daya',
            'Trend Values': 'Nilai tren',
            Category: 'Kategori',
            Type: 'Jenis',
            Unit: 'Satuan',
            Limit: 'Batas',
            'Normal Limit': 'Batas normal',
            'Severe Limit': 'Batas berat',
            Compliance: 'Tingkat kepatuhan',
            'Worst Deviation': 'Deviasi terburuk',
            'Worst Time': 'Waktu terburuk',
            'Severe Exceed Count': 'Jumlah pelampauan berat',
            'Worst Unbalance': 'Ketidakseimbangan maksimum',
            Hz: 'Hz',
            voltage: 'Tegangan',
            current: 'Arus',
            frequency: 'Frekuensi',
            voltage_deviation: 'Penyimpangan tegangan',
            current_unbalance: 'Ketidakseimbangan arus',
            voltage_unbalance: 'Ketidakseimbangan tegangan',
            mean_deviation_pct: 'Penyimpangan rata-rata (%)',
            p95_abs_deviation_pct: 'Penyimpangan absolut P95 (%)',
            mean_abs_deviation_hz: 'Penyimpangan absolut rata-rata (Hz)',
            frequency_deviation: 'Penyimpangan frekuensi',
            p95_abs_deviation_hz: 'Penyimpangan absolut P95 (Hz)',
            mean_unbalance_pct: 'Ketidakseimbangan rata-rata (%)',
            p95_unbalance_pct: 'Ketidakseimbangan P95 (%)',
            count: 'Jumlah',
            min: 'Min',
            max: 'Maks',
            mean: 'Rata-rata',
            std: 'Simpangan baku',
            p5: 'P5',
            p95: 'P95'
        }
    },
    zh_TW: {
        translation: {
            // routes & menus
            Dashboard: '總覽',
            'Space Data': '空間數據',
            'Equipment Data': '設備數據',
            'Meter Data': '計量表數據',
            'Tenant Data': '租⼾數據',
            'Store Data': '⾨店數據',
            'Shopfloor Data': '⾞間數據',
            'Combined Equipment Data': '組合設備數據',
            'Auxiliary System': '輔助系統',
            Microgrid: '微電網',
            'Energy Storage Power Station': '儲能電站',
            'Photovoltaic Power Station': '電站',
            'Fault Alarm': '故障報警',
            Monitoring: '設備監控',
            'Advanced Reporting': '⾼級報表',
            'Knowledge Base': '知識庫',
            'Energy Category Data': '能耗分類分析',
            'Energy Item Data': '能耗分項分析',
            Carbon: '碳排放分析',
            Cost: '成本分析',
            Output: '產出分析',
            Income: '收入分析',
            Efficiency: '效率分析',
            Load: '負荷分析',
            Statistics: '統計分析',
            'Batch Analysis': '批量分析',
            Saving: '節能分析',
            Plan: '計劃分析',
            Prediction: 'Prediction',
            'Production': '產量',
            'Space Production': '產量能耗分析',
            'Equipment Tracking': '設備台賬',
            'Equipment Comparison': '對比分析',
            'Shopfloor Comparison': '對比分析',
            'Store Comparison': '對比分析',
            'Space Comparison': '對比分析',
            'Combined Equipment Comparison': '對比分析',
            'Tenant Comparison': '租戶對比',
            'Environment Monitor': '環境監測',
            'Meter Energy': '計量表能耗分析',
            'Meter Carbon': '計量表碳排放分析',
            'Meter Cost': '計量表成本分析',
            'Meter Trend': '計量表趨勢分析',
            'Meter Realtime': '計量表實時分析',
            'Meter Saving': '計量表節能分析',
            'Meter Plan': '計量表計劃分析',
            'Master Meter Submeters Balance': '總分表平衡分析',
            'Meter Batch Analysis': '計量表批量分析',
            'Meter Comparison': '計量表對比分析',
            'Meter Tracking': '計量表台賬',
            'Virtual Meter Saving': '虛擬表節能分析',
            'Virtual Meter Plan': '虛擬表計劃分析',
            'Virtual Meter Energy': '虛擬表能耗分析',
            'Virtual Meter Carbon': '虛擬表碳排放分析',
            'Virtual Meter Cost': '虛擬表成本分析',
            'Virtual Meter Batch Analysis': '虛擬表批量分析',
            'Offline Meter Energy': '離線表能耗分析',
            'Offline Meter Carbon': '離線表碳排放分析',
            'Offline Meter Cost': '離線表成本分析',
            'Offline Meter Batch Analysis': '離線表批量分析',
            'Offline Meter Saving': '離線表節能分析',
            'Offline Meter Plan': '離線表計劃分析',
            'Offline Meter Input': '離線表數據錄入',
            'Tenant Bill': '租⼾賬單',
            'Energy Flow Diagram': '能流圖',
            'Distribution System': '配電系統',
            'SVG System': '組態可視化系統',
            'Faults Data': '故障分析',
            'Space Equipments': '空間設備',
            'Combined Equipments': '組合設備',
            'Energy Storage Power Station List': '電站列表',
            'Energy Storage Power Station Details': '設備監控',
            'Energy Storage Power Station Reporting': '數據報表',
            'Energy Storage Power Station Alarm': '故障報警',
            'Energy Storage Power Station Maintenance': '維護保養',
            'Enter Production': '產量錄入',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': '多站數據',
            'Multiple Energy Storage Power Stations Dashboard': '多站總覽',
            'Multiple Energy Storage Power Stations List': '電站列表',
            'Single Energy Storage Power Station': '單站數據',
            'Single Energy Storage Power Station Dashboard': '單站總覽',
            'Single Energy Storage Power Station Details': '設備數據',
            'Single Energy Storage Power Station Fault Alarm': '故障告警',
            'Energy Storage Power Station Reports': '統計報表',
            'Energy Storage Power Station Reports Energy': '電量報表',
            'Energy Storage Power Station Reports Revenue': '收益報表',
            'Energy Storage Power Station Reports Parameters': '數據査詢',
            'Photovoltaic Power Station List': '電站列表',
            'Photovoltaic Power Station Details': '設備監控',
            'Photovoltaic Power Station Reporting': '數據報表',
            'Photovoltaic Power Station Alarm': '故障報警',
            'Photovoltaic Power Station Maintenance': '維護保養',
            'Multiple Photovoltaic Power Stations': '多站數據',
            'Multiple Photovoltaic Power Stations Dashboard': '多站總覽',
            'Multiple Photovoltaic Power Stations List': '電站列表',
            'Single Photovoltaic Power Station': '單站數據',
            'Single Photovoltaic Power Station Dashboard': '單站總覽',
            'Single Photovoltaic Power Station Details': '設備數據',
            'Single Photovoltaic Power Station Fault Alarm': '故障告警',
            'Photovoltaic Power Station Reports': '統計報表',
            'Photovoltaic Power Station Reports Energy': '電量報表',
            'Photovoltaic Power Station Reports Revenue': '收益報表',
            'Photovoltaic Power Station Reports Parameters': '數據査詢',
            'Work Order': '⼯單管理',
            'Work Order Installation': '安裝記錄',
            'Work Order Repair': '維修記錄',
            'Work Order Inspection': '巡檢記錄',
            'Total Number of Work Orders': '工單總數',
            'Number of New Work Orders': '新工單數量',
            'Number of Inprogress Work Orders': '進行中的工單數量',
            'Number of Done Work Orders': '已完成工單數量',
            'Fuel Indicator': '耗油量',
            'Charge Energy Indicator': '充電能量',
            'Discharge Energy Indicator': '放電能量',
            'Charge Cost Indicator': '充電成本',
            'Discharge Revenue Indicator': '放電收益',
            'HVAC': '空調',
            'Fire Control': '消防',

            // Dashboard
            'Welcome to MyEMS': '歡迎使⽤ MyEMS',
            'An Industry Leading Open Source Energy Management System': '⾏業領先的開源能源管理系統',
            "This Year's Consumption CATEGORY VALUE UNIT": '本年消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": '本年成本 {{CATEGORY}}{{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": '本⽉消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": '本⽉成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                '去年同期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '去年同期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} 消耗 {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} 成本 {{UNIT}}',
            // Entities
            Space: '空間',
            Equipment: '設備',
            Meter: '計量表',
            'Offline Meter': '離線表',
            'Virtual Meter': '虛擬表',
            Tenant: '租⼾',
            Store: '⾨店',
            Shopfloor: '⾞間',
            'Combined Equipment': '組合設備',
            'Cost Center': '成本中⼼',
            Name: '名稱',
            DisplayName: '顯⽰名',
            UserName: '⽤⼾名',
            Description: '描述',
            'Energy Category': '能源分類',
            'Child Spaces': '⼦空間',
            'Associated Equipment': '相關設備',
            //Energy Categories
            Electricity: '電',
            Water: '⾃來⽔',
            'Natural Gas': '天然氣',
            // SidePanelModal
            Settings: '設置',
            'Set your own customized style': '設置您的⾃定義樣式',
            'Color Scheme': '配⾊⽅案',
            'Choose the perfect color mode for your app': '為您的應⽤選擇理想的⾊彩模式',
            Light: '亮⾊',
            Dark: '暗⾊',
            'RTL Mode': 'RTL 模式',
            'Switch your language direction': '改變你的語⾔⽅向',
            'Fluid Layout': '流動布局',
            'Toggle container layout system': '切換容器布局系統',
            'Navigation Position': '導航欄位置',
            'Vertical': '垂直',
            'Top': '頂部',
            'Combo': '組合',
            'Transparent': '透明',
            'Inverted': '反色',
            'Card': '卡片',
            'Vibrant': '活力',
            'Select a suitable navigation system for your web application': '為您的 web 應⽤程序選擇合適的導航欄系統',
            'Vertical Nav': '垂直導航欄',
            'Top Nav': '頂部導航欄',
            'Vertical Navbar Style': '垂直導航欄樣式',
            'Switch between styles for your vertical navbar': '切換垂直導航欄的樣式',
            Language: '語⾔',
            'Switch between languages': '切換語⾔',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Руссĸий',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中⽂',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': '喜歡這個系統?',
            'Get MyEMS now': '立即獲取 MyEMS',
            'PQ.About': '本分析涵蓋電壓偏差、電壓不平衡、頻率偏差與電流不平衡。電壓偏差以(U−Un)/Un×100%計算；頻率偏差以|f−fn|計算；三相不平衡以max(|Xi−Xavg|)/Xavg×100%計算，並要求三相通道時間對齊。結果基於所選計量表於報告期內之時間序列；若缺少三相通道或時間戳未對齊，將略過不平衡指標。瞬態尖峰或缺失採樣可能放大最差值，穩態評估建議參考合規率與P95等統計指標。',
            Purchase: '採購企業版',
            ContactInfo: '聯絡方式',
            ProductWebsite: '產品官網',
            CompanyWebsite: '公司官網',
            SalesPhone: '銷售電話',
            // Query Panels
            'Base Period Begins': '基準期開始',
            'Base Period Ends': '基準期結束',
            'Comparison Types': '比較類型',
            'Year-Over-Year': '去年同比',
            'Month-On-Month': '上⽉環比',
            'Free Comparison': '⾃由比',
            'None Comparison': '不比',
            'Reporting Period Begins': '報告期開始',
            'Reporting Period Ends': '報告期結束',
            '(Optional)': '(可選)',
            'Period Types': '時間尺度',
            Yearly: '年',
            Monthly: '⽉',
            Weekly: '周',
            Daily: '⽇',
            Hourly: '時',
            Submit: '提交',
            'Input Energy Category': '消耗能源分類',
            'Output Energy Category': '產出能源分類',
            'Fraction Parameter': '分式參數',
            Search: '搜索',
            //DateRangePicker
            sunday: '⽇',
            monday: '⼀',
            tuesday: '⼆',
            wednesday: '三',
            thursday: '四',
            friday: '五',
            saturday: '六',
            ok: '確定',
            today: '今天',
            yesterday: '昨天',
            hours: '時',
            minutes: '分',
            seconds: '秒',
            last7Days: '最近七天',
            'Select Date Range': '選擇⽇期範圍',
            //Card Summaries and Line Charts
            'Base Period': '基準期',
            'Reporting Period': '報告期',
            'Per Unit Area': '單位⾯積值',
            'Per Capita': '人均值',
            'Per Unit Production': '單位產品值',
            Baseline: '基線值',
            Actual: '實際值',
            'Baseline Value - Actual Value': '基線值-實際值',
            'Average Load': '平均負荷',
            'Maximum Load': '最⼤負荷',
            'Load Factor': '負荷系數',
            'Ratio of Average Load to Maximum Load': '平均負荷與最⼤負荷的比值',
            'Carbon Dioxide Emissions by Energy Category': '⼆氧化碳排放占比',
            'Costs by Energy Category': '成本占比',
            'Incomes by Energy Category': '收入占比',
            'Electricity Consumption by Time-Of-Use': '分時消耗電量',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': '分時⽤電排放⼆氧化碳',
            'Electricity Cost by Time-Of-Use': '分時⽤電成本',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}}{{UNIT}} 分項消耗占比',
            'Ton of Standard Coal by Energy Category': '噸標準煤 (TCE) 占比',
            'Ton of Carbon Dioxide Emissions by Energy Category': '噸⼆氧化碳排放 (TCO2E) 占比',
            'Reporting Period Consumption CATEGORY UNIT': '報告期消耗{{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} 報告期消耗 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期消耗 {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': '報告期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': '報告期產量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': '基準期產量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': '基準期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': '報告期消耗 {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '報告期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': '基準期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': '⼦空間分類占比 {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': '⼦空間總計占比',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '報告期⼆氧化碳排放 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                '報告期⼆氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '基準期⼆氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': '報告期成本 {{CATEGORY}}{{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': '報告期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': '基準期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': '報告期產出 {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{EQUIPMENT}} 報告期產出 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期產出 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': '報告期產出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': '基準期產出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': '報告期收入 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': '報告期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': '基準期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': '報告期總收入 {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': '報告期累積效率 {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} 報告期累積效率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期累積綜合效率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期累積綜合效率 {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 基準期累積綜合效率 {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': '瞬時效率 {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 瞬時效率 {{UNIT}}',
            'Equipment Efficiency Indicator': '設備能效指標',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 瞬時綜合效率 {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': '報告期累積效率 {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '報告期累積效率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': '基準期累積效率 {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': '基準期累積效率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': '基準期 {{CATEGORY}} 最⼤負荷 {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': '報告期 {{CATEGORY}} 最⼤負荷 {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': '報告期 {{CATEGORY}} 平均負荷 {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': '報告期 {{CATEGORY}} 負荷系數',
            'Base Period CATEGORY Average Load VALUE UNIT': '基準期 {{CATEGORY}} 平均負荷 {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': '報告期 {{CATEGORY}} 平均值 {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': '報告期 {{CATEGORY}} 最⼤值 {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': '報告期 {{CATEGORY}} 最⼩值 {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': '報告期 {{CATEGORY}} 算術平均數 {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': '報告期 {{CATEGORY}} 中位數 {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': '報告期 {{CATEGORY}} 樣本標準差 {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': '報告期 {{CATEGORY}} 樣本⽅差 {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '報告期節約 {{CATEGORY}} (基線-實際) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '報告期減少 {{CATEGORY}} (基線-實際) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': '報告期節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': '基準期節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': '報告期總表消耗 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '報告期總表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': '報告期分表消耗 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                '報告期分表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': '報告期差值 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': '報告期差值百分比',
            'Reporting Period Difference CATEGORY VALUE UNIT': '報告期差值 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': '趨勢值',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': '故障列表',
            'Reporting Period Number of Fault VALUE': '報告期故障數: {{VALUE}}',
            'All Faults': '全部故障',
            'Space Faults': '空間故障',
            'Number of All Faults': '全部故障數',
            'Number of Space Faults': '空間故障數',
            'Total Number of Faults': '總故障數量',
            'Number of New Faults': '新發故障數量',
            'Number of Inprogress Faults': '進⾏中故障數量',
            'Number of Done Faults': '已完成故障數量',
            //Data Panels
            'Ton of Standard Coal': '噸標準煤',
            'Ton of Carbon Dioxide Emissions': '噸⼆氧化碳排放',
            'Carbon Emissions Per Unit Of Energy Consumption': '單位能耗碳排放',
            'Operating Characteristic Curve': '運⾏曲線',
            Tariff: '費率',
            'Detailed Data': '詳細數據',
            'Child Spaces Data': '⼦空間數據',
            'Associated Equipment Data': '相關設備數據',
            'This Year': '本年',
            'The Same Period Last Year': '去年同期',
            'This Month': '本⽉',
            'This Day': '本⽇',
            Total: '總計',
            'No data found': '沒有數據',
            Export: '導出',
            Datetime: '⽇期時間',
            'Time-Of-Use Type': '分時類型',
            'Top-Peak': '尖',
            'On-Peak': '峰',
            'Mid-Peak': '平',
            'Off-Peak': '⾕',
            'Deep': '深谷',
            Percentage: '百分比',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': '能耗值點最近⼀⼩時趨勢',
            Circuit: '回路',
            Point: '數據點',
            'Realtime Value': '實時值',
            //Meter Tracking
            'Meter List': '計量表列表',
            'Edit Meter': '編輯',
            'Start Value': '起始值',
            'End Value': '結束值',
            'Difference Value': '差值',
            'Start Integrity Rate': '起始數據完整率 (%)',
            'End Integrity Rate': '結束數據完整率 (%)',
            'Full Integrity Rate': '整體數據完整率 (%)',
            //Equipment Tracking
            'Equipment List': '設備列表',
            'Edit Equipment': '編輯',
            //Profile Dropdown
            Feedback: '反饋',
            'Account Settings': '賬號設置',
            Logout: '退出',
            //Authentication
            'Log in': '登錄',
            'Email address': '電⼦郵件地址',
            'Phone Number': '電話號碼',
            Password: '密碼',
            CaptchaCode: '驗證碼',
            Refresh: '刷新',
            'Remember me': '記住我',
            'Logged in as ': '已登錄 ',
            'Forgot Password?': '忘記密碼?',
            'Forgot your password?': '忘記你的密碼?',
            "Enter your email and we'll send you a reset link": '輸入電⼦郵件地址，我們會把重置鏈接發送給您',
            "Enter your email and we'll send you a registration link": '輸入電⼦郵件地址，我們會把注冊鏈接發送給您',
            'Reset Password': '重置密碼',
            'Thanks for using MyEMS!': '感謝您使⽤ MyEMS!',
            'You are now successfully signed out': '您已成功退出',
            'Return to Login': '返回登錄',
            'Please check your email!': '請查收您的電⼦郵件!',
            'An email has been sent to ': '⼀封電⼦郵件已經發送⾄ ',
            'Please click on the included link to reset your password': '請點擊⾥⾯的鏈接重置您的密碼',
            'Please click on the included link to register your account': '請點擊⾥⾯的鏈接注冊您的賬⼾',
            'An email with password reset link is sent to ': '⼀封包含密碼重置鏈接的電⼦郵件已經發送⾄ ',
            'Change Password': '修改密碼',
            'Old Password': '原密碼',
            'New Password': '新密碼',
            'Confirm Password': '重覆新密碼',
            'Update Password': '更新密碼',
            'Password has been changed!': '密碼已修改!',
            'Verification code has been sent to your inbox. \
    Please copy it to the input box below.':
                '驗證碼已發送到您的收件箱，請將其覆制到下⾯的輸入框中。',
            'New to MyEMS': '初次使⽤ MyEMS',
            'Create an account': '注冊賬⼾',
            'EMAIL Account registration successful': '{{EMAIL}} 賬號注冊成功',
            'Thanks for verifying your account!': '感謝您驗證您的賬⼾！',
            'Your code is': '您的代碼是',
            'Send verification code': '發送驗證碼',
            'Please wait for NUMBER seconds': '請等待 {{NUMBER}} 秒',
            'Password reset': '密碼重置',
            'Please wait for approval': '請等待審核',
            //notification
            Notifications: '通知',
            'Mark all as read': '全部設為已讀',
            'View all': '全部',
            'Notification New': '新的',
            'Notification Earlier': '更早的',
            'Notification List': '通知列表',
            'Bulk actions': '批量操作',
            'Notification Subject': '主題',
            'Notification Created Datetime': '創建時間',
            'Notification Message': '內容',
            'Notification Priority': '優先級',
            'Notification Status': '狀態',
            'Notification Mark As Read': '標記為已讀',
            'Notification Mark As Acknowledged': '確認',
            'Notification Low': '低',
            'Notification Medium': '中',
            'Notification High': '⾼',
            'Notification Critical': '嚴重',
            'Notification Unread': '未讀',
            'Notification Read': '已讀',
            'Notification Acknowledged': '已確認',
            'Notification Archive': '存檔',
            'Notification Delete': '刪除',
            'Notification Apply': '應⽤',
            'Notification Start Datetime': '開始時間',
            'Notification End Datetime': '結束時間',
            'Notification Update Datetime': '更新時間',
            //Monitoring
            'Run Commands': '運⾏指令',
            'Pin Code': '密碼',
            'Unlock': '解鎖',
            'Set Value': '設定值',
            'Fault Alarms': '故障報警',
            'Instantaneous Efficiency VALUE UNIT': '瞬時效率 {{VALUE}} {{UNIT}}',
            'Communication Status': '通信狀態',
            'Communication Online': '在線',
            'Communication Offline': '離線',
            'Equipment Status': '設備狀態',
            'Equipment Running': '運⾏',
            'Equipment Stopped': '停機',
            'Show Up to': '每⾴顯⽰數量',
            All: '全部',
            'FROM - TO of TOTAL': '當前顯⽰ {{FROM}} - {{TO}} 總計 {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': '微電網能源',
            'Microgrid Revenue': '微電網收益',
            'Microgrid Carbon': '微電網碳排放',
            'Photovoltaic Generation': '光伏發電量',
            'EV Charger Consumption': '充電樁用電量',
            'Load Consumption': '負載用電量',
            'Grid Buy': '從電網購買電量',
            'Grid Sell': '向電網銷售電量',
            'EV Charger': '電動汽車充電器',
            'Heat Pump': '熱泵',
            'Photovoltaic': '光電',
            'PCS Run State': 'PCS 運⾏狀態',
            'PCS Unknown': '未知',
            'PCS Initializing': '初始上電',
            'PCS Standby': '待機',
            'PCS Shutdown': '關機',
            'PCS Fault': '故障',
            'PCS Running': '運⾏',
            'Battery Power': '電池功率',
            'Photovoltaic Power': '光伏功率',
            'Grid Power': '電網功率',
            'Load Power': '負載功率',
            Reporting: '數據報表',
            Maintenance: '維護保養',
            'General Information': '基本信息',
            'Serial Number': '序列號',
            Address: '地址',
            'Postal Code': '郵編',
            'Rated Capacity': '額定容量',
            'Rated Power': '額定功率',
            Latitude: '緯度',
            Longitude: '經度',
            'Strategy Management': '策略管理',
            'Charging Schedule': '充電時間表',
            'Charge Start Time': '充電開始時間',
            'Charge End Time': '充電結束時間',
            'Discharge Start Time': '放電開始時間',
            'Discharge End Time': '放電結束時間',
            'Total Rated Power': '總額定功率',
            'Total Rated Capacity': '總額定容量',
            "Today's Charge": '今日充電量',
            "Today's Discharge": '今日放電量',
            "Today's Generation": "今日發電量",
            'Total Fuel Consumption': '總耗油量',
            'Total Charge': '總充電',
            'Total Discharge': '總放電',
            'Total Generation': '總發電量',
            'Total Revenue': '總收益',
            'Total Photovoltaic Generation': '總光伏發電量',
            'Total EV Charger Consumption': '充電樁總用電量',
            'Total Load Consumption': '負載總用電量',
            'Total Grid Buy': '從電網購買總電量',
            'Total Grid Sell': '向電網銷售總電量',
            'Total Efficiency': '總效率',
            'Discharge Achievement Rate': '放電達成率',
            // Revenue Indicator
            "Today's Cost": "今日成本",
            "Today's Income": "今日收入",
            "Total Cost": "總成本",
            "Total Income": "總收入",
            "Today's Revenue": "今日利潤",

            'Revenue Ranking': '收益排名',
            'Efficiency Ranking': '效率排名',
            'Charge Ranking': '充電排名',
            'Discharge Ranking': '放電排名',
            'Number of Microgrids': '微電網數',
            'Number of Power Stations': '電站數',
            'Microgrid List': '微電網列表',
            'Select Microgrid': '選擇微電網',
            'Previous Page': '上⼀⾴',
            'Next Page': '下⼀⾴',
            '7 Days': '7⽇',
            'Charge UNIT': '充 {{UNIT}}',
            'Discharge UNIT': '放 {{UNIT}}',
            'Generation UNIT': '發電 {{UNIT}}',
            'Energy Indicator': '能量指標',
            'Revenue Indicator': '收益指標',
            'Carbon Indicator': '碳指標',

            // Energy Storage Power Station
            'Battery Operating State': '電池運⾏狀態',
            'Battery State': '電池狀態',
            'Battery Unknown': '未知',
            'Battery Stopped': '停⽌',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': '故障', // 1
            'Battery Warning': '預警', // 2
            'Battery Standby': '待機', // 3
            'Battery Prohibit DisCharging': '禁放', // 4
            'Battery Prohibit Charging': '禁充', // 5
            'Battery Normal': '正常', // 6
            'Battery Charging': '充電', // 7
            'Battery Discharging': '放電', // 8
            'Battery Idle': '空闲', // 9
            'Phase of Lifecycle': '生命週期階段',
            'Use Phase': '使用階段',
            'Commissioning Phase': '調試階段',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': '安裝階段',
            'Device Status': '設備狀態',
            'Basic Information': '基本訊息',
            'Gateway': 'Gateway',
            'Grid Meter': '電網電錶',
            'Load Meter': '負載電錶',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Total Active Power',
            'Active Power A': 'Active Power A',
            'Active Power B': 'Active Power B',
            'Active Power C': 'Active Power C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Reactive Power A',
            'Reactive Power B': 'Reactive Power B',
            'Reactive Power C': 'Reactive Power C',
            'Total Apparent Power': 'Total Apparent Power',
            'Apparent Power A': 'Apparent Power A',
            'Apparent Power B': 'Apparent Power B',
            'Apparent Power C': 'Apparent Power C',
            'Total Power Factor': 'Total Power Factor',
            'Active Energy Import': 'Active Energy Import',
            'Active Energy Export': 'Active Energy Export',
            'Active Energy Net': 'Active Energy Net',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': '逆變器',
            'Invertor Run State': '逆變器運⾏狀態',
            'Invertor Unknown': '未知',
            'Invertor Initializing': '初始上電',
            'Invertor Standby': '待機',
            'Invertor Shutdown': '關機',
            'Invertor Fault': '故障',
            'Invertor Running': '運⾏',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': '⽣成時間',
            'File Format': '⽂件格式',
            'File Size': '⽂件⼤⼩',
            Uploader: '上傳者',
            'Upload Datetime': '上傳時間',
            //Error
            "The page you're looking for is not found": '您要找的⾴⾯不存在',
            "Make sure the address is correct and that the page hasn't moved":
                '請確認地址正確且⾴⾯沒有被移動',
            'If you think this is a mistake,': '如果您認為這是⼀個錯誤,',
            'contact us': '聯系我們',
            'Take me home': '帶我回⾸⾴',
            'Whoops, something went wrong!': '哦, 出錯了！!',
            'Try refreshing the page, or going back and attempting the action again':
                '請嘗試刷新⾴⾯, 或回退並再次嘗試執⾏這個操作',
            'If this problem persists,': '如果問題依然存在,',
            'Captcha Error': '驗證碼錯誤',
            'Confirm Password Error': '兩次密碼不⼀致',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                '看起來你點擊了⼀個無效的重置密碼鏈接。請再試⼀次。',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                '看起來你點擊了⼀個無效的注冊賬號鏈接。請再試⼀次。',
            //Tenant Bill
            'Lease Contract Number': '租賃合同號碼',
            Download: '下載',
            Print: '打印',
            'Payment Notice': '付款通知書',
            'Bill To': '致',
            'Bill Number': '賬單號碼',
            'Bill Date': '賬單⽇期',
            'Payment Due Date': '付款到期⽇',
            'Amount Payable': '應付款⾦額',
            'Billing Period Start': '結算期起始⽇期',
            'Billing Period End': '結算期結束⽇期',
            Quantity: '數量',
            Price: '價格',
            Unit: '單位',
            Amount: '⾦額',
            Subtotal: '⼩計',
            'VAT Output Tax': '增值稅銷項稅⾦',
            'Total Amount Payable': '應付⾦額合計',
            'Please make sure to pay on or before the payment due date above':
                '請確保在上述付款到期⽇或之前付款',
            'Send money to the following account': '匯款⾄以下賬⼾',
            'Account Name': '賬⼾名稱',
            'Bank Name': '開⼾銀⾏',
            'Bank Address': '銀⾏地址',
            'RMB Account': '⼈⺠幣賬⼾',
            // button
            'Toggle Navigation': '切換導航',
            // working calendar
            'Working Days': '⼯作⽇',
            'Non Working Days': '非⼯作⽇',
            'Select Row': '請選擇要操作的數據⾏',
            // Offline Meter Input
            'Daily Value': '⽇數據',
            Date: '⽇期',
            'Successfully Saved': '保存成功',
            'Previous Data Is Empty': '之前的數據為空',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': '管理員會話不存在',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': '管理員會話已超時',
            'API.ADVANCED_REPORT_NOT_FOUND': '⾼級報表不存在',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': '錯誤請求',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': '不能將已經設為分表的計量表設置為總表',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS':
                'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND':
                'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': '組合設備與設備關系已存在',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND':
                '組合設備與設備關系不存在',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': '組合設備與計量表關系已存在',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': '組合設備與計量表關系不存在',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': '組合設備名稱已使⽤',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': '組合設備不存在',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS':
                '組合設備與離線表關系已存在',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '組合設備與離線表關系不存在',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE':
                '組合設備相關參數名稱已使⽤',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '組合設備相關參數不存在或不匹配',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS':
                '組合設備與虛擬表關系已存在',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '組合設備與虛擬表關系不存在',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': '聯系⼈姓名已使⽤',
            'API.CONTACT_NOT_FOUND': '聯系⼈不存在',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': '成本中⼼外部 ID 已存在',
            'API.COST_CENTER_NAME_EXISTS': '成本中⼼名稱已存在',
            'API.COST_CENTER_NOT_FOUND': '成本中⼼不存在',
            'API.COST_FILE_NOT_FOUND': '成本⽂件不存在',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': '數據源名稱已使⽤',
            'API.DATA_SOURCE_NOT_FOUND': '數據源不存在',
            'API.DATABASE_ERROR': '數據庫錯誤',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': '⽇期已在⼯作⽇歷中',
            'API.DATE_LOCAL_NOT_FOUND': '未找到本地⽇期',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': '配電回路名稱已使⽤',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': '配電回路不存在',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': '配電回路與點位關系已存在',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': '配電回路與點位關系不存在',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': '配電系統名稱已使⽤',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': '配電系統不存在',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': '電⼦郵箱已使⽤',
            'API.EMAIL_MESSAGE_NOT_FOUND': '電⼦郵件消息不存在',
            'API.EMAIL_NOT_FOUND': '電⼦郵箱不存在',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': '郵件服務器主機已使⽤',
            'API.EMAIL_SERVER_NOT_FOUND': '郵件服務器主機不存在',
            'API.EMPTY_VARIABLES_ARRAY': '空變量數組',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': '能源分類名稱已使⽤',
            'API.ENERGY_CATEGORY_NOT_FOUND': '能源分類不存在',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': '能源分類在能源分項中已使⽤',
            'API.ENERGY_CATEGORY_USED_IN_METER': '能源分類在計量表中已使⽤',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': '能源分類在離線表中已使⽤',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': '能源分類在費率中已使⽤',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': '能源分類在虛擬表中已使⽤',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': '能流圖鏈接已使⽤',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH':
                '能流圖鏈接不存在或不匹配',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': '能流圖名稱已使⽤',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE':
                '能流圖節點已使⽤',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH':
                '能流圖節點不存在或不匹配',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': '能流圖不存在',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY':
                '能源分項不屬於能源分類',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': '能源分項不屬於能源分類',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': '能源分項已使⽤',
            'API.ENERGY_ITEM_NOT_FOUND': '能源分項不存在',
            'API.ENERGY_ITEM_USED_IN_METER': '能源分項在計量表中已使⽤',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': '能源分項在離線表中已使⽤',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': '能源分項在虛擬表中已使⽤',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE':
                'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': '設備與計量表關系已存在',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': '設備與計量表關系不存在',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': '設備名稱已使⽤',
            'API.EQUIPMENT_NOT_FOUND': '設備不存在',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '設備與離線表關系已存在',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '設備與離線表關系不存在',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '設備相關參數名稱已使⽤',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '設備相關參數不存在或不匹配',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '設備與虛擬表關系已存在',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '設備與虛擬表關系不存在',
            'API.ERROR': '錯誤',
            'API.EXCEPTION': '異常',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': '恢覆成本⽂件失敗',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': '恢覆知識⽂件失敗',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': '恢覆離線表⽂件失敗',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': '保存離線表⽂件失敗',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': '上傳成本⽂件失敗',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': '上傳知識⽂件失敗',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': '上傳離線表⽂件失敗',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': '網關名稱已使⽤',
            'API.GATEWAY_NOT_FOUND': '網關不存在',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': '無效的 ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': '無效地址',
            'API.INVALID_ADDRESS_VALUE': '無效地址值',
            'API.INVALID_ADVANCED_REPORT_ID': '無效的⾼級報表 ID',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': '無效⾯積值',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': '無效的基準期結束時間',
            'API.INVALID_BASE_PERIOD_START_DATETIME': '無效的基準期開始時間',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': '無效波特率',
            'API.INVALID_BUILDINGS_VALUE': '無效的建築值',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': '無效類型',
            'API.INVALID_CHANNEL': '無效通道',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': '無效的組合設備 ID',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': '無效的組合設備名稱',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': '無效的組合設備相關參數 ID',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': '無效的組合設備相關參數名稱',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': '無效的組合設備相關參數類型',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': '無效的組合設備 UUIDs',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': '無效連接',
            'API.INVALID_CONSTANT_VALUE': '無效常量值',
            'API.INVALID_CONTACT_ID': '無效的聯絡⼈ ID',
            'API.INVALID_CONTACT_NAME': '無效的聯絡⼈姓名',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': '無效的成本中⼼ ID',
            'API.INVALID_COST_FILE_ID': '無效的成本⽂件 ID',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': '無效的數據源 ID',
            'API.INVALID_DATA_SOURCE_NAME': '無效的數據源名稱',
            'API.INVALID_DATA_SOURCE_PROTOCOL': '無效的數據源協議',
            'API.INVALID_DATE_LOCAL': '無效的本地⽇期',
            'API.INVALID_DENOMINATOR_METER_UUID': '無效的標準計量表 UUID',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': '無效的顯⽰名稱',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': '無效的配電回路 ID',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': '無效的配電回路名稱',
            'API.INVALID_DISTRIBUTION_ROOM': '無效的配電室',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': '無效的配電系統 ID',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': '無效的配電系統名稱',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': '無效的郵箱',
            'API.INVALID_EMAIL_MESSAGE_ID': '無效的電⼦郵件 ID',
            'API.INVALID_EMAIL_SERVER_HOST': '無效的電⼦郵箱服務器主機',
            'API.INVALID_EMAIL_SERVER_ID': '無效的電⼦郵箱服務器 ID',
            'API.INVALID_END_DATE_FORMAT': '無效的結束⽇期格式',
            'API.INVALID_END_DATETIME': '無效的結束⽇期',
            'API.INVALID_ENERGY_CATEGORY_ID': '無效的能源分類 ID',
            'API.INVALID_ENERGY_CATEGORY_NAME': '無效的能源分類名稱',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': '無效的能流圖 ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': '無效的能流圖鏈接 ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': '無效的能流圖名稱',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': '無效的能流圖節點 ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': '無效的能流圖節點名稱',
            'API.INVALID_ENERGY_ITEM_ID': '無效的能源分項 ID',
            'API.INVALID_ENERGY_ITEM_NAME': '無效的能源分項名稱',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': '表達式中無效的表達式',
            'API.INVALID_EQUIPMENT_ID': '無效的設備 ID',
            'API.INVALID_EQUIPMENT_NAME': '無效的設備名稱',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': '無效的設備相關參數 ID',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': '無效的設備相關參數名稱',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': '無效的設備相關參數類型',
            'API.INVALID_EQUIPMENT_UUID': '無效的設備 UUID',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': '無效表達式',
            'API.INVALID_EXPRESSION_OBJECT': '無效的表達式對象',
            'API.INVALID_FDD_CODE': '無效的故障錯誤碼',
            'API.INVALID_FLOORS_VALUE': '無效的樓層值',
            'API.INVALID_FROM_ADDR': '無效地址',
            'API.INVALID_GATEWAY_ID': '無效的網關 ID',
            'API.INVALID_GATEWAY_NAME': '無效的網關名稱',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': '無效的⼩時上限值',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': '無效的⼩時下限值',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': '無效的管理值',
            'API.INVALID_IS_COST_DATA_DISPLAYED': '無效的是否顯⽰成本數據',
            'API.INVALID_IS_COUNTED_VALUE': '無效的計數值',
            'API.INVALID_IS_ENABLED': '無效的是否啟⽤',
            'API.INVALID_IS_HIDDEN': '無效的是否隱藏',
            'API.INVALID_IS_IN_LEASE_VALUE': '無效的是否在租值',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': '無效的輸入是否匯總值',
            'API.INVALID_IS_KEY_TENANT_VALUE': '無效的是否主⼒租⼾值',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': '無效的輸出是否匯總值',
            'API.INVALID_IS_OUTPUT_VALUE': '無效的輸出是否匯總值',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': '無效的是否保存趨勢值',
            'API.INVALID_IS_VIRTUAL_VALUE': '無效的是否虛擬點值',
            'API.INVALID_KGCE': '無效的千克標準煤系數',
            'API.INVALID_KGCO2E': '無效的千克⼆氧化碳排放系數',
            'API.INVALID_KNOWLEDGE_FILE_ID': '無效的知識⽂件 ID',
            'API.INVALID_LATITUDE_VALUE': '無效的緯度值',
            'API.INVALID_LEASE_NUMBER_VALUE': '無效的租約編號',
            'API.INVALID_LONGITUDE_VALUE': '無效的經度值',
            'API.INVALID_LOW_LIMIT_VALUE': '無效的下限值',
            'API.INVALID_MASTER_METER_ID': '無效的總計量表 ID',
            'API.INVALID_MENU_ID': '無效的菜單 ID',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': '無效的消息模板',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': '無效的計量表 ID',
            'API.INVALID_METER_NAME': '無效的計量表名稱',
            'API.INVALID_METER_UUID': '無效的計量表 UUID',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID':
                'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME':
                'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': '無效的名稱值',
            'API.INVALID_NEW_PASSWORD': '無效的新密碼',
            'API.INVALID_NON_WORKING_DAY_ID': '無效的非⼯作⽇ ID',
            'API.INVALID_NOTIFICATION_ID': '無效的通知 ID',
            'API.INVALID_NUMERATOR_METER_UUID': '無效的分⼦表 UUID',
            'API.INVALID_OBJECT_TYPE': '無效的對象類型',
            'API.INVALID_OFFLINE_METER_DATA': '無效離線表數據',
            'API.INVALID_OFFLINE_METER_FILE_ID': '無效的離線表⽂件 ID',
            'API.INVALID_OFFLINE_METER_ID': '無效的離線表 ID',
            'API.INVALID_OFFLINE_METER_NAME': '無效的離線表名稱',
            'API.INVALID_OFFLINE_METER_UUID': '無效的離線表 UUID',
            'API.INVALID_OFFSET_CONSTANT_VALUE': '無效的偏移常量',
            'API.INVALID_OLD_PASSWORD': '無效的舊密碼',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': '無效的⽗空間 ID',
            'API.INVALID_PASSWORD': '無效的密碼',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': '無效峰值電流',
            'API.INVALID_PEAK_LOAD': '無效峰值負載',
            'API.INVALID_PERIOD_TYPE': '無效周期類型',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': '無效的數據點 ID',
            'API.INVALID_POINT_NAME': '無效的數據點名稱',
            'API.INVALID_PORT': '無效端⼝',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': '無效的優先級',
            'API.INVALID_PRIVILEGE': '無效的權限',
            'API.INVALID_PRIVILEGE_DATA': '無效的權限數據',
            'API.INVALID_PRIVILEGE_ID': '無效的權限 ID',
            'API.INVALID_PRIVILEGE_NAME': '無效的權限名稱',
            'API.INVALID_RATIO_VALUE': '無效的變比值',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': '無效回覆',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': '無效的報告期結束⽇期時間',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': '無效的報告期開始⽇期時間',
            'API.INVALID_REQUIRES_AUTHENTICATION': '無效的需要⾝份驗證',
            'API.INVALID_ROOMS_VALUE': '無效的房間值',
            'API.INVALID_RULE_ID': '無效的規則 ID',
            'API.INVALID_RULE_NAME': '無效的規則名稱',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': '無效的傳感器 ID',
            'API.INVALID_SENSOR_NAME': '無效的傳感器名稱',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': '無效的串⼝號',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': '會話無效，請重新登陸',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': '無效的⾞間 ID',
            'API.INVALID_SHOPFLOOR_NAME': '無效的⾞間名稱',
            'API.INVALID_SHOPFLOOR_UUID': '無效的⾞間 UUID',
            'API.INVALID_SOURCE_NODE_ID': '無效的源節點 ID',
            'API.INVALID_SPACE_ID': '無效的空間 ID',
            'API.INVALID_SPACE_NAME': '無效的空間名稱',
            'API.INVALID_SPACE_UUID': '無效的空間 UUID',
            'API.INVALID_START_DATE_FORMAT': '無效的開始時間格式',
            'API.INVALID_START_DATETIME': '無效的開始時間',
            'API.INVALID_STATUS': '無效狀態',
            'API.INVALID_STORE_ID': '無效⾨店 ID',
            'API.INVALID_STORE_NAME': '無效⾨店名稱',
            'API.INVALID_STORE_TYPE_DESCRIPTION': '無效的⾨店類型描述',
            'API.INVALID_STORE_TYPE_ID': '無效的⾨店類型 ID',
            'API.INVALID_STORE_TYPE_NAME': '無效的⾨店類型名稱',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': '無效的⾨店類型簡化代碼',
            'API.INVALID_STORE_UUID': '無效⾨店 UUID',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': '無效 SVG',
            'API.INVALID_SWITCHGEAR': '無效的開關設備',
            'API.INVALID_TARGET_NODE_ID': '無效的⽬標節點 ID',
            'API.INVALID_TARIFF_BLOCK_PRICING': '無效的階梯費率定價',
            'API.INVALID_TARIFF_ID': '無效的費率 ID',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': '無效的分時費率定價',
            'API.INVALID_TARIFF_TYPE': '無效的費率類型',
            'API.INVALID_TENANT_ID': '無效的租⼾ ID',
            'API.INVALID_TENANT_NAME': '無效的租⼾名稱',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': '無效的租⼾類型描述',
            'API.INVALID_TENANT_TYPE_ID': '無效的租⼾類型 ID',
            'API.INVALID_TENANT_TYPE_NAME': '無效的租⼾類型名稱',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': '無效的租⼾類型簡化代碼',
            'API.INVALID_TENANT_UUID': '無效的租⼾ UUID',
            'API.INVALID_TEXT_MESSAGE_ID': '無效的短信 ID',
            'API.INVALID_TIMEZONE_ID': '無效的時區 ID',
            'API.INVALID_TOKEN': '無效令牌',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': '無效的計量單位',
            'API.INVALID_UNIT_OF_PRICE': '無效的價格單位',
            'API.INVALID_UNITS': '無效單位',
            'API.INVALID_USER_ID': '無效的⽤⼾ ID',
            'API.INVALID_USER_NAME': '無效的⽤⼾名稱',
            'API.INVALID_USER_NAME_OR_EMAIL': '無效的⽤⼾名稱或郵箱',
            'API.INVALID_USER_PHONE': '無效的⽤⼾⼿機號',
            'API.INVALID_USER_PLEASE_RE_LOGIN': '無效的⽤⼾請重新登錄',
            'API.INVALID_USER_UUID': '無效的⽤⼾ UUID',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': '無效的變量計量表 ID',
            'API.INVALID_VARIABLE_METER_TYPE': '無效的變量計量表類型',
            'API.INVALID_VARIABLE_NAME': '無效的變量名稱',
            'API.INVALID_VERIFICATION_CODE': '無效的驗證碼',
            'API.INVALID_VIRTUAL_METER_ID': '無效的虛擬表 ID',
            'API.INVALID_VIRTUAL_METER_NAME': '無效的虛擬表名稱',
            'API.INVALID_VIRTUAL_METER_UUID': '無效的虛擬表 UUID',
            'API.INVALID_WEB_MESSAGE_ID': '無效的 web 消息 ID',
            'API.INVALID_WECHAT_MESSAGE_ID': '無效的微信消息 ID',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': '無效的⼯作⽇歷 ID',
            'API.INVALID_WORKING_CALENDAR_NAME': '無效的⼯作⽇歷名稱',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': '無法從磁盤中刪除知識⽂件',
            'API.KNOWLEDGE_FILE_NOT_FOUND': '知識庫⽂件不存在',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': '總表不屬於同⼀能源分類',
            'API.MASTER_METER_NOT_FOUND': '總表不存在',
            'API.MENU_NOT_FOUND': '菜單不存在',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': '計量表名稱已使⽤',
            'API.METER_NOT_FOUND': '計量表不存在',
            'API.METER_OF_VARIABLE_NOT_FOUND': '計量表變量不存在',
            'API.METER_POINT_RELATION_EXISTS': '計量表與數據點關系已存在',
            'API.METER_POINT_RELATION_NOT_FOUND': '計量表與數據點關系不存在',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE':
                'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE':
                'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE':
                'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND':
                'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
                '新密碼長度不能超過 100 個字符',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': '非⼯作⽇不存在',
            'API.NOT_FOUND': '不存在',
            'API.NOTIFICATION_NOT_FOUND': '通知不存在',
            'API.OFFLINE_METER_FILE_NOT_FOUND': '離線表⽂件不存在',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': '離線表名稱已使⽤',
            'API.OFFLINE_METER_NOT_FOUND': '離線表不存在',
            'API.INVALID_OFFLINE_METER_VALUE': '無效的離線數據',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': '離線表變量不存在',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
                '舊密碼長度不能超過 100 個字符',
            'API.PARENT_SPACE_NOT_FOUND': '⽗空間不存在',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '密碼長度不能超過 100 個字符',
            'API.PASSWORDS_MATCH': '新密碼與舊密碼⼀致',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE':
                'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': '數據點名稱已使⽤',
            'API.POINT_NOT_FOUND': '數據點不存在',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': '權限名稱已使⽤',
            'API.PRIVILEGE_NOT_FOUND': '權限不存在',
            'API.RULE_NAME_IS_ALREADY_IN_USE': '規則名稱已使⽤',
            'API.RULE_NOT_FOUND': '規則不存在',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': '傳感器名稱已使⽤',
            'API.SENSOR_NOT_FOUND': '傳感器不存在',
            'API.SENSOR_POINT_RELATION_EXISTS': '傳感器與數據點關系已存在',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': '傳感器與數據點關系不存在',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': '⾞間與設備關系已存在',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': '⾞間與設備關系不存在',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': '⾞間與計量表關系已存在',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': '⾞間與計量表關系不存在',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': '⾞間名稱已使⽤',
            'API.SHOPFLOOR_NOT_FOUND': '⾞間不存在',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': '⾞間與離線表關系已存在',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': '⾞間與離線表關系不存在',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': '⾞間與數據點關系已存在',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': '⾞間與數據點關系不存在',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': '⾞間與傳感器關系已存在',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': '⾞間與傳感器關系不存在',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': '⾞間與虛擬表關系已存在',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': '⾞間與虛擬表關系不存在',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': '⾞間⼯作⽇歷關系已存在',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND':
                '⾞間與⼯作⽇歷關系不存在',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': '源節點不存在',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': '空間與組合設備關系已存在',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': '空間與組合設備關系不存在',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS':
                'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': '空間與設備關系已存在',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': '空間與設備關系不存在',
            'API.SPACE_METER_RELATION_EXISTS': '空間與計量表關系已存在',
            'API.SPACE_METER_RELATION_NOT_FOUND': '空間與計量表關系不存在',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': '空間名稱已使⽤',
            'API.SPACE_NOT_FOUND': '空間不存在',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': '空間在權限中不存在',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': '空間與離線表關系已存在',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': '空間與離線表關系不存在',
            'API.SPACE_POINT_RELATION_EXISTS': '空間與數據點關系已存在',
            'API.SPACE_POINT_RELATION_NOT_FOUND': '空間與數據點關系不存在',
            'API.SPACE_SENSOR_RELATION_EXISTS': '空間與傳感器關系已存在',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': '空間與傳感器關系不存在',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': '空間與⾞間關系已存在',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': '空間與⾞間關系不存在',
            'API.SPACE_STORE_RELATION_EXISTS': '空間與⾨店關系已存在',
            'API.SPACE_STORE_RELATION_NOT_FOUND': '空間與⾨店關系不存在',
            'API.SPACE_TENANT_RELATION_EXISTS': '空間與租⼾關系已存在',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': '空間與租⼾關系不存在',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': '空間與虛擬表關系已存在',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': '空間與虛擬表關系不存在',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': '空間與⼯作⽇歷關系已存在',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': '空間與⼯作⽇歷關系不存在',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME':
                '開始⽇期時間必須早於結束⽇期時間',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': '⾨店與計量表關系已存在',
            'API.STORE_METER_RELATION_NOT_FOUND': '⾨店與計量表關系不存在',
            'API.STORE_NAME_IS_ALREADY_IN_USE': '⾨店名稱已使⽤',
            'API.STORE_NOT_FOUND': '⾨店不存在',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': '⾨店與離線表關系已存在',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': '⾨店與離線表關系不存在',
            'API.STORE_POINT_RELATION_EXISTS': '⾨店與數據點關系已存在',
            'API.STORE_POINT_RELATION_NOT_FOUND': '⾨店與數據點關系不存在',
            'API.STORE_SENSOR_RELATION_EXISTS': '⾨店與傳感器關系已存在',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': '⾨店傳感器關系不存在',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': '⾨店類型名稱已使⽤',
            'API.STORE_TYPE_NOT_FOUND': '⾨店類型不存在',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '⾨店類型簡化代碼已使⽤',
            'API.STORE_TYPE_USED_IN_STORE': '⾨店類型在⾨店中已使⽤',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': '⾨店與虛擬表關系已存在',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': '⾨店與虛擬表關系不存在',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': '⾨店與⼯作⽇歷關系已存在',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': '⾨店與⼯作⽇歷關系不存在',
            'API.TARGET_NODE_NOT_FOUND': '⽬標節點不存在',
            'API.TARIFF_IN_USE': '費率正在使⽤',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': '費率和成本中⼼已關聯',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': '費率和成本中⼼未關聯',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': '費率名稱已使⽤',
            'API.TARIFF_NOT_FOUND': '費率不存在',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation not found',
            'API.TENANT_METER_RELATION_EXISTS': '租⼾與計量表關系已存在',
            'API.TENANT_METER_RELATION_NOT_FOUND': '租⼾與計量表關系不存在',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': '租⼾名稱已使⽤',
            'API.TENANT_NOT_FOUND': '租⼾不存在',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': '租⼾與離線表關系已存在',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': '租⼾與離線表關系不存在',
            'API.TENANT_POINT_RELATION_EXISTS': '租⼾與數據點關系已存在',
            'API.TENANT_POINT_RELATION_NOT_FOUND': '租⼾與數據點關系不存在',
            'API.TENANT_SENSOR_RELATION_EXISTS': '租⼾與傳感器關系已存在',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': '租⼾與傳感器關系不存在',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': '租⼾與類型名稱已使⽤',
            'API.TENANT_TYPE_NOT_FOUND': '租⼾類型不存在',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '租⼾類型簡化代碼已使⽤',
            'API.TENANT_TYPE_USED_IN_TENANT': '租⼾類型在租⼾中已使⽤',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': '租⼾與虛擬表關系已存在',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': '租⼾與虛擬表關系不存在',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': '租⼾與⼯作⽇歷關系已存在',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': '租⼾與⼯作⽇歷關系不存在',
            'API.TEXT_MESSAGE_NOT_FOUND': '未找到短信',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES':
                '報告期必須⼤於 15 分鐘',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': '與⼦表有關系',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': '與⼦空間有關系',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': '與組合設備相關參數有關系',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': '與組合設備有關系',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': '與數據源有關系',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS':
                '與能流圖有關系',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': '與儲能集裝箱電池有關係',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': '與儲能集裝箱電網有關係',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': '與儲能集裝箱負載有關係',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': '與儲能集裝箱功率轉換系統(PCS)有關係',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': '與設備相關參數有關系',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': '與設備有關系',
            'API.THERE_IS_RELATION_WITH_METER': '與計量表有關系',
            'API.THERE_IS_RELATION_WITH_METERS': '與多個記量表有關系',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': '與離線表有關系',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': '與多個離線表有關系',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': '與虛擬表有關系',
            'API.THERE_IS_RELATION_WITH_SENSORS': '與傳感器有關系',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': '與⾞間有關系',
            'API.THERE_IS_RELATION_WITH_SPACES': '與空間有關系',
            'API.THERE_IS_RELATION_WITH_STORES': '與⾨店有關系',
            'API.THERE_IS_RELATION_WITH_TENANTS': '與租⼾有關系',
            'API.THERE_IS_RELATION_WITH_USERS': '與⽤⼾有關系',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': '與虛擬表有關系',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': '與虛擬電廠有關系',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': '這個數據源正在被⼀個計量表使⽤',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '這個計量表正在被⼀個虛擬表使⽤',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '這個離線表正在被⼀個虛擬表使⽤',
            'API.THIS_SPACE_CANNOT_BE_CLONED': '空間不能被克隆',
            'API.THIS_SPACE_CANNOT_BE_DELETED': '空間不能被刪除',
            'API.TIMEZONE_NOT_FOUND': '時區不存在',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '未找到令牌，請登錄',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': '⽤⼾帳號已鎖定',
            'API.USER_ACCOUNT_HAS_EXPIRED': '⽤⼾帳號已過期',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': '⽤⼾名已使⽤',
            'API.USER_NOT_FOUND': '⽤⼾不存在',
            'API.USER_PASSWORD_HAS_EXPIRED': '⽤⼾密碼已過期',
            'API.USER_PRIVILEGE_NOT_FOUND': '未發現⽤⼾權限',
            'API.USER_SESSION_NOT_FOUND': '未發現⽤⼾會話',
            'API.USER_SESSION_TIMEOUT': '⽤⼾會話已過期',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '⽤⼾ UUID 不存在，請登錄',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': '虛擬表名稱已使⽤',
            'API.VIRTUAL_METER_NOT_FOUND': '虛擬表不存在',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': '變量的虛擬表不存在',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': '虛擬數據點應該是模擬量',
            'API.WEB_MESSAGE_NOT_FOUND': 'web 信息不存在',
            'API.WECHAT_MESSAGE_NOT_FOUND': '微信信息不存在',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': '⼯作⽇歷名稱已使⽤',
            'API.WORKING_CALENDAR_NOT_FOUND': '⼯作⽇歷不存在',

            MasterMeter: '總表',
            SubMeter: '分錶',
            'Power Quality': '電能品質',
            'About Power Quality': '關於電能品質',
            Category: '類別',
            Type: '類型',
            Limit: '限值',
            'Normal Limit': '正常限值',
            'Severe Limit': '嚴重限值',
            Compliance: '合規率',
            'Worst Deviation': '最差偏差',
            'Worst Time': '最差發生時間',
            'Severe Exceed Count': '嚴重越限次數',
            'Worst Unbalance': '最大不平衡率',
            Hz: '赫茲',
            voltage: '電壓',
            current: '電流',
            frequency: '頻率',
            voltage_deviation: '電壓偏差',
            current_unbalance: '電流不平衡',
            voltage_unbalance: '電壓不平衡',
            mean_deviation_pct: '平均偏差(%)',
            p95_abs_deviation_pct: 'P95絕對偏差(%)',
            mean_abs_deviation_hz: '平均絕對偏差(Hz)',
            frequency_deviation: '頻率偏差',
            p95_abs_deviation_hz: 'P95絕對偏差(Hz)',
            mean_unbalance_pct: '平均不平衡率(%)',
            p95_unbalance_pct: 'P95不平衡率(%)',
            count: '計數',
            min: '最小值',
            max: '最大值',
            mean: '平均值',
            std: '標準差',
            p5: 'P5',
            p95: 'P95'
        }
    },
    ko_KR: {
        translation: {
            // routes & menus
            Dashboard: '대시보드',
            'Space Data': '공간 데이터',
            'Equipment Data': '장비 데이터',
            'Meter Data': '계량기 데이터',
            'Tenant Data': '임차인 데이터',
            'Store Data': '매장 데이터',
            'Shopfloor Data': '작업장 데이터',
            'Combined Equipment Data': '복합 장비 데이터',
            'Auxiliary System': '보조 시스템',
            Microgrid: '마이크로그리드',
            'Energy Storage Power Station': '에너지 저장 발전소',
            'Photovoltaic Power Station': '태양광 발전소',
            'Fault Alarm': '고장 알람',
            Monitoring: '장비 모니터링',
            'Advanced Reporting': '고급 보고서',
            'Knowledge Base': '지식 베이스',
            'Energy Category Data': '에너지 분류 분석',
            'Energy Item Data': '에너지 항목 분석',
            Carbon: '탄소 배출 분석',
            Cost: '비용 분석',
            Output: '산출 분석',
            Income: '수입 분석',
            Efficiency: '효율 분석',
            Load: '부하 분석',
            Statistics: '통계 분석',
            'Batch Analysis': '일괄 분석',
            Saving: '에너지 절약 분석',
            Plan: '계획 분석',
            Prediction: '예측 분석',
            'Production': '생산량',
            'Space Production': '생산량 에너지 소비 분석',
            'Equipment Tracking': '장비 대장',
            'Equipment Comparison': '비교 분석',
            'Shopfloor Comparison': '비교 분석',
            'Store Comparison': '비교 분석',
            'Space Comparison': '비교 분석',
            'Combined Equipment Comparison': '비교 분석',
            'Tenant Comparison': '비교 분석',
            'Environment Monitor': '환경 모니터링',
            'Meter Energy': '계량기 에너지 소비 분석',
            'Meter Carbon': '계량기 탄소 배출 분석',
            'Meter Cost': '계량기 비용 분석',
            'Meter Trend': '계량기 추세 분석',
            'Meter Realtime': '계량기 실시간 분석',
            'Meter Saving': '계량기 에너지 절약 분석',
            'Meter Plan': '계량기 계획 분석',
            'Master Meter Submeters Balance': '주계량기 및 부계량기 균형 분석',
            'Meter Batch Analysis': '계량기 일괄 분석',
            'Meter Comparison': '계량기 비교 분석',
            'Meter Tracking': '계량기 대장',
            'Virtual Meter Saving': '가상 계량기 에너지 절약 분석',
            'Virtual Meter Plan': '가상 계량기 계획 분석',
            'Virtual Meter Energy': '가상 계량기 에너지 소비 분석',
            'Virtual Meter Carbon': '가상 계량기 탄소 배출 분석',
            'Virtual Meter Cost': '가상 계량기 비용 분석',
            'Virtual Meter Batch Analysis': '가상 계량기 일괄 분석',
            'Virtual Meter Comparison': '가상 계량기 비교 분석',
            'Offline Meter Energy': '오프라인 계량기 에너지 소비 분석',
            'Offline Meter Carbon': '오프라인 계량기 탄소 배출 분석',
            'Offline Meter Cost': '오프라인 계량기 비용 분석',
            'Offline Meter Batch Analysis': '오프라인 계량기 일괄 분석',
            'Offline Meter Saving': '오프라인 계량기 에너지 절약 분석',
            'Offline Meter Plan': '오프라인 계량기 계획 분석',
            'Offline Meter Input': '오프라인 계량기 데이터 입력',
            'Tenant Bill': '임차인 청구서',
            'Energy Flow Diagram': '에너지 흐름도',
            'Distribution System': '배전 시스템',
            'SVG System': '구성 시각화 시스템',
            'Faults Data': '고장 분석',
            'Space Equipments': '공간 장비',
            'Combined Equipments': '복합 장비',
            'Energy Storage Power Station List': '발전소 목록',
            'Energy Storage Power Station Details': '장비 모니터링',
            'Energy Storage Power Station Reporting': '데이터 보고서',
            'Energy Storage Power Station Alarm': '고장 알람',
            'Energy Storage Power Station Maintenance': '유지 보수',
            'Enter Production': '생산량 입력',
            'Multiple Microgrids': '다중 발전소 데이터',
            'Multiple Microgrids Dashboard': '다중 발전소 대시보드',
            'Multiple Microgrids List': '발전소 목록',
            'Single Microgrid': '단일 발전소 데이터',
            'Single Microgrid Dashboard': '단일 발전소 대시보드',
            'Single Microgrid Details': '장비 데이터',
            'Single Microgrid Fault Alarm': '고장 알람',
            'Microgrid Reports': '통계 보고서',
            'Microgrid Reports Energy': '전력량 보고서',
            'Microgrid Reports Revenue': '수익 보고서',
            'Microgrid Reports Parameters': '데이터 조회',
            'Multiple Energy Storage Power Stations': '에너지 저장 다중 발전소 데이터',
            'Multiple Energy Storage Power Stations Dashboard': '에너지 저장 다중 발전소 대시보드',
            'Multiple Energy Storage Power Stations List': '에너지 저장 발전소 목록',
            'Single Energy Storage Power Station': '에너지 저장 단일 발전소 데이터',
            'Single Energy Storage Power Station Dashboard': '에너지 저장 단일 발전소 대시보드',
            'Single Energy Storage Power Station Details': '에너지 저장 장비 데이터',
            'Single Energy Storage Power Station Fault Alarm': '에너지 저장 고장 알람',
            'Energy Storage Power Station Reports': '에너지 저장 통계 보고서',
            'Energy Storage Power Station Reports Energy': '에너지 저장 전력량 보고서',
            'Energy Storage Power Station Reports Revenue': '에너지 저장 수익 보고서',
            'Energy Storage Power Station Reports Parameters': '에너지 저장 데이터 조회',
            'Multiple Photovoltaic Power Stations': '태양광 다중 발전소 데이터',
            'Multiple Photovoltaic Power Stations Dashboard': '태양광 다중 발전소 대시보드',
            'Multiple Photovoltaic Power Stations List': '태양광 발전소 목록',
            'Single Photovoltaic Power Station': '태양광 단일 발전소 데이터',
            'Single Photovoltaic Power Station Dashboard': '태양광 단일 발전소 대시보드',
            'Single Photovoltaic Power Station Details': '태양광 장비 데이터',
            'Single Photovoltaic Power Station Fault Alarm': '태양광 고장 알람',
            'Photovoltaic Power Station Reports': '태양광 통계 보고서',
            'Photovoltaic Power Station Reports Energy': '태양광 전력량 보고서',
            'Photovoltaic Power Station Reports Revenue': '태양광 수익 보고서',
            'Photovoltaic Power Station Reports Parameters': '태양광 데이터 조회',
            'Work Order': '작업 지시 관리',
            'Work Order Installation': '설치 기록',
            'Work Order Repair': '수리 기록',
            'Work Order Inspection': '점검 기록',
            'Total Number of Work Orders': '총 작업 지시 수',
            'Number of New Work Orders': '신규 작업 지시 수',
            'Number of Inprogress Work Orders': '진행 중 작업 지시 수',
            'Number of Done Work Orders': '완료된 작업 지시 수',
            'Fuel Indicator': '연료 소비량',
            'Charge Energy Indicator': '충전 에너지',
            'Discharge Energy Indicator': '방전 에너지',
            'Charge Cost Indicator': '충전 비용',
            'Discharge Revenue Indicator': '방전 수익',
            'HVAC': '공조',
            'Fire Control': '소방',
            // Dashboard
            'Welcome to MyEMS': 'MyEMS에 오신 것을 환영합니다',
            'An Industry Leading Open Source Energy Management System': '업계를 선도하는 오픈소스 에너지 관리 시스템',
            "This Year's Consumption CATEGORY VALUE UNIT": '올해 {{CATEGORY}} {{UNIT}} 소비 {{VALUE}}',
            "This Year's Costs CATEGORY VALUE UNIT": '올해 {{CATEGORY}} {{UNIT}} 비용 {{VALUE}}',
            "This Month's Consumption CATEGORY VALUE UNIT": '이번 달 {{CATEGORY}} {{UNIT}} 소비 {{VALUE}}',
            "This Month's Generation CATEGORY VALUE UNIT": '이번 달 {{CATEGORY}} {{UNIT}} 생산 {{VALUE}}',
            "This Month's Costs CATEGORY VALUE UNIT": '이번 달 {{CATEGORY}} {{UNIT}} 비용 {{VALUE}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': '작년 동기 {{CATEGORY}} {{UNIT}} 소비 {{VALUE}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '작년 동기 {{CATEGORY}} {{UNIT}} 비용 {{VALUE}}',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} {{UNIT}} 소비',
            'CATEGORY Costs UNIT': '{{CATEGORY}} {{UNIT}} 비용',
            // Entities
            Space: '공간',
            Equipment: '장비',
            Meter: '계량기',
            'Offline Meter': '오프라인 계량기',
            'Virtual Meter': '가상 계량기',
            Tenant: '임차인',
            Store: '매장',
            Shopfloor: '작업장',
            'Combined Equipment': '복합 장비',
            'Cost Center': '비용 센터',
            Name: '이름',
            DisplayName: '표시 이름',
            UserName: '사용자 이름',
            Description: '설명',
            'Energy Category': '에너지 분류',
            'Child Spaces': '하위 공간',
            'Associated Equipment': '관련 장비',
            //Energy Categories
            Electricity: '전기',
            Water: '수도',
            'Natural Gas': '천연가스',
            // SidePanelModal
            Settings: '설정',
            'Set your own customized style': '사용자 정의 스타일 설정',
            'Color Scheme': '색 구성표',
            'Choose the perfect color mode for your app': '앱에 적합한 색상 모드 선택',
            Light: '밝은 모드',
            Dark: '어두운 모드',
            'RTL Mode': 'RTL 모드',
            'Switch your language direction': '언어 방향 전환',
            'Fluid Layout': '유동 레이아웃',
            'Toggle container layout system': '컨테이너 레이아웃 시스템 전환',
            'Navigation Position': '네비게이션 위치',
            'Vertical': '수직',
            'Top': '상단',
            'Combo': '콤보',
            'Transparent': '투명',
            'Inverted': '반전',
            'Card': '카드',
            'Vibrant': '활기',
            'Select a suitable navigation system for your web application': '웹 애플리케이션에 적합한 네비게이션 시스템 선택',
            'Vertical Nav': '수직 네비게이션',
            'Top Nav': '상단 네비게이션',
            'Vertical Navbar Style': '수직 네비게이션바 스타일',
            'Switch between styles for your vertical navbar': '수직 네비게이션바 스타일 전환',
            Language: '언어',
            'Switch between languages': '언어 전환',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': '시스템이 마음에 드시나요?',
            'Get MyEMS now': '지금 MyEMS를 받으세요',
            'PQ.About': '본 분석은 전압 편차, 전압 불평형, 주파수 편차 및 전류 불평형을 포함합니다. 전압 편차는 (U−Un)/Un×100%로 계산되며, 주파수 편차는 |f−fn|으로 계산됩니다. 3상 불평형은 max(|Xi−Xavg|)/Xavg×100%로 계산되며, 3상 채널 시간 동기화가 필요합니다. 결과는 선택된 계량기의 보고 기간 동안 시계열을 기반으로 합니다. 3상 채널이 없거나 타임스탬프가 일치하지 않으면 불평형 지표는 건너뜁니다. 순간적인 스파이크 또는 샘플 누락은 최악의 값을 증폭시킬 수 있으며, 정상 상태 평가는 합격률 및 P95와 같은 통계 지표를 참조하는 것이 좋습니다.',
            Purchase: '엔터프라이즈 버전 구매',
            ContactInfo: '연락처 정보',
            ProductWebsite: '제품 웹사이트',
            CompanyWebsite: '회사 웹사이트',
            SalesPhone: '영업 전화',
            // Query Panels
            'Base Period Begins': '기준 기간 시작',
            'Base Period Ends': '기준 기간 종료',
            'Comparison Types': '비교 유형',
            'Year-Over-Year': '전년 대비',
            'Month-On-Month': '전월 대비',
            'Free Comparison': '자유 비교',
            'None Comparison': '비교 없음',
            'Reporting Period Begins': '보고 기간 시작',
            'Reporting Period Ends': '보고 기간 종료',
            '(Optional)': '(선택 사항)',
            'Period Types': '시간 단위',
            Yearly: '연간',
            Monthly: '월간',
            Weekly: '주간',
            Daily: '일간',
            Hourly: '시간별',
            Submit: '제출',
            'Input Energy Category': '에너지 소비 분류',
            'Output Energy Category': '에너지 생산 분류',
            'Fraction Parameter': '분수 매개변수',
            Search: '검색',
            //DateRangePicker
            sunday: '일',
            monday: '월',
            tuesday: '화',
            wednesday: '수',
            thursday: '목',
            friday: '금',
            saturday: '토',
            ok: '확인',
            today: '오늘',
            yesterday: '어제',
            hours: '시',
            minutes: '분',
            seconds: '초',
            last7Days: '최근 7일',
            'Select Date Range': '날짜 범위 선택',
            //Card Summaries and Line Charts
            'Base Period': '기준 기간',
            'Reporting Period': '보고 기간',
            'Per Unit Area': '단위 면적당 값',
            'Per Capita': '인당 값',
            'Per Unit Production': '단위 제품당 값',
            Baseline: '기준값',
            Actual: '실제값',
            'Baseline Value - Actual Value': '기준값 - 실제값',
            'Average Load': '평균 부하',
            'Maximum Load': '최대 부하',
            'Load Factor': '부하율',
            'Ratio of Average Load to Maximum Load': '평균 부하 대 최대 부하 비율',
            'Carbon Dioxide Emissions by Energy Category': '이산화탄소 배출 비율',
            'Costs by Energy Category': '비용 비율',
            'Incomes by Energy Category': '수입 비율',
            'Electricity Consumption by Time-Of-Use': '시간대별 전력 소비',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': '시간대별 전력 이산화탄소 배출',
            'Electricity Cost by Time-Of-Use': '시간대별 전력 비용',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} 항목별 소비 비율',
            'Ton of Standard Coal by Energy Category': '톤 표준 석탄(TCE) 비율',
            'Ton of Carbon Dioxide Emissions by Energy Category': '톤 이산화탄소 배출(TCO2E) 비율',
            'Reporting Period Consumption CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 소비',
            'Reporting Period Prediction CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 예측',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 소비',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 소비',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': '보고 기간 {{PRODUCT}} {{VALUE}} {{UNIT}} 생산',
            'Base Period Production PRODUCT VALUE UNIT': '기준 기간 {{PRODUCT}} {{VALUE}} {{UNIT}} 생산',
            'Reporting Period Consumption CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
            'Reporting Period Prediction CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 예측',
            'Base Period Consumption CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
            'Base Period Prediction CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 예측',
            'Reporting Period Consumption ITEM CATEGORY UNIT': '보고 기간 {{ITEM}} {{CATEGORY}} {{UNIT}} 소비',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '보고 기간 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': '기준 기간 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
            'Child Space Proportion CATEGORY UNIT': '하위 공간 {{CATEGORY}} {{UNIT}} 비율',
            'Child Space Total Proportion': '하위 공간 총 비율',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 이산화탄소 배출',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 이산화탄소 배출',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 이산화탄소 배출',
            'Reporting Period Costs CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 비용',
            'Reporting Period Costs CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 비용',
            'Base Period Costs CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 비용',
            'Reporting Period Output CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 생산',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 생산',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 보고 기간 {{CATEGORY}} {{UNIT}} 생산',
            'Reporting Period Output CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 생산',
            'Base Period Output CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 생산',
            'Reporting Period Income CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 수입',
            'Reporting Period Income CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 수입',
            'Base Period Income CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 수입',
            'Reporting Period Total Income UNIT': '보고 기간 총 수입 {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': '보고 기간 누적 효율 {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} 보고 기간 누적 효율 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} 보고 기간 누적 종합 효율 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 보고 기간 누적 종합 효율 {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 기준 기간 누적 종합 효율 {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': '순간 효율 {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 순간 효율 {{UNIT}}',
            'Equipment Efficiency Indicator': '장비 에너지 효율 지표',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 순간 종합 효율 {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': '보고 기간 누적 효율 {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '보고 기간 누적 효율 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': '기준 기간 누적 효율 {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': '기준 기간 누적 효율 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': '기준 기간 {{CATEGORY}} 최대 부하 {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': '보고 기간 {{CATEGORY}} 최대 부하 {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': '보고 기간 {{CATEGORY}} 평균 부하 {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': '보고 기간 {{CATEGORY}} 부하율',
            'Base Period CATEGORY Average Load VALUE UNIT': '기준 기간 {{CATEGORY}} 평균 부하 {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': '보고 기간 {{CATEGORY}} 평균 {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': '보고 기간 {{CATEGORY}} 최대값 {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': '보고 기간 {{CATEGORY}} 최소값 {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': '보고 기간 {{CATEGORY}} 산술 평균 {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': '보고 기간 {{CATEGORY}} 중앙값 {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': '보고 기간 {{CATEGORY}} 표본 표준 편차 {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': '보고 기간 {{CATEGORY}} 표본 분산 {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 절감 (기준 - 실제)',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 감소 (기준 - 실제)',
            'Reporting Period Saving CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 절감',
            'Base Period Saving CATEGORY VALUE UNIT': '기준 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 절감',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': '보고 기간 주계량기 {{CATEGORY}} {{UNIT}} 소비',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '보고 기간 주계량기 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
            'Reporting Period Submeters Consumption CATEGORY UNIT': '보고 기간 부계량기 {{CATEGORY}} {{UNIT}} 소비',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': '보고 기간 부계량기 {{CATEGORY}} {{VALUE}} {{UNIT}} 소비',
            'Reporting Period Difference CATEGORY UNIT': '보고 기간 {{CATEGORY}} {{UNIT}} 차이',
            'Reporting Period Percentage Difference': '보고 기간 차이 백분율',
            'Reporting Period Difference CATEGORY VALUE UNIT': '보고 기간 {{CATEGORY}} {{VALUE}} {{UNIT}} 차이',
            'Trend Values': '추세 값',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': '고장 목록',
            'Reporting Period Number of Fault VALUE': '보고 기간 고장 수: {{VALUE}}',
            'All Faults': '모든 고장',
            'Space Faults': '공간 고장',
            'Number of All Faults': '전체 고장 수',
            'Number of Space Faults': '공간 고장 수',
            'Total Number of Faults': '총 고장 수',
            'Number of New Faults': '신규 고장 수',
            'Number of Inprogress Faults': '진행 중 고장 수',
            'Number of Done Faults': '완료된 고장 수',
            //Data Panels
            'Ton of Standard Coal': '톤 표준 석탄',
            'Ton of Carbon Dioxide Emissions': '톤 이산화탄소 배출',
            'Carbon Emissions Per Unit Of Energy Consumption': '단위 에너지 소비당 탄소 배출',
            'Operating Characteristic Curve': '운전 특성 곡선',
            Tariff: '요금',
            'Detailed Data': '상세 데이터',
            'Child Spaces Data': '하위 공간 데이터',
            'Associated Equipment Data': '관련 장비 데이터',
            'This Year': '올해',
            'The Same Period Last Year': '작년 동기',
            'This Month': '이번 달',
            'This Day': '오늘',
            Total: '총계',
            'No data found': '데이터 없음',
            Export: '내보내기',
            Datetime: '날짜 시간',
            'Time-Of-Use Type': '시간대별 유형',
            'Top-Peak': '최대',
            'On-Peak': '최고',
            'Mid-Peak': '중간',
            'Off-Peak': '최저',
            'Deep': '최저(심야)',
            Percentage: '백분율',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': '에너지 값 포인트 최근 1시간 추세',
            Circuit: '회로',
            Point: '데이터 포인트',
            'Realtime Value': '실시간 값',
            //Meter Tracking
            'Meter List': '계량기 목록',
            'Edit Meter': '편집',
            'Start Value': '시작 값',
            'End Value': '종료 값',
            'Difference Value': '차이 값',
            'Start Integrity Rate': '시작 데이터 무결성율(%)',
            'End Integrity Rate': '종료 데이터 무결성율(%)',
            'Full Integrity Rate': '전체 데이터 무결성율(%)',
            //Equipment Tracking
            'Equipment List': '장비 목록',
            'Edit Equipment': '편집',
            //Profile Dropdown
            Feedback: '피드백',
            'Account Settings': '계정 설정',
            Logout: '로그아웃',
            //Authentication
            'Log in': '로그인',
            'Email address': '이메일 주소',
            'Phone Number': '전화번호',
            Password: '비밀번호',
            CaptchaCode: '인증 코드',
            Refresh: '새로 고침',
            'Remember me': '로그인 상태 유지',
            'Logged in as ': '다음으로 로그인됨 ',
            'Forgot Password?': '비밀번호를 잊으셨나요?',
            'Forgot your password?': '비밀번호를 잊으셨나요?',
            "Enter your email and we'll send you a reset link": '이메일을 입력하면 재설정 링크를 보내드립니다',
            "Enter your email and we'll send you a registration link": '이메일을 입력하면 등록 링크를 보내드립니다',
            'Reset Password': '비밀번호 재설정',
            'Thanks for using MyEMS!': 'MyEMS를 사용해 주셔서 감사합니다!',
            'You are now successfully signed out': '성공적으로 로그아웃되었습니다',
            'Return to Login': '로그인으로 돌아가기',
            'Please check your email!': '이메일을 확인하세요!',
            'An email has been sent to ': '이메일이 다음으로 발송되었습니다 ',
            'Please click on the included link to reset your password': '비밀번호를 재설정하려면 포함된 링크를 클릭하세요',
            'Please click on the included link to register your account': '계정을 등록하려면 포함된 링크를 클릭하세요',
            'An email with password reset link is sent to ': '비밀번호 재설정 링크가 포함된 이메일이 다음으로 발송되었습니다 ',
            'Change Password': '비밀번호 변경',
            'Old Password': '기존 비밀번호',
            'New Password': '새 비밀번호',
            'Confirm Password': '새 비밀번호 확인',
            'Update Password': '비밀번호 업데이트',
            'Password has been changed!': '비밀번호가 변경되었습니다!',
            'Verification code has been sent to your inbox. \
  Please copy it to the input box below.':
                '인증 코드가 수신함으로 발송되었습니다. 아래 입력란에 복사하세요.',
            'New to MyEMS': 'MyEMS가 처음이신가요',
            'Create an account': '계정 생성',
            'EMAIL Account registration successful': '{{EMAIL}} 계정 등록 성공',
            'Thanks for verifying your account!': '계정 인증에 감사드립니다!',
            'Your code is': '귀하의 코드는',
            'Send verification code': '인증 코드 전송',
            'Please wait for NUMBER seconds': '{{NUMBER}}초 동안 기다려주세요',
            'Password reset': '비밀번호 재설정',
            'Please wait for approval': '승인을 기다려주세요',
            //notification
            Notifications: '알림',
            'Mark all as read': '모두 읽음으로 표시',
            'View all': '모두 보기',
            'Notification New': '새로운',
            'Notification Earlier': '이전',
            'Notification List': '알림 목록',
            'Bulk actions': '일괄 작업',
            'Notification Subject': '주제',
            'Notification Created Datetime': '생성 시간',
            'Notification Message': '내용',
            'Notification Priority': '우선순위',
            'Notification Status': '상태',
            'Notification Mark As Read': '읽음으로 표시',
            'Notification Mark As Acknowledged': '확인',
            'Notification Low': '낮음',
            'Notification Medium': '중간',
            'Notification High': '높음',
            'Notification Critical': '심각',
            'Notification Unread': '읽지 않음',
            'Notification Read': '읽음',
            'Notification Acknowledged': '확인됨',
            'Notification Archive': '보관',
            'Notification Delete': '삭제',
            'Notification Apply': '적용',
            'Notification Start Datetime': '시작 시간',
            'Notification End Datetime': '종료 시간',
            'Notification Update Datetime': '업데이트 시간',
            //Monitoring
            'Run Commands': '명령 실행',
            'Pin Code': '암호',
            'Unlock': '잠금 해제',
            'Set Value': '값 설정',
            'Fault Alarms': '고장 알람',
            'Instantaneous Efficiency VALUE UNIT': '순간 효율 {{VALUE}} {{UNIT}}',
            'Communication Status': '통신 상태',
            'Communication Online': '온라인',
            'Communication Offline': '오프라인',
            'Equipment Status': '장비 상태',
            'Equipment Running': '운전 중',
            'Equipment Stopped': '정지',
            'Show Up to': '페이지당 표시 수',
            All: '전체',
            'FROM - TO of TOTAL': '현재 {{FROM}} - {{TO}} 표시, 총 {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': '전력량',
            'Microgrid Revenue': '수익',
            'Microgrid Carbon': '탄소 배출',
            'Photovoltaic Generation': '태양광 발전량',
            'EV Charger Consumption': '전기차 충전기 소비량',
            'Load Consumption': '부하 소비량',
            'Grid Buy': '전력망 구매량',
            'Grid Sell': '전력망 판매량',
            'EV Charger': '전기차 충전기',
            'Heat Pump': '히트펌프',
            'Photovoltaic': '태양광',
            'PCS Run State': 'PCS 운전 상태',
            'PCS Unknown': '알 수 없음',
            'PCS Initializing': '초기 전원 공급',
            'PCS Standby': '대기',
            'PCS Shutdown': '종료',
            'PCS Fault': '고장',
            'PCS Running': '운전 중',
            'Battery Power': '배터리 전력',
            'Photovoltaic Power': '태양광 전력',
            'Grid Power': '전력망 전력',
            'Load Power': '부하 전력',
            Reporting: '데이터 보고서',
            Maintenance: '유지 보수',
            'General Information': '기본 정보',
            'Serial Number': '일련 번호',
            Address: '주소',
            'Postal Code': '우편번호',
            'Rated Capacity': '정격 용량',
            'Rated Power': '정격 출력',
            Latitude: '위도',
            Longitude: '경도',
            'Strategy Management': '전략 관리',
            'Charging Schedule': '충전 일정',
            'Charge Start Time': '충전 시작 시간',
            'Charge End Time': '충전 종료 시간',
            'Discharge Start Time': '방전 시작 시간',
            'Discharge End Time': '방전 종료 시간',
            'Total Rated Power': '총 정격 출력',
            'Total Rated Capacity': '총 정격 용량',
            // Energy Indicator
            "Today's Charge": "오늘 충전량",
            "Today's Discharge": "오늘 방전량",
            "Today's Generation": "오늘 발전량",
            'Total Fuel Consumption': '총 연료 소비량',
            'Total Charge': '총 충전',
            'Total Discharge': '총 방전',
            'Total Generation': '총 발전량',
            'Total Revenue': '총 수익',
            'Total Photovoltaic Generation': '총 태양광 발전량',
            'Total EV Charger Consumption': '전기차 충전기 총 소비량',
            'Total Load Consumption': '부하 총 소비량',
            'Total Grid Buy': '전력망 총 구매량',
            'Total Grid Sell': '전력망 총 판매량',
            'Total Efficiency': '종합 효율',
            'Discharge Achievement Rate': '방전 달성률',
            // Revenue Indicator
            "Today's Cost": "오늘 비용",
            "Today's Income": "오늘 수입",
            "Total Cost": "누적 비용",
            "Total Income": "누적 수입",
            "Today's Revenue": "오늘 수익",

            'Revenue Ranking': '수익 순위',
            'Efficiency Ranking': '효율 순위',
            'Charge Ranking': '충전 순위',
            'Discharge Ranking': '방전 순위',
            'Number of Microgrids': '마이크로그리드 수',
            'Number of Power Stations': '발전소 수',
            'Microgrid List': '마이크로그리드 목록',
            'Select Microgrid': '마이크로그리드 선택',
            'Previous Page': '이전 페이지',
            'Next Page': '다음 페이지',
            '7 Days': '7일',
            'Charge UNIT': '충전 {{UNIT}}',
            'Discharge UNIT': '방전 {{UNIT}}',
            'Generation UNIT': '발전 {{UNIT}}',
            'Energy Indicator': '에너지',
            'Revenue Indicator': '수익',
            'Carbon Indicator': '탄소',

            // Energy Storage Power Station
            'Battery Operating State': '배터리 운전 상태',
            'Battery State': '배터리 상태',
            'Battery Unknown': '알 수 없음',
            'Battery Stopped': '정지',
            'Battery Reserved': 'Reserved',
            'Battery Fault': '고장',
            'Battery Warning': '경고',
            'Battery Standby': '대기',
            'Battery Prohibit DisCharging': '방전 금지',
            'Battery Prohibit Charging': '충전 금지',
            'Battery Normal': '정상',
            'Battery Charging': '충전 중',
            'Battery Discharging': '방전 중',
            'Battery Idle': '유휴 상태',
            'Phase of Lifecycle': '단계',
            'Use Phase': '가동',
            'Commissioning Phase': '시운전',
            'Commissioning Date': '가동 날짜',
            'Installation Phase': '건설 중',
            'Device Status': '장비 상태',
            'Basic Information': '기본 정보',
            'Gateway': '게이트웨이',
            'Grid Meter': '전력망 계량기',
            'Load Meter': '부하 계량기',
            'ESS Meter': '에너지 저장 계량기',
            'Total Active Power': '총 유효 전력',
            'Active Power A': 'A상 유효 전력',
            'Active Power B': 'B상 유효 전력',
            'Active Power C': 'C상 유효 전력',
            'Total Reactive Power': '총 무효 전력',
            'Reactive Power A': 'A상 무효 전력',
            'Reactive Power B': 'B상 무효 전력',
            'Reactive Power C': 'C상 무효 전력',
            'Total Apparent Power': '총 피상 전력',
            'Apparent Power A': 'A상 피상 전력',
            'Apparent Power B': 'B상 피상 전력',
            'Apparent Power C': 'C상 피상 전력',
            'Total Power Factor': '총 역률',
            'Active Energy Import': '순방향 유효 전력',
            'Active Energy Export': '역방향 유효 전력',
            'Active Energy Net': '순 유효 전력',

            'Generator': '발전기',

            // Photovoltaic Power Station
            'Invertor': '인버터',
            'Invertor Run State': '인버터 운전 상태',
            'Invertor Unknown': '알 수 없음',
            'Invertor Initializing': '초기 전원 공급',
            'Invertor Standby': '대기',
            'Invertor Shutdown': '종료',
            'Invertor Fault': '고장',
            'Invertor Running': '운전 중',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': '생성 시간',
            'File Format': '파일 형식',
            'File Size': '파일 크기',
            Uploader: '업로더',
            'Upload Datetime': '업로드 시간',
            //Error
            "The page you're looking for is not found": '찾으시는 페이지를 찾을 수 없습니다',
            "Make sure the address is correct and that the page hasn't moved": '주소가 올바른지, 페이지가 이동되지 않았는지 확인하세요',
            'If you think this is a mistake,': '이것이 실수라고 생각되시면,',
            'contact us': '문의하기',
            'Take me home': '홈으로 이동',
            'Whoops, something went wrong!': '앗, 문제가 발생했습니다!',
            'Try refreshing the page, or going back and attempting the action again':
                '페이지를 새로 고침하거나, 돌아가서 작업을 다시 시도하세요',
            'If this problem persists,': '문제가 계속되면,',
            'Captcha Error': '인증 코드 오류',
            'Confirm Password Error': '비밀번호 불일치',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                '유효하지 않은 비밀번호 재설정 링크를 클릭한 것 같습니다. 다시 시도해 주세요.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                '유효하지 않은 계정 등록 링크를 클릭한 것 같습니다. 다시 시도해 주세요.',
            //Tenant Bill
            'Lease Contract Number': '임대 계약 번호',
            Download: '다운로드',
            Print: '인쇄',
            'Payment Notice': '지불 안내서',
            'Bill To': '수취인',
            'Bill Number': '청구서 번호',
            'Bill Date': '청구서 날짜',
            'Payment Due Date': '지불 기한',
            'Amount Payable': '지불 금액',
            'Billing Period Start': '청구 기간 시작일',
            'Billing Period End': '청구 기간 종료일',
            Quantity: '수량',
            Price: '단가',
            Unit: '단위',
            Amount: '금액',
            Subtotal: '소계',
            'VAT Output Tax': '부가가치세 출력 세금',
            'Total Amount Payable': '총 지불 금액',
            'Please make sure to pay on or before the payment due date above': '위 지불 기한 또는 그 이전에 지불해 주십시오',
            'Send money to the following account': '다음 계좌로 송금',
            'Account Name': '계좌 명의',
            'Bank Name': '은행 이름',
            'Bank Address': '은행 주소',
            'RMB Account': '위안 계좌',
            // button
            'Toggle Navigation': '네비게이션 전환',
            // working calendar
            'Working Days': '근무일',
            'Non Working Days': '비근무일',
            'Select Row': '작업할 데이터 행 선택',
            // Offline Meter Input
            'Daily Value': '일일 데이터',
            Date: '날짜',
            'Successfully Saved': '성공적으로 저장됨',
            'Previous Data Is Empty': '이전 데이터가 비어 있음',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Bad request',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
            'API.CONTACT_NOT_FOUND': 'Contact not found',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external ID exists',
            'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
            'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
            'API.COST_FILE_NOT_FOUND': 'Cost file not found',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
            'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
            'API.DATABASE_ERROR': 'Database error',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date is already in working calendar',
            'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
            'API.EMAIL_NOT_FOUND': 'Email not found',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
            'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
            'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
            'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
            'API.ERROR': 'Error',
            'API.EXCEPTION': 'Exception',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
            'API.GATEWAY_NOT_FOUND': 'Gateway not found',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Invalid ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Invalid address',
            'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
            'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report ID',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Invalid area value',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Invalid baud rate',
            'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Invalid category',
            'API.INVALID_CHANNEL': 'Invalid channel',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment ID',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter ID',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment UUIDs',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Invalid connection',
            'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
            'API.INVALID_CONTACT_ID': 'Invalid contact ID',
            'API.INVALID_CONTACT_NAME': 'Invalid contact name',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Invalid cost center ID',
            'API.INVALID_COST_FILE_ID': 'Invalid cost file ID',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Invalid data source ID',
            'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
            'API.INVALID_DATE_LOCAL': 'Invalid date local',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter UUID',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Invalid display name',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit ID',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
            'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system ID',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Invalid email',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message ID',
            'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
            'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server ID',
            'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
            'API.INVALID_END_DATETIME': 'Invalid end datetime',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category ID',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
            'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item ID',
            'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
            'API.INVALID_EQUIPMENT_ID': 'Invalid equipment ID',
            'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter ID',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
            'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment UUID',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Invalid expression',
            'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
            'API.INVALID_FDD_CODE': 'Invalid FDD code',
            'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
            'API.INVALID_FROM_ADDR': 'Invalid from addr',
            'API.INVALID_GATEWAY_ID': 'Invalid gateway ID',
            'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
            'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
            'API.INVALID_IS_ENABLED': 'Invalid is enabled',
            'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
            'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
            'API.INVALID_KGCE': 'Invalid kgce',
            'API.INVALID_KGCO2E': 'Invalid kgco2e',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file ID',
            'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
            'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
            'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
            'API.INVALID_MASTER_METER_ID': 'Invalid master meter ID',
            'API.INVALID_MENU_ID': 'Invalid menu ID',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Invalid meter ID',
            'API.INVALID_METER_NAME': 'Invalid meter name',
            'API.INVALID_METER_UUID': 'Invalid meter UUID',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Invalid name value',
            'API.INVALID_NEW_PASSWORD': 'Invalid new password',
            'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
            'API.INVALID_NOTIFICATION_ID': 'Invalid notification ID',
            'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter UUID',
            'API.INVALID_OBJECT_TYPE': 'Invalid object type',
            'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file ID',
            'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter ID',
            'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
            'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter UUID',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
            'API.INVALID_OLD_PASSWORD': 'Invalid old password',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space ID',
            'API.INVALID_PASSWORD': 'Invalid password',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
            'API.INVALID_PEAK_LOAD': 'Invalid peak load',
            'API.INVALID_PERIOD_TYPE': 'Invalid period type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Invalid point ID',
            'API.INVALID_POINT_NAME': 'Invalid point name',
            'API.INVALID_PORT': 'Invalid port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Invalid priority',
            'API.INVALID_PRIVILEGE': 'Invalid privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
            'API.INVALID_PRIVILEGE_ID': 'Invalid privilege ID',
            'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
            'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Invalid reply',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
            'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
            'API.INVALID_RULE_ID': 'Invalid rule ID',
            'API.INVALID_RULE_NAME': 'Invalid rule name',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Invalid sensor ID',
            'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Invalid serial port',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session, please re-login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor ID',
            'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
            'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor UUID',
            'API.INVALID_SOURCE_NODE_ID': 'Invalid source node ID',
            'API.INVALID_SPACE_ID': 'Invalid space ID',
            'API.INVALID_SPACE_NAME': 'Invalid space name',
            'API.INVALID_SPACE_UUID': 'Invalid space UUID',
            'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
            'API.INVALID_START_DATETIME': 'Invalid start datetime',
            'API.INVALID_STATUS': 'Invalid status',
            'API.INVALID_STORE_ID': 'Invalid store ID',
            'API.INVALID_STORE_NAME': 'Invalid store name',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
            'API.INVALID_STORE_TYPE_ID': 'Invalid store type ID',
            'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
            'API.INVALID_STORE_UUID': 'Invalid store UUID',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Invalid SVG',
            'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
            'API.INVALID_TARGET_NODE_ID': 'Invalid target node ID',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
            'API.INVALID_TARIFF_ID': 'Invalid tariff ID',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
            'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
            'API.INVALID_TENANT_ID': 'Invalid tenant ID',
            'API.INVALID_TENANT_NAME': 'Invalid tenant name',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
            'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type ID',
            'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
            'API.INVALID_TENANT_UUID': 'Invalid tenant UUID',
            'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message ID',
            'API.INVALID_TIMEZONE_ID': 'Invalid timezone ID',
            'API.INVALID_TOKEN': 'Invalid token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
            'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
            'API.INVALID_UNITS': 'Invalid units',
            'API.INVALID_USER_ID': 'Invalid user ID',
            'API.INVALID_USER_NAME': 'Invalid user name',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
            'API.INVALID_USER_PHONE': 'Invalid user phone',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
            'API.INVALID_USER_UUID': 'Invalid user UUID',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter ID',
            'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
            'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
            'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
            'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter ID',
            'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
            'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter UUID',
            'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message ID',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message ID',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar ID',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge file cannot be removed from disk',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Master meter does not belong to same energy category',
            'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
            'API.MENU_NOT_FOUND': 'Menu not found',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
            'API.METER_NOT_FOUND': 'Meter not found',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
            'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day not found',
            'API.NOT_FOUND': 'Not found',
            'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
            'API.INVALID_OFFLINE_METER_VALUE': '유효하지 않은 오프라인 계량기 값',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
            'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
            'API.PASSWORDS_MATCH': 'Passwords match',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
            'API.POINT_NOT_FOUND': 'Point not found',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
            'API.RULE_NOT_FOUND': 'Rule not found',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
            'API.SENSOR_NOT_FOUND': 'Sensor not found',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
            'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
            'API.SPACE_NOT_FOUND': 'Space not found',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
            'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
            'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be earlier than end datetime',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
            'API.STORE_NOT_FOUND': 'Store not found',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
            'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
            'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
            'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
            'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
            'API.TARIFF_IN_USE': 'Tariff in use',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
            'API.TARIFF_NOT_FOUND': 'Tariff not found',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
            'API.TENANT_NOT_FOUND': 'Tenant not found',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
            'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
            'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'There is relation with combined equipment parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There is relation with energy storage containers batteries',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There is relation with energy storage containers grids',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There is relation with energy storage containers loads',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There is relation with energy storage containers power conversion systems',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
            'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
            'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
            'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
            'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'There is relation with virtual power plants',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
            'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers, please login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User account has been locked',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'User account has expired',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
            'API.USER_NOT_FOUND': 'User not found',
            'API.USER_PASSWORD_HAS_EXPIRED': 'User password has expired',
            'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
            'API.USER_SESSION_NOT_FOUND': 'User session not found',
            'API.USER_SESSION_TIMEOUT': 'User session timeout',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User UUID not found in headers, please login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
            'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

            MasterMeter: '주계량기',
            SubMeter: '부계량기',
            'Power Quality': '전력 품질',
            'About Power Quality': '전력 품질에 관하여',
            'Trend Values': '추세 값',
            Category: '카테고리',
            Type: '유형',
            Unit: '단위',
            Limit: '한계',
            'Normal Limit': '정상 한계',
            'Severe Limit': '심각한 한계',
            Compliance: '합격률',
            'Worst Deviation': '최악 편차',
            'Worst Time': '최악 발생 시간',
            'Severe Exceed Count': '심각 초과 횟수',
            'Worst Unbalance': '최대 불평형률',
            Hz: '헤르츠',
            voltage: '전압',
            current: '전류',
            frequency: '주파수',
            voltage_deviation: '전압 편차',
            current_unbalance: '전류 불평형',
            voltage_unbalance: '전압 불평형',
            mean_deviation_pct: '평균 편차(%)',
            p95_abs_deviation_pct: 'P95 절대 편차(%)',
            mean_abs_deviation_hz: '평균 절대 편차(Hz)',
            frequency_deviation: '주파수 편차',
            p95_abs_deviation_hz: 'P95 절대 편차(Hz)',
            mean_unbalance_pct: '평균 불평형률(%)',
            p95_unbalance_pct: 'P95 불평형률(%)',
            count: '계수',
            min: '최소값',
            max: '최대값',
            mean: '평균',
            std: '표준 편차',
            p5: 'P5',
            p95: 'P95'
        }
    },
    pt: {
        translation: {
            // routes & menus
            Dashboard: 'Painel de instrumentos',
            'Space Data': 'Espaço',
            'Equipment Data': 'Equipamentos',
            'Meter Data': 'Medidor',
            'Tenant Data': 'Inquilino',
            'Store Data': 'Loja',
            'Shopfloor Data': 'Chão de fábrica',
            'Combined Equipment Data': 'Equipamento Combinado',
            'Auxiliary System': 'Sistema Auxiliar',
            Microgrid: 'Microgrelha',
            'Energy Storage Power Station': 'Central eléctrica',
            'Photovoltaic Power Station': 'Central eléctrica',
            'Fault Alarm': 'Alarme de falha',
            Monitoring: 'Monitoramento',
            'Advanced Reporting': 'Relatórios Avançados',
            'Knowledge Base': 'Base de Conhecimento',
            'Energy Category Data': 'Categoria energética',
            'Energy Item Data': 'Item de energia',
            Carbon: 'Emissões de CO2',
            Cost: 'Custo',
            Output: 'Saída',
            Income: 'Rendimentos',
            Efficiency: 'Eficiência',
            Load: 'Carregar',
            Statistics: 'Estatísticas',
            'Batch Analysis': 'Análise em Lote',
            Saving: 'Poupança',
            Plan: 'Planejamento',
            Prediction: 'Prediction',
            'Production': 'Produção',
            'Space Production': 'Produção Espacial',
            'Equipment Tracking': 'Rastreamento do equipamento',
            'Equipment Comparison': 'Comparação de equipamentos',
            'Shopfloor Comparison': 'Comparação de equipamentos',
            'Store Comparison': 'Comparação de equipamentos',
            'Combined Equipment Comparison': 'Comparação de equipamentos',
            'Tenant Comparison': 'comparação de inquilinos',
            'Environment Monitor': 'Monitor Ambiente',
            'Meter Energy': 'Energia do medidor',
            'Meter Carbon': 'Medidor de emissões de CO2',
            'Meter Cost': 'Custo do medidor',
            'Meter Trend': 'Tendência do medidor',
            'Meter Realtime': 'Medidor em Tempo Real',
            'Meter Saving': 'Economia do medidor',
            'Meter Plan': 'Plano do medidor',
            'Master Meter Submeters Balance': 'Master Metro Submeters Equilíbrio',
            'Meter Batch Analysis': 'Análise de lotes de medidores',
            'Meter Comparison': 'Comparação do medidor',
            'Meter Tracking': 'Rastreamento do medidor',
            'Virtual Meter Saving': 'Poupança do medidor virtual',
            'Virtual Meter Plan': 'Plano do medidor virtual',
            'Virtual Meter Energy': 'Energia do medidor virtual',
            'Virtual Meter Carbon': 'Emissões de CO2 do medidor virtual',
            'Virtual Meter Cost': 'Custo do medidor virtual',
            'Virtual Meter Batch Analysis': 'Análise de lotes de medidores virtuais',
            'Virtual Meter Comparison': 'Comparação de Medidores Virtuais',
            'Offline Meter Energy': 'Energia do medidor offline',
            'Offline Meter Carbon': 'Medidor off-line Emissões de CO2',
            'Offline Meter Cost': 'Custo do medidor offline',
            'Offline Meter Batch Analysis': 'Análise de lotes de medidores offline',
            'Offline Meter Saving': 'Economia do medidor offline',
            'Offline Meter Plan': 'Plano do medidor offline',
            'Offline Meter Input': 'Entrada do medidor offline',
            'Tenant Bill': 'Lei do inquilino',
            'Energy Flow Diagram': 'Diagrama de fluxo de energia',
            'Distribution System': 'Sistema de distribuição',
            'SVG System': 'Sistema de Visualização SCADA',
            'Faults Data': 'Defeitos',
            'Space Equipments': 'equipamentos espaciais',
            'Combined Equipments': 'Equipamentos combinados',
            'Energy Storage Power Station List': 'Lista',
            'Energy Storage Power Station Details': 'Detalhes',
            'Energy Storage Power Station Reporting': 'Relatórios',
            'Energy Storage Power Station Alarm': 'Alarme',
            'Energy Storage Power Station Maintenance': 'Manutenção',
            'Enter Production': 'Entrar Produção',
            'Multiple Microgrids': 'Multiple Microgirds',
            'Multiple Microgrids Dashboard': 'Dashboard',
            'Multiple Microgrids List': 'List',
            'Single Microgrid': 'Single Microgrid',
            'Single Microgrid Dashboard': 'Dashboard',
            'Single Microgrid Details': 'Details',
            'Single Microgrid Fault Alarm': 'Fault Alarm',
            'Microgrid Reports': 'Power Station Reports',
            'Microgrid Reports Energy': 'Energy',
            'Microgrid Reports Revenue': 'Revenue',
            'Microgrid Reports Parameters': 'Parameters',
            'Multiple Energy Storage Power Stations': 'Várias estações elétricas',
            'Multiple Energy Storage Power Stations Dashboard': 'Painel',
            'Multiple Energy Storage Power Stations List': 'Lista',
            'Single Energy Storage Power Station': 'Estação elétrica única',
            'Single Energy Storage Power Station Dashboard': 'Painel',
            'Single Energy Storage Power Station Details': 'Detalhes',
            'Single Energy Storage Power Station Fault Alarm': 'Alarme de falha',
            'Energy Storage Power Station Reports': 'Relatórios da Estação de Energia',
            'Energy Storage Power Station Reports Energy': 'Energia',
            'Energy Storage Power Station Reports Revenue': 'Receita',
            'Energy Storage Power Station Reports Parameters': 'Parâmetros',
            'Photovoltaic Power Station List': 'Lista de Estações de Energia',
            'Photovoltaic Power Station Details': 'Detalhes',
            'Photovoltaic Power Station Reporting': 'Relatórios',
            'Photovoltaic Power Station Alarm': 'Alarme',
            'Photovoltaic Power Station Maintenance': 'Manutenção',
            'Multiple Photovoltaic Power Stations': 'Várias estações elétricas',
            'Multiple Photovoltaic Power Stations Dashboard': 'Painel',
            'Multiple Photovoltaic Power Stations List': 'Lista',
            'Single Photovoltaic Power Station': 'Estação elétrica única',
            'Single Photovoltaic Power Station Dashboard': 'Painel',
            'Single Photovoltaic Power Station Details': 'Detalhes',
            'Single Photovoltaic Power Station Fault Alarm': 'Alarme de falha',
            'Photovoltaic Power Station Reports': 'Relatórios da Estação de Energia',
            'Photovoltaic Power Station Reports Energy': 'Energia',
            'Photovoltaic Power Station Reports Revenue': 'Receita',
            'Photovoltaic Power Station Reports Parameters': 'Parâmetros',
            'Work Order': 'Ordem de trabalho',
            'Work Order Installation': 'Instalação',
            'Work Order Repair': 'Reparação',
            'Work Order Inspection': 'Inspeção',
            'Total Number of Work Orders': 'Número total de encomendas de trabalho',
            'Number of New Work Orders': 'Número de novos pedidos de trabalho',
            'Number of Inprogress Work Orders': 'Número de pedidos de trabalho em curso',
            'Number of Done Work Orders': 'Número de pedidos de trabalho realizados',
            'Fuel Indicator': 'Consumo de combustível',
            'Charge Energy Indicator': 'Energia de carga',
            'Discharge Energy Indicator': 'Energia de descarga',
            'Charge Cost Indicator': 'Custo de cobrança',
            'Discharge Revenue Indicator': 'Receitas de quitação',
            'HVAC': 'HVAC',
            'Fire Control': 'Controle Incêndio',

            // Dashboard
            'Welcome to MyEMS': 'Bem-vindo ao MyEMS',
            'An Industry Leading Open Source Energy Management System':
                'Um sistema de gerenciamento de energia de código aberto líder da indústria',
            "This Year's Consumption CATEGORY VALUE UNIT": "O consumo deste ano {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Year's Costs CATEGORY VALUE UNIT": "Custos deste ano {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Consumption CATEGORY VALUE UNIT": "Este mês Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": "Custos deste mês {{CATEGORY}} {{VALUE}} {{UNIT}}",
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Consumo {{CATEGORY}} {{VALUE}} {{UNIT}} No mesmo período do ano passado',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Custos {{CATEGORY}} {{VALUE}} {{UNIT}} No mesmo período do ano passado',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Consumo {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Custos {{UNIT}}',
            // Entities
            Space: 'Espaço',
            Equipment: 'Equipamento',
            Meter: 'medidor',
            'Offline Meter': 'medidor offline',
            'Virtual Meter': 'Medidor virtual',
            Tenant: 'Locatário',
            Store: 'Loja',
            Shopfloor: 'Shopfloor',
            'Combined Equipment': 'Equipamento combinado',
            'Cost Center': 'Centro Custo',
            Name: 'Nome',
            DisplayName: 'Mostrar o Nome',
            UserName: 'Nome do usuário',
            Description: 'Descrição',
            'Energy Category': 'Categoria de energia',
            'Child Spaces': 'Espaços para crianças',
            'Associated Equipment': 'Equipamento associado',
            //Energy Categories
            Electricity: 'eletricidade',
            Water: 'Água',
            'Natural Gas': 'gás natural',
            // SidePanelModal
            Settings: 'Configuração',
            'Set your own customized style': 'Defina seu próprio estilo personalizado',
            'Color Scheme': 'Esquema de cores',
            'Choose the perfect color mode for your app': 'Escolha o modo de cor perfeito para o seu aplicativo',
            Light: 'Luz',
            Dark: 'Escuro',
            'RTL Mode': 'Modo RTL',
            'Switch your language direction': 'Mude de direção de idioma',
            'Fluid Layout': 'Layout de fluido',
            'Toggle container layout system': 'Alternar o sistema de layout do contêiner',
            'Navigation Position': 'Posição de Navegação',
            'Vertical': 'Vertical',
            'Top': 'Topo',
            'Combo': 'Combinação',
            'Transparent': 'Transparente',
            'Inverted': 'Invertido',
            'Card': 'Cartão',
            'Vibrant': 'Vivo',
            'Select a suitable navigation system for your web application':
                'Selecione um sistema de navegação adequado para sua aplicação web',
            'Vertical Nav': 'Navegação Vertical',
            'Top Nav': 'Navegação superior',
            'Vertical Navbar Style': 'Estilo Navbar Vertical',
            'Switch between styles for your vertical navbar': 'Alternar entre estilos para sua barra de navegação vertical',
            Language: 'Idioma',
            'Switch between languages': 'Alternar entre idiomas',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Gosto do que você vê?',
            'Get MyEMS now': 'Obtenha MyEMS agora',
            Purchase: 'Edição Enterprise',
            ContactInfo: 'Informacoes de Contato',
            ProductWebsite: 'Site do Produto',
            CompanyWebsite: 'Site da Empresa',
            SalesPhone: 'Telefone de Vendas',
            // Query Panel
            'Base Period Begins': 'Período de base começa',
            'Base Period Ends': 'Período de base termina',
            'Comparison Types': 'Tipos de comparação',
            'Year-Over-Year': 'Ano após ano',
            'Month-On-Month': 'Mês-a-Mês',
            'Free Comparison': 'Comparação Livre',
            'None Comparison': 'Nenhuma comparação',
            'Reporting Period Begins': 'Periodo de relatório começa',
            'Reporting Period Ends': 'Fim do Período de Relatório',
            '(Optional)': '(Opcional)',
            'Period Types': 'Tipos de Período',
            Yearly: 'Anualmente',
            Monthly: 'Mensal',
            Weekly: 'Semanalmente',
            Daily: 'Diário',
            Hourly: 'Horário',
            Submit: 'Enviar',
            'Input Energy Category': 'Categoria de energia de entrada',
            'Output Energy Category': 'Categoria de energia de saída',
            'Fraction Parameter': 'Parâmetro da fração',
            Search: 'Pesquisar',
            //DateRangePicker
            sunday: 'Dom',
            monday: 'Seg',
            tuesday: 'Ter',
            wednesday: 'Qua',
            thursday: 'Qui',
            friday: 'Sex',
            saturday: 'Sáb',
            ok: 'OK',
            today: 'Hoje',
            yesterday: 'Ontem',
            hours: 'Horário',
            minutes: 'minutos',
            seconds: 'segundos',
            last7Days: 'Últimos 7 Dias',
            'Select Date Range': 'Selecionar intervalo de data',
            //Card Summaries and Line Charts
            'Base Period': 'Período de base',
            'Reporting Period': 'Período de reporte',
            'Per Unit Area': 'Por Área Unidade',
            'Per Capita': 'Por Capita',
            'Per Unit Production': 'Produção por unidade',
            Baseline: 'Linha de base',
            Actual: 'Atuais',
            'Baseline Value - Actual Value': 'Linha de base - Atual',
            'Average Load': 'Carga média',
            'Maximum Load': 'Carga máxima',
            'Load Factor': 'Fator de carga',
            'Ratio of Average Load to Maximum Load': 'Relação de carga média para carga máxima',
            'Carbon Dioxide Emissions by Energy Category': 'Emissões de dióxido de carbono por categoria de energia',
            'Costs by Energy Category': 'Custos por categoria de energia',
            'Incomes by Energy Category': 'Rendimentos por categoria de energia',
            'Electricity Consumption by Time-Of-Use': 'Consumo de eletricidade por tempo de uso',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Electricidade Emissões de dióxido de carbono por tempo de utilização',
            'Electricity Cost by Time-Of-Use': 'Custo da eletricidade por tempo de uso',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Consumo por Itens Energéticos',
            'Ton of Standard Coal by Energy Category': 'Tonelada de carvão normal(TCE) por categoria de energia',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Tonelada de Emissões de Dióxido de Carbono (TCO2E) por Categoria de Energia',
            'Reporting Period Consumption CATEGORY UNIT': 'Consumo do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Consumo do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Consumo do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Consumo do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Produção do período de relatório {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Produção do Período Base {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Consumo do Período Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Consumo do Período de Relatório {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Consumo do Período de Relatório {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Consumo do Período Base {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Proporção de espaço infantil por categoria de energia {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Proporção total de espaço infantil',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Emissões de dióxido de carbono no período de relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emissões de dióxido de carbono no período de relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emissões de dióxido de carbono no período de base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Custos do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Custos do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Custos do período de base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Saída do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Saída do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Saída do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Saída do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Produção do período de base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Rendimento do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Rendimento do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Rendimento do Período Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Período de reporte Total do rendimento {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Eficiência Cumulativa do Período de Relatório {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Eficiência Cumulativa do Período de Relatório {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência global cumulativa do período de relatório {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência global cumulativa do período de relatório {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência completa cumulativa do período de base {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Eficiência Instantânea {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Eficiência Instantânea {{UNIT}}',
            'Equipment Efficiency Indicator': 'Indicador de Eficiência Energética do Equipamento',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência abrangente instantânea {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Eficiência Cumulativa do Período de Relatório {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Eficiência Cumulativa do Período de Relatório {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Eficiência Cumulativa do Período Base {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Eficiência Cumulativa do Período Base {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Período de base {{CATEGORY}} Carga máxima {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Período de reporte {{CATEGORY}} Carga máxima {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Período de reporte {{CATEGORY}} Carga média {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Período de reporte {{CATEGORY}} Fator de carga',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Período de base {{CATEGORY}} Carga média {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Período de reporte {{CATEGORY}} Valor médio {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Período de reporte {{CATEGORY}} Valor máximo {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Período de reporte {{CATEGORY}} Valor mínimo {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Período de reporte {{CATEGORY}} média aritmética {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Período de reporte {{CATEGORY}} Mediana (valor médio) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Período de reporte {{CATEGORY}} Desvio padrão da amostra {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Período de reporte {{CATEGORY}} Variância da amostra {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Economia do período de relatório {{CATEGORY}} (Linha de base - Atual) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Período de relatório diminuído {{CATEGORY}} (Linha de base - Atual) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Economia do período de relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Economia do Período Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Consumo do medidor mestre do período de relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Consumo do medidor mestre do período de relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Período de Relatório Submetros Consumo {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Período de Relatório Submetros Consumo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Diferença do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Período de relatório Diferença percentual',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Diferença do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Valores de tendência',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Lista de falhas',
            'Reporting Period Number of Fault VALUE': 'Período de relatório Número de falhas {{VALUE}}',
            'All Faults': 'Todas as falhas',
            'Space Faults': 'Falhas espaciais',
            'Number of All Faults': 'Número de todas as falhas',
            'Number of Space Faults': 'Número de falhas espaciais',
            'Total Number of Faults': 'Número total de falhas',
            'Number of New Faults': 'Número de novas falhas',
            'Number of Inprogress Faults': 'Número de falhas em curso',
            'Number of Done Faults': 'Número de falhas feitas',
            //Data Panels
            'Ton of Standard Coal': 'Tonelada de carvão normal',
            'Ton of Carbon Dioxide Emissions': 'Toneladas de emissões de dióxido de carbono',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Emissões de carbono por unidade de consumo de energia',
            'Operating Characteristic Curve': 'Curva característica operacional',
            Tariff: 'Tarifa',
            'Detailed Data': 'Dados detalhados',
            'Child Spaces Data': 'Dados de espaços infantis',
            'Associated Equipment Data': 'Dados de equipamentos associados',
            'This Year': 'Este ano',
            'The Same Period Last Year': 'O mesmo período do ano passado',
            'This Month': 'Este mês',
            'This Day': 'Este dia',
            Total: 'Total',
            'No data found': 'Não foram encontrados dados',
            Export: 'Exportação',
            Datetime: 'Data e hora',
            'Time-Of-Use Type': 'Tipo de tempo de uso',
            'Top-Peak': 'Top-pico',
            'On-Peak': 'No pico',
            'Mid-Peak': 'Meio-pico',
            'Off-Peak': 'Off-pico',
            'Deep': 'Deep-Valley',
            Percentage: 'Percentagem',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Tendência na última hora de Energy Value Point',
            Circuit: 'Circuito',
            Point: 'Ponto',
            'Realtime Value': 'Valor em tempo real',
            //Meter Tracking
            'Meter List': 'Lista do medidor',
            'Edit Meter': 'Editar',
            'Start Value': 'Valor inicial',
            'End Value': 'Valor Final',
            'Difference Value': 'Valor da Diferença',
            'Start Integrity Rate': 'Taxa de Integridade Inicial(%)',
            'End Integrity Rate': 'Taxa de integridade final(%)',
            'Full Integrity Rate': 'Taxa de Integridade Total(%)',
            //Equipment Tracking
            'Equipment List': 'Lista de equipamentos',
            'Edit Equipment': 'Editar',
            //Profile Dropdown
            Feedback: 'Comentários',
            'Account Settings': 'Configurações da Conta',
            Logout: 'Sair',
            //Authentication
            'Log in': 'Entrar',
            'Email address': 'Endereço de e-mail',
            'Phone Number': 'Número de telefone',
            Password: 'Senha',
            CaptchaCode: 'Captcha',
            Refresh: 'Refreshar',
            'Remember me': 'Lembre-se de mim',
            'Logged in as ': 'Login como ',
            'Forgot Password?': 'Esqueci a senha?',
            'Forgot your password?': 'Esqueceu a senha?',
            "Enter your email and we'll send you a reset link": "Digite seu e-mail e nós lhe enviaremos um link de reset",
            "Enter your email and we'll send you a registration link":
                "Digite seu e-mail e enviaremos um link de registro",
            'Reset Password': 'Restaurar senha',
            'Thanks for using MyEMS!': 'Obrigado por usar o MyEMS!',
            'You are now successfully signed out': 'Você saiu com sucesso',
            'Return to Login': 'Voltar para Login',
            'Please check your email!': 'Por favor, verifique seu e-mail!',
            'An email has been sent to ': 'Um e-mail foi enviado para ',
            'Please click on the included link to reset your password':
                'Clique no link incluído para redefinir sua senha',
            'Please click on the included link to register your account':
                'Clique no link incluído para registrar sua conta',
            'An email with password reset link is sent to ': 'Um e-mail com link de redefinição de senha é enviado para ',
            'Change Password': 'Alterar senha',
            'Old Password': 'Senha antiga',
            'New Password': 'Nova senha',
            'Confirm Password': 'Confirmar senha',
            'Update Password': 'Atualizar senha',
            'Password has been changed!': 'A senha foi alterada!',
            'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
                'Código de verificação foi enviado para a sua caixa de entrada. \
  Por favor, copie-o para a caixa de entrada abaixo.',
            'New to MyEMS': 'Novo no MyEMS',
            'Create an account': 'Criar uma conta',
            'EMAIL Account registration successful': '{{EMAIL}} Registro de conta bem sucedido',
            'Thanks for verifying your account!': 'Obrigado por verificar sua conta!',
            'Your code is': 'Seu código é',
            'Send verification code': 'Enviar código de verificação',
            'Please wait for NUMBER seconds': 'Por favor aguarde {{NUMBER}} segundos',
            'Password reset': 'Reinicializar senha',
            'Please wait for approval': 'Aguarde a aprovação',
            //notification
            Notifications: 'Notificações',
            'Mark all as read': 'Marcar tudo como lido',
            'View all': 'Todos',
            'Notification New': 'NOVO',
            'Notification Earlier': 'MAIS ANTERIOR',
            'Notification List': 'Lista de notificações',
            'Bulk actions': 'Ações em massa',
            'Notification Subject': 'Assunto',
            'Notification Created Datetime': 'Data e hora de criação',
            'Notification Priority': 'Prioridade',
            'Notification Message': 'Mensagem',
            'Notification Status': 'Estado',
            'Notification Mark As Read': 'Marcar como lido',
            'Notification Mark As Acknowledged': 'Reconhecer',
            'Notification Low': 'Baixo',
            'Notification Medium': 'Médio',
            'Notification High': 'Alta',
            'Notification Critical': 'Crítico',
            'Notification Unread': 'Não lido',
            'Notification Read': 'Leia',
            'Notification Acknowledged': 'Reconhecido',
            'Notification Archive': 'Arquivo',
            'Notification Delete': 'Apagar',
            'Notification Apply': 'Aplicar',
            'Notification Start Datetime': 'Data de início e hora',
            'Notification End Datetime': 'Data e hora do fim',
            'Notification Update Datetime': 'Actualizar a Data- Hora',
            //Monitoring
            'Run Commands': 'Executar comandos',
            'Pin Code': 'Código Pin',
            'Unlock': 'Desbloquear',
            'Set Value': 'Definir o Valor',
            'Fault Alarms': 'Alarmes de falha',
            'Instantaneous Efficiency VALUE UNIT': 'Eficiência Instantânea {{VALUE}} {{UNIT}}',
            'Communication Online': 'Online',
            'Communication Offline': 'Offline',
            'Equipment Status': 'Estado do equipamento',
            'Equipment Running': 'Correndo',
            'Equipment Stopped': 'Parado',
            'Show Up to': 'Mostrar até',
            All: 'Todos',
            'FROM - TO of TOTAL': 'A exibição atual de {{FROM}} - {{TO}} total {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Energia de Microrrede',
            'Microgrid Revenue': 'Receita de Microrrede',
            'Microgrid Carbon': 'Carbono de Microrrede',
            'Photovoltaic Generation': 'Geração Fotovoltaica',
            'EV Charger Consumption': 'Consumo de Carregadores EV',
            'Load Consumption': 'Consumo de Carga',
            'Grid Buy': 'Compra da Rede',
            'Grid Sell': 'Venda para a Rede',
            'EV Charger': 'Carregador EV',
            'Heat Pump': 'Bomba de calor',
            'Photovoltaic': 'Fotovoltaica',
            'PCS Run State': 'Estado de execução do PCS',
            'PCS Unknown': 'Desconhecido',
            'PCS Initializing': 'Inicialização',
            'PCS Standby': 'em espera',
            'PCS Shutdown': 'Desligamento',
            'PCS Fault': 'Falha',
            'PCS Running': 'Correndo',
            'Battery Power': 'Energia da bateria',
            'Photovoltaic Power': 'Potência fotovoltaica',
            'Grid Power': 'Potência da Rede',
            'Load Power': 'Potência de carga',
            Reporting: 'Relatórios',
            Maintenance: 'Manutenção',
            'Serial Number': 'Número de série',
            Address: 'Endereço',
            'Postal Code': 'Código Postal',
            'Rated Capacity': 'Capacidade nominal',
            'Rated Power': 'Potência nominal',
            Latitude: 'Latitude',
            Longitude: 'Longitude',
            'Strategy Management': 'Gestão Estratégica',
            'Charging Schedule': 'Horário de carregamento',
            'Charge Start Time': 'Hora de início da carga',
            'Charge End Time': 'Tempo de fim de carga',
            'Discharge Start Time': 'Hora de início da descarga',
            'Discharge End Time': 'Tempo final de descarga',
            'Total Rated Power': 'Potência nominal total',
            'Total Rated Capacity': 'Capacidade nominal total',
            "Today's Charge": "Carga de hoje",
            "Today's Discharge": "Discharge de hoje",
            "Today's Generation": "Geração de hoje",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Carga Total',
            'Total Discharge': 'Descarga Total',
            'Total Generation': 'Geração Total',
            'Total Revenue': 'Receita Total',
            'Total Photovoltaic Generation': 'Geração Fotovoltaica Total',
            'Total EV Charger Consumption': 'Consumo Total de Carregadores EV',
            'Total Load Consumption': 'Consumo Total de Carga',
            'Total Grid Buy': 'Compra Total da Rede',
            'Total Grid Sell': 'Venda Total para a Rede',
            'Total Efficiency': 'Eficiência Total',
            'Discharge Achievement Rate': 'Taxa de realização da descarga',
            'Revenue Ranking': 'Ranking de receita',
            'Efficiency Ranking': 'Classificação de Eficiência',
            'Charge Ranking': 'Classificação de carga',
            'Discharge Ranking': 'Classificação de descarga',
            'Number of Microgrids': 'Número de microredes',
            'Number of Power Stations': 'Número de estações elétricas',
            'Microgrid List': 'Lista de Microgrelhas',
            'Select Microgrid': 'Selecionar Microgrelha',
            'Previous Page': 'Página anterior',
            'Next Page': 'Página seguinte',
            '7 Days': '7 dias',
            'Charge UNIT': 'Carga {{UNIT}}',
            'Discharge UNIT': 'Descarga {{UNIT}}',
            'Generation UNIT': 'Geração {{UNIT}}',
            'Energy Indicator': 'Energia',
            'Revenue Indicator': 'Receita',
            'Carbon Indicator': 'Carbono',

            // Energy Storage Power Station
            'Battery Operating State': 'Estado de funcionamento da bateria',
            'Battery State': 'Estado da bateria',
            'Battery Unknown': 'Desconhecido',
            'Battery Stopped': 'Parado',
            'Battery Reserved': 'Reservado', // 0
            'Battery Fault': 'Falha', // 1
            'Battery Warning': 'Aviso', // 2
            'Battery Standby': 'em espera', // 3
            'Battery Prohibit DisCharging': 'Proibir Descarga', //4
            'Battery Prohibit Charging': 'Proibir carregamento',// 5
            'Battery Normal': 'Normal', // 6
            'Battery Charging': 'Carregamento', // 7
            'Battery Discharging': 'Descarga', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Fase do Ciclo de Vida',
            'Use Phase': 'Fase de Utilização',
            'Commissioning Phase': 'Fase de comissionamento',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Fase de instalação',
            'Device Status': 'Status do dispositivo',
            'Basic Information': 'Informações básicas',
            'Gateway': 'Portal',
            'Grid Meter': 'Medidor de grade',
            'Load Meter': 'Medidor de carga',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Potência Ativa Total',
            'Active Power A': 'Potência Ativa A',
            'Active Power B': 'Potência Ativa B',
            'Active Power C': 'Potência Ativa C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Potência Reactiva A',
            'Reactive Power B': 'Potência Reactiva B',
            'Reactive Power C': 'Potência Reactiva C',
            'Total Apparent Power': 'Potência aparente total',
            'Apparent Power A': 'Poder aparente A',
            'Apparent Power B': 'Poder aparente B',
            'Apparent Power C': 'Poder aparente C',
            'Total Power Factor': 'Fator de potência total',
            'Active Energy Import': 'Importação de energia ativa',
            'Active Energy Export': 'Exportação de energia ativa',
            'Active Energy Net': 'Rede de Energia Ativa',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'Inversor',
            'Invertor Run State': 'Estado de execução do inversor',
            'Invertor Unknown': 'Desconhecido',
            'Invertor Initializing': 'Inicialização',
            'Invertor Standby': 'em espera',
            'Invertor Shutdown': 'Desligamento',
            'Invertor Fault': 'Falha',
            'Invertor Running': 'Correndo',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Data e hora de criação',
            'File Format': 'Formato do Arquivo',
            'File Size': 'Tamanho do Arquivo',
            Uploader: 'Carregador',
            //Error
            "The page you're looking for is not found": "A página que você está procurando não foi encontrada.",
            "Make sure the address is correct and that the page hasn't moved. ":
                "Certifique-se de que o endereço está correto e que a página não se mudou. ",
            'If you think this is a mistake,': 'Se você acha que isso é um erro,',
            'contact us': 'entre em contato conosco',
            'Take me home': 'Leve-me para casa.',
            'Whoops, something went wrong!': 'Oups, algo deu errado!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Tente atualizar a página ou voltar e tentar a ação novamente. ',
            'If this problem persists,': 'Se esse problema persistir,',
            'Captcha Error': 'Erro Captcha',
            'Confirm Password Error': 'A senha de confirmação não corresponde',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Parece que você clicou \
  em um link de redefinição de senha inválido. Por favor tente novamente.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Parece que você clicou \
  em um link de conta de registro inválido. Por favor tente novamente.',
            //Tenant Bill
            'Lease Contract Number': 'Número do contrato de arrendamento',
            Download: 'Transferir',
            Print: 'Imprimir',
            'Payment Notice': 'Aviso de pagamento',
            'Bill To': 'Bill Para',
            'Bill Number': 'Número da conta',
            'Bill Date': 'Data da fatura',
            'Payment Due Date': 'Data de vencimento do pagamento',
            'Amount Payable': 'Montante a pagar',
            'Billing Period Start': 'Inicio do Período de Faturação',
            'Billing Period End': 'Fim do Período de Faturação',
            Quantity: 'Quantidade',
            Price: 'Preço',
            Unit: 'Unidade',
            Amount: 'Quantidade',
            Subtotal: 'Subtotal',
            'VAT Output Tax': 'IVA Imposto sobre a Saída',
            'Total Amount Payable': 'Montante total a pagar',
            'Please make sure to pay on or before the payment due date above':
                'Por favor, certifique-se de pagar no ou antes da data de vencimento acima',
            'Send money to the following account': 'Envie dinheiro para a seguinte conta',
            'Account Name': 'Nome da Conta',
            'Bank Name': 'Nome do Banco',
            'Bank Address': 'Endereço Bancário',
            'RMB Account': 'Conta em RMB',
            // button
            'Toggle Navigation': 'Alternar navegação',
            // working calendar
            'Working Days': 'dias de trabalho',
            'Non Working Days': 'dias não úteis',
            'Select Row': 'Selecione Linha de Dados',
            // Offline Meter Input
            'Daily Value': 'Valor diário',
            Date: 'Data',
            'Successfully Saved': 'Salvado com sucesso',
            'Previous Data Is Empty': 'Dados anteriores estão vazios',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Falha ao desbloquear a conta',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sessão de administrador não encontrada',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Tempo de sessão do administrador expirado',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Relatório avançado não encontrado',
            'API.API_KEY_HAS_EXPIRED': 'A chave expirou',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'O nome da chave já está em uso',
            'API.API_KEY_NOT_FOUND': 'Chave não encontrada',
            'API.BAD_REQUEST': 'Solicitação inválida',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Ponto de equilíbrio de preço não encontrado',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Ponto de estado da bateria não encontrado',
            'API.BUY_METER_NOT_FOUND': 'Medidor de compra não encontrado',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Não é possível definir o submedidor existente como medidor principal',
            'API.CHARGE_METER_NOT_FOUND': 'Medidor de carga não encontrado',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Relação de comando de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relação de medidor de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relação de medidor de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'O nome do equipamento combinado já está em uso',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Equipamento combinado não encontrado',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'O nome do parâmetro de equipamento combinado já está em uso',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parâmetro de equipamento combinado não encontrado ou não corresponde',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de equipamento combinado não encontrada',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'O nome do comando já está em uso',
            'API.COMMAND_NOT_FOUND': 'Comando não encontrado',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'O nome do contato já está em uso',
            'API.CONTACT_NOT_FOUND': 'Contato não encontrado',
            'API.COOLING_METER_NOT_FOUND': 'Medidor de resfriamento não encontrado',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'ID externo do centro de custos já existe',
            'API.COST_CENTER_NAME_EXISTS': 'Nome do centro de custos já existe',
            'API.COST_CENTER_NOT_FOUND': 'Centro de custos não encontrado',
            'API.COST_FILE_NOT_FOUND': 'Arquivo de custos não encontrado',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Arquivo de reparo de dados não encontrado',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'O nome da fonte de dados já está em uso',
            'API.DATA_SOURCE_NOT_FOUND': 'Fonte de dados não encontrada',
            'API.DATABASE_ERROR': 'Erro no banco de dados',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Data já está no calendário de trabalho',
            'API.DATE_LOCAL_NOT_FOUND': 'Local da data não encontrado',
            'API.DISCHARGE_METER_NOT_FOUND': 'Medidor de descarga não encontrado',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'O nome do circuito de distribuição já está em uso',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Circuito de distribuição não encontrado',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relação de ponto de circuito de distribuição já existe',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relação de ponto de circuito de distribuição não encontrada',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'O nome do sistema de distribuição já está em uso',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Sistema de distribuição não encontrado',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Medidor de eletricidade não encontrado',
            'API.EMAIL_IS_ALREADY_IN_USE': 'E-mail já está em uso',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Mensagem de e-mail não encontrada',
            'API.EMAIL_NOT_FOUND': 'E-mail não encontrado',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'O host do servidor de e-mail já está em uso',
            'API.EMAIL_SERVER_NOT_FOUND': 'Servidor de e-mail não encontrado',
            'API.EMPTY_VARIABLES_ARRAY': 'Array de variáveis vazio',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'O nome da categoria de energia já está em uso',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Categoria de energia não encontrada',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Categoria de energia usada em itens de energia',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Categoria de energia usada em medidor',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Categoria de energia usada em medidor offline',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Categoria de energia usada em tarifas',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Categoria de energia usada em medidor virtual',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'O link do diagrama de fluxo de energia já está em uso',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Link do diagrama de fluxo de energia não encontrado ou não corresponde',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'O nome do diagrama de fluxo de energia já está em uso',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'O nome do nó do diagrama de fluxo de energia já está em uso',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Nó do diagrama de fluxo de energia não encontrado ou não corresponde',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Diagrama de fluxo de energia não encontrado',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Item de energia não pertence à categoria de energia',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Item de energia não pertence à categoria de energia',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'O nome do item de energia já está em uso',
            'API.ENERGY_ITEM_NOT_FOUND': 'Item de energia não encontrado',
            'API.ENERGY_ITEM_USED_IN_METER': 'Item de energia usado em medidor',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Item de energia usado em medidor offline',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Item de energia usado em medidor virtual',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'O nome da estação de armazenamento de energia já está em uso',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Estação de armazenamento de energia não encontrada',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Relação de comando de equipamento já existe',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de equipamento não encontrada',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relação de medidor de equipamento já existe',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relação de medidor de equipamento não encontrada',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nome do equipamento já está em uso',
            'API.EQUIPMENT_NOT_FOUND': 'Equipamento não encontrado',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de equipamento já existe',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de equipamento não encontrada',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nome do parâmetro de equipamento já está em uso',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parâmetro de equipamento não encontrado ou não corresponde',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de equipamento já existe',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de equipamento não encontrada',
            'API.ERROR': 'Erro',
            'API.EXCEPTION': 'Exceção',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Falha ao ler o fluxo de solicitação',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Falha ao restaurar o arquivo de custos',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Falha ao restaurar o arquivo de reparo de dados',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Falha ao restaurar o arquivo de conhecimento',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Falha ao restaurar o arquivo de medidor offline',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Falha ao salvar o arquivo de medidor offline',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Falha ao fazer upload do arquivo de anexo',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Falha ao fazer upload do arquivo de custos',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Falha ao fazer upload do arquivo de reparo de dados',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Falha ao fazer upload do arquivo de conhecimento',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Falha ao fazer upload do arquivo de medidor offline',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'O nome do gateway já está em uso',
            'API.GATEWAY_NOT_FOUND': 'Gateway não encontrado',
            'API.HEAT_METER_NOT_FOUND': 'Medidor de calor não encontrado',
            'API.INVALID_': 'Inválido',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Código de reconhecimento inválido',
            'API.INVALID_ADDRESS': 'Endereço inválido',
            'API.INVALID_ADDRESS_VALUE': 'Valor de endereço inválido',
            'API.INVALID_ADVANCED_REPORT_ID': 'ID de relatório avançado inválido',
            'API.INVALID_API_KEY_ID': 'ID da chave da API inválido',
            'API.INVALID_API_KEY_NAME': 'Nome da chave da API inválido',
            'API.INVALID_AREA_VALUE': 'Valor de área inválido',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'ID de ponto de preço de equilíbrio inválido',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Data e hora de fim do período base inválida',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Data e hora de início do período base inválida',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'ID de ponto de estado da bateria inválido',
            'API.INVALID_BAUD_RATE': 'Taxa de bauds inválida',
            'API.INVALID_BUILDINGS_VALUE': 'Valor de edifícios inválido',
            'API.INVALID_BUY_METER_ID': 'ID de medidor de compra inválido',
            'API.INVALID_CAPACITY': 'Capacidade inválida',
            'API.INVALID_CATEGORY': 'Categoria inválida',
            'API.INVALID_CHANNEL': 'Canal inválido',
            'API.INVALID_CHARGE_METER_ID': 'ID de medidor de carga inválido',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'ID de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nome de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'ID de parâmetro de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Nome de parâmetro de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Tipo de parâmetro de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID de equipamento combinado inválido',
            'API.INVALID_COMMAND_ID': 'ID de comando inválido',
            'API.INVALID_COMMAND_NAME': 'Nome de comando inválido',
            'API.INVALID_CONNECTION': 'Conexão inválida',
            'API.INVALID_CONSTANT_VALUE': 'Valor constante inválido',
            'API.INVALID_CONTACT_ID': 'ID de contato inválido',
            'API.INVALID_CONTACT_NAME': 'Nome de contato inválido',
            'API.INVALID_COOLING_METER_ID': 'ID de medidor de resfriamento inválido',
            'API.INVALID_COST_CENTER_ID': 'ID de centro de custo inválido',
            'API.INVALID_COST_FILE_ID': 'ID de arquivo de custos inválido',
            'API.INVALID_CREATED_DATETIME': 'Data e hora de criação inválida',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'ID de arquivo de reparo de dados inválido',
            'API.INVALID_DATA_SOURCE_ID': 'ID de fonte de dados inválido',
            'API.INVALID_DATA_SOURCE_NAME': 'Nome de fonte de dados inválido',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Protocolo de fonte de dados inválido',
            'API.INVALID_DATE_LOCAL': 'Local de data inválido',
            'API.INVALID_DENOMINATOR_METER_UUID': 'UUID de medidor de denominador inválido',
            'API.INVALID_DISCHARGE_METER_ID': 'ID de medidor de descarga inválido',
            'API.INVALID_DISPLAY_NAME': 'Nome de exibição inválido',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'ID de circuito de distribuição inválido',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nome de circuito de distribuição inválido',
            'API.INVALID_DISTRIBUTION_ROOM': 'Sala de distribuição inválida',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'ID de sistema de distribuição inválido',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nome de sistema de distribuição inválido',
            'API.INVALID_ELECTRICITY_METER_ID': 'ID de medidor de eletricidade inválido',
            'API.INVALID_EMAIL': 'E-mail inválido',
            'API.INVALID_EMAIL_MESSAGE_ID': 'ID de mensagem de e-mail inválido',
            'API.INVALID_EMAIL_SERVER_HOST': 'Host do servidor de e-mail inválido',
            'API.INVALID_EMAIL_SERVER_ID': 'ID de servidor de e-mail inválido',
            'API.INVALID_END_DATE_FORMAT': 'Formato de data final inválido',
            'API.INVALID_END_DATETIME': 'Data e hora de término inválida',
            'API.INVALID_ENERGY_CATEGORY_ID': 'ID de categoria de energia inválido',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Nome de categoria de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'ID de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'ID de link de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nome de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'ID de nó de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nome de nó de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_ITEM_ID': 'ID de item de energia inválido',
            'API.INVALID_ENERGY_ITEM_NAME': 'Nome de item de energia inválido',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'ID de estação de energia de armazenamento inválido',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Nome de estação de energia de armazenamento inválido',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Equação inválida na expressão',
            'API.INVALID_EQUIPMENT_ID': 'ID de equipamento inválido',
            'API.INVALID_EQUIPMENT_NAME': 'Nome de equipamento inválido',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'ID de parâmetro de equipamento inválido',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nome de parâmetro de equipamento inválido',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Tipo de parâmetro de equipamento inválido',
            'API.INVALID_EQUIPMENT_UUID': 'UUID de equipamento inválido',
            'API.INVALID_EXPIRES_DATETIME': 'Data e hora de expiração inválida',
            'API.INVALID_EXPRESSION': 'Expressão inválida',
            'API.INVALID_EXPRESSION_OBJECT': 'Objeto de expressão inválido',
            'API.INVALID_FDD_CODE': 'Código FDD inválido',
            'API.INVALID_FLOORS_VALUE': 'Valor de andares inválido',
            'API.INVALID_FROM_ADDR': 'Endereço de origem inválido',
            'API.INVALID_GATEWAY_ID': 'ID de gateway inválido',
            'API.INVALID_GATEWAY_NAME': 'Nome de gateway inválido',
            'API.INVALID_HEAT_METER_ID': 'ID de medidor de calor inválido',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Valor de limite superior inválido',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Valor de limite superior horário inválido',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Valor de limite inferior horário inválido',
            'API.INVALID_Id': 'ID inválido',
            'API.INVALID_IS_ADMIN_VALUE': 'Valor de é admin inválido',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Valor de exibição de dados de custo inválido',
            'API.INVALID_IS_COUNTED_VALUE': 'Valor de contado inválido',
            'API.INVALID_IS_ENABLED': 'Valor de habilitado inválido',
            'API.INVALID_IS_HIDDEN': 'Valor de oculto inválido',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Valor de está em leasing inválido',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Valor de entrada contado inválido',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Valor de é inquilino chave inválido',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Valor de saída contado inválido',
            'API.INVALID_IS_OUTPUT_VALUE': 'Valor de saída inválido',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Valor de somente leitura inválido',
            'API.INVALID_IS_TREND_VALUE': 'Valor de tendência inválido',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Valor de virtual inválido',
            'API.INVALID_KGCE': 'KGCE inválido',
            'API.INVALID_KGCO2E': 'KGCO2E inválido',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'ID de arquivo de conhecimento inválido',
            'API.INVALID_LATITUDE_VALUE': 'Valor de latitude inválido',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Valor de número de leasing inválido',
            'API.INVALID_LONGITUDE_VALUE': 'Valor de longitude inválido',
            'API.INVALID_LOW_LIMIT_VALUE': 'Valor de limite inferior inválido',
            'API.INVALID_MASTER_METER_ID': 'ID de medidor mestre inválido',
            'API.INVALID_MENU_ID': 'ID de menu inválido',
            'API.INVALID_MESSAGE_DATA': 'Dados de mensagem inválidos',
            'API.INVALID_MESSAGE_TEMPLATE': 'Modelo de mensagem inválido',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'ID de modelo de mensagem inválido',
            'API.INVALID_MESSAGE_VALUE': 'Valor de mensagem inválido',
            'API.INVALID_METER_ID': 'ID de medidor inválido',
            'API.INVALID_METER_NAME': 'Nome de medidor inválido',
            'API.INVALID_METER_UUID': 'UUID de medidor inválido',
            'API.INVALID_MICROGRID_BATTERY_ID': 'ID de bateria de microrede inválido',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Nome de bateria de microrede inválido',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'ID de carregador EV de microrede inválido',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Nome de carregador EV de microrede inválido',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'ID de gerador de microrede inválido',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Nome de gerador de microrede inválido',
            'API.INVALID_MICROGRID_GRID_ID': 'ID de grade de microrede inválido',
            'API.INVALID_MICROGRID_GRID_NAME': 'Nome de grade de microrede inválido',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'ID de bomba de calor de microrede inválido',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Nome de bomba de calor de microrede inválido',
            'API.INVALID_MICROGRID_ID': 'ID de microrede inválido',
            'API.INVALID_MICROGRID_LOAD_ID': 'ID de carga de microrede inválido',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Nome de carga de microrede inválido',
            'API.INVALID_MICROGRID_NAME': 'Nome de microrede inválido',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'ID de fotovoltaico de microrede inválido',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Nome de fotovoltaico de microrede inválido',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'ID de sistema de conversão de energia de microrede inválido',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Nome de sistema de conversão de energia de microrede inválido',
            'API.INVALID_MICROGRID_UUID': 'UUID de microrede inválido',
            'API.INVALID_NAME_VALUE': 'Valor de nome inválido',
            'API.INVALID_NEW_PASSWORD': 'Nova senha inválida',
            'API.INVALID_NON_WORKING_DAY_ID': 'ID de dia não útil inválido',
            'API.INVALID_NOTIFICATION_ID': 'ID de notificação inválido',
            'API.INVALID_NUMERATOR_METER_UUID': 'UUID de medidor do numerador inválido',
            'API.INVALID_OBJECT_TYPE': 'Tipo de objeto inválido',
            'API.INVALID_OFFLINE_METER_DATA': 'Dados de medidor offline inválidos',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'ID de arquivo de medidor offline inválido',
            'API.INVALID_OFFLINE_METER_ID': 'ID de medidor offline inválido',
            'API.INVALID_OFFLINE_METER_NAME': 'Nome de medidor offline inválido',
            'API.INVALID_OFFLINE_METER_UUID': 'UUID de medidor offline inválido',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Valor de constante de deslocamento inválido',
            'API.INVALID_OLD_PASSWORD': 'Senha antiga inválida',
            'API.INVALID_OPENID': 'OpenID inválido',
            'API.INVALID_PARENT_SPACE_ID': 'ID de espaço pai inválido',
            'API.INVALID_PASSWORD': 'Senha inválida',
            'API.INVALID_PAYLOAD': 'Carga útil inválida',
            'API.INVALID_PEAK_CURRENT': 'Corrente de pico inválida',
            'API.INVALID_PEAK_LOAD': 'Carga de pico inválida',
            'API.INVALID_PERIOD_TYPE': 'Tipo de período inválido',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'ID de estação de energia fotovoltaica inválido',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Nome de estação de energia fotovoltaica inválido',
            'API.INVALID_POINT_ID': 'ID de ponto inválido',
            'API.INVALID_POINT_NAME': 'Nome de ponto inválido',
            'API.INVALID_PORT': 'Porta inválida',
            'API.INVALID_POSTAL_CODE_VALUE': 'Valor de código postal inválido',
            'API.INVALID_POWER_POINT_ID': 'ID de ponto de energia inválido',
            'API.INVALID_PRIORITY': 'Prioridade inválida',
            'API.INVALID_PRIVILEGE': 'Privilégio inválido',
            'API.INVALID_PRIVILEGE_DATA': 'Dados de privilégio inválidos',
            'API.INVALID_PRIVILEGE_ID': 'ID de privilégio inválido',
            'API.INVALID_PRIVILEGE_NAME': 'Nome de privilégio inválido',
            'API.INVALID_RATIO_VALUE': 'Valor de razão inválido',
            'API.INVALID_RECIPIENT_EMAIL': 'Email do destinatário inválido',
            'API.INVALID_RECIPIENT_MOBILE': 'Móvel do destinatário inválido',
            'API.INVALID_RECIPIENT_NAME': 'Nome do destinatário inválido',
            'API.INVALID_RECIPIENT_OPENID': 'OpenID do destinatário inválido',
            'API.INVALID_REPLY': 'Resposta inválida',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Data e hora de término do período de relatório inválidos',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Data e hora de início do período de relatório inválidos',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Requer autenticação inválida',
            'API.INVALID_ROOMS_VALUE': 'Valor de quartos inválido',
            'API.INVALID_RULE_ID': 'ID de regra inválido',
            'API.INVALID_RULE_NAME': 'Nome de regra inválido',
            'API.INVALID_RUN_STATE_POINT_ID': 'ID de ponto de estado de execução inválido',
            'API.INVALID_SCHEDULED_DATETIME': 'Data e hora agendadas inválidas',
            'API.INVALID_SELL_METER_ID': 'ID de medidor de venda inválido',
            'API.INVALID_SENSOR_ID': 'ID de sensor inválido',
            'API.INVALID_SENSOR_NAME': 'Nome de sensor inválido',
            'API.INVALID_SENSOR_UUID': 'UUID de sensor inválido',
            'API.INVALID_SERIAL_NUMBER': 'Número de série inválido',
            'API.INVALID_SERIAL_PORT': 'Porta serial inválida',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sessão inválida, por favor, faça login novamente',
            'API.INVALID_SET_VALUE': 'Valor de configuração inválido',
            'API.INVALID_SHOPFLOOR_ID': 'ID de andar de loja inválido',
            'API.INVALID_SHOPFLOOR_NAME': 'Nome de andar de loja inválido',
            'API.INVALID_SHOPFLOOR_UUID': 'UUID de andar de loja inválido',
            'API.INVALID_SOURCE_NODE_ID': 'ID de nó de origem inválido',
            'API.INVALID_SPACE_ID': 'ID de espaço inválido',
            'API.INVALID_SPACE_NAME': 'Nome de espaço inválido',
            'API.INVALID_SPACE_UUID': 'UUID de espaço inválido',
            'API.INVALID_START_DATE_FORMAT': 'Formato de data de início inválido',
            'API.INVALID_START_DATETIME': 'Data e hora de início inválidas',
            'API.INVALID_STATUS': 'Status inválido',
            'API.INVALID_STORE_ID': 'ID de loja inválido',
            'API.INVALID_STORE_NAME': 'Nome de loja inválido',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Descrição de tipo de loja inválida',
            'API.INVALID_STORE_TYPE_ID': 'ID de tipo de loja inválido',
            'API.INVALID_STORE_TYPE_NAME': 'Nome de tipo de loja inválido',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Código simplificado de tipo de loja inválido',
            'API.INVALID_STORE_UUID': 'UUID de loja inválido',
            'API.INVALID_SUBJECT_VALUE': 'Valor de assunto inválido',
            'API.INVALID_SVG': 'SVG inválido',
            'API.INVALID_SWITCHGEAR': 'Equipamento de manobra inválido',
            'API.INVALID_TARGET_NODE_ID': 'ID de nó de destino inválido',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Precificação de bloco tarifário inválida',
            'API.INVALID_TARIFF_ID': 'ID de tarifa inválido',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Precificação tarifária por tempo de uso inválida',
            'API.INVALID_TARIFF_TYPE': 'Tipo de tarifa inválido',
            'API.INVALID_TENANT_ID': 'ID de inquilino inválido',
            'API.INVALID_TENANT_NAME': 'Nome de inquilino inválido',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Descrição de tipo de inquilino inválida',
            'API.INVALID_TENANT_TYPE_ID': 'ID de tipo de inquilino inválido',
            'API.INVALID_TENANT_TYPE_NAME': 'Nome de tipo de inquilino inválido',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Código simplificado de tipo de inquilino inválido',
            'API.INVALID_TENANT_UUID': 'UUID de inquilino inválido',
            'API.INVALID_TEXT_MESSAGE_ID': 'ID de mensagem de texto inválido',
            'API.INVALID_TIMEZONE_ID': 'ID de fuso horário inválido',
            'API.INVALID_TOKEN': 'Token inválido',
            'API.INVALID_TOPIC': 'Tópico inválido',
            'API.INVALID_UNIT_OF_MEASURE': 'Unidade de medida inválida',
            'API.INVALID_UNIT_OF_PRICE': 'Unidade de preço inválida',
            'API.INVALID_UNITS': 'Unidades inválidas',
            'API.INVALID_USER_ID': 'ID de usuário inválido',
            'API.INVALID_USER_NAME': 'Nome de usuário inválido',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Nome de usuário ou email inválido',
            'API.INVALID_USER_PHONE': 'Telefone de usuário inválido',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Usuário inválido, por favor, faça login novamente',
            'API.INVALID_USER_UUID': 'UUID de usuário inválido',
            'API.INVALID_USERNAME': 'Nome de usuário inválido',
            'API.INVALID_VARIABLE_METER_ID': 'ID de medidor variável inválido',
            'API.INVALID_VARIABLE_METER_TYPE': 'Tipo de medidor variável inválido',
            'API.INVALID_VARIABLE_NAME': 'Nome de variável inválido',
            'API.INVALID_VERIFICATION_CODE': 'Código de verificação inválido',
            'API.INVALID_VIRTUAL_METER_ID': 'ID de medidor virtual inválido',
            'API.INVALID_VIRTUAL_METER_NAME': 'Nome de medidor virtual inválido',
            'API.INVALID_VIRTUAL_METER_UUID': 'UUID de medidor virtual inválido',
            'API.INVALID_WEB_MESSAGE_ID': 'ID de mensagem web inválido',
            'API.INVALID_WECHAT_MESSAGE_ID': 'ID de mensagem WeChat inválido',
            'API.INVALID_WIND_FARM_ID': 'ID de parque eólico inválido',
            'API.INVALID_WIND_FARM_NAME': 'Nome de parque eólico inválido',
            'API.INVALID_WORKING_CALENDAR_ID': 'ID de calendário de trabalho inválido',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Nome de calendário de trabalho inválido',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Arquivo de conhecimento não pode ser removido do disco',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Arquivo de conhecimento não encontrado',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'O medidor mestre não pertence à mesma categoria de energia',
            'API.MASTER_METER_NOT_FOUND': 'Medidor mestre não encontrado',
            'API.MENU_NOT_FOUND': 'Menu não encontrado',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'O medidor não pode ter mais de um ponto de valor de energia',
            'API.METER_COMMAND_RELATION_EXISTS': 'Relação de comando de medidor existe',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de medidor não encontrada',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Nome do medidor já está em uso',
            'API.METER_NOT_FOUND': 'Medidor não encontrado',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Medidor de variável não encontrado',
            'API.METER_POINT_RELATION_EXISTS': 'Relação de ponto de medidor existe',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Relação de ponto de medidor não encontrada',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Nome de bateria de microgrid já está em uso',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Bateria de microgrid não encontrada',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Nome de carregador EV de microgrid já está em uso',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Carregador EV de microgrid não encontrado',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Nome de gerador de microgrid já está em uso',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Gerador de microgrid não encontrado',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Nome de rede de microgrid já está em uso',
            'API.MICROGRID_GRID_NOT_FOUND': 'Rede de microgrid não encontrada',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Nome de bomba de calor de microgrid já está em uso',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Bomba de calor de microgrid não encontrada',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Nome de carga de microgrid já está em uso',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Carga de microgrid não encontrada',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Nome de microgrid já está em uso',
            'API.MICROGRID_NOT_FOUND': 'Microgrid não encontrado',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Nome de fotovoltaico de microgrid já está em uso',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Fotovoltaico de microgrid não encontrado',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nome do sistema de conversão de energia de microgrid já está em uso',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Sistema de conversão de energia de microgrid não encontrado',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Relação de sensor de microgrid existe',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Sensor de microgrid não encontrado',
            'API.MQTT_CONNECTION_ERROR': 'Erro de conexão MQTT',
            'API.MQTT_PUBLISH_ERROR': 'Erro ao publicar no MQTT',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'O comprimento da nova senha não pode exceder 100 caracteres',
            'API.NEW_USER_SESSION_NOT_FOUND': 'Sessão de novo usuário não encontrada',
            'API.NEW_USER_SESSION_TIMEOUT': 'Sessão de novo usuário expirada',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Dia não útil não encontrado',
            'API.NOT_FOUND': 'Não encontrado',
            'API.NOTIFICATION_NOT_FOUND': 'Notificação não encontrada',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Arquivo de medidor offline não encontrado',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nome de medidor offline já está em uso',
            'API.OFFLINE_METER_NOT_FOUND': 'Medidor offline não encontrado',
            'API.INVALID_OFFLINE_METER_VALUE': 'Valor de medidor offline inválido',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Medidor offline de variável não encontrado',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'O comprimento da senha antiga não pode exceder 100 caracteres',
            'API.PARENT_SPACE_NOT_FOUND': 'Espaço pai não encontrado',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'O comprimento da senha não pode exceder 100 caracteres',
            'API.PASSWORDS_MATCH': 'A nova senha é a mesma que a senha antiga',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Nome de estação de energia fotovoltaica já está em uso',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Estação de energia fotovoltaica não encontrada',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nome do ponto já está em uso',
            'API.POINT_NOT_FOUND': 'Ponto não encontrado',
            'API.POWER_POINT_NOT_FOUND': 'Ponto de energia não encontrado',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nome do privilégio já está em uso',
            'API.PRIVILEGE_NOT_FOUND': 'Privilégio não encontrado',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nome da regra já está em uso',
            'API.RULE_NOT_FOUND': 'Regra não encontrada',
            'API.SELL_METER_NOT_FOUND': 'Medidor de venda não encontrado',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nome do sensor já está em uso',
            'API.SENSOR_NOT_FOUND': 'Sensor não encontrado',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Relação de ponto de sensor existe',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relação de ponto de sensor não encontrada',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Relação de comando de shopfloor existe',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de shopfloor não encontrada',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento de shopfloor existe',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento de shopfloor não encontrada',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relação de medidor de shopfloor existe',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relação de medidor de shopfloor não encontrada',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nome de shopfloor já está em uso',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor não encontrado',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de shopfloor existe',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de shopfloor não encontrada',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relação de ponto de shopfloor existe',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relação de ponto de shopfloor não encontrada',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relação de sensor de shopfloor existe',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de shopfloor não encontrada',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de shopfloor existe',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de shopfloor não encontrada',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de shopfloor existe',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de shopfloor não encontrada',
            'API.SOC_POINT_NOT_FOUND': 'Ponto SOC não encontrado',
            'API.SOURCE_NODE_NOT_FOUND': 'Nó de origem não encontrado',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento combinado de espaço existe',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento combinado de espaço não encontrada',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Relação de comando de espaço existe',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de espaço não encontrada',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Relação de estação de energia de armazenamento de espaço existe',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Relação de estação de energia de armazenamento de espaço não encontrada',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento de espaço existe',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento de espaço não encontrada',
            'API.SPACE_METER_RELATION_EXISTS': 'Relação de medidor de espaço existe',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Relação de medidor de espaço não encontrada',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nome de espaço já está em uso',
            'API.SPACE_NOT_FOUND': 'Espaço não encontrado',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Espaço não encontrado no privilégio',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de espaço existe',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de espaço não encontrada',
            'API.SPACE_POINT_RELATION_EXISTS': 'Relação de ponto de espaço existe',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relação de ponto de espaço não encontrada',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Relação de sensor de espaço existe',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de espaço não encontrada',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relação de shopfloor de espaço existe',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relação de shopfloor de espaço não encontrada',
            'API.SPACE_STORE_RELATION_EXISTS': 'Relação de loja de espaço existe',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relação de loja de espaço não encontrada',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Relação de inquilino de espaço existe',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relação de inquilino de espaço não encontrada',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de espaço existe',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de espaço não encontrada',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de espaço existe',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de espaço não encontrada',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'A data/hora de início deve ser anterior à data/hora de término',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Relação de comando de loja existe',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de loja não encontrada',
            'API.STORE_METER_RELATION_EXISTS': 'Relação de medidor de loja existe',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Relação de medidor de loja não encontrada',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Nome de loja já está em uso',
            'API.STORE_NOT_FOUND': 'Loja não encontrada',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de loja existe',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de loja não encontrada',
            'API.STORE_POINT_RELATION_EXISTS': 'Relação de ponto de loja existe',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Relação de ponto de loja não encontrada',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Relação de sensor de loja existe',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de loja não encontrada',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome do tipo de loja já está em uso',
            'API.STORE_TYPE_NOT_FOUND': 'Tipo de loja não encontrado',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Código simplificado do tipo de loja já está em uso',
            'API.STORE_TYPE_USED_IN_STORE': 'Tipo de loja usado na loja',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de loja existe',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de loja não encontrada',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de loja existe',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de loja não encontrada',
            'API.TARGET_NODE_NOT_FOUND': 'Nó de destino não encontrado',
            'API.TARIFF_IN_USE': 'Tarifa em uso',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'A tarifa já está associada ao centro de custo',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'A tarifa não está associada ao centro de custo',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nome da tarifa já está em uso',
            'API.TARIFF_NOT_FOUND': 'Tarifa não encontrada',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Relação de comando de inquilino existe',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de inquilino não encontrada',
            'API.TENANT_METER_RELATION_EXISTS': 'Relação de medidor de inquilino existe',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Relação de medidor de inquilino não encontrada',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nome de inquilino já está em uso',
            'API.TENANT_NOT_FOUND': 'Inquilino não encontrado',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de inquilino existe',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de inquilino não encontrada',
            'API.TENANT_POINT_RELATION_EXISTS': 'Relação de ponto de inquilino existe',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relação de ponto de inquilino não encontrada',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Relação de sensor de inquilino existe',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de inquilino não encontrada',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome do tipo de inquilino já está em uso',
            'API.TENANT_TYPE_NOT_FOUND': 'Tipo de inquilino não encontrado',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Código simplificado do tipo de inquilino já está em uso',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tipo de inquilino usado no inquilino',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de inquilino existe',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de inquilino não encontrada',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de inquilino existe',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de inquilino não encontrada',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Mensagem de texto não encontrada',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'O período de relatório deve ser superior a 15 minutos',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Há relação com medidores filhos',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Há relação com espaços filhos',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Há relação com parâmetros de equipamentos combinados',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Há relação com equipamentos combinados',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Há relação com fontes de dados',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Há relação com links de diagrama de fluxo de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Há relação com baterias de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Há relação com redes de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Há relação com cargas de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Há relação com sistemas de conversão de energia de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Há relação com parâmetros de equipamentos',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Há relação com equipamentos',
            'API.THERE_IS_RELATION_WITH_METER': 'Há relação com medidor',
            'API.THERE_IS_RELATION_WITH_METERS': 'Há relação com medidores',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Há relação com medidor offline',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Há relação com medidores offline',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Há relação com outros medidores virtuais',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'Há relação com sensores',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Há relação com shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'Há relação com espaços',
            'API.THERE_IS_RELATION_WITH_STORES': 'Há relação com lojas',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'Há relação com inquilinos',
            'API.THERE_IS_RELATION_WITH_USERS': 'Há relação com usuários',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Há relação com medidor virtual',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Há relação com usinas de energia virtuais',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Esta fonte de dados está sendo usada por um medidor',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Este medidor está sendo usado por um medidor virtual',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Este medidor offline está sendo usado por um medidor virtual',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'Este espaço não pode ser clonado',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'Este espaço não pode ser deletado',
            'API.TIMEZONE_NOT_FOUND': 'Fuso horário não encontrado',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token não encontrado nos cabeçalhos, por favor faça login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'A conta do usuário foi bloqueada',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'A conta do usuário expirou',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'A conta do usuário não está bloqueada',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'Nome de usuário já está em uso',
            'API.USER_NOT_FOUND': 'Usuário não encontrado',
            'API.USER_PASSWORD_HAS_EXPIRED': 'A senha do usuário expirou',
            'API.USER_PRIVILEGE_NOT_FOUND': 'Privilégio de usuário não encontrado',
            'API.USER_SESSION_NOT_FOUND': 'Sessão de usuário não encontrada',
            'API.USER_SESSION_TIMEOUT': 'Tempo de sessão do usuário expirado',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID do usuário não encontrado nos cabeçalhos, por favor faça login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nome de medidor virtual já está em uso',
            'API.VIRTUAL_METER_NOT_FOUND': 'Medidor virtual não encontrado',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Medidor virtual da variável não encontrado',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Ponto virtual deve ser um valor analógico',
            'API.WEB_MESSAGE_NOT_FOUND': 'Mensagem da web não encontrada',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Mensagem do WeChat não encontrada',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Nome de fazenda eólica já está em uso',
            'API.WIND_FARM_NOT_FOUND': 'Fazenda eólica não encontrada',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nome do calendário de trabalho já está em uso',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Calendário de trabalho não encontrado',

            MasterMeter: 'Mestre medidor',
            SubMeter: 'Submetro',
            'Power Quality': 'Qualidade de energia',
            'About Power Quality': 'Sobre a qualidade de energia',
            Category: 'Categoria',
            Type: 'Tipo',
            Limit: 'Limite',
            'Normal Limit': 'Limite normal',
            'Severe Limit': 'Limite severo',
            Compliance: 'Taxa de conformidade',
            'Worst Deviation': 'Pior desvio',
            'Worst Time': 'Pior momento',
            'Severe Exceed Count': 'Contagem de excedentes severos',
            'Worst Unbalance': 'Desequilíbrio máximo',
            Hz: 'Hz',
            voltage: 'Tensão',
            current: 'Corrente',
            frequency: 'Frequência',
            voltage_deviation: 'Desvio de tensão',
            current_unbalance: 'Desequilíbrio de corrente',
            voltage_unbalance: 'Desequilíbrio de tensão',
            mean_deviation_pct: 'Desvio médio (%)',
            p95_abs_deviation_pct: 'Desvio absoluto P95 (%)',
            mean_abs_deviation_hz: 'Desvio absoluto médio (Hz)',
            frequency_deviation: 'Desvio de frequência',
            p95_abs_deviation_hz: 'Desvio absoluto P95 (Hz)',
            mean_unbalance_pct: 'Desequilíbrio médio (%)',
            p95_unbalance_pct: 'Desequilíbrio P95 (%)',
            count: 'Contagem',
            min: 'Mín',
            max: 'Máx',
            mean: 'Média',
            std: 'Desvio padrão',
            p5: 'P5',
            p95: 'P95'
        }
    },
    it: {
        translation: {
// routes & menus
            Dashboard: 'Dashboard',
            'Space Data': 'Dati Spazio',
            'Equipment Data': 'Dati Attrezzatura',
            'Meter Data': 'Dati Contatore',
            'Tenant Data': 'Dati Locatario',
            'Store Data': 'Dati Negozio',
            'Shopfloor Data': 'Dati Reparto',
            'Combined Equipment Data': 'Dati Attrezzatura Combinata',
            'Auxiliary System': 'Sistema Ausiliario',
            Microgrid: 'Microrete',
            'Energy Storage Power Station': 'Centrale di Accumulo Energia',
            'Photovoltaic Power Station': 'Centrale Fotovoltaica',
            'Fault Alarm': 'Allarme Guasto',
            Monitoring: 'Monitoraggio',
            'Advanced Reporting': 'Report Avanzati',
            'Knowledge Base': 'Base di Conoscenza',
            'Energy Category Data': 'Analisi Categoria Consumi',
            'Energy Item Data': 'Analisi Voci di Consumo',
            Carbon: 'Analisi Emissioni CO2',
            Cost: 'Analisi Costi',
            Output: 'Analisi Produzione',
            Income: 'Analisi Ricavi',
            Efficiency: 'Analisi Efficienza',
            Load: 'Analisi Carico',
            Statistics: 'Analisi Statistica',
            'Batch Analysis': 'Analisi Batch',
            Saving: 'Analisi Risparmio Energetico',
            Plan: 'Analisi Piano',
            Prediction: 'Analisi Previsionale',
            'Production': 'Produzione',
            'Space Production': 'Analisi Consumo per Produzione Spazio',
            'Equipment Tracking': 'Registro Attrezzature',
            'Equipment Comparison': 'Analisi Comparativa',
            'Shopfloor Comparison': 'Analisi Comparativa',
            'Store Comparison': 'Analisi Comparativa',
            'Space Comparison': 'Analisi Comparativa',
            'Combined Equipment Comparison': 'Analisi Comparativa',
            'Tenant Comparison': 'Analisi Comparativa',
            'Environment Monitor': 'Monitor Ambientale',
            'Meter Energy': 'Analisi Consumo Contatore',
            'Meter Carbon': 'Analisi Emissioni CO2 Contatore',
            'Meter Cost': 'Analisi Costi Contatore',
            'Meter Trend': 'Analisi Trend Contatore',
            'Meter Realtime': 'Analisi in Tempo Reale Contatore',
            'Meter Saving': 'Analisi Risparmio Contatore',
            'Meter Plan': 'Analisi Piano Contatore',
            'Master Meter Submeters Balance': 'Analisi Bilanciamento Contatore Principale-Sottocontatori',
            'Meter Batch Analysis': 'Analisi Batch Contatore',
            'Meter Comparison': 'Analisi Comparativa Contatori',
            'Meter Tracking': 'Registro Contatori',
            'Virtual Meter Saving': 'Analisi Risparmio Contatore Virtuale',
            'Virtual Meter Plan': 'Analisi Piano Contatore Virtuale',
            'Virtual Meter Energy': 'Analisi Consumo Contatore Virtuale',
            'Virtual Meter Carbon': 'Analisi Emissioni CO2 Contatore Virtuale',
            'Virtual Meter Cost': 'Analisi Costi Contatore Virtuale',
            'Virtual Meter Batch Analysis': 'Analisi Batch Contatore Virtuale',
            'Virtual Meter Comparison': 'Analisi Comparativa Contatori Virtuali',
            'Offline Meter Energy': 'Analisi Consumo Contatore Offline',
            'Offline Meter Carbon': 'Analisi Emissioni CO2 Contatore Offline',
            'Offline Meter Cost': 'Analisi Costi Contatore Offline',
            'Offline Meter Batch Analysis': 'Analisi Batch Contatore Offline',
            'Offline Meter Saving': 'Analisi Risparmio Contatore Offline',
            'Offline Meter Plan': 'Analisi Piano Contatore Offline',
            'Offline Meter Input': 'Inserimento Dati Contatore Offline',
            'Tenant Bill': 'Fattura Locatario',
            'Energy Flow Diagram': 'Diagramma Flusso Energia',
            'Distribution System': 'Sistema Distribuzione',
            'SVG System': 'Sistema Configurazione Visiva (SVG)',
            'Faults Data': 'Analisi Guasti',
            'Space Equipments': 'Attrezzature Spazio',
            'Combined Equipments': 'Attrezzature Combinate',
            'Energy Storage Power Station List': 'Lista Centrali Accumulo',
            'Energy Storage Power Station Details': 'Monitoraggio Attrezzatura',
            'Energy Storage Power Station Reporting': 'Report Dati',
            'Energy Storage Power Station Alarm': 'Allarme Guasto',
            'Energy Storage Power Station Maintenance': 'Manutenzione',
            'Enter Production': 'Inserimento Produzione',
            'Multiple Microgrids': 'Dati Multi-Stazione Microrete',
            'Multiple Microgrids Dashboard': 'Dashboard Multi-Stazione',
            'Multiple Microgrids List': 'Lista Centrali Microrete',
            'Single Microgrid': 'Dati Singola Stazione Microrete',
            'Single Microgrid Dashboard': 'Dashboard Singola Stazione',
            'Single Microgrid Details': 'Dati Attrezzatura',
            'Single Microgrid Fault Alarm': 'Allarme Guasto Singola Stazione',
            'Microgrid Reports': 'Report Statistici Microrete',
            'Microgrid Reports Energy': 'Report Energia Microrete',
            'Microgrid Reports Revenue': 'Report Ricavi Microrete',
            'Microgrid Reports Parameters': 'Query Dati Microrete',
            'Multiple Energy Storage Power Stations': 'Dati Multi-Stazione Accumulo',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard Multi-Stazione Accumulo',
            'Multiple Energy Storage Power Stations List': 'Lista Centrali Accumulo',
            'Single Energy Storage Power Station': 'Dati Singola Stazione Accumulo',
            'Single Energy Storage Power Station Dashboard': 'Dashboard Singola Stazione Accumulo',
            'Single Energy Storage Power Station Details': 'Dati Attrezzatura Accumulo',
            'Single Energy Storage Power Station Fault Alarm': 'Allarme Guasto Stazione Accumulo',
            'Energy Storage Power Station Reports': 'Report Statistici Accumulo',
            'Energy Storage Power Station Reports Energy': 'Report Energia Accumulo',
            'Energy Storage Power Station Reports Revenue': 'Report Ricavi Accumulo',
            'Energy Storage Power Station Reports Parameters': 'Query Dati Accumulo',
            'Multiple Energy Storage Power Stations': 'Dati Multi-Stazione',
            'Multiple Energy Storage Power Stations Dashboard': 'Dashboard Multi-Stazione',
            'Multiple Energy Storage Power Stations List': 'Lista Centrali',
            'Single Energy Storage Power Station': 'Dati Singola Stazione',
            'Single Energy Storage Power Station Dashboard': 'Dashboard Singola Stazione',
            'Single Energy Storage Power Station Details': 'Dati Attrezzatura',
            'Single Energy Storage Power Station Fault Alarm': 'Allarme Guasto',
            'Energy Storage Power Station Reports': 'Report Statistici',
            'Energy Storage Power Station Reports Energy': 'Report Energia',
            'Energy Storage Power Station Reports Revenue': 'Report Ricavi',
            'Energy Storage Power Station Reports Parameters': 'Query Dati',
            'Photovoltaic Power Station List': 'Lista Centrali Fotovoltaiche',
            'Photovoltaic Power Station Details': 'Monitoraggio Attrezzatura',
            'Photovoltaic Power Station Reporting': 'Report Dati',
            'Photovoltaic Power Station Alarm': 'Allarme Guasto',
            'Photovoltaic Power Station Maintenance': 'Manutenzione',
            'Multiple Photovoltaic Power Stations': 'Dati Multi-Stazione Fotovoltaica',
            'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard Multi-Stazione Fotovoltaica',
            'Multiple Photovoltaic Power Stations List': 'Lista Centrali Fotovoltaiche',
            'Single Photovoltaic Power Station': 'Dati Singola Stazione Fotovoltaica',
            'Single Photovoltaic Power Station Dashboard': 'Dashboard Singola Stazione Fotovoltaica',
            'Single Photovoltaic Power Station Details': 'Dati Attrezzatura',
            'Single Photovoltaic Power Station Fault Alarm': 'Allarme Guasto Singola Stazione',
            'Photovoltaic Power Station Reports': 'Report Statistici Fotovoltaico',
            'Photovoltaic Power Station Reports Energy': 'Report Energia Fotovoltaico',
            'Photovoltaic Power Station Reports Revenue': 'Report Ricavi Fotovoltaico',
            'Photovoltaic Power Station Reports Parameters': 'Query Dati Fotovoltaico',
            'Work Order': 'Gestione Ordini di Lavoro',
            'Work Order Installation': 'Registro Installazioni',
            'Work Order Repair': 'Registro Riparazioni',
            'Work Order Inspection': 'Registro Ispezioni',
            'Total Number of Work Orders': 'Totale Ordini di Lavoro',
            'Number of New Work Orders': 'Numero Nuovi Ordini',
            'Number of Inprogress Work Orders': 'Numero Ordini in Corso',
            'Number of Done Work Orders': 'Numero Ordini Completati',
            'Fuel Indicator': 'Consumo Carburante',
            'Charge Energy Indicator': 'Energia di Ricarica',
            'Discharge Energy Indicator': 'Energia di Scarica',
            'Charge Cost Indicator': 'Costo Ricarica',
            'Discharge Revenue Indicator': 'Ricavo Scarica',
            'HVAC': 'Climatizzazione',
            'Fire Control': 'Antincendio',
            // Dashboard
            'Welcome to MyEMS': 'Benvenuto in MyEMS',
            'An Industry Leading Open Source Energy Management System': 'Sistema di Gestione Energia Open Source All\'Avanguardia',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Consumo Anno Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Costi Anno Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Consumo Mese Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": 'Produzione Mese Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Costs CATEGORY VALUE UNIT": 'Costi Mese Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'Consumo Periodo Corrispondente Anno Precedente {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'Costi Periodo Corrispondente Anno Precedente {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': 'Consumo {{CATEGORY}} {{UNIT}}',
            'CATEGORY Costs UNIT': 'Costi {{CATEGORY}} {{UNIT}}',
            // Entities
            Space: 'Spazio',
            Equipment: 'Attrezzatura',
            Meter: 'Contatore',
            'Offline Meter': 'Contatore Offline',
            'Virtual Meter': 'Contatore Virtuale',
            Tenant: 'Locatario',
            Store: 'Negozio',
            Shopfloor: 'Reparto',
            'Combined Equipment': 'Attrezzatura Combinata',
            'Cost Center': 'Centro di Costo',
            Name: 'Nome',
            DisplayName: 'Nome Visualizzato',
            UserName: 'Nome Utente',
            Description: 'Descrizione',
            'Energy Category': 'Categoria Energia',
            'Child Spaces': 'Sottospazi',
            'Associated Equipment': 'Attrezzatura Associata',
            //Energy Categories
            Electricity: 'Elettricità',
            Water: 'Acqua',
            'Natural Gas': 'Gas Naturale',
            // SidePanelModal
            Settings: 'Impostazioni',
            'Set your own customized style': 'Imposta il tuo stile personalizzato',
            'Color Scheme': 'Schema Colori',
            'Choose the perfect color mode for your app': 'Scegli la modalità colore ideale per la tua app',
            Light: 'Chiaro',
            Dark: 'Scuro',
            'RTL Mode': 'Modalità RTL',
            'Switch your language direction': 'Cambia direzione della lingua',
            'Fluid Layout': 'Layout Fluido',
            'Toggle container layout system': 'Attiva/Disattiva sistema layout container',
            'Navigation Position': 'Posizione Navigazione',
            'Vertical': 'Verticale',
            'Top': 'In Alto',
            'Combo': 'Combinato',
            'Transparent': 'Trasparente',
            'Inverted': 'Invertito',
            'Card': 'Scheda',
            'Vibrant': 'Vivace',
            'Select a suitable navigation system for your web application': 'Seleziona un sistema di navigazione adatto per la tua applicazione web',
            'Vertical Nav': 'Navigazione Verticale',
            'Top Nav': 'Navigazione in Alto',
            'Vertical Navbar Style': 'Stile Barra Navigazione Verticale',
            'Switch between styles for your vertical navbar': 'Cambia tra gli stili per la tua barra di navigazione verticale',
            Language: 'Lingua',
            'Switch between languages': 'Cambia lingua',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Ti Piace Quello che Vedi?',
            'Get MyEMS now': 'Ottieni MyEMS Ora',
            'PQ.About': 'Questa analisi copre deviazione di tensione, squilibrio di tensione, deviazione di frequenza e squilibrio di corrente. La deviazione di tensione è calcolata come (U−Un)/Un×100%; la deviazione di frequenza come |f−fn|; lo squilibrio trifase come max(|Xi−Xavg|)/Xavg×100%, richiedendo allineamento temporale dei canali trifase. I risultati si basano sulle serie temporali del contatore selezionato nel periodo di report. Se mancano canali trifase o i timestamp non sono allineati, gli indicatori di squilibrio vengono saltati. Picchi transienti o campionamenti mancanti possono amplificare i valori peggiori; per valutazioni a regime stazionario si consiglia di fare riferimento a indicatori statistici come tasso di conformità e P95.',
            Purchase: 'Acquista Edizione Enterprise',
            ContactInfo: 'Informazioni di Contatto',
            ProductWebsite: 'Sito Web del Prodotto',
            CompanyWebsite: 'Sito Web Aziendale',
            SalesPhone: 'Telefono Vendite',
            // Query Panels
            'Base Period Begins': 'Periodo Base Inizia',
            'Base Period Ends': 'Periodo Base Termina',
            'Comparison Types': 'Tipi di Confronto',
            'Year-Over-Year': 'Anno su Anno',
            'Month-On-Month': 'Mese su Mese',
            'Free Comparison': 'Confronto Libero',
            'None Comparison': 'Nessun Confronto',
            'Reporting Period Begins': 'Periodo di Report Inizia',
            'Reporting Period Ends': 'Periodo di Report Termina',
            '(Optional)': '(Opzionale)',
            'Period Types': 'Scale Temporali',
            Yearly: 'Annuale',
            Monthly: 'Mensile',
            Weekly: 'Settimanale',
            Daily: 'Giornaliero',
            Hourly: 'Orario',
            Submit: 'Invia',
            'Input Energy Category': 'Categoria Energia Input',
            'Output Energy Category': 'Categoria Energia Output',
            'Fraction Parameter': 'Parametro Frazionario',
            Search: 'Cerca',
            //DateRangePicker
            sunday: 'Dom',
            monday: 'Lun',
            tuesday: 'Mar',
            wednesday: 'Mer',
            thursday: 'Gio',
            friday: 'Ven',
            saturday: 'Sab',
            ok: 'OK',
            today: 'Oggi',
            yesterday: 'Ieri',
            hours: 'Ore',
            minutes: 'Minuti',
            seconds: 'Secondi',
            last7Days: 'Ultimi 7 Giorni',
            'Select Date Range': 'Seleziona Intervallo Date',
            //Card Summaries and Line Charts
            'Base Period': 'Periodo Base',
            'Reporting Period': 'Periodo di Report',
            'Per Unit Area': 'Per Unità di Superficie',
            'Per Capita': 'Pro Capite',
            'Per Unit Production': 'Per Unità di Prodotto',
            Baseline: 'Valore Baseline',
            Actual: 'Valore Attuale',
            'Baseline Value - Actual Value': 'Valore Baseline - Valore Attuale',
            'Average Load': 'Carico Medio',
            'Maximum Load': 'Carico Massimo',
            'Load Factor': 'Fattore di Carico',
            'Ratio of Average Load to Maximum Load': 'Rapporto Carico Medio / Carico Massimo',
            'Carbon Dioxide Emissions by Energy Category': 'Emissioni CO2 per Categoria Energia',
            'Costs by Energy Category': 'Costi per Categoria Energia',
            'Incomes by Energy Category': 'Ricavi per Categoria Energia',
            'Electricity Consumption by Time-Of-Use': 'Consumo Elettrico per Fascia Oraria',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Emissioni CO2 Elettriche per Fascia Oraria',
            'Electricity Cost by Time-Of-Use': 'Costo Elettrico per Fascia Oraria',
            'CATEGORY UNIT Consumption by Energy Items': 'Consumo {{CATEGORY}} {{UNIT}} per Voci di Energia',
            'Ton of Standard Coal by Energy Category': 'Tonnellate Carbone Standard (TCE) per Categoria Energia',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Tonnellate Emissioni CO2 (TCO2E) per Categoria Energia',
            'Reporting Period Consumption CATEGORY UNIT': 'Consumo Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Previsione Periodo Report {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': 'Consumo {{EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                'Consumo {{COMBINED_EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Produzione Periodo Report {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Produzione Periodo Base {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Consumo Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Previsione Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Consumo Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Previsione Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Consumo Periodo Report {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'Consumo Periodo Report {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Consumo Periodo Base {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Proporzione Sottospazi {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Proporzione Totale Sottospazi',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'Emissioni CO2 Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emissioni CO2 Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'Emissioni CO2 Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Costi Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Costi Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Costi Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Produzione Periodo Report {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': 'Produzione {{EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                'Produzione {{COMBINED_EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Produzione Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Produzione Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Ricavi Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Ricavi Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Ricavi Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Ricavi Totali Periodo Report {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Efficienza Cumulativa Periodo Report {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': 'Efficienza Cumulativa {{EQUIPMENT}} Periodo Report {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                'Efficienza Cumulativa Complessiva {{COMBINED_EQUIPMENT}} Periodo Report {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                'Efficienza Cumulativa Complessiva {{COMBINED_EQUIPMENT}} Periodo Report {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                'Efficienza Cumulativa Complessiva {{COMBINED_EQUIPMENT}} Periodo Base {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Efficienza Istantanea {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': 'Efficienza Istantanea {{EQUIPMENT}} {{UNIT}}',
            'Equipment Efficiency Indicator': "Indicatore di Efficienza Energetica dell'Apparecchiatura",
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': 'Efficienza Istantanea Complessiva {{COMBINED_EQUIPMENT}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Efficienza Cumulativa Periodo Report {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'Efficienza Cumulativa Periodo Report {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Efficienza Cumulativa Periodo Base {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Efficienza Cumulativa Periodo Base {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Carico Massimo {{CATEGORY}} Periodo Base {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Carico Massimo {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Carico Medio {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Fattore di Carico {{CATEGORY}} Periodo Report',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Carico Medio {{CATEGORY}} Periodo Base {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Media {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Massimo {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Minimo {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Media Aritmetica {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Mediana {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Deviazione Standard Campione {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Varianza Campione {{CATEGORY}} Periodo Report {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'Risparmio Periodo Report {{CATEGORY}} (Baseline - Attuale) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'Riduzione Periodo Report {{CATEGORY}} (Baseline - Attuale) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Risparmio Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Risparmio Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': 'Consumo Contatore Principale Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'Consumo Contatore Principale Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': 'Consumo Sottocontatori Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'Consumo Sottocontatori Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Differenza Periodo Report {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Differenza Percentuale Periodo Report',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Differenza Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Valori di Trend',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Lista Guasti',
            'Reporting Period Number of Fault VALUE': 'Numero Guasti Periodo Report: {{VALUE}}',
            'All Faults': 'Tutti i Guasti',
            'Space Faults': 'Guasti Spazio',
            'Number of All Faults': 'Numero Totale Guasti',
            'Number of Space Faults': 'Numero Guasti Spazio',
            'Total Number of Faults': 'Numero Totale Guasti',
            'Number of New Faults': 'Numero Nuovi Guasti',
            'Number of Inprogress Faults': 'Numero Guasti in Corso',
            'Number of Done Faults': 'Numero Guasti Completati',
            //Data Panels
            'Ton of Standard Coal': 'Tonnellate Carbone Standard',
            'Ton of Carbon Dioxide Emissions': 'Tonnellate Emissioni CO2',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Emissioni CO2 per Unità di Consumo Energetico',
            'Operating Characteristic Curve': 'Curva Caratteristica di Funzionamento',
            Tariff: 'Tariffa',
            'Detailed Data': 'Dati Dettagliati',
            'Child Spaces Data': 'Dati Sottospazi',
            'Associated Equipment Data': 'Dati Attrezzatura Associata',
            'This Year': 'Anno Corrente',
            'The Same Period Last Year': 'Stesso Periodo Anno Precedente',
            'This Month': 'Mese Corrente',
            'This Day': 'Giorno Corrente',
            Total: 'Totale',
            'No data found': 'Nessun Dato Trovato',
            Export: 'Esporta',
            Datetime: 'Data/Ora',
            'Time-Of-Use Type': 'Tipo Fascia Oraria',
            'Top-Peak': 'Punta',
            'On-Peak': 'Picco',
            'Mid-Peak': 'Normale',
            'Off-Peak': 'Fuori Picco',
            'Deep': 'Valle Profonda',
            Percentage: 'Percentuale',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Trend Ultima Ora Punto Valore Energia',
            Circuit: 'Circuito',
            Point: 'Punto Dati',
            'Realtime Value': 'Valore in Tempo Reale',
            //Meter Tracking
            'Meter List': 'Lista Contatori',
            'Edit Meter': 'Modifica',
            'Start Value': 'Valore Iniziale',
            'End Value': 'Valore Finale',
            'Difference Value': 'Differenza',
            'Start Integrity Rate': 'Tasso Integrità Dati Iniziale (%)',
            'End Integrity Rate': 'Tasso Integrità Dati Finale (%)',
            'Full Integrity Rate': 'Tasso Integrità Dati Complessivo (%)',
            //Equipment Tracking
            'Equipment List': 'Lista Attrezzature',
            'Edit Equipment': 'Modifica',
            //Profile Dropdown
            Feedback: 'Feedback',
            'Account Settings': 'Impostazioni Account',
            Logout: 'Esci',
            //Authentication
            'Log in': 'Accedi',
            'Email address': 'Indirizzo Email',
            'Phone Number': 'Numero di Telefono',
            Password: 'Password',
            CaptchaCode: 'Codice di Verifica',
            Refresh: 'Aggiorna',
            'Remember me': 'Ricordami',
            'Logged in as ': 'Accesso effettuato come ',
            'Forgot Password?': 'Password Dimenticata?',
            'Forgot your password?': 'Hai Dimenticato la Password?',
            "Enter your email and we'll send you a reset link": 'Inserisci la tua email e ti invieremo un link di reset',
            "Enter your email and we'll send you a registration link": 'Inserisci la tua email e ti invieremo un link di registrazione',
            'Reset Password': 'Reimposta Password',
            'Thanks for using MyEMS!': 'Grazie per usare MyEMS!',
            'You are now successfully signed out': 'Sei uscito con successo',
            'Return to Login': 'Torna al Login',
            'Please check your email!': 'Controlla la tua email!',
            'An email has been sent to ': 'Un\'email è stata inviata a ',
            'Please click on the included link to reset your password': 'Clicca sul link incluso per reimpostare la tua password',
            'Please click on the included link to register your account': 'Clicca sul link incluso per registrare il tuo account',
            'An email with password reset link is sent to ': 'Un\'email con link di reset password è stata inviata a ',
            'Change Password': 'Cambia Password',
            'Old Password': 'Vecchia Password',
            'New Password': 'Nuova Password',
            'Confirm Password': 'Conferma Nuova Password',
            'Update Password': 'Aggiorna Password',
            'Password has been changed!': 'Password modificata!',
            'Verification code has been sent to your inbox. \
            Please copy it to the input box below.':
                'Il codice di verifica è stato inviato alla tua casella di posta. Copialo nella casella di input qui sotto.',
            'New to MyEMS': 'Nuovo su MyEMS',
            'Create an account': 'Crea un account',
            'EMAIL Account registration successful': 'Registrazione account {{EMAIL}} riuscita',
            'Thanks for verifying your account!': 'Grazie per aver verificato il tuo account!',
            'Your code is': 'Il tuo codice è',
            'Send verification code': 'Invia codice di verifica',
            'Please wait for NUMBER seconds': 'Attendi {{NUMBER}} secondi',
            'Password reset': 'Reset Password',
            'Please wait for approval': 'Attendi approvazione',
            //notification
            Notifications: 'Notifiche',
            'Mark all as read': 'Segna tutte come lette',
            'View all': 'Visualizza tutte',
            'Notification New': 'Nuove',
            'Notification Earlier': 'Precedenti',
            'Notification List': 'Lista Notifiche',
            'Bulk actions': 'Azioni di Gruppo',
            'Notification Subject': 'Oggetto',
            'Notification Created Datetime': 'Data/Ora Creazione',
            'Notification Message': 'Contenuto',
            'Notification Priority': 'Priorità',
            'Notification Status': 'Stato',
            'Notification Mark As Read': 'Segna come Letta',
            'Notification Mark As Acknowledged': 'Conferma',
            'Notification Low': 'Bassa',
            'Notification Medium': 'Media',
            'Notification High': 'Alta',
            'Notification Critical': 'Critica',
            'Notification Unread': 'Non Letta',
            'Notification Read': 'Letta',
            'Notification Acknowledged': 'Confermata',
            'Notification Archive': 'Archivia',
            'Notification Delete': 'Elimina',
            'Notification Apply': 'Applica',
            'Notification Start Datetime': 'Data/Ora Inizio',
            'Notification End Datetime': 'Data/Ora Fine',
            'Notification Update Datetime': 'Data/Ora Aggiornamento',
            //Monitoring
            'Run Commands': 'Esegui Comandi',
            'Pin Code': 'Codice PIN',
            'Unlock': 'Sblocca',
            'Set Value': 'Imposta Valore',
            'Fault Alarms': 'Allarmi Guasto',
            'Instantaneous Efficiency VALUE UNIT': 'Efficienza Istantanea {{VALUE}} {{UNIT}}',
            'Communication Status': 'Stato Comunicazione',
            'Communication Online': 'Online',
            'Communication Offline': 'Offline',
            'Equipment Status': 'Stato Attrezzatura',
            'Equipment Running': 'In Funzione',
            'Equipment Stopped': 'Fermo',
            'Show Up to': 'Mostra fino a',
            All: 'Tutti',
            'FROM - TO of TOTAL': 'Visualizzando {{FROM}} - {{TO}} di {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Energia Microrete',
            'Microgrid Revenue': 'Ricavi Microrete',
            'Microgrid Carbon': 'Carbonio Microrete',
            'Photovoltaic Generation': 'Generazione Fotovoltaica',
            'EV Charger Consumption': 'Consumo Colonnina Ricarica EV',
            'Load Consumption': 'Consumo Carico',
            'Grid Buy': 'Acquisto da Rete',
            'Grid Sell': 'Vendita alla Rete',
            'EV Charger': 'Colonnina Ricarica EV',
            'Heat Pump': 'Pompa di Calore',
            'Photovoltaic': 'Fotovoltaico',
            'PCS Run State': 'Stato Funzionamento PCS',
            'PCS Unknown': 'Sconosciuto',
            'PCS Initializing': 'Inizializzazione',
            'PCS Standby': 'Standby',
            'PCS Shutdown': 'Spento',
            'PCS Fault': 'Guasto',
            'PCS Running': 'In Funzione',
            'Battery Power': 'Potenza Batteria',
            'Photovoltaic Power': 'Potenza Fotovoltaica',
            'Grid Power': 'Potenza Rete',
            'Load Power': 'Potenza Carico',
            Reporting: 'Report Dati',
            Maintenance: 'Manutenzione',
            'General Information': 'Informazioni Generali',
            'Serial Number': 'Numero Seriale',
            Address: 'Indirizzo',
            'Postal Code': 'Codice Postale',
            'Rated Capacity': 'Capacità Nominale',
            'Rated Power': 'Potenza Nominale',
            Latitude: 'Latitudine',
            Longitude: 'Longitudine',
            'Strategy Management': 'Gestione Strategia',
            'Charging Schedule': 'Programma Ricarica',
            'Charge Start Time': 'Ora Inizio Ricarica',
            'Charge End Time': 'Ora Fine Ricarica',
            'Discharge Start Time': 'Ora Inizio Scarica',
            'Discharge End Time': 'Ora Fine Scarica',
            'Total Rated Power': 'Potenza Nominale Totale',
            'Total Rated Capacity': 'Capacità Nominale Totale',
            // Energy Indicator
            "Today's Charge": "Ricarica Oggi",
            "Today's Discharge": "Scarica Oggi",
            "Today's Generation": "Generazione Oggi",
            'Total Fuel Consumption': 'Consumo Totale Carburante',
            'Total Charge': 'Ricarica Totale',
            'Total Discharge': 'Scarica Totale',
            'Total Generation': 'Generazione Totale',
            'Total Revenue': 'Ricavi Totali',
            'Total Photovoltaic Generation': 'Generazione Fotovoltaica Totale',
            'Total EV Charger Consumption': 'Consumo Totale Colonnine Ricarica EV',
            'Total Load Consumption': 'Consumo Totale Carico',
            'Total Grid Buy': 'Acquisto Totale da Rete',
            'Total Grid Sell': 'Vendita Totale alla Rete',
            'Total Efficiency': 'Efficienza Complessiva',
            'Discharge Achievement Rate': 'Tasso di Realizzazione Scarica',
            // Revenue Indicator
            "Today's Cost": "Costo Oggi",
            "Today's Income": "Ricavo Oggi",
            "Total Cost": "Costo Totale",
            "Total Income": "Ricavo Totale",
            "Today's Revenue": "Profitto Oggi",

            'Revenue Ranking': 'Classifica Ricavi',
            'Efficiency Ranking': 'Classifica Efficienza',
            'Charge Ranking': 'Classifica Ricarica',
            'Discharge Ranking': 'Classifica Scarica',
            'Number of Microgrids': 'Numero Microreti',
            'Number of Power Stations': 'Numero Centrali',
            'Microgrid List': 'Lista Microreti',
            'Select Microgrid': 'Seleziona Microrete',
            'Previous Page': 'Pagina Precedente',
            'Next Page': 'Pagina Successiva',
            '7 Days': '7 Giorni',
            'Charge UNIT': 'Carica {{UNIT}}',
            'Discharge UNIT': 'Scarica {{UNIT}}',
            'Generation UNIT': 'Genera {{UNIT}}',
            'Energy Indicator': 'Energia',
            'Revenue Indicator': 'Ricavi',
            'Carbon Indicator': 'Carbonio',

            // Energy Storage Power Station
            'Battery Operating State': 'Stato Operativo Batteria',
            'Battery State': 'Stato Batteria',
            'Battery Unknown': 'Sconosciuto',
            'Battery Stopped': 'Fermo',
            'Battery Reserved': 'Reserved',
            'Battery Fault': 'Guasto',
            'Battery Warning': 'Avviso',
            'Battery Standby': 'Standby',
            'Battery Prohibit DisCharging': 'Scarica Bloccata',
            'Battery Prohibit Charging': 'Ricarica Bloccata',
            'Battery Normal': 'Normale',
            'Battery Charging': 'In Carica',
            'Battery Discharging': 'In Scarica',
            'Battery Idle': 'Inattiva',
            'Phase of Lifecycle': 'Fase Ciclo Vita',
            'Use Phase': 'In Uso',
            'Commissioning Phase': 'Messa in Servizio',
            'Commissioning Date': 'Data Attivazione',
            'Installation Phase': 'In Costruzione',
            'Device Status': 'Stato Dispositivo',
            'Basic Information': 'Informazioni Base',
            'Gateway': 'Gateway',
            'Grid Meter': 'Contatore Rete',
            'Load Meter': 'Contatore Carico',
            'ESS Meter': 'Contatore Sistema Accumulo (ESS)',
            'Total Active Power': 'Potenza Attiva Totale',
            'Active Power A': 'Potenza Attiva Fase A',
            'Active Power B': 'Potenza Attiva Fase B',
            'Active Power C': 'Potenza Attiva Fase C',
            'Total Reactive Power': 'Potenza Reattiva Totale',
            'Reactive Power A': 'Potenza Reattiva Fase A',
            'Reactive Power B': 'Potenza Reattiva Fase B',
            'Reactive Power C': 'Potenza Reattiva Fase C',
            'Total Apparent Power': 'Potenza Apparente Totale',
            'Apparent Power A': 'Potenza Apparente Fase A',
            'Apparent Power B': 'Potenza Apparente Fase B',
            'Apparent Power C': 'Potenza Apparente Fase C',
            'Total Power Factor': 'Fattore di Potenza Totale',
            'Active Energy Import': 'Energia Attiva Importata',
            'Active Energy Export': 'Energia Attiva Esportata',
            'Active Energy Net': 'Energia Attiva Netta',

            'Generator': 'Generatore',

            // Photovoltaic Power Station
            'Invertor': 'Inverter',
            'Invertor Run State': 'Stato Funzionamento Inverter',
            'Invertor Unknown': 'Sconosciuto',
            'Invertor Initializing': 'Inizializzazione',
            'Invertor Standby': 'Standby',
            'Invertor Shutdown': 'Spento',
            'Invertor Fault': 'Guasto',
            'Invertor Running': 'In Funzione',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': 'Data/Ora Creazione',
            'File Format': 'Formato File',
            'File Size': 'Dimensione File',
            Uploader: 'Caricatore',
            'Upload Datetime': 'Data/Ora Caricamento',
            //Error
            "The page you're looking for is not found": 'La pagina che stai cercando non esiste',
            "Make sure the address is correct and that the page hasn't moved": 'Assicurati che l\'indirizzo sia corretto e che la pagina non sia stata spostata',
            'If you think this is a mistake,': 'Se pensi che sia un errore,',
            'contact us': 'contattaci',
            'Take me home': 'Portami alla Home',
            'Whoops, something went wrong!': 'Ops, qualcosa è andato storto!',
            'Try refreshing the page, or going back and attempting the action again':
                'Prova ad aggiornare la pagina, o torna indietro e tenta nuovamente l\'azione',
            'If this problem persists,': 'Se il problema persiste,',
            'Captcha Error': 'Errore Codice di Verifica',
            'Confirm Password Error': 'Le password non corrispondono',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Sembra che tu abbia cliccato su un link di reset password non valido. Riprova.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Sembra che tu abbia cliccato su un link di registrazione account non valido. Riprova.',
            //Tenant Bill
            'Lease Contract Number': 'Numero Contratto di Locazione',
            Download: 'Scarica',
            Print: 'Stampa',
            'Payment Notice': 'Avviso di Pagamento',
            'Bill To': 'A',
            'Bill Number': 'Numero Fattura',
            'Bill Date': 'Data Fattura',
            'Payment Due Date': 'Scadenza Pagamento',
            'Amount Payable': 'Importo da Pagare',
            'Billing Period Start': 'Inizio Periodo di Fatturazione',
            'Billing Period End': 'Fine Periodo di Fatturazione',
            Quantity: 'Quantità',
            Price: 'Prezzo',
            Unit: 'Unità',
            Amount: 'Importo',
            Subtotal: 'Subtotale',
            'VAT Output Tax': 'IVA a Debito',
            'Total Amount Payable': 'Totale da Pagare',
            'Please make sure to pay on or before the payment due date above': 'Si prega di pagare entro o prima della data di scadenza sopra indicata',
            'Send money to the following account': 'Versa l\'importo sul seguente conto',
            'Account Name': 'Intestatario Conto',
            'Bank Name': 'Banca',
            'Bank Address': 'Indirizzo Banca',
            'RMB Account': 'Conto RMB',
            // button
            'Toggle Navigation': 'Attiva/Disattiva Navigazione',
            // working calendar
            'Working Days': 'Giorni Lavorativi',
            'Non Working Days': 'Giorni Non Lavorativi',
            'Select Row': 'Seleziona la riga di dati da operare',
            // Offline Meter Input
            'Daily Value': 'Dati Giornalieri',
            Date: 'Data',
            'Successfully Saved': 'Salvato con Successo',
            'Previous Data Is Empty': 'I dati precedenti sono vuoti',

            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sessione amministratore non trovata',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Sessione amministratore scaduta',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Report avanzato non trovato',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Richiesta non valida',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Impossibile impostare un sottocontatore esistente come contatore principale',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relazione attrezzatura combinata-attrezzatura già esistente',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-attrezzatura non trovata',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relazione attrezzatura combinata-contatore già esistente',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-contatore non trovata',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nome attrezzatura combinata già in uso',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Attrezzatura combinata non trovata',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relazione attrezzatura combinata-contatore offline già esistente',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-contatore offline non trovata',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nome parametro attrezzatura combinata già in uso',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametro attrezzatura combinata non trovato o non corrispondente',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relazione attrezzatura combinata-contatore virtuale già esistente',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-contatore virtuale non trovata',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Nome contatto già in uso',
            'API.CONTACT_NOT_FOUND': 'Contatto non trovato',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'ID esterno centro di costo già esistente',
            'API.COST_CENTER_NAME_EXISTS': 'Nome centro di costo già esistente',
            'API.COST_CENTER_NOT_FOUND': 'Centro di costo non trovato',
            'API.COST_FILE_NOT_FOUND': 'File costi non trovato',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Nome sorgente dati già in uso',
            'API.DATA_SOURCE_NOT_FOUND': 'Sorgente dati non trovata',
            'API.DATABASE_ERROR': 'Errore database',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Data già presente nel calendario lavorativo',
            'API.DATE_LOCAL_NOT_FOUND': 'Data locale non trovata',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Nome circuito distribuzione già in uso',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Circuito distribuzione non trovato',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relazione circuito distribuzione-punto dati già esistente',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relazione circuito distribuzione-punto dati non trovata',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nome sistema distribuzione già in uso',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Sistema distribuzione non trovato',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Email già in uso',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Messaggio email non trovato',
            'API.EMAIL_NOT_FOUND': 'Email non trovata',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Host server email già in uso',
            'API.EMAIL_SERVER_NOT_FOUND': 'Server email non trovato',
            'API.EMPTY_VARIABLES_ARRAY': 'Array variabili vuoto',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Nome categoria energia già in uso',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Categoria energia non trovata',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Categoria energia già usata nelle voci di energia',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Categoria energia già usata nei contatori',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Categoria energia già usata nei contatori offline',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Categoria energia già usata nelle tariffe',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Categoria energia già usata nei contatori virtuali',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Collegamento diagramma flusso energia già in uso',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Collegamento diagramma flusso energia non trovato o non corrispondente',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Nome diagramma flusso energia già in uso',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Nome nodo diagramma flusso energia già in uso',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Nodo diagramma flusso energia non trovato o non corrispondente',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Diagramma flusso energia non trovato',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Voce energia non appartiene alla categoria energia',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Voce energia non appartiene alla categoria energia',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Nome voce energia già in uso',
            'API.ENERGY_ITEM_NOT_FOUND': 'Voce energia non trovata',
            'API.ENERGY_ITEM_USED_IN_METER': 'Voce energia già usata nei contatori',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Voce energia già usata nei contatori offline',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Voce energia già usata nei contatori virtuali',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relazione attrezzatura-contatore già esistente',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura-contatore non trovata',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nome attrezzatura già in uso',
            'API.EQUIPMENT_NOT_FOUND': 'Attrezzatura non trovata',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relazione attrezzatura-contatore offline già esistente',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura-contatore offline non trovata',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nome parametro attrezzatura già in uso',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametro attrezzatura non trovato o non corrispondente',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relazione attrezzatura-contatore virtuale già esistente',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura-contatore virtuale non trovata',
            'API.ERROR': 'Errore',
            'API.EXCEPTION': 'Eccezione',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Ripristino file costi fallito',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Ripristino file conoscenza fallito',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Ripristino file contatore offline fallito',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Salvataggio file contatore offline fallito',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Upload file costi fallito',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Upload file conoscenza fallito',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Upload file contatore offline fallito',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Nome gateway già in uso',
            'API.GATEWAY_NOT_FOUND': 'Gateway non trovato',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Non valido ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Indirizzo non valido',
            'API.INVALID_ADDRESS_VALUE': 'Valore indirizzo non valido',
            'API.INVALID_ADVANCED_REPORT_ID': 'ID report avanzato non valido',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Valore area non valido',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Data/ora fine periodo base non valida',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Data/ora inizio periodo base non valida',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Baud rate non valido',
            'API.INVALID_BUILDINGS_VALUE': 'Valore edifici non valido',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Categoria non valida',
            'API.INVALID_CHANNEL': 'Canale non valido',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'ID attrezzatura combinata non valido',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nome attrezzatura combinata non valido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'ID parametro attrezzatura combinata non valido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Nome parametro attrezzatura combinata non valido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Tipo parametro attrezzatura combinata non valido',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID attrezzatura combinata non valido',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Connessione non valida',
            'API.INVALID_CONSTANT_VALUE': 'Valore costante non valido',
            'API.INVALID_CONTACT_ID': 'ID contatto non valido',
            'API.INVALID_CONTACT_NAME': 'Nome contatto non valido',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'ID centro di costo non valido',
            'API.INVALID_COST_FILE_ID': 'ID file costi non valido',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'ID sorgente dati non valido',
            'API.INVALID_DATA_SOURCE_NAME': 'Nome sorgente dati non valido',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Protocollo sorgente dati non valido',
            'API.INVALID_DATE_LOCAL': 'Data locale non valida',
            'API.INVALID_DENOMINATOR_METER_UUID': 'UUID contatore denominatore non valido',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Nome visualizzato non valido',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'ID circuito distribuzione non valido',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nome circuito distribuzione non valido',
            'API.INVALID_DISTRIBUTION_ROOM': 'Stanza distribuzione non valida',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'ID sistema distribuzione non valido',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nome sistema distribuzione non valido',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Email non valida',
            'API.INVALID_EMAIL_MESSAGE_ID': 'ID messaggio email non valido',
            'API.INVALID_EMAIL_SERVER_HOST': 'Host server email non valido',
            'API.INVALID_EMAIL_SERVER_ID': 'ID server email non valido',
            'API.INVALID_END_DATE_FORMAT': 'Formato data fine non valido',
            'API.INVALID_END_DATETIME': 'Data/ora fine non valida',
            'API.INVALID_ENERGY_CATEGORY_ID': 'ID categoria energia non valido',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Nome categoria energia non valido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'ID diagramma flusso energia non valido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'ID collegamento diagramma flusso energia non valido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nome diagramma flusso energia non valido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'ID nodo diagramma flusso energia non valido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nome nodo diagramma flusso energia non valido',
            'API.INVALID_ENERGY_ITEM_ID': 'ID voce energia non valido',
            'API.INVALID_ENERGY_ITEM_NAME': 'Nome voce energia non valido',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Equazione non valida nell espressione',
            'API.INVALID_EQUIPMENT_ID': 'ID attrezzatura non valido',
            'API.INVALID_EQUIPMENT_NAME': 'Nome attrezzatura non valido',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'ID parametro attrezzatura non valido',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nome parametro attrezzatura non valido',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Tipo parametro attrezzatura non valido',
            'API.INVALID_EQUIPMENT_UUID': 'UUID attrezzatura non valido',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Espressione non valida',
            'API.INVALID_EXPRESSION_OBJECT': 'Oggetto espressione non valido',
            'API.INVALID_FDD_CODE': 'Codice guasto FDD non valido',
            'API.INVALID_FLOORS_VALUE': 'Valore piani non valido',
            'API.INVALID_FROM_ADDR': 'Indirizzo mittente non valido',
            'API.INVALID_GATEWAY_ID': 'ID gateway non valido',
            'API.INVALID_GATEWAY_NAME': 'Nome gateway non valido',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Valore limite superiore orario non valido',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Valore limite inferiore orario non valido',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Valore amministratore non valido',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Valore visualizzazione dati costi non valido',
            'API.INVALID_IS_COUNTED_VALUE': 'Valore conteggiato non valido',
            'API.INVALID_IS_ENABLED': 'Valore abilitazione non valido',
            'API.INVALID_IS_HIDDEN': 'Valore nascosto non valido',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Valore in locazione non valido',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Valore input conteggiato non valido',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Valore locatario principale non valido',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Valore output conteggiato non valido',
            'API.INVALID_IS_OUTPUT_VALUE': 'Valore output non valido',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Valore salvataggio trend non valido',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Valore punto virtuale non valido',
            'API.INVALID_KGCE': 'Coefficiente kg carbone standard non valido',
            'API.INVALID_KGCO2E': 'Coefficiente kg emissioni CO2 non valido',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'ID file conoscenza non valido',
            'API.INVALID_LATITUDE_VALUE': 'Valore latitudine non valido',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Valore numero contratto locazione non valido',
            'API.INVALID_LONGITUDE_VALUE': 'Valore longitudine non valido',
            'API.INVALID_LOW_LIMIT_VALUE': 'Valore limite inferiore non valido',
            'API.INVALID_MASTER_METER_ID': 'ID contatore principale non valido',
            'API.INVALID_MENU_ID': 'ID menu non valido',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Modello messaggio non valido',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'ID contatore non valido',
            'API.INVALID_METER_NAME': 'Nome contatore non valido',
            'API.INVALID_METER_UUID': 'UUID contatore non valido',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Valore nome non valido',
            'API.INVALID_NEW_PASSWORD': 'Nuova password non valida',
            'API.INVALID_NON_WORKING_DAY_ID': 'ID giorno non lavorativo non valido',
            'API.INVALID_NOTIFICATION_ID': 'ID notifica non valido',
            'API.INVALID_NUMERATOR_METER_UUID': 'UUID contatore numeratore non valido',
            'API.INVALID_OBJECT_TYPE': 'Tipo oggetto non valido',
            'API.INVALID_OFFLINE_METER_DATA': 'Dati contatore offline non validi',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'ID file contatore offline non valido',
            'API.INVALID_OFFLINE_METER_ID': 'ID contatore offline non valido',
            'API.INVALID_OFFLINE_METER_NAME': 'Nome contatore offline non valido',
            'API.INVALID_OFFLINE_METER_UUID': 'UUID contatore offline non valido',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Valore costante offset non valido',
            'API.INVALID_OLD_PASSWORD': 'Vecchia password non valida',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'ID spazio padre non valido',
            'API.INVALID_PASSWORD': 'Password non valida',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Corrente di picco non valida',
            'API.INVALID_PEAK_LOAD': 'Carico di picco non valido',
            'API.INVALID_PERIOD_TYPE': 'Tipo periodo non valido',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'ID punto dati non valido',
            'API.INVALID_POINT_NAME': 'Nome punto dati non valido',
            'API.INVALID_PORT': 'Porta non valida',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Priorità non valida',
            'API.INVALID_PRIVILEGE': 'Privilegio non valido',
            'API.INVALID_PRIVILEGE_DATA': 'Dati privilegio non validi',
            'API.INVALID_PRIVILEGE_ID': 'ID privilegio non valido',
            'API.INVALID_PRIVILEGE_NAME': 'Nome privilegio non valido',
            'API.INVALID_RATIO_VALUE': 'Valore rapporto di trasformazione non valido',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Risposta non valida',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Data/ora fine periodo report non valida',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Data/ora inizio periodo report non valida',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Richiesta autenticazione non valida',
            'API.INVALID_ROOMS_VALUE': 'Valore stanze non valido',
            'API.INVALID_RULE_ID': 'ID regola non valido',
            'API.INVALID_RULE_NAME': 'Nome regola non valido',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'ID sensore non valido',
            'API.INVALID_SENSOR_NAME': 'Nome sensore non valido',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Porta seriale non valida',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sessione non valida, eseguire nuovamente il login',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'ID reparto non valido',
            'API.INVALID_SHOPFLOOR_NAME': 'Nome reparto non valido',
            'API.INVALID_SHOPFLOOR_UUID': 'UUID reparto non valido',
            'API.INVALID_SOURCE_NODE_ID': 'ID nodo sorgente non valido',
            'API.INVALID_SPACE_ID': 'ID spazio non valido',
            'API.INVALID_SPACE_NAME': 'Nome spazio non valido',
            'API.INVALID_SPACE_UUID': 'UUID spazio non valido',
            'API.INVALID_START_DATE_FORMAT': 'Formato data inizio non valido',
            'API.INVALID_START_DATETIME': 'Data/ora inizio non valida',
            'API.INVALID_STATUS': 'Stato non valido',
            'API.INVALID_STORE_ID': 'ID negozio non valido',
            'API.INVALID_STORE_NAME': 'Nome negozio non valido',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Descrizione tipo negozio non valida',
            'API.INVALID_STORE_TYPE_ID': 'ID tipo negozio non valido',
            'API.INVALID_STORE_TYPE_NAME': 'Nome tipo negozio non valido',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Codice semplificato tipo negozio non valido',
            'API.INVALID_STORE_UUID': 'UUID negozio non valido',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'SVG non valido',
            'API.INVALID_SWITCHGEAR': 'Apparecchiatura di commutazione non valida',
            'API.INVALID_TARGET_NODE_ID': 'ID nodo destinazione non valido',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Prezzo tariffa a blocchi non valido',
            'API.INVALID_TARIFF_ID': 'ID tariffa non valido',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Prezzo tariffa per fascia oraria non valido',
            'API.INVALID_TARIFF_TYPE': 'Tipo tariffa non valido',
            'API.INVALID_TENANT_ID': 'ID locatario non valido',
            'API.INVALID_TENANT_NAME': 'Nome locatario non valido',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Descrizione tipo locatario non valida',
            'API.INVALID_TENANT_TYPE_ID': 'ID tipo locatario non valido',
            'API.INVALID_TENANT_TYPE_NAME': 'Nome tipo locatario non valido',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Codice semplificato tipo locatario non valido',
            'API.INVALID_TENANT_UUID': 'UUID locatario non valido',
            'API.INVALID_TEXT_MESSAGE_ID': 'ID messaggio SMS non valido',
            'API.INVALID_TIMEZONE_ID': 'ID fuso orario non valido',
            'API.INVALID_TOKEN': 'Token non valido',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Unità di misura non valida',
            'API.INVALID_UNIT_OF_PRICE': 'Unità di prezzo non valida',
            'API.INVALID_UNITS': 'Unità non valide',
            'API.INVALID_USER_ID': 'ID utente non valido',
            'API.INVALID_USER_NAME': 'Nome utente non valido',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Nome utente o email non validi',
            'API.INVALID_USER_PHONE': 'Telefono utente non valido',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Utente non valido, eseguire nuovamente il login',
            'API.INVALID_USER_UUID': 'UUID utente non valido',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'ID contatore variabile non valido',
            'API.INVALID_VARIABLE_METER_TYPE': 'Tipo contatore variabile non valido',
            'API.INVALID_VARIABLE_NAME': 'Nome variabile non valido',
            'API.INVALID_VERIFICATION_CODE': 'Codice di verifica non valido',
            'API.INVALID_VIRTUAL_METER_ID': 'ID contatore virtuale non valido',
            'API.INVALID_VIRTUAL_METER_NAME': 'Nome contatore virtuale non valido',
            'API.INVALID_VIRTUAL_METER_UUID': 'UUID contatore virtuale non valido',
            'API.INVALID_WEB_MESSAGE_ID': 'ID messaggio web non valido',
            'API.INVALID_WECHAT_MESSAGE_ID': 'ID messaggio WeChat non valido',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'ID calendario lavorativo non valido',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Nome calendario lavorativo non valido',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Impossibile rimuovere file conoscenza dal disco',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'File conoscenza non trovato',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Contatore principale non appartiene alla stessa categoria energia',
            'API.MASTER_METER_NOT_FOUND': 'Contatore principale non trovato',
            'API.MENU_NOT_FOUND': 'Menu non trovato',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Nome contatore già in uso',
            'API.METER_NOT_FOUND': 'Contatore non trovato',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Contatore variabile non trovato',
            'API.METER_POINT_RELATION_EXISTS': 'Relazione contatore-punto dati già esistente',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Relazione contatore-punto dati non trovata',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Lunghezza nuova password non può superare 100 caratteri',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Giorno non lavorativo non trovato',
            'API.NOT_FOUND': 'Non trovato',
            'API.NOTIFICATION_NOT_FOUND': 'Notifica non trovata',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'File contatore offline non trovato',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nome contatore offline già in uso',
            'API.OFFLINE_METER_NOT_FOUND': 'Contatore offline non trovato',
            'API.INVALID_OFFLINE_METER_VALUE': 'Valore del contatore offline non valido',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Contatore offline variabile non trovato',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Lunghezza vecchia password non può superare 100 caratteri',
            'API.PARENT_SPACE_NOT_FOUND': 'Spazio padre non trovato',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Lunghezza password non può superare 100 caratteri',
            'API.PASSWORDS_MATCH': 'Nuova password identica alla vecchia password',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nome punto dati già in uso',
            'API.POINT_NOT_FOUND': 'Punto dati non trovato',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nome privilegio già in uso',
            'API.PRIVILEGE_NOT_FOUND': 'Privilegio non trovato',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nome regola già in uso',
            'API.RULE_NOT_FOUND': 'Regola non trovata',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nome sensore già in uso',
            'API.SENSOR_NOT_FOUND': 'Sensore non trovato',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Relazione sensore-punto dati già esistente',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relazione sensore-punto dati non trovata',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relazione reparto-attrezzatura già esistente',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione reparto-attrezzatura non trovata',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relazione reparto-contatore già esistente',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relazione reparto-contatore non trovata',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nome reparto già in uso',
            'API.SHOPFLOOR_NOT_FOUND': 'Reparto non trovato',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relazione reparto-contatore offline già esistente',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione reparto-contatore offline non trovata',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relazione reparto-punto dati già esistente',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relazione reparto-punto dati non trovata',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relazione reparto-sensore già esistente',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relazione reparto-sensore non trovata',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relazione reparto-contatore virtuale già esistente',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione reparto-contatore virtuale non trovata',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione reparto-calendario lavorativo già esistente',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione reparto-calendario lavorativo non trovata',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Nodo sorgente non trovato',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relazione spazio-attrezzatura combinata già esistente',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione spazio-attrezzatura combinata non trovata',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relazione spazio-attrezzatura già esistente',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione spazio-attrezzatura non trovata',
            'API.SPACE_METER_RELATION_EXISTS': 'Relazione spazio-contatore già esistente',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Relazione spazio-contatore non trovata',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nome spazio già in uso',
            'API.SPACE_NOT_FOUND': 'Spazio non trovato',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Spazio non trovato nel privilegio',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relazione spazio-contatore offline già esistente',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione spazio-contatore offline non trovata',
            'API.SPACE_POINT_RELATION_EXISTS': 'Relazione spazio-punto dati già esistente',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relazione spazio-punto dati non trovata',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Relazione spazio-sensore già esistente',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relazione spazio-sensore non trovata',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relazione spazio-reparto già esistente',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relazione spazio-reparto non trovata',
            'API.SPACE_STORE_RELATION_EXISTS': 'Relazione spazio-negozio già esistente',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relazione spazio-negozio non trovata',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Relazione spazio-locatario già esistente',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relazione spazio-locatario non trovata',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relazione spazio-contatore virtuale già esistente',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione spazio-contatore virtuale non trovata',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione spazio-calendario lavorativo già esistente',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione spazio-calendario lavorativo non trovata',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Data/ora inizio deve precedere data/ora fine',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Relazione negozio-contatore già esistente',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Relazione negozio-contatore non trovata',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Nome negozio già in uso',
            'API.STORE_NOT_FOUND': 'Negozio non trovato',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relazione negozio-contatore offline già esistente',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione negozio-contatore offline non trovata',
            'API.STORE_POINT_RELATION_EXISTS': 'Relazione negozio-punto dati già esistente',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Relazione negozio-punto dati non trovata',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Relazione negozio-sensore già esistente',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Relazione negozio-sensore non trovata',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome tipo negozio già in uso',
            'API.STORE_TYPE_NOT_FOUND': 'Tipo negozio non trovato',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Codice semplificato tipo negozio già in uso',
            'API.STORE_TYPE_USED_IN_STORE': 'Tipo negozio già usato nel negozio',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relazione negozio-contatore virtuale già esistente',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione negozio-contatore virtuale non trovata',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione negozio-calendario lavorativo già esistente',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione negozio-calendario lavorativo non trovata',
            'API.TARGET_NODE_NOT_FOUND': 'Nodo destinazione non trovato',
            'API.TARIFF_IN_USE': 'Tariffa in uso',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariffa già associata al centro di costo',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariffa non associata al centro di costo',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nome tariffa già in uso',
            'API.TARIFF_NOT_FOUND': 'Tariffa non trovata',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Relazione locatario-contatore già esistente',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Relazione locatario-contatore non trovata',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nome locatario già in uso',
            'API.TENANT_NOT_FOUND': 'Locatario non trovato',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relazione locatario-contatore offline già esistente',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione locatario-contatore offline non trovata',
            'API.TENANT_POINT_RELATION_EXISTS': 'Relazione locatario-punto dati già esistente',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relazione locatario-punto dati non trovata',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Relazione locatario-sensore già esistente',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Relazione locatario-sensore non trovata',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome tipo locatario già in uso',
            'API.TENANT_TYPE_NOT_FOUND': 'Tipo locatario non trovato',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Codice semplificato tipo locatario già in uso',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tipo locatario già usato nel locatario',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relazione locatario-contatore virtuale già esistente',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione locatario-contatore virtuale non trovata',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione locatario-calendario lavorativo già esistente',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione locatario-calendario lavorativo non trovata',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Messaggio SMS non trovato',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Periodo di report deve essere superiore a 15 minuti',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Esiste relazione con sottocontatori',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Esiste relazione con sottospazi',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Esiste relazione con parametri attrezzatura combinata',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Esiste relazione con attrezzature combinate',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Esiste relazione con sorgenti dati',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Esiste relazione con collegamenti diagramma flusso energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Esiste relazione con batterie container accumulo energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Esiste relazione con reti container accumulo energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Esiste relazione con carichi container accumulo energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Esiste relazione con sistemi conversione potenza (PCS) container accumulo energia',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Esiste relazione con parametri attrezzatura',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Esiste relazione con attrezzature',
            'API.THERE_IS_RELATION_WITH_METER': 'Esiste relazione con contatore',
            'API.THERE_IS_RELATION_WITH_METERS': 'Esiste relazione con più contatori',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Esiste relazione con contatore offline',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Esiste relazione con più contatori offline',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Esiste relazione con altri contatori virtuali',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'Esiste relazione con sensori',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Esiste relazione con reparti',
            'API.THERE_IS_RELATION_WITH_SPACES': 'Esiste relazione con spazi',
            'API.THERE_IS_RELATION_WITH_STORES': 'Esiste relazione con negozi',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'Esiste relazione con locatari',
            'API.THERE_IS_RELATION_WITH_USERS': 'Esiste relazione con utenti',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Esiste relazione con contatore virtuale',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Esiste relazione con centrali elettriche virtuali',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Questa sorgente dati è in uso da un contatore',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Questo contatore è in uso da un contatore virtuale',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Questo contatore offline è in uso da un contatore virtuale',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'Spazio non può essere clonato',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'Spazio non può essere eliminato',
            'API.TIMEZONE_NOT_FOUND': 'Fuso orario non trovato',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token non trovato negli header, effettuare il login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Account utente bloccato',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'Account utente scaduto',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'Nome utente già in uso',
            'API.USER_NOT_FOUND': 'Utente non trovato',
            'API.USER_PASSWORD_HAS_EXPIRED': 'Password utente scaduta',
            'API.USER_PRIVILEGE_NOT_FOUND': 'Privilegio utente non trovato',
            'API.USER_SESSION_NOT_FOUND': 'Sessione utente non trovata',
            'API.USER_SESSION_TIMEOUT': 'Sessione utente scaduta',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID utente non trovato negli header, effettuare il login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nome contatore virtuale già in uso',
            'API.VIRTUAL_METER_NOT_FOUND': 'Contatore virtuale non trovato',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Contatore virtuale variabile non trovato',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Punto dati virtuale dovrebbe essere valore analogico',
            'API.WEB_MESSAGE_NOT_FOUND': 'Messaggio web non trovato',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Messaggio WeChat non trovato',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nome calendario lavorativo già in uso',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Calendario lavorativo non trovato',
            MasterMeter: 'Contatore Principale',
            SubMeter: 'Sottocontatore',
            'Power Quality': 'Qualità dell\'Energia',
            'About Power Quality': 'Informazioni sulla Qualità dell\'Energia',
            'Trend Values': 'Valori di Trend',
            Category: 'Categoria',
            Type: 'Tipo',
            Unit: 'Unità',
            Limit: 'Limite',
            'Normal Limit': 'Limite Normale',
            'Severe Limit': 'Limite Grave',
            Compliance: 'Tasso di Conformità',
            'Worst Deviation': 'Deviazione Peggiore',
            'Worst Time': 'Ora Peggiore',
            'Severe Exceed Count': 'Conteggio Superamenti Gravi',
            'Worst Unbalance': 'Squilibrio Massimo',
            Hz: 'Hertz',
            voltage: 'tensione',
            current: 'corrente',
            frequency: 'frequenza',
            voltage_deviation: 'deviazione di tensione',
            current_unbalance: 'squilibrio di corrente',
            voltage_unbalance: 'squilibrio di tensione',
            mean_deviation_pct: 'deviazione media(%)',
            p95_abs_deviation_pct: 'deviazione assoluta P95(%)',
            mean_abs_deviation_hz: 'deviazione assoluta media(Hz)',
            frequency_deviation: 'deviazione di frequenza',
            p95_abs_deviation_hz: 'deviazione assoluta P95(Hz)',
            mean_unbalance_pct: 'squilibrio medio(%)',
            p95_unbalance_pct: 'squilibrio P95(%)',
            count: 'conteggio',
            min: 'minimo',
            max: 'massimo',
            mean: 'media',
            std: 'deviazione standard',
            p5: 'P5',
            p95: 'P95'
        }
    }, pol: {
        translation: {
            // routes & menus
            Dashboard: 'Panel główny',
            'Space Data': 'Dane przestrzeni',
            'Equipment Data': 'Dane urządzeń',
            'Meter Data': 'Dane liczników',
            'Tenant Data': 'Dane najemców',
            'Store Data': 'Dane sklepów',
            'Shopfloor Data': 'Dane hal produkcyjnych',
            'Combined Equipment Data': 'Dane urządzeń zespolonych',
            'Auxiliary System': 'Systemy pomocnicze',
            Microgrid: 'Mikrosieć',
            'Energy Storage Power Station': 'Elektrownia',
            'Photovoltaic Power Station': 'Elektrownia',
            'Fault Alarm': 'Alarm awaryjny',
            Monitoring: 'Monitorowanie urządzeń',
            'Advanced Reporting': 'Zaawansowane raportowanie',
            'Knowledge Base': 'Baza wiedzy',
            'Energy Category Data': 'Analiza kategorii energii',
            'Energy Item Data': 'Analiza pozycji zużycia energii',
            Carbon: 'Analiza emisji CO2',
            Cost: 'Analiza kosztów',
            Output: 'Analiza wytwarzania',
            Income: 'Analiza dochodów',
            Efficiency: 'Analiza efektywności',
            Load: 'Analiza obciążenia',
            Statistics: 'Analiza statystyczna',
            'Batch Analysis': 'Analiza zbiorcza',
            Saving: 'Analiza oszczędności energii',
            Plan: 'Analiza planistyczna',
            Prediction: 'Analiza predykcyjna',
            'Production': 'Wielkość produkcji',
            'Space Production': 'Analiza produkcji i zużycia energii w przestrzeniach',
            'Equipment Tracking': 'Rejestr urządzeń',
            'Equipment Comparison': 'Analiza porównawcza urządzeń',
            'Shopfloor Comparison': 'Analiza porównawcza hal produkcyjnych',
            'Store Comparison': 'Analiza porównawcza sklepów',
            'Space Comparison': 'Analiza porównawcza przestrzeni',
            'Combined Equipment Comparison': 'Analiza porównawcza urządzeń zespolonych',
            'Tenant Comparison': 'Analiza porównawcza najemców',
            'Environment Monitor': 'Monitorowanie środowiska',
            'Meter Energy': 'Analiza zużycia energii przez liczniki',
            'Meter Carbon': 'Analiza emisji CO2 przez liczniki',
            'Meter Cost': 'Analiza kosztów liczników',
            'Meter Trend': 'Analiza trendów liczników',
            'Meter Realtime': 'Analiza czasu rzeczywistego liczników',
            'Meter Saving': 'Analiza oszczędności energii przez liczniki',
            'Meter Plan': 'Analiza planistyczna liczników',
            'Master Meter Submeters Balance': 'Analiza bilansu licznika głównego i podliczników',
            'Meter Batch Analysis': 'Analiza zbiorcza liczników',
            'Meter Comparison': 'Analiza porównawcza liczników',
            'Meter Tracking': 'Rejestr liczników',
            'Virtual Meter Saving': 'Analiza oszczędności energii przez liczniki wirtualne',
            'Virtual Meter Plan': 'Analiza planistyczna liczników wirtualnych',
            'Virtual Meter Energy': 'Analiza zużycia energii przez liczniki wirtualne',
            'Virtual Meter Carbon': 'Analiza emisji CO2 przez liczniki wirtualne',
            'Virtual Meter Cost': 'Analiza kosztów liczników wirtualnych',
            'Virtual Meter Batch Analysis': 'Analiza zbiorcza liczników wirtualnych',
            'Virtual Meter Comparison': 'Analiza porównawcza liczników wirtualnych',
            'Offline Meter Energy': 'Analiza zużycia energii przez liczniki offline',
            'Offline Meter Carbon': 'Analiza emisji CO2 przez liczniki offline',
            'Offline Meter Cost': 'Analiza kosztów liczników offline',
            'Offline Meter Batch Analysis': 'Analiza zbiorcza liczników offline',
            'Offline Meter Saving': 'Analiza oszczędności energii przez liczniki offline',
            'Offline Meter Plan': 'Analiza planistyczna liczników offline',
            'Offline Meter Input': 'Wprowadzanie danych liczników offline',
            'Tenant Bill': 'Rachunek najemcy',
            'Energy Flow Diagram': 'Schemat przepływu energii',
            'Distribution System': 'System rozdziału energii',
            'SVG System': 'System wizualizacji konfiguracji',
            'Faults Data': 'Analiza usterek',
            'Space Equipments': 'Urządzenia w przestrzeni',
            'Combined Equipments': 'Urządzenia zespolone',
            'Energy Storage Power Station List': 'Lista elektrowni',
            'Energy Storage Power Station Details': 'Monitorowanie urządzeń',
            'Energy Storage Power Station Reporting': 'Raporty danych',
            'Energy Storage Power Station Alarm': 'Alarm awaryjny',
            'Energy Storage Power Station Maintenance': 'Konserwacja i utrzymanie',
            'Enter Production': 'Wprowadzanie wielkości produkcji',
            'Multiple Microgrids': 'Dane wielu elektrowni',
            'Multiple Microgrids Dashboard': 'Panel główny wielu elektrowni',
            'Multiple Microgrids List': 'Lista elektrowni',
            'Single Microgrid': 'Dane pojedynczej elektrowni',
            'Single Microgrid Dashboard': 'Panel główny pojedynczej elektrowni',
            'Single Microgrid Details': 'Dane urządzeń',
            'Single Microgrid Fault Alarm': 'Alarm awaryjny',
            'Microgrid Reports': 'Raporty statystyczne',
            'Microgrid Reports Energy': 'Raport energii',
            'Microgrid Reports Revenue': 'Raport przychodów',
            'Microgrid Reports Parameters': 'Zapytanie danych',
            'Multiple Energy Storage Power Stations': 'Dane wielu elektrowni magazynujących energię',
            'Multiple Energy Storage Power Stations Dashboard': 'Panel główny wielu elektrowni magazynujących energię',
            'Multiple Energy Storage Power Stations List': 'Lista elektrowni magazynujących energię',
            'Single Energy Storage Power Station': 'Dane pojedynczej elektrowni magazynującej energię',
            'Single Energy Storage Power Station Dashboard': 'Panel główny pojedynczej elektrowni magazynującej energię',
            'Single Energy Storage Power Station Details': 'Dane urządzeń magazynujących energię',
            'Single Energy Storage Power Station Fault Alarm': 'Alarm awaryjny elektrowni magazynującej energię',
            'Energy Storage Power Station Reports': 'Raporty statystyczne elektrowni magazynującej energię',
            'Energy Storage Power Station Reports Energy': 'Raport energii elektrowni magazynującej energię',
            'Energy Storage Power Station Reports Revenue': 'Raport przychodów elektrowni magazynującej energię',
            'Energy Storage Power Station Reports Parameters': 'Zapytanie danych elektrowni magazynującej energię',
            'Multiple Energy Storage Power Stations': 'Dane wielu elektrowni',
            'Multiple Energy Storage Power Stations Dashboard': 'Panel główny wielu elektrowni',
            'Multiple Energy Storage Power Stations List': 'Lista elektrowni',
            'Single Energy Storage Power Station': 'Dane pojedynczej elektrowni',
            'Single Energy Storage Power Station Dashboard': 'Panel główny pojedynczej elektrowni',
            'Single Energy Storage Power Station Details': 'Dane urządzeń',
            'Single Energy Storage Power Station Fault Alarm': 'Alarm awaryjny',
            'Energy Storage Power Station Reports': 'Raporty statystyczne',
            'Energy Storage Power Station Reports Energy': 'Raport energii',
            'Energy Storage Power Station Reports Revenue': 'Raport przychodów',
            'Energy Storage Power Station Reports Parameters': 'Zapytanie danych',
            'Photovoltaic Power Station List': 'Lista elektrowni fotowoltaicznych',
            'Photovoltaic Power Station Details': 'Monitorowanie urządzeń',
            'Photovoltaic Power Station Reporting': 'Raporty danych',
            'Photovoltaic Power Station Alarm': 'Alarm awaryjny',
            'Photovoltaic Power Station Maintenance': 'Konserwacja i utrzymanie',
            'Multiple Photovoltaic Power Stations': 'Dane wielu elektrowni fotowoltaicznych',
            'Multiple Photovoltaic Power Stations Dashboard': 'Panel główny wielu elektrowni fotowoltaicznych',
            'Multiple Photovoltaic Power Stations List': 'Lista elektrowni fotowoltaicznych',
            'Single Photovoltaic Power Station': 'Dane pojedynczej elektrowni fotowoltaicznej',
            'Single Photovoltaic Power Station Dashboard': 'Panel główny pojedynczej elektrowni fotowoltaicznej',
            'Single Photovoltaic Power Station Details': 'Dane urządzeń',
            'Single Photovoltaic Power Station Fault Alarm': 'Alarm awaryjny elektrowni fotowoltaicznej',
            'Photovoltaic Power Station Reports': 'Raporty statystyczne elektrowni fotowoltaicznej',
            'Photovoltaic Power Station Reports Energy': 'Raport energii elektrowni fotowoltaicznej',
            'Photovoltaic Power Station Reports Revenue': 'Raport przychodów elektrowni fotowoltaicznej',
            'Photovoltaic Power Station Reports Parameters': 'Zapytanie danych elektrowni fotowoltaicznej',
            'Work Order': 'Zarządzanie zleceniami pracy',
            'Work Order Installation': 'Rejestr instalacji',
            'Work Order Repair': 'Rejestr napraw',
            'Work Order Inspection': 'Rejestr inspekcji',
            'Total Number of Work Orders': 'Całkowita liczba zleceń pracy',
            'Number of New Work Orders': 'Liczba nowych zleceń pracy',
            'Number of Inprogress Work Orders': 'Liczba zleceń pracy w toku',
            'Number of Done Work Orders': 'Liczba wykonanych zleceń pracy',
            'Fuel Indicator': 'Zużycie paliwa',
            'Charge Energy Indicator': 'Energia ładowania',
            'Discharge Energy Indicator': 'Energia rozładowania',
            'Charge Cost Indicator': 'Koszt ładowania',
            'Discharge Revenue Indicator': 'Przychód z rozładowania',
            'HVAC': 'Klimatyzacja',
            'Fire Control': 'Ochrona przeciwpożarowa',
            // Dashboard
            'Welcome to MyEMS': 'Witamy w MyEMS',
            'An Industry Leading Open Source Energy Management System': 'Wiodący w branży, otwarty system zarządzania energią',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Zużycie w tym roku {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Koszty w tym roku {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Zużycie w tym miesiącu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": 'Wytworzenie w tym miesiącu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Costs CATEGORY VALUE UNIT": 'Koszty w tym miesiącu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'Zużycie w tym samym okresie rok temu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'Koszty w tym samym okresie rok temu {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': 'Zużycie {{CATEGORY}} {{UNIT}}',
            'CATEGORY Costs UNIT': 'Koszty {{CATEGORY}} {{UNIT}}',
            // Entities
            Space: 'Przestrzeń',
            Equipment: 'Urządzenie',
            Meter: 'Licznik',
            'Offline Meter': 'Licznik offline',
            'Virtual Meter': 'Licznik wirtualny',
            Tenant: 'Najemca',
            Store: 'Sklep',
            Shopfloor: 'Hala produkcyjna',
            'Combined Equipment': 'Urządzenie zespolone',
            'Cost Center': 'Centrum kosztów',
            Name: 'Nazwa',
            DisplayName: 'Nazwa wyświetlana',
            UserName: 'Nazwa użytkownika',
            Description: 'Opis',
            'Energy Category': 'Kategoria energii',
            'Child Spaces': 'Przestrzenie podrzędne',
            'Associated Equipment': 'Powiązane urządzenia',
            //Energy Categories
            Electricity: 'Energia elektryczna',
            Water: 'Woda',
            'Natural Gas': 'Gaz ziemny',
            // SidePanelModal
            Settings: 'Ustawienia',
            'Set your own customized style': 'Ustaw swój własny styl',
            'Color Scheme': 'Schemat kolorów',
            'Choose the perfect color mode for your app': 'Wybierz idealny tryb kolorów dla swojej aplikacji',
            Light: 'Jasny',
            Dark: 'Ciemny',
            'RTL Mode': 'Tryb RTL',
            'Switch your language direction': 'Zmień kierunek języka',
            'Fluid Layout': 'Układ płynny',
            'Toggle container layout system': 'Przełącz system układu kontenera',
            'Navigation Position': 'Pozycja nawigacji',
            'Vertical': 'Pionowa',
            'Top': 'Górna',
            'Combo': 'Kombinacja',
            'Transparent': 'Przezroczysta',
            'Inverted': 'Odwrócona',
            'Card': 'Karta',
            'Vibrant': 'Żywa',
            'Select a suitable navigation system for your web application': 'Wybierz odpowiedni system nawigacji dla swojej aplikacji webowej',
            'Vertical Nav': 'Nawigacja pionowa',
            'Top Nav': 'Nawigacja górna',
            'Vertical Navbar Style': 'Styl pionowego paska nawigacyjnego',
            'Switch between styles for your vertical navbar': 'Przełączaj między stylami pionowego paska nawigacyjnego',
            Language: 'Język',
            'Switch between languages': 'Przełącz języki',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Podoba Ci się to, co widzisz?',
            'Get MyEMS now': 'Pobierz MyEMS teraz',
            'PQ.About': 'Analiza obejmuje odchylenie napięcia, niezrównoważenie napięcia, odchylenie częstotliwości i niezrównoważenie prądu. Odchylenie napięcia obliczane jako (U−Un)/Un×100%; odchylenie częstotliwości jako |f−fn|; niezrównoważenie trójfazowe jako max(|Xi−Xavg|)/Xavg×100%, z wymaganiem wyrównania czasowego kanałów trójfazowych. Wyniki bazują na szeregach czasowych wybranego licznika w okresie raportowania. Brak kanałów trójfazowych lub niewyrównane znaczniki czasowe spowodują pominięcie wskaźników niezrównoważenia. Chwilowe skoki lub brak próbek mogą zwiększać wartości maksymalne; dla oceny stanu ustalonego zaleca się odwołanie do współczynnika zgodności oraz wskaźników statystycznych takich jak P95.',
            Purchase: 'Zakup wersji Enterprise',
            ContactInfo: 'Informacje Kontaktowe',
            ProductWebsite: 'Strona Produktu',
            CompanyWebsite: 'Strona Firmy',
            SalesPhone: 'Telefon Sprzedazy',
            // Query Panels
            'Base Period Begins': 'Okres bazowy rozpoczyna się',
            'Base Period Ends': 'Okres bazowy kończy się',
            'Comparison Types': 'Typy porównań',
            'Year-Over-Year': 'Rok do roku',
            'Month-On-Month': 'Miesiąc do miesiąca',
            'Free Comparison': 'Porównanie dowolne',
            'None Comparison': 'Brak porównania',
            'Reporting Period Begins': 'Okres raportowania rozpoczyna się',
            'Reporting Period Ends': 'Okres raportowania kończy się',
            '(Optional)': '(Opcjonalne)',
            'Period Types': 'Skale czasowe',
            Yearly: 'Rocznie',
            Monthly: 'Miesięcznie',
            Weekly: 'Tygodniowo',
            Daily: 'Dziennie',
            Hourly: 'Godzinowo',
            Submit: 'Zatwierdź',
            'Input Energy Category': 'Kategoria zużywanej energii',
            'Output Energy Category': 'Kategoria wytwarzanej energii',
            'Fraction Parameter': 'Parametr ułamka',
            Search: 'Szukaj',
            //DateRangePicker
            sunday: 'Niedz',
            monday: 'Pon',
            tuesday: 'Wt',
            wednesday: 'Śr',
            thursday: 'Czw',
            friday: 'Pt',
            saturday: 'Sob',
            ok: 'OK',
            today: 'Dziś',
            yesterday: 'Wczoraj',
            hours: 'Godziny',
            minutes: 'Minuty',
            seconds: 'Sekundy',
            last7Days: 'Ostatnie 7 dni',
            'Select Date Range': 'Wybierz zakres dat',
            //Card Summaries and Line Charts
            'Base Period': 'Okres bazowy',
            'Reporting Period': 'Okres raportowania',
            'Per Unit Area': 'Na jednostkę powierzchni',
            'Per Capita': 'Na mieszkańca',
            'Per Unit Production': 'Na jednostkę produktu',
            Baseline: 'Wartość bazowa',
            Actual: 'Wartość rzeczywista',
            'Baseline Value - Actual Value': 'Wartość bazowa - wartość rzeczywista',
            'Average Load': 'Średnie obciążenie',
            'Maximum Load': 'Maksymalne obciążenie',
            'Load Factor': 'Współczynnik obciążenia',
            'Ratio of Average Load to Maximum Load': 'Stosunek średniego obciążenia do maksymalnego',
            'Carbon Dioxide Emissions by Energy Category': 'Udział emisji CO2 według kategorii energii',
            'Costs by Energy Category': 'Udział kosztów według kategorii energii',
            'Incomes by Energy Category': 'Udział dochodów według kategorii energii',
            'Electricity Consumption by Time-Of-Use': 'Zużycie energii elektrycznej według czasu użytkowania',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Emisje CO2 z energii elektrycznej według czasu użytkowania',
            'Electricity Cost by Time-Of-Use': 'Koszt energii elektrycznej według czasu użytkowania',
            'CATEGORY UNIT Consumption by Energy Items': 'Udział zużycia {{CATEGORY}} {{UNIT}} według pozycji energii',
            'Ton of Standard Coal by Energy Category': 'Udział ton ekwiwalentu węgla (TCE) według kategorii energii',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Udział ton emisji CO2 (TCO2E) według kategorii energii',
            'Reporting Period Consumption CATEGORY UNIT': 'Zużycie w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Prognoza w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} zużycie w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} zużycie w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Produkcja w okresie raportowania {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Produkcja w okresie bazowym {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Zużycie w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Prognoza w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Zużycie w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Prognoza w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Zużycie w okresie raportowania {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'Zużycie w okresie raportowania {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Zużycie w okresie bazowym {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Udział przestrzeni podrzędnych {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Łączny udział przestrzeni podrzędnych',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'Emisje CO2 w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emisje CO2 w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'Emisje CO2 w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Koszty w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Koszty w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Koszty w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Wytworzenie w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} wytworzenie w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} wytworzenie w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Wytworzenie w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Wytworzenie w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Dochód w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Dochód w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Dochód w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Całkowity dochód w okresie raportowania {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Skumulowana efektywność w okresie raportowania {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} skumulowana efektywność w okresie raportowania {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} skumulowana efektywność kompleksowa w okresie raportowania {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} skumulowana efektywność kompleksowa w okresie raportowania {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} skumulowana efektywność kompleksowa w okresie bazowym {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Efektywność chwilowa {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} efektywność chwilowa {{UNIT}}',
            'Equipment Efficiency Indicator': 'Wskaźnik efektywności energetycznej urządzenia',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} efektywność kompleksowa chwilowa {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Skumulowana efektywność w okresie raportowania {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'Skumulowana efektywność w okresie raportowania {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Skumulowana efektywność w okresie bazowym {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Skumulowana efektywność w okresie bazowym {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Maksymalne obciążenie {{CATEGORY}} w okresie bazowym {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Maksymalne obciążenie {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Średnie obciążenie {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Współczynnik obciążenia {{CATEGORY}} w okresie raportowania',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Średnie obciążenie {{CATEGORY}} w okresie bazowym {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Średnia {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Maksimum {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Minimum {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Średnia arytmetyczna {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Mediana {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Odchylenie standardowe próbki {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Wariancja próbki {{CATEGORY}} w okresie raportowania {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'Oszczędność w okresie raportowania {{CATEGORY}} (bazowa - rzeczywista) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'Zmniejszenie w okresie raportowania {{CATEGORY}} (bazowa - rzeczywista) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Oszczędność w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Oszczędność w okresie bazowym {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': 'Zużycie licznika głównego w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'Zużycie licznika głównego w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': 'Zużycie podliczników w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'Zużycie podliczników w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Różnica w okresie raportowania {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Procentowa różnica w okresie raportowania',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Różnica w okresie raportowania {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Wartości trendu',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Lista usterek',
            'Reporting Period Number of Fault VALUE': 'Liczba usterek w okresie raportowania: {{VALUE}}',
            'All Faults': 'Wszystkie usterki',
            'Space Faults': 'Usterki przestrzeni',
            'Number of All Faults': 'Liczba wszystkich usterek',
            'Number of Space Faults': 'Liczba usterek przestrzeni',
            'Total Number of Faults': 'Całkowita liczba usterek',
            'Number of New Faults': 'Liczba nowych usterek',
            'Number of Inprogress Faults': 'Liczba usterek w toku',
            'Number of Done Faults': 'Liczba wykonanych usterek',
            //Data Panels
            'Ton of Standard Coal': 'Tona ekwiwalentu węgla',
            'Ton of Carbon Dioxide Emissions': 'Tona emisji CO2',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Emisja CO2 na jednostkę zużycia energii',
            'Operating Characteristic Curve': 'Krzywa charakterystyki pracy',
            Tariff: 'Taryfa',
            'Detailed Data': 'Szczegółowe dane',
            'Child Spaces Data': 'Dane przestrzeni podrzędnych',
            'Associated Equipment Data': 'Dane powiązanych urządzeń',
            'This Year': 'W tym roku',
            'The Same Period Last Year': 'W tym samym okresie rok temu',
            'This Month': 'W tym miesiącu',
            'This Day': 'W tym dniu',
            Total: 'Razem',
            'No data found': 'Brak danych',
            Export: 'Eksportuj',
            Datetime: 'Data i czas',
            'Time-Of-Use Type': 'Typ czasu użytkowania',
            'Top-Peak': 'Szczyt',
            'On-Peak': 'Szczyt',
            'Mid-Peak': 'Średnie obciążenie',
            'Off-Peak': 'Dolina',
            'Deep': 'Głęboka dolina',
            Percentage: 'Procent',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Trend punktu wartości energii z ostatniej godziny',
            Circuit: 'Obwód',
            Point: 'Punkt danych',
            'Realtime Value': 'Wartość w czasie rzeczywistym',
            //Meter Tracking
            'Meter List': 'Lista liczników',
            'Edit Meter': 'Edytuj',
            'Start Value': 'Wartość początkowa',
            'End Value': 'Wartość końcowa',
            'Difference Value': 'Różnica',
            'Start Integrity Rate': 'Wskaźnik kompletności danych początkowych (%)',
            'End Integrity Rate': 'Wskaźnik kompletności danych końcowych (%)',
            'Full Integrity Rate': 'Całkowity wskaźnik kompletności danych (%)',
            //Equipment Tracking
            'Equipment List': 'Lista urządzeń',
            'Edit Equipment': 'Edytuj',
            //Profile Dropdown
            Feedback: 'Opinia',
            'Account Settings': 'Ustawienia konta',
            Logout: 'Wyloguj',
            //Authentication
            'Log in': 'Zaloguj się',
            'Email address': 'Adres e-mail',
            'Phone Number': 'Numer telefonu',
            Password: 'Hasło',
            CaptchaCode: 'Kod weryfikacyjny',
            Refresh: 'Odśwież',
            'Remember me': 'Zapamiętaj mnie',
            'Logged in as ': 'Zalogowany jako ',
            'Forgot Password?': 'Zapomniałeś hasła?',
            'Forgot your password?': 'Zapomniałeś hasła?',
            "Enter your email and we'll send you a reset link": 'Wprowadź swój adres e-mail, a wyślemy Ci link resetujący',
            "Enter your email and we'll send you a registration link": 'Wprowadź swój adres e-mail, a wyślemy Ci link rejestracyjny',
            'Reset Password': 'Zresetuj hasło',
            'Thanks for using MyEMS!': 'Dziękujemy za korzystanie z MyEMS!',
            'You are now successfully signed out': 'Pomyślnie wylogowano',
            'Return to Login': 'Powrót do logowania',
            'Please check your email!': 'Sprawdź swój e-mail!',
            'An email has been sent to ': 'E-mail został wysłany do ',
            'Please click on the included link to reset your password': 'Kliknij na załączony link, aby zresetować hasło',
            'Please click on the included link to register your account': 'Kliknij na załączony link, aby zarejestrować konto',
            'An email with password reset link is sent to ': 'E-mail z linkiem resetującym hasło został wysłany do ',
            'Change Password': 'Zmień hasło',
            'Old Password': 'Stare hasło',
            'New Password': 'Nowe hasło',
            'Confirm Password': 'Potwierdź nowe hasło',
            'Update Password': 'Aktualizuj hasło',
            'Password has been changed!': 'Hasło zostało zmienione!',
            'Verification code has been sent to your inbox. \
            Please copy it to the input box below.':
                'Kod weryfikacyjny został wysłany na Twoją skrzynkę pocztową. Skopiuj go do poniższego pola.',
            'New to MyEMS': 'Nowy w MyEMS',
            'Create an account': 'Utwórz konto',
            'EMAIL Account registration successful': 'Rejestracja konta {{EMAIL}} zakończona sukcesem',
            'Thanks for verifying your account!': 'Dziękujemy za weryfikację konta!',
            'Your code is': 'Twój kod to',
            'Send verification code': 'Wyślij kod weryfikacyjny',
            'Please wait for NUMBER seconds': 'Poczekaj {{NUMBER}} sekund',
            'Password reset': 'Reset hasła',
            'Please wait for approval': 'Proszę czekać na zatwierdzenie',
            //notification
            Notifications: 'Powiadomienia',
            'Mark all as read': 'Oznacz wszystkie jako przeczytane',
            'View all': 'Zobacz wszystkie',
            'Notification New': 'Nowe',
            'Notification Earlier': 'Wcześniejsze',
            'Notification List': 'Lista powiadomień',
            'Bulk actions': 'Akcje zbiorcze',
            'Notification Subject': 'Temat',
            'Notification Created Datetime': 'Czas utworzenia',
            'Notification Message': 'Treść',
            'Notification Priority': 'Priorytet',
            'Notification Status': 'Status',
            'Notification Mark As Read': 'Oznacz jako przeczytane',
            'Notification Mark As Acknowledged': 'Potwierdź',
            'Notification Low': 'Niski',
            'Notification Medium': 'Średni',
            'Notification High': 'Wysoki',
            'Notification Critical': 'Krytyczny',
            'Notification Unread': 'Nieprzeczytane',
            'Notification Read': 'Przeczytane',
            'Notification Acknowledged': 'Potwierdzone',
            'Notification Archive': 'Archiwizuj',
            'Notification Delete': 'Usuń',
            'Notification Apply': 'Zastosuj',
            'Notification Start Datetime': 'Czas rozpoczęcia',
            'Notification End Datetime': 'Czas zakończenia',
            'Notification Update Datetime': 'Czas aktualizacji',
            //Monitoring
            'Run Commands': 'Uruchom polecenia',
            'Pin Code': 'Kod PIN',
            'Unlock': 'Odblokuj',
            'Set Value': 'Ustaw wartość',
            'Fault Alarms': 'Alarmy awaryjne',
            'Instantaneous Efficiency VALUE UNIT': 'Efektywność chwilowa {{VALUE}} {{UNIT}}',
            'Communication Status': 'Status komunikacji',
            'Communication Online': 'Online',
            'Communication Offline': 'Offline',
            'Equipment Status': 'Status urządzenia',
            'Equipment Running': 'Praca',
            'Equipment Stopped': 'Zatrzymane',
            'Show Up to': 'Pokaż do',
            All: 'Wszystko',
            'FROM - TO of TOTAL': 'Wyświetlane {{FROM}} - {{TO}} z {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Energia',
            'Microgrid Revenue': 'Przychód',
            'Microgrid Carbon': 'Emisje CO2',
            'Photovoltaic Generation': 'Generacja fotowoltaiczna',
            'EV Charger Consumption': 'Zużycie ładowarek EV',
            'Load Consumption': 'Zużycie obciążenia',
            'Grid Buy': 'Zakup z sieci',
            'Grid Sell': 'Sprzedaż do sieci',
            'EV Charger': 'Ładowarka EV',
            'Heat Pump': 'Pompa ciepła',
            'Photovoltaic': 'Fotowoltaika',
            'PCS Run State': 'Status pracy PCS',
            'PCS Unknown': 'Nieznany',
            'PCS Initializing': 'Inicjalizacja zasilania',
            'PCS Standby': 'Czuwanie',
            'PCS Shutdown': 'Wyłączony',
            'PCS Fault': 'Usterka',
            'PCS Running': 'Praca',
            'Battery Power': 'Moc baterii',
            'Photovoltaic Power': 'Moc fotowoltaiki',
            'Grid Power': 'Moc sieci',
            'Load Power': 'Moc obciążenia',
            Reporting: 'Raportowanie danych',
            Maintenance: 'Konserwacja',
            'General Information': 'Informacje ogólne',
            'Serial Number': 'Numer seryjny',
            Address: 'Adres',
            'Postal Code': 'Kod pocztowy',
            'Rated Capacity': 'Pojemność znamionowa',
            'Rated Power': 'Moc znamionowa',
            Latitude: 'Szerokość geograficzna',
            Longitude: 'Długość geograficzna',
            'Strategy Management': 'Zarządzanie strategią',
            'Charging Schedule': 'Harmonogram ładowania',
            'Charge Start Time': 'Czas rozpoczęcia ładowania',
            'Charge End Time': 'Czas zakończenia ładowania',
            'Discharge Start Time': 'Czas rozpoczęcia rozładowania',
            'Discharge End Time': 'Czas zakończenia rozładowania',
            'Total Rated Power': 'Całkowita moc znamionowa',
            'Total Rated Capacity': 'Całkowita pojemność znamionowa',
            // Energy Indicator
            "Today's Charge": "Dzisiejsze ładowanie",
            "Today's Discharge": "Dzisiejsze rozładowanie",
            "Today's Generation": "Dzisiejsza generacja",
            'Total Fuel Consumption': 'Całkowite zużycie paliwa',
            'Total Charge': 'Całkowite ładowanie',
            'Total Discharge': 'Całkowite rozładowanie',
            'Total Generation': 'Całkowita generacja',
            'Total Revenue': 'Całkowity przychód',
            'Total Photovoltaic Generation': 'Całkowita generacja fotowoltaiczna',
            'Total EV Charger Consumption': 'Całkowite zużycie ładowarek EV',
            'Total Load Consumption': 'Całkowite zużycie obciążenia',
            'Total Grid Buy': 'Całkowity zakup z sieci',
            'Total Grid Sell': 'Całkowita sprzedaż do sieci',
            'Total Efficiency': 'Całkowita efektywność',
            'Discharge Achievement Rate': 'Wskaźnik realizacji rozładowania',
            // Revenue Indicator
            "Today's Cost": "Dzisiejszy koszt",
            "Today's Income": "Dzisiejszy dochód",
            "Total Cost": "Łączny koszt",
            "Total Income": "Łączny dochód",
            "Today's Revenue": "Dzisiejszy zysk",

            'Revenue Ranking': 'Ranking przychodów',
            'Efficiency Ranking': 'Ranking efektywności',
            'Charge Ranking': 'Ranking ładowania',
            'Discharge Ranking': 'Ranking rozładowania',
            'Number of Microgrids': 'Liczba mikrosieci',
            'Number of Power Stations': 'Liczba elektrowni',
            'Microgrid List': 'Lista mikrosieci',
            'Select Microgrid': 'Wybierz mikrosieć',
            'Previous Page': 'Poprzednia strona',
            'Next Page': 'Następna strona',
            '7 Days': '7 dni',
            'Charge UNIT': 'Ładuj {{UNIT}}',
            'Discharge UNIT': 'Rozładuj {{UNIT}}',
            'Generation UNIT': 'Generuj {{UNIT}}',
            'Energy Indicator': 'Energia',
            'Revenue Indicator': 'Przychód',
            'Carbon Indicator': 'Węgiel',

            // Energy Storage Power Station
            'Battery Operating State': 'Stan pracy baterii',
            'Battery State': 'Stan baterii',
            'Battery Unknown': 'Nieznany',
            'Battery Stopped': 'Zatrzymany',
            'Battery Reserved': 'Zarezerwowany',
            'Battery Fault': 'Usterka',
            'Battery Warning': 'Ostrzeżenie',
            'Battery Standby': 'Czuwanie',
            'Battery Prohibit DisCharging': 'Zabronione rozładowanie',
            'Battery Prohibit Charging': 'Zabronione ładowanie',
            'Battery Normal': 'Normalny',
            'Battery Charging': 'Ładowanie',
            'Battery Discharging': 'Rozładowanie',
            'Battery Idle': 'Bezczynny',
            'Phase of Lifecycle': 'Faza cyklu życia',
            'Use Phase': 'Eksploatacja',
            'Commissioning Phase': 'Rozruch',
            'Commissioning Date': 'Data oddania do użytku',
            'Installation Phase': 'W budowie',
            'Device Status': 'Status urządzenia',
            'Basic Information': 'Informacje podstawowe',
            'Gateway': 'Brama',
            'Grid Meter': 'Licznik sieci',
            'Load Meter': 'Licznik obciążenia',
            'ESS Meter': 'Licznik magazynowania energii',
            'Total Active Power': 'Całkowita moc czynna',
            'Active Power A': 'Moc czynna fazy A',
            'Active Power B': 'Moc czynna fazy B',
            'Active Power C': 'Moc czynna fazy C',
            'Total Reactive Power': 'Całkowita moc bierna',
            'Reactive Power A': 'Moc bierna fazy A',
            'Reactive Power B': 'Moc bierna fazy B',
            'Reactive Power C': 'Moc bierna fazy C',
            'Total Apparent Power': 'Całkowita moc pozorna',
            'Apparent Power A': 'Moc pozorna fazy A',
            'Apparent Power B': 'Moc pozorna fazy B',
            'Apparent Power C': 'Moc pozorna fazy C',
            'Total Power Factor': 'Całkowity współczynnik mocy',
            'Active Energy Import': 'Energia czynna pobrana',
            'Active Energy Export': 'Energia czynna oddana',
            'Active Energy Net': 'Energia czynna netto',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'Falownik',
            'Invertor Run State': 'Status pracy falownika',
            'Invertor Unknown': 'Nieznany',
            'Invertor Initializing': 'Inicjalizacja zasilania',
            'Invertor Standby': 'Czuwanie',
            'Invertor Shutdown': 'Wyłączony',
            'Invertor Fault': 'Usterka',
            'Invertor Running': 'Praca',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': 'Czas utworzenia',
            'File Format': 'Format pliku',
            'File Size': 'Rozmiar pliku',
            Uploader: 'Przesyłający',
            'Upload Datetime': 'Czas przesłania',
            //Error
            "The page you're looking for is not found": 'Strona, której szukasz, nie została znaleziona',
            "Make sure the address is correct and that the page hasn't moved": 'Upewnij się, że adres jest poprawny i strona nie została przeniesiona',
            'If you think this is a mistake,': 'Jeśli uważasz, że to błąd,',
            'contact us': 'skontaktuj się z nami',
            'Take me home': 'Zabierz mnie do strony głównej',
            'Whoops, something went wrong!': 'Ups, coś poszło nie tak!',
            'Try refreshing the page, or going back and attempting the action again':
                'Spróbuj odświeżyć stronę lub cofnąć się i ponowić akcję',
            'If this problem persists,': 'Jeśli problem się utrzymuje,',
            'Captcha Error': 'Błąd kodu weryfikacyjnego',
            'Confirm Password Error': 'Hasła nie są zgodne',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Wygląda na to, że kliknąłeś w nieprawidłowy link resetowania hasła. Spróbuj ponownie.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Wygląda na to, że kliknąłeś w nieprawidłowy link rejestracji konta. Spróbuj ponownie.',
            //Tenant Bill
            'Lease Contract Number': 'Numer umowy najmu',
            Download: 'Pobierz',
            Print: 'Drukuj',
            'Payment Notice': 'Powiadomienie o płatności',
            'Bill To': 'Do',
            'Bill Number': 'Numer rachunku',
            'Bill Date': 'Data rachunku',
            'Payment Due Date': 'Termin płatności',
            'Amount Payable': 'Kwota do zapłaty',
            'Billing Period Start': 'Początek okresu rozliczeniowego',
            'Billing Period End': 'Koniec okresu rozliczeniowego',
            Quantity: 'Ilość',
            Price: 'Cena',
            Unit: 'Jednostka',
            Amount: 'Kwota',
            Subtotal: 'Suma częściowa',
            'VAT Output Tax': 'Podatek VAT należny',
            'Total Amount Payable': 'Łączna kwota do zapłaty',
            'Please make sure to pay on or before the payment due date above': 'Upewnij się, że zapłacisz w lub przed powyższym terminem płatności',
            'Send money to the following account': 'Prześlij pieniądze na następujące konto',
            'Account Name': 'Nazwa konta',
            'Bank Name': 'Nazwa banku',
            'Bank Address': 'Adres banku',
            'RMB Account': 'Konto RMB',
            // button
            'Toggle Navigation': 'Przełącz nawigację',
            // working calendar
            'Working Days': 'Dni robocze',
            'Non Working Days': 'Dni wolne od pracy',
            'Select Row': 'Wybierz wiersz do operacji',
            // Offline Meter Input
            'Daily Value': 'Dane dzienne',
            Date: 'Data',
            'Successfully Saved': 'Zapisano pomyślnie',
            'Previous Data Is Empty': 'Poprzednie dane są puste',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sesja administratora nie istnieje',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Sesja administratora wygasła',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Zaawansowany raport nie istnieje',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': 'Złe żądanie',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Nie można ustawić licznika, który już jest podlicznikiem, jako licznika głównego',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a urządzeniem już istnieje',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a urządzeniem nie istnieje',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a licznikiem już istnieje',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a licznikiem nie istnieje',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nazwa urządzenia zespolonego jest już w użyciu',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Urządzenie zespolone nie istnieje',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a licznikiem offline już istnieje',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a licznikiem offline nie istnieje',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nazwa parametru powiązanego z urządzeniem zespolonym jest już w użyciu',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametr powiązany z urządzeniem zespolonym nie istnieje lub nie pasuje',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między urządzeniem zespolonym a licznikiem wirtualnym już istnieje',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem zespolonym a licznikiem wirtualnym nie istnieje',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Nazwa kontaktu jest już w użyciu',
            'API.CONTACT_NOT_FOUND': 'Kontakt nie istnieje',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Zewnętrzny ID centrum kosztów już istnieje',
            'API.COST_CENTER_NAME_EXISTS': 'Nazwa centrum kosztów już istnieje',
            'API.COST_CENTER_NOT_FOUND': 'Centrum kosztów nie istnieje',
            'API.COST_FILE_NOT_FOUND': 'Plik kosztów nie istnieje',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Nazwa źródła danych jest już w użyciu',
            'API.DATA_SOURCE_NOT_FOUND': 'Źródło danych nie istnieje',
            'API.DATABASE_ERROR': 'Błąd bazy danych',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Data jest już w kalendarzu roboczym',
            'API.DATE_LOCAL_NOT_FOUND': 'Nie znaleziono daty lokalnej',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Nazwa obwodu rozdziału energii jest już w użyciu',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Obwód rozdziału energii nie istnieje',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relacja między obwodem rozdziału energii a punktem już istnieje',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relacja między obwodem rozdziału energii a punktem nie istnieje',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nazwa systemu rozdziału energii jest już w użyciu',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'System rozdziału energii nie istnieje',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': 'Adres e-mail jest już w użyciu',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Wiadomość e-mail nie istnieje',
            'API.EMAIL_NOT_FOUND': 'Adres e-mail nie istnieje',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Host serwera pocztowego jest już w użyciu',
            'API.EMAIL_SERVER_NOT_FOUND': 'Host serwera pocztowego nie istnieje',
            'API.EMPTY_VARIABLES_ARRAY': 'Pusta tablica zmiennych',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Nazwa kategorii energii jest już w użyciu',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Kategoria energii nie istnieje',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Kategoria energii jest już używana w pozycjach energii',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Kategoria energii jest już używana w liczniku',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Kategoria energii jest już używana w liczniku offline',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Kategoria energii jest już używana w taryfach',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Kategoria energii jest już używana w liczniku wirtualnym',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Łącze schematu przepływu energii jest już w użyciu',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Łącze schematu przepływu energii nie istnieje lub nie pasuje',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Nazwa schematu przepływu energii jest już w użyciu',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Węzeł schematu przepływu energii jest już w użyciu',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Węzeł schematu przepływu energii nie istnieje lub nie pasuje',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Schemat przepływu energii nie istnieje',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Pozycja energii nie należy do kategorii energii',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Pozycja energii nie należy do kategorii energii',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Pozycja energii jest już w użyciu',
            'API.ENERGY_ITEM_NOT_FOUND': 'Pozycja energii nie istnieje',
            'API.ENERGY_ITEM_USED_IN_METER': 'Pozycja energii jest już używana w liczniku',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Pozycja energii jest już używana w liczniku offline',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Pozycja energii jest już używana w liczniku wirtualnym',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relacja między urządzeniem a licznikiem już istnieje',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem a licznikiem nie istnieje',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nazwa urządzenia jest już w użyciu',
            'API.EQUIPMENT_NOT_FOUND': 'Urządzenie nie istnieje',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relacja między urządzeniem a licznikiem offline już istnieje',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem a licznikiem offline nie istnieje',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nazwa parametru powiązanego z urządzeniem jest już w użyciu',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametr powiązany z urządzeniem nie istnieje lub nie pasuje',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między urządzeniem a licznikiem wirtualnym już istnieje',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między urządzeniem a licznikiem wirtualnym nie istnieje',
            'API.ERROR': 'Błąd',
            'API.EXCEPTION': 'Wyjątek',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Nie udało się przywrócić pliku kosztów',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Nie udało się przywrócić pliku wiedzy',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Nie udało się przywrócić pliku licznika offline',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Nie udało się zapisać pliku licznika offline',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Nie udało się przesłać pliku kosztów',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Nie udało się przesłać pliku wiedzy',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Nie udało się przesłać pliku licznika offline',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Nazwa bramy jest już w użyciu',
            'API.GATEWAY_NOT_FOUND': 'Brama nie istnieje',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': 'Nieprawidłowy ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': 'Nieprawidłowy adres',
            'API.INVALID_ADDRESS_VALUE': 'Nieprawidłowa wartość adresu',
            'API.INVALID_ADVANCED_REPORT_ID': 'Nieprawidłowy ID zaawansowanego raportu',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': 'Nieprawidłowa wartość powierzchni',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Nieprawidłowa data i czas zakończenia okresu bazowego',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Nieprawidłowa data i czas rozpoczęcia okresu bazowego',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': 'Nieprawidłowa prędkość transmisji',
            'API.INVALID_BUILDINGS_VALUE': 'Nieprawidłowa wartość budynków',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': 'Nieprawidłowa kategoria',
            'API.INVALID_CHANNEL': 'Nieprawidłowy kanał',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Nieprawidłowy ID urządzenia zespolonego',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nieprawidłowa nazwa urządzenia zespolonego',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Nieprawidłowy ID parametru powiązanego z urządzeniem zespolonym',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Nieprawidłowa nazwa parametru powiązanego z urządzeniem zespolonym',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Nieprawidłowy typ parametru powiązanego z urządzeniem zespolonym',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Nieprawidłowe UUID urządzenia zespolonego',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': 'Nieprawidłowe połączenie',
            'API.INVALID_CONSTANT_VALUE': 'Nieprawidłowa wartość stałej',
            'API.INVALID_CONTACT_ID': 'Nieprawidłowy ID kontaktu',
            'API.INVALID_CONTACT_NAME': 'Nieprawidłowa nazwa kontaktu',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': 'Nieprawidłowy ID centrum kosztów',
            'API.INVALID_COST_FILE_ID': 'Nieprawidłowy ID pliku kosztów',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': 'Nieprawidłowy ID źródła danych',
            'API.INVALID_DATA_SOURCE_NAME': 'Nieprawidłowa nazwa źródła danych',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Nieprawidłowy protokół źródła danych',
            'API.INVALID_DATE_LOCAL': 'Nieprawidłowa data lokalna',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Nieprawidłowe UUID licznika referencyjnego',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': 'Nieprawidłowa nazwa wyświetlana',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Nieprawidłowy ID obwodu rozdziału energii',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nieprawidłowa nazwa obwodu rozdziału energii',
            'API.INVALID_DISTRIBUTION_ROOM': 'Nieprawidłowa rozdzielnia',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Nieprawidłowy ID systemu rozdziału energii',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nieprawidłowa nazwa systemu rozdziału energii',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': 'Nieprawidłowy adres e-mail',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Nieprawidłowy ID wiadomości e-mail',
            'API.INVALID_EMAIL_SERVER_HOST': 'Nieprawidłowy host serwera poczty e-mail',
            'API.INVALID_EMAIL_SERVER_ID': 'Nieprawidłowy ID serwera poczty e-mail',
            'API.INVALID_END_DATE_FORMAT': 'Nieprawidłowy format daty końcowej',
            'API.INVALID_END_DATETIME': 'Nieprawidłowa data i czas zakończenia',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Nieprawidłowy ID kategorii energii',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Nieprawidłowa nazwa kategorii energii',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Nieprawidłowy ID schematu przepływu energii',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Nieprawidłowy ID łącza schematu przepływu energii',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nieprawidłowa nazwa schematu przepływu energii',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Nieprawidłowy ID węzła schematu przepływu energii',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nieprawidłowa nazwa węzła schematu przepływu energii',
            'API.INVALID_ENERGY_ITEM_ID': 'Nieprawidłowy ID pozycji energii',
            'API.INVALID_ENERGY_ITEM_NAME': 'Nieprawidłowa nazwa pozycji energii',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Nieprawidłowe równanie w wyrażeniu',
            'API.INVALID_EQUIPMENT_ID': 'Nieprawidłowy ID urządzenia',
            'API.INVALID_EQUIPMENT_NAME': 'Nieprawidłowa nazwa urządzenia',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Nieprawidłowy ID parametru powiązanego z urządzeniem',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nieprawidłowa nazwa parametru powiązanego z urządzeniem',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Nieprawidłowy typ parametru powiązanego z urządzeniem',
            'API.INVALID_EQUIPMENT_UUID': 'Nieprawidłowe UUID urządzenia',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': 'Nieprawidłowe wyrażenie',
            'API.INVALID_EXPRESSION_OBJECT': 'Nieprawidłowy obiekt wyrażenia',
            'API.INVALID_FDD_CODE': 'Nieprawidłowy kod błędu usterki',
            'API.INVALID_FLOORS_VALUE': 'Nieprawidłowa wartość pięter',
            'API.INVALID_FROM_ADDR': 'Nieprawidłowy adres nadawcy',
            'API.INVALID_GATEWAY_ID': 'Nieprawidłowy ID bramy',
            'API.INVALID_GATEWAY_NAME': 'Nieprawidłowa nazwa bramy',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Nieprawidłowa wartość limitu górnego na godzinę',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Nieprawidłowa wartość limitu dolnego na godzinę',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': 'Nieprawidłowa wartość administratora',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Nieprawidłowa wartość wyświetlania danych kosztów',
            'API.INVALID_IS_COUNTED_VALUE': 'Nieprawidłowa wartość liczenia',
            'API.INVALID_IS_ENABLED': 'Nieprawidłowa wartość włączone',
            'API.INVALID_IS_HIDDEN': 'Nieprawidłowa wartość ukryte',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Nieprawidłowa wartość w najmie',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Nieprawidłowa wartość sumowania wejść',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Nieprawidłowa wartość główny najemca',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Nieprawidłowa wartość sumowania wyjść',
            'API.INVALID_IS_OUTPUT_VALUE': 'Nieprawidłowa wartość sumowania wyjść',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': 'Nieprawidłowa wartość zapisywania trendu',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Nieprawidłowa wartość punktu wirtualnego',
            'API.INVALID_KGCE': 'Nieprawidłowy współczynnik kg ekwiwalentu węgla',
            'API.INVALID_KGCO2E': 'Nieprawidłowy współczynnik kg emisji CO2',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Nieprawidłowy ID pliku wiedzy',
            'API.INVALID_LATITUDE_VALUE': 'Nieprawidłowa wartość szerokości geograficznej',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Nieprawidłowy numer umowy najmu',
            'API.INVALID_LONGITUDE_VALUE': 'Nieprawidłowa wartość długości geograficznej',
            'API.INVALID_LOW_LIMIT_VALUE': 'Nieprawidłowa wartość limitu dolnego',
            'API.INVALID_MASTER_METER_ID': 'Nieprawidłowy ID licznika głównego',
            'API.INVALID_MENU_ID': 'Nieprawidłowy ID menu',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': 'Nieprawidłowy szablon wiadomości',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': 'Nieprawidłowy ID licznika',
            'API.INVALID_METER_NAME': 'Nieprawidłowa nazwa licznika',
            'API.INVALID_METER_UUID': 'Nieprawidłowe UUID licznika',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Nieprawidłowa wartość nazwy',
            'API.INVALID_NEW_PASSWORD': 'Nieprawidłowe nowe hasło',
            'API.INVALID_NON_WORKING_DAY_ID': 'Nieprawidłowy ID dnia wolnego od pracy',
            'API.INVALID_NOTIFICATION_ID': 'Nieprawidłowy ID powiadomienia',
            'API.INVALID_NUMERATOR_METER_UUID': 'Nieprawidłowe UUID licznika licznika',
            'API.INVALID_OBJECT_TYPE': 'Nieprawidłowy typ obiektu',
            'API.INVALID_OFFLINE_METER_DATA': 'Nieprawidłowe dane licznika offline',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Nieprawidłowy ID pliku licznika offline',
            'API.INVALID_OFFLINE_METER_ID': 'Nieprawidłowy ID licznika offline',
            'API.INVALID_OFFLINE_METER_NAME': 'Nieprawidłowa nazwa licznika offline',
            'API.INVALID_OFFLINE_METER_UUID': 'Nieprawidłowe UUID licznika offline',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Nieprawidłowa stała przesunięcia',
            'API.INVALID_OLD_PASSWORD': 'Nieprawidłowe stare hasło',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': 'Nieprawidłowy ID przestrzeni nadrzędnej',
            'API.INVALID_PASSWORD': 'Nieprawidłowe hasło',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': 'Nieprawidłowy prąd szczytowy',
            'API.INVALID_PEAK_LOAD': 'Nieprawidłowe obciążenie szczytowe',
            'API.INVALID_PERIOD_TYPE': 'Nieprawidłowy typ okresu',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': 'Nieprawidłowy ID punktu danych',
            'API.INVALID_POINT_NAME': 'Nieprawidłowa nazwa punktu danych',
            'API.INVALID_PORT': 'Nieprawidłowy port',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': 'Nieprawidłowy priorytet',
            'API.INVALID_PRIVILEGE': 'Nieprawidłowe uprawnienie',
            'API.INVALID_PRIVILEGE_DATA': 'Nieprawidłowe dane uprawnień',
            'API.INVALID_PRIVILEGE_ID': 'Nieprawidłowy ID uprawnienia',
            'API.INVALID_PRIVILEGE_NAME': 'Nieprawidłowa nazwa uprawnienia',
            'API.INVALID_RATIO_VALUE': 'Nieprawidłowa wartość współczynnika konwersji',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': 'Nieprawidłowa odpowiedź',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Nieprawidłowa data i czas zakończenia okresu raportowania',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Nieprawidłowa data i czas rozpoczęcia okresu raportowania',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Nieprawidłowa wartość wymagania uwierzytelnienia',
            'API.INVALID_ROOMS_VALUE': 'Nieprawidłowa wartość pomieszczeń',
            'API.INVALID_RULE_ID': 'Nieprawidłowy ID reguły',
            'API.INVALID_RULE_NAME': 'Nieprawidłowa nazwa reguły',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': 'Nieprawidłowy ID czujnika',
            'API.INVALID_SENSOR_NAME': 'Nieprawidłowa nazwa czujnika',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': 'Nieprawidłowy port szeregowy',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sesja nieprawidłowa, zaloguj się ponownie',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': 'Nieprawidłowy ID hali produkcyjnej',
            'API.INVALID_SHOPFLOOR_NAME': 'Nieprawidłowa nazwa hali produkcyjnej',
            'API.INVALID_SHOPFLOOR_UUID': 'Nieprawidłowe UUID hali produkcyjnej',
            'API.INVALID_SOURCE_NODE_ID': 'Nieprawidłowy ID węzła źródłowego',
            'API.INVALID_SPACE_ID': 'Nieprawidłowy ID przestrzeni',
            'API.INVALID_SPACE_NAME': 'Nieprawidłowa nazwa przestrzeni',
            'API.INVALID_SPACE_UUID': 'Nieprawidłowe UUID przestrzeni',
            'API.INVALID_START_DATE_FORMAT': 'Nieprawidłowy format daty rozpoczęcia',
            'API.INVALID_START_DATETIME': 'Nieprawidłowa data i czas rozpoczęcia',
            'API.INVALID_STATUS': 'Nieprawidłowy status',
            'API.INVALID_STORE_ID': 'Nieprawidłowy ID sklepu',
            'API.INVALID_STORE_NAME': 'Nieprawidłowa nazwa sklepu',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Nieprawidłowy opis typu sklepu',
            'API.INVALID_STORE_TYPE_ID': 'Nieprawidłowy ID typu sklepu',
            'API.INVALID_STORE_TYPE_NAME': 'Nieprawidłowa nazwa typu sklepu',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Nieprawidłowy uproszczony kod typu sklepu',
            'API.INVALID_STORE_UUID': 'Nieprawidłowe UUID sklepu',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': 'Nieprawidłowe SVG',
            'API.INVALID_SWITCHGEAR': 'Nieprawidłowy aparat łączeniowy',
            'API.INVALID_TARGET_NODE_ID': 'Nieprawidłowy ID węzła docelowego',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Nieprawidłowe ceny taryfy blokowej',
            'API.INVALID_TARIFF_ID': 'Nieprawidłowy ID taryfy',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Nieprawidłowe ceny taryfy czasowej',
            'API.INVALID_TARIFF_TYPE': 'Nieprawidłowy typ taryfy',
            'API.INVALID_TENANT_ID': 'Nieprawidłowy ID najemcy',
            'API.INVALID_TENANT_NAME': 'Nieprawidłowa nazwa najemcy',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Nieprawidłowy opis typu najemcy',
            'API.INVALID_TENANT_TYPE_ID': 'Nieprawidłowy ID typu najemcy',
            'API.INVALID_TENANT_TYPE_NAME': 'Nieprawidłowa nazwa typu najemcy',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Nieprawidłowy uproszczony kod typu najemcy',
            'API.INVALID_TENANT_UUID': 'Nieprawidłowe UUID najemcy',
            'API.INVALID_TEXT_MESSAGE_ID': 'Nieprawidłowy ID wiadomości SMS',
            'API.INVALID_TIMEZONE_ID': 'Nieprawidłowy ID strefy czasowej',
            'API.INVALID_TOKEN': 'Nieprawidłowy token',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': 'Nieprawidłowa jednostka miary',
            'API.INVALID_UNIT_OF_PRICE': 'Nieprawidłowa jednostka ceny',
            'API.INVALID_UNITS': 'Nieprawidłowe jednostki',
            'API.INVALID_USER_ID': 'Nieprawidłowy ID użytkownika',
            'API.INVALID_USER_NAME': 'Nieprawidłowa nazwa użytkownika',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Nieprawidłowa nazwa użytkownika lub e-mail',
            'API.INVALID_USER_PHONE': 'Nieprawidłowy numer telefonu użytkownika',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Nieprawidłowy użytkownik, zaloguj się ponownie',
            'API.INVALID_USER_UUID': 'Nieprawidłowe UUID użytkownika',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': 'Nieprawidłowy ID licznika zmiennej',
            'API.INVALID_VARIABLE_METER_TYPE': 'Nieprawidłowy typ licznika zmiennej',
            'API.INVALID_VARIABLE_NAME': 'Nieprawidłowa nazwa zmiennej',
            'API.INVALID_VERIFICATION_CODE': 'Nieprawidłowy kod weryfikacyjny',
            'API.INVALID_VIRTUAL_METER_ID': 'Nieprawidłowy ID licznika wirtualnego',
            'API.INVALID_VIRTUAL_METER_NAME': 'Nieprawidłowa nazwa licznika wirtualnego',
            'API.INVALID_VIRTUAL_METER_UUID': 'Nieprawidłowe UUID licznika wirtualnego',
            'API.INVALID_WEB_MESSAGE_ID': 'Nieprawidłowy ID wiadomości web',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Nieprawidłowy ID wiadomości WeChat',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': 'Nieprawidłowy ID kalendarza roboczego',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Nieprawidłowa nazwa kalendarza roboczego',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Nie można usunąć pliku wiedzy z dysku',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Plik bazy wiedzy nie istnieje',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Licznik główny nie należy do tej samej kategorii energii',
            'API.MASTER_METER_NOT_FOUND': 'Licznik główny nie istnieje',
            'API.MENU_NOT_FOUND': 'Menu nie istnieje',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Nazwa licznika jest już w użyciu',
            'API.METER_NOT_FOUND': 'Licznik nie istnieje',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Zmienna licznika nie istnieje',
            'API.METER_POINT_RELATION_EXISTS': 'Relacja między licznikiem a punktem danych już istnieje',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Relacja między licznikiem a punktem danych nie istnieje',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Nowe hasło nie może przekraczać 100 znaków',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Dzień wolny od pracy nie istnieje',
            'API.NOT_FOUND': 'Nie istnieje',
            'API.NOTIFICATION_NOT_FOUND': 'Powiadomienie nie istnieje',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Plik licznika offline nie istnieje',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nazwa licznika offline jest już w użyciu',
            'API.OFFLINE_METER_NOT_FOUND': 'Licznik offline nie istnieje',
            'API.INVALID_OFFLINE_METER_VALUE': 'Nieprawidłowa wartość licznika offline',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Zmienna licznika offline nie istnieje',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Stare hasło nie może przekraczać 100 znaków',
            'API.PARENT_SPACE_NOT_FOUND': 'Przestrzeń nadrzędna nie istnieje',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Hasło nie może przekraczać 100 znaków',
            'API.PASSWORDS_MATCH': 'Nowe hasło jest takie samo jak stare',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nazwa punktu danych jest już w użyciu',
            'API.POINT_NOT_FOUND': 'Punkt danych nie istnieje',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nazwa uprawnienia jest już w użyciu',
            'API.PRIVILEGE_NOT_FOUND': 'Uprawnienie nie istnieje',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nazwa reguły jest już w użyciu',
            'API.RULE_NOT_FOUND': 'Reguła nie istnieje',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nazwa czujnika jest już w użyciu',
            'API.SENSOR_NOT_FOUND': 'Czujnik nie istnieje',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Relacja między czujnikiem a punktem danych już istnieje',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relacja między czujnikiem a punktem danych nie istnieje',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relacja między halą produkcyjną a urządzeniem już istnieje',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a urządzeniem nie istnieje',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relacja między halą produkcyjną a licznikiem już istnieje',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a licznikiem nie istnieje',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nazwa hali produkcyjnej jest już w użyciu',
            'API.SHOPFLOOR_NOT_FOUND': 'Hala produkcyjna nie istnieje',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relacja między halą produkcyjną a licznikiem offline już istnieje',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a licznikiem offline nie istnieje',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relacja między halą produkcyjną a punktem danych już istnieje',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a punktem danych nie istnieje',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relacja między halą produkcyjną a czujnikiem już istnieje',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a czujnikiem nie istnieje',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między halą produkcyjną a licznikiem wirtualnym już istnieje',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a licznikiem wirtualnym nie istnieje',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między halą produkcyjną a kalendarzem roboczym już istnieje',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między halą produkcyjną a kalendarzem roboczym nie istnieje',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'Węzeł źródłowy nie istnieje',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relacja między przestrzenią a urządzeniem zespolonym już istnieje',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a urządzeniem zespolonym nie istnieje',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relacja między przestrzenią a urządzeniem już istnieje',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a urządzeniem nie istnieje',
            'API.SPACE_METER_RELATION_EXISTS': 'Relacja między przestrzenią a licznikiem już istnieje',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Relacja między przestrzenią a licznikiem nie istnieje',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nazwa przestrzeni jest już w użyciu',
            'API.SPACE_NOT_FOUND': 'Przestrzeń nie istnieje',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Przestrzeń nie istnieje w uprawnieniach',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relacja między przestrzenią a licznikiem offline już istnieje',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między przestrzenią a licznikiem offline nie istnieje',
            'API.SPACE_POINT_RELATION_EXISTS': 'Relacja między przestrzenią a punktem danych już istnieje',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a punktem danych nie istnieje',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Relacja między przestrzenią a czujnikiem już istnieje',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relacja między przestrzenią a czujnikiem nie istnieje',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relacja między przestrzenią a halą produkcyjną już istnieje',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relacja między przestrzenią a halą produkcyjną nie istnieje',
            'API.SPACE_STORE_RELATION_EXISTS': 'Relacja między przestrzenią a sklepem już istnieje',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relacja między przestrzenią a sklepem nie istnieje',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Relacja między przestrzenią a najemcą już istnieje',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relacja między przestrzenią a najemcą nie istnieje',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między przestrzenią a licznikiem wirtualnym już istnieje',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między przestrzenią a licznikiem wirtualnym nie istnieje',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między przestrzenią a kalendarzem roboczym już istnieje',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między przestrzenią a kalendarzem roboczym nie istnieje',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Data i czas rozpoczęcia muszą być wcześniejsze niż zakończenia',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': 'Relacja między sklepem a licznikiem już istnieje',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Relacja między sklepem a licznikiem nie istnieje',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Nazwa sklepu jest już w użyciu',
            'API.STORE_NOT_FOUND': 'Sklep nie istnieje',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relacja między sklepem a licznikiem offline już istnieje',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między sklepem a licznikiem offline nie istnieje',
            'API.STORE_POINT_RELATION_EXISTS': 'Relacja między sklepem a punktem danych już istnieje',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Relacja między sklepem a punktem danych nie istnieje',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Relacja między sklepem a czujnikiem już istnieje',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Relacja między sklepem a czujnikiem nie istnieje',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Nazwa typu sklepu jest już w użyciu',
            'API.STORE_TYPE_NOT_FOUND': 'Typ sklepu nie istnieje',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Uproszczony kod typu sklepu jest już w użyciu',
            'API.STORE_TYPE_USED_IN_STORE': 'Typ sklepu jest już używany w sklepie',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między sklepem a licznikiem wirtualnym już istnieje',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między sklepem a licznikiem wirtualnym nie istnieje',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między sklepem a kalendarzem roboczym już istnieje',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między sklepem a kalendarzem roboczym nie istnieje',
            'API.TARGET_NODE_NOT_FOUND': 'Węzeł docelowy nie istnieje',
            'API.TARIFF_IN_USE': 'Taryfa jest w użyciu',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Taryfa i centrum kosztów są już powiązane',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Taryfa i centrum kosztów nie są powiązane',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nazwa taryfy jest już w użyciu',
            'API.TARIFF_NOT_FOUND': 'Taryfa nie istnieje',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'Relacja między najemcą a licznikiem już istnieje',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Relacja między najemcą a licznikiem nie istnieje',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nazwa najemcy jest już w użyciu',
            'API.TENANT_NOT_FOUND': 'Najemca nie istnieje',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relacja między najemcą a licznikiem offline już istnieje',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relacja między najemcą a licznikiem offline nie istnieje',
            'API.TENANT_POINT_RELATION_EXISTS': 'Relacja między najemcą a punktem danych już istnieje',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relacja między najemcą a punktem danych nie istnieje',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Relacja między najemcą a czujnikiem już istnieje',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Relacja między najemcą a czujnikiem nie istnieje',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nazwa typu najemcy jest już w użyciu',
            'API.TENANT_TYPE_NOT_FOUND': 'Typ najemcy nie istnieje',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Uproszczony kod typu najemcy jest już w użyciu',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Typ najemcy jest już używany u najemcy',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relacja między najemcą a licznikiem wirtualnym już istnieje',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relacja między najemcą a licznikiem wirtualnym nie istnieje',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Relacja między najemcą a kalendarzem roboczym już istnieje',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relacja między najemcą a kalendarzem roboczym nie istnieje',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Nie znaleziono wiadomości SMS',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Okres raportowania musi być dłuższy niż 15 minut',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Istnieje relacja z podlicznikami',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Istnieje relacja z przestrzeniami podrzędnymi',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Istnieje relacja z parametrami urządzeń zespolonych',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Istnieje relacja z urządzeniami zespolonymi',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Istnieje relacja ze źródłami danych',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Istnieje relacja ze schematami przepływu energii',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Istnieje relacja z bateriami kontenerów magazynowania energii',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Istnieje relacja z sieciami elektroenergetycznymi kontenerów magazynowania energii',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Istnieje relacja z obciążeniami kontenerów magazynowania energii',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Istnieje relacja z systemami konwersji mocy (PCS) kontenerów magazynowania energii',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Istnieje relacja z parametrami urządzeń',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Istnieje relacja z urządzeniami',
            'API.THERE_IS_RELATION_WITH_METER': 'Istnieje relacja z licznikiem',
            'API.THERE_IS_RELATION_WITH_METERS': 'Istnieje relacja z wieloma licznikami',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Istnieje relacja z licznikiem offline',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Istnieje relacja z wieloma licznikami offline',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Istnieje relacja z licznikami wirtualnymi',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'Istnieje relacja z czujnikami',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Istnieje relacja z halami produkcyjnymi',
            'API.THERE_IS_RELATION_WITH_SPACES': 'Istnieje relacja z przestrzeniami',
            'API.THERE_IS_RELATION_WITH_STORES': 'Istnieje relacja ze sklepami',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'Istnieje relacja z najemcami',
            'API.THERE_IS_RELATION_WITH_USERS': 'Istnieje relacja z użytkownikami',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Istnieje relacja z licznikiem wirtualnym',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Istnieje relacja z wirtualnymi elektrowniami',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'To źródło danych jest używane przez licznik',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Ten licznik jest używany przez licznik wirtualny',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Ten licznik offline jest używany przez licznik wirtualny',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'Przestrzeni nie można sklonować',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'Przestrzeni nie można usunąć',
            'API.TIMEZONE_NOT_FOUND': 'Strefa czasowa nie istnieje',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Nie znaleziono tokenu, zaloguj się',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Konto użytkownika zostało zablokowane',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'Konto użytkownika wygasło',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'Nazwa użytkownika jest już w użyciu',
            'API.USER_NOT_FOUND': 'Użytkownik nie istnieje',
            'API.USER_PASSWORD_HAS_EXPIRED': 'Hasło użytkownika wygasło',
            'API.USER_PRIVILEGE_NOT_FOUND': 'Nie znaleziono uprawnień użytkownika',
            'API.USER_SESSION_NOT_FOUND': 'Nie znaleziono sesji użytkownika',
            'API.USER_SESSION_TIMEOUT': 'Sesja użytkownika wygasła',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID użytkownika nie istnieje, zaloguj się',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nazwa licznika wirtualnego jest już w użyciu',
            'API.VIRTUAL_METER_NOT_FOUND': 'Licznik wirtualny nie istnieje',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Licznik wirtualny zmiennej nie istnieje',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Punkt danych wirtualnych powinien być wartością analogową',
            'API.WEB_MESSAGE_NOT_FOUND': 'Wiadomość web nie istnieje',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Wiadomość WeChat nie istnieje',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nazwa kalendarza roboczego jest już w użyciu',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Kalendarz roboczy nie istnieje',

            MasterMeter: 'Licznik główny',
            SubMeter: 'Podlicznik',
            'Power Quality': 'Jakość energii elektrycznej',
            'About Power Quality': 'O jakości energii elektrycznej',
            'Trend Values': 'Wartości trendu',
            Category: 'Kategoria',
            Type: 'Typ',
            Unit: 'Jednostka',
            Limit: 'Limit',
            'Normal Limit': 'Limit normalny',
            'Severe Limit': 'Limit poważny',
            Compliance: 'Wskaźnik zgodności',
            'Worst Deviation': 'Najgorsze odchylenie',
            'Worst Time': 'Czas najgorszego',
            'Severe Exceed Count': 'Liczba poważnych przekroczeń',
            'Worst Unbalance': 'Maksymalna niezrównoważenie',
            Hz: 'Hz',
            voltage: 'napięcie',
            current: 'prąd',
            frequency: 'częstotliwość',
            voltage_deviation: 'odchylenie napięcia',
            current_unbalance: 'niezrównoważenie prądu',
            voltage_unbalance: 'niezrównoważenie napięcia',
            mean_deviation_pct: 'średnie odchylenie (%)',
            p95_abs_deviation_pct: 'P95 odchylenie bezwzględne (%)',
            mean_abs_deviation_hz: 'średnie odchylenie bezwzględne (Hz)',
            frequency_deviation: 'odchylenie częstotliwości',
            p95_abs_deviation_hz: 'P95 odchylenie bezwzględne (Hz)',
            mean_unbalance_pct: 'średnie niezrównoważenie (%)',
            p95_unbalance_pct: 'P95 niezrównoważenie (%)',
            count: 'liczba',
            min: 'minimum',
            max: 'maksimum',
            mean: 'średnia',
            std: 'odchylenie standardowe',
            p5: 'P5',
            p95: 'P95'
        }
    },
    nl: {
        translation: {
            // routes & menus
            Dashboard: 'Dashboard',
            'Space Data': 'Ruimtegegevens',
            'Equipment Data': 'Apparatuurgegevens',
            'Meter Data': 'Meetgegevens',
            'Tenant Data': 'Huurdergegevens',
            'Store Data': 'Winkelgegevens',
            'Shopfloor Data': 'Werkvloergegevens',
            'Combined Equipment Data': 'Gecombineerde Apparatuurgegevens',
            'Auxiliary System': 'Hulpsysteem',
            Microgrid: 'Microgrid',
            'Energy Storage Power Station': 'Energieopslagcentrale',
            'Photovoltaic Power Station': 'Fotovoltaïsche centrale',
            'Fault Alarm': 'Foutalarm',
            Monitoring: 'Apparatuurmonitoring',
            'Advanced Reporting': 'Geavanceerde rapportage',
            'Knowledge Base': 'Kennisbank',
            'Energy Category Data': 'Energiecategorie-analyse',
            'Energy Item Data': 'Energieonderdeel-analyse',
            Carbon: 'CO2-uitstootanalyse',
            Cost: 'Kostenanalyse',
            Output: 'Outputanalyse',
            Income: 'Inkomstenanalyse',
            Efficiency: 'Efficiëntieanalyse',
            Load: 'Belastingsanalyse',
            Statistics: 'Statistische analyse',
            'Batch Analysis': 'Batchanalyse',
            Saving: 'Energiebesparingsanalyse',
            Plan: 'Planningsanalyse',
            Prediction: 'Voorspellingsanalyse',
            'Production': 'Productie',
            'Space Production': 'Productie-energieverbruiksanalyse',
            'Equipment Tracking': 'Apparatuurlogboek',
            'Equipment Comparison': 'Vergelijkende analyse',
            'Shopfloor Comparison': 'Vergelijkende analyse',
            'Store Comparison': 'Vergelijkende analyse',
            'Space Comparison': 'Vergelijkende analyse',
            'Combined Equipment Comparison': 'Vergelijkende analyse',
            'Tenant Comparison': 'Vergelijkende analyse',
            'Environment Monitor': 'Omgevingsmonitoring',
            'Meter Energy': 'Meetmeter energieverbruiksanalyse',
            'Meter Carbon': 'Meetmeter CO2-uitstootanalyse',
            'Meter Cost': 'Meetmeter kostenanalyse',
            'Meter Trend': 'Meetmeter trendanalyse',
            'Meter Realtime': 'Meetmeter realtime-analyse',
            'Meter Saving': 'Meetmeter energiebesparingsanalyse',
            'Meter Plan': 'Meetmeter planningsanalyse',
            'Master Meter Submeters Balance': 'Hoofd-/submeters balansanalyse',
            'Meter Batch Analysis': 'Meetmeter batchanalyse',
            'Meter Comparison': 'Meetmeter vergelijkende analyse',
            'Meter Tracking': 'Meetmeter logboek',
            'Virtual Meter Saving': 'Virtuele meter energiebesparingsanalyse',
            'Virtual Meter Plan': 'Virtuele meter planningsanalyse',
            'Virtual Meter Energy': 'Virtuele meter energieverbruiksanalyse',
            'Virtual Meter Carbon': 'Virtuele meter CO2-uitstootanalyse',
            'Virtual Meter Cost': 'Virtuele meter kostenanalyse',
            'Virtual Meter Batch Analysis': 'Virtuele meter batchanalyse',
            'Virtual Meter Comparison': 'Virtuele meter vergelijkende analyse',
            'Offline Meter Energy': 'Offline meter energieverbruiksanalyse',
            'Offline Meter Carbon': 'Offline meter CO2-uitstootanalyse',
            'Offline Meter Cost': 'Offline meter kostenanalyse',
            'Offline Meter Batch Analysis': 'Offline meter batchanalyse',
            'Offline Meter Saving': 'Offline meter energiebesparingsanalyse',
            'Offline Meter Plan': 'Offline meter planningsanalyse',
            'Offline Meter Input': 'Offline meter gegevensinvoer',
            'Tenant Bill': 'Huurderrekening',
            'Energy Flow Diagram': 'Energieflowdiagram',
            'Distribution System': 'Distributiesysteem',
            'SVG System': 'Configuratie visualisatiesysteem',
            'Faults Data': 'Foutanalyse',
            'Space Equipments': 'Ruimteapparatuur',
            'Combined Equipments': 'Gecombineerde apparatuur',
            'Energy Storage Power Station List': 'Energieopslagcentrale lijst',
            'Energy Storage Power Station Details': 'Apparatuurmonitoring',
            'Energy Storage Power Station Reporting': 'Gegevensrapportage',
            'Energy Storage Power Station Alarm': 'Foutalarm',
            'Energy Storage Power Station Maintenance': 'Onderhoud',
            'Enter Production': 'Productie-invoer',
            'Multiple Microgrids': 'Meerdere microgrids',
            'Multiple Microgrids Dashboard': 'Meerdere microgrids dashboard',
            'Multiple Microgrids List': 'Microgrid lijst',
            'Single Microgrid': 'Enkele microgrid',
            'Single Microgrid Dashboard': 'Enkele microgrid dashboard',
            'Single Microgrid Details': 'Apparatuurgegevens',
            'Single Microgrid Fault Alarm': 'Foutmelding',
            'Microgrid Reports': 'Statistische rapportage',
            'Microgrid Reports Energy': 'Energierapport',
            'Microgrid Reports Revenue': 'Inkomstenrapport',
            'Microgrid Reports Parameters': 'Gegevensquery',
            'Multiple Energy Storage Power Stations': 'Meerdere energieopslagcentrales',
            'Multiple Energy Storage Power Stations Dashboard': 'Meerdere energieopslagcentrales dashboard',
            'Multiple Energy Storage Power Stations List': 'Energieopslagcentrale lijst',
            'Single Energy Storage Power Station': 'Enkele energieopslagcentrale',
            'Single Energy Storage Power Station Dashboard': 'Enkele energieopslagcentrale dashboard',
            'Single Energy Storage Power Station Details': 'Energieopslagapparatuurgegevens',
            'Single Energy Storage Power Station Fault Alarm': 'Energieopslag foutmelding',
            'Energy Storage Power Station Reports': 'Energieopslag statistische rapportage',
            'Energy Storage Power Station Reports Energy': 'Energieopslag energierapport',
            'Energy Storage Power Station Reports Revenue': 'Energieopslag inkomstenrapport',
            'Energy Storage Power Station Reports Parameters': 'Energieopslag gegevensquery',
            'Multiple Energy Storage Power Stations': 'Meerdere energieopslagcentrales',
            'Multiple Energy Storage Power Stations Dashboard': 'Meerdere energieopslagcentrales dashboard',
            'Multiple Energy Storage Power Stations List': 'Energieopslagcentrale lijst',
            'Single Energy Storage Power Station': 'Enkele energieopslagcentrale',
            'Single Energy Storage Power Station Dashboard': 'Enkele energieopslagcentrale dashboard',
            'Single Energy Storage Power Station Details': 'Apparatuurgegevens',
            'Single Energy Storage Power Station Fault Alarm': 'Foutmelding',
            'Energy Storage Power Station Reports': 'Statistische rapportage',
            'Energy Storage Power Station Reports Energy': 'Energierapport',
            'Energy Storage Power Station Reports Revenue': 'Inkomstenrapport',
            'Energy Storage Power Station Reports Parameters': 'Gegevensquery',
            'Photovoltaic Power Station List': 'Fotovoltaïsche centrale lijst',
            'Photovoltaic Power Station Details': 'Apparatuurmonitoring',
            'Photovoltaic Power Station Reporting': 'Gegevensrapportage',
            'Photovoltaic Power Station Alarm': 'Foutalarm',
            'Photovoltaic Power Station Maintenance': 'Onderhoud',
            'Multiple Photovoltaic Power Stations': 'Meerdere fotovoltaïsche centrales',
            'Multiple Photovoltaic Power Stations Dashboard': 'Meerdere fotovoltaïsche centrales dashboard',
            'Multiple Photovoltaic Power Stations List': 'Fotovoltaïsche centrale lijst',
            'Single Photovoltaic Power Station': 'Enkele fotovoltaïsche centrale',
            'Single Photovoltaic Power Station Dashboard': 'Enkele fotovoltaïsche centrale dashboard',
            'Single Photovoltaic Power Station Details': 'Apparatuurgegevens',
            'Single Photovoltaic Power Station Fault Alarm': 'Foutmelding',
            'Photovoltaic Power Station Reports': 'Statistische rapportage',
            'Photovoltaic Power Station Reports Energy': 'Energierapport',
            'Photovoltaic Power Station Reports Revenue': 'Inkomstenrapport',
            'Photovoltaic Power Station Reports Parameters': 'Gegevensquery',
            'Work Order': 'Werkorderbeheer',
            'Work Order Installation': 'Installatierecord',
            'Work Order Repair': 'Reparatierecord',
            'Work Order Inspection': 'Inspectierecord',
            'Total Number of Work Orders': 'Totaal aantal werkorders',
            'Number of New Work Orders': 'Aantal nieuwe werkorders',
            'Number of Inprogress Work Orders': 'Aantal lopende werkorders',
            'Number of Done Work Orders': 'Aantal voltooide werkorders',
            'Fuel Indicator': 'Brandstofverbruik',
            'Charge Energy Indicator': 'Oplaadenergie',
            'Discharge Energy Indicator': 'Ontlaadenergie',
            'Charge Cost Indicator': 'Oplaadkosten',
            'Discharge Revenue Indicator': 'Ontlaadinkomsten',
            'HVAC': 'Airconditioning',
            'Fire Control': 'Brandbeveiliging',

            // Dashboard
            'Welcome to MyEMS': 'Welkom bij MyEMS',
            'An Industry Leading Open Source Energy Management System': 'Een toonaangevend open source energiebeheersysteem',
            "This Year's Consumption CATEGORY VALUE UNIT": 'Jaarverbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'Jaarkosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'Maandverbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": 'Maandopwekking {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Costs CATEGORY VALUE UNIT": 'Maandkosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'Verbruik zelfde periode vorig jaar {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'Kosten zelfde periode vorig jaar {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} verbruik {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} kosten {{UNIT}}',
            // Entities
            Space: 'Ruimte',
            Equipment: 'Apparatuur',
            Meter: 'Meetmeter',
            'Offline Meter': 'Offline meter',
            'Virtual Meter': 'Virtuele meter',
            Tenant: 'Huurder',
            Store: 'Winkel',
            Shopfloor: 'Werkvloer',
            'Combined Equipment': 'Gecombineerde apparatuur',
            'Cost Center': 'Kostenplaats',
            Name: 'Naam',
            DisplayName: 'Weergavenaam',
            UserName: 'Gebruikersnaam',
            Description: 'Beschrijving',
            'Energy Category': 'Energiecategorie',
            'Child Spaces': 'Onderliggende ruimtes',
            'Associated Equipment': 'Gerelateerde apparatuur',
            //Energy Categories
            Electricity: 'Elektriciteit',
            Water: 'Kraanwater',
            'Natural Gas': 'Aardgas',
            // SidePanelModal
            Settings: 'Instellingen',
            'Set your own customized style': 'Stel uw eigen aangepaste stijl in',
            'Color Scheme': 'Kleurenschema',
            'Choose the perfect color mode for your app': 'Kies de perfecte kleurmodus voor uw app',
            Light: 'Licht',
            Dark: 'Donker',
            'RTL Mode': 'RTL-modus',
            'Switch your language direction': 'Verander uw taalrichting',
            'Fluid Layout': 'Vloeiende layout',
            'Toggle container layout system': 'Wissel containerlayout systeem',
            'Navigation Position': 'Navigatiepositie',
            'Vertical': 'Verticaal',
            'Top': 'Boven',
            'Combo': 'Combinatie',
            'Transparent': 'Transparant',
            'Inverted': 'Ingekeerd',
            'Card': 'Kaart',
            'Vibrant': 'Levendig',
            'Select a suitable navigation system for your web application': 'Selecteer een geschikt navigatiesysteem voor uw webapplicatie',
            'Vertical Nav': 'Verticale navigatie',
            'Top Nav': 'Bovenste navigatie',
            'Vertical Navbar Style': 'Verticale navigatiebalk stijl',
            'Switch between styles for your vertical navbar': 'Wissel tussen stijlen voor uw verticale navigatiebalk',
            Language: 'Taal',
            'Switch between languages': 'Wissel tussen talen',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Vindt u dit systeem leuk?',
            'Get MyEMS now': 'Download MyEMS nu',
            'PQ.About': 'Deze analyse omvat spanningsafwijking, spanningsonbalans, frequentieafwijking en stroomonbalans. Spanningsafwijking berekend als (U−Un)/Un×100%; frequentieafwijking als |f−fn|; driefasige onbalans als max(|Xi−Xavg|)/Xavg×100%, vereist tijdsynchronisatie van driefasige kanalen. Resultaten gebaseerd op tijdreeksen van geselecteerde meetmeters in rapportageperiode. Bij ontbrekende driefasige kanalen of niet-gesynchroniseerde tijdstempels worden onbalansindicatoren overgeslagen. Transiënte pieken of ontbrekende samples kunnen slechtste waarde vergroten; voor steady-state evaluatie wordt verwezen naar statistische indicatoren zoals compliantiepercentage en P95.',
            Purchase: 'Koop Enterprise Editie',
            ContactInfo: 'Contactinformatie',
            ProductWebsite: 'Productwebsite',
            CompanyWebsite: 'Bedrijfswebsite',
            SalesPhone: 'Verkooptelefoon',
            // Query Panels
            'Base Period Begins': 'Basisperiode start',
            'Base Period Ends': 'Basisperiode einde',
            'Comparison Types': 'Vergelijkingstypes',
            'Year-Over-Year': 'Jaar-op-jaar',
            'Month-On-Month': 'Maand-op-maand',
            'Free Comparison': 'Vrije vergelijking',
            'None Comparison': 'Geen vergelijking',
            'Reporting Period Begins': 'Rapportageperiode start',
            'Reporting Period Ends': 'Rapportageperiode einde',
            '(Optional)': '(Optioneel)',
            'Period Types': 'Tijdsschaal',
            Yearly: 'Jaar',
            Monthly: 'Maand',
            Weekly: 'Week',
            Daily: 'Dag',
            Hourly: 'Uur',
            Submit: 'Indienen',
            'Input Energy Category': 'Verbruikte energiecategorie',
            'Output Energy Category': 'Geproduceerde energiecategorie',
            'Fraction Parameter': 'Breukparameter',
            Search: 'Zoeken',
            //DateRangePicker
            sunday: 'Zo',
            monday: 'Ma',
            tuesday: 'Di',
            wednesday: 'Wo',
            thursday: 'Do',
            friday: 'Vr',
            saturday: 'Za',
            ok: 'OK',
            today: 'Vandaag',
            yesterday: 'Gisteren',
            hours: 'Uur',
            minutes: 'Minuut',
            seconds: 'Seconde',
            last7Days: 'Laatste 7 dagen',
            'Select Date Range': 'Selecteer datumbereik',
            //Card Summaries and Line Charts
            'Base Period': 'Basisperiode',
            'Reporting Period': 'Rapportageperiode',
            'Per Unit Area': 'Waarde per eenheid oppervlakte',
            'Per Capita': 'Waarde per persoon',
            'Per Unit Production': 'Waarde per eenheid product',
            Baseline: 'Baseline waarde',
            Actual: 'Werkelijke waarde',
            'Baseline Value - Actual Value': 'Baseline waarde - Werkelijke waarde',
            'Average Load': 'Gemiddelde belasting',
            'Maximum Load': 'Maximale belasting',
            'Load Factor': 'Belastingsfactor',
            'Ratio of Average Load to Maximum Load': 'Verhouding gemiddelde belasting tot maximale belasting',
            'Carbon Dioxide Emissions by Energy Category': 'CO2-uitstoot aandeel per energiecategorie',
            'Costs by Energy Category': 'Kostenaandeel per energiecategorie',
            'Incomes by Energy Category': 'Inkomensaandeel per energiecategorie',
            'Electricity Consumption by Time-Of-Use': 'Elektriciteitsverbruik per tijd-van-dag',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'CO2-uitstoot elektriciteit per tijd-van-dag',
            'Electricity Cost by Time-Of-Use': 'Elektriciteitskosten per tijd-van-dag',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} verbruiksaandeel per energieonderdeel',
            'Ton of Standard Coal by Energy Category': 'Ton standaardkool (TCE) aandeel per energiecategorie',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Ton CO2-uitstoot (TCO2E) aandeel per energiecategorie',
            'Reporting Period Consumption CATEGORY UNIT': 'Rapportageperiode verbruik {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Rapportageperiode voorspelling {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} rapportageperiode verbruik {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} rapportageperiode verbruik {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Rapportageperiode productie {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Basisperiode productie {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Rapportageperiode verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Rapportageperiode voorspelling {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Basisperiode verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Rapportageperiode voorspelling {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Rapportageperiode verbruik {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'Rapportageperiode verbruik {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Basisperiode verbruik {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Onderliggende ruimte categorie aandeel {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Onderliggende ruimte totaal aandeel',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'Rapportageperiode CO2-uitstoot {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Rapportageperiode CO2-uitstoot {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'Basisperiode CO2-uitstoot {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Rapportageperiode kosten {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Rapportageperiode kosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Basisperiode kosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Rapportageperiode output {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} rapportageperiode output {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} rapportageperiode output {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Rapportageperiode output {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Basisperiode output {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Rapportageperiode inkomsten {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Rapportageperiode inkomsten {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Basisperiode inkomsten {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Rapportageperiode totale inkomsten {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Rapportageperiode cumulatieve efficiëntie {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} rapportageperiode cumulatieve efficiëntie {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} rapportageperiode cumulatieve algehele efficiëntie {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} rapportageperiode cumulatieve algehele efficiëntie {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} basisperiode cumulatieve algehele efficiëntie {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Momentane efficiëntie {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} momentane efficiëntie {{UNIT}}',
            'Equipment Efficiency Indicator': 'Indicator voor energie-efficiëntie van apparatuur',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} momentane algehele efficiëntie {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Rapportageperiode cumulatieve efficiëntie {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'Rapportageperiode cumulatieve efficiëntie {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Basisperiode cumulatieve efficiëntie {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Basisperiode cumulatieve efficiëntie {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Basisperiode {{CATEGORY}} maximale belasting {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Rapportageperiode {{CATEGORY}} maximale belasting {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Rapportageperiode {{CATEGORY}} gemiddelde belasting {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Rapportageperiode {{CATEGORY}} belastingsfactor',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Basisperiode {{CATEGORY}} gemiddelde belasting {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Rapportageperiode {{CATEGORY}} gemiddelde {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Rapportageperiode {{CATEGORY}} maximum {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Rapportageperiode {{CATEGORY}} minimum {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Rapportageperiode {{CATEGORY}} rekenkundig gemiddelde {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Rapportageperiode {{CATEGORY}} mediaan {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Rapportageperiode {{CATEGORY}} steekproef standaardafwijking {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Rapportageperiode {{CATEGORY}} steekproef variantie {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'Rapportageperiode besparing {{CATEGORY}} (baseline - werkelijk) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'Rapportageperiode reductie {{CATEGORY}} (baseline - werkelijk) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Rapportageperiode besparing {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Basisperiode besparing {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': 'Rapportageperiode hoofdmeter verbruik {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'Rapportageperiode hoofdmeter verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': 'Rapportageperiode submeters verbruik {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'Rapportageperiode submeters verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Rapportageperiode verschil {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Rapportageperiode verschilpercentage',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Rapportageperiode verschil {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Trendwaarden',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Foutenlijst',
            'Reporting Period Number of Fault VALUE': 'Rapportageperiode foutaantal: {{VALUE}}',
            'All Faults': 'Alle fouten',
            'Space Faults': 'Ruimtefouten',
            'Number of All Faults': 'Totaal foutaantal',
            'Number of Space Faults': 'Ruimte foutaantal',
            'Total Number of Faults': 'Totaal aantal fouten',
            'Number of New Faults': 'Aantal nieuwe fouten',
            'Number of Inprogress Faults': 'Aantal lopende fouten',
            'Number of Done Faults': 'Aantal voltooide fouten',
            //Data Panels
            'Ton of Standard Coal': 'Ton standaardkool',
            'Ton of Carbon Dioxide Emissions': 'Ton CO2-uitstoot',
            'Carbon Emissions Per Unit Of Energy Consumption': 'CO2-uitstoot per energieverbruikseenheid',
            'Operating Characteristic Curve': 'Bedrijfskenmerkcurve',
            Tariff: 'Tarief',
            'Detailed Data': 'Gedetailleerde gegevens',
            'Child Spaces Data': 'Onderliggende ruimtegegevens',
            'Associated Equipment Data': 'Gerelateerde apparatuurgegevens',
            'This Year': 'Dit jaar',
            'The Same Period Last Year': 'Zelfde periode vorig jaar',
            'This Month': 'Deze maand',
            'This Day': 'Vandaag',
            Total: 'Totaal',
            'No data found': 'Geen gegevens gevonden',
            Export: 'Exporteren',
            Datetime: 'Datumtijd',
            'Time-Of-Use Type': 'Tijd-van-dag type',
            'Top-Peak': 'Piek',
            'On-Peak': 'Hoog',
            'Mid-Peak': 'Normaal',
            'Off-Peak': 'Dal',
            'Deep': 'Diep dal',
            Percentage: 'Percentage',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Trend laatste uur van energie waardepunt',
            Circuit: 'Circuit',
            Point: 'Datapunt',
            'Realtime Value': 'Realtime waarde',
            //Meter Tracking
            'Meter List': 'Meetmeter lijst',
            'Edit Meter': 'Bewerken',
            'Start Value': 'Startwaarde',
            'End Value': 'Eindwaarde',
            'Difference Value': 'Verschilwaarde',
            'Start Integrity Rate': 'Start gegevensintegriteit (%)',
            'End Integrity Rate': 'Eind gegevensintegriteit (%)',
            'Full Integrity Rate': 'Volledige gegevensintegriteit (%)',
            //Equipment Tracking
            'Equipment List': 'Apparatuurlijst',
            'Edit Equipment': 'Bewerken',
            //Profile Dropdown
            Feedback: 'Feedback',
            'Account Settings': 'Accountinstellingen',
            Logout: 'Uitloggen',
            //Authentication
            'Log in': 'Inloggen',
            'Email address': 'E-mailadres',
            'Phone Number': 'Telefoonnummer',
            Password: 'Wachtwoord',
            CaptchaCode: 'Captcha',
            Refresh: 'Vernieuwen',
            'Remember me': 'Onthoud mij',
            'Logged in as ': 'Ingelogd als ',
            'Forgot Password?': 'Wachtwoord vergeten?',
            'Forgot your password?': 'Wachtwoord vergeten?',
            "Enter your email and we'll send you a reset link": 'Voer uw e-mailadres in en we sturen u een resetlink',
            "Enter your email and we'll send you a registration link": 'Voer uw e-mailadres in en we sturen u een registratielink',
            'Reset Password': 'Wachtwoord resetten',
            'Thanks for using MyEMS!': 'Bedankt voor het gebruiken van MyEMS!',
            'You are now successfully signed out': 'U bent succesvol uitgelogd',
            'Return to Login': 'Terug naar inloggen',
            'Please check your email!': 'Controleer uw e-mail!',
            'An email has been sent to ': 'Een e-mail is verzonden naar ',
            'Please click on the included link to reset your password': 'Klik op de bijgevoegde link om uw wachtwoord te resetten',
            'Please click on the included link to register your account': 'Klik op de bijgevoegde link om uw account te registreren',
            'An email with password reset link is sent to ': 'Een e-mail met wachtwoord resetlink is verzonden naar ',
            'Change Password': 'Wachtwoord wijzigen',
            'Old Password': 'Oud wachtwoord',
            'New Password': 'Nieuw wachtwoord',
            'Confirm Password': 'Herhaal nieuw wachtwoord',
            'Update Password': 'Wachtwoord bijwerken',
            'Password has been changed!': 'Wachtwoord is gewijzigd!',
            'Verification code has been sent to your inbox. \
            Please copy it to the input box below.':
                'Verificatiecode is naar uw inbox verzonden. Kopieer deze naar het onderstaande invoervak.',
            'New to MyEMS': 'Nieuw bij MyEMS',
            'Create an account': 'Account aanmaken',
            'EMAIL Account registration successful': '{{EMAIL}} accountregistratie succesvol',
            'Thanks for verifying your account!': 'Bedankt voor het verifiëren van uw account!',
            'Your code is': 'Uw code is',
            'Send verification code': 'Verificatiecode verzenden',
            'Please wait for NUMBER seconds': 'Wacht {{NUMBER}} seconden',
            'Password reset': 'Wachtwoord reset',
            'Please wait for approval': 'Wacht op goedkeuring',
            //notification
            Notifications: 'Notificaties',
            'Mark all as read': 'Alles als gelezen markeren',
            'View all': 'Alles bekijken',
            'Notification New': 'Nieuw',
            'Notification Earlier': 'Eerder',
            'Notification List': 'Notificatielijst',
            'Bulk actions': 'Bulkacties',
            'Notification Subject': 'Onderwerp',
            'Notification Created Datetime': 'Aanmaaktijd',
            'Notification Message': 'Inhoud',
            'Notification Priority': 'Prioriteit',
            'Notification Status': 'Status',
            'Notification Mark As Read': 'Markeren als gelezen',
            'Notification Mark As Acknowledged': 'Bevestigen',
            'Notification Low': 'Laag',
            'Notification Medium': 'Gemiddeld',
            'Notification High': 'Hoog',
            'Notification Critical': 'Kritiek',
            'Notification Unread': 'Ongelezen',
            'Notification Read': 'Gelezen',
            'Notification Acknowledged': 'Bevestigd',
            'Notification Archive': 'Archiveren',
            'Notification Delete': 'Verwijderen',
            'Notification Apply': 'Toepassen',
            'Notification Start Datetime': 'Starttijd',
            'Notification End Datetime': 'Eindtijd',
            'Notification Update Datetime': 'Bijwerkingstijd',
            //Monitoring
            'Run Commands': 'Opdrachten uitvoeren',
            'Pin Code': 'Pincode',
            'Unlock': 'Ontgrendelen',
            'Set Value': 'Waarde instellen',
            'Fault Alarms': 'Foutalarmen',
            'Instantaneous Efficiency VALUE UNIT': 'Momentane efficiëntie {{VALUE}} {{UNIT}}',
            'Communication Status': 'Communicatiestatus',
            'Communication Online': 'Online',
            'Communication Offline': 'Offline',
            'Equipment Status': 'Apparatuurstatus',
            'Equipment Running': 'Actief',
            'Equipment Stopped': 'Gestopt',
            'Show Up to': 'Aantal per pagina',
            All: 'Alle',
            'FROM - TO of TOTAL': 'Momenteel getoond {{FROM}} - {{TO}} Totaal {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Energie',
            'Microgrid Revenue': 'Inkomsten',
            'Microgrid Carbon': 'CO2-uitstoot',
            'Photovoltaic Generation': 'Fotovoltaïsche opwekking',
            'EV Charger Consumption': 'EV-laadpaal verbruik',
            'Load Consumption': 'Belasting verbruik',
            'Grid Buy': 'Energie kopen van net',
            'Grid Sell': 'Energie verkopen aan net',
            'EV Charger': 'EV-laadpaal',
            'Heat Pump': 'Warmtepomp',
            'Photovoltaic': 'Fotovoltaïsch',
            'PCS Run State': 'PCS bedrijfsstatus',
            'PCS Unknown': 'Onbekend',
            'PCS Initializing': 'Initialiseren',
            'PCS Standby': 'Stand-by',
            'PCS Shutdown': 'Uitgeschakeld',
            'PCS Fault': 'Fout',
            'PCS Running': 'Actief',
            'Battery Power': 'Batterijvermogen',
            'Photovoltaic Power': 'Fotovoltaïsch vermogen',
            'Grid Power': 'Netvermogen',
            'Load Power': 'Belastingsvermogen',
            Reporting: 'Gegevensrapportage',
            Maintenance: 'Onderhoud',
            'General Information': 'Algemene informatie',
            'Serial Number': 'Serienummer',
            Address: 'Adres',
            'Postal Code': 'Postcode',
            'Rated Capacity': 'Nominale capaciteit',
            'Rated Power': 'Nominaal vermogen',
            Latitude: 'Breedtegraad',
            Longitude: 'Lengtegraad',
            'Strategy Management': 'Strategiebeheer',
            'Charging Schedule': 'Oplaadschema',
            'Charge Start Time': 'Oplaad starttijd',
            'Charge End Time': 'Oplaad eindtijd',
            'Discharge Start Time': 'Ontlaad starttijd',
            'Discharge End Time': 'Ontlaad eindtijd',
            'Total Rated Power': 'Totaal nominaal vermogen',
            'Total Rated Capacity': 'Totaal nominale capaciteit',
            // Energy Indicator
            "Today's Charge": "Vandaag opgeladen",
            "Today's Discharge": "Vandaag ontladen",
            "Today's Generation": "Vandaag opgewekt",
            'Total Fuel Consumption': 'Totaal brandstofverbruik',
            'Total Charge': 'Totaal opgeladen',
            'Total Discharge': 'Totaal ontladen',
            'Total Generation': 'Totaal opgewekt',
            'Total Revenue': 'Totale inkomsten',
            'Total Photovoltaic Generation': 'Totaal fotovoltaïsch opgewekt',
            'Total EV Charger Consumption': 'EV-laadpaal totaal verbruik',
            'Total Load Consumption': 'Belasting totaal verbruik',
            'Total Grid Buy': 'Totaal gekocht van net',
            'Total Grid Sell': 'Totaal verkocht aan net',
            'Total Efficiency': 'Totale efficiëntie',
            'Discharge Achievement Rate': 'Ontlaadrealisatiepercentage',
            // Revenue Indicator
            "Today's Cost": "Kosten vandaag",
            "Today's Income": "Inkomsten vandaag",
            "Total Cost": "Totale kosten",
            "Total Income": "Totale inkomsten",
            "Today's Revenue": "Winst vandaag",

            'Revenue Ranking': 'Inkomstenranglijst',
            'Efficiency Ranking': 'Efficiëntieranglijst',
            'Charge Ranking': 'Oplaadranglijst',
            'Discharge Ranking': 'Ontlaadranglijst',
            'Number of Microgrids': 'Aantal microgrids',
            'Number of Power Stations': 'Aantal centrales',
            'Microgrid List': 'Microgrid lijst',
            'Select Microgrid': 'Selecteer microgrid',
            'Previous Page': 'Vorige pagina',
            'Next Page': 'Volgende pagina',
            '7 Days': '7 dagen',
            'Charge UNIT': 'Oplaad {{UNIT}}',
            'Discharge UNIT': 'Ontlaad {{UNIT}}',
            'Generation UNIT': 'Opwekking {{UNIT}}',
            'Energy Indicator': 'Energie',
            'Revenue Indicator': 'Inkomsten',
            'Carbon Indicator': 'CO2',

            // Energy Storage Power Station
            'Battery Operating State': 'Batterij bedrijfsstatus',
            'Battery State': 'Batterijstatus',
            'Battery Unknown': 'Onbekend',
            'Battery Stopped': 'Gestopt',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': 'Fout', // 1
            'Battery Warning': 'Waarschuwing', // 2
            'Battery Standby': 'Stand-by', // 3
            'Battery Prohibit DisCharging': 'Ontladen verboden', // 4
            'Battery Prohibit Charging': 'Opladen verboden', // 5
            'Battery Normal': 'Normaal', // 6
            'Battery Charging': 'Opladen', // 7
            'Battery Discharging': 'Ontladen', // 8
            'Battery Idle': 'Inactief', // 9
            'Phase of Lifecycle': 'Levenscyclusfase',
            'Use Phase': 'In gebruik',
            'Commissioning Phase': 'Inbedrijfstelling',
            'Commissioning Date': 'Ingebruikname datum',
            'Installation Phase': 'In aanbouw',
            'Device Status': 'Apparaatstatus',
            'Basic Information': 'Basisinformatie',
            'Gateway': 'Gateway',
            'Grid Meter': 'Netmeetmeter',
            'Load Meter': 'Belastingmeetmeter',
            'ESS Meter': 'Energieopslagmeetmeter',
            'Total Active Power': 'Totaal actief vermogen',
            'Active Power A': 'Fase A actief vermogen',
            'Active Power B': 'Fase B actief vermogen',
            'Active Power C': 'Fase C actief vermogen',
            'Total Reactive Power': 'Totaal reactief vermogen',
            'Reactive Power A': 'Fase A reactief vermogen',
            'Reactive Power B': 'Fase B reactief vermogen',
            'Reactive Power C': 'Fase C reactief vermogen',
            'Total Apparent Power': 'Totaal schijnbaar vermogen',
            'Apparent Power A': 'Fase A schijnbaar vermogen',
            'Apparent Power B': 'Fase B schijnbaar vermogen',
            'Apparent Power C': 'Fase C schijnbaar vermogen',
            'Total Power Factor': 'Totale arbeidsfactor',
            'Active Energy Import': 'Actieve energie import',
            'Active Energy Export': 'Actieve energie export',
            'Active Energy Net': 'Netto actieve energie',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'Omvormer',
            'Invertor Run State': 'Omvormer bedrijfsstatus',
            'Invertor Unknown': 'Onbekend',
            'Invertor Initializing': 'Initialiseren',
            'Invertor Standby': 'Stand-by',
            'Invertor Shutdown': 'Uitgeschakeld',
            'Invertor Fault': 'Fout',
            'Invertor Running': 'Actief',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': 'Aanmaaktijd',
            'File Format': 'Bestandsformaat',
            'File Size': 'Bestandsgrootte',
            Uploader: 'Uploader',
            'Upload Datetime': 'Uploadtijd',
            //Error
            "The page you're looking for is not found": 'De pagina die u zoekt bestaat niet',
            "Make sure the address is correct and that the page hasn't moved": 'Controleer of het adres correct is en de pagina niet verplaatst is',
            'If you think this is a mistake,': 'Als u denkt dat dit een fout is,',
            'contact us': 'neem contact met ons op',
            'Take me home': 'Terug naar startpagina',
            'Whoops, something went wrong!': 'Oeps, er is iets misgegaan!',
            'Try refreshing the page, or going back and attempting the action again':
                'Probeer de pagina te vernieuwen, of ga terug en probeer de actie opnieuw',
            'If this problem persists,': 'Als dit probleem aanhoudt,',
            'Captcha Error': 'Captcha fout',
            'Confirm Password Error': 'Wachtwoorden komen niet overeen',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Het lijkt erop dat u op een ongeldige wachtwoord resetlink heeft geklikt. Probeer het opnieuw.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Het lijkt erop dat u op een ongeldige accountregistratielink heeft geklikt. Probeer het opnieuw.',
            //Tenant Bill
            'Lease Contract Number': 'Huurcontractnummer',
            Download: 'Downloaden',
            Print: 'Afdrukken',
            'Payment Notice': 'Betalingsnotificatie',
            'Bill To': 'Aan',
            'Bill Number': 'Rekeningnummer',
            'Bill Date': 'Rekeningdatum',
            'Payment Due Date': 'Vervaldatum betaling',
            'Amount Payable': 'Te betalen bedrag',
            'Billing Period Start': 'Factureringsperiode start',
            'Billing Period End': 'Factureringsperiode einde',
            Quantity: 'Hoeveelheid',
            Price: 'Prijs',
            Unit: 'Eenheid',
            Amount: 'Bedrag',
            Subtotal: 'Subtotaal',
            'VAT Output Tax': 'BTW afdracht',
            'Total Amount Payable': 'Totaal te betalen bedrag',
            'Please make sure to pay on or before the payment due date above': 'Zorg ervoor dat u betaalt op of vóór bovenstaande vervaldatum',
            'Send money to the following account': 'Stort geld op de volgende rekening',
            'Account Name': 'Rekeninghouder',
            'Bank Name': 'Banknaam',
            'Bank Address': 'Bankadres',
            'RMB Account': 'RMB rekening',
            // button
            'Toggle Navigation': 'Navigatie in-/uitschakelen',
            // working calendar
            'Working Days': 'Werkdagen',
            'Non Working Days': 'Niet-werkdagen',
            'Select Row': 'Selecteer een rij om te bewerken',
            // Offline Meter Input
            'Daily Value': 'Dagelijkse waarde',
            Date: 'Datum',
            'Successfully Saved': 'Succesvol opgeslagen',
            'Previous Data Is Empty': 'Vorige gegevens zijn leeg',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account ontgrendelen mislukt',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Beheerderssessie bestaat niet',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Beheerderssessie is verlopen',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Geavanceerd rapport bestaat niet',
            'API.API_KEY_HAS_EXPIRED': 'Key is verlopen',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key naam is al in gebruik',
            'API.API_KEY_NOT_FOUND': 'Key niet gevonden',
            'API.BAD_REQUEST': 'Ongeldig verzoek',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balanceringsprijspunt niet gevonden',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Batterijstatuspunt niet gevonden',
            'API.BUY_METER_NOT_FOUND': 'Koopmeter niet gevonden',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Kan bestaande submeterniet instellen als hoofdmeter',
            'API.CHARGE_METER_NOT_FOUND': 'Oplaadmeter niet gevonden',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Gecombineerde apparatuur opdrachtsrelatie bestaat',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Gecombineerde apparatuur opdrachtsrelatie niet gevonden',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en apparaat bestaat al',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en apparaat bestaat niet',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en meetmeter bestaat al',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en meetmeter bestaat niet',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Naam gecombineerde apparatuur is al in gebruik',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Gecombineerde apparatuur bestaat niet',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en offline meter bestaat al',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en offline meter bestaat niet',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Parameter naam gerelateerd aan gecombineerde apparatuur is al in gebruik',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parameter gerelateerd aan gecombineerde apparatuur bestaat niet of komt niet overeen',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en virtuele meter bestaat al',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en virtuele meter bestaat niet',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Opdrachtnaam is al in gebruik',
            'API.COMMAND_NOT_FOUND': 'Opdracht niet gevonden',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contactpersoon naam is al in gebruik',
            'API.CONTACT_NOT_FOUND': 'Contactpersoon bestaat niet',
            'API.COOLING_METER_NOT_FOUND': 'Koelmeter niet gevonden',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Kostenplaats externe ID bestaat al',
            'API.COST_CENTER_NAME_EXISTS': 'Kostenplaats naam bestaat al',
            'API.COST_CENTER_NOT_FOUND': 'Kostenplaats bestaat niet',
            'API.COST_FILE_NOT_FOUND': 'Kostenbestand bestaat niet',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data reparatiebestand niet gevonden',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Gegevensbron naam is al in gebruik',
            'API.DATA_SOURCE_NOT_FOUND': 'Gegevensbron bestaat niet',
            'API.DATABASE_ERROR': 'Databasefout',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Datum staat al in werkagenda',
            'API.DATE_LOCAL_NOT_FOUND': 'Lokale datum niet gevonden',
            'API.DISCHARGE_METER_NOT_FOUND': 'Ontlaadmeter niet gevonden',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distributiecircuit naam is al in gebruik',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distributiecircuit bestaat niet',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relatie distributiecircuit en datapunt bestaat al',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relatie distributiecircuit en datapunt bestaat niet',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distributiesysteem naam is al in gebruik',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distributiesysteem bestaat niet',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Elektriciteitsmeter niet gevonden',
            'API.EMAIL_IS_ALREADY_IN_USE': 'E-mailadres is al in gebruik',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'E-mailbericht bestaat niet',
            'API.EMAIL_NOT_FOUND': 'E-mailadres bestaat niet',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'E-mailserver host is al in gebruik',
            'API.EMAIL_SERVER_NOT_FOUND': 'E-mailserver host bestaat niet',
            'API.EMPTY_VARIABLES_ARRAY': 'Lege variabelen array',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energiecategorie naam is al in gebruik',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Energiecategorie bestaat niet',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energiecategorie wordt al gebruikt in energieonderdelen',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Energiecategorie wordt al gebruikt in meetmeter',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energiecategorie wordt al gebruikt in offline meter',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energiecategorie wordt al gebruikt in tarieven',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energiecategorie wordt al gebruikt in virtuele meter',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energieflowdiagram link is al in gebruik',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energieflowdiagram link bestaat niet of komt niet overeen',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energieflowdiagram naam is al in gebruik',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energieflowdiagram knooppunt is al in gebruik',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energieflowdiagram knooppunt bestaat niet of komt niet overeen',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energieflowdiagram bestaat niet',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieonderdeel behoort niet tot energiecategorie',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieonderdeel behoort niet tot energiecategorie',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energieonderdeel is al in gebruik',
            'API.ENERGY_ITEM_NOT_FOUND': 'Energieonderdeel bestaat niet',
            'API.ENERGY_ITEM_USED_IN_METER': 'Energieonderdeel wordt al gebruikt in meetmeter',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energieonderdeel wordt al gebruikt in offline meter',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energieonderdeel wordt al gebruikt in virtuele meter',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energieopslagcentrale naam is al in gebruik',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energieopslagcentrale niet gevonden',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Apparatuur opdrachtsrelatie bestaat',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Apparatuur opdrachtsrelatie niet gevonden',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relatie apparatuur en meetmeter bestaat al',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relatie apparatuur en meetmeter bestaat niet',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Apparatuurnaam is al in gebruik',
            'API.EQUIPMENT_NOT_FOUND': 'Apparatuur bestaat niet',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relatie apparatuur en offline meter bestaat al',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie apparatuur en offline meter bestaat niet',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Parameter naam gerelateerd aan apparaat is al in gebruik',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parameter gerelateerd aan apparaat bestaat niet of komt niet overeen',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relatie apparatuur en virtuele meter bestaat al',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie apparatuur en virtuele meter bestaat niet',
            'API.ERROR': 'Fout',
            'API.EXCEPTION': 'Uitzondering',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Lezen verzoekstroom mislukt',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Herstellen kostenbestand mislukt',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Herstellen data reparatiebestand mislukt',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Herstellen kennisbestand mislukt',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Herstellen offline meterbestand mislukt',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Opslaan offline meterbestand mislukt',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Uploaden bijlagebestand mislukt',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Uploaden kostenbestand mislukt',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Uploaden data reparatiebestand mislukt',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Uploaden kennisbestand mislukt',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Uploaden offline meterbestand mislukt',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway naam is al in gebruik',
            'API.GATEWAY_NOT_FOUND': 'Gateway bestaat niet',
            'API.HEAT_METER_NOT_FOUND': 'Warmtemeter niet gevonden',
            'API.INVALID_': 'Ongeldig ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Ongeldige bevestigingscode',
            'API.INVALID_ADDRESS': 'Ongeldig adres',
            'API.INVALID_ADDRESS_VALUE': 'Ongeldige adreswaarde',
            'API.INVALID_ADVANCED_REPORT_ID': 'Ongeldig geavanceerd rapport ID',
            'API.INVALID_API_KEY_ID': 'Ongeldig API key ID',
            'API.INVALID_API_KEY_NAME': 'Ongeldige API key naam',
            'API.INVALID_AREA_VALUE': 'Ongeldige oppervlaktewaarde',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Ongeldig balanceringsprijspunt ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Ongeldige basisperiode eindtijd',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Ongeldige basisperiode starttijd',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Ongeldig batterijstatuspunt ID',
            'API.INVALID_BAUD_RATE': 'Ongeldige baudrate',
            'API.INVALID_BUILDINGS_VALUE': 'Ongeldige gebouwwaarde',
            'API.INVALID_BUY_METER_ID': 'Ongeldig koopmeter ID',
            'API.INVALID_CAPACITY': 'Ongeldige capaciteit',
            'API.INVALID_CATEGORY': 'Ongeldige categorie',
            'API.INVALID_CHANNEL': 'Ongeldig kanaal',
            'API.INVALID_CHARGE_METER_ID': 'Ongeldig oplaadmeter ID',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'Ongeldig gecombineerd apparaat ID',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Ongeldige gecombineerde apparatuurnaam',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Ongeldig gecombineerd apparaat parameter ID',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Ongeldige gecombineerde apparaat parameternaam',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Ongeldig gecombineerd apparaat parametertype',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Ongeldige gecombineerde apparaat UUIDs',
            'API.INVALID_COMMAND_ID': 'Ongeldig opdracht ID',
            'API.INVALID_COMMAND_NAME': 'Ongeldige opdrachtnaam',
            'API.INVALID_CONNECTION': 'Ongeldige verbinding',
            'API.INVALID_CONSTANT_VALUE': 'Ongeldige constante waarde',
            'API.INVALID_CONTACT_ID': 'Ongeldig contactpersoon ID',
            'API.INVALID_CONTACT_NAME': 'Ongeldige contactpersoon naam',
            'API.INVALID_COOLING_METER_ID': 'Ongeldig koelmeter ID',
            'API.INVALID_COST_CENTER_ID': 'Ongeldig kostenplaats ID',
            'API.INVALID_COST_FILE_ID': 'Ongeldig kostenbestand ID',
            'API.INVALID_CREATED_DATETIME': 'Ongeldige aanmaaktijd',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Ongeldig data reparatiebestand ID',
            'API.INVALID_DATA_SOURCE_ID': 'Ongeldig gegevensbron ID',
            'API.INVALID_DATA_SOURCE_NAME': 'Ongeldige gegevensbron naam',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Ongeldig gegevensbron protocol',
            'API.INVALID_DATE_LOCAL': 'Ongeldige lokale datum',
            'API.INVALID_DENOMINATOR_METER_UUID': 'Ongeldige standaard meetmeter UUID',
            'API.INVALID_DISCHARGE_METER_ID': 'Ongeldig ontlaadmeter ID',
            'API.INVALID_DISPLAY_NAME': 'Ongeldige weergavenaam',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Ongeldig distributiecircuit ID',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Ongeldige distributiecircuit naam',
            'API.INVALID_DISTRIBUTION_ROOM': 'Ongeldige verdeelkast',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Ongeldig distributiesysteem ID',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Ongeldige distributiesysteem naam',
            'API.INVALID_ELECTRICITY_METER_ID': 'Ongeldig elektriciteitsmeter ID',
            'API.INVALID_EMAIL': 'Ongeldig e-mailadres',
            'API.INVALID_EMAIL_MESSAGE_ID': 'Ongeldig e-mailbericht ID',
            'API.INVALID_EMAIL_SERVER_HOST': 'Ongeldige e-mailserver host',
            'API.INVALID_EMAIL_SERVER_ID': 'Ongeldig e-mailserver ID',
            'API.INVALID_END_DATE_FORMAT': 'Ongeldig einddatumformaat',
            'API.INVALID_END_DATETIME': 'Ongeldige eindtijd',
            'API.INVALID_ENERGY_CATEGORY_ID': 'Ongeldig energiecategorie ID',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Ongeldige energiecategorie naam',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Ongeldig energieflowdiagram ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Ongeldig energieflowdiagram link ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Ongeldige energieflowdiagram naam',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Ongeldig energieflowdiagram knooppunt ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Ongeldige energieflowdiagram knooppuntnaam',
            'API.INVALID_ENERGY_ITEM_ID': 'Ongeldig energieonderdeel ID',
            'API.INVALID_ENERGY_ITEM_NAME': 'Ongeldige energieonderdeel naam',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Ongeldig energieopslagcentrale ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Ongeldige energieopslagcentrale naam',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Ongeldige vergelijking in expressie',
            'API.INVALID_EQUIPMENT_ID': 'Ongeldig apparaat ID',
            'API.INVALID_EQUIPMENT_NAME': 'Ongeldige apparatuurnaam',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Ongeldig apparaat parameter ID',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Ongeldige apparaat parameternaam',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Ongeldig apparaat parametertype',
            'API.INVALID_EQUIPMENT_UUID': 'Ongeldige apparaat UUID',
            'API.INVALID_EXPIRES_DATETIME': 'Ongeldige vervaltijd',
            'API.INVALID_EXPRESSION': 'Ongeldige expressie',
            'API.INVALID_EXPRESSION_OBJECT': 'Ongeldig expressieobject',
            'API.INVALID_FDD_CODE': 'Ongeldige foutcode',
            'API.INVALID_FLOORS_VALUE': 'Ongeldige verdiepingwaarde',
            'API.INVALID_FROM_ADDR': 'Ongeldig adres',
            'API.INVALID_GATEWAY_ID': 'Ongeldig gateway ID',
            'API.INVALID_GATEWAY_NAME': 'Ongeldige gateway naam',
            'API.INVALID_HEAT_METER_ID': 'Ongeldig warmtemeter ID',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Ongeldige bovengrens waarde',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Ongeldige uurlijkse bovengrens waarde',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Ongeldige uurlijkse ondergrens waarde',
            'API.INVALID_Id': 'Ongeldig ID',
            'API.INVALID_IS_ADMIN_VALUE': 'Ongeldige beheerwaarde',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Ongeldig tonen kostengegevens',
            'API.INVALID_IS_COUNTED_VALUE': 'Ongeldige telwaarde',
            'API.INVALID_IS_ENABLED': 'Ongeldig ingeschakeld',
            'API.INVALID_IS_HIDDEN': 'Ongeldig verborgen',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Ongeldige inhuurwaarde',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Ongeldige invoer telwaarde',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Ongeldige hoofdhurderwaarde',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Ongeldige uitvoer telwaarde',
            'API.INVALID_IS_OUTPUT_VALUE': 'Ongeldige uitvoerwaarde',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Ongeldige alleen-lezen waarde',
            'API.INVALID_IS_TREND_VALUE': 'Ongeldige trendwaarde',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Ongeldige virtuele puntwaarde',
            'API.INVALID_KGCE': 'Ongeldige kilogram standaardkool coëfficiënt',
            'API.INVALID_KGCO2E': 'Ongeldige kilogram CO2-uitstoot coëfficiënt',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'Ongeldig kennisbestand ID',
            'API.INVALID_LATITUDE_VALUE': 'Ongeldige breedtegraadwaarde',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Ongeldig huurcontractnummer',
            'API.INVALID_LONGITUDE_VALUE': 'Ongeldige lengtegraadwaarde',
            'API.INVALID_LOW_LIMIT_VALUE': 'Ongeldige ondergrens waarde',
            'API.INVALID_MASTER_METER_ID': 'Ongeldig hoofdmeter ID',
            'API.INVALID_MENU_ID': 'Ongeldig menu ID',
            'API.INVALID_MESSAGE_DATA': 'Ongeldige berichtgegevens',
            'API.INVALID_MESSAGE_TEMPLATE': 'Ongeldig berichtsjabloon',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Ongeldig berichtsjabloon ID',
            'API.INVALID_MESSAGE_VALUE': 'Ongeldige berichtwaarde',
            'API.INVALID_METER_ID': 'Ongeldig meetmeter ID',
            'API.INVALID_METER_NAME': 'Ongeldige meetmeternaam',
            'API.INVALID_METER_UUID': 'Ongeldige meetmeter UUID',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Ongeldig microgrid batterij ID',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Ongeldige microgrid batterij naam',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Ongeldig microgrid EV-laadpaal ID',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Ongeldige microgrid EV-laadpaal naam',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Ongeldig microgrid generator ID',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Ongeldige microgrid generator naam',
            'API.INVALID_MICROGRID_GRID_ID': 'Ongeldig microgrid net ID',
            'API.INVALID_MICROGRID_GRID_NAME': 'Ongeldige microgrid net naam',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Ongeldig microgrid warmtepomp ID',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Ongeldige microgrid warmtepomp naam',
            'API.INVALID_MICROGRID_ID': 'Ongeldig microgrid ID',
            'API.INVALID_MICROGRID_LOAD_ID': 'Ongeldig microgrid belasting ID',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Ongeldige microgrid belasting naam',
            'API.INVALID_MICROGRID_NAME': 'Ongeldige microgrid naam',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Ongeldig microgrid fotovoltaïsch ID',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Ongeldige microgrid fotovoltaïsch naam',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Ongeldig microgrid vermogensomzettingssysteem ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Ongeldige microgrid vermogensomzettingssysteem naam',
            'API.INVALID_MICROGRID_UUID': 'Ongeldige microgrid UUID',
            'API.INVALID_NAME_VALUE': 'Ongeldige naamwaarde',
            'API.INVALID_NEW_PASSWORD': 'Ongeldig nieuw wachtwoord',
            'API.INVALID_NON_WORKING_DAY_ID': 'Ongeldig niet-werkdag ID',
            'API.INVALID_NOTIFICATION_ID': 'Ongeldig notificatie ID',
            'API.INVALID_NUMERATOR_METER_UUID': 'Ongeldige teller meter UUID',
            'API.INVALID_OBJECT_TYPE': 'Ongeldig objecttype',
            'API.INVALID_OFFLINE_METER_DATA': 'Ongeldige offline meter gegevens',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'Ongeldig offline meterbestand ID',
            'API.INVALID_OFFLINE_METER_ID': 'Ongeldig offline meter ID',
            'API.INVALID_OFFLINE_METER_NAME': 'Ongeldige offline meternaam',
            'API.INVALID_OFFLINE_METER_UUID': 'Ongeldige offline meter UUID',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Ongeldige offset constante',
            'API.INVALID_OLD_PASSWORD': 'Ongeldig oud wachtwoord',
            'API.INVALID_OPENID': 'Ongeldige OpenID',
            'API.INVALID_PARENT_SPACE_ID': 'Ongeldig bovenliggende ruimte ID',
            'API.INVALID_PASSWORD': 'Ongeldig wachtwoord',
            'API.INVALID_PAYLOAD': 'Ongeldige payload',
            'API.INVALID_PEAK_CURRENT': 'Ongeldige piekstroom',
            'API.INVALID_PEAK_LOAD': 'Ongeldige piekbelasting',
            'API.INVALID_PERIOD_TYPE': 'Ongeldig periode type',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Ongeldig fotovoltaïsche centrale ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Ongeldige fotovoltaïsche centrale naam',
            'API.INVALID_POINT_ID': 'Ongeldig datapunt ID',
            'API.INVALID_POINT_NAME': 'Ongeldige datapuntnaam',
            'API.INVALID_PORT': 'Ongeldige poort',
            'API.INVALID_POSTAL_CODE_VALUE': 'Ongeldige postcodewaarde',
            'API.INVALID_POWER_POINT_ID': 'Ongeldig vermogenspunt ID',
            'API.INVALID_PRIORITY': 'Ongeldige prioriteit',
            'API.INVALID_PRIVILEGE': 'Ongeldig privilege',
            'API.INVALID_PRIVILEGE_DATA': 'Ongeldige privilegengegevens',
            'API.INVALID_PRIVILEGE_ID': 'Ongeldig privilege ID',
            'API.INVALID_PRIVILEGE_NAME': 'Ongeldige privilegenaam',
            'API.INVALID_RATIO_VALUE': 'Ongeldige verhoudingswaarde',
            'API.INVALID_RECIPIENT_EMAIL': 'Ongeldig ontvanger e-mailadres',
            'API.INVALID_RECIPIENT_MOBILE': 'Ongeldig ontvanger mobiel nummer',
            'API.INVALID_RECIPIENT_NAME': 'Ongeldige ontvangernaam',
            'API.INVALID_RECIPIENT_OPENID': 'Ongeldige ontvanger OpenID',
            'API.INVALID_REPLY': 'Ongeldig antwoord',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Ongeldige rapportageperiode eindtijd',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Ongeldige rapportageperiode starttijd',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Ongeldige vereiste authenticatie',
            'API.INVALID_ROOMS_VALUE': 'Ongeldige kamerswaarde',
            'API.INVALID_RULE_ID': 'Ongeldige regel ID',
            'API.INVALID_RULE_NAME': 'Ongeldige regelnaam',
            'API.INVALID_RUN_STATE_POINT_ID': 'Ongeldig bedrijfsstatuspunt ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Ongeldige geplande tijd',
            'API.INVALID_SELL_METER_ID': 'Ongeldig verkoopmeter ID',
            'API.INVALID_SENSOR_ID': 'Ongeldig sensor ID',
            'API.INVALID_SENSOR_NAME': 'Ongeldige sensornaam',
            'API.INVALID_SENSOR_UUID': 'Ongeldige sensor UUID',
            'API.INVALID_SERIAL_NUMBER': 'Ongeldig serienummer',
            'API.INVALID_SERIAL_PORT': 'Ongeldige seriële poort',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sessie ongeldig, log opnieuw in',
            'API.INVALID_SET_VALUE': 'Ongeldige ingestelde waarde',
            'API.INVALID_SHOPFLOOR_ID': 'Ongeldig werkvloer ID',
            'API.INVALID_SHOPFLOOR_NAME': 'Ongeldige werkvloernaam',
            'API.INVALID_SHOPFLOOR_UUID': 'Ongeldige werkvloer UUID',
            'API.INVALID_SOURCE_NODE_ID': 'Ongeldig bronknooppunt ID',
            'API.INVALID_SPACE_ID': 'Ongeldige ruimte ID',
            'API.INVALID_SPACE_NAME': 'Ongeldige ruimtenaam',
            'API.INVALID_SPACE_UUID': 'Ongeldige ruimte UUID',
            'API.INVALID_START_DATE_FORMAT': 'Ongeldig startdatumformaat',
            'API.INVALID_START_DATETIME': 'Ongeldige starttijd',
            'API.INVALID_STATUS': 'Ongeldige status',
            'API.INVALID_STORE_ID': 'Ongeldig winkel ID',
            'API.INVALID_STORE_NAME': 'Ongeldige winklenaam',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Ongeldige winkelsysteembeschrijving',
            'API.INVALID_STORE_TYPE_ID': 'Ongeldig winkelsysteem ID',
            'API.INVALID_STORE_TYPE_NAME': 'Ongeldige winkelsysteemnaam',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Ongeldige winkelsysteem vereenvoudigde code',
            'API.INVALID_STORE_UUID': 'Ongeldige winkel UUID',
            'API.INVALID_SUBJECT_VALUE': 'Ongeldige onderwerpwaarde',
            'API.INVALID_SVG': 'Ongeldige SVG',
            'API.INVALID_SWITCHGEAR': 'Ongeldige schakelapparatuur',
            'API.INVALID_TARGET_NODE_ID': 'Ongeldig doelknooppunt ID',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Ongeldige bloktarief prijsstelling',
            'API.INVALID_TARIFF_ID': 'Ongeldig tarief ID',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Ongeldige tijd-van-dag tarief prijsstelling',
            'API.INVALID_TARIFF_TYPE': 'Ongeldig tarief type',
            'API.INVALID_TENANT_ID': 'Ongeldig huurder ID',
            'API.INVALID_TENANT_NAME': 'Ongeldige hurdernaam',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Ongeldige huurdersysteembeschrijving',
            'API.INVALID_TENANT_TYPE_ID': 'Ongeldig huurdersysteem ID',
            'API.INVALID_TENANT_TYPE_NAME': 'Ongeldige huurdersysteemnaam',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Ongeldige huurdersysteem vereenvoudigde code',
            'API.INVALID_TENANT_UUID': 'Ongeldige huurder UUID',
            'API.INVALID_TEXT_MESSAGE_ID': 'Ongeldig SMS ID',
            'API.INVALID_TIMEZONE_ID': 'Ongeldige tijdzone ID',
            'API.INVALID_TOKEN': 'Ongeldig token',
            'API.INVALID_TOPIC': 'Ongeldig onderwerp',
            'API.INVALID_UNIT_OF_MEASURE': 'Ongeldige meeteenheid',
            'API.INVALID_UNIT_OF_PRICE': 'Ongeldige prijseenheid',
            'API.INVALID_UNITS': 'Ongeldige eenheden',
            'API.INVALID_USER_ID': 'Ongeldig gebruiker ID',
            'API.INVALID_USER_NAME': 'Ongeldige gebruikersnaam',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Ongeldige gebruikersnaam of e-mailadres',
            'API.INVALID_USER_PHONE': 'Ongeldig gebruikers telefoonnummer',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Ongeldige gebruiker log opnieuw in',
            'API.INVALID_USER_UUID': 'Ongeldige gebruiker UUID',
            'API.INVALID_USERNAME': 'Ongeldige gebruikersnaam',
            'API.INVALID_VARIABLE_METER_ID': 'Ongeldig variabele meter ID',
            'API.INVALID_VARIABLE_METER_TYPE': 'Ongeldig variabele meter type',
            'API.INVALID_VARIABLE_NAME': 'Ongeldige variabelenaam',
            'API.INVALID_VERIFICATION_CODE': 'Ongeldige verificatiecode',
            'API.INVALID_VIRTUAL_METER_ID': 'Ongeldig virtuele meter ID',
            'API.INVALID_VIRTUAL_METER_NAME': 'Ongeldige virtuele meternaam',
            'API.INVALID_VIRTUAL_METER_UUID': 'Ongeldige virtuele meter UUID',
            'API.INVALID_WEB_MESSAGE_ID': 'Ongeldig webbericht ID',
            'API.INVALID_WECHAT_MESSAGE_ID': 'Ongeldig WeChat bericht ID',
            'API.INVALID_WIND_FARM_ID': 'Ongeldig windpark ID',
            'API.INVALID_WIND_FARM_NAME': 'Ongeldige windpark naam',
            'API.INVALID_WORKING_CALENDAR_ID': 'Ongeldig werkagenda ID',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Ongeldige werkagendanaam',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Kan kennisbestand niet van schijf verwijderen',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Kennisbestand bestaat niet',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Hoofdmeter behoort niet tot dezelfde energiecategorie',
            'API.MASTER_METER_NOT_FOUND': 'Hoofdmeter bestaat niet',
            'API.MENU_NOT_FOUND': 'Menu bestaat niet',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter kan niet meer dan één energie waardepunt hebben',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter opdrachtsrelatie bestaat',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter opdrachtsrelatie niet gevonden',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Meetmeternaam is al in gebruik',
            'API.METER_NOT_FOUND': 'Meetmeter bestaat niet',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Variabele meetmeter bestaat niet',
            'API.METER_POINT_RELATION_EXISTS': 'Relatie meetmeter en datapunt bestaat al',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Relatie meetmeter en datapunt bestaat niet',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid batterij naam is al in gebruik',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid batterij niet gevonden',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid EV-laadpaal naam is al in gebruik',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid EV-laadpaal niet gevonden',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator naam is al in gebruik',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator niet gevonden',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid net naam is al in gebruik',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid net niet gevonden',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid warmtepomp naam is al in gebruik',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid warmtepomp niet gevonden',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid belasting naam is al in gebruik',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid belasting niet gevonden',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid naam is al in gebruik',
            'API.MICROGRID_NOT_FOUND': 'Microgrid niet gevonden',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid fotovoltaïsch naam is al in gebruik',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid fotovoltaïsch niet gevonden',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid vermogensomzettingssysteem naam is al in gebruik',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid vermogensomzettingssysteem niet gevonden',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensorrelatie bestaat',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor niet gevonden',
            'API.MQTT_CONNECTION_ERROR': 'MQTT verbindingsfout',
            'API.MQTT_PUBLISH_ERROR': 'MQTT publicatiefout',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Nieuw wachtwoord lengte mag niet meer dan 100 tekens zijn',
            'API.NEW_USER_SESSION_NOT_FOUND': 'Nieuwe gebruikerssessie niet gevonden',
            'API.NEW_USER_SESSION_TIMEOUT': 'Nieuwe gebruikerssessie verlopen',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Niet-werkdag bestaat niet',
            'API.NOT_FOUND': 'Bestaat niet',
            'API.NOTIFICATION_NOT_FOUND': 'Notificatie bestaat niet',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meterbestand bestaat niet',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meternaam is al in gebruik',
            'API.OFFLINE_METER_NOT_FOUND': 'Offline meter bestaat niet',
            'API.INVALID_OFFLINE_METER_VALUE': 'Ongeldige offline meterwaarde',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter variabele bestaat niet',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Oud wachtwoord lengte mag niet meer dan 100 tekens zijn',
            'API.PARENT_SPACE_NOT_FOUND': 'Bovenliggende ruimte bestaat niet',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Wachtwoord lengte mag niet meer dan 100 tekens zijn',
            'API.PASSWORDS_MATCH': 'Nieuw wachtwoord komt overeen met oud wachtwoord',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Fotovoltaïsche centrale naam is al in gebruik',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Fotovoltaïsche centrale niet gevonden',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Datapuntnaam is al in gebruik',
            'API.POINT_NOT_FOUND': 'Datapunt bestaat niet',
            'API.POWER_POINT_NOT_FOUND': 'Vermogenspunt niet gevonden',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilegenaam is al in gebruik',
            'API.PRIVILEGE_NOT_FOUND': 'Privilege bestaat niet',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Regelnaam is al in gebruik',
            'API.RULE_NOT_FOUND': 'Regel bestaat niet',
            'API.SELL_METER_NOT_FOUND': 'Verkoopmeter niet gevonden',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensornaam is al in gebruik',
            'API.SENSOR_NOT_FOUND': 'Sensor bestaat niet',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Relatie sensor en datapunt bestaat al',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relatie sensor en datapunt bestaat niet',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Werkvloer opdrachtsrelatie bestaat',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Werkvloer opdrachtsrelatie niet gevonden',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relatie werkvloer en apparaat bestaat al',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie werkvloer en apparaat bestaat niet',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relatie werkvloer en meetmeter bestaat al',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relatie werkvloer en meetmeter bestaat niet',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Werkvloernaam is al in gebruik',
            'API.SHOPFLOOR_NOT_FOUND': 'Werkvloer bestaat niet',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relatie werkvloer en offline meter bestaat al',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie werkvloer en offline meter bestaat niet',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relatie werkvloer en datapunt bestaat al',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relatie werkvloer en datapunt bestaat niet',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relatie werkvloer en sensor bestaat al',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relatie werkvloer en sensor bestaat niet',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relatie werkvloer en virtuele meter bestaat al',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie werkvloer en virtuele meter bestaat niet',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Werkvloer werkagenda relatie bestaat al',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Werkvloer en werkagenda relatie bestaat niet',
            'API.SOC_POINT_NOT_FOUND': 'SOC punt niet gevonden',
            'API.SOURCE_NODE_NOT_FOUND': 'Bronknooppunt bestaat niet',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relatie ruimte en gecombineerde apparatuur bestaat al',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie ruimte en gecombineerde apparatuur bestaat niet',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Ruimte opdrachtsrelatie bestaat',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Ruimte opdrachtsrelatie niet gevonden',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Ruimte Energieopslagcentrale Relatie Bestaat',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Ruimte Energieopslagcentrale Relatie Niet Gevonden',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relatie ruimte en apparaat bestaat al',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie ruimte en apparaat bestaat niet',
            'API.SPACE_METER_RELATION_EXISTS': 'Relatie ruimte en meetmeter bestaat al',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Relatie ruimte en meetmeter bestaat niet',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Ruimtenaam is al in gebruik',
            'API.SPACE_NOT_FOUND': 'Ruimte bestaat niet',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Ruimte bestaat niet in privilege',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relatie ruimte en offline meter bestaat al',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie ruimte en offline meter bestaat niet',
            'API.SPACE_POINT_RELATION_EXISTS': 'Relatie ruimte en datapunt bestaat al',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relatie ruimte en datapunt bestaat niet',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Relatie ruimte en sensor bestaat al',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relatie ruimte en sensor bestaat niet',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relatie ruimte en werkvloer bestaat al',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relatie ruimte en werkvloer bestaat niet',
            'API.SPACE_STORE_RELATION_EXISTS': 'Relatie ruimte en winkel bestaat al',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relatie ruimte en winkel bestaat niet',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Relatie ruimte en huurder bestaat al',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relatie ruimte en huurder bestaat niet',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relatie ruimte en virtuele meter bestaat al',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie ruimte en virtuele meter bestaat niet',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relatie ruimte en werkagenda bestaat al',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relatie ruimte en werkagenda bestaat niet',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Starttijd moet eerder zijn dan eindtijd',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Winkel opdrachtsrelatie bestaat',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Winkel opdrachtsrelatie niet gevonden',
            'API.STORE_METER_RELATION_EXISTS': 'Relatie winkel en meetmeter bestaat al',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Relatie winkel en meetmeter bestaat niet',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Winkelnaam is al in gebruik',
            'API.STORE_NOT_FOUND': 'Winkel bestaat niet',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relatie winkel en offline meter bestaat al',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie winkel en offline meter bestaat niet',
            'API.STORE_POINT_RELATION_EXISTS': 'Relatie winkel en datapunt bestaat al',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Relatie winkel en datapunt bestaat niet',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Relatie winkel en sensor bestaat al',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Winkel sensor relatie bestaat niet',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Winkelsysteemnaam is al in gebruik',
            'API.STORE_TYPE_NOT_FOUND': 'Winkelsysteem bestaat niet',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Winkelsysteem vereenvoudigde code is al in gebruik',
            'API.STORE_TYPE_USED_IN_STORE': 'Winkelsysteem wordt al gebruikt in winkel',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relatie winkel en virtuele meter bestaat al',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie winkel en virtuele meter bestaat niet',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Winkel en werkagenda relatie bestaat al',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Winkel en werkagenda relatie bestaat niet',
            'API.TARGET_NODE_NOT_FOUND': 'Doelknooppunt bestaat niet',
            'API.TARIFF_IN_USE': 'Tarief wordt gebruikt',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tarief en kostenplaats zijn al geassocieerd',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tarief en kostenplaats zijn niet geassocieerd',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariefnaam is al in gebruik',
            'API.TARIFF_NOT_FOUND': 'Tarief bestaat niet',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Huurder opdrachtsrelatie bestaat',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Huurder opdrachtsrelatie niet gevonden',
            'API.TENANT_METER_RELATION_EXISTS': 'Relatie huurder en meetmeter bestaat al',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Relatie huurder en meetmeter bestaat niet',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Huurdernaam is al in gebruik',
            'API.TENANT_NOT_FOUND': 'Huurder bestaat niet',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relatie huurder en offline meter bestaat al',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie huurder en offline meter bestaat niet',
            'API.TENANT_POINT_RELATION_EXISTS': 'Relatie huurder en datapunt bestaat al',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relatie huurder en datapunt bestaat niet',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Relatie huurder en sensor bestaat al',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Huurder en sensor relatie bestaat niet',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Huurder en systeemnaam is al in gebruik',
            'API.TENANT_TYPE_NOT_FOUND': 'Huurdersysteem bestaat niet',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Huurdersysteem vereenvoudigde code is al in gebruik',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Huurdersysteem wordt al gebruikt in huurder',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relatie huurder en virtuele meter bestaat al',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie huurder en virtuele meter bestaat niet',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Huurder en werkagenda relatie bestaat al',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Huurder en werkagenda relatie bestaat niet',
            'API.TEXT_MESSAGE_NOT_FOUND': 'SMS niet gevonden',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Rapportageperiode moet langer zijn dan 15 minuten',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Relatie met submeters',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Relatie met onderliggende ruimtes',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Relatie met gecombineerde apparaat parameters',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Relatie met gecombineerde apparatuur',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Relatie met gegevensbronnen',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Relatie met energieflowdiagram',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Relatie met energieopslagcontainer batterijen',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Relatie met energieopslagcontainer netten',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Relatie met energieopslagcontainer belastingen',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Relatie met energieopslagcontainer vermogensomzettingssystemen (PCS)',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Relatie met apparaat parameters',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Relatie met apparatuur',
            'API.THERE_IS_RELATION_WITH_METER': 'Relatie met meetmeter',
            'API.THERE_IS_RELATION_WITH_METERS': 'Relatie met meerdere meetmeters',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Relatie met offline meter',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Relatie met meerdere offline meters',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Relatie met virtuele meter',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'Relatie met sensoren',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Relatie met werkvloeren',
            'API.THERE_IS_RELATION_WITH_SPACES': 'Relatie met ruimtes',
            'API.THERE_IS_RELATION_WITH_STORES': 'Relatie met winkels',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'Relatie met huurders',
            'API.THERE_IS_RELATION_WITH_USERS': 'Relatie met gebruikers',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Relatie met virtuele meter',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Relatie met virtuele energiecentrales',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Deze gegevensbron wordt gebruikt door een meetmeter',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Deze meetmeter wordt gebruikt door een virtuele meter',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Deze offline meter wordt gebruikt door een virtuele meter',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'Ruimte kan niet gekloond worden',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'Ruimte kan niet verwijderd worden',
            'API.TIMEZONE_NOT_FOUND': 'Tijdzone bestaat niet',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token niet gevonden, log in',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Gebruikersaccount is geblokkeerd',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'Gebruikersaccount is verlopen',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'Gebruikersaccount is niet geblokkeerd',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'Gebruikersnaam is al in gebruik',
            'API.USER_NOT_FOUND': 'Gebruiker bestaat niet',
            'API.USER_PASSWORD_HAS_EXPIRED': 'Gebruikerswachtwoord is verlopen',
            'API.USER_PRIVILEGE_NOT_FOUND': 'Gebruikersprivilege niet gevonden',
            'API.USER_SESSION_NOT_FOUND': 'Gebruikerssessie niet gevonden',
            'API.USER_SESSION_TIMEOUT': 'Gebruikerssessie verlopen',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Gebruikers UUID bestaat niet, log in',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtuele meternaam is al in gebruik',
            'API.VIRTUAL_METER_NOT_FOUND': 'Virtuele meter bestaat niet',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Variabele virtuele meter bestaat niet',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtueel datapunt moet analoog zijn',
            'API.WEB_MESSAGE_NOT_FOUND': 'Webbericht bestaat niet',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'WeChat bericht bestaat niet',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Windpark naam is al in gebruik',
            'API.WIND_FARM_NOT_FOUND': 'Windpark niet gevonden',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Werkagendanaam is al in gebruik',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Werkagenda bestaat niet',

            MasterMeter: 'Hoofdmeter',
            SubMeter: 'Submeter',
            'Power Quality': 'Kwaliteit van stroomvoorziening',
            'About Power Quality': 'Over Kwaliteit van Stroomvoorziening',
            'Trend Values': 'Trendwaarden',
            Category: 'Categorie',
            Type: 'Type',
            Unit: 'Eenheid',
            Limit: 'Limiet',
            'Normal Limit': 'Normale limiet',
            'Severe Limit': 'Ernstige limiet',
            Compliance: 'Compliance percentage',
            'Worst Deviation': 'Slechtste afwijking',
            'Worst Time': 'Slechtste tijdstip',
            'Severe Exceed Count': 'Aantal ernstige overschrijdingen',
            'Worst Unbalance': 'Maximale onbalans',
            Hz: 'Hertz',
            voltage: 'Spanning',
            current: 'Stroom',
            frequency: 'Frequentie',
            voltage_deviation: 'Spanningsafwijking',
            current_unbalance: 'Stroomonbalans',
            voltage_unbalance: 'Spanningsonbalans',
            mean_deviation_pct: 'Gemiddelde afwijking (%)',
            p95_abs_deviation_pct: 'P95 absolute afwijking (%)',
            mean_abs_deviation_hz: 'Gemiddelde absolute afwijking (Hz)',
            frequency_deviation: 'Frequentieafwijking',
            p95_abs_deviation_hz: 'P95 absolute afwijking (Hz)',
            mean_unbalance_pct: 'Gemiddelde onbalans (%)',
            p95_unbalance_pct: 'P95 onbalans (%)',
            count: 'Aantal',
            min: 'Minimum',
            max: 'Maximum',
            mean: 'Gemiddelde',
            std: 'Standaardafwijking',
            p5: 'P5',
            p95: 'P95'
        }
    },
    jp: {
        translation: {
            // routes & menus
            Dashboard: '総覧',
            'Space Data': '空間データ',
            'Equipment Data': '設備データ',
            'Meter Data': '計量メータデータ',
            'Tenant Data': 'テナントデータ',
            'Store Data': '店舗データ',
            'Shopfloor Data': '現場データ',
            'Combined Equipment Data': '複合設備データ',
            'Auxiliary System': '補助システム',
            Microgrid: 'マイクログリッド',
            'Energy Storage Power Station': '発電所',
            'Photovoltaic Power Station': '発電所',
            'Fault Alarm': '故障アラーム',
            Monitoring: '設備監視',
            'Advanced Reporting': '高度レポート',
            'Knowledge Base': 'ナレッジベース',
            'Energy Category Data': 'エネルギー分類分析',
            'Energy Item Data': 'エネルギー項目分析',
            Carbon: '炭素排出分析',
            Cost: 'コスト分析',
            Output: '産出分析',
            Income: '収入分析',
            Efficiency: '効率分析',
            Load: '負荷分析',
            Statistics: '統計分析',
            'Batch Analysis': '一括分析',
            Saving: '省エネ分析',
            Plan: '計画分析',
            Prediction: '予測分析',
            'Production': '生産量',
            'Space Production': '生産量エネルギー分析',
            'Equipment Tracking': '設備台帳',
            'Equipment Comparison': '比較分析',
            'Shopfloor Comparison': '比較分析',
            'Store Comparison': '比較分析',
            'Space Comparison': '比較分析',
            'Combined Equipment Comparison': '比較分析',
            'Tenant Comparison': '比較分析',
            'Environment Monitor': '環境モニタリング',
            'Meter Energy': '計量メータエネルギー分析',
            'Meter Carbon': '計量メータ炭素排出分析',
            'Meter Cost': '計量メータコスト分析',
            'Meter Trend': '計量メータ傾向分析',
            'Meter Realtime': '計量メータリアルタイム分析',
            'Meter Saving': '計量メータ省エネ分析',
            'Meter Plan': '計量メータ計画分析',
            'Master Meter Submeters Balance': '総メータサブメータ平衡分析',
            'Meter Batch Analysis': '計量メータ一括分析',
            'Meter Comparison': '計量メータ比較分析',
            'Meter Tracking': '計量メータ台帳',
            'Virtual Meter Saving': '仮想メータ省エネ分析',
            'Virtual Meter Plan': '仮想メータ計画分析',
            'Virtual Meter Energy': '仮想メータエネルギー分析',
            'Virtual Meter Carbon': '仮想メータ炭素排出分析',
            'Virtual Meter Cost': '仮想メータコスト分析',
            'Virtual Meter Batch Analysis': '仮想メータ一括分析',
            'Virtual Meter Comparison': '仮想メータ比較分析',
            'Offline Meter Energy': 'オフラインメータエネルギー分析',
            'Offline Meter Carbon': 'オフラインメータ炭素排出分析',
            'Offline Meter Cost': 'オフラインメータコスト分析',
            'Offline Meter Batch Analysis': 'オフラインメータ一括分析',
            'Offline Meter Saving': 'オフラインメータ省エネ分析',
            'Offline Meter Plan': 'オフラインメータ計画分析',
            'Offline Meter Input': 'オフラインメータデータ入力',
            'Tenant Bill': 'テナント請求書',
            'Energy Flow Diagram': 'エネルギー流れ図',
            'Distribution System': '配電システム',
            'SVG System': 'コンフィギュレーション可視化システム',
            'Faults Data': '故障分析',
            'Space Equipments': '空間設備',
            'Combined Equipments': '複合設備',
            'Energy Storage Power Station List': '発電所リスト',
            'Energy Storage Power Station Details': '設備監視',
            'Energy Storage Power Station Reporting': 'データレポート',
            'Energy Storage Power Station Alarm': '故障アラーム',
            'Energy Storage Power Station Maintenance': 'メンテナンス',
            'Enter Production': '生産量入力',
            'Multiple Microgrids': '多サイトデータ',
            'Multiple Microgrids Dashboard': '多サイト総覧',
            'Multiple Microgrids List': '発電所リスト',
            'Single Microgrid': '単一サイトデータ',
            'Single Microgrid Dashboard': '単一サイト総覧',
            'Single Microgrid Details': '設備データ',
            'Single Microgrid Fault Alarm': '故障警告',
            'Microgrid Reports': '統計レポート',
            'Microgrid Reports Energy': '電力量レポート',
            'Microgrid Reports Revenue': '収益レポート',
            'Microgrid Reports Parameters': 'データクエリ',
            'Multiple Energy Storage Power Stations': 'エネルギー貯蔵多サイトデータ',
            'Multiple Energy Storage Power Stations Dashboard': 'エネルギー貯蔵多サイト総覧',
            'Multiple Energy Storage Power Stations List': 'エネルギー貯蔵発電所リスト',
            'Single Energy Storage Power Station': 'エネルギー貯蔵単一サイトデータ',
            'Single Energy Storage Power Station Dashboard': 'エネルギー貯蔵単一サイト総覧',
            'Single Energy Storage Power Station Details': 'エネルギー貯蔵設備データ',
            'Single Energy Storage Power Station Fault Alarm': 'エネルギー貯蔵故障警告',
            'Energy Storage Power Station Reports': 'エネルギー貯蔵統計レポート',
            'Energy Storage Power Station Reports Energy': 'エネルギー貯蔵電力量レポート',
            'Energy Storage Power Station Reports Revenue': 'エネルギー貯蔵収益レポート',
            'Energy Storage Power Station Reports Parameters': 'エネルギー貯蔵データクエリ',
            'Multiple Energy Storage Power Stations': '多サイトデータ',
            'Multiple Energy Storage Power Stations Dashboard': '多サイト総覧',
            'Multiple Energy Storage Power Stations List': '発電所リスト',
            'Single Energy Storage Power Station': '単一サイトデータ',
            'Single Energy Storage Power Station Dashboard': '単一サイト総覧',
            'Single Energy Storage Power Station Details': '設備データ',
            'Single Energy Storage Power Station Fault Alarm': '故障警告',
            'Energy Storage Power Station Reports': '統計レポート',
            'Energy Storage Power Station Reports Energy': '電力量レポート',
            'Energy Storage Power Station Reports Revenue': '収益レポート',
            'Energy Storage Power Station Reports Parameters': 'データクエリ',
            'Photovoltaic Power Station List': '発電所リスト',
            'Photovoltaic Power Station Details': '設備監視',
            'Photovoltaic Power Station Reporting': 'データレポート',
            'Photovoltaic Power Station Alarm': '故障アラーム',
            'Photovoltaic Power Station Maintenance': 'メンテナンス',
            'Multiple Photovoltaic Power Stations': '多サイトデータ',
            'Multiple Photovoltaic Power Stations Dashboard': '多サイト総覧',
            'Multiple Photovoltaic Power Stations List': '発電所リスト',
            'Single Photovoltaic Power Station': '単一サイトデータ',
            'Single Photovoltaic Power Station Dashboard': '単一サイト総覧',
            'Single Photovoltaic Power Station Details': '設備データ',
            'Single Photovoltaic Power Station Fault Alarm': '故障警告',
            'Photovoltaic Power Station Reports': '統計レポート',
            'Photovoltaic Power Station Reports Energy': '電力量レポート',
            'Photovoltaic Power Station Reports Revenue': '収益レポート',
            'Photovoltaic Power Station Reports Parameters': 'データクエリ',
            'Work Order': '作業票管理',
            'Work Order Installation': '設置記録',
            'Work Order Repair': '修理記録',
            'Work Order Inspection': '巡回点検記録',
            'Total Number of Work Orders': '総作業票数量',
            'Number of New Work Orders': '新規発行作業票数量',
            'Number of Inprogress Work Orders': '進行中作業票数量',
            'Number of Done Work Orders': '完了済み作業票数量',
            'Fuel Indicator': '燃料消費量',
            'Charge Energy Indicator': '充電エネルギー',
            'Discharge Energy Indicator': '放電エネルギー',
            'Charge Cost Indicator': '充電コスト',
            'Discharge Revenue Indicator': '放電収益',
            'HVAC': '空調',
            'Fire Control': '消防',

            // Dashboard
            'Welcome to MyEMS': 'MyEMSへようこそ',
            'An Industry Leading Open Source Energy Management System': '業界をリードするオープンソースエネルギー管理システム',
            "This Year's Consumption CATEGORY VALUE UNIT": '本年消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": '本年コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": '今月消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": '今月産出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Costs CATEGORY VALUE UNIT": '今月コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': '前年同期消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '前年同期コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} 消費 {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} コスト {{UNIT}}',
            // Entities
            Space: '空間',
            Equipment: '設備',
            Meter: '計量メータ',
            'Offline Meter': 'オフラインメータ',
            'Virtual Meter': '仮想メータ',
            Tenant: 'テナント',
            Store: '店舗',
            Shopfloor: '現場',
            'Combined Equipment': '複合設備',
            'Cost Center': 'コストセンター',
            Name: '名称',
            DisplayName: '表示名',
            UserName: 'ユーザー名',
            Description: '説明',
            'Energy Category': 'エネルギー分類',
            'Child Spaces': '子空間',
            'Associated Equipment': '関連設備',
            //Energy Categories
            Electricity: '電気',
            Water: '水道水',
            'Natural Gas': '天然ガス',
            // SidePanelModal
            Settings: '設定',
            'Set your own customized style': 'カスタマイズしたスタイルを設定する',
            'Color Scheme': 'カラースキーム',
            'Choose the perfect color mode for your app': 'アプリに最適なカラーモードを選択',
            Light: 'ライト',
            Dark: 'ダーク',
            'RTL Mode': 'RTLモード',
            'Switch your language direction': '言語の方向を切り替える',
            'Fluid Layout': '流動レイアウト',
            'Toggle container layout system': 'コンテナレイアウトシステムを切り替える',
            'Navigation Position': 'ナビゲーションバー位置',
            'Vertical': '垂直',
            'Top': '上部',
            'Combo': 'コンボ',
            'Transparent': '透明',
            'Inverted': '反転色',
            'Card': 'カード',
            'Vibrant': '鮮やか',
            'Select a suitable navigation system for your web application': 'Webアプリケーションに適したナビゲーションバーシステムを選択',
            'Vertical Nav': '垂直ナビゲーションバー',
            'Top Nav': '上部ナビゲーションバー',
            'Vertical Navbar Style': '垂直ナビゲーションバースタイル',
            'Switch between styles for your vertical navbar': '垂直ナビゲーションバーのスタイルを切り替える',
            Language: '言語',
            'Switch between languages': '言語を切り替える',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'このシステムが気に入りましたか？',
            'Get MyEMS now': 'MyEMSを今すぐ入手',
            'PQ.About': '本分析は電圧偏差、電圧不平衡、周波数偏差、電流不平衡を対象とします。電圧偏差は(U−Un)/Un×100%で計算されます。周波数偏差は|f−fn|で計算されます。三相不平衡はmax(|Xi−Xavg|)/Xavg×100%で計算され、三相チャネルのタイムアライメントが要求されます。結果は、選択された計量メータの報告期間内の時系列データに基づきます。三相チャネルが不足している場合やタイムスタンプが同期していない場合は、不平衡指標がスキップされます。過渡的なスパイクやサンプリング欠落は最悪値を増幅する可能性があり、定常状態の評価にはコンプライアンス率やP95などの統計指標を参照することをお勧めします。',
            Purchase: 'エンタープライズ版を購入',
            ContactInfo: '連絡先情報',
            ProductWebsite: '製品サイト',
            CompanyWebsite: '会社サイト',
            SalesPhone: '営業電話',
            // Query Panels
            'Base Period Begins': '基準期間開始',
            'Base Period Ends': '基準期間終了',
            'Comparison Types': '比較タイプ',
            'Year-Over-Year': '前年比',
            'Month-On-Month': '前月比',
            'Free Comparison': '自由比較',
            'None Comparison': '比較なし',
            'Reporting Period Begins': '報告期間開始',
            'Reporting Period Ends': '報告期間終了',
            '(Optional)': '(オプション)',
            'Period Types': '時間尺度',
            Yearly: '年',
            Monthly: '月',
            Weekly: '週',
            Daily: '日',
            Hourly: '時間',
            Submit: '送信',
            'Input Energy Category': '消費エネルギー分類',
            'Output Energy Category': '産出エネルギー分類',
            'Fraction Parameter': '分数パラメータ',
            Search: '検索',
            //DateRangePicker
            sunday: '日',
            monday: '月',
            tuesday: '火',
            wednesday: '水',
            thursday: '木',
            friday: '金',
            saturday: '土',
            ok: '確定',
            today: '今日',
            yesterday: '昨日',
            hours: '時',
            minutes: '分',
            seconds: '秒',
            last7Days: '過去7日間',
            'Select Date Range': '日付範囲を選択',
            //Card Summaries and Line Charts
            'Base Period': '基準期間',
            'Reporting Period': '報告期間',
            'Per Unit Area': '単位面積あたり',
            'Per Capita': '一人あたり',
            'Per Unit Production': '単位製品あたり',
            Baseline: 'ベースライン値',
            Actual: '実績値',
            'Baseline Value - Actual Value': 'ベースライン値 - 実績値',
            'Average Load': '平均負荷',
            'Maximum Load': '最大負荷',
            'Load Factor': '負荷率',
            'Ratio of Average Load to Maximum Load': '平均負荷と最大負荷の比率',
            'Carbon Dioxide Emissions by Energy Category': '二酸化炭素排出割合',
            'Costs by Energy Category': 'コスト割合',
            'Incomes by Energy Category': '収入割合',
            'Electricity Consumption by Time-Of-Use': '時間帯別消費電力量',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': '時間帯別電力使用による二酸化炭素排出',
            'Electricity Cost by Time-Of-Use': '時間帯別電力コスト',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} 項目別消費割合',
            'Ton of Standard Coal by Energy Category': 'トン標準炭(TCE)割合',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'トン二酸化炭素排出(TCO2E)割合',
            'Reporting Period Consumption CATEGORY UNIT': '報告期間消費 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': '報告期間予測 {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} 報告期間消費 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間消費 {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': '報告期間生産量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': '基準期間生産量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': '報告期間消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': '報告期間予測 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': '基準期間消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': '報告期間予測 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': '報告期間消費 {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '報告期間消費 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': '基準期間消費 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': '子空間分類割合 {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': '子空間合計割合',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '報告期間二酸化炭素排出 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                '報告期間二酸化炭素排出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '基準期間二酸化炭素排出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': '報告期間コスト {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': '報告期間コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': '基準期間コスト {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': '報告期間産出 {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} 報告期間産出 {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間産出 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': '報告期間産出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': '基準期間産出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': '報告期間収入 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': '報告期間収入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': '基準期間収入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': '報告期間総収入 {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': '報告期間累積効率 {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} 報告期間累積効率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間累積総合効率 {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 報告期間累積総合効率 {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} 基準期間累積総合効率 {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': '瞬時効率 {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 瞬時効率 {{UNIT}}',
            'Equipment Efficiency Indicator': '設備エネルギー効率指標',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 瞬時総合効率 {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': '報告期間累積効率 {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '報告期間累積効率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': '基準期間累積効率 {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': '基準期間累積効率 {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': '基準期間 {{CATEGORY}} 最大負荷 {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': '報告期間 {{CATEGORY}} 最大負荷 {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': '報告期間 {{CATEGORY}} 平均負荷 {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': '報告期間 {{CATEGORY}} 負荷率',
            'Base Period CATEGORY Average Load VALUE UNIT': '基準期間 {{CATEGORY}} 平均負荷 {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': '報告期間 {{CATEGORY}} 平均値 {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': '報告期間 {{CATEGORY}} 最大値 {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': '報告期間 {{CATEGORY}} 最小値 {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': '報告期間 {{CATEGORY}} 算術平均 {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': '報告期間 {{CATEGORY}} 中央値 {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': '報告期間 {{CATEGORY}} 標本標準偏差 {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': '報告期間 {{CATEGORY}} 標本分散 {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '報告期間節約 {{CATEGORY}} (ベースライン-実績) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '報告期間減少 {{CATEGORY}} (ベースライン-実績) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': '報告期間節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': '基準期間節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': '報告期間総メータ消費 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '報告期間総メータ消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': '報告期間サブメータ消費 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': '報告期間サブメータ消費 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': '報告期間差 {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': '報告期間差百分比',
            'Reporting Period Difference CATEGORY VALUE UNIT': '報告期間差 {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': '傾向値',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': '故障リスト',
            'Reporting Period Number of Fault VALUE': '報告期間故障数: {{VALUE}}',
            'All Faults': '全故障',
            'Space Faults': '空間故障',
            'Number of All Faults': '全故障数',
            'Number of Space Faults': '空間故障数',
            'Total Number of Faults': '総故障数量',
            'Number of New Faults': '新規故障数量',
            'Number of Inprogress Faults': '進行中故障数量',
            'Number of Done Faults': '完了済み故障数量',
            //Data Panels
            'Ton of Standard Coal': 'トン標準炭',
            'Ton of Carbon Dioxide Emissions': 'トン二酸化炭素排出',
            'Carbon Emissions Per Unit Of Energy Consumption': '単位エネルギー消費当たり炭素排出',
            'Operating Characteristic Curve': '運転曲線',
            Tariff: '料率',
            'Detailed Data': '詳細データ',
            'Child Spaces Data': '子空間データ',
            'Associated Equipment Data': '関連設備データ',
            'This Year': '本年',
            'The Same Period Last Year': '前年同期',
            'This Month': '今月',
            'This Day': '本日',
            Total: '合計',
            'No data found': 'データがありません',
            Export: 'エクスポート',
            Datetime: '日時',
            'Time-Of-Use Type': '時間帯タイプ',
            'Top-Peak': 'ピーク',
            'On-Peak': 'オン・ピーク',
            'Mid-Peak': 'ミッド・ピーク',
            'Off-Peak': 'オフ・ピーク',
            'Deep': '深夜',
            Percentage: '百分比',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'エネルギー値ポイントの過去1時間傾向',
            Circuit: '回路',
            Point: 'データポイント',
            'Realtime Value': 'リアルタイム値',
            //Meter Tracking
            'Meter List': '計量メータリスト',
            'Edit Meter': '編集',
            'Start Value': '開始値',
            'End Value': '終了値',
            'Difference Value': '差額',
            'Start Integrity Rate': '開始データ完全性率(%)',
            'End Integrity Rate': '終了データ完全性率(%)',
            'Full Integrity Rate': '全体データ完全性率(%)',
            //Equipment Tracking
            'Equipment List': '設備リスト',
            'Edit Equipment': '編集',
            //Profile Dropdown
            Feedback: 'フィードバック',
            'Account Settings': 'アカウント設定',
            Logout: 'ログアウト',
            //Authentication
            'Log in': 'ログイン',
            'Email address': '電子メールアドレス',
            'Phone Number': '電話番号',
            Password: 'パスワード',
            CaptchaCode: '認証コード',
            Refresh: '更新',
            'Remember me': 'ログイン状態を保持',
            'Logged in as ': 'ログイン済み ',
            'Forgot Password?': 'パスワードをお忘れですか？',
            'Forgot your password?': 'パスワードをお忘れですか？',
            "Enter your email and we'll send you a reset link": '電子メールアドレスを入力すると、リセットリンクを送信します',
            "Enter your email and we'll send you a registration link": '電子メールアドレスを入力すると、登録リンクを送信します',
            'Reset Password': 'パスワードリセット',
            'Thanks for using MyEMS!': 'MyEMSをご利用いただきありがとうございます！',
            'You are now successfully signed out': '正常にログアウトしました',
            'Return to Login': 'ログイン画面に戻る',
            'Please check your email!': '電子メールを確認してください！',
            'An email has been sent to ': '電子メールが送信されました ',
            'Please click on the included link to reset your password': '含まれるリンクをクリックしてパスワードをリセットしてください',
            'Please click on the included link to register your account': '含まれるリンクをクリックしてアカウントを登録してください',
            'An email with password reset link is sent to ': 'パスワードリセットリンク付きの電子メールが送信されました ',
            'Change Password': 'パスワード変更',
            'Old Password': '旧パスワード',
            'New Password': '新パスワード',
            'Confirm Password': '新パスワード確認',
            'Update Password': 'パスワード更新',
            'Password has been changed!': 'パスワードが変更されました！',
            'Verification code has been sent to your inbox. \
            Please copy it to the input box below.':
                '認証コードが受信箱に送信されました。下記の入力ボックスにコピーしてください。',
            'New to MyEMS': 'MyEMSを初めてお使いの方',
            'Create an account': 'アカウント登録',
            'EMAIL Account registration successful': '{{EMAIL}}アカウント登録成功',
            'Thanks for verifying your account!': 'アカウントの認証ありがとうございます！',
            'Your code is': 'コードは次のとおりです',
            'Send verification code': '認証コードを送信',
            'Please wait for NUMBER seconds': '{{NUMBER}}秒お待ちください',
            'Password reset': 'パスワードリセット',
            'Please wait for approval': '承認をお待ちください',
            //notification
            Notifications: '通知',
            'Mark all as read': 'すべて既読にする',
            'View all': 'すべて表示',
            'Notification New': '新着',
            'Notification Earlier': '以前のもの',
            'Notification List': '通知リスト',
            'Bulk actions': '一括操作',
            'Notification Subject': '件名',
            'Notification Created Datetime': '作成日時',
            'Notification Message': '内容',
            'Notification Priority': '優先度',
            'Notification Status': 'ステータス',
            'Notification Mark As Read': '既読にする',
            'Notification Mark As Acknowledged': '確認',
            'Notification Low': '低',
            'Notification Medium': '中',
            'Notification High': '高',
            'Notification Critical': '重大',
            'Notification Unread': '未読',
            'Notification Read': '既読',
            'Notification Acknowledged': '確認済み',
            'Notification Archive': 'アーカイブ',
            'Notification Delete': '削除',
            'Notification Apply': '適用',
            'Notification Start Datetime': '開始日時',
            'Notification End Datetime': '終了日時',
            'Notification Update Datetime': '更新日時',
            //Monitoring
            'Run Commands': 'コマンド実行',
            'Pin Code': 'パスコード',
            'Unlock': 'ロック解除',
            'Set Value': '設定値',
            'Fault Alarms': '故障アラーム',
            'Instantaneous Efficiency VALUE UNIT': '瞬時効率 {{VALUE}} {{UNIT}}',
            'Communication Status': '通信ステータス',
            'Communication Online': 'オンライン',
            'Communication Offline': 'オフライン',
            'Equipment Status': '設備ステータス',
            'Equipment Running': '運転中',
            'Equipment Stopped': '停止中',
            'Show Up to': 'ページあたり表示数',
            All: 'すべて',
            'FROM - TO of TOTAL': '現在表示中 {{FROM}} - {{TO}} 合計{{TOTAL}}',
            //Microgrid
            'Microgrid Energy': '電力量',
            'Microgrid Revenue': '収益',
            'Microgrid Carbon': '炭素排出',
            'Photovoltaic Generation': '太陽光発電量',
            'EV Charger Consumption': '充電スタンド消費電力量',
            'Load Consumption': '負荷消費電力量',
            'Grid Buy': 'グリッドから購入電力量',
            'Grid Sell': 'グリッドへ販売電力量',
            'EV Charger': '充電スタンド',
            'Heat Pump': 'ヒートポンプ',
            'Photovoltaic': '太陽光発電',
            'PCS Run State': 'PCS運転状態',
            'PCS Unknown': '不明',
            'PCS Initializing': '初期起動',
            'PCS Standby': '待機中',
            'PCS Shutdown': '停止',
            'PCS Fault': '故障',
            'PCS Running': '運転中',
            'Battery Power': 'バッテリー電力',
            'Photovoltaic Power': '太陽光発電電力',
            'Grid Power': 'グリッド電力',
            'Load Power': '負荷電力',
            Reporting: 'データレポート',
            Maintenance: 'メンテナンス',
            'General Information': '基本情報',
            'Serial Number': 'シリアル番号',
            Address: '住所',
            'Postal Code': '郵便番号',
            'Rated Capacity': '定格容量',
            'Rated Power': '定格出力',
            Latitude: '緯度',
            Longitude: '経度',
            'Strategy Management': '戦略管理',
            'Charging Schedule': '充電スケジュール',
            'Charge Start Time': '充電開始時間',
            'Charge End Time': '充電終了時間',
            'Discharge Start Time': '放電開始時間',
            'Discharge End Time': '放電終了時間',
            'Total Rated Power': '総定格出力',
            'Total Rated Capacity': '総定格容量',
            // Energy Indicator
            "Today's Charge": "本日充電量",
            "Today's Discharge": "本日放電量",
            "Today's Generation": "本日発電量",
            'Total Fuel Consumption': '総燃料消費量',
            'Total Charge': '総充電量',
            'Total Discharge': '総放電量',
            'Total Generation': '総発電量',
            'Total Revenue': '総収益',
            'Total Photovoltaic Generation': '総太陽光発電量',
            'Total EV Charger Consumption': '充電スタンド総消費電力量',
            'Total Load Consumption': '負荷総消費電力量',
            'Total Grid Buy': 'グリッドから購入総電力量',
            'Total Grid Sell': 'グリッドへ販売総電力量',
            'Total Efficiency': '総合効率',
            'Discharge Achievement Rate': '放電達成率',
            // Revenue Indicator
            "Today's Cost": "本日コスト",
            "Today's Income": "本日収入",
            "Total Cost": "累積コスト",
            "Total Income": "累積収入",
            "Today's Revenue": "本日利益",

            'Revenue Ranking': '収益ランキング',
            'Efficiency Ranking': '効率ランキング',
            'Charge Ranking': '充電ランキング',
            'Discharge Ranking': '放電ランキング',
            'Number of Microgrids': 'マイクログリッド数',
            'Number of Power Stations': '発電所数',
            'Microgrid List': 'マイクログリッドリスト',
            'Select Microgrid': 'マイクログリッドを選択',
            'Previous Page': '前のページ',
            'Next Page': '次のページ',
            '7 Days': '7日間',
            'Charge UNIT': '充 {{UNIT}}',
            'Discharge UNIT': '放 {{UNIT}}',
            'Generation UNIT': '発電 {{UNIT}}',
            'Energy Indicator': 'エネルギー',
            'Revenue Indicator': '収益',
            'Carbon Indicator': '炭素',

            // Energy Storage Power Station
            'Battery Operating State': 'バッテリー運転状態',
            'Battery State': 'バッテリー状態',
            'Battery Unknown': '不明',
            'Battery Stopped': '停止',
            'Battery Reserved': 'Reserved', // 0
            'Battery Fault': '故障', // 1
            'Battery Warning': '警告', // 2
            'Battery Standby': '待機中', // 3
            'Battery Prohibit DisCharging': '放電禁止', // 4
            'Battery Prohibit Charging': '充電禁止', // 5
            'Battery Normal': '正常', // 6
            'Battery Charging': '充電中', // 7
            'Battery Discharging': '放電中', // 8
            'Battery Idle': 'アイドル', // 9
            'Phase of Lifecycle': '段階',
            'Use Phase': '運用',
            'Commissioning Phase': '試運転',
            'Commissioning Date': '起動日',
            'Installation Phase': '建設中',
            'Device Status': 'デバイスステータス',
            'Basic Information': '基本情報',
            'Gateway': 'ゲートウェイ',
            'Grid Meter': 'グリッドメータ',
            'Load Meter': '負荷メータ',
            'ESS Meter': 'エネルギー貯蔵メータ',
            'Total Active Power': '総有効電力',
            'Active Power A': 'A相有効電力',
            'Active Power B': 'B相有効電力',
            'Active Power C': 'C相有効電力',
            'Total Reactive Power': '総無効電力',
            'Reactive Power A': 'A相無効電力',
            'Reactive Power B': 'B相無効電力',
            'Reactive Power C': 'C相無効電力',
            'Total Apparent Power': '総皮相電力',
            'Apparent Power A': 'A相皮相電力',
            'Apparent Power B': 'B相皮相電力',
            'Apparent Power C': 'C相皮相電力',
            'Total Power Factor': '総力率',
            'Active Energy Import': '正方向有効電力量',
            'Active Energy Export': '逆方向有効電力量',
            'Active Energy Net': '正味有効電力量',

            'Generator': '発電機',

            // Photovoltaic Power Station
            'Invertor': 'インバーター',
            'Invertor Run State': 'インバーター運転状態',
            'Invertor Unknown': '不明',
            'Invertor Initializing': '初期起動',
            'Invertor Standby': '待機中',
            'Invertor Shutdown': '停止',
            'Invertor Fault': '故障',
            'Invertor Running': '運転中',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': '生成日時',
            'File Format': 'ファイル形式',
            'File Size': 'ファイルサイズ',
            Uploader: 'アップロード者',
            'Upload Datetime': 'アップロード日時',
            //Error
            "The page you're looking for is not found": 'お探しのページは見つかりません',
            "Make sure the address is correct and that the page hasn't moved": 'アドレスが正しく、ページが移動していないことを確認してください',
            'If you think this is a mistake,': '間違いだと思われる場合は、',
            'contact us': 'お問い合わせください',
            'Take me home': 'ホームに戻る',
            'Whoops, something went wrong!': 'おっと、何か問題が発生しました！',
            'Try refreshing the page, or going back and attempting the action again':
                'ページを更新するか、戻って再度操作を試みてください',
            'If this problem persists,': 'この問題が続く場合は、',
            'Captcha Error': '認証コードエラー',
            'Confirm Password Error': 'パスワードが一致しません',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                '無効なパスワードリセットリンクをクリックしたようです。もう一度お試しください。',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                '無効なアカウント登録リンクをクリックしたようです。もう一度お試しください。',
            //Tenant Bill
            'Lease Contract Number': '賃貸契約番号',
            Download: 'ダウンロード',
            Print: '印刷',
            'Payment Notice': '支払通知書',
            'Bill To': '宛先',
            'Bill Number': '請求書番号',
            'Bill Date': '請求書日付',
            'Payment Due Date': '支払期日',
            'Amount Payable': '支払金額',
            'Billing Period Start': '請求期間開始日',
            'Billing Period End': '請求期間終了日',
            Quantity: '数量',
            Price: '単価',
            Unit: '単位',
            Amount: '金額',
            Subtotal: '小計',
            'VAT Output Tax': '消費税（売上税）',
            'Total Amount Payable': '支払総額',
            'Please make sure to pay on or before the payment due date above': '上記の支払期日までにお支払いください',
            'Send money to the following account': '次の口座へお振り込みください',
            'Account Name': '口座名義',
            'Bank Name': '銀行名',
            'Bank Address': '銀行住所',
            'RMB Account': '人民元口座',
            // button
            'Toggle Navigation': 'ナビゲーション切り替え',
            // working calendar
            'Working Days': '営業日',
            'Non Working Days': '非営業日',
            'Select Row': '操作するデータ行を選択してください',
            // Offline Meter Input
            'Daily Value': '日次データ',
            Date: '日付',
            'Successfully Saved': '保存成功',
            'Previous Data Is Empty': '以前のデータが空です',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': '管理者セッションが存在しません',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': '管理者セッションがタイムアウトしました',
            'API.ADVANCED_REPORT_NOT_FOUND': '高度レポートが存在しません',
            'API.API_KEY_HAS_EXPIRED': 'Key has expired',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
            'API.API_KEY_NOT_FOUND': 'Key not found',
            'API.BAD_REQUEST': '不正なリクエスト',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
            'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': '既にサブメータとして設定されている計量メータを総メータに設定できません',
            'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': '複合設備コマンド関係が存在します',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': '複合設備と設備の関係が既に存在します',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': '複合設備と設備の関係が存在しません',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': '複合設備と計量メータの関係が既に存在します',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': '複合設備と計量メータの関係が存在しません',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': '複合設備名称が既に使用されています',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': '複合設備が存在しません',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '複合設備とオフラインメータの関係が既に存在します',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '複合設備とオフラインメータの関係が存在しません',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '複合設備関連パラメータ名称が既に使用されています',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '複合設備関連パラメータが存在しないか、一致しません',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '複合設備と仮想メータの関係が既に存在します',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '複合設備と仮想メータの関係が存在しません',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
            'API.COMMAND_NOT_FOUND': 'Command not  found',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': '連絡先名が既に使用されています',
            'API.CONTACT_NOT_FOUND': '連絡先が存在しません',
            'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'コストセンター外部IDが既に存在します',
            'API.COST_CENTER_NAME_EXISTS': 'コストセンター名称が既に存在します',
            'API.COST_CENTER_NOT_FOUND': 'コストセンターが存在しません',
            'API.COST_FILE_NOT_FOUND': 'コストファイルが存在しません',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'データソース名称が既に使用されています',
            'API.DATA_SOURCE_NOT_FOUND': 'データソースが存在しません',
            'API.DATABASE_ERROR': 'データベースエラー',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': '日付が既に営業日カレンダーに存在します',
            'API.DATE_LOCAL_NOT_FOUND': 'ローカル日付が見つかりません',
            'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': '配電回路名称が既に使用されています',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': '配電回路が存在しません',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': '配電回路とデータポイントの関係が既に存在します',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': '配電回路とデータポイントの関係が存在しません',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': '配電システム名称が既に使用されています',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': '配電システムが存在しません',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
            'API.EMAIL_IS_ALREADY_IN_USE': '電子メールアドレスが既に使用されています',
            'API.EMAIL_MESSAGE_NOT_FOUND': '電子メールメッセージが存在しません',
            'API.EMAIL_NOT_FOUND': '電子メールアドレスが存在しません',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'メールサーバーホストが既に使用されています',
            'API.EMAIL_SERVER_NOT_FOUND': 'メールサーバーホストが存在しません',
            'API.EMPTY_VARIABLES_ARRAY': '空の変数配列',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'エネルギー分類名称が既に使用されています',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'エネルギー分類が存在しません',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'エネルギー分類がエネルギー項目で既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'エネルギー分類が計量メータで既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'エネルギー分類がオフラインメータで既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'エネルギー分類が料率で既に使用されています',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'エネルギー分類が仮想メータで既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'エネルギー流れ図リンクが既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'エネルギー流れ図リンクが存在しないか、一致しません',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'エネルギー流れ図名称が既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'エネルギー流れ図ノードが既に使用されています',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'エネルギー流れ図ノードが存在しないか、一致しません',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'エネルギー流れ図が存在しません',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'エネルギー項目はエネルギー分類に属していません',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'エネルギー項目はエネルギー分類に属していません',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'エネルギー項目が既に使用されています',
            'API.ENERGY_ITEM_NOT_FOUND': 'エネルギー項目が存在しません',
            'API.ENERGY_ITEM_USED_IN_METER': 'エネルギー項目が計量メータで既に使用されています',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'エネルギー項目がオフラインメータで既に使用されています',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'エネルギー項目が仮想メータで既に使用されています',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
            'API.EQUIPMENT_METER_RELATION_EXISTS': '設備と計量メータの関係が既に存在します',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': '設備と計量メータの関係が存在しません',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': '設備名称が既に使用されています',
            'API.EQUIPMENT_NOT_FOUND': '設備が存在しません',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '設備とオフラインメータの関係が既に存在します',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '設備とオフラインメータの関係が存在しません',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '設備関連パラメータ名称が既に使用されています',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '設備関連パラメータが存在しないか、一致しません',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '設備と仮想メータの関係が既に存在します',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '設備と仮想メータの関係が存在しません',
            'API.ERROR': 'エラー',
            'API.EXCEPTION': '例外',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
            'API.FAILED_TO_RESTORE_COST_FILE': 'コストファイルの復元に失敗しました',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'ナレッジファイルの復元に失敗しました',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'オフラインメータファイルの復元に失敗しました',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'オフラインメータファイルの保存に失敗しました',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'コストファイルのアップロードに失敗しました',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'ナレッジファイルのアップロードに失敗しました',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'オフラインメータファイルのアップロードに失敗しました',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'ゲートウェイ名称が既に使用されています',
            'API.GATEWAY_NOT_FOUND': 'ゲートウェイが存在しません',
            'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
            'API.INVALID_': '無効な ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
            'API.INVALID_ADDRESS': '無効なアドレス',
            'API.INVALID_ADDRESS_VALUE': '無効なアドレス値',
            'API.INVALID_ADVANCED_REPORT_ID': '無効な高度レポートID',
            'API.INVALID_API_KEY_ID': 'Invalid api key id',
            'API.INVALID_API_KEY_NAME': 'Invalid api key name',
            'API.INVALID_AREA_VALUE': '無効な面積値',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
            'API.INVALID_BASE_PERIOD_END_DATETIME': '無効な基準期間終了日時',
            'API.INVALID_BASE_PERIOD_START_DATETIME': '無効な基準期間開始日時',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
            'API.INVALID_BAUD_RATE': '無効なボーレート',
            'API.INVALID_BUILDINGS_VALUE': '無効な建物値',
            'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
            'API.INVALID_CAPACITY': 'Invalid capacity',
            'API.INVALID_CATEGORY': '無効なカテゴリー',
            'API.INVALID_CHANNEL': '無効なチャネル',
            'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
            'API.INVALID_COMBINED_EQUIPMENT_ID': '無効な複合設備ID',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': '無効な複合設備名称',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': '無効な複合設備関連パラメータID',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': '無効な複合設備関連パラメータ名称',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': '無効な複合設備関連パラメータタイプ',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': '無効な複合設備UUIDs',
            'API.INVALID_COMMAND_ID': 'Invalid command id',
            'API.INVALID_COMMAND_NAME': 'Invalid command name',
            'API.INVALID_CONNECTION': '無効な接続',
            'API.INVALID_CONSTANT_VALUE': '無効な定数値',
            'API.INVALID_CONTACT_ID': '無効な連絡先ID',
            'API.INVALID_CONTACT_NAME': '無効な連絡先名',
            'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
            'API.INVALID_COST_CENTER_ID': '無効なコストセンターID',
            'API.INVALID_COST_FILE_ID': '無効なコストファイルID',
            'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
            'API.INVALID_DATA_SOURCE_ID': '無効なデータソースID',
            'API.INVALID_DATA_SOURCE_NAME': '無効なデータソース名称',
            'API.INVALID_DATA_SOURCE_PROTOCOL': '無効なデータソースプロトコル',
            'API.INVALID_DATE_LOCAL': '無効なローカル日付',
            'API.INVALID_DENOMINATOR_METER_UUID': '無効な基準計量メータUUID',
            'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
            'API.INVALID_DISPLAY_NAME': '無効な表示名',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': '無効な配電回路ID',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': '無効な配電回路名称',
            'API.INVALID_DISTRIBUTION_ROOM': '無効な配電室',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': '無効な配電システムID',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': '無効な配電システム名称',
            'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
            'API.INVALID_EMAIL': '無効なメールアドレス',
            'API.INVALID_EMAIL_MESSAGE_ID': '無効な電子メールID',
            'API.INVALID_EMAIL_SERVER_HOST': '無効な電子メールサーバーホスト',
            'API.INVALID_EMAIL_SERVER_ID': '無効な電子メールサーバーID',
            'API.INVALID_END_DATE_FORMAT': '無効な終了日付形式',
            'API.INVALID_END_DATETIME': '無効な終了日時',
            'API.INVALID_ENERGY_CATEGORY_ID': '無効なエネルギー分類ID',
            'API.INVALID_ENERGY_CATEGORY_NAME': '無効なエネルギー分類名称',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': '無効なエネルギー流れ図ID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': '無効なエネルギー流れ図リンクID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': '無効なエネルギー流れ図名称',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': '無効なエネルギー流れ図ノードID',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': '無効なエネルギー流れ図ノード名称',
            'API.INVALID_ENERGY_ITEM_ID': '無効なエネルギー項目ID',
            'API.INVALID_ENERGY_ITEM_NAME': '無効なエネルギー項目名称',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
            'API.INVALID_EQUATION_IN_EXPRESSION': '式内の無効な方程式',
            'API.INVALID_EQUIPMENT_ID': '無効な設備ID',
            'API.INVALID_EQUIPMENT_NAME': '無効な設備名称',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': '無効な設備関連パラメータID',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': '無効な設備関連パラメータ名称',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': '無効な設備関連パラメータタイプ',
            'API.INVALID_EQUIPMENT_UUID': '無効な設備UUID',
            'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
            'API.INVALID_EXPRESSION': '無効な式',
            'API.INVALID_EXPRESSION_OBJECT': '無効な式オブジェクト',
            'API.INVALID_FDD_CODE': '無効な故障エラーコード',
            'API.INVALID_FLOORS_VALUE': '無効な階数値',
            'API.INVALID_FROM_ADDR': '無効なアドレス',
            'API.INVALID_GATEWAY_ID': '無効なゲートウェイID',
            'API.INVALID_GATEWAY_NAME': '無効なゲートウェイ名称',
            'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': '無効な時間上限値',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': '無効な時間下限値',
            'API.INVALID_Id': 'Invalid id',
            'API.INVALID_IS_ADMIN_VALUE': '無効な管理値',
            'API.INVALID_IS_COST_DATA_DISPLAYED': '無効なコストデータ表示フラグ',
            'API.INVALID_IS_COUNTED_VALUE': '無効な計上値',
            'API.INVALID_IS_ENABLED': '無効な有効化フラグ',
            'API.INVALID_IS_HIDDEN': '無効な非表示フラグ',
            'API.INVALID_IS_IN_LEASE_VALUE': '無効な賃貸中フラグ',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': '無効な入力計上フラグ',
            'API.INVALID_IS_KEY_TENANT_VALUE': '無効な主力テナントフラグ',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': '無効な出力計上フラグ',
            'API.INVALID_IS_OUTPUT_VALUE': '無効な出力計上フラグ',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
            'API.INVALID_IS_TREND_VALUE': '無効な傾向保存フラグ',
            'API.INVALID_IS_VIRTUAL_VALUE': '無効な仮想ポイントフラグ',
            'API.INVALID_KGCE': '無効なキログラム標準炭係数',
            'API.INVALID_KGCO2E': '無効なキログラム二酸化炭素排出係数',
            'API.INVALID_KNOWLEDGE_FILE_ID': '無効なナレッジファイルID',
            'API.INVALID_LATITUDE_VALUE': '無効な緯度値',
            'API.INVALID_LEASE_NUMBER_VALUE': '無効なリース番号',
            'API.INVALID_LONGITUDE_VALUE': '無効な経度値',
            'API.INVALID_LOW_LIMIT_VALUE': '無効な下限値',
            'API.INVALID_MASTER_METER_ID': '無効な総計量メータID',
            'API.INVALID_MENU_ID': '無効なメニューID',
            'API.INVALID_MESSAGE_DATA': 'Invalid message data',
            'API.INVALID_MESSAGE_TEMPLATE': '無効なメッセージテンプレート',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
            'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
            'API.INVALID_METER_ID': '無効な計量メータID',
            'API.INVALID_METER_NAME': '無効な計量メータ名称',
            'API.INVALID_METER_UUID': '無効な計量メータUUID',
            'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
            'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
            'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
            'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
            'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
            'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
            'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
            'API.INVALID_NAME_VALUE': '無効な名称値',
            'API.INVALID_NEW_PASSWORD': '無効な新パスワード',
            'API.INVALID_NON_WORKING_DAY_ID': '無効な非営業日ID',
            'API.INVALID_NOTIFICATION_ID': '無効な通知ID',
            'API.INVALID_NUMERATOR_METER_UUID': '無効な分子メータUUID',
            'API.INVALID_OBJECT_TYPE': '無効なオブジェクトタイプ',
            'API.INVALID_OFFLINE_METER_DATA': '無効なオフラインメータデータ',
            'API.INVALID_OFFLINE_METER_FILE_ID': '無効なオフラインメータファイルID',
            'API.INVALID_OFFLINE_METER_ID': '無効なオフラインメータID',
            'API.INVALID_OFFLINE_METER_NAME': '無効なオフラインメータ名称',
            'API.INVALID_OFFLINE_METER_UUID': '無効なオフラインメータUUID',
            'API.INVALID_OFFSET_CONSTANT_VALUE': '無効なオフセット定数',
            'API.INVALID_OLD_PASSWORD': '無効な旧パスワード',
            'API.INVALID_OPENID': 'Invalid openid',
            'API.INVALID_PARENT_SPACE_ID': '無効な親空間ID',
            'API.INVALID_PASSWORD': '無効なパスワード',
            'API.INVALID_PAYLOAD': 'Invalid payload',
            'API.INVALID_PEAK_CURRENT': '無効なピーク電流',
            'API.INVALID_PEAK_LOAD': '無効なピーク負荷',
            'API.INVALID_PERIOD_TYPE': '無効な期間タイプ',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
            'API.INVALID_POINT_ID': '無効なデータポイントID',
            'API.INVALID_POINT_NAME': '無効なデータポイント名称',
            'API.INVALID_PORT': '無効なポート',
            'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
            'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
            'API.INVALID_PRIORITY': '無効な優先度',
            'API.INVALID_PRIVILEGE': '無効な権限',
            'API.INVALID_PRIVILEGE_DATA': '無効な権限データ',
            'API.INVALID_PRIVILEGE_ID': '無効な権限ID',
            'API.INVALID_PRIVILEGE_NAME': '無効な権限名称',
            'API.INVALID_RATIO_VALUE': '無効な変圧比',
            'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
            'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
            'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
            'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
            'API.INVALID_REPLY': '無効な返信',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': '無効な報告期間終了日時',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': '無効な報告期間開始日時',
            'API.INVALID_REQUIRES_AUTHENTICATION': '無効な認証必要フラグ',
            'API.INVALID_ROOMS_VALUE': '無効な部屋数値',
            'API.INVALID_RULE_ID': '無効なルールID',
            'API.INVALID_RULE_NAME': '無効なルール名称',
            'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
            'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
            'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
            'API.INVALID_SENSOR_ID': '無効なセンサーID',
            'API.INVALID_SENSOR_NAME': '無効なセンサー名称',
            'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
            'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
            'API.INVALID_SERIAL_PORT': '無効なシリアルポート',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'セッションが無効です、再ログインしてください',
            'API.INVALID_SET_VALUE': 'Invalid set value',
            'API.INVALID_SHOPFLOOR_ID': '無効な現場ID',
            'API.INVALID_SHOPFLOOR_NAME': '無効な現場名称',
            'API.INVALID_SHOPFLOOR_UUID': '無効な現場UUID',
            'API.INVALID_SOURCE_NODE_ID': '無効なソースノードID',
            'API.INVALID_SPACE_ID': '無効な空間ID',
            'API.INVALID_SPACE_NAME': '無効な空間名称',
            'API.INVALID_SPACE_UUID': '無効な空間UUID',
            'API.INVALID_START_DATE_FORMAT': '無効な開始日付形式',
            'API.INVALID_START_DATETIME': '無効な開始日時',
            'API.INVALID_STATUS': '無効なステータス',
            'API.INVALID_STORE_ID': '無効な店舗ID',
            'API.INVALID_STORE_NAME': '無効な店舗名称',
            'API.INVALID_STORE_TYPE_DESCRIPTION': '無効な店舗タイプ説明',
            'API.INVALID_STORE_TYPE_ID': '無効な店舗タイプID',
            'API.INVALID_STORE_TYPE_NAME': '無効な店舗タイプ名称',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': '無効な店舗タイプ簡略コード',
            'API.INVALID_STORE_UUID': '無効な店舗UUID',
            'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
            'API.INVALID_SVG': '無効なSVG',
            'API.INVALID_SWITCHGEAR': '無効な開閉装置',
            'API.INVALID_TARGET_NODE_ID': '無効なターゲットノードID',
            'API.INVALID_TARIFF_BLOCK_PRICING': '無効な段階料率価格設定',
            'API.INVALID_TARIFF_ID': '無効な料率ID',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': '無効な時間帯別料率価格設定',
            'API.INVALID_TARIFF_TYPE': '無効な料率タイプ',
            'API.INVALID_TENANT_ID': '無効なテナントID',
            'API.INVALID_TENANT_NAME': '無効なテナント名称',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': '無効なテナントタイプ説明',
            'API.INVALID_TENANT_TYPE_ID': '無効なテナントタイプID',
            'API.INVALID_TENANT_TYPE_NAME': '無効なテナントタイプ名称',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': '無効なテナントタイプ簡略コード',
            'API.INVALID_TENANT_UUID': '無効なテナントUUID',
            'API.INVALID_TEXT_MESSAGE_ID': '無効なSMS ID',
            'API.INVALID_TIMEZONE_ID': '無効なタイムゾーンID',
            'API.INVALID_TOKEN': '無効なトークン',
            'API.INVALID_TOPIC': 'Invalid topic',
            'API.INVALID_UNIT_OF_MEASURE': '無効な測定単位',
            'API.INVALID_UNIT_OF_PRICE': '無効な価格単位',
            'API.INVALID_UNITS': '無効な単位',
            'API.INVALID_USER_ID': '無効なユーザーID',
            'API.INVALID_USER_NAME': '無効なユーザー名称',
            'API.INVALID_USER_NAME_OR_EMAIL': '無効なユーザー名称またはメールアドレス',
            'API.INVALID_USER_PHONE': '無効なユーザー電話番号',
            'API.INVALID_USER_PLEASE_RE_LOGIN': '無効なユーザー、再ログインしてください',
            'API.INVALID_USER_UUID': '無効なユーザーUUID',
            'API.INVALID_USERNAME': 'Invalid userName',
            'API.INVALID_VARIABLE_METER_ID': '無効な変数計量メータID',
            'API.INVALID_VARIABLE_METER_TYPE': '無効な変数計量メータタイプ',
            'API.INVALID_VARIABLE_NAME': '無効な変数名称',
            'API.INVALID_VERIFICATION_CODE': '無効な認証コード',
            'API.INVALID_VIRTUAL_METER_ID': '無効な仮想メータID',
            'API.INVALID_VIRTUAL_METER_NAME': '無効な仮想メータ名称',
            'API.INVALID_VIRTUAL_METER_UUID': '無効な仮想メータUUID',
            'API.INVALID_WEB_MESSAGE_ID': '無効なWebメッセージID',
            'API.INVALID_WECHAT_MESSAGE_ID': '無効なWeChatメッセージID',
            'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
            'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
            'API.INVALID_WORKING_CALENDAR_ID': '無効な営業日カレンダーID',
            'API.INVALID_WORKING_CALENDAR_NAME': '無効な営業日カレンダー名称',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'ナレッジファイルをディスクから削除できません',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'ナレッジファイルが存在しません',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': '総メータは同じエネルギー分類に属していません',
            'API.MASTER_METER_NOT_FOUND': '総メータが存在しません',
            'API.MENU_NOT_FOUND': 'メニューが存在しません',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
            'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
            'API.METER_NAME_IS_ALREADY_IN_USE': '計量メータ名称が既に使用されています',
            'API.METER_NOT_FOUND': '計量メータが存在しません',
            'API.METER_OF_VARIABLE_NOT_FOUND': '変数の計量メータが存在しません',
            'API.METER_POINT_RELATION_EXISTS': '計量メータとデータポイントの関係が既に存在します',
            'API.METER_POINT_RELATION_NOT_FOUND': '計量メータとデータポイントの関係が存在しません',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
            'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
            'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
                'Microgrid power conversion system name is already in use',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
            'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
            'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '新パスワードの長さは100文字を超えることはできません',
            'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
            'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
            'API.NON_WORKING_DAY_NOT_FOUND': '非営業日が存在しません',
            'API.NOT_FOUND': '存在しません',
            'API.NOTIFICATION_NOT_FOUND': '通知が存在しません',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'オフラインメータファイルが存在しません',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'オフラインメータ名称が既に使用されています',
            'API.OFFLINE_METER_NOT_FOUND': 'オフラインメータが存在しません',
            'API.INVALID_OFFLINE_METER_VALUE': '無効なオフラインメータ値',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': '変数のオフラインメータが存在しません',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '旧パスワードの長さは100文字を超えることはできません',
            'API.PARENT_SPACE_NOT_FOUND': '親空間が存在しません',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'パスワードの長さは100文字を超えることはできません',
            'API.PASSWORDS_MATCH': '新パスワードが旧パスワードと一致しています',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'データポイント名称が既に使用されています',
            'API.POINT_NOT_FOUND': 'データポイントが存在しません',
            'API.POWER_POINT_NOT_FOUND': 'Power point not found',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': '権限名称が既に使用されています',
            'API.PRIVILEGE_NOT_FOUND': '権限が存在しません',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'ルール名称が既に使用されています',
            'API.RULE_NOT_FOUND': 'ルールが存在しません',
            'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'センサー名称が既に使用されています',
            'API.SENSOR_NOT_FOUND': 'センサーが存在しません',
            'API.SENSOR_POINT_RELATION_EXISTS': 'センサーとデータポイントの関係が既に存在します',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'センサーとデータポイントの関係が存在しません',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': '現場と設備の関係が既に存在します',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': '現場と設備の関係が存在しません',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': '現場と計量メータの関係が既に存在します',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': '現場と計量メータの関係が存在しません',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': '現場名称が既に使用されています',
            'API.SHOPFLOOR_NOT_FOUND': '現場が存在しません',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': '現場とオフラインメータの関係が既に存在します',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': '現場とオフラインメータの関係が存在しません',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': '現場とデータポイントの関係が既に存在します',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': '現場とデータポイントの関係が存在しません',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': '現場とセンサーの関係が既に存在します',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': '現場とセンサーの関係が存在しません',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': '現場と仮想メータの関係が既に存在します',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': '現場と仮想メータの関係が存在しません',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': '現場営業日カレンダー関係が既に存在します',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': '現場と営業日カレンダーの関係が存在しません',
            'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
            'API.SOURCE_NODE_NOT_FOUND': 'ソースノードが存在しません',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': '空間と複合設備の関係が既に存在します',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': '空間と複合設備の関係が存在しません',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': '空間と設備の関係が既に存在します',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': '空間と設備の関係が存在しません',
            'API.SPACE_METER_RELATION_EXISTS': '空間と計量メータの関係が既に存在します',
            'API.SPACE_METER_RELATION_NOT_FOUND': '空間と計量メータの関係が存在しません',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': '空間名称が既に使用されています',
            'API.SPACE_NOT_FOUND': '空間が存在しません',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': '権限内に空間が存在しません',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': '空間とオフラインメータの関係が既に存在します',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': '空間とオフラインメータの関係が存在しません',
            'API.SPACE_POINT_RELATION_EXISTS': '空間とデータポイントの関係が既に存在します',
            'API.SPACE_POINT_RELATION_NOT_FOUND': '空間とデータポイントの関係が存在しません',
            'API.SPACE_SENSOR_RELATION_EXISTS': '空間とセンサーの関係が既に存在します',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': '空間とセンサーの関係が存在しません',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': '空間と現場の関係が既に存在します',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': '空間と現場の関係が存在しません',
            'API.SPACE_STORE_RELATION_EXISTS': '空間と店舗の関係が既に存在します',
            'API.SPACE_STORE_RELATION_NOT_FOUND': '空間と店舗の関係が存在しません',
            'API.SPACE_TENANT_RELATION_EXISTS': '空間とテナントの関係が既に存在します',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': '空間とテナントの関係が存在しません',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': '空間と仮想メータの関係が既に存在します',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': '空間と仮想メータの関係が存在しません',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': '空間と営業日カレンダーの関係が既に存在します',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': '空間と営業日カレンダーの関係が存在しません',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': '開始日時は終了日時より前でなければなりません',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
            'API.STORE_METER_RELATION_EXISTS': '店舗と計量メータの関係が既に存在します',
            'API.STORE_METER_RELATION_NOT_FOUND': '店舗と計量メータの関係が存在しません',
            'API.STORE_NAME_IS_ALREADY_IN_USE': '店舗名称が既に使用されています',
            'API.STORE_NOT_FOUND': '店舗が存在しません',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': '店舗とオフラインメータの関係が既に存在します',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': '店舗とオフラインメータの関係が存在しません',
            'API.STORE_POINT_RELATION_EXISTS': '店舗とデータポイントの関係が既に存在します',
            'API.STORE_POINT_RELATION_NOT_FOUND': '店舗とデータポイントの関係が存在しません',
            'API.STORE_SENSOR_RELATION_EXISTS': '店舗とセンサーの関係が既に存在します',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': '店舗とセンサーの関係が存在しません',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': '店舗タイプ名称が既に使用されています',
            'API.STORE_TYPE_NOT_FOUND': '店舗タイプが存在しません',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '店舗タイプ簡略コードが既に使用されています',
            'API.STORE_TYPE_USED_IN_STORE': '店舗タイプが店舗で既に使用されています',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': '店舗と仮想メータの関係が既に存在します',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': '店舗と仮想メータの関係が存在しません',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': '店舗と営業日カレンダーの関係が既に存在します',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': '店舗と営業日カレンダーの関係が存在しません',
            'API.TARGET_NODE_NOT_FOUND': 'ターゲットノードが存在しません',
            'API.TARIFF_IN_USE': '料率は使用中です',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': '料率とコストセンターは既に関連付けられています',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': '料率とコストセンターは関連付けられていません',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': '料率名称が既に使用されています',
            'API.TARIFF_NOT_FOUND': '料率が存在しません',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
            'API.TENANT_METER_RELATION_EXISTS': 'テナントと計量メータの関係が既に存在します',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'テナントと計量メータの関係が存在しません',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'テナント名称が既に使用されています',
            'API.TENANT_NOT_FOUND': 'テナントが存在しません',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'テナントとオフラインメータの関係が既に存在します',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'テナントとオフラインメータの関係が存在しません',
            'API.TENANT_POINT_RELATION_EXISTS': 'テナントとデータポイントの関係が既に存在します',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'テナントとデータポイントの関係が存在しません',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'テナントとセンサーの関係が既に存在します',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'テナントとセンサーの関係が存在しません',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'テナントとタイプ名称が既に使用されています',
            'API.TENANT_TYPE_NOT_FOUND': 'テナントタイプが存在しません',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'テナントタイプ簡略コードが既に使用されています',
            'API.TENANT_TYPE_USED_IN_TENANT': 'テナントタイプがテナントで既に使用されています',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'テナントと仮想メータの関係が既に存在します',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'テナントと仮想メータの関係が存在しません',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'テナントと営業日カレンダーの関係が既に存在します',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'テナントと営業日カレンダーの関係が存在しません',
            'API.TEXT_MESSAGE_NOT_FOUND': 'SMSが見つかりません',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': '報告期間は15分より長くなければなりません',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': '子メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': '子空間との関係があります',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': '複合設備関連パラメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': '複合設備との関係があります',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'データソースとの関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'エネルギー流れ図との関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'エネルギー貯蔵コンテナバッテリーとの関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'エネルギー貯蔵コンテナグリッドとの関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'エネルギー貯蔵コンテナ負荷との関係があります',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'エネルギー貯蔵コンテナPCSとの関係があります',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': '設備関連パラメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': '設備との関係があります',
            'API.THERE_IS_RELATION_WITH_METER': '計量メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_METERS': '複数の計量メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'オフラインメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': '複数のオフラインメータとの関係があります',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': '仮想メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'センサーとの関係があります',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': '現場との関係があります',
            'API.THERE_IS_RELATION_WITH_SPACES': '空間との関係があります',
            'API.THERE_IS_RELATION_WITH_STORES': '店舗との関係があります',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'テナントとの関係があります',
            'API.THERE_IS_RELATION_WITH_USERS': 'ユーザーとの関係があります',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': '仮想メータとの関係があります',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': '仮想発電所との関係があります',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'このデータソースは計量メータで使用中です',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'この計量メータは仮想メータで使用中です',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'このオフラインメータは仮想メータで使用中です',
            'API.THIS_SPACE_CANNOT_BE_CLONED': '空間は複製できません',
            'API.THIS_SPACE_CANNOT_BE_DELETED': '空間は削除できません',
            'API.TIMEZONE_NOT_FOUND': 'タイムゾーンが存在しません',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'トークンが見つかりません、ログインしてください',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'ユーザーアカウントがロックされました',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'ユーザーアカウントの有効期限が切れています',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'ユーザー名が既に使用されています',
            'API.USER_NOT_FOUND': 'ユーザーが存在しません',
            'API.USER_PASSWORD_HAS_EXPIRED': 'ユーザーパスワードの有効期限が切れています',
            'API.USER_PRIVILEGE_NOT_FOUND': 'ユーザー権限が見つかりません',
            'API.USER_SESSION_NOT_FOUND': 'ユーザーセッションが見つかりません',
            'API.USER_SESSION_TIMEOUT': 'ユーザーセッションがタイムアウトしました',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'ユーザーUUIDが存在しません、ログインしてください',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': '仮想メータ名称が既に使用されています',
            'API.VIRTUAL_METER_NOT_FOUND': '仮想メータが存在しません',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': '変数の仮想メータが存在しません',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': '仮想データポイントはアナログ値である必要があります',
            'API.WEB_MESSAGE_NOT_FOUND': 'Webメッセージが存在しません',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'WeChatメッセージが存在しません',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
            'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': '営業日カレンダー名称が既に使用されています',
            'API.WORKING_CALENDAR_NOT_FOUND': '営業日カレンダーが存在しません',

            MasterMeter: '総メータ',
            SubMeter: 'サブメータ',
            'Power Quality': '電力量質',
            'About Power Quality': '電力量質について',
            'Trend Values': '傾向値',
            Category: 'カテゴリー',
            Type: 'タイプ',
            Unit: '単位',
            Limit: '限界値',
            'Normal Limit': '正常限界値',
            'Severe Limit': '重大限界値',
            Compliance: 'コンプライアンス率',
            'Worst Deviation': '最悪偏差',
            'Worst Time': '最悪発生時刻',
            'Severe Exceed Count': '重大越限回数',
            'Worst Unbalance': '最大不平衡率',
            Hz: 'ヘルツ',
            voltage: '電圧',
            current: '電流',
            frequency: '周波数',
            voltage_deviation: '電圧偏差',
            current_unbalance: '電流不平衡',
            voltage_unbalance: '電圧不平衡',
            mean_deviation_pct: '平均偏差(%)',
            p95_abs_deviation_pct: 'P95絶対偏差(%)',
            mean_abs_deviation_hz: '平均絶対偏差(Hz)',
            frequency_deviation: '周波数偏差',
            p95_abs_deviation_hz: 'P95絶対偏差(Hz)',
            mean_unbalance_pct: '平均不平衡率(%)',
            p95_unbalance_pct: 'P95不平衡率(%)',
            count: 'カウント',
            min: '最小値',
            max: '最大値',
            mean: '平均値',
            std: '標準偏差',
            p5: 'P5',
            p95: 'P95'
        }
    }, fa: {
        translation: {
            // routes & menus
            Dashboard: 'داشبورد',
            'Space Data': 'داده‌های فضا',
            'Equipment Data': 'داده‌های تجهیزات',
            'Meter Data': 'داده‌های کنتور',
            'Tenant Data': 'داده‌های مستأجر',
            'Store Data': 'داده‌های فروشگاه',
            'Shopfloor Data': 'داده‌های کارگاه',
            'Combined Equipment Data': 'داده‌های تجهیزات ترکیبی',
            'Auxiliary System': 'سیستم کمکی',
            Microgrid: 'ریزشبکه',
            'Energy Storage Power Station': 'نیروگاه',
            'Photovoltaic Power Station': 'نیروگاه',
            'Fault Alarm': 'هشدار خرابی',
            Monitoring: 'پایش تجهیزات',
            'Advanced Reporting': 'گزارش‌گیری پیشرفته',
            'Knowledge Base': 'پایگاه دانش',
            'Energy Category Data': 'تحلیل دسته‌بندی انرژی',
            'Energy Item Data': 'تحلیل آیتم انرژی',
            Carbon: 'تحلیل انتشار کربن',
            Cost: 'تحلیل هزینه',
            Output: 'تحلیل خروجی',
            Income: 'تحلیل درآمد',
            Efficiency: 'تحلیل کارایی',
            Load: 'تحلیل بار',
            Statistics: 'تحلیل آماری',
            'Batch Analysis': 'تحلیل انبوه',
            Saving: 'تحلیل صرفه‌جویی',
            Plan: 'تحلیل برنامه',
            Prediction: 'تحلیل پیش‌بینی',
            'Production': 'تولید',
            'Space Production': 'تحلیل انرژی مصرفی تولید',
            'Equipment Tracking': 'دفترچه تجهیزات',
            'Equipment Comparison': 'تحلیل مقایسه‌ای',
            'Shopfloor Comparison': 'تحلیل مقایسه‌ای',
            'Store Comparison': 'تحلیل مقایسه‌ای',
            'Space Comparison': 'تحلیل مقایسه‌ای',
            'Combined Equipment Comparison': 'تحلیل مقایسه‌ای',
            'Tenant Comparison': 'تحلیل مقایسه‌ای',
            'Environment Monitor': 'پایش محیط زیست',
            'Meter Energy': 'تحلیل انرژی کنتور',
            'Meter Carbon': 'تحلیل کربن کنتور',
            'Meter Cost': 'تحلیل هزینه کنتور',
            'Meter Trend': 'تحلیل روند کنتور',
            'Meter Realtime': 'تحلیل بی‌درنگ کنتور',
            'Meter Saving': 'تحلیل صرفه‌جویی کنتور',
            'Meter Plan': 'تحلیل برنامه کنتور',
            'Master Meter Submeters Balance': 'تحلیل تعادل کنتور اصلی-فرعی',
            'Meter Batch Analysis': 'تحلیل انبوه کنتور',
            'Meter Comparison': 'تحلیل مقایسه‌ای کنتور',
            'Meter Tracking': 'دفترچه کنتور',
            'Virtual Meter Saving': 'تحلیل صرفه‌جویی کنتور مجازی',
            'Virtual Meter Plan': 'تحلیل برنامه کنتور مجازی',
            'Virtual Meter Energy': 'تحلیل انرژی کنتور مجازی',
            'Virtual Meter Carbon': 'تحلیل کربن کنتور مجازی',
            'Virtual Meter Cost': 'تحلیل هزینه کنتور مجازی',
            'Virtual Meter Batch Analysis': 'تحلیل انبوه کنتور مجازی',
            'Virtual Meter Comparison': 'تحلیل مقایسه‌ای کنتور مجازی',
            'Offline Meter Energy': 'تحلیل انرژی کنتور آفلاین',
            'Offline Meter Carbon': 'تحلیل کربن کنتور آفلاین',
            'Offline Meter Cost': 'تحلیل هزینه کنتور آفلاین',
            'Offline Meter Batch Analysis': 'تحلیل انبوه کنتور آفلاین',
            'Offline Meter Saving': 'تحلیل صرفه‌جویی کنتور آفلاین',
            'Offline Meter Plan': 'تحلیل برنامه کنتور آفلاین',
            'Offline Meter Input': 'ورود داده کنتور آفلاین',
            'Tenant Bill': 'صورتحساب مستأجر',
            'Energy Flow Diagram': 'نمودار جریان انرژی',
            'Distribution System': 'سیستم توزیع',
            'SVG System': 'سیستم بصری‌سازی پیکربندی',
            'Faults Data': 'تحلیل خرابی',
            'Space Equipments': 'تجهیزات فضایی',
            'Combined Equipments': 'تجهیزات ترکیبی',
            'Energy Storage Power Station List': 'لیست نیروگاه‌ها',
            'Energy Storage Power Station Details': 'پایش تجهیزات',
            'Energy Storage Power Station Reporting': 'گزارش داده',
            'Energy Storage Power Station Alarm': 'هشدار خرابی',
            'Energy Storage Power Station Maintenance': 'نگهداری و تعمیرات',
            'Enter Production': 'ورود تولید',
            'Multiple Microgrids': 'داده‌های چندایستگاه',
            'Multiple Microgrids Dashboard': 'نمای کلی چندایستگاه',
            'Multiple Microgrids List': 'لیست نیروگاه‌ها',
            'Single Microgrid': 'داده‌های تک‌ایستگاه',
            'Single Microgrid Dashboard': 'نمای کلی تک‌ایستگاه',
            'Single Microgrid Details': 'داده‌های تجهیزات',
            'Single Microgrid Fault Alarm': 'هشدار خرابی',
            'Microgrid Reports': 'گزارش‌های آماری',
            'Microgrid Reports Energy': 'گزارش انرژی الکتریکی',
            'Microgrid Reports Revenue': 'گزارش درآمد',
            'Microgrid Reports Parameters': 'پرس‌وجوی داده',
            'Multiple Energy Storage Power Stations': 'داده‌های چندایستگاه ذخیره‌ساز',
            'Multiple Energy Storage Power Stations Dashboard': 'نمای کلی چندایستگاه ذخیره‌ساز',
            'Multiple Energy Storage Power Stations List': 'لیست نیروگاه‌های ذخیره‌ساز',
            'Single Energy Storage Power Station': 'داده‌های تک‌ایستگاه ذخیره‌ساز',
            'Single Energy Storage Power Station Dashboard': 'نمای کلی تک‌ایستگاه ذخیره‌ساز',
            'Single Energy Storage Power Station Details': 'داده‌های تجهیزات ذخیره‌ساز',
            'Single Energy Storage Power Station Fault Alarm': 'هشدار خرابی ذخیره‌ساز',
            'Energy Storage Power Station Reports': 'گزارش‌های آماری ذخیره‌ساز',
            'Energy Storage Power Station Reports Energy': 'گزارش انرژی الکتریکی ذخیره‌ساز',
            'Energy Storage Power Station Reports Revenue': 'گزارش درآمد ذخیره‌ساز',
            'Energy Storage Power Station Reports Parameters': 'پرس‌وجوی داده ذخیره‌ساز',
            'Multiple Energy Storage Power Stations': 'داده‌های چندایستگاه',
            'Multiple Energy Storage Power Stations Dashboard': 'نمای کلی چندایستگاه',
            'Multiple Energy Storage Power Stations List': 'لیست نیروگاه‌ها',
            'Single Energy Storage Power Station': 'داده‌های تک‌ایستگاه',
            'Single Energy Storage Power Station Dashboard': 'نمای کلی تک‌ایستگاه',
            'Single Energy Storage Power Station Details': 'داده‌های تجهیزات',
            'Single Energy Storage Power Station Fault Alarm': 'هشدار خرابی',
            'Energy Storage Power Station Reports': 'گزارش‌های آماری',
            'Energy Storage Power Station Reports Energy': 'گزارش انرژی الکتریکی',
            'Energy Storage Power Station Reports Revenue': 'گزارش درآمد',
            'Energy Storage Power Station Reports Parameters': 'پرس‌وجوی داده',
            'Photovoltaic Power Station List': 'لیست نیروگاه‌ها',
            'Photovoltaic Power Station Details': 'پایش تجهیزات',
            'Photovoltaic Power Station Reporting': 'گزارش داده',
            'Photovoltaic Power Station Alarm': 'هشدار خرابی',
            'Photovoltaic Power Station Maintenance': 'نگهداری و تعمیرات',
            'Multiple Photovoltaic Power Stations': 'داده‌های چندایستگاه',
            'Multiple Photovoltaic Power Stations Dashboard': 'نمای کلی چندایستگاه',
            'Multiple Photovoltaic Power Stations List': 'لیست نیروگاه‌ها',
            'Single Photovoltaic Power Station': 'داده‌های تک‌ایستگاه',
            'Single Photovoltaic Power Station Dashboard': 'نمای کلی تک‌ایستگاه',
            'Single Photovoltaic Power Station Details': 'داده‌های تجهیزات',
            'Single Photovoltaic Power Station Fault Alarm': 'هشدار خرابی',
            'Photovoltaic Power Station Reports': 'گزارش‌های آماری',
            'Photovoltaic Power Station Reports Energy': 'گزارش انرژی الکتریکی',
            'Photovoltaic Power Station Reports Revenue': 'گزارش درآمد',
            'Photovoltaic Power Station Reports Parameters': 'پرس‌وجوی داده',
            'Work Order': 'مدیریت دستورکار',
            'Work Order Installation': 'رکورد نصب',
            'Work Order Repair': 'رکورد تعمیر',
            'Work Order Inspection': 'رکورد بازرسی',
            'Total Number of Work Orders': 'تعداد کل دستورکارها',
            'Number of New Work Orders': 'تعداد دستورکارهای جدید',
            'Number of Inprogress Work Orders': 'تعداد دستورکارهای در حال انجام',
            'Number of Done Work Orders': 'تعداد دستورکارهای تکمیل‌شده',
            'Fuel Indicator': 'مصرف سوخت',
            'Charge Energy Indicator': 'انرژی شارژ',
            'Discharge Energy Indicator': 'انرژی دشارژ',
            'Charge Cost Indicator': 'هزینه شارژ',
            'Discharge Revenue Indicator': 'درآمد دشارژ',
            'HVAC': 'تهویه مطبوع',
            'Fire Control': 'آتش‌نشانی',
            // Dashboard
            'Welcome to MyEMS': 'به MyEMS خوش آمدید',
            'An Industry Leading Open Source Energy Management System': 'سیستم مدیریت انرژی منبع‌باز پیشرو در صنعت',
            "This Year's Consumption CATEGORY VALUE UNIT": 'مصرف امسال {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Year's Costs CATEGORY VALUE UNIT": 'هزینه امسال {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Consumption CATEGORY VALUE UNIT": 'مصرف این ماه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Generation CATEGORY VALUE UNIT": 'تولید این ماه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            "This Month's Costs CATEGORY VALUE UNIT": 'هزینه این ماه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'مصرف مدت مشابه سال قبل {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'هزینه مدت مشابه سال قبل {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'CATEGORY Consumption UNIT': 'مصرف {{CATEGORY}} {{UNIT}}',
            'CATEGORY Costs UNIT': 'هزینه {{CATEGORY}} {{UNIT}}',
            // Entities
            Space: 'فضا',
            Equipment: 'تجهیزات',
            Meter: 'کنتور',
            'Offline Meter': 'کنتور آفلاین',
            'Virtual Meter': 'کنتور مجازی',
            Tenant: 'مستأجر',
            Store: 'فروشگاه',
            Shopfloor: 'کارگاه',
            'Combined Equipment': 'تجهیزات ترکیبی',
            'Cost Center': 'مرکز هزینه',
            Name: 'نام',
            DisplayName: 'نام نمایشی',
            UserName: 'نام کاربری',
            Description: 'توضیحات',
            'Energy Category': 'دسته‌بندی انرژی',
            'Child Spaces': 'زیرفضاها',
            'Associated Equipment': 'تجهیزات مرتبط',
            //Energy Categories
            Electricity: 'برق',
            Water: 'آب لوله‌کشی',
            'Natural Gas': 'گاز طبیعی',
            // SidePanelModal
            Settings: 'تنظیمات',
            'Set your own customized style': 'سبک سفارشی خود را تنظیم کنید',
            'Color Scheme': 'طرح رنگ',
            'Choose the perfect color mode for your app': 'حالت رنگ ایده‌آل را برای برنامه خود انتخاب کنید',
            Light: 'روشن',
            Dark: 'تاریک',
            'RTL Mode': 'حالت RTL',
            'Switch your language direction': 'جهت زبان خود را تغییر دهید',
            'Fluid Layout': 'چیدمان سیال',
            'Toggle container layout system': 'سیستم چیدمان کانتینر را تغییر دهید',
            'Navigation Position': 'موقعیت نوار ناوبری',
            'Vertical': 'عمودی',
            'Top': 'بالا',
            'Combo': 'ترکیبی',
            'Transparent': 'شفاف',
            'Inverted': 'برعکس',
            'Card': 'کارت',
            'Vibrant': 'پررنگ',
            'Select a suitable navigation system for your web application': 'یک سیستم ناوبری مناسب برای برنامه وب خود انتخاب کنید',
            'Vertical Nav': 'ناوبری عمودی',
            'Top Nav': 'ناوبری بالایی',
            'Vertical Navbar Style': 'سبک نوار ناوبری عمودی',
            'Switch between styles for your vertical navbar': 'بین سبک‌های نوار ناوبری عمودی خود جابه‌جا شوید',
            Language: 'زبان',
            'Switch between languages': 'بین زبان‌ها جابه‌جا شوید',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'این سیستم را می‌پسندید؟',
            'Get MyEMS now': 'هم‌اکنون MyEMS را دریافت کنید',
            'PQ.About': 'این تحلیل شامل انحراف ولتاژ، عدم تعادل ولتاژ، انحراف فرکانس و عدم تعادل جریان است. انحراف ولتاژ بر اساس (U−Un)/Un×100% محاسبه می‌شود؛ انحراف فرکانس بر اساس |f−fn| محاسبه می‌شود؛ عدم تعادل سه فاز بر اساس max(|Xi−Xavg|)/Xavg×100% محاسبه می‌شود و نیاز به هم‌زمانی زمانی کانال‌های سه فاز دارد. نتایج بر اساس سری زمانی کنتور انتخاب‌شده در دوره گزارش است. در صورت فقدان کانال‌های سه فاز یا عدم تطابق زمان، شاخص عدم تعادل رد می‌شود. نوسانات لحظه‌ای یا نمونه‌های از دست رفته ممکن است بدترین مقدار را بزرگنمایی کنند؛ برای ارزیابی حالت پایدار، توصیه می‌شود به شاخص‌های آماری مانند نرخ انطباق و P95 مراجعه شود.',
            Purchase: 'خرید نسخه سازمانی',
            ContactInfo: 'اطلاعات تماس',
            ProductWebsite: 'وب سایت محصول',
            CompanyWebsite: 'وب سایت شرکت',
            SalesPhone: 'تلفن فروش',
            // Query Panels
            'Base Period Begins': 'شروع دوره پایه',
            'Base Period Ends': 'پایان دوره پایه',
            'Comparison Types': 'نوع مقایسه',
            'Year-Over-Year': 'نسبت به سال قبل',
            'Month-On-Month': 'نسبت به ماه قبل',
            'Free Comparison': 'مقایسه آزاد',
            'None Comparison': 'بدون مقایسه',
            'Reporting Period Begins': 'شروع دوره گزارش',
            'Reporting Period Ends': 'پایان دوره گزارش',
            '(Optional)': '(اختیاری)',
            'Period Types': 'مقیاس زمانی',
            Yearly: 'سالانه',
            Monthly: 'ماهانه',
            Weekly: 'هفتگی',
            Daily: 'روزانه',
            Hourly: 'ساعتی',
            Submit: 'ارسال',
            'Input Energy Category': 'دسته‌بندی انرژی مصرفی',
            'Output Energy Category': 'دسته‌بندی انرژی تولیدی',
            'Fraction Parameter': 'پارامتر کسری',
            Search: 'جستجو',
            //DateRangePicker
            sunday: 'یکشنبه',
            monday: 'دوشنبه',
            tuesday: 'سه‌شنبه',
            wednesday: 'چهارشنبه',
            thursday: 'پنجشنبه',
            friday: 'جمعه',
            saturday: 'شنبه',
            ok: 'تأیید',
            today: 'امروز',
            yesterday: 'دیروز',
            hours: 'ساعت',
            minutes: 'دقیقه',
            seconds: 'ثانیه',
            last7Days: 'هفت روز گذشته',
            'Select Date Range': 'انتخاب بازه زمانی',
            //Card Summaries and Line Charts
            'Base Period': 'دوره پایه',
            'Reporting Period': 'دوره گزارش',
            'Per Unit Area': 'ارزش به ازای واحد سطح',
            'Per Capita': 'ارزش سرانه',
            'Per Unit Production': 'ارزش به ازای واحد محصول',
            Baseline: 'مقدار پایه',
            Actual: 'مقدار واقعی',
            'Baseline Value - Actual Value': 'مقدار پایه - مقدار واقعی',
            'Average Load': 'میانگین بار',
            'Maximum Load': 'حداکثر بار',
            'Load Factor': 'ضریب بار',
            'Ratio of Average Load to Maximum Load': 'نسبت میانگین بار به حداکثر بار',
            'Carbon Dioxide Emissions by Energy Category': 'سهم انتشار دی‌اکسید کربن',
            'Costs by Energy Category': 'سهم هزینه',
            'Incomes by Energy Category': 'سهم درآمد',
            'Electricity Consumption by Time-Of-Use': 'مصرف برق به تفکیک زمان مصرف',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'انتشار دی‌اکسید کربن ناشی از برق به تفکیک زمان مصرف',
            'Electricity Cost by Time-Of-Use': 'هزینه برق به تفکیک زمان مصرف',
            'CATEGORY UNIT Consumption by Energy Items': 'سهم مصرف آیتم {{CATEGORY}} {{UNIT}}',
            'Ton of Standard Coal by Energy Category': 'سهم تن زغال سنگ استاندارد (TCE)',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'سهم تن انتشار دی‌اکسید کربن (TCO2E)',
            'Reporting Period Consumption CATEGORY UNIT': 'مصرف دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'پیش‌بینی دوره گزارش {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} مصرف دوره گزارش {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} مصرف دوره گزارش {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'تولید دوره گزارش {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'تولید دوره پایه {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'مصرف دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'پیش‌بینی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'مصرف دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'پیش‌بینی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'مصرف دوره گزارش {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'مصرف دوره گزارش {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'مصرف دوره پایه {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'سهم دسته‌بندی زیرفضا {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'سهم کل زیرفضا',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'انتشار دی‌اکسید کربن دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'انتشار دی‌اکسید کربن دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'انتشار دی‌اکسید کربن دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'هزینه دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'هزینه دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'هزینه دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'خروجی دوره گزارش {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} خروجی دوره گزارش {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} خروجی دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'خروجی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'خروجی دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'درآمد دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'درآمد دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'درآمد دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'کل درآمد دوره گزارش {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'کارایی تجمعی دوره گزارش {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} کارایی تجمعی دوره گزارش {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} کارایی جامع تجمعی دوره گزارش {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} کارایی جامع تجمعی دوره گزارش {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} کارایی جامع تجمعی دوره پایه {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'کارایی لحظه‌ای {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} کارایی لحظه‌ای {{UNIT}}',
            'Equipment Efficiency Indicator': 'شاخص بهره‌وری انرژی تجهیزات',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} کارایی جامع لحظه‌ای {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'کارایی تجمعی دوره گزارش {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'کارایی تجمعی دوره گزارش {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'کارایی تجمعی دوره پایه {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT': 'کارایی تجمعی دوره پایه {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'حداکثر بار دوره پایه {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'حداکثر بار دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'میانگین بار دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'ضریب بار دوره گزارش {{CATEGORY}}',
            'Base Period CATEGORY Average Load VALUE UNIT': 'میانگین بار دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'میانگین دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'حداکثر دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'حداقل دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'میانگین حسابی دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'میانه دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'انحراف معیار نمونه دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'واریانس نمونه دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'صرفه‌جویی دوره گزارش {{CATEGORY}} (پایه - واقعی) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'کاهش دوره گزارش {{CATEGORY}} (پایه - واقعی) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'صرفه‌جویی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'صرفه‌جویی دوره پایه {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT': 'مصرف کنتور اصلی دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'مصرف کنتور اصلی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT': 'مصرف کنتورهای فرعی دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'مصرف کنتورهای فرعی دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'اختلاف دوره گزارش {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'درصد اختلاف دوره گزارش',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'اختلاف دوره گزارش {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'مقادیر روند',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'لیست خرابی‌ها',
            'Reporting Period Number of Fault VALUE': 'تعداد خرابی دوره گزارش: {{VALUE}}',
            'All Faults': 'همه خرابی‌ها',
            'Space Faults': 'خرابی‌های فضا',
            'Number of All Faults': 'تعداد کل خرابی‌ها',
            'Number of Space Faults': 'تعداد خرابی‌های فضا',
            'Total Number of Faults': 'تعداد کل خرابی‌ها',
            'Number of New Faults': 'تعداد خرابی‌های جدید',
            'Number of Inprogress Faults': 'تعداد خرابی‌های در حال انجام',
            'Number of Done Faults': 'تعداد خرابی‌های تکمیل‌شده',
            //Data Panels
            'Ton of Standard Coal': 'تن زغال سنگ استاندارد',
            'Ton of Carbon Dioxide Emissions': 'تن انتشار دی‌اکسید کربن',
            'Carbon Emissions Per Unit Of Energy Consumption': 'انتشار کربن به ازای واحد مصرف انرژی',
            'Operating Characteristic Curve': 'منحنی عملکرد',
            Tariff: 'تعرفه',
            'Detailed Data': 'داده‌های تفصیلی',
            'Child Spaces Data': 'داده‌های زیرفضاها',
            'Associated Equipment Data': 'داده‌های تجهیزات مرتبط',
            'This Year': 'امسال',
            'The Same Period Last Year': 'مدت مشابه سال قبل',
            'This Month': 'این ماه',
            'This Day': 'امروز',
            Total: 'مجموع',
            'No data found': 'داده‌ای یافت نشد',
            Export: 'خروجی',
            Datetime: 'تاریخ و زمان',
            'Time-Of-Use Type': 'نوع زمان مصرف',
            'Top-Peak': 'اوج بالا',
            'On-Peak': 'اوج',
            'Mid-Peak': 'میانه',
            'Off-Peak': 'کم‌بار',
            'Deep': 'عمیق',
            Percentage: 'درصد',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'روند نقطه مقدار انرژی در ساعت گذشته',
            Circuit: 'مدار',
            Point: 'نقطه داده',
            'Realtime Value': 'مقدار بی‌درنگ',
            //Meter Tracking
            'Meter List': 'لیست کنتورها',
            'Edit Meter': 'ویرایش',
            'Start Value': 'مقدار شروع',
            'End Value': 'مقدار پایان',
            'Difference Value': 'مقدار اختلاف',
            'Start Integrity Rate': 'نرخ یکپارچگی داده شروع (%)',
            'End Integrity Rate': 'نرخ یکپارچگی داده پایان (%)',
            'Full Integrity Rate': 'نرخ یکپارچگی کل داده (%)',
            //Equipment Tracking
            'Equipment List': 'لیست تجهیزات',
            'Edit Equipment': 'ویرایش',
            //Profile Dropdown
            Feedback: 'بازخورد',
            'Account Settings': 'تنظیمات حساب',
            Logout: 'خروج',
            //Authentication
            'Log in': 'ورود',
            'Email address': 'آدرس ایمیل',
            'Phone Number': 'شماره تلفن',
            Password: 'رمز عبور',
            CaptchaCode: 'کد امنیتی',
            Refresh: 'بازخوانی',
            'Remember me': 'مرا به خاطر بسپار',
            'Logged in as ': 'ورود به عنوان ',
            'Forgot Password?': 'رمز عبور را فراموش کرده‌اید؟',
            'Forgot your password?': 'رمز عبور خود را فراموش کرده‌اید؟',
            "Enter your email and we'll send you a reset link": 'ایمیل خود را وارد کنید، ما یک لینک بازنشانی برای شما ارسال می‌کنیم',
            "Enter your email and we'll send you a registration link": 'ایمیل خود را وارد کنید، ما یک لینک ثبت‌نام برای شما ارسال می‌کنیم',
            'Reset Password': 'بازنشانی رمز عبور',
            'Thanks for using MyEMS!': 'از استفاده شما از MyEMS متشکریم!',
            'You are now successfully signed out': 'شما با موفقیت خارج شدید',
            'Return to Login': 'بازگشت به صفحه ورود',
            'Please check your email!': 'لطفاً ایمیل خود را بررسی کنید!',
            'An email has been sent to ': 'یک ایمیل به آدرس ',
            'Please click on the included link to reset your password': 'لطفاً برای بازنشانی رمز عبور خود روی لینک موجود کلیک کنید',
            'Please click on the included link to register your account': 'لطفاً برای ثبت‌نام حساب کاربری خود روی لینک موجود کلیک کنید',
            'An email with password reset link is sent to ': 'ایمیلی حاوی لینک بازنشانی رمز عبور به آدرس ',
            'Change Password': 'تغییر رمز عبور',
            'Old Password': 'رمز عبور قدیمی',
            'New Password': 'رمز عبور جدید',
            'Confirm Password': 'تکرار رمز عبور جدید',
            'Update Password': 'به‌روزرسانی رمز عبور',
            'Password has been changed!': 'رمز عبور تغییر یافت!',
            'Verification code has been sent to your inbox. \
            Please copy it to the input box below.':
                'کد تأیید به صندوق ورودی شما ارسال شد. لطفاً آن را در کادر ورودی زیر کپی کنید.',
            'New to MyEMS': 'کاربر جدید MyEMS هستید',
            'Create an account': 'ایجاد حساب کاربری',
            'EMAIL Account registration successful': 'ثبت‌نام حساب {{EMAIL}} موفقیت‌آمیز بود',
            'Thanks for verifying your account!': 'از تأیید حساب کاربری خود متشکریم!',
            'Your code is': 'کد شما',
            'Send verification code': 'ارسال کد تأیید',
            'Please wait for NUMBER seconds': 'لطفاً {{NUMBER}} ثانیه صبر کنید',
            'Password reset': 'بازنشانی رمز عبور',
            'Please wait for approval': 'لطفاً منتظر تأیید باشید',
            //notification
            Notifications: 'اعلان‌ها',
            'Mark all as read': 'علامت‌گذاری همه به عنوان خوانده‌شده',
            'View all': 'همه',
            'Notification New': 'جدید',
            'Notification Earlier': 'قدیمی‌تر',
            'Notification List': 'لیست اعلان‌ها',
            'Bulk actions': 'عملیات گروهی',
            'Notification Subject': 'موضوع',
            'Notification Created Datetime': 'زمان ایجاد',
            'Notification Message': 'محتوا',
            'Notification Priority': 'اولویت',
            'Notification Status': 'وضعیت',
            'Notification Mark As Read': 'علامت‌گذاری به عنوان خوانده‌شده',
            'Notification Mark As Acknowledged': 'تأیید',
            'Notification Low': 'پایین',
            'Notification Medium': 'متوسط',
            'Notification High': 'بالا',
            'Notification Critical': 'بحرانی',
            'Notification Unread': 'خوانده‌نشده',
            'Notification Read': 'خوانده‌شده',
            'Notification Acknowledged': 'تأیید شده',
            'Notification Archive': 'بایگانی',
            'Notification Delete': 'حذف',
            'Notification Apply': 'اعمال',
            'Notification Start Datetime': 'زمان شروع',
            'Notification End Datetime': 'زمان پایان',
            'Notification Update Datetime': 'زمان به‌روزرسانی',
            //Monitoring
            'Run Commands': 'اجرای دستورات',
            'Pin Code': 'رمز',
            'Unlock': 'باز کردن قفل',
            'Set Value': 'مقدار تنظیم شده',
            'Fault Alarms': 'هشدار خرابی',
            'Instantaneous Efficiency VALUE UNIT': 'کارایی لحظه‌ای {{VALUE}} {{UNIT}}',
            'Communication Status': 'وضعیت ارتباط',
            'Communication Online': 'آنلاین',
            'Communication Offline': 'آفلاین',
            'Equipment Status': 'وضعیت تجهیزات',
            'Equipment Running': 'در حال کار',
            'Equipment Stopped': 'متوقف',
            'Show Up to': 'تعداد نمایش در هر صفحه',
            All: 'همه',
            'FROM - TO of TOTAL': 'نمایش {{FROM}} تا {{TO}} از مجموع {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'انرژی',
            'Microgrid Revenue': 'درآمد',
            'Microgrid Carbon': 'انتشار کربن',
            'Photovoltaic Generation': 'تولید برق خورشیدی',
            'EV Charger Consumption': 'مصرف برق ایستگاه شارژ',
            'Load Consumption': 'مصرف برق بار',
            'Grid Buy': 'خرید برق از شبکه',
            'Grid Sell': 'فروش برق به شبکه',
            'EV Charger': 'ایستگاه شارژ',
            'Heat Pump': 'پمپ حرارتی',
            'Photovoltaic': 'خورشیدی',
            'PCS Run State': 'وضعیت عملکرد PCS',
            'PCS Unknown': 'ناشناخته',
            'PCS Initializing': 'روشن‌شدن اولیه',
            'PCS Standby': 'آماده‌به‌کار',
            'PCS Shutdown': 'خاموش',
            'PCS Fault': 'خرابی',
            'PCS Running': 'در حال کار',
            'Battery Power': 'توان باتری',
            'Photovoltaic Power': 'توان خورشیدی',
            'Grid Power': 'توان شبکه',
            'Load Power': 'توان بار',
            Reporting: 'گزارش داده',
            Maintenance: 'نگهداری و تعمیرات',
            'General Information': 'اطلاعات عمومی',
            'Serial Number': 'شماره سریال',
            Address: 'آدرس',
            'Postal Code': 'کد پستی',
            'Rated Capacity': 'ظرفیت اسمی',
            'Rated Power': 'توان اسمی',
            Latitude: 'عرض جغرافیایی',
            Longitude: 'طول جغرافیایی',
            'Strategy Management': 'مدیریت استراتژی',
            'Charging Schedule': 'برنامه زمانی شارژ',
            'Charge Start Time': 'زمان شروع شارژ',
            'Charge End Time': 'زمان پایان شارژ',
            'Discharge Start Time': 'زمان شروع دشارژ',
            'Discharge End Time': 'زمان پایان دشارژ',
            'Total Rated Power': 'مجموع توان اسمی',
            'Total Rated Capacity': 'مجموع ظرفیت اسمی',
            // Energy Indicator
            "Today's Charge": 'مقدار شارژ امروز',
            "Today's Discharge": 'مقدار دشارژ امروز',
            "Today's Generation": 'مقدار تولید برق امروز',
            'Total Fuel Consumption': 'کل مصرف سوخت',
            'Total Charge': 'کل شارژ',
            'Total Discharge': 'کل دشارژ',
            'Total Generation': 'کل تولید برق',
            'Total Revenue': 'کل درآمد',
            'Total Photovoltaic Generation': 'کل تولید برق خورشیدی',
            'Total EV Charger Consumption': 'کل مصرف برق ایستگاه شارژ',
            'Total Load Consumption': 'کل مصرف برق بار',
            'Total Grid Buy': 'کل خرید برق از شبکه',
            'Total Grid Sell': 'کل فروش برق به شبکه',
            'Total Efficiency': 'کارایی جامع',
            'Discharge Achievement Rate': 'نرخ تحقق دشارژ',
            // Revenue Indicator
            "Today's Cost": 'هزینه امروز',
            "Today's Income": 'درآمد امروز',
            "Total Cost": 'هزینه تجمعی',
            "Total Income": 'درآمد تجمعی',
            "Today's Revenue": 'سود امروز',

            'Revenue Ranking': 'رتبه‌بندی درآمد',
            'Efficiency Ranking': 'رتبه‌بندی کارایی',
            'Charge Ranking': 'رتبه‌بندی شارژ',
            'Discharge Ranking': 'رتبه‌بندی دشارژ',
            'Number of Microgrids': 'تعداد ریزشبکه‌ها',
            'Number of Power Stations': 'تعداد نیروگاه‌ها',
            'Microgrid List': 'لیست ریزشبکه‌ها',
            'Select Microgrid': 'انتخاب ریزشبکه',
            'Previous Page': 'صفحه قبل',
            'Next Page': 'صفحه بعد',
            '7 Days': '۷ روز',
            'Charge UNIT': 'شارژ {{UNIT}}',
            'Discharge UNIT': 'دشارژ {{UNIT}}',
            'Generation UNIT': 'تولید برق {{UNIT}}',
            'Energy Indicator': 'انرژی',
            'Revenue Indicator': 'درآمد',
            'Carbon Indicator': 'کربن',

            // Energy Storage Power Station
            'Battery Operating State': 'وضعیت عملکرد باتری',
            'Battery State': 'وضعیت باتری',
            'Battery Unknown': 'ناشناخته',
            'Battery Stopped': 'متوقف',
            'Battery Reserved': 'رزرو شده',
            'Battery Fault': 'خرابی',
            'Battery Warning': 'هشدار',
            'Battery Standby': 'آماده‌به‌کار',
            'Battery Prohibit DisCharging': 'ممنوعیت دشارژ',
            'Battery Prohibit Charging': 'ممنوعیت شارژ',
            'Battery Normal': 'عادی',
            'Battery Charging': 'در حال شارژ',
            'Battery Discharging': 'در حال دشارژ',
            'Battery Idle': 'بیکار',
            'Phase of Lifecycle': 'مرحله',
            'Use Phase': 'بهره‌برداری',
            'Commissioning Phase': 'راه‌اندازی',
            'Commissioning Date': 'تاریخ راه‌اندازی',
            'Installation Phase': 'در حال ساخت',
            'Device Status': 'وضعیت دستگاه',
            'Basic Information': 'اطلاعات پایه',
            'Gateway': 'دروازه',
            'Grid Meter': 'کنتور شبکه',
            'Load Meter': 'کنتور بار',
            'ESS Meter': 'کنتور ذخیره‌ساز',
            'Total Active Power': 'توان اکتیو کل',
            'Active Power A': 'توان اکتیو فاز A',
            'Active Power B': 'توان اکتیو فاز B',
            'Active Power C': 'توان اکتیو فاز C',
            'Total Reactive Power': 'توان راکتیو کل',
            'Reactive Power A': 'توان راکتیو فاز A',
            'Reactive Power B': 'توان راکتیو فاز B',
            'Reactive Power C': 'توان راکتیو فاز C',
            'Total Apparent Power': 'توان ظاهری کل',
            'Apparent Power A': 'توان ظاهری فاز A',
            'Apparent Power B': 'توان ظاهری فاز B',
            'Apparent Power C': 'توان ظاهری فاز C',
            'Total Power Factor': 'ضریب توان کل',
            'Active Energy Import': 'انرژی اکتیو ورودی',
            'Active Energy Export': 'انرژی اکتیو خروجی',
            'Active Energy Net': 'انرژی اکتیو خالص',

            'Generator': 'ژنراتور',

            // Photovoltaic Power Station
            'Invertor': 'اینورتر',
            'Invertor Run State': 'وضعیت عملکرد اینورتر',
            'Invertor Unknown': 'ناشناخته',
            'Invertor Initializing': 'روشن‌شدن اولیه',
            'Invertor Standby': 'آماده‌به‌کار',
            'Invertor Shutdown': 'خاموش',
            'Invertor Fault': 'خرابی',
            'Invertor Running': 'در حال کار',

            //Advanced Reporting & Knowledge Base
            'Created Datetime': 'زمان ایجاد',
            'File Format': 'فرمت فایل',
            'File Size': 'حجم فایل',
            Uploader: 'بارگذاری‌کننده',
            'Upload Datetime': 'زمان بارگذاری',
            //Error
            "The page you're looking for is not found": 'صفحه مورد نظر شما یافت نشد',
            "Make sure the address is correct and that the page hasn't moved": 'لطفاً از صحت آدرس و جابه‌جا نشدن صفحه اطمینان حاصل کنید',
            'If you think this is a mistake,': 'اگر فکر می‌کنید این یک اشتباه است،',
            'contact us': 'با ما تماس بگیرید',
            'Take me home': 'به صفحه اصلی بروید',
            'Whoops, something went wrong!': 'اوه، خطایی رخ داد!',
            'Try refreshing the page, or going back and attempting the action again':
                'صفحه را بازخوانی کنید یا به صفحه قبل بازگشته و دوباره تلاش کنید',
            'If this problem persists,': 'اگر این مشکل ادامه یافت،',
            'Captcha Error': 'خطای کد امنیتی',
            'Confirm Password Error': 'تکرار رمز عبور مطابقت ندارد',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'به نظر می‌رسد روی یک لینک بازنشانی رمز عبور نامعتبر کلیک کرده‌اید. لطفاً دوباره تلاش کنید.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'به نظر می‌رسد روی یک لینک ثبت‌نام حساب کاربری نامعتبر کلیک کرده‌اید. لطفاً دوباره تلاش کنید.',
            //Tenant Bill
            'Lease Contract Number': 'شماره قرارداد اجاره',
            Download: 'دانلود',
            Print: 'چاپ',
            'Payment Notice': 'اطلاعیه پرداخت',
            'Bill To': 'گیرنده',
            'Bill Number': 'شماره صورتحساب',
            'Bill Date': 'تاریخ صورتحساب',
            'Payment Due Date': 'تاریخ سررسید پرداخت',
            'Amount Payable': 'مبلغ قابل پرداخت',
            'Billing Period Start': 'تاریخ شروع دوره صورتحساب',
            'Billing Period End': 'تاریخ پایان دوره صورتحساب',
            Quantity: 'مقدار',
            Price: 'قیمت',
            Unit: 'واحد',
            Amount: 'مبلغ',
            Subtotal: 'جمع جزء',
            'VAT Output Tax': 'مالیات بر ارزش افزوده فروش',
            'Total Amount Payable': 'جمع کل مبلغ قابل پرداخت',
            'Please make sure to pay on or before the payment due date above': 'لطفاً اطمینان حاصل کنید که در تاریخ سررسید پرداخت ذکر شده یا قبل از آن پرداخت را انجام دهید',
            'Send money to the following account': 'وجه را به حساب زیر واریز کنید',
            'Account Name': 'نام حساب',
            'Bank Name': 'بانک',
            'Bank Address': 'آدرس بانک',
            'RMB Account': 'حساب یوان',
            // button
            'Toggle Navigation': 'تغییر وضعیت ناوبری',
            // working calendar
            'Working Days': 'روزهای کاری',
            'Non Working Days': 'روزهای غیرکاری',
            'Select Row': 'لطفاً ردیف داده را برای عملیات انتخاب کنید',
            // Offline Meter Input
            'Daily Value': 'داده روزانه',
            Date: 'تاریخ',
            'Successfully Saved': 'با موفقیت ذخیره شد',
            'Previous Data Is Empty': 'داده قبلی خالی است',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'رفع قفل حساب ناموفق بود',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'نشست مدیر یافت نشد',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'نشست مدیر منقضی شده است',
            'API.ADVANCED_REPORT_NOT_FOUND': 'گزارش پیشرفته یافت نشد',
            'API.API_KEY_HAS_EXPIRED': 'کلید منقضی شده است',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'نام کلید قبلاً استفاده شده است',
            'API.API_KEY_NOT_FOUND': 'کلید یافت نشد',
            'API.BAD_REQUEST': 'درخواست نادرست',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'نقطه قیمت متعادل‌ساز یافت نشد',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'نقطه وضعیت باتری یافت نشد',
            'API.BUY_METER_NOT_FOUND': 'کنتور خرید یافت نشد',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'نمی‌توان کنتوری که قبلاً به عنوان کنتور فرعی تعیین شده را به کنتور اصلی تبدیل کرد',
            'API.CHARGE_METER_NOT_FOUND': 'کنتور شارژ یافت نشد',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و دستور وجود دارد',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و دستور یافت نشد',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و تجهیزات وجود دارد',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و تجهیزات یافت نشد',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و کنتور وجود دارد',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و کنتور یافت نشد',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'نام تجهیزات ترکیبی قبلاً استفاده شده است',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'تجهیزات ترکیبی یافت نشد',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و کنتور آفلاین وجود دارد',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و کنتور آفلاین یافت نشد',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'نام پارامتر مرتبط با تجهیزات ترکیبی قبلاً استفاده شده است',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'پارامتر مرتبط با تجهیزات ترکیبی یافت نشد یا مطابقت ندارد',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'رابطه تجهیزات ترکیبی و کنتور مجازی وجود دارد',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات ترکیبی و کنتور مجازی یافت نشد',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'نام دستور قبلاً استفاده شده است',
            'API.COMMAND_NOT_FOUND': 'دستور یافت نشد',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'نام مخاطب قبلاً استفاده شده است',
            'API.CONTACT_NOT_FOUND': 'مخاطب یافت نشد',
            'API.COOLING_METER_NOT_FOUND': 'کنتور سرمایش یافت نشد',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'شناسه خارجی مرکز هزینه از قبل وجود دارد',
            'API.COST_CENTER_NAME_EXISTS': 'نام مرکز هزینه از قبل وجود دارد',
            'API.COST_CENTER_NOT_FOUND': 'مرکز هزینه یافت نشد',
            'API.COST_FILE_NOT_FOUND': 'فایل هزینه یافت نشد',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'فایل تعمیر داده یافت نشد',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'نام منبع داده قبلاً استفاده شده است',
            'API.DATA_SOURCE_NOT_FOUND': 'منبع داده یافت نشد',
            'API.DATABASE_ERROR': 'خطای پایگاه داده',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'تاریخ از قبل در تقویم کاری وجود دارد',
            'API.DATE_LOCAL_NOT_FOUND': 'تاریخ محلی یافت نشد',
            'API.DISCHARGE_METER_NOT_FOUND': 'کنتور دشارژ یافت نشد',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'نام مدار توزیع قبلاً استفاده شده است',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'مدار توزیع یافت نشد',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'رابطه مدار توزیع و نقطه وجود دارد',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'رابطه مدار توزیع و نقطه یافت نشد',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'نام سیستم توزیع قبلاً استفاده شده است',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'سیستم توزیع یافت نشد',
            'API.ELECTRICITY_METER_NOT_FOUND': 'کنتور برق یافت نشد',
            'API.EMAIL_IS_ALREADY_IN_USE': 'آدرس ایمیل قبلاً استفاده شده است',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'پیام ایمیل یافت نشد',
            'API.EMAIL_NOT_FOUND': 'آدرس ایمیل یافت نشد',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'میزبان سرور ایمیل قبلاً استفاده شده است',
            'API.EMAIL_SERVER_NOT_FOUND': 'سرور ایمیل یافت نشد',
            'API.EMPTY_VARIABLES_ARRAY': 'آرایه متغیرها خالی است',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'نام دسته‌بندی انرژی قبلاً استفاده شده است',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'دسته‌بندی انرژی یافت نشد',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'دسته‌بندی انرژی در آیتم‌های انرژی استفاده شده است',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'دسته‌بندی انرژی در کنتور استفاده شده است',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'دسته‌بندی انرژی در کنتور آفلاین استفاده شده است',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'دسته‌بندی انرژی در تعرفه‌ها استفاده شده است',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'دسته‌بندی انرژی در کنتور مجازی استفاده شده است',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'لینک نمودار جریان انرژی قبلاً استفاده شده است',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'لینک نمودار جریان انرژی یافت نشد یا مطابقت ندارد',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'نام نمودار جریان انرژی قبلاً استفاده شده است',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'گره نمودار جریان انرژی قبلاً استفاده شده است',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'گره نمودار جریان انرژی یافت نشد یا مطابقت ندارد',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'نمودار جریان انرژی یافت نشد',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'آیتم انرژی به دسته‌بندی انرژی تعلق ندارد',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'آیتم انرژی به دسته‌بندی انرژی تعلق ندارد',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'آیتم انرژی قبلاً استفاده شده است',
            'API.ENERGY_ITEM_NOT_FOUND': 'آیتم انرژی یافت نشد',
            'API.ENERGY_ITEM_USED_IN_METER': 'آیتم انرژی در کنتور استفاده شده است',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'آیتم انرژی در کنتور آفلاین استفاده شده است',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'آیتم انرژی در کنتور مجازی استفاده شده است',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'نام نیروگاه ذخیره‌ساز انرژی قبلاً استفاده شده است',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'نیروگاه ذخیره‌ساز انرژی یافت نشد',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'رابطه تجهیزات و دستور وجود دارد',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'رابطه تجهیزات و دستور یافت نشد',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'رابطه تجهیزات و کنتور وجود دارد',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات و کنتور یافت نشد',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'نام تجهیزات قبلاً استفاده شده است',
            'API.EQUIPMENT_NOT_FOUND': 'تجهیزات یافت نشد',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'رابطه تجهیزات و کنتور آفلاین وجود دارد',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات و کنتور آفلاین یافت نشد',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'نام پارامتر مرتبط با تجهیزات قبلاً استفاده شده است',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'پارامتر مرتبط با تجهیزات یافت نشد یا مطابقت ندارد',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'رابطه تجهیزات و کنتور مجازی وجود دارد',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه تجهیزات و کنتور مجازی یافت نشد',
            'API.ERROR': 'خطا',
            'API.EXCEPTION': 'استثنا',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'خواندن جریان درخواست ناموفق بود',
            'API.FAILED_TO_RESTORE_COST_FILE': 'بازیابی فایل هزینه ناموفق بود',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'بازیابی فایل تعمیر داده ناموفق بود',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'بازیابی فایل دانش ناموفق بود',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'بازیابی فایل کنتور آفلاین ناموفق بود',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'ذخیره فایل کنتور آفلاین ناموفق بود',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'بارگذاری فایل پیوست ناموفق بود',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'بارگذاری فایل هزینه ناموفق بود',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'بارگذاری فایل تعمیر داده ناموفق بود',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'بارگذاری فایل دانش ناموفق بود',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'بارگذاری فایل کنتور آفلاین ناموفق بود',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'نام دروازه قبلاً استفاده شده است',
            'API.GATEWAY_NOT_FOUND': 'دروازه یافت نشد',
            'API.HEAT_METER_NOT_FOUND': 'کنتور گرمایش یافت نشد',
            'API.INVALID_': 'نامعتبر ',
            'API.INVALID_ACKNOWLEDGE_CODE': 'کد تأیید نامعتبر است',
            'API.INVALID_ADDRESS': 'آدرس نامعتبر',
            'API.INVALID_ADDRESS_VALUE': 'مقدار آدرس نامعتبر',
            'API.INVALID_ADVANCED_REPORT_ID': 'شناسه گزارش پیشرفته نامعتبر',
            'API.INVALID_API_KEY_ID': 'شناسه کلید API نامعتبر',
            'API.INVALID_API_KEY_NAME': 'نام کلید API نامعتبر',
            'API.INVALID_AREA_VALUE': 'مقدار مساحت نامعتبر',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'شناسه نقطه قیمت متعادل‌ساز نامعتبر',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'زمان پایان دوره پایه نامعتبر',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'زمان شروع دوره پایه نامعتبر',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'شناسه نقطه وضعیت باتری نامعتبر',
            'API.INVALID_BAUD_RATE': 'نرخ باود نامعتبر',
            'API.INVALID_BUILDINGS_VALUE': 'مقدار ساختمان نامعتبر',
            'API.INVALID_BUY_METER_ID': 'شناسه کنتور خرید نامعتبر',
            'API.INVALID_CAPACITY': 'ظرفیت نامعتبر',
            'API.INVALID_CATEGORY': 'دسته نامعتبر',
            'API.INVALID_CHANNEL': 'کانال نامعتبر',
            'API.INVALID_CHARGE_METER_ID': 'شناسه کنتور شارژ نامعتبر',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'شناسه تجهیزات ترکیبی نامعتبر',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'نام تجهیزات ترکیبی نامعتبر',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'شناسه پارامتر مرتبط با تجهیزات ترکیبی نامعتبر',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'نام پارامتر مرتبط با تجهیزات ترکیبی نامعتبر',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'نوع پارامتر مرتبط با تجهیزات ترکیبی نامعتبر',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID تجهیزات ترکیبی نامعتبر',
            'API.INVALID_COMMAND_ID': 'شناسه دستور نامعتبر',
            'API.INVALID_COMMAND_NAME': 'نام دستور نامعتبر',
            'API.INVALID_CONNECTION': 'اتصال نامعتبر',
            'API.INVALID_CONSTANT_VALUE': 'مقدار ثابت نامعتبر',
            'API.INVALID_CONTACT_ID': 'شناسه مخاطب نامعتبر',
            'API.INVALID_CONTACT_NAME': 'نام مخاطب نامعتبر',
            'API.INVALID_COOLING_METER_ID': 'شناسه کنتور سرمایش نامعتبر',
            'API.INVALID_COST_CENTER_ID': 'شناسه مرکز هزینه نامعتبر',
            'API.INVALID_COST_FILE_ID': 'شناسه فایل هزینه نامعتبر',
            'API.INVALID_CREATED_DATETIME': 'زمان ایجاد نامعتبر',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'شناسه فایل تعمیر داده نامعتبر',
            'API.INVALID_DATA_SOURCE_ID': 'شناسه منبع داده نامعتبر',
            'API.INVALID_DATA_SOURCE_NAME': 'نام منبع داده نامعتبر',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'پروتکل منبع داده نامعتبر',
            'API.INVALID_DATE_LOCAL': 'تاریخ محلی نامعتبر',
            'API.INVALID_DENOMINATOR_METER_UUID': 'UUID کنتور استاندارد نامعتبر',
            'API.INVALID_DISCHARGE_METER_ID': 'شناسه کنتور دشارژ نامعتبر',
            'API.INVALID_DISPLAY_NAME': 'نام نمایشی نامعتبر',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'شناسه مدار توزیع نامعتبر',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'نام مدار توزیع نامعتبر',
            'API.INVALID_DISTRIBUTION_ROOM': 'اتاق توزیع نامعتبر',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'شناسه سیستم توزیع نامعتبر',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'نام سیستم توزیع نامعتبر',
            'API.INVALID_ELECTRICITY_METER_ID': 'شناسه کنتور برق نامعتبر',
            'API.INVALID_EMAIL': 'ایمیل نامعتبر',
            'API.INVALID_EMAIL_MESSAGE_ID': 'شناسه پیام ایمیل نامعتبر',
            'API.INVALID_EMAIL_SERVER_HOST': 'میزبان سرور ایمیل نامعتبر',
            'API.INVALID_EMAIL_SERVER_ID': 'شناسه سرور ایمیل نامعتبر',
            'API.INVALID_END_DATE_FORMAT': 'فرمت تاریخ پایان نامعتبر',
            'API.INVALID_END_DATETIME': 'تاریخ پایان نامعتبر',
            'API.INVALID_ENERGY_CATEGORY_ID': 'شناسه دسته‌بندی انرژی نامعتبر',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'نام دسته‌بندی انرژی نامعتبر',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'شناسه نمودار جریان انرژی نامعتبر',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'شناسه لینک نمودار جریان انرژی نامعتبر',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'نام نمودار جریان انرژی نامعتبر',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'شناسه گره نمودار جریان انرژی نامعتبر',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'نام گره نمودار جریان انرژی نامعتبر',
            'API.INVALID_ENERGY_ITEM_ID': 'شناسه آیتم انرژی نامعتبر',
            'API.INVALID_ENERGY_ITEM_NAME': 'نام آیتم انرژی نامعتبر',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'شناسه نیروگاه ذخیره‌ساز انرژی نامعتبر',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'نام نیروگاه ذخیره‌ساز انرژی نامعتبر',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'معادله نامعتبر در عبارت',
            'API.INVALID_EQUIPMENT_ID': 'شناسه تجهیزات نامعتبر',
            'API.INVALID_EQUIPMENT_NAME': 'نام تجهیزات نامعتبر',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'شناسه پارامتر مرتبط با تجهیزات نامعتبر',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'نام پارامتر مرتبط با تجهیزات نامعتبر',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'نوع پارامتر مرتبط با تجهیزات نامعتبر',
            'API.INVALID_EQUIPMENT_UUID': 'UUID تجهیزات نامعتبر',
            'API.INVALID_EXPIRES_DATETIME': 'تاریخ انقضا نامعتبر',
            'API.INVALID_EXPRESSION': 'عبارت نامعتبر',
            'API.INVALID_EXPRESSION_OBJECT': 'شیء عبارت نامعتبر',
            'API.INVALID_FDD_CODE': 'کد خطای خرابی نامعتبر',
            'API.INVALID_FLOORS_VALUE': 'مقدار طبقه نامعتبر',
            'API.INVALID_FROM_ADDR': 'آدرس مبدأ نامعتبر',
            'API.INVALID_GATEWAY_ID': 'شناسه دروازه نامعتبر',
            'API.INVALID_GATEWAY_NAME': 'نام دروازه نامعتبر',
            'API.INVALID_HEAT_METER_ID': 'شناسه کنتور گرمایش نامعتبر',
            'API.INVALID_HIGH_LIMIT_VALUE': 'مقدار حد بالا نامعتبر',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'مقدار حد بالای ساعتی نامعتبر',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'مقدار حد پایین ساعتی نامعتبر',
            'API.INVALID_Id': 'شناسه نامعتبر',
            'API.INVALID_IS_ADMIN_VALUE': 'مقدار مدیریت نامعتبر',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'نمایش داده هزینه نامعتبر',
            'API.INVALID_IS_COUNTED_VALUE': 'مقدار شمارش نامعتبر',
            'API.INVALID_IS_ENABLED': 'فعال بودن نامعتبر',
            'API.INVALID_IS_HIDDEN': 'مخفی بودن نامعتبر',
            'API.INVALID_IS_IN_LEASE_VALUE': 'مقدار در اجاره بودن نامعتبر',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'مقدار جمع‌آوری ورودی نامعتبر',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'مقدار مستأجر اصلی بودن نامعتبر',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'مقدار جمع‌آوری خروجی نامعتبر',
            'API.INVALID_IS_OUTPUT_VALUE': 'مقدار جمع‌آوری خروجی نامعتبر',
            'API.INVALID_IS_READ_ONLY_VALUE': 'مقدار فقط خواندنی نامعتبر',
            'API.INVALID_IS_TREND_VALUE': 'مقدار ذخیره روند نامعتبر',
            'API.INVALID_IS_VIRTUAL_VALUE': 'مقدار نقطه مجازی نامعتبر',
            'API.INVALID_KGCE': 'ضریب تبدیل به کیلوگرم زغال سنگ استاندارد نامعتبر',
            'API.INVALID_KGCO2E': 'ضریب انتشار دی‌اکسید کربن به کیلوگرم نامعتبر',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'شناسه فایل دانش نامعتبر',
            'API.INVALID_LATITUDE_VALUE': 'مقدار عرض جغرافیایی نامعتبر',
            'API.INVALID_LEASE_NUMBER_VALUE': 'شماره قرارداد اجاره نامعتبر',
            'API.INVALID_LONGITUDE_VALUE': 'مقدار طول جغرافیایی نامعتبر',
            'API.INVALID_LOW_LIMIT_VALUE': 'مقدار حد پایین نامعتبر',
            'API.INVALID_MASTER_METER_ID': 'شناسه کنتور اصلی نامعتبر',
            'API.INVALID_MENU_ID': 'شناسه منو نامعتبر',
            'API.INVALID_MESSAGE_DATA': 'داده پیام نامعتبر',
            'API.INVALID_MESSAGE_TEMPLATE': 'قالب پیام نامعتبر',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'شناسه قالب پیام نامعتبر',
            'API.INVALID_MESSAGE_VALUE': 'مقدار پیام نامعتبر',
            'API.INVALID_METER_ID': 'شناسه کنتور نامعتبر',
            'API.INVALID_METER_NAME': 'نام کنتور نامعتبر',
            'API.INVALID_METER_UUID': 'UUID کنتور نامعتبر',
            'API.INVALID_MICROGRID_BATTERY_ID': 'شناسه باتری ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'نام باتری ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'شناسه ایستگاه شارژ ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'نام ایستگاه شارژ ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'شناسه ژنراتور ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'نام ژنراتور ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_GRID_ID': 'شناسه شبکه ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_GRID_NAME': 'نام شبکه ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'شناسه پمپ حرارتی ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'نام پمپ حرارتی ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_ID': 'شناسه ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_LOAD_ID': 'شناسه بار ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_LOAD_NAME': 'نام بار ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_NAME': 'نام ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'شناسه فتوولتائیک ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'نام فتوولتائیک ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'شناسه سیستم تبدیل توان ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'نام سیستم تبدیل توان ریزشبکه نامعتبر',
            'API.INVALID_MICROGRID_UUID': 'UUID ریزشبکه نامعتبر',
            'API.INVALID_NAME_VALUE': 'مقدار نام نامعتبر',
            'API.INVALID_NEW_PASSWORD': 'رمز عبور جدید نامعتبر',
            'API.INVALID_NON_WORKING_DAY_ID': 'شناسه روز غیرکاری نامعتبر',
            'API.INVALID_NOTIFICATION_ID': 'شناسه اعلان نامعتبر',
            'API.INVALID_NUMERATOR_METER_UUID': 'UUID کنتور صورت کسر نامعتبر',
            'API.INVALID_OBJECT_TYPE': 'نوع شیء نامعتبر',
            'API.INVALID_OFFLINE_METER_DATA': 'داده کنتور آفلاین نامعتبر',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'شناسه فایل کنتور آفلاین نامعتبر',
            'API.INVALID_OFFLINE_METER_ID': 'شناسه کنتور آفلاین نامعتبر',
            'API.INVALID_OFFLINE_METER_NAME': 'نام کنتور آفلاین نامعتبر',
            'API.INVALID_OFFLINE_METER_UUID': 'UUID کنتور آفلاین نامعتبر',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'ثابت افست نامعتبر',
            'API.INVALID_OLD_PASSWORD': 'رمز عبور قدیمی نامعتبر',
            'API.INVALID_OPENID': 'شناسه باز نامعتبر',
            'API.INVALID_PARENT_SPACE_ID': 'شناسه فضای والد نامعتبر',
            'API.INVALID_PASSWORD': 'رمز عبور نامعتبر',
            'API.INVALID_PAYLOAD': 'بار محموله نامعتبر',
            'API.INVALID_PEAK_CURRENT': 'جریان پیک نامعتبر',
            'API.INVALID_PEAK_LOAD': 'بار پیک نامعتبر',
            'API.INVALID_PERIOD_TYPE': 'نوع دوره نامعتبر',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'شناسه نیروگاه فتوولتائیک نامعتبر',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'نام نیروگاه فتوولتائیک نامعتبر',
            'API.INVALID_POINT_ID': 'شناسه نقطه داده نامعتبر',
            'API.INVALID_POINT_NAME': 'نام نقطه داده نامعتبر',
            'API.INVALID_PORT': 'پورت نامعتبر',
            'API.INVALID_POSTAL_CODE_VALUE': 'مقدار کد پستی نامعتبر',
            'API.INVALID_POWER_POINT_ID': 'شناسه نقطه توان نامعتبر',
            'API.INVALID_PRIORITY': 'اولویت نامعتبر',
            'API.INVALID_PRIVILEGE': 'دسترسی نامعتبر',
            'API.INVALID_PRIVILEGE_DATA': 'داده دسترسی نامعتبر',
            'API.INVALID_PRIVILEGE_ID': 'شناسه دسترسی نامعتبر',
            'API.INVALID_PRIVILEGE_NAME': 'نام دسترسی نامعتبر',
            'API.INVALID_RATIO_VALUE': 'مقدار نسبت تبدیل نامعتبر',
            'API.INVALID_RECIPIENT_EMAIL': 'ایمیل گیرنده نامعتبر',
            'API.INVALID_RECIPIENT_MOBILE': 'موبایل گیرنده نامعتبر',
            'API.INVALID_RECIPIENT_NAME': 'نام گیرنده نامعتبر',
            'API.INVALID_RECIPIENT_OPENID': 'شناسه باز گیرنده نامعتبر',
            'API.INVALID_REPLY': 'پاسخ نامعتبر',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'تاریخ و زمان پایان دوره گزارش نامعتبر',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'تاریخ و زمان شروع دوره گزارش نامعتبر',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'نیاز به احراز هویت نامعتبر',
            'API.INVALID_ROOMS_VALUE': 'مقدار اتاق نامعتبر',
            'API.INVALID_RULE_ID': 'شناسه قانون نامعتبر',
            'API.INVALID_RULE_NAME': 'نام قانون نامعتبر',
            'API.INVALID_RUN_STATE_POINT_ID': 'شناسه نقطه وضعیت عملکرد نامعتبر',
            'API.INVALID_SCHEDULED_DATETIME': 'تاریخ زمان‌بندی شده نامعتبر',
            'API.INVALID_SELL_METER_ID': 'شناسه کنتور فروش نامعتبر',
            'API.INVALID_SENSOR_ID': 'شناسه سنسور نامعتبر',
            'API.INVALID_SENSOR_NAME': 'نام سنسور نامعتبر',
            'API.INVALID_SENSOR_UUID': 'UUID سنسور نامعتبر',
            'API.INVALID_SERIAL_NUMBER': 'شماره سریال نامعتبر',
            'API.INVALID_SERIAL_PORT': 'پورت سریال نامعتبر',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'نشست نامعتبر است، لطفاً دوباره وارد شوید',
            'API.INVALID_SET_VALUE': 'مقدار تنظیم شده نامعتبر',
            'API.INVALID_SHOPFLOOR_ID': 'شناسه کارگاه نامعتبر',
            'API.INVALID_SHOPFLOOR_NAME': 'نام کارگاه نامعتبر',
            'API.INVALID_SHOPFLOOR_UUID': 'UUID کارگاه نامعتبر',
            'API.INVALID_SOURCE_NODE_ID': 'شناسه گره مبدأ نامعتبر',
            'API.INVALID_SPACE_ID': 'شناسه فضا نامعتبر',
            'API.INVALID_SPACE_NAME': 'نام فضا نامعتبر',
            'API.INVALID_SPACE_UUID': 'UUID فضا نامعتبر',
            'API.INVALID_START_DATE_FORMAT': 'فرمت تاریخ شروع نامعتبر',
            'API.INVALID_START_DATETIME': 'تاریخ شروع نامعتبر',
            'API.INVALID_STATUS': 'وضعیت نامعتبر',
            'API.INVALID_STORE_ID': 'شناسه فروشگاه نامعتبر',
            'API.INVALID_STORE_NAME': 'نام فروشگاه نامعتبر',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'توضیحات نوع فروشگاه نامعتبر',
            'API.INVALID_STORE_TYPE_ID': 'شناسه نوع فروشگاه نامعتبر',
            'API.INVALID_STORE_TYPE_NAME': 'نام نوع فروشگاه نامعتبر',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'کد ساده‌شده نوع فروشگاه نامعتبر',
            'API.INVALID_STORE_UUID': 'UUID فروشگاه نامعتبر',
            'API.INVALID_SUBJECT_VALUE': 'مقدار موضوع نامعتبر',
            'API.INVALID_SVG': 'SVG نامعتبر',
            'API.INVALID_SWITCHGEAR': 'تابلوی برق نامعتبر',
            'API.INVALID_TARGET_NODE_ID': 'شناسه گره مقصد نامعتبر',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'قیمت‌گذاری پلکانی تعرفه نامعتبر',
            'API.INVALID_TARIFF_ID': 'شناسه تعرفه نامعتبر',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'قیمت‌گذاری زمان مصرف تعرفه نامعتبر',
            'API.INVALID_TARIFF_TYPE': 'نوع تعرفه نامعتبر',
            'API.INVALID_TENANT_ID': 'شناسه مستأجر نامعتبر',
            'API.INVALID_TENANT_NAME': 'نام مستأجر نامعتبر',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'توضیحات نوع مستأجر نامعتبر',
            'API.INVALID_TENANT_TYPE_ID': 'شناسه نوع مستأجر نامعتبر',
            'API.INVALID_TENANT_TYPE_NAME': 'نام نوع مستأجر نامعتبر',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'کد ساده‌شده نوع مستأجر نامعتبر',
            'API.INVALID_TENANT_UUID': 'UUID مستأجر نامعتبر',
            'API.INVALID_TEXT_MESSAGE_ID': 'شناسه پیامک نامعتبر',
            'API.INVALID_TIMEZONE_ID': 'شناسه منطقه زمانی نامعتبر',
            'API.INVALID_TOKEN': 'توکن نامعتبر',
            'API.INVALID_TOPIC': 'موضوع نامعتبر',
            'API.INVALID_UNIT_OF_MEASURE': 'واحد اندازه‌گیری نامعتبر',
            'API.INVALID_UNIT_OF_PRICE': 'واحد قیمت نامعتبر',
            'API.INVALID_UNITS': 'واحد نامعتبر',
            'API.INVALID_USER_ID': 'شناسه کاربر نامعتبر',
            'API.INVALID_USER_NAME': 'نام کاربری نامعتبر',
            'API.INVALID_USER_NAME_OR_EMAIL': 'نام کاربری یا ایمیل نامعتبر',
            'API.INVALID_USER_PHONE': 'شماره تلفن کاربر نامعتبر',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'کاربر نامعتبر است، لطفاً دوباره وارد شوید',
            'API.INVALID_USER_UUID': 'UUID کاربر نامعتبر',
            'API.INVALID_USERNAME': 'نام کاربری نامعتبر',
            'API.INVALID_VARIABLE_METER_ID': 'شناسه کنتور متغیر نامعتبر',
            'API.INVALID_VARIABLE_METER_TYPE': 'نوع کنتور متغیر نامعتبر',
            'API.INVALID_VARIABLE_NAME': 'نام متغیر نامعتبر',
            'API.INVALID_VERIFICATION_CODE': 'کد تأیید نامعتبر',
            'API.INVALID_VIRTUAL_METER_ID': 'شناسه کنتور مجازی نامعتبر',
            'API.INVALID_VIRTUAL_METER_NAME': 'نام کنتور مجازی نامعتبر',
            'API.INVALID_VIRTUAL_METER_UUID': 'UUID کنتور مجازی نامعتبر',
            'API.INVALID_WEB_MESSAGE_ID': 'شناسه پیام وب نامعتبر',
            'API.INVALID_WECHAT_MESSAGE_ID': 'شناسه پیام وی‌چت نامعتبر',
            'API.INVALID_WIND_FARM_ID': 'شناسه مزرعه بادی نامعتبر',
            'API.INVALID_WIND_FARM_NAME': 'نام مزرعه بادی نامعتبر',
            'API.INVALID_WORKING_CALENDAR_ID': 'شناسه تقویم کاری نامعتبر',
            'API.INVALID_WORKING_CALENDAR_NAME': 'نام تقویم کاری نامعتبر',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'امکان حذف فایل دانش از دیسک وجود ندارد',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'فایل پایگاه دانش یافت نشد',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'کنتور اصلی به همان دسته‌بندی انرژی تعلق ندارد',
            'API.MASTER_METER_NOT_FOUND': 'کنتور اصلی یافت نشد',
            'API.MENU_NOT_FOUND': 'منو یافت نشد',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'کنتور نمی‌تواند بیش از یک نقطه مقدار انرژی داشته باشد',
            'API.METER_COMMAND_RELATION_EXISTS': 'رابطه کنتور و دستور وجود دارد',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'رابطه کنتور و دستور یافت نشد',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'نام کنتور قبلاً استفاده شده است',
            'API.METER_NOT_FOUND': 'کنتور یافت نشد',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'کنتور متغیر یافت نشد',
            'API.METER_POINT_RELATION_EXISTS': 'رابطه کنتور و نقطه داده وجود دارد',
            'API.METER_POINT_RELATION_NOT_FOUND': 'رابطه کنتور و نقطه داده یافت نشد',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'نام باتری ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'باتری ریزشبکه یافت نشد',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'نام ایستگاه شارژ ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'ایستگاه شارژ ریزشبکه یافت نشد',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'نام ژنراتور ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'ژنراتور ریزشبکه یافت نشد',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'نام شبکه ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_GRID_NOT_FOUND': 'شبکه ریزشبکه یافت نشد',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'نام پمپ حرارتی ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'پمپ حرارتی ریزشبکه یافت نشد',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'نام بار ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_LOAD_NOT_FOUND': 'بار ریزشبکه یافت نشد',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'نام ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_NOT_FOUND': 'ریزشبکه یافت نشد',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'نام فتوولتائیک ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'فتوولتائیک ریزشبکه یافت نشد',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'نام سیستم تبدیل توان ریزشبکه قبلاً استفاده شده است',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'سیستم تبدیل توان ریزشبکه یافت نشد',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'رابطه ریزشبکه و سنسور وجود دارد',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'رابطه ریزشبکه و سنسور یافت نشد',
            'API.MQTT_CONNECTION_ERROR': 'خطای اتصال MQTT',
            'API.MQTT_PUBLISH_ERROR': 'خطای انتشار MQTT',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'طول رمز عبور جدید نمی‌تواند بیش از ۱۰۰ کاراکتر باشد',
            'API.NEW_USER_SESSION_NOT_FOUND': 'نشست کاربر جدید یافت نشد',
            'API.NEW_USER_SESSION_TIMEOUT': 'نشست کاربر جدید منقضی شده است',
            'API.NON_WORKING_DAY_NOT_FOUND': 'روز غیرکاری یافت نشد',
            'API.NOT_FOUND': 'یافت نشد',
            'API.NOTIFICATION_NOT_FOUND': 'اعلان یافت نشد',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'فایل کنتور آفلاین یافت نشد',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'نام کنتور آفلاین قبلاً استفاده شده است',
            'API.OFFLINE_METER_NOT_FOUND': 'کنتور آفلاین یافت نشد',
            'API.INVALID_OFFLINE_METER_VALUE': 'مقدار کنتور آفلاین نامعتبر است',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'کنتور آفلاین متغیر یافت نشد',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'طول رمز عبور قدیمی نمی‌تواند بیش از ۱۰۰ کاراکتر باشد',
            'API.PARENT_SPACE_NOT_FOUND': 'فضای والد یافت نشد',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'طول رمز عبور نمی‌تواند بیش از ۱۰۰ کاراکتر باشد',
            'API.PASSWORDS_MATCH': 'رمز عبور جدید با رمز عبور قدیمی یکسان است',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'نام نیروگاه فتوولتائیک قبلاً استفاده شده است',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'نیروگاه فتوولتائیک یافت نشد',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'نام نقطه داده قبلاً استفاده شده است',
            'API.POINT_NOT_FOUND': 'نقطه داده یافت نشد',
            'API.POWER_POINT_NOT_FOUND': 'نقطه توان یافت نشد',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'نام دسترسی قبلاً استفاده شده است',
            'API.PRIVILEGE_NOT_FOUND': 'دسترسی یافت نشد',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'نام قانون قبلاً استفاده شده است',
            'API.RULE_NOT_FOUND': 'قانون یافت نشد',
            'API.SELL_METER_NOT_FOUND': 'کنتور فروش یافت نشد',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'نام سنسور قبلاً استفاده شده است',
            'API.SENSOR_NOT_FOUND': 'سنسور یافت نشد',
            'API.SENSOR_POINT_RELATION_EXISTS': 'رابطه سنسور و نقطه داده وجود دارد',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'رابطه سنسور و نقطه داده یافت نشد',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'رابطه کارگاه و دستور وجود دارد',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'رابطه کارگاه و دستور یافت نشد',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'رابطه کارگاه و تجهیزات وجود دارد',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه کارگاه و تجهیزات یافت نشد',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'رابطه کارگاه و کنتور وجود دارد',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'رابطه کارگاه و کنتور یافت نشد',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'نام کارگاه قبلاً استفاده شده است',
            'API.SHOPFLOOR_NOT_FOUND': 'کارگاه یافت نشد',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'رابطه کارگاه و کنتور آفلاین وجود دارد',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه کارگاه و کنتور آفلاین یافت نشد',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'رابطه کارگاه و نقطه داده وجود دارد',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'رابطه کارگاه و نقطه داده یافت نشد',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'رابطه کارگاه و سنسور وجود دارد',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'رابطه کارگاه و سنسور یافت نشد',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'رابطه کارگاه و کنتور مجازی وجود دارد',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه کارگاه و کنتور مجازی یافت نشد',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه کارگاه و تقویم کاری وجود دارد',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه کارگاه و تقویم کاری یافت نشد',
            'API.SOC_POINT_NOT_FOUND': 'نقطه SOC یافت نشد',
            'API.SOURCE_NODE_NOT_FOUND': 'گره مبدأ یافت نشد',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'رابطه فضا و تجهیزات ترکیبی وجود دارد',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه فضا و تجهیزات ترکیبی یافت نشد',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'رابطه فضا و دستور وجود دارد',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'رابطه فضا و دستور یافت نشد',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'رابطه فضا و نیروگاه ذخیره‌ساز انرژی وجود دارد',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'رابطه فضا و نیروگاه ذخیره‌ساز انرژی یافت نشد',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'رابطه فضا و تجهیزات وجود دارد',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'رابطه فضا و تجهیزات یافت نشد',
            'API.SPACE_METER_RELATION_EXISTS': 'رابطه فضا و کنتور وجود دارد',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'رابطه فضا و کنتور یافت نشد',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'نام فضا قبلاً استفاده شده است',
            'API.SPACE_NOT_FOUND': 'فضا یافت نشد',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'فضا در دسترسی‌ها یافت نشد',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'رابطه فضا و کنتور آفلاین وجود دارد',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه فضا و کنتور آفلاین یافت نشد',
            'API.SPACE_POINT_RELATION_EXISTS': 'رابطه فضا و نقطه داده وجود دارد',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'رابطه فضا و نقطه داده یافت نشد',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'رابطه فضا و سنسور وجود دارد',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'رابطه فضا و سنسور یافت نشد',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'رابطه فضا و کارگاه وجود دارد',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'رابطه فضا و کارگاه یافت نشد',
            'API.SPACE_STORE_RELATION_EXISTS': 'رابطه فضا و فروشگاه وجود دارد',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'رابطه فضا و فروشگاه یافت نشد',
            'API.SPACE_TENANT_RELATION_EXISTS': 'رابطه فضا و مستأجر وجود دارد',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'رابطه فضا و مستأجر یافت نشد',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'رابطه فضا و کنتور مجازی وجود دارد',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه فضا و کنتور مجازی یافت نشد',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه فضا و تقویم کاری وجود دارد',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه فضا و تقویم کاری یافت نشد',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'تاریخ و زمان شروع باید قبل از تاریخ و زمان پایان باشد',
            'API.STORE_COMMAND_RELATION_EXISTS': 'رابطه فروشگاه و دستور وجود دارد',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'رابطه فروشگاه و دستور یافت نشد',
            'API.STORE_METER_RELATION_EXISTS': 'رابطه فروشگاه و کنتور وجود دارد',
            'API.STORE_METER_RELATION_NOT_FOUND': 'رابطه فروشگاه و کنتور یافت نشد',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'نام فروشگاه قبلاً استفاده شده است',
            'API.STORE_NOT_FOUND': 'فروشگاه یافت نشد',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'رابطه فروشگاه و کنتور آفلاین وجود دارد',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه فروشگاه و کنتور آفلاین یافت نشد',
            'API.STORE_POINT_RELATION_EXISTS': 'رابطه فروشگاه و نقطه داده وجود دارد',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'رابطه فروشگاه و نقطه داده یافت نشد',
            'API.STORE_SENSOR_RELATION_EXISTS': 'رابطه فروشگاه و سنسور وجود دارد',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'رابطه فروشگاه و سنسور یافت نشد',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'نام نوع فروشگاه قبلاً استفاده شده است',
            'API.STORE_TYPE_NOT_FOUND': 'نوع فروشگاه یافت نشد',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'کد ساده‌شده نوع فروشگاه قبلاً استفاده شده است',
            'API.STORE_TYPE_USED_IN_STORE': 'نوع فروشگاه در فروشگاه استفاده شده است',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'رابطه فروشگاه و کنتور مجازی وجود دارد',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه فروشگاه و کنتور مجازی یافت نشد',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه فروشگاه و تقویم کاری وجود دارد',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه فروشگاه و تقویم کاری یافت نشد',
            'API.TARGET_NODE_NOT_FOUND': 'گره مقصد یافت نشد',
            'API.TARIFF_IN_USE': 'تعرفه در حال استفاده است',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'تعرفه و مرکز هزینه قبلاً مرتبط شده‌اند',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'تعرفه و مرکز هزینه مرتبط نیستند',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'نام تعرفه قبلاً استفاده شده است',
            'API.TARIFF_NOT_FOUND': 'تعرفه یافت نشد',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'رابطه مستأجر و دستور وجود دارد',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'رابطه مستأجر و دستور یافت نشد',
            'API.TENANT_METER_RELATION_EXISTS': 'رابطه مستأجر و کنتور وجود دارد',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'رابطه مستأجر و کنتور یافت نشد',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'نام مستأجر قبلاً استفاده شده است',
            'API.TENANT_NOT_FOUND': 'مستأجر یافت نشد',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'رابطه مستأجر و کنتور آفلاین وجود دارد',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'رابطه مستأجر و کنتور آفلاین یافت نشد',
            'API.TENANT_POINT_RELATION_EXISTS': 'رابطه مستأجر و نقطه داده وجود دارد',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'رابطه مستأجر و نقطه داده یافت نشد',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'رابطه مستأجر و سنسور وجود دارد',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'رابطه مستأجر و سنسور یافت نشد',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'نام نوع مستأجر قبلاً استفاده شده است',
            'API.TENANT_TYPE_NOT_FOUND': 'نوع مستأجر یافت نشد',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'کد ساده‌شده نوع مستأجر قبلاً استفاده شده است',
            'API.TENANT_TYPE_USED_IN_TENANT': 'نوع مستأجر در مستأجر استفاده شده است',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'رابطه مستأجر و کنتور مجازی وجود دارد',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'رابطه مستأجر و کنتور مجازی یافت نشد',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'رابطه مستأجر و تقویم کاری وجود دارد',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'رابطه مستأجر و تقویم کاری یافت نشد',
            'API.TEXT_MESSAGE_NOT_FOUND': 'پیامک یافت نشد',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'دوره گزارش باید بیشتر از ۱۵ دقیقه باشد',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'با کنتورهای فرعی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'با زیرفضاها رابطه دارد',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'با پارامترهای مرتبط با تجهیزات ترکیبی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'با تجهیزات ترکیبی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'با منابع داده رابطه دارد',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'با لینک‌های نمودار جریان انرژی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'با باتری‌های کانتینر ذخیره‌ساز انرژی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'با شبکه‌های کانتینر ذخیره‌ساز انرژی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'با بارهای کانتینر ذخیره‌ساز انرژی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'با سیستم‌های تبدیل توان (PCS) کانتینر ذخیره‌ساز انرژی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'با پارامترهای مرتبط با تجهیزات رابطه دارد',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'با تجهیزات رابطه دارد',
            'API.THERE_IS_RELATION_WITH_METER': 'با کنتور رابطه دارد',
            'API.THERE_IS_RELATION_WITH_METERS': 'با چندین کنتور رابطه دارد',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'با کنتور آفلاین رابطه دارد',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'با چندین کنتور آفلاین رابطه دارد',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'با کنتورهای مجازی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'با سنسورها رابطه دارد',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'با کارگاه‌ها رابطه دارد',
            'API.THERE_IS_RELATION_WITH_SPACES': 'با فضاها رابطه دارد',
            'API.THERE_IS_RELATION_WITH_STORES': 'با فروشگاه‌ها رابطه دارد',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'با مستأجران رابطه دارد',
            'API.THERE_IS_RELATION_WITH_USERS': 'با کاربران رابطه دارد',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'با کنتور مجازی رابطه دارد',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'با نیروگاه‌های مجازی رابطه دارد',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'این منبع داده توسط یک کنتور در حال استفاده است',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'این کنتور توسط یک کنتور مجازی در حال استفاده است',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'این کنتور آفلاین توسط یک کنتور مجازی در حال استفاده است',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'فضا قابل شبیه‌سازی نیست',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'فضا قابل حذف نیست',
            'API.TIMEZONE_NOT_FOUND': 'منطقه زمانی یافت نشد',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'توکن در هدرها یافت نشد، لطفاً وارد شوید',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'حساب کاربری قفل شده است',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'حساب کاربری منقضی شده است',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'حساب کاربری قفل نیست',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'نام کاربری قبلاً استفاده شده است',
            'API.USER_NOT_FOUND': 'کاربر یافت نشد',
            'API.USER_PASSWORD_HAS_EXPIRED': 'رمز عبور کاربر منقضی شده است',
            'API.USER_PRIVILEGE_NOT_FOUND': 'دسترسی کاربر یافت نشد',
            'API.USER_SESSION_NOT_FOUND': 'نشست کاربر یافت نشد',
            'API.USER_SESSION_TIMEOUT': 'نشست کاربر منقضی شده است',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID کاربر در هدرها یافت نشد، لطفاً وارد شوید',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'نام کنتور مجازی قبلاً استفاده شده است',
            'API.VIRTUAL_METER_NOT_FOUND': 'کنتور مجازی یافت نشد',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'کنتور مجازی متغیر یافت نشد',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'نقطه داده مجازی باید مقدار آنالوگ باشد',
            'API.WEB_MESSAGE_NOT_FOUND': 'پیام وب یافت نشد',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'پیام وی‌چت یافت نشد',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'نام مزرعه بادی قبلاً استفاده شده است',
            'API.WIND_FARM_NOT_FOUND': 'مزرعه بادی یافت نشد',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'نام تقویم کاری قبلاً استفاده شده است',
            'API.WORKING_CALENDAR_NOT_FOUND': 'تقویم کاری یافت نشد',

            MasterMeter: 'جدول اصلی',
            SubMeter: 'جدول فرعی',
            'Power Quality': 'کیفیت برق',
            'About Power Quality': 'درباره کیفیت برق',
            'Trend Values': 'مقادیر روند',
            Category: 'دسته‌بندی',
            Type: 'نوع',
            Unit: 'واحد',
            Limit: 'حد',
            'Normal Limit': 'حد عادی',
            'Severe Limit': 'حد شدید',
            Compliance: 'نرخ انطباق',
            'Worst Deviation': 'بدترین انحراف',
            'Worst Time': 'بدترین زمان',
            'Severe Exceed Count': 'تعداد تجاوزات شدید',
            'Worst Unbalance': 'بدترین عدم تعادل',
            Hz: 'هرتز',
            voltage: 'ولتاژ',
            current: 'جریان',
            frequency: 'فرکانس',
            voltage_deviation: 'انحراف ولتاژ',
            current_unbalance: 'عدم تعادل جریان',
            voltage_unbalance: 'عدم تعادل ولتاژ',
            mean_deviation_pct: 'میانگین انحراف (%)',
            p95_abs_deviation_pct: 'انحراف مطلق P95 (%)',
            mean_abs_deviation_hz: 'میانگین انحراف مطلق (Hz)',
            frequency_deviation: 'انحراف فرکانس',
            p95_abs_deviation_hz: 'انحراف مطلق P95 (Hz)',
            mean_unbalance_pct: 'میانگین عدم تعادل (%)',
            p95_unbalance_pct: 'عدم تعادل P95 (%)',
            count: 'تعداد',
            min: 'حداقل',
            max: 'حداکثر',
            mean: 'میانگین',
            std: 'انحراف معیار',
            p5: 'P5',
            p95: 'P95'
        }
    },
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'zh_CN',

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
